{
  "analyzer.mapping.error.profileUnavailable": "The analyzer profile could not be read. Retry confirmation when the Bridge is available.",
  "reporting.title": "自定义数据导出",
  "reporting.description": "选择报告、报告期间和列，然后下载可直接用于电子表格的 CSV 文件。",
  "reporting.builder": "返回报告生成器",
  "reporting.queue": "我的报告队列",
  "reporting.queueEmpty": "您生成的报告将显示在此处。",
  "reporting.design.emptyQueuePage": "此页面上没有报告。",
  "reporting.design.firstQueuePage": "返回第一页",
  "reporting.reportType": "报告类型",
  "reporting.layout": "CSV布局",
  "reporting.layout.SPREADSHEET": "电子表格：检测按列排列",
  "reporting.layout.RESULT_LIST": "详细列表：结果按行排列",
  "reporting.layout.TABLE": "表格",
  "reporting.meaning.SPREADSHEET": "每个样本的检测显示为列。重复结果使用额外的行；不相关的重复读数分开保存。",
  "reporting.meaning.RESULT_LIST": "每个独立结果单独占一行。重复结果会被保留。",
  "reporting.meaning.TABLE": "每条记录的发生情况单独占一行。",
  "reporting.dateFrom": "开始日期",
  "reporting.dateTo": "结束日期",
  "reporting.dates.required": "必填",
  "reporting.dates.requiredFrom": "请选择开始日期。",
  "reporting.dates.requiredTo": "请选择结束日期。",
  "reporting.dates.invalid": "请选择有效的日历日期。",
  "reporting.dates.reversed": "结束日期必须等于或晚于开始日期。",
  "reporting.dates.tooLong": "请选择不超过 {days} 天的期间（含起止两日）。",
  "reporting.dates.range": "请在上方所示的最长期限内选择起止顺序正确的期间。",
  "reporting.periodHelp": "按{timezone}时区的{dateMeaning}计算，包含起止两天。最长期间：{days}天。",
  "reporting.dateAnchor.collectionDate": "样本采集日期",
  "reporting.dateAnchor.requestDate": "转诊申请日期",
  "reporting.dateAnchor.sentDate": "转诊发送日期",
  "reporting.dateAnchor.eventOrRecordedDate": "已知时为事件日期，否则为记录日期（由“日期依据”标识）",
  "reporting.dateAnchor.dateOfEvent": "不符合事件日期",
  "reporting.dateAnchor.enteredDate": "已记录的拒收日期",
  "reporting.labSections": "实验室单元",
  "reporting.allAccessibleSections": "所有可访问的实验室单元",
  "reporting.tests": "检测项目",
  "reporting.allTests": "所有检测",
  "reporting.resultStatuses": "结果状态",
  "reporting.finalized": "最终确定",
  "reporting.all": "所有分析仪",
  "reporting.available": "可用列",
  "reporting.search": "搜索列",
  "reporting.selected": "已选列",
  "reporting.selectedCount": "已选列（{count}）",
  "reporting.group.sample": "样本和订单",
  "reporting.group.referrals": "转诊",
  "reporting.group.nonConformance": "不符合项 / 拒收",
  "reporting.group.patient": "患者",
  "reporting.group.result": "结果详情",
  "reporting.group.tests": "已配置的检测",
  "reporting.group.components": "已配置的结果组分",
  "reporting.group.turnaround": "周转时间",
  "reporting.group.testTurnaround": "按检测的周转时间",
  "reporting.group.componentTurnaround": "按结果组分的周转时间",
  "reporting.group.observations": "附加问题",
  "reporting.headerPreview": "CSV表头预览",
  "reporting.moveUp": "上移{field}",
  "reporting.moveDown": "下移{field}",
  "reporting.remove": "移除{field}",
  "reporting.position": "{field}：第{position}位，共{count}位",
  "reporting.review": "复核报告",
  "reporting.edit": "编辑报告",
  "reporting.generate": "生成 CSV",
  "reporting.submitting": "正在提交报告…",
  "reporting.generating": "正在准备您的CSV…",
  "reporting.download": "下载CSV",
  "reporting.loading": "正在加载报告选项…",
  "reporting.currentReport": "您当前的报告",
  "reporting.previous": "上一个",
  "reporting.next": "下一个",
  "reporting.rows": "{count, plural, other {# 行}}",
  "reporting.state.QUEUED": "已排队",
  "reporting.state.GENERATING": "生成中",
  "reporting.state.READY": "可下载",
  "reporting.state.FAILED": "失败数量",
  "reporting.state.EXPIRED": "已过期",
  "reporting.state.CANCELLED": "已取消",
  "reporting.loadError": "无法加载报告信息",
  "reporting.submitError": "无法生成报告",
  "reporting.requestError": "无法完成请求。您的选择已保留，请重试。",
  "reporting.networkError": "无法连接服务器。您的选择已保留，请重试。",
  "reporting.request.invalid": "请检查报告期间、筛选条件和所选列，然后重试。",
  "reporting.request.conflict": "此提交标识符已用于其他报告选择。请开始新报告。",
  "reporting.columns.stale": "部分所选列已不可用。请将其移除，并从当前目录中选择。",
  "reporting.jobs.limit": "您已达到活动报告数量上限。请等待某个报告完成后再试。",
  "reporting.access.denied": "您当前的 OpenELIS 访问权限不允许查看此报告。",
  "reporting.access.scopeChanged": "您对所选实验室单元的访问权限已更改。请按当前访问权限复核报告。",
  "reporting.access.noSections": "此报告没有可访问的实验室单元。",
  "reporting.access.signIn": "请登录 OpenELIS 以继续。",
  "reporting.definition.changed": "报告定义已更改。再次运行前请复核当前报告选项。",
  "reporting.definition.unavailable": "此报告类型已不可用。",
  "reporting.tests.stale": "部分所选检测已不可用。请复核您的检测选择。",
  "reporting.status.invalid": "请选择可用的结果状态。",
  "reporting.filters.unsupported": "部分请求的筛选条件不适用于此报告。请复核当前报告选项。",
  "reporting.filters.unavailable": "部分先前的筛选条件不适用于此报告。生成前请复核当前筛选条件。",
  "reporting.job.generationFailed": "无法生成CSV。您的报告请求已保留。",
  "reporting.job.outputUnavailable": "服务器无法保存导出文件。请联系管理员将导出文件夹设为可写，然后重试此报告。",
  "reporting.job.expired": "此文件已过期。请使用新的报告期间重新运行报告。",
  "reporting.job.notReady": "此报告尚未准备好下载。",
  "reporting.job.notFound": "找不到此报告。",
  "reporting.saved.library": "共享报告",
  "reporting.saved.search": "搜索共享报告",
  "reporting.saved.loading": "正在加载共享报告…",
  "reporting.saved.loadError": "无法加载共享报告",
  "reporting.saved.empty": "尚未保存任何共享报告。",
  "reporting.saved.shared": "可供所有能使用报告的用户使用。",
  "reporting.saved.open": "待处理",
  "reporting.saved.save": "保存报告",
  "reporting.saved.update": "更新共享报告",
  "reporting.saved.copy": "保存副本",
  "reporting.saved.delete": "删除共享报告",
  "reporting.saved.name": "报告名称",
  "reporting.saved.confirmSave": "保存共享报告",
  "reporting.saved.confirmDelete": "删除",
  "reporting.saved.confirmUpdate": "更新",
  "reporting.saved.cancel": "取消",
  "reporting.saved.copyName": "{name} 的副本",
  "reporting.saved.created": "已保存为{name}。",
  "reporting.saved.updated": "已更新 {name}。",
  "reporting.saved.freshDates": "运行此报告前请选择新的日期。",
  "reporting.saved.deleteHelp": "要从共享报告库中删除{name}吗？已生成的文件将保留。",
  "reporting.saved.updateHelp": "用构建器中当前显示的选择替换{name}？",
  "reporting.saved.changed": "在您打开此共享报告后，有人对其进行了更改。您的选择仍保留在此；请重新打开当前已保存的报告或保存副本。",
  "reporting.saved.invalid": "保存前请复核报告选择。",
  "reporting.saved.nameInvalid": "请输入不超过200个字符的报告名称。",
  "reporting.saved.notFound": "此共享报告已不可用。",
  "reporting.saved.pageInvalid": "共享报告列表请求无效。",
  "accept.action.button": "接受",
  "accessDenied.message": "您无权访问此模块，请联系系统管理员",
  "accessDenied.okButton": "确定",
  "accessDenied.title": "访问被拒绝",
  "accession.entry": "实验室编号录入",
  "activityReportByPanel": "按检测组别统计活动报告",
  "activityReportByTest": "按检测项目统计活动报告",
  "activityReportByTestSection": "按检测科室统计活动报告",
  "add.age.range": "添加另一个年龄范围 +",
  "add.aliquot": "添加分装样本",
  "add.new.dictionary.menu": "添加新字典菜单",
  "address.search.label": "快速地址搜索",
  "address.level.provinsi": "省",
  "address.level.kabupaten": "县/市",
  "address.level.kecamatan": "地区",
  "address.level.kelurahan": "村",
  "adjustment.button": "调整数量",
  "adjustment.newQuantity": "新数量",
  "adjustment.notes": "备注",
  "adjustment.notes.placeholder": "提供关于此调整的详细信息",
  "adjustment.reason": "调整原因",
  "adjustment.reason.select": "选择原因",
  "adjustment.success": "批次数量调整成功",
  "adjustment.title": "调整批次数量",
  "admin.dashboard.subtitle": "选择一个管理区域来配置 OpenELIS。",
  "admin.dashboard.title": "管理仪表板",
  "admin.formEntryConfig": "通用配置",
  "admin.programs.title": "计划",
  "admin.programs.subtitle": "订单归属的项目计划：每个计划包含一个领域、一个或多个实验室单元，以及可选的订单录入问卷。",
  "admin.programs.add": "添加计划",
  "admin.programs.search": "按名称搜索",
  "admin.programs.selector.new": "新程序",
  "admin.programs.row.expand.aria": "编辑计划",
  "admin.programs.row.actions.aria": "计划操作",
  "admin.programs.list.column.name": "名称",
  "admin.programs.list.column.domain": "领域",
  "admin.programs.list.column.active": "状态",
  "admin.programs.list.column.units": "实验室单元",
  "admin.programs.list.status.active": "活跃",
  "admin.programs.list.status.inactive": "非活跃",
  "admin.programs.list.filter.domain.label": "领域",
  "admin.programs.list.filter.domain.all": "所有领域",
  "admin.programs.list.toggle.showDeactivated": "显示已停用",
  "admin.programs.action.deactivate": "停用",
  "admin.programs.action.reactivate": "重新激活",
  "admin.programs.deactivate.modal.title": "停用此计划？",
  "admin.programs.deactivate.modal.body.noOrders": "“{programName}”没有订单，只会不再出现在新订单中。您可以随时从计划列表中重新激活。",
  "admin.programs.deactivate.modal.confirm": "停用",
  "admin.programs.deactivate.modal.cancel": "取消",
  "admin.programs.reactivate.success": "{programName} 已重新激活",
  "admin.programs.deactivate.success": "{programName} 已停用",
  "admin.programs.domain.confirm.heading": "更改计划领域？",
  "admin.programs.domain.confirm.body": "历史订单已按 {from} 领域的规则进行评估。更改为 {to} 仅对今后生效：现有订单保留其计划编码，不会重新编码；此后该计划只会在 {to} 订单中提供。",
  "admin.programs.list.empty": "没有与当前搜索和筛选条件匹配的计划。",
  "admin.programs.basicInfo.labUnits.selectAll": "全选",
  "admin.programs.basicInfo.labUnits.placeholder": "输入以筛选实验室单元",
  "orderEntry.programPicker.empty": "当前没有启用的计划。管理员可以在“管理 › 计划”下启用一个计划。",
  "orderEntry.programPicker.empty.domain": "当前没有启用的{domain}计划。管理员可以在“管理 › 计划”下启用一个计划。",
  "admin.programs.basicInfo.programName.label": "项目名称",
  "admin.programs.basicInfo.programName.placeholder": "例如 HBV 产前筛查",
  "admin.programs.basicInfo.code.label": "计划代码",
  "admin.programs.basicInfo.code.placeholder": "例如 HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "只能使用字母、数字、空格或下划线。",
  "admin.programs.basicInfo.programName.tooLong": "最多使用 {max} 个字符。",
  "admin.programs.basicInfo.labUnits.label": "实验室单元",
  "admin.programs.basicInfo.showOnMicroCase.off": "手动输入已关闭",
  "admin.programs.basicInfo.showOnMicroCase.on": "手动输入已开启",
  "admin.programs.basicInfo.showOnMicroCase.label": "在微生物病例中显示",
  "admin.programs.basicInfo.showOnMicroCase.helper": "允许在微生物病例中使用此计划。新病例从订单继承该计划；不会改变工作的分配方式。",
  "admin.programs.basicInfo.domain.label": "领域",
  "admin.programs.basicInfo.domain.required": "领域为必填项",
  "admin.programs.editor.status.label": "状态：",
  "admin.programs.guidance.domain.toggle.show": "各领域的含义是什么？",
  "admin.programs.guidance.domain.toggle.hide": "隐藏",
  "admin.programs.guidance.domain.clinical": "患者检测：表单采集患者标识符、申请医生和既往病史。",
  "admin.programs.guidance.domain.environmental": "合规/监测采样（水、食品、空气）。无患者字段。",
  "admin.programs.guidance.domain.vector": "标本监测（蚊、蜱）：物种、混样清单。",
  "admin.programs.guidance.gui.emptyState.body": "暂无问题：可逐个添加问题，或在 JSON 模式下粘贴问卷。",
  "admin.programs.guidance.gui.emptyState.action": "添加第一个问题",
  "admin.programs.guidance.json.referenceCard.format": "格式：FHIR R4 问卷",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "允许的 item.type：{allowed}。",
  "admin.programs.questionnaire.mode.visualBuilder": "可视化构建器",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "问题文本",
  "admin.programs.questionnaire.question.type.label": "问题类型",
  "admin.programs.questionnaire.question.addNew": "添加新问题",
  "admin.programs.questionnaire.question.actions.aria": "问题操作",
  "admin.programs.questionnaire.question.actions.delete": "删除问题",
  "admin.programs.questionnaire.answerOptions.section.title": "答案选项",
  "admin.programs.questionnaire.answerOptions.addOption": "添加选项",
  "admin.programs.questionnaire.answerOptions.deleteOption": "删除选项",
  "admin.programs.questionnaire.answerOptions.empty": "暂无选项：请至少添加一个，以便接收处选择值。",
  "admin.programs.questionnaire.answerOptions.coded": "编码",
  "admin.programs.questionnaire.answerOptions.codedHelp": "编码选项来自术语集，在此仅以只读方式显示。请在 JSON 模式下编辑。",
  "admin.programs.questionnaire.preview.label": "示例",
  "admin.programs.questionnaire.preview.empty": "暂无问题：开始添加问题即可查看预览。",
  "admin.programs.questionnaire.preview.untitled": "（无标题）",
  "admin.programs.questionnaire.preview.boolean.example": "◯ 是 ◯ 否",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "数字",
  "admin.programs.questionnaire.preview.quantity.unit": "单位",
  "admin.programs.questionnaire.json.validate": "验证 JSON",
  "admin.programs.questionnaire.json.reformat": "重新格式化",
  "admin.programs.questionnaire.json.validated": "已验证：{count} 个问题",
  "admin.programs.questionnaire.json.error.title": "无效的问卷",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType 必须为“Questionnaire”",
  "admin.programs.questionnaire.json.error.itemArray": "item 必须是数组",
  "admin.programs.questionnaire.json.error.itemShape": "每个项目必须包含 linkId、text 和 type，且 type 须为 [{allowed}] 之一",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "linkId“{linkId}”重复：每个项目必须具有唯一的 linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "高级功能（enableWhen、通过 unit/unitOption 设置的数量单位、嵌套项）在此以 JSON 编辑：可视化构建器会保留这些功能，但不会显示它们。",
  "admin.programs.basicInfo.domain.helper": "控制此计划的显示位置：接收处只会看到与订单领域相匹配的计划。",
  "admin.programs.editor.status.noHardDelete": "不支持彻底删除：停用可保留历史记录。",
  "admin.programs.deactivate.modal.body": "“{programName}”将不再出现在新订单的订单录入计划选择器中。{orderCount, plural, one {其 # 个历史订单保留计划编码} other {其 # 个历史订单保留计划编码}}，所有指标计数均予以保留。您可以随时从计划列表中重新激活。",
  "admin.programs.deactivate.modal.body.unknownCount": "“{programName}”将不再出现在新订单的订单录入计划选择器中。历史订单保留其计划编码，所有指标计数均予以保留。您可以随时从计划列表中重新激活。",
  "admin.programs.questionnaire.question.unsupported": "这是一个“{type}”项目，此构建器无法编辑。保存时将原样保留。请在 JSON 模式下编辑。",
  "admin.programs.questionnaire.question.type.boolean": "是 / 否",
  "admin.programs.questionnaire.question.type.choice": "单选",
  "admin.programs.questionnaire.question.type.checkbox": "复选框",
  "admin.programs.questionnaire.question.type.integer": "整数",
  "admin.programs.questionnaire.question.type.decimal": "小数",
  "admin.programs.questionnaire.question.type.date": "日期",
  "admin.programs.questionnaire.question.type.time": "时间",
  "admin.programs.questionnaire.question.type.string": "短文本",
  "admin.programs.questionnaire.question.type.text": "长文本",
  "admin.programs.questionnaire.question.type.quantity": "数量",
  "admin.programs.questionnaire.question.typeExample.boolean": "是/否答案。示例：“首次产前检查？”",
  "admin.programs.questionnaire.question.typeExample.choice": "从固定列表中选择一个选项。示例：“样本状况”。",
  "admin.programs.questionnaire.question.typeExample.checkbox": "可选择多个选项。示例：“现有症状”。",
  "admin.programs.questionnaire.question.typeExample.integer": "仅限整数。示例：“孕周（周）”。",
  "admin.programs.questionnaire.question.typeExample.decimal": "带小数的数字。示例：“母亲体重（kg）”。",
  "admin.programs.questionnaire.question.typeExample.date": "日历日期。示例：“末次月经日期”。",
  "admin.programs.questionnaire.question.typeExample.time": "一天中的时间。示例：“样本采集时间”。",
  "admin.programs.questionnaire.question.typeExample.string": "简短自由文本。示例：“申请医生姓名”。",
  "admin.programs.questionnaire.question.typeExample.text": "较长的自由文本。示例：“临床备注”。",
  "admin.programs.questionnaire.question.typeExample.quantity": "数字加单位（例如“采集量：5 mL”）。允许的单位来自在 JSON 模式下设置的 FHIR 扩展；仅通过图形界面创建的数量类型接受任何单位。",
  "admin.config.logo.error.fileTooLarge": "图片太大。最大尺寸为 2MB。",
  "admin.config.logo.formats": "文件格式：JPG、PNG、GIF（最大2MB）",
  "admin.label": "管理",
  "admin.labUnit.basicInfo.domain.clinical": "临床",
  "admin.labUnit.basicInfo.domain.environmental": "环境",
  "admin.labUnit.basicInfo.domain.label": "领域",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "历史订单/结果是根据原领域的规则进行评估的。新订单将采用新领域的规则。",
  "admin.labUnit.domain.confirm.heading": "更改实验室单元领域？",
  "admin.labUnit.edit.select": "选择实验室单元",
  "admin.labUnit.edit.title": "编辑实验室单元域",
  "admin.labUnit.list.filter.domain": "按领域筛选",
  "admin.legacy": "传统管理",
  "button.back": "← 返回列表",
  "button.labUnit.add": "添加实验室单元",
  "button.labUnit.create": "创建实验室单元",
  "button.labUnit.creating": "创建中...",
  "button.labUnit.tests.assign": "分配检测",
  "button.labUnit.tests.assign.confirm": "分配 {count, plural, one {# 个检测} other {# 个检测}}",
  "button.labUnit.tests.reassign": "重新分配已选择项（{count}）",
  "button.labUnit.tests.reassign.confirm": "重新分配 {count, plural, one {# 个检测} other {# 个检测}}",
  "configuration.labUnit.manage": "实验室单元管理",
  "error.labUnit.description.maxLength": "描述内容必须不超过{max}个字符",
  "error.labUnit.domain.required": "必须选择领域",
  "error.labUnit.list.load": "加载实验室单元时出错",
  "error.labUnit.name.duplicate": "该实验室单元名称已存在",
  "error.labUnit.name.maxLength": "名称不得超过{max}个字符",
  "error.request.unreadable": "未保存任何内容：服务器不接受发送的某个值。请检查表单后重试。",
  "error.labUnit.name.required": "名称为必填项",
  "heading.labUnit.add": "添加新的实验室单元",
  "heading.labUnit.editing": "编辑中",
  "heading.labUnit.filtered": "显示 {filtered} 个，共 {total} 个实验室单元",
  "heading.labUnit.management": "实验室单元管理",
  "heading.labUnit.subtitle": "配置实验室单元（检测科室）、领域分类、检测分配及显示顺序。",
  "heading.labUnit.total": "总计：{total} 个实验室单元",
  "helper.labUnit.description": "本实验室单元的简短内部描述，供实验室工作人员参考",
  "helper.labUnit.domain": "确定哪些订单录入和样本采集字段适用于转至该实验室单元的订单。",
  "helper.labUnit.name": "请为此实验室单元输入一个唯一的名称（例如，“血液学”、“微生物学”）",
  "label.labUnit.actions": "操作",
  "label.labUnit.active": "活跃",
  "label.labUnit.description": "描述",
  "label.labUnit.displayOrder": "位置",
  "label.labUnit.displayOrder.addHint": "请先保存该实验室单元，然后设置其显示顺序。",
  "label.labUnit.displayOrder.current": "当前",
  "label.labUnit.displayOrder.intro": "在全系统的实验室单元菜单和下拉列表中为该实验室单元设置位置。输入位置并保存——其余实验室单元将自动重新编号。",
  "label.labUnit.displayOrder.loading": "正在加载显示顺序...",
  "label.labUnit.displayOrder.saved": "已保存显示顺序",
  "label.labUnit.displayOrder.saveError": "保存显示顺序失败",
  "label.labUnit.domain": "领域",
  "label.labUnit.filterStatus": "按状态筛选",
  "label.labUnit.list.loading": "正在加载实验室单元……",
  "label.labUnit.loading": "正在加载实验室单元……",
  "label.labUnit.notFound": "该实验室单元不存在。请返回列表选择其他单元。",
  "label.labUnit.editorLoadError": "无法加载实验室单元。请刷新页面重试。",
  "label.labUnit.name": "名称",
  "label.labUnit.nameInLocale": "名称（{language}）",
  "error.labUnit.tests.action": "检测分配操作失败",
  "error.labUnit.deactivate.failed": "实验室单元未停用。请检查选项后重试。",
  "error.labUnit.deactivate.destinationInactive": "目标实验室单元已停用。请选择已启用的单元，或先重新启用该单元。",
  "heading.labUnit.tests.assign": "将检测分配给本实验室单元",
  "heading.labUnit.tests.reassign": "重新分配检测项目",
  "label.labUnit.tests.assign.explain": "每项检测都隶属于且仅隶属于一个实验室单元。在此分配检测会将其从当前所属的实验室单元中移出（每个检测旁均显示所属实验室单元）。",
  "label.labUnit.tests.assign.none": "未找到可分配的检测项目。",
  "label.labUnit.tests.reassign.destination": "目的地实验室单元",
  "label.labUnit.tests.reassign.explain": "重新分配即刻生效。新订单将转发至目标实验室单元；已完成检测结果将保留其原始数据。",
  "label.labUnit.tests.reassign.inactiveDestination": "该实验室单元已停用：在重新启用之前，移入的检测无法下单。已完成的结果保留其原始数据。",
  "label.labUnit.inactiveOption": "{name}（已停用）",
  "label.labUnit.tests.reassign.moving": "{count, plural, other {# 项检测}} will be moved:",
  "message.labUnit.tests.assigned": "本实验室单元所安排的检测项目。",
  "message.labUnit.tests.reassigned": "检测项目已成功重新分配。",
  "placeholder.labUnit.tests.reassign.destination": "选择目的地...",
  "placeholder.labUnit.tests.search": "搜索检测...",
  "label.labUnit.section.assigned-tests": "检测",
  "label.labUnit.section.basic-info": "基本信息",
  "label.labUnit.section.display-order": "显示顺序",
  "label.labUnit.status": "状态",
  "label.labUnit.testCount": "检测项目",
  "label.labUnit.tests.addHint": "请先保存该实验室单元，然后再为其分配检测项目。",
  "label.labUnit.tests.count": "{count, plural, other {已分配 # 项检测}}",
  "label.labUnit.tests.loadError": "无法加载已分配的检测项目",
  "label.labUnit.tests.loading": "正在加载已分配的检测...",
  "label.labUnit.tests.none": "该实验室单元目前尚未分配任何检测项目。",
  "label.labUnit.tests.testName": "检测名称",
  "message.labUnit.add.success": "实验室单元已成功创建。",
  "message.labUnit.edit.success": "实验室单元已成功保存。",
  "message.labUnit.noResults": "未找到符合您条件的实验室单元",
  "placeholder.labUnit.filter.domain": "所有领域",
  "placeholder.labUnit.filter.status": "所有状态",
  "placeholder.labUnit.search": "搜索实验室单元……",
  "sidenav.label.admin.labUnit.addingNew": "添加新的实验室单元",
  "sidenav.label.admin.labUnit.backToList": "← 所有实验室单元",
  "sidenav.label.admin.labUnit.editing": "编辑中",
  "sidenav.label.admin.labUnit.editingGeneric": "编辑实验室单元",
  "sidenav.label.admin.labUnit.sectionsHelper": "点击一个实验室单元以编辑其各部分",
  "sidenav.label.admin.labUnitManagement": "实验室单元编辑器",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "heading.labUnit.deactivate": "停用实验室单元",
  "button.labUnit.deactivate.confirm": "停用实验室单元",
  "label.labUnit.deactivate.loading": "正在检查此操作的影响…",
  "label.labUnit.deactivate.impact": "该实验室单元当前包含：",
  "label.labUnit.deactivate.impact.tests": "{count} 项已分配的检测（{active} 项启用）",
  "label.labUnit.deactivate.impact.pending": "{count} 项待处理的分析",
  "label.labUnit.deactivate.impact.historical": "{count} 项已完成的分析（历史记录永不删除）",
  "info.labUnit.deactivate.pending": "此实验室单元会保留在工作列表中，直到其 {count} 项待处理分析完成。",
  "label.labUnit.deactivate.option": "已分配的检测应如何处理？",
  "label.labUnit.deactivate.option.keep": "保留分配：检测保持分配，该单元不再接收新订单",
  "label.labUnit.deactivate.option.deactivateAll": "同时停用所有已分配的检测",
  "label.labUnit.deactivate.option.reassign": "先将检测重新分配到其他实验室单元",
  "label.labUnit.deactivate.confirm": "输入 DEACTIVATE 以确认",
  "admin.page.configuration.formEntryConfigMenu.button.add": "添加",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "停用",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "退出",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "修改",
  "admin.page.configuration.formEntryConfigMenu.button.save": "保存",
  "admin.page.configuration.formEntryConfigMenu.description": "描述",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "编辑记录",
  "admin.page.configuration.formEntryConfigMenu.name": "名称",
  "admin.page.configuration.formEntryConfigMenu.select": "选择",
  "admin.page.configuration.formEntryConfigMenu.value": "值",
  "admin.labelPresets.title": "标签预设",
  "admin.labelPresets.addButton": "添加预设",
  "admin.labelPresets.search.placeholder": "搜索预设...",
  "admin.labelPresets.col.name": "名称",
  "admin.labelPresets.col.barcodeType": "条码类型",
  "admin.labelPresets.col.dimensions": "尺寸",
  "admin.labelPresets.col.scope": "范围",
  "admin.labelPresets.col.status": "状态",
  "admin.labelPresets.col.actions": "操作",
  "admin.labelPresets.systemTag": "系统",
  "admin.labelPresets.status.active": "活跃",
  "admin.labelPresets.status.inactive": "非活跃",
  "admin.labelPresets.scope.order": "订单",
  "admin.labelPresets.scope.sample": "样本",
  "admin.labelPresets.action.edit": "编辑",
  "admin.labelPresets.action.duplicate": "复制",
  "admin.labelPresets.action.activate": "激活",
  "admin.labelPresets.action.deactivate": "停用",
  "admin.labelPresets.duplicateName": "{name} 的副本",
  "admin.labelPresets.duplicated": "预设已复制",
  "admin.labelPresets.duplicateFailed": "复制失败",
  "admin.labelPresets.activated": "预设已激活",
  "admin.labelPresets.deactivated": "预设已停用",
  "admin.labelPresets.toggleFailed": "状态更改失败",
  "admin.labelPresets.saveFailed": "保存失败",
  "admin.labelPresets.saveFailed.detail": "服务器返回 {status}：{message}",
  "admin.labelPresets.saveFailed.noResponse": "服务器无响应。请检查连接后重试。",
  "error.labelpreset.fields.unique": "每个预设中，每个内容字段和每个显示位置只能使用一次。",
  "error.labelpreset.field.required": "每个内容字段条目都必须指定一个字段。",
  "admin.labelPresets.created": "预设已创建",
  "admin.labelPresets.updated": "预设已更新",
  "admin.labelPresets.editor.titleAdd": "添加标签预设",
  "admin.labelPresets.editor.titleEdit": "编辑标签预设",
  "admin.labelPresets.editor.section.basicInfo": "基本信息",
  "admin.labelPresets.editor.section.dimensions": "尺寸（毫米）",
  "admin.labelPresets.editor.section.barcodeSettings": "条码设置",
  "admin.labelPresets.editor.section.printScope": "打印范围与数量",
  "admin.labelPresets.field.name": "预设名称",
  "admin.labelPresets.field.isActive": "活跃",
  "admin.labelPresets.field.heightMm": "高度（毫米）",
  "admin.labelPresets.field.widthMm": "宽度（毫米）",
  "admin.labelPresets.field.barcodeType": "条码类型",
  "admin.labelPresets.field.defaultPerOrder": "每笔订单的默认值",
  "admin.labelPresets.field.maxPerOrder": "每笔订单的最大值",
  "admin.labelPresets.field.defaultPerSample": "每样本的默认值",
  "admin.labelPresets.field.maxPerSample": "每个样本的最大值",
  "admin.labelPresets.validation.name.required": "名称为必填项",
  "admin.labelPresets.validation.name.toolong": "名称不得超过120个字符",
  "admin.labelPresets.validation.dimension.range": "尺寸必须在5至200毫米之间",
  "admin.labelPresets.validation.barcodeType.required": "必须选择条码类型",
  "admin.labelPresets.validation.scope.required": "必须至少选择一个打印范围（订单或样本）",
  "admin.labelPresets.validation.max.lte": "最大值必须大于或等于默认值",
  "admin.labelPresets.editor.section.fields": "内容字段",
  "admin.labelPresets.fields.helper": "打印在条码上方的字段，按此顺序排列。实验室编号始终排在第一位。",
  "admin.labelPresets.fields.locked": "始终第一",
  "admin.labelPresets.fields.required": "必填",
  "admin.labelPresets.fields.required.aria": "必填：{field}",
  "admin.labelPresets.fields.moveUp": "上移 {field}",
  "admin.labelPresets.fields.moveDown": "下移 {field}",
  "admin.labelPresets.fields.remove": "移除{field}",
  "admin.labelPresets.fields.add.label": "添加字段",
  "admin.labelPresets.fields.add.placeholder": "选择字段",
  "admin.labelPresets.fields.add.button": "添加",
  "admin.labelPresets.fields.allAdded": "所有可用字段均已在此标签上。",
  "admin.labelPresets.fields.fitHint": "{count, plural, one {所选字段} other {所选的 # 个字段}}可能无法容纳在 {height} mm 的标签上；条码上方大约{rows, plural, one {可容纳 # 行} other {可容纳 # 行}}。您仍可保存。",
  "admin.labelPresets.fields.position": "位置 {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": "实验室编号",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "患者姓名",
  "admin.labelPresets.fieldKey.PATIENT_ID": "患者ID",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "出生日期",
  "admin.labelPresets.fieldKey.PATIENT_SEX": "性别",
  "admin.labelPresets.fieldKey.SITE_ID": "站点ID",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "采集日期时间",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "采集人",
  "admin.labelPresets.fieldKey.TESTS": "检测项目",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "标本类型",
  "admin.labelPresets.fieldKey.BLOCK_ID": "蜡块ID",
  "admin.labelPresets.fieldKey.SLIDE_ID": "切片ID",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "染色类型",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "病例号",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "存储位置",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "过期日期",
  "error.labelpreset.field.key.unknown": "未知内容字段。",
  "admin.labelPresets.siteWide.title": "全站条码设置",
  "admin.labelPresets.siteWide.scope": "适用于整个实验室",
  "admin.labelPresets.siteWide.prePrint.legend": "预印标签编号来源",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "与订单录入相同的格式和编号池",
  "admin.labelPresets.siteWide.prePrint.separate": "单独的预印编号系列",
  "admin.labelPresets.siteWide.prefix.label": "前缀",
  "admin.labelPresets.siteWide.prefix.helper": "必须恰好为 4 个字母或数字。预印编号以此前缀开头，后接年份和序号。",
  "admin.labelPresets.siteWide.prefix.invalid": "前缀必须恰好为 4 个字母或数字",
  "admin.labelPresets.siteWide.save": "保存设置",
  "admin.labelPresets.siteWide.saved": "全站条码设置已保存",
  "admin.labelPresets.siteWide.saveFailed": "全站条码设置未保存",
  "admin.labelPresets.siteWide.loadFailed": "无法加载全站条码设置。请重新加载页面后重试。",
  "error.sitesettings.barcode.prefix.format": "使用单独的号段时，预印前缀必须正好是 4 个字母或数字",
  "advanced.search": "高级搜索",
  "alert.expired.title": "已过期物品",
  "alert.expiring.title": "即将过期",
  "alert.lowStock.title": "低库存警报",
  "alerts.acknowledge.button": "确认",
  "alerts.acknowledge.comment": "备注",
  "alerts.acknowledge.comment.placeholder": "输入确认备注...",
  "alerts.acknowledge.comment.required": "确认备注为必填项",
  "alerts.acknowledge.error": "确认警报失败",
  "alerts.acknowledge.success": "警报已成功确认",
  "alerts.acknowledge.title": "确认警报",
  "alerts.autoRefresh": "自动刷新",
  "alerts.dashboard.title": "警报仪表板",
  "alerts.empty": "暂无警报",
  "alerts.eqaDeadlineSummary.critical": "紧急",
  "alerts.eqaDeadlineSummary.deadlineCount": "截止日期数量",
  "alerts.eqaDeadlineSummary.subtitle": "即将到期的EQA截止日期概要",
  "alerts.eqaDeadlineSummary.title": "EQA截止日期概要",
  "alerts.eqaDeadlineSummary.viewAll": "查看全部",
  "alerts.filter.myAlerts": "我的警报",
  "alerts.filter.search": "搜索",
  "alerts.filter.severity": "严重程度",
  "alerts.filter.status": "状态",
  "alerts.filter.type": "类型",
  "alerts.severity.critical": "紧急",
  "alerts.severity.warning": "警告",
  "alerts.status.acknowledged": "已确认",
  "alerts.status.open": "待处理",
  "alerts.status.resolved": "已解决",
  "alerts.summary.critical": "紧急",
  "alerts.summary.eqaDeadlines": "EQA截止日期",
  "alerts.summary.sampleExpiration": "样本过期",
  "alerts.summary.statOverdue": "加急逾期",
  "alerts.summary.totalOpen": "待处理总数",
  "alerts.table.actions": "操作",
  "alerts.table.created": "创建时间",
  "alerts.table.message": "消息",
  "alerts.table.severity": "严重程度",
  "alerts.table.status": "状态",
  "alerts.table.type": "类型",
  "alerts.type.critical_result": "紧急结果",
  "alerts.type.equipment_failure": "设备警报",
  "alerts.type.freezer_humidity": "冰箱湿度",
  "alerts.type.freezer_offline": "冰箱离线",
  "alerts.type.freezer_temperature": "冰箱温度",
  "alerts.type.inventory_low": "库存不足",
  "alerts.type.other": "其他原因",
  "alerts.type.referral_critical_result": "转诊紧急结果",
  "alerts.type.referral_rejected": "转诊被拒绝",
  "alerts.type.sample_tracking": "样本跟踪",
  "alerts.type.critical_unacknowledged": "紧急未确认",
  "alerts.type.eqa_deadline": "EQA截止日期",
  "alerts.type.eqa_submission_failed": "室间质评提交失败",
  "alerts.type.microbiology_critical": "微生物学紧急",
  "alerts.type.required_by_deadline": "须在截止日期前完成",
  "alerts.type.sample_expiration": "样本过期",
  "alerts.type.stat_overdue": "加急逾期",
  "alerts.type.stat_upcoming": "即将到期的加急",
  "aliquot": "分装样本",
  "aliquot.analyses.count": "分析: {count}",
  "aliquot.id": "分装样本ID",
  "aliquot.quantity": "分装样本数量",
  "aliquot.quantity.not.balanced": "样本类型的数量不平衡",
  "aliquot.save.error": "保存分装样本数据时出错。",
  "aliquot.save.success": "分装样本数据保存成功。",
  "aliquot.tests.not.assigned": "样本类型未分配检测",
  "aliquot.validation.errors": "验证错误",
  "aliquoting": "样本分装",
  "aliquoting.section": "样本分装部分",
  "all.label": "全部",
  "all.tests.assigned": "所有检测已分配",
  "allocated.to.aliquots": "分配到分装样本",
  "analysis.count": "分析计数",
  "analysis.details": "分析详情",
  "analyzer.adoption.error.heldResults": "{record} 仍有来自修订版 {revision} 的暂存结果。请在采用前处理这些结果。",
  "analyzer.adoption.error.inactiveTest": "{record} 映射到的检测已不再启用。请在采用前选择其他检测。",
  "analyzer.adoption.error.missingAnswers": "{record} 需要为其每个答案做出决定。缺少：{answers}。",
  "analyzer.adoption.error.missingDecisions": "新修订版本保留的每条记录都需要做出决定。缺少：{records}。",
  "analyzer.adoption.error.notNewer": "采用会将分析仪迁移到比修订版本 {revision} 更新的修订版本。",
  "analyzer.adoption.error.revisionInactive": "此分析仪类型的修订版本 {revision} 未启用。",
  "analyzer.bridge.connection.httpStatus": "Analyzer Bridge 拒绝了该请求。",
  "analyzer.bridge.connection.invalidEvidence": "Analyzer Bridge 返回的是另一台分析仪或另一种分析仪类型的应答。",
  "analyzer.bridge.connection.invalidRequest": "发送到 Analyzer Bridge 的请求不完整。",
  "analyzer.bridge.connection.notConfigured": "此服务器未配置 Analyzer Bridge。",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS 保留了分析仪之前的映射，但 Analyzer Bridge 可能仍在使用新映射。请在 Bridge 可以连接时再次应用映射，使两者重新保持一致。",
  "analyzer.bridge.connection.referenceNotStored": "无法将 Analyzer Bridge 连接与此分析仪一起保存。",
  "analyzer.bridge.connection.unreachable": "无法连接 Analyzer Bridge。",
  "analyzer.mapping.error.catalogNotCurrent": "某个已映射的检测或答案在检测目录中已不再启用。请在确认前另选一个。",
  "analyzer.mapping.error.changedSinceLoaded": "此页面加载后，该分析仪的映射已发生变化。请重新加载页面以查看当前映射。",
  "analyzer.mapping.error.componentRequired": "{record} 对应其检测的某个组分。请选择该组分，或将该记录保留为未解决。",
  "analyzer.mapping.error.confirmBeforeApply": "请先确认分析仪的当前映射，然后再应用。",
  "analyzer.mapping.error.resultNotCurrent": "某个已映射的答案对其检测已不再启用。请另选一个答案。",
  "analyzer.mapping.error.testNotCurrent": "某个已映射的检测在检测目录中已不再启用。请另选一个检测。",
  "analyzer.setup.assays.continue": "继续验证",
  "analyzer.setup.assays.count": "已开启 {on}/{total} 个检测项目",
  "analyzer.setup.assays.help": "开启此仪器运行的检测项目，与其自身的主机检测代码设置一致。验证只映射已开启的检测项目。已关闭的检测项目的结果会被暂存，绝不会丢失。",
  "analyzer.setup.assays.loadError": "无法加载该分析仪的检测项目。",
  "analyzer.setup.assays.loading": "正在加载检测项目",
  "analyzer.setup.assays.match.ambiguous": "本实验室目录中有多个检测匹配",
  "analyzer.setup.assays.match.bound": "匹配 {name}",
  "analyzer.setup.assays.match.excluded": "设置为不接收",
  "analyzer.setup.assays.match.incompatible": "有检测匹配，但无法容纳这些结果",
  "analyzer.setup.assays.match.noMatch": "本实验室目录中无此检测",
  "analyzer.setup.assays.none": "此分析仪类型未声明任何检测项目，因此无需映射。其发送的结果将作为未知检测暂存，并可从暂存结果中进行映射。",
  "analyzer.setup.assays.saveError": "无法保存检测项目。",
  "analyzer.setup.assays.title": "检测项目",
  "analyzer.setup.error.adoptToMove": "如需将此分析仪迁移到修订版本 {revision}，请在分析仪类型页面中采用该版本。",
  "analyzer.setup.error.profileKept": "已配置的分析仪保留其分析仪类型。",
  "analyzer.reset.error.profileAvailable": "该分析仪的类型仍然可用。请采用较新的修订版本进行迁移。",
  "analyzer.setup.connect.reset": "重置分析仪类型",
  "analyzer.setup.connect.reset.failed": "无法重置分析仪类型。请重试。",
  "analyzer.action.activate": "激活",
  "analyzer.action.add": "添加",
  "analyzer.action.configureConnection": "配置连接",
  "analyzer.action.deactivate": "停用",
  "analyzer.action.editSetup": "编辑设置",
  "analyzer.action.qualityControl": "质控",
  "analyzer.action.reactivate": "重新激活",
  "analyzer.action.restore": "Restore",
  "analyzer.action.retire": "Retire",
  "analyzer.bridgePairing.automatic": "OpenELIS 会自动使用其已配置的代码进行配对。您也可以在此输入代码。",
  "analyzer.bridgePairing.cancel": "取消",
  "analyzer.bridgePairing.code.label": "配对代码",
  "analyzer.bridgePairing.error.certificateMismatch": "Bridge 应答所用的证书与其出示的证书不同，因此 OpenELIS 未与其配对。",
  "analyzer.bridgePairing.error.closed": "Bridge 当前不接受配对。请在 Bridge 上配置新的配对代码，重启 Bridge，然后重新配对。",
  "analyzer.bridgePairing.error.codeRequired": "请输入配对代码。",
  "analyzer.bridgePairing.error.identity": "OpenELIS 无法为 Bridge 创建或读取其密钥。",
  "analyzer.bridgePairing.error.invalidAnswer": "无法读取 Bridge 的应答。",
  "analyzer.bridgePairing.error.notConfigured": "未为 OpenELIS 配置 Analyzer Bridge 地址。",
  "analyzer.bridgePairing.error.refused": "Bridge 拒绝了配对。",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS 无法连接 Analyzer Bridge。",
  "analyzer.bridgePairing.error.wrongCode": "Bridge 未接受该代码。",
  "analyzer.bridgePairing.pair": "配对",
  "analyzer.bridgePairing.pairAgain": "重新配对",
  "analyzer.bridgePairing.paired.detail": "{url} · Bridge 证书 {fingerprint} · 配对于 {pairedAt}",
  "analyzer.bridgePairing.paired.title": "已与 Analyzer Bridge 配对",
  "analyzer.bridgePairing.stale.bridgeUnpaired.subtitle": "The Bridge at {url} presents the paired certificate {fingerprint} but no longer holds a pairing, so it refuses OpenELIS's calls and holds results.",
  "analyzer.bridgePairing.stale.bridgeUnpaired.title": "The Analyzer Bridge lost its pairing",
  "analyzer.bridgePairing.stale.otherCertificate.subtitle": "The Bridge at {url} presents a certificate other than the paired one ({fingerprint}). OpenELIS refuses its results until it pairs again.",
  "analyzer.bridgePairing.stale.otherCertificate.title": "Paired with a different Bridge certificate",
  "analyzer.bridgePairing.unpaired.subtitle": "请输入 Bridge 日志中显示的配对代码，或 Bridge 配置时使用的代码。配对完成前，结果会暂存在 Bridge 中。",
  "analyzer.bridgePairing.unpaired.title": "Analyzer Bridge 尚未配对",
  "analyzer.combinationName.notification": "分析仪和分析仪检测名称的组合必须唯一",
  "analyzer.fhirImport.error.importFailed": "FHIR数据导入失败",
  "analyzer.fhirImport.error.invalidBundleType": "FHIR Bundle类型无效",
  "analyzer.fhirImport.error.noObservations": "FHIR Bundle中无检验观测数据",
  "analyzer.deliveryIssues.attention.review": "复核未送达的结果",
  "analyzer.deliveryIssues.attention.subtitle": "Analyzer Bridge 中暂存着无法送达 OpenELIS 的结果。",
  "analyzer.deliveryIssues.attention.title": "{count, plural, other {# 条分析仪结果}} not delivered",
  "analyzer.deliveryIssues.column.actions": "操作",
  "analyzer.deliveryIssues.column.analyzer": "分析仪",
  "analyzer.deliveryIssues.column.detail": "详情",
  "analyzer.deliveryIssues.column.reason": "理由",
  "analyzer.deliveryIssues.column.received": "已接收",
  "analyzer.deliveryIssues.column.sender": "发送方",
  "analyzer.deliveryIssues.column.status": "状态",
  "analyzer.deliveryIssues.description": "Analyzer Bridge 已接收但尚未送达 OpenELIS 的结果。“重试”会在问题原因解决后重新发送结果；“忽略”会隐藏该结果，并将其保留在 Bridge 中以供审计。",
  "analyzer.deliveryIssues.dismiss": "关闭",
  "analyzer.deliveryIssues.empty": "Bridge 中没有未送达的结果。",
  "analyzer.deliveryIssues.error.actionFailed": "无法完成该操作。请重新加载后重试。",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "Analyzer Bridge 发送了 OpenELIS 无法读取的响应。",
  "analyzer.deliveryIssues.error.incompleteList": "Analyzer Bridge 中未送达的结果超出了此视图可加载的数量。请直接复核 Bridge 发件箱。",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS 未配置 Analyzer Bridge 地址。",
  "analyzer.deliveryIssues.error.bridgeRefused": "Bridge 拒绝了此操作（{reason}）。请重新加载以查看其当前状态。",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "无法连接 Analyzer Bridge。",
  "analyzer.deliveryIssues.error.invalidId": "此结果引用无效。",
  "analyzer.deliveryIssues.loadFailed": "无法从 Analyzer Bridge 加载未送达的结果。",
  "analyzer.deliveryIssues.loading": "正在检查 Analyzer Bridge 中未送达的结果",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "有多个分析仪连接可能对应此消息。请为每台分析仪设置不同的地址，然后重试。",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "分析仪使用了其设置不接受的连接类型发送数据。",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "由于 OpenELIS 自身的设置问题，OpenELIS 拒收了该结果。请修正分析仪设置，然后重试。",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS 拒绝了该结果。",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS 返回了重定向，因此结果未送达。请检查 Bridge 中配置的 OpenELIS 地址。",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "该消息中没有可送达的结果。",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "Bridge 无法为 OpenELIS 转换该消息。",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "在所有重试次数用完之前，OpenELIS 一直无法连接。结果完好无损；请在 OpenELIS 可以连接后重试。",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "该分析仪的连接没有分析仪类型修订版本，因此无法读取其结果。",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "发送方与任何已保存的分析仪连接都不匹配。请先设置该分析仪，然后重试。",
  "analyzer.deliveryIssues.reason.none": "OpenELIS 尚未接受该结果；Bridge 会继续重试。",
  "analyzer.deliveryIssues.reason.unknown": "Bridge 无法送达此结果（{code}）。",
  "analyzer.deliveryIssues.retry": "重试",
  "analyzer.deliveryIssues.state.deadLettered": "未送达",
  "analyzer.deliveryIssues.state.retrying": "重试中",
  "analyzer.deliveryIssues.title": "未送达的分析仪结果",
  "analyzer.deliveryIssues.unrecognizedSender": "无法识别的发送方 {source}",
  "analyzer.importIssues.accession": "实验室编号",
  "analyzer.importIssues.action": "操作",
  "analyzer.importIssues.description": "复核无法匹配或处理的微生物分析仪事件。暂存的结果可在各分析仪的结果工作列表中进行复核。",
  "analyzer.importIssues.empty": "没有需要关注的微生物分析仪故障事件",
  "analyzer.importIssues.event": "事件",
  "analyzer.importIssues.event.astQcFail": "AST质控失败",
  "analyzer.importIssues.event.astResultAvailable": "AST结果已出",
  "analyzer.importIssues.event.unknown": "分析仪事件（{code}）",
  "analyzer.importIssues.events.description": "在源端再次发送结果之前，请更正分析仪的映射或目标信息。",
  "analyzer.importIssues.events.title": "分析仪事件卡住",
  "analyzer.importIssues.failure.astRunNotMatched": "没有哪个 AST 运行与分析仪和卡片的标识符匹配。",
  "analyzer.importIssues.failure.processingFailed": "无法处理该分析仪事件。",
  "analyzer.importIssues.failure.unknown": "无法处理分析仪事件（{code}）。",
  "analyzer.importIssues.loadFailed": "无法加载分析仪导入问题",
  "analyzer.importIssues.loading": "正在加载分析仪导入问题",
  "analyzer.importIssues.openMappings": "打开映射",
  "analyzer.importIssues.openResults": "查看分析仪结果",
  "analyzer.importIssues.reason": "失败原因",
  "analyzer.importIssues.received": "已接收",
  "analyzer.importIssues.result": "结果",
  "analyzer.importIssues.source": "源ID",
  "analyzer.importIssues.staging.description": "在审核这些导入的结果行之前，需要先修正分析仪的配置。",
  "analyzer.importIssues.staging.title": "暂存结果问题",
  "analyzer.importIssues.target": "目标参考",
  "analyzer.importIssues.test": "检测",
  "analyzer.importIssues.title": "分析仪导入问题",
  "analyzer.fieldCreation.acceptedUnits.label": "可接受单位",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "输入可接受的单位",
  "analyzer.fieldCreation.cancel": "取消",
  "analyzer.fieldCreation.confirmation": "字段创建成功",
  "analyzer.fieldCreation.create": "创建",
  "analyzer.fieldCreation.createNew": "新建字段",
  "analyzer.fieldCreation.description.label": "描述",
  "analyzer.fieldCreation.description.placeholder": "输入字段描述",
  "analyzer.fieldCreation.entityType.label": "实体类型",
  "analyzer.fieldCreation.entityType.placeholder": "选择实体类型",
  "analyzer.fieldCreation.error.generic": "创建字段时出错",
  "analyzer.fieldCreation.error.title": "创建失败",
  "analyzer.fieldCreation.fieldName.label": "字段名称",
  "analyzer.fieldCreation.fieldName.placeholder": "输入字段名称",
  "analyzer.fieldCreation.fieldType.label": "字段类型",
  "analyzer.fieldCreation.fieldType.placeholder": "选择字段类型",
  "analyzer.fieldCreation.loincCode.label": "LOINC代码",
  "analyzer.fieldCreation.loincCode.placeholder": "输入LOINC代码",
  "analyzer.fieldCreation.modal.subtitle": "定义新的分析仪字段",
  "analyzer.fieldCreation.modal.title": "创建新字段",
  "analyzer.fieldCreation.success.message": "字段已成功创建",
  "analyzer.fieldCreation.success.title": "创建成功",
  "analyzer.fieldCreation.validation.entityType.required": "实体类型为必填项",
  "analyzer.fieldCreation.validation.fieldName.required": "字段名称为必填项",
  "analyzer.fieldCreation.validation.unique": "字段名称必须唯一",
  "analyzer.fieldCreation.validation.units.required": "单位为必填项",
  "analyzer.filter.lifecycleStage.all": "全部",
  "analyzer.filter.lifecycleStage.label": "生命周期阶段",
  "analyzer.filter.showRetired": "Show retired analyzers",
  "analyzer.filter.status": "状态",
  "analyzer.filter.status.all": "全部",
  "analyzer.filter.status.label": "状态",
  "analyzer.filter.testUnit": "检测科室",
  "analyzer.filter.type": "类型",
  "analyzer.form.activeStatus": "活跃状态",
  "analyzer.form.activeStatus.description": "设置分析仪为活跃或非活跃状态",
  "analyzer.form.addTitle": "添加分析仪",
  "analyzer.form.cancel": "取消",
  "analyzer.form.communicationMode": "通信模式",
  "analyzer.form.communicationMode.analyzerInitiated": "分析仪发起",
  "analyzer.form.communicationMode.both": "双向",
  "analyzer.form.communicationMode.help": "选择此分析仪的通信启动方向",
  "analyzer.form.communicationMode.lisInitiated": "LIS发起",
  "analyzer.form.createdBy": "创建人",
  "analyzer.form.createdDate": "创建日期",
  "analyzer.form.defaults.error": "加载默认配置失败",
  "analyzer.form.defaults.loaded": "默认配置已加载",
  "analyzer.form.defaults.loaded.subtitle": "默认配置已成功应用",
  "analyzer.form.editTitle": "编辑分析仪",
  "analyzer.form.error.invalidCommunicationMode": "通信模式无效",
  "analyzer.form.error.invalidProtocolVersion": "协议版本无效",
  "analyzer.form.error.save": "保存分析仪时出错",
  "analyzer.form.error.unknown": "发生未知错误",
  "analyzer.form.fileProtocol.description": "配置基于文件的通信协议设置",
  "analyzer.form.fileProtocol.title": "文件协议",
  "analyzer.form.identifierPattern": "标识符模式",
  "analyzer.form.identifierPattern.helperText": "用于识别分析仪消息的正则表达式模式",
  "analyzer.form.identifierPattern.placeholder": "输入标识符模式",
  "analyzer.form.ipAddress": "IP地址",
  "analyzer.form.ipAddress.placeholder": "输入IP地址",
  "analyzer.form.lastModified": "最后修改",
  "analyzer.form.loadDefaultConfig": "加载默认配置",
  "analyzer.form.loadDefaultConfig.helperText": "从预定义模板加载默认配置",
  "analyzer.form.loadDefaultConfig.placeholder": "选择默认配置",
  "analyzer.form.name": "名称",
  "analyzer.form.name.placeholder": "输入分析仪名称",
  "analyzer.form.pluginType": "插件类型",
  "analyzer.form.pluginType.helperText": "选择此分析仪使用的插件类型",
  "analyzer.form.pluginType.placeholder": "选择插件类型",
  "analyzer.form.port": "端口",
  "analyzer.form.port.placeholder": "输入端口号",
  "analyzer.form.protocolVersion": "协议版本",
  "analyzer.form.save": "保存",
  "analyzer.form.status": "状态",
  "analyzer.form.status.helperText": "分析仪的当前状态",
  "analyzer.form.subtitle": "分析仪配置",
  "analyzer.form.success.save": "分析仪保存成功",
  "analyzer.form.testConnection": "测试连接",
  "analyzer.form.testConnection.error": "连接测试失败",
  "analyzer.form.testUnits": "检测科室",
  "analyzer.form.testUnits.helper": "选择此分析仪关联的检测科室",
  "analyzer.form.testUnits.placeholder": "选择检测科室",
  "analyzer.form.type": "类型",
  "analyzer.form.type.helperText": "为该已安装的连接选择可重用的分析仪类型。",
  "analyzer.form.type.invalidSelection": "该分析仪类型修订版本不可用或已停用",
  "analyzer.form.type.loadError": "无法加载分析仪类型管理",
  "analyzer.form.type.other": "其他",
  "analyzer.form.type.placeholder": "选择类型",
  "analyzer.form.type.revision": "{name}，修订版 {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "IP地址格式无效",
  "analyzer.form.validation.name.required": "名称为必填项",
  "analyzer.form.validation.type.required": "类型为必填项",
  "analyzer.hl7.insertError": "HL7消息插入错误",
  "analyzer.hl7.parseError": "HL7消息解析错误",
  "analyzer.hl7.unknownAnalyzer": "未知分析仪",
  "analyzer.list.subtitle": "管理已配置的分析仪",
  "analyzer.list.title": "分析仪列表",
  "analyzer.lifecycle.activate.blockedMessage": "启用前请先完成以下设置要求。请在此分析仪上打开“编辑设置”，验证其映射和连接。",
  "analyzer.lifecycle.activate.blockedTitle": "分析仪尚未就绪",
  "analyzer.lifecycle.activate.cancel": "取消启用",
  "analyzer.lifecycle.activate.confirm": "启用分析仪",
  "analyzer.lifecycle.activate.error": "无法启用该分析仪。",
  "analyzer.lifecycle.activate.errorTitle": "启用失败",
  "analyzer.lifecycle.activate.message": "启用 {name}？在使用前将检查其设置。",
  "analyzer.lifecycle.activate.title": "启用分析仪",
  "analyzer.lifecycle.deactivate.cancel": "取消停用",
  "analyzer.lifecycle.deactivate.confirm": "停用分析仪",
  "analyzer.lifecycle.deactivate.error": "无法停用分析仪。",
  "analyzer.lifecycle.deactivate.errorTitle": "停用失败",
  "analyzer.lifecycle.deactivate.message": "停用{name}？新运行将停止。其配置和历史记录将被保留，日后可重新激活。",
  "analyzer.lifecycle.deactivate.title": "停用分析仪",
  "analyzer.lifecycle.delete.cancel": "Keep analyzer",
  "analyzer.lifecycle.delete.confirm": "Delete analyzer",
  "analyzer.lifecycle.delete.error": "The analyzer could not be deleted.",
  "analyzer.lifecycle.delete.errorTitle": "Delete refused",
  "analyzer.lifecycle.delete.message": "Delete {name}? This is for an analyzer that never received a result and was never activated; one that was used is refused, so retire it instead.",
  "analyzer.lifecycle.delete.title": "Delete analyzer",
  "analyzer.lifecycle.error.inUse": "This analyzer has results or history. Retire it instead.",
  "analyzer.lifecycle.error.notRetired": "The analyzer is not retired.",
  "analyzer.lifecycle.error.running": "Deactivate the analyzer before retiring it.",
  "analyzer.lifecycle.reactivate.blockedMessage": "在重新激活之前，请先完成以下设置要求。请在该分析仪上打开“编辑设置”，以验证其映射和连接。",
  "analyzer.lifecycle.reactivate.blockedTitle": "分析仪尚未就绪",
  "analyzer.lifecycle.reactivate.cancel": "取消重新激活",
  "analyzer.lifecycle.reactivate.confirm": "重新激活分析仪",
  "analyzer.lifecycle.reactivate.error": "无法重新激活分析仪。",
  "analyzer.lifecycle.reactivate.errorTitle": "重新激活失败",
  "analyzer.lifecycle.reactivate.message": "重新激活{name}？在使用前，系统将再次检查其设置。",
  "analyzer.lifecycle.reactivate.title": "重新激活分析仪",
  "analyzer.lifecycle.restore.cancel": "Keep retired",
  "analyzer.lifecycle.restore.confirm": "Restore analyzer",
  "analyzer.lifecycle.restore.error": "The analyzer could not be restored.",
  "analyzer.lifecycle.restore.errorTitle": "Restore failed",
  "analyzer.lifecycle.restore.message": "Restore {name}? It comes back inactive, to be set up and activated again.",
  "analyzer.lifecycle.restore.title": "Restore analyzer",
  "analyzer.lifecycle.retire.cancel": "Keep analyzer",
  "analyzer.lifecycle.retire.confirm": "Retire analyzer",
  "analyzer.lifecycle.retire.error": "The analyzer could not be retired.",
  "analyzer.lifecycle.retire.errorTitle": "Retire failed",
  "analyzer.lifecycle.retire.message": "Retire {name}? Its results and history are kept, and it is hidden from this list unless you show retired analyzers.",
  "analyzer.lifecycle.retire.title": "Retire analyzer",
  "analyzer.connection.choice.select": "选择一个值",
  "analyzer.connection.field.apiToken": "API 令牌",
  "analyzer.connection.field.connectionRole": "连接角色",
  "analyzer.connection.field.directory": "目录",
  "analyzer.connection.field.directory.help": "Analyzer Bridge 主机上的目录",
  "analyzer.connection.field.enabled": "已启用",
  "analyzer.connection.field.filePattern": "文件名模式",
  "analyzer.connection.field.filePattern.help": "Analyzer Bridge 监视的文件名模式",
  "analyzer.connection.field.host": "主机",
  "analyzer.connection.field.host.help": "分析仪的 IP 地址。分析仪连接 Analyzer Bridge 时为可选项。如果分析仪通过 NAT 或代理连接 Bridge，请留空，并改用仪器系统名称。",
  "analyzer.connection.field.numberFormat": "结果中的小数分隔符",
  "analyzer.connection.numberFormat.comma": "逗号（12,5）",
  "analyzer.connection.numberFormat.point": "句点（12.5）",
  "analyzer.connection.field.port": "端口",
  "analyzer.connection.field.senderId": "仪器系统名称",
  "analyzer.connection.field.senderId.help": "此仪器在其消息中发送的名称（ASTM H.5 或 HL7 MSH-3），例如 GeneXpert 系统名称。仅当多台分析仪共用此端口和地址时才需要。",
  "analyzer.connection.field.received": "Received from instruments:",
  "analyzer.connection.field.serialPort": "串行设备",
  "analyzer.connection.field.transport": "传输方式",
  "analyzer.connection.field.unavailable": "连接设置",
  "analyzer.connection.readiness.profileUnavailable": "此连接固定使用 {profileId} 修订版本 {revision}，但 Analyzer Bridge 已不再提供该版本。请重置分析仪类型，然后选择一个可用类型重新连接。分析仪会保留其名称、实验室单元、连接和历史记录。",
  "analyzer.connection.readiness.restoreFailed": "Analyzer Bridge 无法重新启动此连接。请再次启用；如果仍然失败，请检查 Bridge 日志。",
  "analyzer.connection.role.client": "客户端",
  "analyzer.connection.role.server": "服务器",
  "analyzer.connection.reference.configured": "已配置桥接连接",
  "analyzer.connection.reference.missing": "需要建立连接",
  "analyzer.connection.transport.RS-232": "串行（RS-232）",
  "analyzer.connection.transport.TCP/IP": "网络（TCP/IP）",
  "analyzer.connection.validation.invalid": "请检查此值。",
  "analyzer.connection.validation.required": "此字段为必填项。",
  "analyzer.setup.close": "关闭分析仪设置",
  "analyzer.setup.connect.address.required": "输入分析仪地址",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge 尚未确认此具体设置。",
  "analyzer.activation.blocker.connection": "连接设置不完整或无效。",
  "analyzer.activation.blocker.dataFlow": "此分析仪类型不支持所选的数据流。",
  "analyzer.activation.blocker.labUnit": "请分配至少一个有效的实验室单元。",
  "analyzer.activation.blocker.mappings": "必须再次验证分析仪的映射关系。",
  "analyzer.activation.blocker.name": "请输入分析仪的名称。",
  "analyzer.activation.blocker.profile": "已选择分析仪类型的修订版不可用，或不再与该分析仪匹配。",
  "analyzer.activation.blocker.retired": "This analyzer is retired. Restore it before activating it.",
  "analyzer.activation.blocker.recognition": "必须再次验证质控品识别。",
  "analyzer.activation.blocker.transport": "此分析仪类型不支持所选的连接类型。",
  "analyzer.setup.connect.activation.active": "分析仪已启用",
  "analyzer.setup.connect.activation.activating": "正在激活分析仪",
  "analyzer.setup.connect.activation.blockerUnknown": "分析仪的设置尚未准备就绪，无法激活。",
  "analyzer.setup.connect.activation.cancel": "取消",
  "analyzer.setup.connect.activation.error": "无法检查分析仪的就绪状态。",
  "analyzer.setup.connect.activation.finish": "完成并激活",
  "analyzer.setup.connect.activation.loading": "正在检查分析仪是否就绪",
  "analyzer.setup.connect.activation.readiness": "激活就绪状态",
  "analyzer.setup.connect.activation.ready": "分析仪已准备就绪，可以激活了",
  "analyzer.setup.connect.activation.saveChanges": "保存更改",
  "analyzer.setup.connect.activation.saveLater": "保存并稍后完成",
  "analyzer.setup.connect.activation.saving": "正在保存分析仪",
  "analyzer.setup.connect.activation.verifyMappings": "验证映射",
  "analyzer.setup.connect.analyzerAddress": "分析仪地址",
  "analyzer.setup.connect.check.analyzer.address.missing": "未保存分析仪地址，因此未检查分析仪。来自分析仪的结果可证明连接正常。",
  "analyzer.setup.connect.check.analyzer.host.unknown": "无法解析分析仪地址 {host}，因此未检查分析仪。来自分析仪的结果可证明连接正常。",
  "analyzer.setup.connect.check.analyzer.reachable": "Bridge 已在 {host} 连接到分析仪。",
  "analyzer.setup.connect.check.analyzer.unreachable": "Bridge 无法访问位于 {host} 的分析仪。连接到 Bridge 的分析仪通常无法从 Bridge 端访问（防火墙、NAT 或托管服务器所致）。只要收到来自该分析仪的结果，即可证明连接正常。",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Bridge 不支持此连接模式。",
  "analyzer.setup.connect.check.directory.configuration.missing": "测试前请输入分析仪文件目录。",
  "analyzer.setup.connect.check.directory.not.directory": "配置的路径不是一个目录。",
  "analyzer.setup.connect.check.directory.not.found": "未找到配置的目录。",
  "analyzer.setup.connect.check.directory.not.readable": "Bridge 无法读取配置的目录。",
  "analyzer.setup.connect.check.directory.path.invalid": "配置的目录路径无效。",
  "analyzer.setup.connect.check.directory.ready": "目录已准备就绪。",
  "analyzer.setup.connect.check.http.configuration.missing": "测试前请输入分析仪的地址。",
  "analyzer.setup.connect.check.http.connection.error": "Bridge 无法连接到分析仪的地址。",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "该分析仪向 Bridge 发送消息，因此必须通过传送一个结果来验证此连接。",
  "analyzer.setup.connect.check.http.interrupted": "网络连接检测被中断了。",
  "analyzer.setup.connect.check.http.ready": "可以访问该分析仪的地址。",
  "analyzer.setup.connect.check.http.server.error": "分析仪的网址返回了服务器错误。",
  "analyzer.setup.connect.check.http.timeout": "在超时之前，分析仪的地址未作出响应。",
  "analyzer.setup.connect.check.http.url.invalid": "分析仪的地址无效。",
  "analyzer.setup.connect.check.listener.configuration.missing": "共享的 Bridge 监听器尚未配置。请联系 Bridge 管理员检查其监听器设置。",
  "analyzer.setup.connect.check.listener.endpoint.missing": "未配置 Bridge 的监听地址。",
  "analyzer.setup.connect.check.listener.not.listening": "Bridge 监听器不接受连接。",
  "analyzer.setup.connect.check.listener.port.in.use": "已配置的 Bridge 监听端口正在使用中。",
  "analyzer.setup.connect.check.listener.profile.unsupported": "固定的配置文件未定义兼容的 Bridge 监听器。",
  "analyzer.setup.connect.check.listener.ready": "Bridge 监听器已就绪。",
  "analyzer.setup.connect.check.listener.timeout": "在超时之前，Bridge 监听器未作出响应。",
  "analyzer.setup.connect.check.remote.astm.ready": "分析仪已完成 ASTM 握手过程。",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "分析仪返回了一个无效的ASTM握手响应。",
  "analyzer.setup.connect.check.remote.configuration.missing": "请检查分析仪地址和出站目标设置。可选的端口覆盖值可替代分析仪类型或 Bridge 的默认端口。",
  "analyzer.setup.connect.check.remote.connection.error": "Bridge 无法连接到分析仪。",
  "analyzer.setup.connect.check.remote.hl7.ready": "分析仪已完成 HL7 握手。",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "分析仪返回了一个无效的 HL7 握手响应。",
  "analyzer.setup.connect.check.remote.host.unknown": "无法解析分析仪的地址。",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "该分析仪协议不支持远程连接测试。",
  "analyzer.setup.connect.check.remote.refused": "分析仪拒绝了连接。",
  "analyzer.setup.connect.check.remote.timeout": "分析仪在超时前未作出响应。",
  "analyzer.setup.connect.check.serial.configuration.missing": "测试前，请输入分析仪的串行设备。",
  "analyzer.setup.connect.check.serial.not.found": "未找到已配置的串行设备。",
  "analyzer.setup.connect.check.serial.not.readable": "Bridge 无法读取已配置的串行设备。",
  "analyzer.setup.connect.check.serial.path.invalid": "配置的串行设备路径无效。",
  "analyzer.setup.connect.check.serial.ready": "分析仪的串行设备已就绪。",
  "analyzer.setup.connect.checkKind.analyzer": "分析仪（仅供参考）",
  "analyzer.setup.connect.checkKind.directory": "目录",
  "analyzer.setup.connect.checkKind.http_endpoint": "网址",
  "analyzer.setup.connect.checkKind.http_input": "分析仪传入消息",
  "analyzer.setup.connect.checkKind.listener": "Bridge 监听器",
  "analyzer.setup.connect.checkKind.other": "连接检查",
  "analyzer.setup.connect.checkKind.remote_protocol": "分析仪协议",
  "analyzer.setup.connect.checkKind.serial_device": "串行设备",
  "analyzer.setup.connect.checkStatus.failed": "连接检查失败。",
  "analyzer.setup.connect.checkStatus.missing_configuration": "连接设置不完整。",
  "analyzer.setup.connect.checkStatus.passed": "连接检查通过。",
  "analyzer.setup.connect.checkStatus.skipped": "无法运行此检查。",
  "analyzer.setup.connect.checkStatus.timed_out": "连接检查超时。",
  "analyzer.setup.connect.configureEndpoint": "将分析仪配置为使用",
  "analyzer.setup.connect.dataFlow": "数据流",
  "analyzer.setup.connect.dataFlow.resultsOnly": "仅结果",
  "analyzer.setup.connect.dataFlow.twoWay": "双向",
  "analyzer.setup.connect.destination": "目标地址：{host}，端口 {port}",
  "analyzer.setup.connect.destinationRemediation": "请检查分析仪地址、目标端口、监听服务和网络访问，然后重新测试。",
  "analyzer.setup.connect.listenerPort": "Bridge 监听端口：{port}",
  "analyzer.setup.connect.portSource": "端口来源：{source}",
  "analyzer.setup.connect.portSource.override": "连接覆盖设置",
  "analyzer.setup.connect.portSource.profile": "分析仪类型默认值",
  "analyzer.setup.connect.portSource.bridge": "Bridge 默认值",
  "analyzer.setup.connect.directory": "分析仪文件目录",
  "analyzer.setup.connect.directory.required": "输入分析仪文件目录",
  "analyzer.setup.connect.error": "无法保存或测试连接设置。",
  "analyzer.setup.connect.evidence": "连接证据",
  "analyzer.setup.connect.loadError": "无法加载已保存的分析仪连接。",
  "analyzer.setup.connect.loading": "正在加载分析仪连接",
  "analyzer.setup.connect.outcome.failure": "连接测试失败",
  "analyzer.setup.connect.outcome.missing_configuration": "连接设置不完整",
  "analyzer.setup.connect.outcome.success": "已准备好连接",
  "analyzer.setup.connect.outcome.timeout": "连接超时",
  "analyzer.setup.connect.port": "分析仪端口",
  "analyzer.setup.connect.port.invalid": "请输入 1 到 65535 之间的端口号",
  "analyzer.setup.connect.sourceAddress": "分析仪源地址",
  "analyzer.setup.connect.test": "测试连接",
  "analyzer.setup.connect.testing": "正在测试连接",
  "analyzer.setup.connect.title": "连接",
  "analyzer.setup.connect.useResultsOnly": "使用“仅结果”",
  "analyzer.setup.instrument.continue": "继续到检测项目",
  "analyzer.setup.instrument.labUnits": "实验室单元",
  "analyzer.setup.instrument.labUnits.placeholder": "选择实验室单元",
  "analyzer.setup.instrument.labUnits.required": "请至少选择一个实验室单元",
  "analyzer.setup.instrument.name": "分析仪名称",
  "analyzer.setup.instrument.name.required": "输入分析仪名称",
  "analyzer.setup.instrument.notListed": "仪器未列出？",
  "analyzer.setup.instrument.saveError": "无法保存分析仪。请重试。",
  "analyzer.setup.instrument.saving": "正在保存分析仪",
  "analyzer.setup.instrument.summary": "已保存的仪器详细信息",
  "analyzer.setup.step.edit": "编辑 {step}",
  "analyzer.setup.instrument.type": "类型",
  "analyzer.setup.instrument.type.helper": "请为您的仪器选择列出的类型，即使它只发送结果。仅发送结果还是同时接收订单，稍后在“连接”中设置。",
  "analyzer.setup.instrument.type.placeholder": "搜索分析仪类型",
  "analyzer.setup.instrument.type.required": "选择分析仪类型",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · 修订版 {revision}",
  "analyzer.setup.instrument.title": "仪器",
  "analyzer.setup.steps": "分析仪设置步骤",
  "analyzer.setup.title": "设置一个新的分析仪",
  "analyzer.setup.title.named": "设置 {name}",
  "analyzer.setup.verify.confirm": "请确认以下映射以继续。",
  "analyzer.setup.verify.noAssays": "此仪器未启用任何检测项。请在“检测项”中启用其运行的检测项。",
  "analyzer.setup.verify.unresolved": "{count, plural, other {# 条记录或值}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "继续到连接",
  "analyzer.setup.verify.selecting": "正在应用映射...",
  "analyzer.setup.verify.selectionError": "无法应用已复核的映射。请重新加载“验证”页面并重试。",
  "analyzer.setup.verify.loading": "正在加载映射验证",
  "analyzer.setup.verify.summary": "此设置中已复核的映射",
  "analyzer.setup.verify.summary.stale": "映射需要重新验证",
  "analyzer.setup.verify.title": "验证",
  "analyzer.navigation.analyzerTypes": "分析仪类型",
  "analyzer.navigation.analyzers": "分析仪",
  "analyzer.navigation.analyzersList": "分析仪列表",
  "analyzer.navigation.fieldMappings": "字段映射",
  "analyzer.navigation.qc": "质控",
  "analyzer.navigation.qcDashboard": "质控仪表板",
  "analyzer.navigation.qcAlerts": "质控警报",
  "analyzer.navigation.qcCorrectiveActions": "质控纠正措施",
  "analyzerType.action.deactivate": "停用",
  "analyzerType.action.editMappings": "查看默认映射",
  "analyzerType.action.history": "查看历史记录",
  "analyzerType.action.reactivate": "重新激活",
  "analyzerType.action.updateShared": "更新共享类型",
  "analyzerType.adoption.adopted": "已采用修订版本 {revision}。请确认以下映射，然后应用以切换此分析仪。",
  "analyzerType.adoption.blocked.heldResults": "{code} 仍有来自修订版本 {revision} 的暂存结果。请先处理这些结果，再进行采用。",
  "analyzerType.adoption.blocked.inactiveTest": "已映射到一个不再启用的检测。请选择其他检测。",
  "analyzerType.adoption.blocked.reviewHeld": "复核保留的结果",
  "analyzerType.adoption.bucket.blocked": "已阻止",
  "analyzerType.adoption.bucket.blocked.help": "需先解决这些问题才能采用。",
  "analyzerType.adoption.bucket.changed": "已更改",
  "analyzerType.adoption.bucket.changed.help": "较新的修订版本为这些项目提出了不同的建议。请保留当前选择或使用新的默认值。",
  "analyzerType.adoption.bucket.needs_mapping": "需要映射",
  "analyzerType.adoption.bucket.needs_mapping.help": "本修订版本中新增或不再沿用的项目。请立即映射，或留待以后处理。",
  "analyzerType.adoption.bucket.retired": "不再发送",
  "analyzerType.adoption.bucket.retired.help": "修订版本 {revision} 不再发送这些项目，因此其映射将被移除。",
  "analyzerType.adoption.bucket.unchanged": "未更改",
  "analyzerType.adoption.bucket.unchanged.help": "这些项目将按原样沿用。",
  "analyzerType.adoption.changed.current": "当前：{name}",
  "analyzerType.adoption.changed.newDefault": "新默认值：{name}",
  "analyzerType.adoption.error.save": "无法保存采用",
  "analyzerType.adoption.keepCurrent": "保留当前",
  "analyzerType.adoption.notice.subtitle": "在您保存、确认并应用此内容之前，此分析仪将继续按修订版本 {from} 接收数据。",
  "analyzerType.adoption.notice.title": "正在采用修订版本 {revision}",
  "analyzerType.adoption.save": "保存为修订版本 {revision}",
  "analyzerType.adoption.title": "采用 {name} 的修订版本 {revision}",
  "analyzerType.adoption.useNewDefault": "使用新默认值",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, other {使用此类型的分析仪}}",
  "analyzerType.affectedAnalyzers.adopt": "采用修订版本 {revision}",
  "analyzerType.affectedAnalyzers.verify": "验证已保存的映射",
  "analyzerType.affectedAnalyzers.current": "Confirmed and current",
  "analyzerType.affectedAnalyzers.behind": "Behind",
  "analyzerType.actions.ariaLabel": "{name} 的操作",
  "analyzerType.button.create": "创建配置文件",
  "analyzerType.button.cancel": "取消",
  "analyzerType.button.duplicate": "复制配置文件",
  "analyzerType.button.publish": "发布配置文件",
  "analyzerType.button.startUpdate": "开始更新",
  "analyzerType.column.actions": "操作",
  "analyzerType.column.protocol": "协议",
  "analyzerType.column.resultsMapped": "已映射的结果",
  "analyzerType.column.status": "状态",
  "analyzerType.column.testsMapped": "已映射的检测项目",
  "analyzerType.column.type": "类型",
  "analyzerType.column.usedBy": "使用方",
  "analyzerType.dataFlow.resultsOnly": "仅显示结果",
  "analyzerType.dataFlow.twoWay": "双向",
  "analyzerType.duplicate.lineage.subtitle": "新配置文件的来源是 {name} 的修订版本 {revision}。此后的更改不会影响源配置文件及其分析仪。",
  "analyzerType.duplicate.lineage.title": "保留谱系的新配置文件",
  "analyzerType.draft.created.subtitle": "该草稿已保存在Analyzer Bridge中。必须先完成并验证该草稿，才能将其发布以用于分析仪的设置。",
  "analyzerType.draft.created.title": "配置文件草稿已创建",
  "analyzerType.draft.loading": "正在加载配置文件草稿",
  "analyzerType.draft.publish.ready.subtitle": "{name} 具有 Bridge 独有的身份标识，并保留了其来源谱系。",
  "analyzerType.draft.publish.ready.title": "已准备好发布",
  "analyzerType.draft.publish.review.subtitle": "发布前，请复核并保存 {name} 的质控识别行为。",
  "analyzerType.draft.publish.review.title": "完成配置文件复核",
  "analyzerType.draft.update.loading": "正在加载配置文件更新草稿",
  "analyzerType.draft.update.subtitle": "在该草稿完成并发布之前，共享分析仪类型保持不变。现有分析仪仍将固定在其当前版本上。",
  "analyzerType.draft.update.title": "已创建配置文件更新草稿",
  "analyzerType.empty.subtitle": "调整搜索条件或筛选条件，以查看其他分析仪类型。",
  "analyzerType.empty.title": "没有匹配的分析仪类型",
  "analyzerType.explainer.subtitle": "相同的分析仪可以共享同一种类型。当某个分析仪需要不同的行为时，请复制该类型；应停用类型，而非删除其历史记录。",
  "analyzerType.explainer.title": "可重复使用的分析仪设置",
  "analyzerType.error.nameUnique": "配置文件名称必须唯一",
  "analyzerType.field.connectionTest": "支持连接测试",
  "analyzerType.field.dataFlow": "数据流",
  "analyzerType.field.fileFormat": "文件格式",
  "analyzerType.field.filePattern": "文件名模式",
  "analyzerType.field.manufacturer": "制造商",
  "analyzerType.field.model": "型号",
  "analyzerType.field.newProfileName": "新配置文件名称",
  "analyzerType.field.profileName": "配置文件名称",
  "analyzerType.field.protocol": "协议",
  "analyzerType.field.resultColumn": "“结果”列",
  "analyzerType.field.sampleColumn": "样本编号列",
  "analyzerType.field.sourceProfile.placeholder": "选择分析仪类型",
  "analyzerType.field.sourceProfile": "源分析仪类型",
  "analyzerType.field.testColumn": "测试代码列",
  "analyzerType.filter.all": "所有分析仪",
  "analyzerType.filter.mapping": "映射状态",
  "analyzerType.filter.protocol": "协议",
  "analyzerType.filter.showDeactivated": "显示已停用",
  "analyzerType.filter.source": "创建时间",
  "analyzerType.history.action.created": "创建时间",
  "analyzerType.history.action.deactivated": "已停用",
  "analyzerType.history.action.duplicated": "已复制",
  "analyzerType.history.action.reactivated": "已重新激活",
  "analyzerType.history.action.shipped": "已发货",
  "analyzerType.history.action.updated": "更新",
  "analyzerType.history.actor": "修改人",
  "analyzerType.history.change": "更改",
  "analyzerType.history.loading": "正在加载配置文件历史记录",
  "analyzerType.history.revisionValue": "修订版 {revision}",
  "analyzerType.history.revision": "修订",
  "analyzerType.history.status": "状态",
  "analyzerType.history.time": "修改于",
  "analyzerType.lineage": "派生自 {profileId} 修订版 {revision}",
  "analyzerType.loading": "正在加载分析仪类型",
  "analyzerType.mapping.complete": "已完全映射",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.allDecided": "{decided} decided: {mapped} mapped, {excluded} excluded",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} 已标记为“请勿接收”",
  "analyzerType.mapping.incomplete": "需要映射",
  "analyzerType.mapping.notApplicable": "不适用",
  "analyzerType.mapping.notStarted": "已映射",
  "analyzerType.mappingEditor.applyToAnalyzer": "应用映射并重试暂存结果",
  "analyzerType.mappingEditor.appliedToAnalyzer": "当前映射已应用到此分析仪。符合条件的暂存结果已重试。",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "无法将映射应用到此分析仪。",
  "analyzerType.mappingEditor.alias": "别名：{alias}",
  "analyzerType.mappingEditor.confirm": "确认映射和质控识别",
  "analyzerType.mappingEditor.confirmation.by": "由 {actor} 于 {date} 确认",
  "analyzerType.mappingEditor.confirmation.current": "当前确认",
  "analyzerType.mappingEditor.confirmation.stale": "确认信息已过期",
  "analyzerType.mappingEditor.confirmation.summary.current": "当前",
  "analyzerType.mappingEditor.confirmation.summary.stale": "过期",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "未确认",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "未确认",
  "analyzerType.mappingEditor.confirmation": "确认",
  "analyzerType.mappingEditor.confirmed": "映射和质控识别已确认",
  "analyzerType.mappingEditor.error.confirm": "确认失败",
  "analyzerType.mappingEditor.error.load": "无法加载分析仪映射",
  "analyzerType.mappingEditor.error.route": "需要有效的分析仪或分析仪类型修订版本",
  "analyzerType.mappingEditor.error.save": "无法保存映射",
  "analyzerType.mappingEditor.excludeResult.short": "请勿接收",
  "analyzerType.mappingEditor.excludeResult": "请勿接收 {value}",
  "analyzerType.mappingEditor.callComponentPicker": "{code} 的判定结果发送至",
  "analyzerType.mappingEditor.componentPicker": "{code} 对应的 OpenELIS 组分",
  "analyzerType.mappingEditor.componentPicker.required": "选择此记录对应的组分。",
  "analyzerType.mappingEditor.componentPicker.placeholder": "选择组分",
  "analyzerType.mappingEditor.excludeTest": "请勿接收 {code}",
  "analyzerType.mappingEditor.partial": "{count} 个未解决的映射。您可以确认并连接；受影响的结果将被保存以待更正后再使用。",
  "analyzerType.mappingEditor.incomplete": "确认前，请更正不可用的检测或结果选择。",
  "analyzerType.mappingEditor.loading": "正在加载分析仪映射",
  "analyzerType.mappingEditor.observed": "在保留结果中观察到",
  "analyzerType.mappingEditor.recognition.heading": "质控结果识别",
  "analyzerType.mappingEditor.recognition.none": "该分析仪类型明确声明，该接口不传输任何质控结果。",
  "analyzerType.mappingEditor.resultPicker.placeholder": "选择一个 OpenELIS 结果",
  "analyzerType.mappingEditor.resultPicker": "{value} 的 OpenELIS 结果",
  "analyzerType.mappingEditor.tests.none": "此分析仪类型未声明任何检测，因此无需映射。其作者可在该类型的新修订版中添加检测。",
  "analyzerType.mappingEditor.results.empty": "此检测没有活跃的结果选项",
  "analyzerType.mappingEditor.results.heading": "结果 - {name}",
  "analyzerType.mappingEditor.results.loading": "正在加载结果选项",
  "analyzerType.mappingEditor.results.openCatalog": "在“检测目录”中添加结果选项",
  "analyzerType.mappingEditor.results.testFirst": "映射结果之前，请先选择一项 OpenELIS 检测",
  "analyzerType.mappingEditor.reason.result.ambiguous": "未映射：此检测有多个答案带有该值的代码。请选择一个。",
  "analyzerType.mappingEditor.reason.result.incompatible": "未映射：此检测没有可容纳该值的答案。",
  "analyzerType.mappingEditor.reason.result.no_match": "未映射：此检测没有答案带有该值的代码。",
  "analyzerType.mappingEditor.reason.test.ambiguous": "未映射：本实验室目录中有多个检测带有此代码。请选择一个。",
  "analyzerType.mappingEditor.reason.test.incompatible": "未映射：本实验室目录中有检测带有此代码，但无法容纳这些结果。",
  "analyzerType.mappingEditor.reason.test.no_match": "未映射：本实验室目录中没有检测带有此代码。",
  "analyzerType.mappingEditor.results": "结果映射",
  "analyzerType.mappingEditor.return": "返回",
  "analyzerType.mappingEditor.save": "保存映射",
  "analyzerType.mappingEditor.saved": "映射已保存",
  "analyzerType.mappingEditor.own.title": "此分析仪自身的映射",
  "analyzerType.mappingEditor.own.subtitle": "此处的更改仅适用于此分析仪。确认映射并应用后生效。",
  "analyzerType.mappingEditor.defaults.title": "新分析仪的默认设置",
  "analyzerType.mappingEditor.defaults.subtitle": "这是此类型新分析仪的初始配置，按标准代码与当前目录匹配。此处不会保存任何内容；每台分析仪保留各自的映射。",
  "analyzerType.mappingEditor.origin.override": "已编辑",
  "analyzerType.mappingEditor.changes.heading": "保存前复核更改",
  "analyzerType.mappingEditor.changes.save": "保存更改",
  "analyzerType.mappingEditor.changes.none": "自上次保存以来没有任何更改。",
  "analyzerType.mappingEditor.changes.row": "{from} 改为 {to}",
  "analyzerType.mappingEditor.sourceCode": "分析仪代码",
  "analyzerType.mappingEditor.state.bound": "已映射",
  "analyzerType.mappingEditor.state.excluded": "请勿接收",
  "analyzerType.mappingEditor.state.unresolved": "需要映射",
  "analyzerType.mappingEditor.subtitle": "{protocol} · 修订版 {revision}",
  "analyzerType.mappingEditor.suggestion": "建议匹配：{name}",
  "analyzerType.mappingEditor.summary": "映射摘要",
  "analyzerType.mappingEditor.testPicker.placeholder": "按名称、代码或 LOINC 搜索",
  "analyzerType.mappingEditor.testPicker": "{code} 的 OpenELIS 检测",
  "analyzerType.mappingEditor.tests.heading": "检测与结果映射",
  "analyzerType.mappingEditor.tests.help": "请逐一复核每个分析仪代码。将其映射到一个活跃的 OpenELIS 检测，或明确将其排除。",
  "analyzerType.mappingEditor.tests": "已映射的检测项目",
  "analyzerType.mappingEditor.title": "{name} 映射",
  "analyzerType.mappingEditor.unsaved": "未保存的映射更改",
  "analyzerType.mappingEditor.useSuggestion": "使用建议的检测项目",
  "analyzerType.modal.deactivate.subtitle": "现有分析仪与修订历史记录仍保持关联。此配置文件将不再可用于新分析仪的设置。",
  "analyzerType.modal.deactivate.title": "停用 {name}",
  "analyzerType.modal.history.title": "{name} 历史",
  "analyzerType.modal.reactivate.subtitle": "该配置文件将再次可用于新分析仪的设置中。现有分析仪仍将保持其已选择版本。",
  "analyzerType.modal.reactivate.title": "重新激活 {name}",
  "analyzerType.modal.update.subtitle": "这将从修订版 {revision} 创建一个新的不可变修订版。{count, plural, one {# 台分析仪仍固定在其当前修订版。} other {# 台分析仪仍固定在其当前修订版。}}",
  "analyzerType.modal.update.title": "更新 {name}",
  "analyzerType.notification.action.error.subtitle": "请重试该配置文件操作。",
  "analyzerType.notification.action.error": "配置文件操作失败",
  "analyzerType.notification.create.success": "配置文件已创建",
  "analyzerType.notification.deactivate.success": "配置文件已停用",
  "analyzerType.notification.duplicate.success": "配置文件已复制",
  "analyzerType.notification.update.success": "配置文件已更新",
  "analyzerType.notification.loadError.subtitle": "请检查 Analyzer Bridge 连接，然后重试。",
  "analyzerType.notification.catalogIssues": "部分分析仪配置文件无法加载",
  "analyzerType.notification.catalogIssues.subtitle": "Analyzer Bridge 已将这些文件搁置，并继续提供其他所有配置文件。请修复或删除每个文件，然后重启 Bridge。",
  "analyzerType.notification.loadError": "无法加载分析仪类型",
  "analyzerType.notification.reactivate.success": "配置文件已重新激活",
  "analyzerType.page.subtitle": "您的分析仪所使用的可复用配置。",
  "analyzerType.page.title": "分析仪类型管理",
  "analyzerType.protocol.file": "平面文件",
  "analyzerType.recognition.none.affirmation": "我确认该接口不传输质控结果",
  "analyzerType.recognition.none.subtitle": "仅当分析仪接口不发送质控结果时，才发布此配置文件。传输质控结果的配置文件需要明确的识别规则。",
  "analyzerType.recognition.none.title": "无自动质控结果识别",
  "analyzerType.recognition.condition.add": "添加条件",
  "analyzerType.recognition.condition.fieldValue": "{source} 值",
  "analyzerType.recognition.condition.new": "新的识别条件",
  "analyzerType.recognition.condition.prefixValue": "标本ID前缀",
  "analyzerType.recognition.condition.remove": "移除条件",
  "analyzerType.recognition.condition.select.placeholder": "选择条件",
  "analyzerType.recognition.condition.select": "新条件",
  "analyzerType.recognition.condition.sourceContains": "{source} 包含",
  "analyzerType.recognition.condition.sourceEquals": "{source} 等于",
  "analyzerType.recognition.condition.specimenPrefix": "标本编号开头为",
  "analyzerType.recognition.condition.summary.configuredPattern": "标本 ID 与配置的模式匹配",
  "analyzerType.recognition.condition.summary.contains": "{source} 包含 {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} 等于{value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} 以 {value} 开头",
  "analyzerType.recognition.condition.summary.unknown": "质控结果识别",
  "analyzerType.recognition.error.load": "无法加载质控识别。",
  "analyzerType.recognition.error.save": "无法保存质控识别。",
  "analyzerType.recognition.error.title": "质控识别需要注意",
  "analyzerType.recognition.heading": "质控结果识别",
  "analyzerType.recognition.loading": "正在加载质控识别",
  "analyzerType.recognition.mode.none": "该接口不传输质控结果",
  "analyzerType.recognition.mode.none.short": "无质控结果识别",
  "analyzerType.recognition.mode.rules": "使用以下条件识别质控",
  "analyzerType.recognition.mode.rules.short": "基于规则的质控识别",
  "analyzerType.recognition.mode.unconfigured.short": "未配置质控识别",
  "analyzerType.recognition.mode.unconfigured": "未配置质控识别规则。质控结果可能无法被自动识别。",
  "analyzerType.recognition.mode": "该接口如何识别质控结果？",
  "analyzerType.recognition.rules.help": "当任一条件匹配时，该结果即被视为质控结果。",
  "analyzerType.recognition.save": "保存质控识别",
  "analyzerType.recognition.saved": "质控识别已保存",
  "analyzerType.recognition.source.specimenId": "标本编号",
  "analyzerType.revision": "修订版 {revision}",
  "analyzerType.search.label": "搜索分析仪类型",
  "analyzerType.search.placeholder": "按名称、制造商或型号搜索",
  "analyzerType.source.shipped": "已发货",
  "analyzerType.source.site": "站点创建",
  "analyzerType.status.active": "活跃",
  "analyzerType.status.inactive": "已停用",
  "analyzerType.summary.ariaLabel": "分析仪类型汇总",
  "analyzerType.summary.deactivated": "已停用",
  "analyzerType.summary.inUse": "使用中",
  "analyzerType.summary.needsAttention": "需注意",
  "analyzerType.summary.total": "分析仪类型管理",
  "analyzerType.usedBy": "{count, plural, =0 {未使用} one {# 台分析仪} other {# 台分析仪}}",
  "analyzer.navigation.qcControlLots": "质控品批号",
  "analyzer.navigation.qcRuleConfig": "规则配置",
  "analyzer.page.addButton": "添加分析仪",
  "analyzer.page.hierarchy.list": "列表",
  "analyzer.page.hierarchy.mappings": "映射",
  "analyzer.page.hierarchy.root": "分析仪",
  "analyzer.page.title": "分析仪管理",
  "analyzer.plugin.missing": "插件缺失",
  "analyzer.qc.alerts.message": "当质控结果超出可接受范围时将显示警报",
  "analyzer.qc.alerts.title": "质控警报",
  "analyzer.qc.corrective.message": "记录和跟踪质控失败的纠正措施",
  "analyzer.qc.corrective.title": "纠正措施",
  "analyzer.qc.placeholder.message": "此功能即将推出",
  "analyzer.qc.placeholder.title": "质控",
  "analyzer.action.viewResults": "查看结果",
  "analyzer.results.held.assayNotEnabled": "此检测项目在分析仪设置中已关闭，因此其结果被暂存。如果此仪器运行该检测项目，请在设置的“检测项目”步骤中将其开启；应用映射时将重试该结果。",
  "analyzer.results.held.code": "分析仪代码：{code}",
  "analyzer.results.held.enableAssay": "开启检测项目",
  "analyzer.results.held.instrumentNote": "仪器备注：{note}",
  "analyzer.results.instrumentReported": "仪器报告",
  "analyzer.results.instrumentReported.assay": "检测项目：{assay}",
  "analyzer.results.instrumentReported.assayVersion": "检测项目：{assay}，版本 {version}",
  "analyzer.results.instrumentReported.flag": "标记：{flag}",
  "analyzer.results.instrumentReported.operator": "操作员：{operator}",
  "analyzer.results.failedRun.dismiss": "作为失败运行忽略",
  "analyzer.results.held.remove": "Remove from review",
  "analyzer.results.held.removed": "The held result is removed from review. The audit trail keeps it.",
  "analyzer.results.held.removeError": "The held result could not be removed",
  "analyzer.results.failedRun.dismissed": "失败运行已记录在订单上，其检测保持开放以便重复检测。",
  "analyzer.results.failedRun.error": "无法忽略该失败运行",
  "analyzer.results.held.conflictingAnswerMapping": "The received spelling and its canonical answer have conflicting local mappings. Make their mapping decisions consistent, then retry this held result.",
  "analyzer.results.held.qcTargetMissing": "此质控报告了答案，但其检测和质控水平没有可供判断的质控靶值。请设置预期答案，然后应用分析仪映射以重试。",
  "analyzer.results.held.setQcTarget": "设置质控靶值",
  "analyzer.results.held.reviewMapping": "复核分析仪映射",
  "analyzer.results.sampleFlags": "分析仪标记：{flags}",
  "analyzer.results.held.subtitle": "暂存结果无法接受。每条结果都会说明处理方法：复核该分析仪的映射，或忽略失败的运行，使其检测保持开放以便重做。",
  "analyzer.results.held.tag": "暂存",
  "analyzer.results.held.title": "{count, plural, other {# 条分析仪结果需要处理}}",
  "analyzer.qualitativeMapping.isDefault": "默认值",
  "analyzer.qualitativeMapping.mappings": "映射",
  "analyzer.qualitativeMapping.noValues": "无可用值",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "选择OpenELIS代码",
  "analyzer.qualitativeMapping.subtitle": "配置定性结果映射",
  "analyzer.qualitativeMapping.title": "定性映射",
  "analyzer.qualitativeMapping.validation.error": "验证错误",
  "analyzer.qualitativeMapping.validation.error.subtitle": "请修正以下错误后再保存",
  "analyzer.qualitativeMapping.validation.noDefault": "未设置默认值",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "必须选择一个默认映射",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS代码为必填项",
  "analyzer.query.button": "查询分析仪",
  "analyzer.query.cancel": "取消",
  "analyzer.query.modal.logs": "日志",
  "analyzer.query.modal.noLogs": "暂无日志",
  "analyzer.query.modal.progress": "进度",
  "analyzer.query.modal.state": "状态",
  "analyzer.query.modal.subtitle": "查询分析仪获取结果",
  "analyzer.query.modal.title": "查询分析仪",
  "analyzer.query.progress": "查询进行中...",
  "analyzer.search.label": "搜索",
  "analyzer.search.placeholder": "搜索分析仪...",
  "analyzer.attention.review": "复核暂存结果",
  "analyzer.attention.subtitle": "在将这些结果用于临床之前，请先对未知检测项目或结果值进行映射。",
  "analyzer.attention.tag": "需要关注",
  "analyzer.attention.title.many": "{count} 台分析仪有暂存结果",
  "analyzer.attention.title.one": "{name} 有暂存结果",
  "analyzer.stat.active": "活跃",
  "analyzer.stat.inactive": "非活跃",
  "analyzer.stat.needsAttention": "需要关注",
  "analyzer.stat.setup": "设置中",
  "analyzer.stat.total": "总计",
  "analyzer.stats.active": "活跃",
  "analyzer.stats.inactive": "非活跃",
  "analyzer.stats.total": "总计",
  "analyzer.status.active": "活跃",
  "analyzer.status.deleted": "已删除",
  "analyzer.status.error_pending": "错误待处理",
  "analyzer.status.inactive": "非活跃",
  "analyzer.status.offline": "离线",
  "analyzer.status.retired": "已停用",
  "analyzer.status.setup": "设置中",
  "analyzer.status.validation": "验证中",
  "analyzer.success.save": "保存成功",
  "analyzer.table.actions": "操作",
  "analyzer.table.connection": "连接",
  "analyzer.table.header.connection": "连接",
  "analyzer.table.header.lastModified": "最后修改",
  "analyzer.table.header.name": "名称",
  "analyzer.table.header.status": "状态",
  "analyzer.table.header.testUnits": "实验室单元",
  "analyzer.table.header.type": "类型",
  "analyzer.table.lastModified": "最后修改",
  "analyzer.table.name": "名称",
  "analyzer.table.status": "状态",
  "analyzer.table.testUnits": "检测科室",
  "analyzer.table.type": "类型",
  "analyzer.table.type.loading": "正在加载分析仪类型",
  "analyzer.table.type.unavailable": "分析仪类型不可用",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "网络桥健康检查失败",
  "analyzer.testConnection.bridge.httpStatus": "网络桥HTTP状态错误",
  "analyzer.testConnection.bridge.notConfigured": "网络桥未配置",
  "analyzer.testConnection.bridge.unparseableResponse": "网络桥响应无法解析",
  "analyzer.testConnection.bridge.unreachable": "网络桥无法访问",
  "analyzer.testConnection.close": "关闭",
  "analyzer.testConnection.logs": "连接日志",
  "analyzer.testConnection.requestBuildFailed": "请求构建失败",
  "analyzer.testConnection.success": "连接成功",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "TCP网络桥未配置",
  "analyzer.testConnection.testAgain": "重新测试",
  "analyzer.testConnection.testing": "正在测试连接...",
  "analyzer.testConnection.title": "测试连接",
  "analyzer.testMapping.activeMappings": "活跃映射",
  "analyzer.testMapping.analyzerInfo": "分析仪信息",
  "analyzer.testMapping.analyzerName": "分析仪名称",
  "analyzer.testMapping.analyzerType": "分析仪类型",
  "analyzer.testMapping.appliedMappings": "已应用的映射",
  "analyzer.testMapping.entityPreview": "实体预览",
  "analyzer.testMapping.errors": "错误",
  "analyzer.testMapping.loading": "加载中...",
  "analyzer.testMapping.messageInput": "消息输入",
  "analyzer.testMapping.messageInput.counter": "字符数",
  "analyzer.testMapping.messageInput.helper": "粘贴分析仪消息以测试映射配置",
  "analyzer.testMapping.messageInput.placeholder": "在此粘贴分析仪消息...",
  "analyzer.testMapping.messageInput.required": "消息为必填项",
  "analyzer.testMapping.noResults": "无结果",
  "analyzer.testMapping.parsedFields": "解析字段",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM引用",
  "analyzer.testMapping.parsedFields.fieldName": "字段名称",
  "analyzer.testMapping.parsedFields.interpretation": "解释",
  "analyzer.testMapping.parsedFields.mappedTo": "映射到",
  "analyzer.testMapping.parsedFields.rawValue": "原始值",
  "analyzer.testMapping.pluginConfigSnapshot": "插件配置快照",
  "analyzer.testMapping.previewOptions": "预览选项",
  "analyzer.testMapping.previewOptions.detailedParsing": "详细解析",
  "analyzer.testMapping.previewOptions.validateAll": "验证全部",
  "analyzer.testMapping.results": "结果",
  "analyzer.testMapping.saveTestCase": "保存测试用例",
  "analyzer.testMapping.submit": "提交",
  "analyzer.testMapping.subtitle": "测试分析仪消息映射配置",
  "analyzer.testMapping.testAnother": "测试其他消息",
  "analyzer.testMapping.title": "测试映射",
  "analyzer.testMapping.validation.invalidFormat": "消息格式无效",
  "analyzer.testMapping.validation.messageRequired": "消息为必填项",
  "analyzer.testMapping.validation.messageTooLarge": "消息过大",
  "analyzer.testMapping.warnings": "警告",
  "analyzer.unitMapping.analyzerUnit": "分析仪单位",
  "analyzer.unitMapping.analyzerUnit.helper": "分析仪报告的计量单位",
  "analyzer.unitMapping.conversionFactor": "转换因子",
  "analyzer.unitMapping.conversionFactor.helper": "用于将分析仪单位转换为OpenELIS单位的乘数",
  "analyzer.unitMapping.openelisUnit": "OpenELIS单位",
  "analyzer.unitMapping.openelisUnit.helper": "OpenELIS系统中使用的计量单位",
  "analyzer.unitMapping.openelisUnit.placeholder": "选择OpenELIS单位",
  "analyzer.unitMapping.rejectIfMismatch": "不匹配时拒绝",
  "analyzer.unitMapping.rejectIfMismatch.helper": "当单位不匹配时自动拒绝结果",
  "analyzer.unitMapping.subtitle": "配置分析仪与OpenELIS之间的单位映射",
  "analyzer.unitMapping.title": "单位映射",
  "analyzer.unitMapping.validation.analyzerUnit.required": "分析仪单位为必填项",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "转换因子无效",
  "analyzer.unitMapping.validation.conversionFactor.required": "转换因子为必填项",
  "analyzer.unitMapping.validation.error": "验证错误",
  "analyzer.unitMapping.validation.error.subtitle": "请修正以下错误后再保存",
  "analyzer.unitMapping.validation.openelisUnit.required": "OpenELIS单位为必填项",
  "analyzerTestName.header.analyzerName": "分析仪 - 分析仪检测名称",
  "analyzerTestName.modal.add.heading": "添加分析仪检测名称",
  "analyzerTestName.modal.update.heading": "更新分析仪检测名称",
  "assigned.cytopathologist.label": "已分配细胞病理学家",
  "assigned.pathologist.label": "已分配病理学家",
  "assigned.technician.label": "已分配技术员",
  "audittrail.table.heading.action": "操作",
  "audittrail.table.heading.identifier": "标识符",
  "audittrail.table.heading.item": "项目",
  "audittrail.table.heading.newvalue": "新值",
  "audittrail.table.heading.oldvalue": "旧值",
  "audittrail.table.heading.time": "时间",
  "audittrail.table.heading.user": "用户",
  "audittrail.table.title.patientResults": "患者结果",
  "availabletests.title": "可用检测",
  "availabletests.none": "Every orderable test of the existing samples is already on this order.",
  "back.action.button": "返回",
  "banner.menu.administration": "管理",
  "banner.menu.alerts": "警报",
  "banner.menu.alerts.tooltip": "查看系统警报",
  "banner.menu.aliquot": "分装样本",
  "banner.menu.aliquot.tooltip": "样本分装",
  "banner.menu.billing": "计费",
  "banner.menu.billing.tooltip": "计费",
  "banner.menu.createDouble": "双重录入",
  "banner.menu.createInitial": "初始录入",
  "banner.menu.eorders": "传入订单",
  "banner.menu.eqa": "外部质量评估",
  "banner.menu.eqa.distribution": "分发",
  "banner.menu.eqa.distribution.tooltip": "EQA样本分发",
  "banner.menu.eqa.management": "室间质评计划",
  "banner.menu.eqa.management.tooltip": "创建和管理室间质评计划",
  "banner.menu.eqa.mgmt": "EQA管理",
  "banner.menu.eqa.mgmt.distributions": "分发管理",
  "banner.menu.eqa.mgmt.distributions.tooltip": "管理EQA样本分发",
  "banner.menu.eqa.mgmt.participants": "参与者",
  "banner.menu.eqa.mgmt.participants.tooltip": "管理机构在室间质评计划中的注册",
  "banner.menu.eqa.mgmt.programs": "计划",
  "banner.menu.eqa.mgmt.programs.tooltip": "创建和管理室间质评计划",
  "banner.menu.eqa.mgmt.results": "结果",
  "banner.menu.eqa.mgmt.results.tooltip": "管理EQA结果",
  "banner.menu.eqa.mgmt.tooltip": "管理室间质评计划、参与者和分发",
  "banner.menu.eqa.tests": "检测",
  "banner.menu.eqa.tests.myPrograms": "我的室间质评计划",
  "banner.menu.eqa.tests.myPrograms.tooltip": "管理在外部室间质评计划中的自主注册",
  "banner.menu.eqa.tests.orders": "订单",
  "banner.menu.eqa.tests.orders.tooltip": "查看EQA检测订单",
  "banner.menu.eqa.tests.tooltip": "室间质评检测订单和计划注册",
  "banner.menu.eqa.tooltip": "外部质量评估",
  "banner.menu.generic.sample": "通用样本",
  "banner.menu.generic.sample.edit": "编辑订单",
  "banner.menu.generic.sample.import": "导入样本",
  "banner.menu.generic.sample.order": "创建订单",
  "banner.menu.generic.sample.results": "输入结果",
  "banner.menu.help": "帮助",
  "banner.menu.help.about": "视频教程",
  "banner.menu.help.contact": "版本说明",
  "banner.menu.help.documents": "流程文档",
  "banner.menu.help.formDBS": "DBS表单",
  "banner.menu.help.formVL": "VL表单",
  "banner.menu.help.usermanual": "用户手册",
  "banner.menu.home": "首页",
  "banner.menu.inventory": "库存",
  "banner.menu.inventory.catalog": "管理目录",
  "banner.menu.inventory.dashboard": "仪表板",
  "banner.menu.inventory.list": "库存物品",
  "banner.menu.inventory.reports": "报告",
  "banner.menu.nonconformity": "不符合项",
  "banner.menu.nonconformity.correctiveActions": "纠正措施",
  "banner.menu.nonconformity.dashboard": "所有不符合事件",
  "banner.menu.nonconformity.report": "报告不符合事件",
  "banner.menu.nonconformity.view": "查看新的不符合事件",
  "banner.menu.patient": "患者",
  "banner.menu.patient.Create": "研究",
  "banner.menu.patient.addOrEdit": "添加/编辑患者",
  "banner.menu.patient.merge": "合并患者",
  "banner.menu.patient.merge.tooltip": "合并重复患者记录",
  "banner.menu.patientConsult": "查看",
  "banner.menu.patientEdit": "编辑",
  "banner.menu.patienthistory": "患者历史",
  "banner.menu.printBarcode": "条码",
  "banner.menu.referredOut": "转诊",
  "banner.menu.report.validation.backlog": "延迟验证",
  "banner.menu.reports": "报告",
  "banner.menu.reports.routine": "常规",
  "banner.menu.reports.study": "研究",
  "banner.menu.results": "结果",
  "banner.menu.results.CobasIntegra400": "生物化学: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "免疫学: FacsCalibur",
  "banner.menu.results.FacsCantoII": "免疫学: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "免疫学: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "生物化学: 全自动分析仪导入器",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpert分析仪",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpert文件分析仪",
  "banner.menu.results.PocH100iAnalyzer": "PocH100i分析仪",
  "banner.menu.results.SysmeXT": "血液学: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNL分析仪",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL分析仪",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXP分析仪",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP分析仪",
  "banner.menu.results.accession": "按订单",
  "banner.menu.results.analyzer": "分析仪",
  "banner.menu.results.cobasc111analyzer": "生物化学: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert分析仪",
  "banner.menu.results.logbook": "按单元",
  "banner.menu.results.mindrayanalyzer": "迈瑞分析仪",
  "banner.menu.results.order.programmes": "订单程序",
  "banner.menu.results.patient": "按患者",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "按检测、日期或状态",
  "banner.menu.results.sysmexanalyzer": "血液学: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "血液学: Sysmex XT分析仪导入器",
  "banner.menu.results.taqman48dbsanalyzer": "病毒学: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "按检测日期",
  "banner.menu.results.unified": "结果录入",
  "banner.menu.results.unified.tooltip": "统一结果录入工作列表",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "验证",
  "banner.menu.resultvalidation.bacteria": "细菌",
  "banner.menu.resultvalidation.bench": "按工作台",
  "banner.menu.resultvalidation.biochemistry": "生物化学",
  "banner.menu.resultvalidation.cytobacteriology": "细胞细菌学",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "内分泌学",
  "banner.menu.resultvalidation.genotyping": "基因分型",
  "banner.menu.resultvalidation.hemato-immunology": "血液免疫学",
  "banner.menu.resultvalidation.hematology": "血液学",
  "banner.menu.resultvalidation.immunology": "免疫学",
  "banner.menu.resultvalidation.immunology.Haiti": "免疫学-病毒学",
  "banner.menu.resultvalidation.immunologyHematology": "免疫学 - 血液学",
  "banner.menu.resultvalidation.liquidBio": "液体生物学",
  "banner.menu.resultvalidation.malaria": "疟疾",
  "banner.menu.resultvalidation.molecularBio": "分子生物学",
  "banner.menu.resultvalidation.mycobacteriology": "分枝杆菌学",
  "banner.menu.resultvalidation.mycology": "真菌学",
  "banner.menu.resultvalidation.parasitology": "寄生虫学",
  "banner.menu.resultvalidation.serology": "血清学",
  "banner.menu.resultvalidation.serology-immunology": "血清学-免疫学",
  "banner.menu.resultvalidation.viralload": "病毒载量",
  "banner.menu.resultvalidation.virology": "病毒学",
  "banner.menu.resultvalidation_routine": "常规",
  "banner.menu.resultvalidation_study": "研究",
  "banner.menu.sample": "订单",
  "banner.menu.sample.shipment": "样本转运",
  "banner.menu.sampleAdd": "添加订单",
  "banner.menu.sampleBatchEntry": "批量订单录入",
  "banner.menu.sampleConsult": "查看",
  "banner.menu.sampleCreate": "研究",
  "banner.menu.sampleEdit": "编辑订单",
  "banner.menu.sampleManagement": "样本管理",
  "banner.menu.sampleManagement.tooltip": "样本管理菜单",
  "banner.menu.storage": "存储",
  "banner.menu.storage.tooltip": "样本存储管理",
  "banner.menu.study.eorders": "电子订单",
  "banner.menu.workplan": "工作计划",
  "banner.menu.workplan.batch": "批量工作计划",
  "banner.menu.workplan.batch.tooltip": "批量工作计划",
  "banner.menu.workplan.bench": "按单元",
  "banner.menu.workplan.panel": "按面板",
  "banner.menu.workplan.priority": "按优先级",
  "banner.menu.workplan.test": "按检测类型",
  "banner.menu.workplan.unit": "按检测科室",
  "barcode.additionalInvalidLevels.message": "条码包含超出有效部分的其他级别。仅预填有效级别。",
  "barcode.additionalInvalidLevels.warning": "检测到其他无效级别",
  "barcode.autoOpenForm": "使用有效层次结构打开位置表单",
  "barcode.debounce.warning": "请在扫描另一个条码前等待",
  "barcode.error": "无效条码",
  "barcode.firstMissingLevel": "第一个缺失级别：{level}",
  "barcode.format": "条码格式",
  "barcode.header": "条码",
  "barcode.invalidFormat": "无效的条码格式。预期：ROOM-DEVICE 或 ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "块标签",
  "barcode.label.freezer": "冰箱标签",
  "barcode.label.helper.text": "以毫米为单位输入值",
  "barcode.label.order": "订单标签行",
  "barcode.label.slide": "幻灯片标签",
  "barcode.label.specimen": "标本标签",
  "barcode.label.info.blockCaseNumber": "蜡块病例号",
  "barcode.label.info.blockId": "蜡块ID",
  "barcode.label.info.blockNumber": "蜡块编号",
  "barcode.label.info.boxid": "箱子编号",
  "barcode.label.info.caseNumber": "病例号",
  "barcode.label.info.collectedBy": "采集人",
  "barcode.label.info.collectionDate": "采集日期",
  "barcode.label.info.collectionDateTime": "采集日期时间",
  "barcode.label.info.created": "创建时间",
  "barcode.label.info.destination": "目标机构",
  "barcode.label.info.expiryDate": "过期日期",
  "barcode.label.info.labNumber": "实验室编号",
  "barcode.label.info.patientDobFull": "出生日期",
  "barcode.label.info.patientId": "患者ID",
  "barcode.label.info.patientName": "患者姓名",
  "barcode.label.info.patientSexFull": "性别",
  "barcode.label.info.samplecount": "样本数量",
  "barcode.label.info.siteId": "站点ID",
  "barcode.label.info.slideId": "切片ID",
  "barcode.label.info.slideNumber": "切片编号",
  "barcode.label.info.specimenType": "标本类型",
  "barcode.label.info.stainType": "染色类型",
  "barcode.label.info.storageLocation": "存储位置",
  "barcode.label.info.temperature": "储存温度",
  "barcode.label.info.tests": "检测",
  "barcode.labels.order.row": "订单标签行",
  "barcode.labels.running.total": "标签累计总数",
  "barcode.labels.sample.row": "样本标签行",
  "barcode.labels.section.title": "条码标签",
  "barcode.locationNotFound": "未找到位置",
  "barcode.notification.save": "条码配置已保存。",
  "barcode.partialMatch": "部分匹配 - 某些组件有效",
  "barcode.print.button": "打印",
  "barcode.print.labels.title": "此订单的标签",
  "barcode.print.all.button": "全部打印",
  "barcode.print.all.saved": "按保存的数量打印此订单保存的所有标签。",
  "barcode.print.all.legacy": "打印 {orderCount, plural, one {# 个订单标签} other {# 个订单标签}}，每个标本打印 {specimenCount, plural, one {# 个标签} other {# 个标签}}。",
  "barcode.print.col.label": "标签",
  "barcode.print.col.accession": "订单号",
  "barcode.print.col.info": "附加信息",
  "barcode.print.col.quantity": "打印数量",
  "barcode.print.quantity.for": "{label} 的标签打印数量",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "最多 {max}",
  "barcode.print.max.total": "总计最多 {max}（含之前的打印）",
  "barcode.print.row.button": "打印 {label}",
  "error.labels.quantity.max": "数量超过预设上限时，需要使用标签覆盖。",
  "error.labels.quantity.min": "至少打印一张标签。",
  "barcode.print.dialog.quantityFor": "{label} 的打印数量",
  "barcode.print.dialog.title": "打印条码",
  "barcode.print.done": "打印完成",
  "barcode.print.later": "跳过 — 稍后打印",
  "barcode.print.preprint": "预印条码",
  "barcode.print.preprint.button": "预印标签",
  "barcode.print.preprint.note": "注意：如果添加了设施和/或样本和检测，它们将打印在每个标签上",
  "barcode.print.skip": "跳过",
  "barcode.print.title": "打印条码标签",
  "barcode.ready": "准备扫描",
  "barcode.scan": "扫描条码",
  "barcode.scan.error": "未找到订单",
  "barcode.scan.placeholder": "扫描条码或输入实验室编号...",
  "barcode.scan.success": "订单已成功加载",
  "barcode.scanning": "扫描中...",
  "barcode.scanOrType": "扫描条码或输入位置",
  "barcode.success": "找到位置",
  "barcode.validHierarchyPrefilled": "有效层次结构级别已预填",
  "barcode.validation.altPrefix": "备用前缀",
  "barcode.validationFailed": "条码验证失败",
  "barcodeconfiguration.browse.title": "条码配置",
  "breadcrumb.home": "首页",
  "breadcrumb.caseView": "案例查看",
  "breadcrums.admin.managment": "管理",
  "calendar.management.title": "日历管理",
  "calendar.management.description": "管理公共假期和周末配置,用于工作时间TAT(周转时间)计算",
  "calendar.management.addHoliday": "添加假期",
  "calendar.management.editHoliday": "编辑假期",
  "calendar.management.deleteConfirm": "确定要删除此假期吗?",
  "calendar.management.holidayName": "假期名称",
  "calendar.management.date": "日期",
  "calendar.management.recurring": "重复",
  "calendar.management.annual": "每年",
  "calendar.management.oneTime": "一次性",
  "calendar.management.active": "活跃",
  "calendar.management.inactive": "非活跃",
  "calendar.management.weekend": "周末",
  "calendar.management.weekendDays": "周末日期(不计入工作时间)",
  "calendar.management.weekendSaved": "周末配置已保存",
  "calendar.management.importCsv": "导入CSV",
  "calendar.management.exportCsv": "导出翻译",
  "calendar.management.importPreview": "导入预览",
  "calendar.management.year": "年份",
  "calendar.management.noHolidays": "未为{year}年配置假期。点击\"添加假期\"开始配置。",
  "calendar.management.duplicateDate": "此日期已存在假期",
  "calendar.management.imported": "已导入{count}个假期",
  "calendar.management.skipped": "已跳过{count}个假期",
  "calendar.management.holidayCount": "已为{year}年配置{count}个假期",
  "calendar.management.saveError": "保存假期时出错",
  "calendar.management.loadError": "加载假期时出错",
  "calendar.management.save": "保存",
  "calendar.management.cancel": "取消",
  "calendar.management.actions": "操作",
  "calendar.management.status": "状态",
  "calendar.management.column.date": "日期",
  "calendar.management.column.holidayName": "假期名称",
  "calendar.management.column.recurring": "重复",
  "calendar.management.column.status": "状态",
  "calendar.management.column.actions": "操作",
  "calendar.management.day.sun": "周日",
  "calendar.management.day.mon": "周一",
  "calendar.management.day.tue": "周二",
  "calendar.management.day.wed": "周三",
  "calendar.management.day.thu": "周四",
  "calendar.management.day.fri": "周五",
  "calendar.management.day.sat": "周六",
  "calendar.management.chooseFile": "选择CSV文件",
  "calendar.management.csvColumns": "列: date(日期), name(名称), recurring(是否重复, true/false)",
  "calendar.management.rowsFound": "找到{count}行",
  "calendar.management.column.csvDate": "日期",
  "calendar.management.column.csvName": "名称",
  "calendar.management.column.csvRecurring": "重复",
  "calendar.management.importing": "正在导入...",
  "caseView.action.discard": "放弃更改",
  "caseView.action.saveDraft": "保存草稿",
  "caseView.action.showDeactivated": "显示已停用",
  "caseView.banner.unsavedChanges": "此病例有未保存的更改。确定离开页面并放弃这些更改吗？",
  "caseView.badge.deactivated": "已停用",
  "caseView.badge.notApplicable": "不适用",
  "caseView.badge.readOnly": "只读",
  "caseView.label.assignedStaff": "{role}：{name}",
  "caseView.label.caseProgress": "病例进度",
  "caseView.label.caseSummary": "病例摘要",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "未记录",
  "caseView.label.unsavedChanges": "未保存的更改",
  "caseView.locked.awaitingStage": "病例进入{stage}后可用",
  "caseView.locked.prerequisite": "此病例的前序步骤完成后可用",
  "column.qc.accession": "质控样本",
  "column.qc.detail": "详情",
  "column.qc.result": "结果",
  "column.qc.test": "检测",
  "column.qc.type": "设备类型",
  "compliance.dashboard.chart.comparison.title": "站点对比 — 本期合规率（%）",
  "compliance.dashboard.chart.drilldown.title": "站点详细分析 — 按参数趋势",
  "compliance.dashboard.chart.trend.title": "合规率趋势 — 所有站点",
  "compliance.dashboard.descriptive.excluded": "趋势图中未包含的描述性参数",
  "compliance.dashboard.drilldown.placeholder": "选择一个站点……",
  "compliance.dashboard.empty": "没有数据符合已选择的过滤器条件",
  "compliance.dashboard.export.pdf": "导出PDF",
  "compliance.dashboard.filter.allStandards": "所有标准",
  "compliance.dashboard.filter.dateRange": "日期范围",
  "compliance.dashboard.filter.dateRangeEnd": "结束日期",
  "compliance.dashboard.filter.drilldownSite": "按站点深入分析",
  "compliance.dashboard.filter.sites": "采样点",
  "compliance.dashboard.filter.sites.placeholder": "所有站点",
  "compliance.dashboard.filter.standard": "合规标准",
  "compliance.dashboard.kpi.complianceRate": "合规率",
  "compliance.dashboard.kpi.exceedances": "超标总次数",
  "compliance.dashboard.kpi.sitesMonitored": "受监测站点",
  "compliance.dashboard.kpi.totalOrders": "订单总数",
  "compliance.dashboard.loading.comparison": "正在加载比较结果……",
  "compliance.dashboard.loading.drilldown": "正在加载详细信息……",
  "compliance.dashboard.loading.exceedances": "正在加载超标数据……",
  "compliance.dashboard.loading.generating": "正在生成……",
  "compliance.dashboard.loading.trend": "正在加载趋势……",
  "compliance.dashboard.lowData": "数据较少（少于3个订单）",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "日期",
  "compliance.dashboard.table.col.labNumber": "实验室编号",
  "compliance.dashboard.table.col.parameter": "参数",
  "compliance.dashboard.table.col.result": "结果",
  "compliance.dashboard.table.col.site": "站点",
  "compliance.dashboard.table.col.status": "状态",
  "compliance.dashboard.table.col.threshold": "阈值",
  "compliance.dashboard.table.exceedances.title": "超标情况摘要",
  "compliance.dashboard.title": "环境合规仪表板",
  "error.referOut.emailFormat": "请输入一个有效的电子邮件地址（例如：lab@example.org）。",
  "error.referOut.handoffRequiredForDispatch": "发送前必须填写交接日期/时间。",
  "error.referOut.maxLength": "最多{max}个字符。",
  "error.referOut.phoneFormat": "请输入包含国家代码前缀的有效电话号码（例如：+62 812 3456 7890）。",
  "error.referOut.referringLabRequired": "选择一家参考实验室。",
  "error.validation.qc.ackFailed": "未能记录质控确认。请重试。",
  "holding.time.exceeded.message": "以下请求的 SOP 最大持有时间已超出：{tests}",
  "holding.time.exceeded.note": "警告：在超过SOP最大保持时间后输入了结果。",
  "holding.time.exceeded.title": "超时",
  "label.button.edit.details": "编辑详情",
  "label.expand.poolDetails": "展开混样详情",
  "label.pool.collapse": "隐藏单个标本",
  "label.pool.expand": "显示单个标本",
  "label.pool.expansion.next": "下一个",
  "label.pool.expansion.page": "第 {page} 页，共 {total} 页",
  "label.pool.expansion.prev": "上一个",
  "label.pool.expansion.title": "{animal} 标本（{count}）",
  "label.qc.fail": "失败",
  "label.qc.pass": "通过",
  "label.referOut.action.dispatch": "发送",
  "label.referOut.action.edit": "编辑",
  "label.referOut.action.referOut": "转诊",
  "label.referOut.action.save": "保存转诊",
  "label.referOut.action.view": "查看",
  "label.referOut.column.actions": "操作",
  "label.referOut.column.referringLab": "参考实验室",
  "label.referOut.column.sampleId": "样本编号",
  "label.referOut.column.sampleType": "样本类型",
  "label.referOut.column.status": "分包状态",
  "label.referOut.column.tests": "检测项目",
  "label.referOut.dispatch.error": "转诊发送失败。",
  "label.referOut.dispatch.notSaved": "在发送前请先保存转诊单。",
  "label.referOut.dispatch.success": "转诊已发送。",
  "label.referOut.empty.subtitle": "样本保存后会显示在此处。请先保存订单，然后才能将样本转诊。",
  "label.referOut.empty.title": "没有可供转诊的样本",
  "label.referOut.field.agreementReference": "协议编号",
  "label.referOut.field.cocContactEmail": "监管链联系人电子邮件",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "监管链联系人姓名",
  "label.referOut.field.cocContactPhone": "监管链联系人电话",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "预计归还日期",
  "label.referOut.field.handoffDate": "移交日期",
  "label.referOut.field.handoffDatetime": "移交日期时间",
  "label.referOut.field.handoffTime": "移交时间",
  "label.referOut.field.handoffTime.placeholder": "时:分",
  "label.referOut.field.notes": "备注",
  "label.referOut.field.referringLab": "参考实验室",
  "label.referOut.field.referringLab.placeholder": "选择参考实验室",
  "label.referOut.save.error": "转诊保存失败。",
  "label.referOut.save.success": "转诊已保存。",
  "label.referOut.section.description": "将样本转诊至外部实验室。每个样本都附有完整的监管链元数据。",
  "label.referOut.section.title": "转诊 / 分包",
  "label.referOut.status.cancelled": "已取消",
  "label.referOut.status.closed": "已关闭",
  "label.referOut.status.completed": "已完成",
  "label.referOut.status.dispatched": "已发送",
  "label.referOut.status.draft": "草稿",
  "label.referOut.status.inProgress": "进行中",
  "label.referOut.status.notReferred": "内部",
  "label.referOut.status.received": "已接收",
  "label.referOut.status.rejected": "已拒收",
  "label.referOut.status.requested": "已请求",
  "label.referOut.status.resultsReturned": "结果已返回",
  "label.referOut.field.reason": "原因",
  "label.referOut.field.reason.placeholder": "选择原因（可选）",
  "label.referOut.action.referOutAll": "外送所有内部样本",
  "label.referOut.status.pendingSave": "待保存",
  "label.referOut.staged.success": "已为 {count} 个样本暂存。转诊将在此步骤保存时一并保存。",
  "order.status.referredOut": "转诊",
  "order.referral.partial": "{total} 项检测中的 {referred} 项已转诊至 {lab}",
  "order.referral.fully": "全部 {total} 项检测已转诊至 {lab}",
  "label.sampleKind.blank": "空白",
  "label.sampleKind.client": "客户样本",
  "label.sampleKind.control": "质控",
  "label.sampleKind.duplicate": "重复",
  "label.sampleKind.qc": "质控",
  "label.validation.qc.ack.checkbox": "我已复核质控失败情况，并评估了其对结果发布的影响",
  "label.validation.qc.ack.heading": "必填确认",
  "label.validation.qc.banner.subtitle": "在发布结果之前，请在下方复核并确认。",
  "label.validation.qc.banner.title": "检测到质控失败：{count} 个质控样本未通过验收标准",
  "label.validation.qc.failedSamples": "未通过的质控样本",
  "label.validation.qc.justification": "理由",
  "label.validation.checkBeforeRelease": "发布前请检查",
  "label.validation.triage.filterLabel": "按信号过滤",
  "label.validation.filter.all": "所有分析仪",
  "label.validation.filter.needsReview": "需要复核",
  "label.validation.filter.nce": "不符合事件",
  "label.validation.filter.qcFail": "质控不合格",
  "label.validation.filter.modified": "已修改",
  "label.validation.filter.ackPending": "待确认",
  "label.validation.search.box": "实验室编号",
  "label.validation.search.rangeHint": "范围：A..B，或 A.. 表示 A 及以后",
  "label.validation.search.fromDate": "来源",
  "label.validation.search.toDate": "到",
  "label.validation.search.loadError": "无法加载审核队列。",
  "label.validation.filter.critical": "紧急",
  "label.validation.filter.abnormal": "异常",
  "label.validation.lane.clear": "清除位置",
  "label.validation.lane.needsReview": "需要复核",
  "label.validation.signal.nce": "不符合事件未关闭",
  "label.validation.signal.qcFail": "质控不合格",
  "label.validation.signal.modified": "已修改",
  "label.validation.signal.ackPending": "确认待处理",
  "label.validation.signal.nonconforming": "不符合要求",
  "label.validation.signal.critical": "紧急",
  "label.validation.review.result": "结果",
  "label.validation.review.units": "单位",
  "label.validation.review.normalRange": "参考范围",
  "label.validation.review.criticalRange": "危急范围",
  "label.validation.review.method": "方法",
  "label.validation.review.analyzer": "分析仪",
  "label.validation.review.performedAt": "执行时间",
  "label.validation.review.enteredBy": "录入人",
  "label.validation.review.enteredDate": "录入于",
  "label.validation.review.collected": "已采样",
  "label.validation.review.qc": "质控",
  "label.validation.review.qc.PASS": "质控通过",
  "label.validation.review.qc.FAIL": "质控未通过",
  "label.validation.review.notRecorded": "未记录",
  "label.validation.review.beforeRelease": "发布前，请检查：",
  "label.validation.review.components": "组件",
  "label.validation.review.component": "组件",
  "label.validation.review.flag": "标记",
  "label.validation.review.primary": "主要",
  "label.validation.review.reference": "参考",
  "label.validation.review.notes": "备注",
  "label.validation.review.notes.summary": "{count} 条备注",
  "label.validation.review.notes.empty": "尚无备注",
  "label.validation.review.notes.add": "审核备注",
  "label.validation.review.notes.placeholder": "添加审核备注……",
  "label.validation.review.notes.visibility": "可见性",
  "label.validation.review.notes.internal": "内部",
  "label.validation.review.notes.external": "随结果发送",
  "label.validation.review.notes.externalWarning": "该备注将显示在患者报告中。",
  "label.validation.review.notes.contextHint": "上下文：审核（自动记录）。",
  "label.validation.review.notes.context.result": "结果备注",
  "label.validation.review.modify.reason": "修改原因",
  "label.validation.review.modify.reasonRequired": "修改结果时需要提供理由。",
  "label.validation.review.modify.newValue": "新结果",
  "label.validation.review.modify.notEditable": "该结果类型可在“结果录入”页面进行编辑。",
  "label.validation.review.qcSection": "质控",
  "label.validation.review.reagents.followUp": "该分析所用的试剂批号和质控品批号在“结果录入”页面进行复核。",
  "label.validation.review.action.release": "审核并发布",
  "label.validation.review.action.modify": "修改结果",
  "label.validation.review.action.saveModification": "保存修改",
  "label.validation.review.action.cancel": "取消",
  "label.validation.review.action.refer": "转诊此检测",
  "label.validation.review.release.qcAckFirst": "发布前请确认下方未通过的质控。",
  "label.validation.review.error.notAwaitingValidation": "自页面加载以来，该结果已发生变化。请重新加载页面并重新复核。",
  "label.validation.review.error.qcAcknowledgmentRequired": "本批次中未通过的质控必须在发布前予以确认。",
  "label.validation.review.error.modificationReasonRequired": "修改结果时需要提供理由。",
  "label.validation.review.error.modifyRoleRequired": "您的角色权限不允许修改结果。",
  "label.validation.review.error.resultRequired": "保存前请输入结果值。",
  "label.validation.review.error.invalidResult": "结果不完整；请检查限定值。",
  "label.validation.review.error.generic": "无法完成此操作。",
  "label.validation.review.success.released": "结果已审核并发布。",
  "label.validation.review.success.accepted": "Component validated. The test is released once its other components are validated.",
  "label.validation.review.success.modified": "结果已修改。该结果仍保留在审核队列中。",
  "esig.context.validateSingle": "审核并发布实验室编号 {accession} 的 {test}",
  "label.validation.bulk.releaseAllClear": "发布所有合格结果（{count}）",
  "label.validation.bulk.heading": "发布所有合格结果",
  "label.validation.bulk.bodyClear": "{count, plural, other {这 # 个结果}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "发布时对整组结果提交一次电子签名。",
  "label.validation.bulk.disabled": "该实验室已关闭批量发布功能。",
  "label.validation.emptyState.signals": "此队列中有 {count} 个结果在发布前需要检查。",
  "label.validation.emptyState.signalsDetail": "最常见：{signals}。",
  "label.validation.emptyState.noReference": "{count} 个结果所属检测在检测目录中未记录参考值，因此无法判定为正常。",
  "label.validation.emptyState.noReferenceHint": "请在检测目录中为这些检测记录预期正常值，以便其结果可以通过。",
  "label.validation.emptyState.rangeNotApplied": "{count} 个结果因未记录患者性别或年龄而未应用参考范围。请逐一审核，或在患者信息中补录缺失的值。",
  "label.validation.emptyState.queueEmpty": "没有等待审核的内容。",
  "label.validation.release.scope": "通过检查包括参考范围、结果标记、不符合项、保存后的编辑和紧急结果确认，并会拦截任何已记录质控失败的结果。它不确认是否已执行质控。",
  "label.validation.bulk.none": "没有可发布的合格结果。",
  "label.validation.bulk.column.accession": "实验室编号",
  "label.validation.bulk.success": "已发布 {count} 项合格结果。",
  "label.validation.bulk.partial": "已发布 {released} 项；{skipped} 项因不再合格而被跳过。",
  "label.validation.bulk.error.bulkReleaseDisabled": "该实验室已关闭批量发布功能。",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "本批次中未通过的质控必须在发布前予以确认。",
  "label.validation.bulk.error.nothingReleased": "所选结果均已不再合格；未发布任何结果。",
  "label.validation.bulk.error.generic": "无法完成批量发布。",
  "label.validation.review.action.review": "复核 →",
  "esig.context.releaseAllClear": "发布实验室编号 {accession} 的 {count} 个无异常结果",
  "instructions.validation.bulk.release": "启用后，“验证”页面将提供“发布全部无异常结果”，仅发布“无异常”通道中的结果（在范围内、无已记录的质控失败、无信号），只需一个电子签名。禁用此选项则要求每个结果在复核后单独发布。",
  "instructions.validation.retest.note": "启用后，审核人员将结果退回重新检测时，必须为检测台填写备注。",
  "label.validation.review.action.retest": "送去重新检测",
  "label.validation.review.action.reject": "拒绝（提交不符合事件）",
  "label.validation.review.retest.note": "给工作台的备注",
  "label.validation.review.retest.noteRequired": "将结果退回重新检测时，必须填写备注。",
  "label.validation.review.retest.hint": "该结果将返回“结果录入”界面，管道将从第1级重新开始。",
  "label.validation.review.reject.hint": "拒绝将提交一个不符合事件；请填写表单进行记录。",
  "label.validation.review.reject.disabled": "该实验室已关闭结果拒收功能。",
  "label.validation.review.error.stale": "该结果已由 {who} 于 {when} 修改。正在重新加载队列……",
  "label.validation.review.error.retestNoteRequired": "将结果送去重新检测时，必须填写备注。",
  "label.validation.review.error.rejectionDisabled": "该实验室已关闭结果拒绝功能。",
  "label.validation.review.success.retest": "结果已返回，需重新检测。",
  "label.validation.review.success.rejected": "结果已拒绝；不符合事件已记录。",
  "label.validation.bulk.error.stale": "您查看期间，队列发生了变化。正在重新加载页面……",
  "label.validation.autoValidated.toggle": "包含自动审核的结果",
  "label.validation.autoValidated.heading": "自动审核的结果（{count}）",
  "label.validation.autoValidated.tag": "自动审核",
  "label.validation.autoValidated.empty": "该实验室编号没有自动审核的结果。",
  "label.validation.autoValidated.hint": "在结果录入时已发布，未经审核人审核；仅供复核查看。",
  "label.validation.autoValidated.releasedOn": "发布于",
  "label.validation.signal.rangeNotApplied": "未应用范围",
  "result.rangeNotApplied.sexMissing": "未应用参考范围：未记录患者性别",
  "result.rangeNotApplied.ageMissing": "未应用参考范围：未记录患者年龄",
  "result.rangeNotApplied.sexAndAgeMissing": "未应用参考范围：未记录患者性别和年龄",
  "laporanHasil.action.generatePdf": "生成 PDF",
  "laporanHasil.action.regeneratePdf": "重新生成 PDF",
  "laporanHasil.col.actions": "操作",
  "laporanHasil.col.collectionDate": "采集日期",
  "laporanHasil.col.compliance": "合规",
  "laporanHasil.col.labNumber": "实验室编号",
  "laporanHasil.col.lastGenerated": "最后生成时间",
  "laporanHasil.col.site": "站点",
  "laporanHasil.col.standard": "标准",
  "laporanHasil.col.tests": "检测项目",
  "laporanHasil.detail.ambientTemp": "环境温度",
  "laporanHasil.detail.collectionDateTime": "采集日期时间",
  "laporanHasil.detail.collectionMethod": "采集方法",
  "laporanHasil.detail.complianceSummary": "合规摘要",
  "laporanHasil.detail.conditions": "采集条件",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "实验室分析师",
  "laporanHasil.detail.labManager": "实验室经理",
  "laporanHasil.detail.parameter": "参数",
  "laporanHasil.detail.ppNo": "PP 编号",
  "laporanHasil.detail.preservation": "保存方式",
  "laporanHasil.detail.result": "结果",
  "laporanHasil.detail.signatures": "签名",
  "laporanHasil.detail.site": "站点",
  "laporanHasil.detail.siteInfo": "站点信息",
  "laporanHasil.detail.standard": "标准",
  "laporanHasil.detail.status": "状态",
  "laporanHasil.detail.threshold": "阈值",
  "laporanHasil.detail.waterTemp": "水温",
  "laporanHasil.detail.weather": "天气",
  "laporanHasil.empty": "根据所选筛选条件，未找到任何订单。",
  "laporanHasil.error": "无法加载报告。请重试。",
  "laporanHasil.filter.all": "所有分析仪",
  "laporanHasil.filter.allSites": "所有站点",
  "laporanHasil.filter.allStandards": "所有标准",
  "laporanHasil.filter.complianceStatus": "合规状态",
  "laporanHasil.filter.dateFrom": "开始日期",
  "laporanHasil.filter.dateTo": "结束日期",
  "laporanHasil.filter.generated": "已生成",
  "laporanHasil.filter.generationStatus": "生成状态",
  "laporanHasil.filter.notGenerated": "尚未生成",
  "laporanHasil.filter.samplingSite": "样本采样点",
  "laporanHasil.filter.standard": "合规标准",
  "laporanHasil.loading": "正在加载合规报告...",
  "laporanHasil.status.borderline": "边缘型",
  "laporanHasil.status.compliant": "符合要求的",
  "laporanHasil.status.ineligible": "未关联标准",
  "laporanHasil.status.nonCompliant": "不符合要求",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "为已审核的环境订单生成合规证书",
  "laporanHasil.tile.generated": "已生成",
  "laporanHasil.tile.ineligible": "不符合条件",
  "laporanHasil.tile.ineligible.desc": "未审核或未关联标准",
  "laporanHasil.tile.notGenerated": "尚未生成",
  "laporanHasil.title": "合规报告",
  "lhu.amendment.error.generic": "无法重新生成报告。请重试。",
  "lhu.amendment.modal.description": "您正在为实验室编号{labNumber}重新签发LHU。重新签发的报告将被视为对先前发布的证书的修订。",
  "lhu.amendment.modal.heading": "重新发布附有修订的LHU",
  "lhu.amendment.modal.submit": "重新发布并下载 PDF",
  "lhu.amendment.reason.helper": "说明对原始报告进行修订的原因（符合 ISO 17025 第 7.8.8 条的要求）。",
  "lhu.amendment.reason.label": "修改原因",
  "lhu.amendment.reason.placeholder": "例如：pH值测得结果不正确——仪器未经过校准",
  "lhu.amendment.reason.required": "必须填写修改原因",
  "lhu.amendment.reissue": "修订后重新发布",
  "lhu.amendment.submitting": "正在重新发布…",
  "nce.close.error": "无法关闭 NCE",
  "nce.close.success": "NCE已成功关闭",
  "nce.correctiveAction.error": "未能推进NCE状态",
  "nce.correctiveAction.success": "NCE已转入纠正措施阶段",
  "notificationtrigger.activetriggers.heading": "活跃触发器",
  "notificationtrigger.activetriggers.subtitle": "每行控制一种通知事件类型。切换至“开启”状态即可激活。通道和收件人设置仅在触发器启用时应用。",
  "notificationtrigger.channel.email": "电子邮件",
  "notificationtrigger.channel.sms": "短信",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "This message type cannot include {fields}. Use the merge fields listed under the template.",
  "notificationtrigger.column.channels": "渠道",
  "notificationtrigger.column.enabled": "已启用",
  "notificationtrigger.column.eventcode": "事件代码",
  "notificationtrigger.column.override": "按实验室单元设置的覆盖规则",
  "notificationtrigger.column.recipients": "收件人",
  "notificationtrigger.column.trigger": "触发器",
  "notificationtrigger.config.subtitle": "按事件启用或禁用通知触发条件，选择发送渠道，并配置收件人类型。",
  "notificationtrigger.config.title": "通知触发器配置",
  "notificationtrigger.disabled.hint": "启用此触发器以配置其渠道和收件人。",
  "notificationtrigger.override.comingsoon": "暂不支持按实验室单元覆盖设置。",
  "notificationtrigger.override.configure": "配置",
  "notificationtrigger.recipient.coccontact": "监管链联系人",
  "notificationtrigger.recipient.orderingprovider": "申请医生",
  "notificationtrigger.recipient.submittinguser": "提交用户",
  "notificationtrigger.referralout.defaultoff": "默认值“关闭”——必须显式启用。",
  "notificationtrigger.referralout.description": "在将样本送往外部实验室时发送。",
  "notificationtrigger.referralout.firesoncenote": "每次保存的转诊单触发一次通知。如果一笔订单包含转诊至两个不同实验室的转诊单，则会发送两条通知。",
  "notificationtrigger.referralout.name": "转出",
  "notificationtrigger.sentmessages.action.resend": "重新发送",
  "notificationtrigger.sentmessages.action.viewlog": "查看日志",
  "notificationtrigger.sentmessages.channel.failed": "失败",
  "notificationtrigger.sentmessages.channel.sent": "已发送",
  "notificationtrigger.sentmessages.column.actions": "操作",
  "notificationtrigger.sentmessages.column.channels": "渠道",
  "notificationtrigger.sentmessages.column.datetime": "日期时间",
  "notificationtrigger.sentmessages.column.recipient": "收件人",
  "notificationtrigger.sentmessages.column.reference": "参考号",
  "notificationtrigger.sentmessages.column.status": "状态",
  "notificationtrigger.sentmessages.column.type": "设备类型",
  "notificationtrigger.sentmessages.count": "{total} 条消息中的 {count} 条",
  "notificationtrigger.sentmessages.empty.heading": "尚未发送任何通知。",
  "notificationtrigger.sentmessages.filter.status.all": "所有状态",
  "notificationtrigger.sentmessages.filter.status.failed": "失败数量",
  "notificationtrigger.sentmessages.filter.status.label": "状态",
  "notificationtrigger.sentmessages.filter.status.sent": "已发送",
  "notificationtrigger.sentmessages.filter.type.all": "所有类型",
  "notificationtrigger.sentmessages.filter.type.label": "设备类型",
  "notificationtrigger.sentmessages.heading": "已发送的消息",
  "notificationtrigger.sentmessages.resend.disclaimer": "重新发送将重复发送原始消息的字节内容和收件人地址。若要发送至其他地址，请编辑患者记录并触发一个新事件。",
  "notificationtrigger.sentmessages.resend.failure": "重新发送失败。详情请参阅服务器日志。",
  "notificationtrigger.sentmessages.resend.success": "通知已重新发送。",
  "notificationtrigger.sentmessages.status.failed": "失败数量",
  "notificationtrigger.sentmessages.status.sent": "已发送",
  "notificationtrigger.sentmessages.subtitle": "OpenELIS 发送的所有外发通知，涵盖所有触发类型和渠道。",
  "notificationtrigger.sentmessages.viewlog.channels": "渠道结果",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "尝试次数",
  "notificationtrigger.sentmessages.viewlog.column.channel": "渠道",
  "notificationtrigger.sentmessages.viewlog.column.error": "错误",
  "notificationtrigger.sentmessages.viewlog.column.status": "状态",
  "notificationtrigger.sentmessages.viewlog.heading": "通知日志",
  "notificationtrigger.sentmessages.viewlog.message": "消息正文",
  "notificationtrigger.sentmessages.viewlog.subject": "主题",
  "notificationtrigger.status.new": "新建",
  "notificationtrigger.subcontractdispatched.description": "当样本已实际寄送至接收实验室时发送。",
  "notificationtrigger.subcontractdispatched.name": "分包样本已发送",
  "notificationtrigger.tabs.sentmessages": "已发送的消息",
  "notificationtrigger.tabs.sentmessages.placeholder": "已发送的消息——将在未来的里程碑版本中推出。",
  "notificationtrigger.tabs.templates": "模板",
  "notificationtrigger.tabs.templates.placeholder": "模板编辑器——将在未来的里程碑版本中推出。",
  "notificationtrigger.tabs.triggers": "触发器",
  "notificationtrigger.templates.body.help": "包含合并字段的自由文本。此模板不由 i18n 管理——可直接编辑。",
  "notificationtrigger.templates.body.label": "消息正文",
  "notificationtrigger.templates.button.reset": "重置到默认值",
  "notificationtrigger.templates.button.save": "保存模板",
  "notificationtrigger.templates.channel.help": "每个渠道都有自己的模板字段。请切换渠道以分别进行编辑。",
  "notificationtrigger.templates.channel.label": "渠道",
  "notificationtrigger.templates.heading": "通知模板配置",
  "notificationtrigger.templates.mergefields.heading": "可用的合并字段",
  "notificationtrigger.templates.mergefields.help": "以下字段专用于{eventCode}事件。点击某个字段，即可将其插入到光标所在位置。",
  "notificationtrigger.templates.mergefields.optionalnote": "如果转诊中未设置 [expectedReturn]，该字段将显示为空白，不会报错。",
  "notificationtrigger.templates.preview.label": "渲染预览",
  "notificationtrigger.templates.referralout.description": "保存转诊时，发送给客户联系人（申请医生）和/或内部员工（提交用户）。",
  "notificationtrigger.templates.subcontractdispatched.description": "当样本实际发送至接收实验室时，发送给接收实验室的监管链（CoC）联系人及客户。",
  "notificationtrigger.templates.subject.label": "主题",
  "notificationtrigger.templates.subtitle": "为每种通知事件类型编写消息模板。模板为包含合并字段的自由文本。",
  "order.clinicalInfo.helper": "用于指导检测选择和报告的可选背景信息——未记录为确诊记录。",
  "order.complete.processing.description": "{labNumber} 该条目目前处于{status}状态，并将显示在V-03向量识别工作列表中。",
  "order.complete.processing.description.plain": "{labNumber} 当前状态为“处理中”，并将显示在 V-03 病媒鉴定工作列表中。",
  "order.complete.processing.title": "订单已完成：处理中",
  "order.context.poolOf": "{count} 只{animal}的混样",
  "order.paymentStatus.helper": "此订单付款的处理方式。",
  "order.priority.helper": "常规：按标准流程处理。紧急：立即处理。",
  "order.referral.sampleType.ambiguous": "此转诊单要求进行{items}检测，但无法自动确定样本类型。请在下方选择样本类型，并选择所需的检测项目。",
  "order.requester.section.helper": "请选择下达检测订单的医疗机构及负责的申请医生。",
  "panel.domain.clinical": "临床",
  "panel.domain.environmental": "环境",
  "panel.domain.eqa": "EQA样本",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "域名",
  "panel.organism.flea": "跳蚤",
  "panel.organism.fly": "飞",
  "panel.organism.mosquito": "蚊子",
  "panel.organism.rodent": "啮齿动物",
  "panel.organism.selectPlaceholder": "选择生物类群",
  "panel.organism.tick": "对",
  "patient.search.section.helper": "可通过任意字段组合进行搜索。姓名按完全匹配或首字母匹配。“外部搜索”会查询客户登记册，至少需要提供姓名和出生日期。",
  "placeholder.validation.qc.justification": "必填（最大 500 个字符）",
  "provider.add.new": "+ 添加新申请医生“{name}”",
  "providerTitle.abbreviation": "缩写",
  "providerTitle.add": "添加称谓",
  "providerTitle.confirm.activate": "启用“{title}”？",
  "providerTitle.confirm.activate.body": "选择申请医生称谓时将再次提供此选项。",
  "providerTitle.confirm.deactivate": "停用“{title}”？",
  "providerTitle.confirm.deactivate.body": "新的选择中将不再提供此选项。已使用此称谓的 {count} 位申请医生将保留该称谓。",
  "providerTitle.duplicate": "“{value}”已在列表中",
  "providerTitle.edit": "编辑称谓",
  "providerTitle.edit.warning": "修改称谓会改变其在所有使用该称谓的申请医生上的显示方式。",
  "providerTitle.empty": "尚未配置任何申请医生称谓。",
  "providerTitle.filter.status": "状态",
  "providerTitle.filter.status.active": "活跃",
  "providerTitle.filter.status.all": "所有分析仪",
  "providerTitle.filter.status.inactive": "非活跃",
  "providerTitle.inUse": "使用中",
  "providerTitle.search": "搜索称谓",
  "providerTitle.sortOrder": "排序顺序",
  "providerTitle.summary": "{total} 个称谓：{active} 个启用，{inactive} 个停用。",
  "providerTitle.title": "标题",
  "providerTitle.titles": "申请医生称谓",
  "provider.email.field": "提供者电子邮件",
  "provider.fax.field": "申请医生传真",
  "provider.title.field": "标题",
  "provider.title.inName": "这看起来像是称谓。建议将其移至“称谓”字段，以便列表按姓氏排序。",
  "provider.title.filter": "按称谓筛选",
  "provider.title.filter.all": "所有称谓",
  "provider.title.placeholder": "选择称谓...",
  "provider.firstName.field": "名",
  "provider.lastName.field": "姓",
  "provider.new.helper": "保存此订单时，将创建为新的申请医生。",
  "provider.new.tag": "新",
  "provider.no.match": "未找到匹配的申请医生。",
  "provider.phone.field": "电话",
  "qc.add.blank": "+ 空白质控",
  "qc.add.control": "+ 质控品",
  "qc.add.duplicate": "+ 重复质控",
  "qc.collect.inheritsFromParent": "采集详细信息继承自父样本",
  "qc.expectedValue.placeholder": "例如 50.0",
  "qc.samples.label": "质控样本：",
  "qc.samples.numericOnly": "目前质控仅支持数值型结果的检测。所选检测为编码型结果，请选择数值型检测以添加质控。",
  "qc.samples.thresholdsMissing": "在添加质控样本之前，请先在“管理”→“检测配置”中为{tests}配置质控阈值。",
  "qc.status.current": "当前质控状态",
  "qc.status.failed.warning.message": "质控未通过的批次将不能用于检测，也不计入可用库存。",
  "qc.status.failed.warning.title": "此批次将不可用",
  "qc.status.new": "新质控状态",
  "qc.status.notes": "QC备注",
  "qc.status.notes.placeholder": "质控结果的原因、所做检测或参考依据",
  "qc.type.blank": "质控：空白",
  "qc.type.control": "质控：质控品",
  "qc.type.duplicate": "质控：重复",
  "referral.accept.error": "无法接受该结果。请重试。",
  "referral.action.accept": "接受",
  "referral.action.acceptToAnalysis": "接受并转入分析",
  "referral.action.clearFilters": "清除筛选条件",
  "referral.action.enterResult": "输入结果",
  "referral.action.markLost": "标记为丢失",
  "referral.action.notifyReferenceLab": "通知参考实验室",
  "referral.action.openResultEntry": "在“结果录入”中打开",
  "referral.action.reject": "拒绝",
  "referral.banner.filterToStuck": "仅显示滞留转诊",
  "referral.banner.stuckReferralsSubtitle": "{count} 个转诊已在参考实验室停留超过 {threshold} 天。",
  "referral.banner.stuckReferralsTitle": "检测到滞留转诊",
  "referral.box.cannotReconcileMessage": "无法核对样本箱：仍有 {count} 个样本等待结果核对。请参阅“参考实验室结果”。",
  "referral.box.viewBlockedReferrals": "在“参考实验室结果”中查看",
  "referral.breadcrumb.referenceLabResults": "参考实验室检测结果",
  "referral.chip.ariaLabel": "参考实验室结果视图",
  "referral.chip.history": "历史",
  "referral.chip.outstanding": "待返回",
  "referral.chip.returned": "已退回，需处理",
  "referral.column.actions": "操作",
  "referral.column.boxId": "箱子编号",
  "referral.column.closedDate": "关闭日期",
  "referral.column.daysOutstanding": "待返回天数",
  "referral.column.daysTotal": "天数总计",
  "referral.column.labNumber": "实验室编号",
  "referral.column.outcome": "结果",
  "referral.column.patient": "患者",
  "referral.column.priority": "优先级",
  "referral.column.referenceLab": "参考实验室",
  "referral.column.requestor": "原始请求者",
  "referral.column.resultSummary": "结果摘要",
  "referral.column.returnedDate": "退回日期",
  "referral.column.sentDate": "发送日期",
  "referral.column.status": "状态",
  "referral.column.tests": "检测",
  "referral.expand.criticalBadge": "紧急",
  "referral.expand.detail.ageYears": "{years, plural, other {# 岁}}",
  "referral.expand.detail.boxId": "箱子编号",
  "referral.expand.detail.boxReceivedDate": "参考实验室接收时间",
  "referral.expand.detail.collected": "已采样",
  "referral.expand.detail.currentStatus": "当前状态",
  "referral.expand.detail.daysOutstanding": "待返回天数",
  "referral.expand.detail.dispatched": "已发送",
  "referral.expand.detail.fhirTask": "FHIR 任务",
  "referral.expand.detail.labNumber": "实验室编号",
  "referral.expand.detail.patient": "患者",
  "referral.expand.detail.priority": "优先级",
  "referral.expand.detail.referenceLab": "参考实验室",
  "referral.expand.detail.requestor": "原始请求者",
  "referral.expand.detail.sampleType": "样本类型",
  "referral.expand.detail.tests": "检测项目",
  "referral.expand.noResultPayload": "参考实验室未返回任何结构化结果。",
  "referral.expand.originalOrderContext": "原始订单上下文",
  "referral.expand.outcomeDetail": "结果详情",
  "referral.expand.receptionAction": "接待操作",
  "referral.expand.receptionHint": "请复核下方返回的结果，然后点击“接受”将其发布到患者记录；如果结果无法使用，请点击“拒绝”。",
  "referral.expand.referenceLabTransit": "参考实验室转运",
  "referral.expand.result": "结果",
  "referral.expand.statusDetail": "状态详情",
  "referral.filter.allPriorities": "所有优先级",
  "referral.filter.allRefLabs": "所有参考实验室",
  "referral.filter.dateRange": "日期范围",
  "referral.filter.daysOutstandingBucket": "未结天数",
  "referral.filter.daysOutstandingBucket.stuck": "卡住（> {threshold} 天）",
  "referral.filter.priority": "优先级",
  "referral.filter.referenceLab": "参考实验室",
  "referral.markLost.cancelButton": "取消",
  "referral.markLost.confirmButton": "标记为丢失",
  "referral.markLost.description": "这表示该转诊样本在运输中丢失，并将该样本从“未结”列表中移除。临床团队需要重新采集样本并重新进行转诊。",
  "referral.markLost.modalTitle": "将转诊标记为“丢失”",
  "referral.markLost.reasonLabel": "理由",
  "referral.markLost.reasonPlaceholder": "例如：快递公司确认丢失。样品盒从未送达参考实验室。",
  "referral.markLost.reasonRequired": "必须提供理由。",
  "referral.metric.outstanding": "未结",
  "referral.metric.reconciledToday": "今天已核对",
  "referral.metric.rejectedThisWeek": "本周已拒收",
  "referral.metric.returned": "已退回 — 需操作",
  "referral.notification.accepted": "该结果已录入患者病历。",
  "referral.notification.rejected": "结果被拒。已通知临床医生重新采集样本。",
  "referral.notify.errorRetry": "未能通知参考实验室。请重试。",
  "referral.notify.toast": "已通知参考实验室。",
  "referral.page.title": "参考实验室检测结果",
  "referral.reject.cancelButton": "取消",
  "referral.reject.confirmButton": "拒绝并通知临床医生",
  "referral.reject.description": "“拒绝”将永久终止原始检测，并通知临床医生重新采集样本并重新转诊。",
  "referral.reject.error": "无法拒绝该结果。请重试。",
  "referral.reject.modalTitle": "拒绝返回的结果",
  "referral.reject.reason.clotted": "凝血",
  "referral.reject.reason.damagedContainer": "容器破损",
  "referral.reject.reason.hemolyzed": "溶血",
  "referral.reject.reason.insufficientVolume": "量不足",
  "referral.reject.reason.mislabeled": "标签错误",
  "referral.reject.reason.other": "其他原因",
  "referral.reject.reason.temperatureDeviation": "储存温度偏差",
  "referral.reject.reason.wrongSampleType": "样本类型错误",
  "referral.reject.reasonLabel": "理由",
  "referral.reject.reasonTextLabel": "详情",
  "referral.reject.reasonTextPlaceholder": "请说明为什么不能使用这个返回的结果。",
  "referral.reject.reasonTextRequired": "需要提供详细信息。",
  "referral.reject.warningTitle": "此操作无法撤销",
  "referral.result.interp.Abnormal": "异常",
  "referral.result.interp.Critical": "紧急",
  "referral.result.interp.Normal": "正常",
  "referral.status.cancelled": "已取消",
  "referral.status.completed": "已返回结果",
  "referral.status.draft": "草稿",
  "referral.status.inProgress": "参考实验室检测中",
  "referral.status.received": "在参考实验室",
  "referral.status.reconciled": "已核对",
  "referral.status.rejected": "被参考实验室拒绝",
  "referral.status.requested": "已发送——等待接受",
  "referral.table.count": "{count, plural, =0 {无转诊} one {# 条转诊} other {# 条转诊}}",
  "referral.table.history.title": "历史",
  "referral.table.outstanding.title": "未结的转诊",
  "referral.table.returned.title": "已退回 — 需操作",
  "referral.tag.manuallyEntered": "手动输入",
  "reports.tat.title": "周转时间(TAT)报告",
  "reports.tat.description": "分析实验室在各个工作流程里程碑的周转时间",
  "reports.tat.generateReport": "生成报告",
  "reports.tat.clearFilters": "清除筛选",
  "reports.tat.segment.orderToCollection": "开单到采样",
  "reports.tat.segment.collectionToReceipt": "采样到接收",
  "reports.tat.segment.receiptToTesting": "接收到开始检测",
  "reports.tat.segment.receiptToResult": "接收到结果录入",
  "reports.tat.segment.receiptToValidation": "接收到审核",
  "reports.tat.segment.resultToValidation": "结果录入到审核",
  "reports.tat.segment.overall": "总体TAT",
  "reports.tat.calendarTime": "日历时间",
  "reports.tat.workingTime": "工作时间",
  "reports.tat.workingTimeInfo": "工作时间模式: 排除选定日期范围内的{weekendDays}和{holidayCount}个公共假期",
  "reports.tat.configuredWeekends": "已配置的周末",
  "reports.tat.noHolidaysWarning": "未配置公共假期。请在 管理 > 日历管理 中配置假期。",
  "reports.tat.manageCalendar": "管理日历",
  "reports.tat.totalResults": "总结果数",
  "reports.tat.meanTat": "平均TAT",
  "reports.tat.medianTat": "中位TAT",
  "reports.tat.percentile90": "第90百分位",
  "reports.tat.minTat": "最小TAT",
  "reports.tat.maxTat": "最大TAT",
  "reports.tat.stdDeviation": "标准差",
  "reports.tat.distribution": "TAT分布",
  "reports.tat.breakdownBy": "细分依据",
  "reports.tat.clickRowHint": "点击行查看 individual 结果",
  "reports.tat.summary": "转运箱摘要",
  "reports.tat.detailList": "详细列表",
  "reports.tat.trends": "趋势",
  "reports.tat.noResults": "未找到符合所选筛选条件的结果。请尝试调整日期范围或筛选条件。",
  "reports.tat.insufficientData": "数据不足",
  "reports.tat.loadError": "加载报告数据时出错",
  "reports.tat.dateRange": "日期范围",
  "reports.tat.labUnit": "实验室单元",
  "reports.tat.testPanel": "检测项目/组合",
  "reports.tat.priority.all": "所有分析仪",
  "reports.tat.priority.routine": "常规",
  "reports.tat.priority.stat": "紧急",
  "reports.tat.priority.asap": "尽快",
  "reports.tat.sampleType": "样本类型",
  "reports.tat.orderingSite": "开单机构",
  "reports.tat.priority": "优先级",
  "reports.tat.includeCancelled": "包含已取消/已拒绝",
  "reports.tat.export": "导出",
  "reports.tat.exportCsv": "导出翻译",
  "reports.tat.exportPdf": "导出PDF",
  "reports.tat.labNumber": "实验室编号",
  "reports.tat.patient": "患者",
  "reports.tat.test": "检测",
  "reports.tat.orderCreated": "已创建医嘱",
  "reports.tat.collected": "已采样",
  "reports.tat.received": "已接收",
  "reports.tat.testingStarted": "已开始检测",
  "reports.tat.resultEntered": "已录入结果",
  "reports.tat.validated": "已审核",
  "reports.tat.selectedTat": "选定TAT",
  "reports.tat.overallTat": "总体TAT",
  "reports.tat.columns": "列",
  "reports.tat.rowsPerPage": "每页行数",
  "reports.tat.showing": "显示第 {from}-{to} 条,共 {total} 条结果",
  "reports.tat.trend": "趋势",
  "reports.tat.aggregation": "聚合",
  "reports.tat.daily": "每日",
  "reports.tat.weekly": "每周",
  "reports.tat.monthly": "每月",
  "reports.tat.compareBy": "对比依据",
  "reports.tat.showVolume": "显示医嘱量",
  "reports.tat.mean": "均值",
  "reports.tat.median": "中位数",
  "reports.tat.notApplicable": "不适用",
  "reports.tat.dateRangeFrom": "日期范围(起)",
  "reports.tat.dateRangeTo": "日期范围(止)",
  "reports.tat.tatSegment": "TAT阶段",
  "reports.tat.metrics": "指标",
  "reports.tat.compareNone": "无",
  "reports.tat.comparePriority": "优先级",
  "reports.tat.column.labNumber": "实验室编号",
  "reports.tat.column.test": "检测",
  "reports.tat.column.labUnit": "实验室单元",
  "reports.tat.column.priority": "优先级",
  "reports.tat.column.ordered": "已订购",
  "reports.tat.column.collected": "已采样",
  "reports.tat.column.received": "已接收",
  "reports.tat.column.started": "已开始",
  "reports.tat.column.resulted": "已出结果",
  "reports.tat.column.validated": "已审核",
  "reports.tat.column.selectedTat": "选定TAT",
  "reports.tat.column.overallTat": "总体TAT",
  "reports.tat.column.name": "名称",
  "reports.tat.column.count": "数量",
  "reports.tat.column.mean": "均值",
  "reports.tat.column.median": "中位数",
  "reports.tat.column.p90": "第90百分位",
  "reports.tat.column.max": "最大值",
  "reports.tat.home": "首页",
  "reports.tat.all": "所有分析仪",
  "reports.tat.preset.today": "今天",
  "reports.tat.preset.7days": "最近7天",
  "reports.tat.preset.30days": "最近30天",
  "reports.tat.preset.90days": "最近90天",
  "reports.tat.preset.thisMonth": "本月",
  "reports.tat.preset.lastMonth": "上月",
  "reports.tat.preset.thisQuarter": "本季度",
  "button.cancel": "取消",
  "button.activate": "激活",
  "button.adjust": "调整",
  "button.deactivate": "停用",
  "button.dispose": "处置",
  "button.edit": "编辑",
  "button.generate": "生成",
  "button.label.genarateReport": "生成报告",
  "button.label.loadnext": "加载下一个包",
  "button.label.loadprevious": "加载上一个包",
  "button.label.showHidePram": "显示/隐藏报告参数",
  "button.record": "记录",
  "button.save": "保存",
  "button.save.draft": "保存草稿",
  "button.save.next": "保存并下一个",
  "button.save.stay": "保存",
  "button.send": "发送",
  "button.update": "更新",
  "calculatedTests": "计算检测",
  "catalog.item.activate.success": "目录项激活成功",
  "catalog.item.category": "类别",
  "catalog.item.code": "代码",
  "catalog.item.code.hint": "供集成使用的稳定标识符。留空则根据名称自动生成，例如 PAR-500MG-001。",
  "catalog.item.code.locked": "代码保存后即锁定，以确保集成和现有引用继续正常工作。",
  "catalog.item.code.placeholder": "留空则根据名称自动生成",
  "catalog.item.code.preview": "将保存为 {code}",
  "catalog.item.compatibleAnalyzers": "兼容的分析仪",
  "catalog.item.deactivate.confirm.button": "停用",
  "catalog.item.deactivate.confirm.message": "您确定要停用 {itemName} 吗？",
  "catalog.item.deactivate.confirm.title": "确认停用",
  "catalog.item.deactivate.implications.1": "此物品将不再出现在活跃物品列表中",
  "catalog.item.deactivate.implications.2": "此物品的现有批次仍可访问",
  "catalog.item.deactivate.implications.3": "如果需要，您可以稍后重新激活此物品",
  "catalog.item.deactivate.implications.title": "影响：",
  "catalog.item.deactivate.label": "停用物品",
  "catalog.item.deactivate.success": "物品停用成功",
  "catalog.item.error.saveGeneric": "保存目录项时出错",
  "catalog.item.error.stabilityRequired": "试剂必须填写开封后稳定性",
  "catalog.item.form.title.add": "添加新目录项",
  "catalog.item.form.title.edit": "编辑目录项",
  "catalog.item.lowStockThreshold": "低库存阈值",
  "catalog.item.manufacturer": "制造商",
  "catalog.item.minimumStock": "最小库存水平",
  "catalog.item.name": "物品名称",
  "catalog.item.reorderLevel": "再订购水平",
  "catalog.item.reorderQuantity": "再订购数量",
  "catalog.item.save.error": "保存目录项时出错",
  "catalog.item.save.success": "目录项保存成功",
  "catalog.item.stabilityAfterOpening": "开封后稳定性（天）",
  "catalog.item.status": "状态",
  "catalog.item.storageRequirements": "存储要求",
  "catalog.item.testTypes": "检测类型",
  "catalog.item.testsPerCartridge": "每个试剂盒的检测次数",
  "catalog.item.testsPerKit": "每个试剂盒的检测次数",
  "catalog.item.units": "单位",
  "catalog.search.placeholder": "按物品名称或代码搜索",
  "choose.availablepanel": "选择可用面板",
  "coldStorage.action.createSuccess": "操作创建成功",
  "coldStorage.action.retractSuccess": "操作撤回成功",
  "coldStorage.action.updateSuccess": "操作更新成功",
  "coldStorage.actions": "操作",
  "coldStorage.activated": "已激活",
  "coldStorage.addDevicesMessage": "请添加设备以开始监控",
  "coldStorage.addNewDevice": "添加新设备",
  "coldStorage.alert.acknowledged": "警报已成功确认",
  "coldStorage.alert.actionFailed": "无法对警报 {alertId} 执行 {action} 操作",
  "coldStorage.alert.equipment": "设备警报",
  "coldStorage.alert.equipment.description": "设备故障或异常时发送警报",
  "coldStorage.alert.inventory": "库存警报",
  "coldStorage.alert.inventory.description": "库存水平异常时发送警报",
  "coldStorage.alert.resolved": "警报已成功解决",
  "coldStorage.alert.saveFailed": "警报保存失败",
  "coldStorage.alert.saveSuccess": "警报保存成功",
  "coldStorage.alert.temperature": "温度和湿度警报",
  "coldStorage.alert.temperature.description": "当设备温度或相对湿度超出其配置范围时触发的警报",
  "coldStorage.alert.type": "警报类型",
  "coldStorage.alertConfiguration": "警报配置",
  "coldStorage.autoEscalate": "自动升级",
  "coldStorage.button.delete": "删除",
  "coldStorage.configuredDevices": "已配置的设备",
  "coldStorage.correctiveAction.column.actionId": "操作 ID",
  "coldStorage.correctiveAction.column.created": "创建时间",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "最后更新者",
  "coldStorage.correctiveAction.column.performedBy": "执行人",
  "coldStorage.correctiveAction.edited": "已编辑",
  "coldStorage.correctiveAction.status.cancelled": "已取消",
  "coldStorage.correctiveAction.status.completed": "已完成",
  "coldStorage.correctiveAction.status.inProgress": "进行中",
  "coldStorage.correctiveAction.status.pending": "待处理",
  "coldStorage.correctiveAction.status.retracted": "已撤回",
  "coldStorage.correctiveAction.type.calibration": "校准",
  "coldStorage.correctiveAction.type.calibration.description": "校准设备或传感器",
  "coldStorage.correctiveAction.type.equipmentRepair": "设备维修",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "维修或更换设备",
  "coldStorage.correctiveAction.type.itemReorder": "物品重新订购",
  "coldStorage.correctiveAction.type.itemReorder.description": "重新订购库存物品",
  "coldStorage.correctiveAction.type.maintenance": "维护",
  "coldStorage.correctiveAction.type.maintenance.description": "执行维护任务",
  "coldStorage.correctiveAction.type.other": "其他原因",
  "coldStorage.correctiveAction.type.other.description": "其他或自定义纠正措施",
  "coldStorage.correctiveAction.type.sampleRelocation": "样本转移",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "将样本转移到另一个位置",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "温度调整",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "调整温度设置",
  "coldStorage.criticalThreshold": "临界阈值",
  "coldStorage.dashboard.acknowledge": "确认",
  "coldStorage.dashboard.activeAlerts": "活动警报（{count}）",
  "coldStorage.dashboard.column.currentTemp": "当前温度",
  "coldStorage.dashboard.column.currentTemp2": "探头 2 温度",
  "coldStorage.dashboard.column.device": "设备",
  "coldStorage.dashboard.column.duration": "时长",
  "coldStorage.dashboard.column.humidity": "湿度",
  "coldStorage.dashboard.column.lastReading": "最近读数",
  "coldStorage.dashboard.column.location": "位置",
  "coldStorage.dashboard.column.severity": "严重程度",
  "coldStorage.dashboard.column.started": "已开始",
  "coldStorage.dashboard.column.targetTemp": "目标温度",
  "coldStorage.dashboard.column.temperature": "储存温度",
  "coldStorage.dashboard.column.unitId": "单元ID",
  "coldStorage.dashboard.column.unitName": "单元名称",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} 个存储单元出现严重温度偏离",
  "coldStorage.dashboard.criticalAlertTitle": "紧急警报",
  "coldStorage.dashboard.deviceTypeFilter": "设备类型",
  "coldStorage.dashboard.kpi.critical": "紧急",
  "coldStorage.dashboard.kpi.normal": "正常状态",
  "coldStorage.dashboard.kpi.totalUnits": "存储单元总数",
  "coldStorage.dashboard.kpi.warnings": "警告",
  "coldStorage.dashboard.lastUpdate": "最后更新时间：{time}",
  "coldStorage.dashboard.loadingUnits": "正在加载存储单元……",
  "coldStorage.dashboard.noActiveAlerts": "没有活跃的警报",
  "coldStorage.dashboard.noUnitsFound": "未找到任何存储单元。",
  "coldStorage.dashboard.online": "在线",
  "coldStorage.dashboard.refresh": "刷新",
  "coldStorage.dashboard.refreshing": "正在刷新",
  "coldStorage.dashboard.refreshingEllipsis": "正在刷新……",
  "coldStorage.dashboard.searchLabel": "按单元编号或名称搜索",
  "coldStorage.dashboard.statusFilter": "状态",
  "coldStorage.dashboard.storageUnitsTitle": "存储单元",
  "coldStorage.dashboard.subtitle": "实时温度监测与合规性",
  "coldStorage.dashboard.systemStatus": "系统状态：{status}",
  "coldStorage.dashboard.tab.correctiveActions": "纠正措施",
  "coldStorage.dashboard.tab.dashboard": "仪表板",
  "coldStorage.dashboard.tab.historicalTrends": "趋势",
  "coldStorage.dashboard.tab.reports": "报告",
  "coldStorage.dashboard.tab.settings": "设置",
  "coldStorage.dashboard.viewAlertDetails": "查看警报详情",
  "coldStorage.deactivated": "已停用",
  "coldStorage.description": "描述",
  "coldStorage.device.activate": "激活设备",
  "coldStorage.device.activateMessage": "确定要激活此设备吗？",
  "coldStorage.device.changeStatus": "更改状态",
  "coldStorage.device.changeStatusOf": "更改设备状态",
  "coldStorage.device.created": "设备已创建",
  "coldStorage.device.createdSuccess": "设备创建成功",
  "coldStorage.device.deactivate": "停用设备",
  "coldStorage.device.deactivateMessage": "确定要停用此设备吗？",
  "coldStorage.device.delete": "删除设备",
  "coldStorage.device.deleteConfirm": "确定要删除此设备吗？",
  "coldStorage.device.deleteWarning": "此操作无法撤销",
  "coldStorage.device.deleted": "设备已删除",
  "coldStorage.device.deviceStatus": "设备状态",
  "coldStorage.device.edit": "编辑设备",
  "coldStorage.device.id": "设备ID",
  "coldStorage.device.ipAddress": "IP地址",
  "coldStorage.device.port": "端口",
  "coldStorage.device.protocol": "协议",
  "coldStorage.device.registerCount": "每个值的寄存器数",
  "coldStorage.device.registerCount.help": "1 表示 16 位值，2 表示跨越两个寄存器的 32 位值",
  "coldStorage.device.roomFacility": "房间/设施",
  "coldStorage.device.rs485": "RS-485 半双工（可选）",
  "coldStorage.device.rs485.delayAfter": "发送后延迟（毫秒）",
  "coldStorage.device.rs485.delayBefore": "发送前延迟（毫秒）",
  "coldStorage.device.rs485.mode": "启用 RS-485 驱动器使能定时",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS 在发送期间为高电平",
  "coldStorage.device.rs485.rxDuringTx": "发送期间保持接收器启用",
  "coldStorage.device.rs485.termination": "已启用总线终结功能",
  "coldStorage.device.secondProbe": "第二个温度探头（可选）",
  "coldStorage.device.secondProbe.offset": "基准温度 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "第二个探头的基准偏移量",
  "coldStorage.device.secondProbe.register": "温度寄存器 2",
  "coldStorage.device.secondProbe.registerHelp": "第二个独立温度传感器的 Modbus 寄存器地址。其测量值会被记录并绘制成图表；阈值警报由第一个传感器触发。",
  "coldStorage.device.secondProbe.scale": "温度标度 2",
  "coldStorage.device.secondProbe.scaleHelp": "缩放因子（例如，0.1 表示除以 10）",
  "coldStorage.device.statusChanged": "设备状态已更改",
  "coldStorage.device.type": "设备类型",
  "coldStorage.device.updated": "设备已更新",
  "coldStorage.device.wordOrder": "字序",
  "coldStorage.device.wordOrder.bigEndian": "大端序（最高有效字在前）",
  "coldStorage.device.wordOrder.help": "32位值中两个寄存器的顺序；读取单个寄存器时忽略此顺序",
  "coldStorage.device.wordOrder.littleEndian": "小端序（最低有效字在前）",
  "coldStorage.deviceHistory.averageMetric": "{metric}平均值",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "确认人 / 执行人",
  "coldStorage.deviceHistory.column.date": "日期",
  "coldStorage.deviceHistory.column.eventId": "事件 ID",
  "coldStorage.deviceHistory.column.eventType": "事件类型",
  "coldStorage.deviceHistory.column.summaryTitle": "摘要 / 标题",
  "coldStorage.deviceHistory.column.time": "时间",
  "coldStorage.deviceHistory.correctiveActions": "纠正措施",
  "coldStorage.deviceHistory.dataPoints": "数据点",
  "coldStorage.deviceHistory.exportCsv": "导出翻译",
  "coldStorage.deviceHistory.loadingEvents": "正在加载事件历史记录...",
  "coldStorage.deviceHistory.loadingTemperature": "正在加载温度数据...",
  "coldStorage.deviceHistory.maxMetric": "{metric}最大值",
  "coldStorage.deviceHistory.metric": "指标：",
  "coldStorage.deviceHistory.minMetric": "{metric}最小值",
  "coldStorage.deviceHistory.noEventsFound": "未找到任何事件。",
  "coldStorage.deviceHistory.noTemperatureData": "所选时间范围内没有可用的温度数据。",
  "coldStorage.deviceHistory.searchEvents": "搜索事件",
  "coldStorage.deviceHistory.searchPlaceholder": "按事件 ID、摘要或用户搜索……",
  "coldStorage.deviceHistory.tab.eventHistory": "事件历史",
  "coldStorage.deviceHistory.tab.temperatureTrends": "温度趋势",
  "coldStorage.deviceHistory.timeRange": "时间范围：",
  "coldStorage.deviceHistory.title": "设备历史记录 - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "警报总数",
  "coldStorage.deviceHistory.totalEvents": "事件总数",
  "coldStorage.email": "电子邮件",
  "coldStorage.emailSmsNotifications": "邮件/短信通知",
  "coldStorage.error.createAction": "创建操作失败",
  "coldStorage.error.createDevice": "创建设备失败",
  "coldStorage.error.createRoom": "创建房间失败",
  "coldStorage.error.deleteDevice": "删除设备失败",
  "coldStorage.error.loadActions": "加载操作失败",
  "coldStorage.error.loadAuditTrail": "无法加载审计跟踪",
  "coldStorage.error.loadAuditTrailDetail": "加载审计记录时发生意外错误。",
  "coldStorage.error.loadDevices": "加载设备失败",
  "coldStorage.error.loadExcursions": "无法加载温度波动记录",
  "coldStorage.error.loadExcursionsDetail": "加载温度波动记录时发生意外错误。",
  "coldStorage.error.loadFailed": "无法加载冷藏存储监控数据。",
  "coldStorage.error.loadLocations": "加载位置失败",
  "coldStorage.error.loadUsers": "加载用户失败",
  "coldStorage.error.noCurrentUser": "无法识别当前用户。请重新登录。",
  "coldStorage.error.retractAction": "撤回操作失败",
  "coldStorage.error.saveThreshold": "保存阈值失败",
  "coldStorage.error.toggleStatus": "切换状态失败",
  "coldStorage.error.updateAction": "更新操作失败",
  "coldStorage.error.updateDevice": "更新设备失败",
  "coldStorage.error.updateFailed": "无法更新冷存储数据",
  "coldStorage.escalationDelay": "升级延迟",
  "coldStorage.escalationDelayHelper": "在升级到下一级之前等待的时间",
  "coldStorage.escalationRules": "升级规则",
  "coldStorage.filter.activeOnly": "仅活跃",
  "coldStorage.filter.all": "全部",
  "coldStorage.filter.inactiveOnly": "仅停用",
  "coldStorage.footer": "冷藏存储监控 v2.1.0 | 符合 CAP、CLIA、FDA 和 WHO 指南 | 符合 HIPAA 标准的数据处理",
  "coldStorage.granularNotificationControl": "精细通知控制",
  "coldStorage.granularNotificationControlDesc": "按设备和警报类型配置通知",
  "coldStorage.howNotificationsWork": "通知工作方式",
  "coldStorage.howNotificationsWorkDesc": "当温度超出阈值时，系统将通过邮件和短信发送通知",
  "coldStorage.loadingDevices": "正在加载设备...",
  "coldStorage.loadingPrefs": "正在加载偏好设置...",
  "coldStorage.name": "名称",
  "coldStorage.noConfigFound": "未找到配置",
  "coldStorage.noDevicesConfigured": "尚未配置设备",
  "coldStorage.notification.createRecord": "创建记录",
  "coldStorage.notification.logAttempt": "记录尝试",
  "coldStorage.notification.sendEmail": "发送邮件",
  "coldStorage.notification.sendSms": "发送短信",
  "coldStorage.pollInterval": "轮询间隔",
  "coldStorage.reports.column.action": "操作",
  "coldStorage.reports.column.details": "详情",
  "coldStorage.reports.column.excursionId": "温度波动编号",
  "coldStorage.reports.column.freezer": "冰箱",
  "coldStorage.reports.column.freezerId": "冰箱编号",
  "coldStorage.reports.column.startTime": "开始时间",
  "coldStorage.reports.column.temperatureRange": "温度范围",
  "coldStorage.reports.column.timestamp": "时间戳",
  "coldStorage.reports.column.user": "用户",
  "coldStorage.reports.downloadReport": "下载 {format} 报告",
  "coldStorage.reports.endDate": "结束日期",
  "coldStorage.reports.excursionHistory": "储存温度波动历史",
  "coldStorage.reports.exportFormat": "导出格式",
  "coldStorage.reports.footer": "冷藏存储监控 v2.1.0 | 符合 CAP、CLIA、FDA 和 WHO 标准 | 符合 HIPAA 要求的数据处理",
  "coldStorage.reports.freezer": "冰箱",
  "coldStorage.reports.generateReport": "生成报告",
  "coldStorage.reports.loadingAudit": "正在加载审计条目……",
  "coldStorage.reports.loadingExcursions": "正在加载温度波动记录……",
  "coldStorage.reports.noAuditActivity": "根据已选择的筛选条件，没有审计活动。",
  "coldStorage.reports.noAuditMatch": "没有符合您搜索条件的审计条目。",
  "coldStorage.reports.noExcursions": "根据已选择的筛选条件，没有可用的温度波动记录。",
  "coldStorage.reports.regulatoryCompliance": "合规",
  "coldStorage.reports.regulatoryComplianceDesc": "报告遵循美国病理学家学会（CAP）、《临床实验室改进修正案》（CLIA）、美国食品药品监督管理局（FDA）以及世界卫生组织（WHO）关于温控存储的指导方针。",
  "coldStorage.reports.reportType": "报告类型",
  "coldStorage.reports.searchAuditTrail": "搜索审计跟踪...",
  "coldStorage.reports.startDate": "开始日期",
  "coldStorage.reports.tab.auditTrail": "审计跟踪",
  "coldStorage.reports.tab.excursions": "温度波动",
  "coldStorage.reports.title": "监管报告",
  "coldStorage.room.addNew": "添加新房间",
  "coldStorage.room.create": "创建房间",
  "coldStorage.room.created": "房间已创建",
  "coldStorage.room.description": "房间描述",
  "coldStorage.room.descriptionPlaceholder": "输入房间描述",
  "coldStorage.room.name": "房间名称",
  "coldStorage.room.namePlaceholder": "输入房间名称",
  "coldStorage.saveNotificationPrefs": "保存通知偏好",
  "coldStorage.saveThresholdConfig": "保存阈值配置",
  "coldStorage.saving": "正在保存...",
  "coldStorage.search.placeholder": "搜索设备...",
  "coldStorage.selectType": "选择设备类型",
  "coldStorage.sms": "短信",
  "coldStorage.status": "状态",
  "coldStorage.status.active": "活跃",
  "coldStorage.status.inactive": "停用",
  "coldStorage.status.noData": "无数据",
  "coldStorage.status.offline": "离线",
  "coldStorage.status.unknown": "未知",
  "coldStorage.supervisorEmail": "主管邮箱",
  "coldStorage.supervisorEmailHelper": "温度警报将发送到此邮箱",
  "coldStorage.supervisorEmailPlaceholder": "输入主管邮箱地址",
  "coldStorage.targetTemperature": "目标温度",
  "coldStorage.threshold.saveSuccess": "阈值保存成功",
  "coldStorage.thresholdConfiguration": "阈值配置",
  "coldStorage.trends.averageMetric": "平均值 {metric}",
  "coldStorage.trends.axis.humidity": "湿度（%）",
  "coldStorage.trends.axis.temperature": "储存温度（°C）",
  "coldStorage.trends.axis.temperature2": "储存温度 - 探头 2（°C）",
  "coldStorage.trends.maxMetric": "最大值 {metric}",
  "coldStorage.trends.metric": "指标",
  "coldStorage.trends.metric.humidity": "湿度",
  "coldStorage.trends.metric.temperature": "储存温度",
  "coldStorage.trends.metric.temperature2": "储存温度（探头 2）",
  "coldStorage.trends.minMetric": "最小值 {metric}",
  "coldStorage.usingDefaults": "使用默认值",
  "coldStorage.validation.error": "验证错误",
  "coldStorage.validation.retractionReason": "请输入撤回原因",
  "coldStorage.validation.selectActionType": "请选择操作类型",
  "coldStorage.validation.selectDevice": "请选择设备",
  "coldStorage.validation.selectRoom": "请选择房间",
  "coldStorage.warningThreshold": "警告阈值",
  "collect.addSample.button": "添加样本",
  "collect.assign.addToSample": "添加到现有样本中",
  "collect.assign.button": "分配检测",
  "collect.assign.description": "将所需检测项目分配到样本管中",
  "collect.assign.newSample": "创建新样本",
  "collect.assign.newSampleHelp": "为新试管选择样本类型",
  "collect.assign.noExisting": "无可用的现有样本",
  "collect.assign.title": "检测分配",
  "collect.multiSampleExample.description": "当需要多种样本类型时",
  "collect.multiSampleExample.result": "为每种样本类型创建单独的试管",
  "collect.multiSampleExample.title": "多样本采集示例",
  "collect.noSampleYet": "尚未采集任何样本",
  "collect.noCompatibleSampleTypes": "检测目录中尚未为此检测设置样本类型",
  "collect.noTestsOrdered": "尚未安排任何检测项目",
  "collect.noTestsWarning.subtitle": "在继续操作之前，请在步骤 1 中添加附带检测项目的样本",
  "collect.noTestsWarning.title": "没有需要采集的检测项目",
  "collect.requestedTests.info": "此订单所需的检测项目",
  "collect.requestedTests.title": "要求进行的检测项目",
  "collect.sample.assignedTests": "检测",
  "collect.sample.collectionConditions": "采集条件",
  "collect.sample.collectionConditions.placeholder": "备注任何特殊情况……",
  "collect.sample.collectionDate": "采集日期",
  "collect.sample.collectionMethod": "采集方式",
  "collect.addTests.title": "添加检测或面板",
  "collect.addTests.helper": "添加订单录入后临床医生要求的检测，或在拿到标本后才适合的检测。",
  "collect.consentRequired.title": "需要知情同意",
  "collect.consentRequired.subtitle": "本实验室要求在采集前记录知情同意。",
  "sample.holdingLimit": "保存时限：{limit}",
  "sample.holdingLimit.testBy": "须在 {deadline} 前检测",
  "env.sample.receivedAtLab": "实验室已接收",
  "collect.sample.specimenOrigin": "标本来源",
  "collect.sample.temperature": "样本温度",
  "collect.sample.temperature.placeholder": "例如 4 C",
  "collect.sample.collectionDate.helper": "默认为今天；如果样本是在更早时间采集的，请更正",
  "collect.sample.collectionTime": "采集时间",
  "collect.sample.collector": "采集人",
  "collect.sample.header": "样本 {number}",
  "collect.sample.labPerformedSampling": "实验室进行的采样",
  "collect.sample.nce.link": "报告不符合事件",
  "collect.sample.noTests": "此样本未分配任何检测项目",
  "collect.sample.printLabels": "打印条码",
  "collect.printMoreLabels.helper": "采集量超出预期，或需要其他样本类型？请使用“添加样本”，然后从样本卡片或“标签”部分打印其标签。",
  "collect.sample.quantity": "数量",
  "collect.sample.receivedAtLab": "实验室已接收",
  "collect.sample.receivedAtLab.helper": "确认实验室是否已接收样本",
  "collect.sample.receivedDate": "接收日期",
  "collect.sample.receivedTime": "接收时间",
  "collect.sample.remove": "移除样本",
  "collect.samples.title": "样本",
  "collect.table.compatibleTypes": "兼容的样本类型",
  "collect.table.sampleAssignments": "样本分配",
  "collect.table.testPanel": "检测项目/组合",
  "heading.informedConsent.sectionTitle": "知情同意书",
  "heading.informedConsent.auditRecord": "知情同意审核记录",
  "label.informedConsent.consentGiven": "患者已签署知情同意书",
  "label.informedConsent.formReference": "知情同意书参考编号",
  "label.informedConsent.recordedBy": "记录人",
  "label.informedConsent.recordedAt": "记录于",
  "label.informedConsent.statusTag": "已记录同意",
  "label.informedConsent.notRecorded": "未记录",
  "placeholder.informedConsent.formReference": "例如：CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "例如：史密斯医生",
  "error.informedConsent.formReferenceMaxLength": "知情同意书的参考编号必须在100个字符以内",
  "error.informedConsent.formReferenceInvalidChars": "仅允许使用字母、数字、连字符和空格",
  "coldstorage.label.dashboard": "冷藏存储仪表板",
  "collection.date": "采集日期",
  "collector": "采集人",
  "collector.label": "采集人",
  "column.actions": "操作",
  "column.name.accept": "接受",
  "column.name.analyzerResult": "分析仪结果",
  "column.name.currentResult": "当前结果",
  "column.name.ignore": "忽略",
  "column.name.normalRange": "正常范围",
  "column.name.notes": "备注",
  "column.name.pastNotes": "历史备注",
  "column.name.qcDetail": "详情",
  "column.name.qcStatus": "QC状态",
  "column.name.reject": "拒绝",
  "column.name.result": "结果",
  "column.name.retest": "重新检测",
  "column.name.sampleInfo": "样本信息",
  "column.name.sampleKind": "样本类型",
  "column.name.save": "保存",
  "column.name.statusPerRegulation": "状态 — 根据规定",
  "column.name.testDate": "检测日期",
  "column.name.testId": "检测ID",
  "column.name.testName": "检测名称",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "代码必须至少包含一个字母、数字或下划线。",
  "common.properties.title": "通用属性",
  "configuration.batch.test.reassignment": "批量检测重新分配和取消",
  "configuration.method": "管理方法",
  "configuration.method.create": "创建新方法",
  "configuration.testCatalog.tests.explain": "创建、编辑、重命名、启用检测项目并设置其可订购性，包括参考范围、结果选项、方法和标签",
  "configuration.testCatalog.panels.explain": "创建和编辑面板，分配其检测项目并设置显示顺序",
  "configuration.testCatalog.sampleTypes.explain": "创建和编辑样本类型，分配检测项目并设置显示顺序",
  "configuration.testCatalog.labUnits.explain": "创建和编辑实验室单元并分配其检测项目",
  "configuration.testCatalog.import.explain": "从 CSV 文件加载检测项目、面板、样本类型和实验室单元",
  "configuration.testCatalog.methods.explain": "添加方法；新方法在被检测项目使用后即变为启用状态",
  "configuration.selectList.add": "添加结果选择列表",
  "configuration.selectList.add.alert": "要更改当前结果列表条目的拼写，请使用重命名现有结果列表选项",
  "configuration.selectList.add.explain": "用于为检测结果创建结果选择列表",
  "configuration.selectList.rename": "重命名现有结果列表选项",
  "configuration.selectList.rename.explain": "重命名现有结果列表选项",
  "configuration.test.activate": "激活/停用检测",
  "configuration.test.activate.explain": "用于激活或停用现有检测。",
  "configuration.test.catalog": "查看检测目录",
  "configuration.test.catalog.explain": "查看当前检测目录",
  "configuration.test.orderable": "启用/禁用检测可订购性",
  "configuration.test.orderable.explain": "可订购的检测可以在收样时订购。如果不可订购，则只能作为反射结果订购",
  "configuration.testCatalog.uom.explain": "列出测量单位并更正其名称、代码和 UCUM 代码",
  "configuration.uom.title": "测量单位",
  "configuration.uom.explain": "报告数值结果所用的单位。编辑检测项目时也可以创建单位。",
  "configuration.uom.add": "添加单位",
  "configuration.uom.edit": "编辑单位",
  "configuration.uom.empty": "没有匹配的测量单位",
  "method.modal.edit.heading": "编辑方法",
  "configuration.method.create.duplicate": "已存在同名方法。请使用其他名称。",
  "configuration.panel.assign": "检测分配",
  "configuration.panel.assign.explain": "通过点击检测名称选择要重新分配到不同面板的检测；它们显示在当前分配的面板下。",
  "configuration.panel.confirmation.explain": "在至少分配一个检测之前，此面板不会激活。",
  "configuration.panel.create": "创建新面板",
  "configuration.panel.create.duplicate": "已找到具有相同名称的现有面板类型。请取消或使用不同的名称。",
  "configuration.panel.order": "设置面板顺序",
  "configuration.panel.order.explain": "通过点击类型并将其拖动到适当顺序来对面板进行排序。",
  "configuration.panel.order.explain.limits": "只有分配了检测的面板才能排序。对于新面板，请在排序前分配检测。",
  "configuration.sampleType.assign.explain": "通过点击检测名称选择要重新分配到不同样本类型的检测；它们显示在当前分配的样本类型下。",
  "configuration.sampleType.assign.new.type": "分配到样本类型",
  "configuration.sampleType.confirmation.explain": "在至少分配一个检测之前，此样本类型不会激活。",
  "configuration.sampleType.create": "创建新样本类型",
  "configuration.sampleType.create.duplicate": "已找到具有相同名称的现有检测样本类型。请取消或使用不同的名称。",
  "configuration.sampleType.manage": "管理样本类型",
  "configuration.sampleType.manage.explain": "用于创建、设置显示顺序或为样本类型分配检测",
  "configuration.sampleType.order": "设置样本类型顺序",
  "configuration.sampleType.order.explain": "通过点击类型并将其拖动到适当顺序来对样本类型进行排序。",
  "configuration.sampleType.order.explain.limits": "只有分配了检测的样本类型才能排序。对于新类型，请在排序前分配检测。",
  "configuration.selectList.assign.description": "新条目可以分配给检测，也可以不分配保存。选择一个或多个检测进行分配，然后调整显示顺序。如果新条目应该是所选检测的正常范围值，请选中标记为`正常`的框。如果希望技术人员在结果选择中输入文本以进一步限定结果，请选中标记为`可限定`的框，例如；如果选项是生物体列表，最后一个选项是`其他`，那么用户可以输入列表中没有的生物体。",
  "configuration.selectList.assign.header": "将新结果选择分配给检测",
  "configuration.selectList.assign.new": "新选择列表选项",
  "configuration.selectList.confirmChange": "正常值将从 %oldvalue% 更改为 %newvalue%，您确定要继续吗？",
  "configuration.selectList.description": "输入新选择选项的英文和法文。如果您不知道翻译，则输入的术语将用于两种语言。",
  "configuration.selectList.header": "创建新结果选择选项",
  "configuration.test.management.ocl": "OCL概念导入",
  "configuration.test.management.organization": "检测组织",
  "configuration.test.modify.tab.configuration": "配置",
  "configuration.test.modify.tab.compliance": "合规阈值",
  "configuration.test.modify.filter.instruction": "选择样本类型或检测科室以显示检测。",
  "configuration.test.modify.filter.noTestsFound": "没有找到匹配所选标准的检测。",
  "configuration.test.modify.filter.selectToBegin": "请选择样本类型或检测科室开始查看检测。",
  "configuration.testUnit.assign.new.unit": "分配到检测科室",
  "configuration.testUnit.confirmation.explain": "在至少分配一个检测之前，此检测单元不会激活。",
  "configuration.testUnit.create": "创建新检测单元",
  "configuration.testUnit.create.duplicate": "已找到具有相同名称的现有检测单元。请取消或使用不同的名称。",
  "configuration.testUnit.order": "设置检测单元顺序",
  "configuration.testUnit.order.explain": "通过点击单元并将其拖动到适当顺序来对实验室单元进行排序。",
  "configuration.testUnit.order.explain.limits": "只有分配了检测的检测科室才能排序。对于新科室，请在排序前分配检测。",
  "heading.sampleType.management": "样本类型编辑器",
  "heading.sampleType.subtitle": "配置样本类型、显示顺序、检测关联以及领域分类。",
  "heading.sampleType.editing": "编辑中",
  "label.sampleType.domain": "样本领域",
  "label.domain.CLINICAL": "临床",
  "label.domain.ENVIRONMENTAL": "环境",
  "label.domain.VECTOR": "病媒",
  "label.sampleType.domain.clinical": "临床",
  "label.sampleType.domain.environmental": "环境",
  "label.sampleType.domain.helper": "确定该样本类型出现在哪种工作流模式（临床或环境）中。",
  "label.sampleType.filterDomain": "按领域筛选",
  "label.sampleType.testCount": "检测项目",
  "label.sampleType.actions": "操作",
  "label.sampleType.status": "状态",
  "placeholder.sampleType.search": "搜索样本类型...",
  "placeholder.sampleType.filter.domain": "所有领域",
  "button.sampleType.add": "添加样本类型",
  "configuration.uom.create": "创建新的测量单位",
  "configure.labNumber.title": "实验室编号管理",
  "confirmation.rename": "确认您上面所做的更改。",
  "currentests.title": "当前检测",
  "cytology.label.cellabnomality": "上皮细胞异常",
  "cytology.label.confirmSelect": "如果您选择此选项，所有当前诊断信息将被移除",
  "cytology.label.dashboard": "细胞学仪表板",
  "cytology.label.glandular": "腺上皮",
  "cytology.label.negative": "无上皮内病变或恶性肿瘤",
  "cytology.label.neoplastic": "非肿瘤性细胞变异",
  "cytology.label.organisms": "生物体",
  "cytology.label.other": "其他恶性肿瘤",
  "cytology.label.otherResult": "其他诊断结果",
  "cytology.label.reactive": "反应性细胞变化",
  "cytology.label.review": "等待细胞病理学家审查",
  "cytology.label.specimen": "标本充分性",
  "cytology.label.squamous": "鳞状",
  "cytology.label.title": "细胞学",
  "cytology.status.completed": "已完成",
  "cytology.status.preparingSlides": "正在制片",
  "cytology.status.readyForCytopathologist": "待细胞病理学家处理",
  "cytology.status.screening": "筛查中",
  "dashboard.avg.turn.around.label": "平均周转时间",
  "dashboard.avg.turn.around.reception.to.result.label": "从接收至结果的平均时间",
  "dashboard.avg.turn.around.reception.to.validation.label": "从接收至审核的平均时间",
  "dashboard.avg.turn.around.result.to.validation.label": "从结果至审核的平均时间",
  "dashboard.avg.turn.around.subtitle.label": "接收至验证",
  "dashboard.complete.orders.label": "今日完成订单",
  "dashboard.in.progress.label": "进行中",
  "dashboard.in.progress.subtitle.label": "等待结果录入",
  "dashboard.metrics.loadFailed": "无法加载仪表板计数。",
  "dashboard.partially.completed.label": "今日部分完成",
  "dashboard.partially.completed.subtitle.label": "等待剩余检测项目",
  "dashboard.rejected.orders": "今日已拒绝订单",
  "dashboard.turn.around.label": "延迟周转",
  "dashboard.turn.around.subtitle.label": "超过96小时",
  "dashboard.unprints.results.label": "今日未打印结果",
  "dashboard.user.orders.label": "今日用户录入的订单",
  "dashboard.user.orders.today.label": "今日用户录入的订单",
  "dashboard.user.ordersEntered": "已录入订单",
  "dashboard.validation.ready.label": "准备验证",
  "dashboard.validation.ready.subtitle.label": "等待审查",
  "dataexport.status.actions": "操作",
  "dataexport.status.attempt.duration": "时长",
  "dataexport.status.attempt.endTime": "结束时间",
  "dataexport.status.attempt.startTime": "开始时间",
  "dataexport.status.attempt.status": "状态",
  "dataexport.status.duration.ms": "{value} 毫秒",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "尚未配置任何 FHIR 订阅者。请在 common.properties 文件中设置 org.openelisglobal.fhir.subscriber，并重启服务器以注册一个订阅者。",
  "dataexport.status.endpoint": "端点",
  "dataexport.status.failed24h": "失败数量 / 总计（24小时）",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "重试间隔",
  "dataexport.status.intervalValue": "{value} 分钟",
  "dataexport.status.lastAttempt": "最后一次尝试",
  "dataexport.status.lastRefreshed": "最后更新时间",
  "dataexport.status.lastStatus": "最新状态",
  "dataexport.status.lastSuccess": "最近的成功",
  "dataexport.status.loadingAttempts": "正在加载尝试记录……",
  "dataexport.status.never": "从未",
  "dataexport.status.noAttempts": "尚未尝试",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "刷新",
  "dataexport.status.retry": "现在重试",
  "dataexport.status.retryInFlight": "正在触发……",
  "dataexport.status.title": "FHIR 数据导出状态",
  "datasubmission.siteid": "站点ID",
  "database.clean": "数据库清理",
  "database.clean.button": "清理数据库",
  "database.clean.confirm.message": "确定要清理数据库吗？此操作将删除所有非必要的演示数据。",
  "database.clean.confirm.title": "确认数据库清理",
  "database.clean.confirm.warning": "警告：此操作不可逆！",
  "database.clean.error": "数据库清理失败",
  "database.clean.not.training": "此功能仅在培训/演示模式下可用",
  "database.clean.success": "数据库清理成功",
  "database.clean.warning": "此操作将永久删除数据，请谨慎操作",
  "date.created": "创建日期",
  "datepicker.future.notAllowed": "日期不能是将来的日期。",
  "datepicker.past.notAllowed": "日期不能是过去的日期。",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "删除时出错",
  "delete.success.msg": "删除成功",
  "description.active": "如果检测处于活跃状态，它可以在订单表单上订购或作为检测算法的一部分。如果不活跃，则不能订购或作为检测算法的一部分",
  "description.ageRange": "如果年龄范围(以月为单位)对给定值很重要，将在此处指定。",
  "description.name": "检测在openELIS中显示的名称。显示英文和法文",
  "description.normalRange": "此范围内的任何数值结果都是健康人的预期结果。",
  "description.note": "n/a表示不可用。未指定值。",
  "description.orderable": "如果检测处于活跃状态且可订购，则可以在订单表单上订购。如果它处于活跃状态但不可订购，则只有当它从另一个检测反射时才会执行",
  "description.panel": "如果此检测是检测面板的一部分，则面板将在此处命名。",
  "description.referenceValue": "健康人的选择值。仅针对选择列表结果提供。",
  "description.reportName": "检测在报告中显示的名称。显示英文和法文",
  "description.resultLimits": "数值检测的正常和有效结果的限制。这些值可以取决于患者的年龄和性别。",
  "description.resultType": "此检测的结果类型：",
  "description.resultType.alphanumeric": "A - 字母数字：",
  "description.resultType.alphanumericDesc": "在文本框中接受数字或文本。不会评估是否为正常或有效。",
  "description.resultType.cascadingMultiSelectList": "C - 级联多选列表：",
  "description.resultType.cascadingMultiSelectListDesc": "类似于多选，但用户将能够从下拉列表中选择多个组。",
  "description.resultType.kind": "此检测的结果类型：",
  "description.resultType.multiSelectList": "M - 多选列表：",
  "description.resultType.multiSelectListDesc": "用户将能够从下拉列表中选择一个或多个值。不会指定参考值。",
  "description.resultType.numeric": "N - 数值：",
  "description.resultType.numericDesc": "在文本框中只接受数值结果。可以评估结果是否在正常或有效范围内。",
  "description.resultType.selectList": "D - 选择列表：",
  "description.resultType.selectListDesc": "用户将能够从下拉列表中选择。正常值将指定为参考值。",
  "description.resultType.textArea": "R-自由文本：",
  "description.resultType.textAreaDesc": "在文本区域中最多接受200个字符。不会评估是否为正常或有效。",
  "description.sampleType": "可以进行检测的样本类型。如果录入技术人员能够在订购检测后选择样本类型，它将被标记为用户，表明用户将选择类型",
  "description.selectValues": "仅针对选择、多选或级联多选结果指定。这些是向用户显示的可用选择。如果选择标记为'可限定'，则当用户选择该值时，他们将能够在文本框中输入附加信息。",
  "description.sex": "如果患者的性别对给定值很重要，将在此处指定。",
  "description.significantDigits": "数值结果的有效位数。输入的结果将四舍五入或填充到正确的位数。正常范围也将以正确的有效位数显示。",
  "description.testUnit": "实验室的哪个部门执行检测。这也称为检测科室。",
  "description.uom": "检测的测量单位。这通常仅适用于数值或字母数字结果类型。",
  "description.validRange": "任何不在此范围内的数值结果都表明检测可能没有正确完成。",
  "dictionary.category.isActive": "是否活跃",
  "dictionary.category.label": "词典类别",
  "dictionary.category.localAbbreviation": "本地缩写",
  "dictionary.category.name": "类别",
  "dictionary.dictEntry": "字典条目",
  "dictionary.error.dictEntryRequired": "Enter the dictionary entry.",
  "dictionary.error.localAbbreviationRequired": "Enter a local abbreviation.",
  "dictionary.error.localAbbreviationTooLong": "A local abbreviation has at most 60 characters.",
  "dictionary.label.modify": "字典菜单",
  "dictionary.loincCode": "LOINC代码",
  "dictionary.loincCode.help": "输入标准LOINC标识符",
  "dictionary.loincCode.helpText": "标准实验室观察标识符",
  "dictionary.loincCode.invalid": "无效的LOINC格式(预期: 12345-6 或 LP12345-6)",
  "dictionary.loincCode.placeholder": "例如: 12345-6",
  "dictionary.menu.deactivate.fail": "字典菜单停用失败",
  "dictionary.menu.deactivate.success": "字典菜单停用成功",
  "dictionary.modal.add.heading": "添加词典",
  "dictionary.modal.edit.heading": "编辑词典",
  "dictionary.number.label": "词典编号",
  "disposal.button": "处置批次",
  "disposal.notes": "处置备注",
  "disposal.notes.placeholder": "提供处置详细信息（处置方法、见证人等）",
  "disposal.reason": "处置原因",
  "disposal.reason.select": "选择原因",
  "disposal.success": "批次处置成功",
  "disposal.title": "处置批次",
  "disposal.warning.message": "此操作无法撤销。批次将被标记为已处置并从活跃库存中移除。",
  "disposal.warning.title": "警告",
  "emergencyContactInfo.title": "紧急联系信息",
  "english.current": "英文当前",
  "english.label": "英文",
  "enterText.label": "输入文本",
  "eorder.allInfo": "全部信息",
  "eorder.button.editOrder": "编辑订单",
  "eorder.button.enterOrder": "录入订单",
  "eorder.buttons": " ",
  "eorder.date.end": "结束日期",
  "eorder.date.start": "开始日期",
  "eorder.facility.requesting": "请求设施",
  "eorder.header": "搜索传入检测请求",
  "eorder.id.national": "国家ID",
  "eorder.id.subjectNumber": "受试者编号",
  "eorder.instructions.enter1": "匹配搜索的检测请求 - 在",
  "eorder.instructions.enter2": "菜单中，添加实验室编号并选择",
  "eorder.instructions.enter3": "以接受订单原样，或选择",
  "eorder.instructions.enter4": "进行更改",
  "eorder.labNumber": "实验室编号",
  "eorder.labnumber.referring": "转诊实验室编号",
  "eorder.name.first": "名",
  "eorder.name.last": "姓",
  "eorder.passport.number": "护照号码",
  "eorder.priority": "优先级",
  "eorder.requestDate": "请求日期",
  "eorder.search.noresults": "没有电子订单",
  "eorder.search1.text": "按姓氏、国家ID号、转诊实验室的实验室编号或护照号码搜索",
  "eorder.search2.text": "按日期和状态搜索 输入检测请求的日期范围。这将按转诊日期或电子请求的订单日期搜索",
  "eorder.searchValue": "搜索值",
  "eorder.status": "状态",
  "eorder.test.name": "检测名称",
  "eqa.action.deactivate": "停用",
  "eqa.action.edit": "编辑",
  "eqa.action.enterResults": "录入结果",
  "eqa.action.enterViewResults": "输入/查看结果",
  "eqa.action.reactivate": "重新激活",
  "eqa.action.viewOrder": "查看订单",
  "eqa.action.viewResults": "查看结果",
  "eqa.admin.addProgram": "添加计划",
  "eqa.admin.col.actions": "操作",
  "eqa.admin.col.category": "类别",
  "eqa.admin.col.frequency": "频率",
  "eqa.admin.col.participants": "参与者",
  "eqa.admin.col.programName": "计划名称",
  "eqa.admin.col.provider": "提供者",
  "eqa.admin.delete": "删除",
  "eqa.admin.form.addHeading": "添加新的室间质评计划",
  "eqa.admin.form.category.placeholder": "选择类别",
  "eqa.admin.form.description.placeholder": "计划描述和目标……",
  "eqa.admin.form.editHeading": "编辑室间质评计划",
  "eqa.admin.form.frequency.placeholder": "选择频率",
  "eqa.admin.form.name.placeholder": "输入计划名称",
  "eqa.admin.form.provider.placeholder": "运行该计划的机构名称",
  "eqa.admin.form.subtitle": "注册新的室间质评计划",
  "eqa.admin.programs.subtitle": "管理已注册的室间质评计划和提供者",
  "eqa.admin.programs.title": "室间质评计划",
  "eqa.admin.provider.placeholder": "选择提供者",
  "eqa.admin.subtitle": "管理室间质评计划",
  "eqa.admin.tab.participants": "参与者",
  "eqa.admin.tab.userManagement": "用户管理",
  "eqa.admin.tile.acrossAllPrograms": "所有计划",
  "eqa.admin.tile.activePrograms": "活跃计划",
  "eqa.admin.tile.canManageEqa": "可管理EQA",
  "eqa.admin.tile.enrolledParticipants": "已注册参与者",
  "eqa.admin.tile.systemUsers": "系统用户",
  "eqa.admin.tile.totalParticipants": "参与者总数",
  "eqa.admin.tile.totalPrograms": "共 {count} 个计划",
  "eqa.admin.title": "计划管理",
  "eqa.admin.userManagement.placeholder": "搜索用户...",
  "eqa.column.actions": "操作",
  "eqa.deadline.label": "截止日期",
  "eqa.distribution.action.continue": "继续",
  "eqa.distribution.action.ship": "发运",
  "eqa.distribution.action.track": "跟踪",
  "eqa.distribution.action.viewReport": "查看报告",
  "eqa.distribution.advance": "推进分发",
  "eqa.distribution.backToDashboard": "返回概览",
  "eqa.distribution.barcodes": "条码",
  "eqa.distribution.col.actions": "操作",
  "eqa.distribution.col.deadline": "截止日期",
  "eqa.distribution.col.participants": "参与者",
  "eqa.distribution.col.program": "计划",
  "eqa.distribution.col.responses": "回复数",
  "eqa.distribution.col.round": "轮次",
  "eqa.distribution.col.samples": "样本",
  "eqa.distribution.col.shipmentId": "发货编号",
  "eqa.distribution.col.status": "状态",
  "eqa.distribution.create": "创建分发",
  "eqa.distribution.createError": "创建分发失败",
  "eqa.distribution.createShipment": "创建发货",
  "eqa.distribution.createSuccess": "分发创建成功",
  "eqa.distribution.dashboard.subtitle": "管理和跟踪EQA分发",
  "eqa.distribution.dashboard.title": "分发仪表板",
  "eqa.distribution.deadline": "截止日期",
  "eqa.distribution.detail.title": "分发详情",
  "eqa.distribution.empty": "暂无分发记录",
  "eqa.distribution.filter.allShipments": "所有发货",
  "eqa.distribution.filter.program": "项目",
  "eqa.distribution.filter.status": "状态",
  "eqa.distribution.list.title": "分发列表",
  "eqa.distribution.manageParticipants": "管理参与者",
  "eqa.distribution.name": "分发名称",
  "eqa.distribution.name.placeholder": "输入分发名称",
  "eqa.distribution.network.active": "活跃",
  "eqa.distribution.network.active.sub": "当前活跃的参与者",
  "eqa.distribution.network.responseRate": "响应率",
  "eqa.distribution.network.responseRate.sub": "参与者响应率",
  "eqa.distribution.network.subtitle": "网络概览",
  "eqa.distribution.network.title": "参与者网络",
  "eqa.distribution.network.total": "总计",
  "eqa.distribution.network.total.sub": "参与者总数",
  "eqa.distribution.participants": "参与者",
  "eqa.distribution.participants.min": "最少参与者",
  "eqa.distribution.participants.none": "目前尚无实验室有效注册此计划。",
  "eqa.distribution.participants.select": "选择参与者",
  "eqa.distribution.program": "项目",
  "eqa.distribution.program.select": "选择项目",
  "eqa.distribution.responseRate": "响应率",
  "eqa.distribution.shipments.subtitle": "查看和管理发货",
  "eqa.distribution.shipments.title": "发货",
  "eqa.distribution.shipped": "已发货",
  "eqa.distribution.status.completed": "已完成",
  "eqa.distribution.status.draft": "草稿",
  "eqa.distribution.status.prepared": "已准备",
  "eqa.distribution.status.shipped": "已发货",
  "eqa.distribution.step.confirmation": "确认",
  "eqa.distribution.step.details": "详情",
  "eqa.distribution.step.participants": "参与者",
  "eqa.distribution.summary.completed": "已完成",
  "eqa.distribution.summary.completed.sub": "已完成的分发",
  "eqa.distribution.summary.draft": "草稿",
  "eqa.distribution.summary.draft.sub": "草稿中的分发",
  "eqa.distribution.summary.participants": "参与者",
  "eqa.distribution.summary.participants.sub": "参与者总数",
  "eqa.distribution.summary.shipped": "已发货",
  "eqa.distribution.summary.shipped.sub": "已发货的分发",
  "eqa.enrollment.allStatuses": "所有状态",
  "eqa.enrollment.alreadyEnrolled": "已注册",
  "eqa.enrollment.alreadyEnrolledCount": "已注册数量",
  "eqa.enrollment.confirmWithdraw": "确认退出",
  "eqa.enrollment.created.success": "计划注册已成功创建",
  "eqa.enrollment.deactivated": "已停用",
  "eqa.enrollment.description": "描述",
  "eqa.enrollment.district": "地区",
  "eqa.enrollment.editing": "编辑中",
  "eqa.enrollment.empty": "此计划暂无注册记录",
  "eqa.enrollment.enroll": "注册",
  "eqa.enrollment.enrollParticipant": "注册参与者",
  "eqa.enrollment.enrollSelected": "注册所选",
  "eqa.enrollment.enrollmentDate": "注册日期",
  "eqa.enrollment.error": "注册未保存。请重试。",
  "eqa.enrollment.labUnits": "实验室科室",
  "eqa.enrollment.new": "新建室间质评计划注册",
  "eqa.enrollment.organizationCode": "机构代码",
  "eqa.enrollment.organizationName": "机构名称",
  "eqa.enrollment.panels": "检测面板",
  "eqa.enrollment.programName": "计划名称",
  "eqa.enrollment.programName.placeholder": "输入计划名称",
  "eqa.enrollment.provider": "供应商",
  "eqa.enrollment.provider.placeholder": "输入提供者名称",
  "eqa.enrollment.reactivate": "重新激活",
  "eqa.enrollment.reactivated": "已重新激活",
  "eqa.enrollment.save": "保存",
  "eqa.enrollment.saveChanges": "保存更改",
  "eqa.enrollment.searchOrgs": "搜索机构",
  "eqa.enrollment.searchPlaceholder": "搜索...",
  "eqa.enrollment.selectLabUnits": "选择实验室科室",
  "eqa.enrollment.selectOrg": "选择机构",
  "eqa.enrollment.selectOrgsPrompt": "请选择要注册的机构",
  "eqa.enrollment.selectPanels": "选择检测面板",
  "eqa.enrollment.selectProgram": "选择计划",
  "eqa.enrollment.selectProgramPrompt": "选择一个计划以查看注册记录",
  "eqa.enrollment.selectTests": "选择检测",
  "eqa.enrollment.selected": "已选择",
  "eqa.enrollment.status": "状态",
  "eqa.enrollment.status.active": "活跃",
  "eqa.enrollment.status.suspended": "已暂停",
  "eqa.enrollment.status.withdrawn": "已退出",
  "eqa.enrollment.success": "注册成功",
  "eqa.enrollment.suspend": "暂停",
  "eqa.enrollment.tests": "检测",
  "eqa.enrollment.thisLab": "本实验室",
  "eqa.enrollment.updated.success": "计划注册已成功更新",
  "eqa.enrollment.withdraw": "退出",
  "eqa.enrollment.withdrawReason": "退出原因",
  "eqa.enrollment.withdrawReasonPlaceholder": "请输入退出原因",
  "eqa.filter.allPriorities": "所有优先级",
  "eqa.filter.allPrograms": "所有项目",
  "eqa.filter.allStatuses": "所有状态",
  "eqa.filter.eqaOnly": "仅EQA",
  "eqa.filter.priority": "优先级",
  "eqa.filter.program": "项目",
  "eqa.filter.status": "状态",
  "eqa.management.action.enterResults": "录入结果",
  "eqa.management.action.submit": "提交",
  "eqa.management.bulkUpload": "批量上传",
  "eqa.management.col.accession": "登记号",
  "eqa.management.col.actions": "操作",
  "eqa.management.col.deadline": "截止日期",
  "eqa.management.col.progress": "进度",
  "eqa.management.col.provider": "供应商",
  "eqa.management.col.sampleId": "样本编号",
  "eqa.management.col.status": "状态",
  "eqa.management.daysLeft": "剩余天数",
  "eqa.management.distributions.title": "分发管理",
  "eqa.management.filter.allSamples": "所有样本",
  "eqa.management.overdue": "已逾期",
  "eqa.management.participants.subtitle": "管理机构在室间质评计划中的注册",
  "eqa.management.participants.title": "参与者管理",
  "eqa.management.performance.onTime": "按时完成",
  "eqa.management.performance.participation": "参与率",
  "eqa.management.performance.participation.sub": "项目参与率",
  "eqa.management.performance.subtitle": "查看绩效指标",
  "eqa.management.performance.title": "绩效",
  "eqa.management.performance.zScore": "Z评分",
  "eqa.management.performance.zScore.sub": "平均Z评分",
  "eqa.management.programs.subtitle": "查看和管理EQA项目",
  "eqa.management.programs.title": "室间质评计划",
  "eqa.management.results.title": "结果管理",
  "eqa.management.samples.empty": "暂无样本",
  "eqa.management.samples.subtitle": "查看和管理样本",
  "eqa.management.samples.title": "样本管理",
  "eqa.management.status.completed": "已完成",
  "eqa.management.status.completed.sub": "已完成的订单",
  "eqa.management.status.inProgress": "进行中",
  "eqa.management.status.inProgress.sub": "进行中的订单",
  "eqa.management.status.in_progress": "进行中",
  "eqa.management.status.overdue": "已逾期",
  "eqa.management.status.pending": "待处理",
  "eqa.management.status.pending.sub": "待处理的订单",
  "eqa.management.status.submitted": "已提交",
  "eqa.management.status.submitted.sub": "已提交的订单",
  "eqa.management.subtitle": "管理外部质量评估",
  "eqa.management.title": "EQA管理",
  "eqa.management.viewPerformance": "查看绩效",
  "eqa.myProgram.helperText": "选择您要参与的EQA项目",
  "eqa.myProgram.label": "我的项目",
  "eqa.myProgram.prePopulated.subtitle": "预填充的项目信息",
  "eqa.myProgram.prePopulated.title": "预填充项目",
  "eqa.myProgram.select": "选择项目",
  "eqa.myPrograms.action.deactivate": "停用",
  "eqa.myPrograms.action.edit": "编辑",
  "eqa.myPrograms.action.reactivate": "重新激活",
  "eqa.myPrograms.description": "描述",
  "eqa.myPrograms.enrollButton": "注册计划",
  "eqa.myPrograms.enrollInProgram": "注册计划",
  "eqa.myPrograms.labUnits": "实验室科室",
  "eqa.myPrograms.panels": "检测面板",
  "eqa.myPrograms.programName": "计划名称",
  "eqa.myPrograms.provider": "供应商",
  "eqa.myPrograms.search.placeholder": "搜索计划...",
  "eqa.myPrograms.status": "状态",
  "eqa.myPrograms.status.active": "活跃",
  "eqa.myPrograms.status.inactive": "未激活",
  "eqa.myPrograms.subtitle": "本实验室参与的室间质评计划",
  "eqa.myPrograms.testMapping": "检测映射",
  "eqa.myPrograms.testMappingHint": "将EQA检测映射到本地检测",
  "eqa.myPrograms.tests": "检测",
  "eqa.myPrograms.title": "我的室间质评计划",
  "eqa.order.deadline": "截止日期",
  "eqa.order.form.title": "EQA订单",
  "eqa.order.participantId": "参与者编号",
  "eqa.order.priority": "优先级",
  "eqa.order.programme": "计划",
  "eqa.order.provider": "供应商",
  "eqa.order.providerSampleId": "供应商样本编号",
  "eqa.orders.completedThisMonth": "本月已完成",
  "eqa.orders.enterNewTest": "录入新检测",
  "eqa.orders.inProgress": "进行中",
  "eqa.orders.overdue": "已逾期",
  "eqa.orders.pending": "待处理",
  "eqa.orders.search.placeholder": "搜索订单...",
  "eqa.participant.id": "参与者编号",
  "eqa.priority.critical": "紧急",
  "eqa.priority.label": "优先级",
  "eqa.priority.standard": "标准",
  "eqa.priority.urgent": "加急",
  "eqa.program.activate": "激活",
  "eqa.program.active": "活跃",
  "eqa.program.addProgram": "添加项目",
  "eqa.program.cancel": "取消",
  "eqa.program.create": "创建项目",
  "eqa.program.createTitle": "创建EQA项目",
  "eqa.program.deactivate": "停用",
  "eqa.program.description": "描述",
  "eqa.program.description.placeholder": "输入项目描述",
  "eqa.program.edit": "编辑计划",
  "eqa.program.editTitle": "编辑EQA项目",
  "eqa.program.empty": "未找到室间质评计划",
  "eqa.program.inactive": "未激活",
  "eqa.program.label": "项目",
  "eqa.program.management.title": "项目管理",
  "eqa.program.name": "计划名称",
  "eqa.program.name.placeholder": "输入项目名称",
  "eqa.program.name.required": "计划名称为必填项",
  "eqa.program.provider.required": "提供者为必填项",
  "eqa.program.participantCount": "参与者数量",
  "eqa.program.provider": "供应商",
  "eqa.program.required": "此字段为必填项",
  "eqa.program.save": "保存计划",
  "eqa.program.select": "选择项目",
  "eqa.program.status": "状态",
  "eqa.program.tests": "检测",
  "eqa.program.tests.assign": "分配检测",
  "eqa.program.tests.select": "选择检测",
  "eqa.provider.label": "供应商",
  "eqa.provider.sampleId": "供应商样本编号",
  "eqa.provider.select": "选择供应商",
  "eqa.results.acceptable": "可接受",
  "eqa.results.batch.import": "批量导入",
  "eqa.results.col.deadline": "截止日期",
  "eqa.results.col.labNumber": "实验室编号",
  "eqa.results.col.priority": "优先级",
  "eqa.results.col.programme": "项目",
  "eqa.results.col.provider": "供应商",
  "eqa.results.col.status": "状态",
  "eqa.results.import.confirm": "确认导入",
  "eqa.results.import.errors": "导入错误",
  "eqa.results.import.success": "导入成功",
  "eqa.results.import.upload": "上传导入文件",
  "eqa.results.manual.entry": "手动录入",
  "eqa.results.mean": "均值",
  "eqa.results.minimum.participants": "最少参与者数",
  "eqa.results.noResults": "无结果",
  "eqa.results.organization": "机构",
  "eqa.results.organization.select": "选择机构",
  "eqa.results.participant.count": "参与者数量",
  "eqa.results.performance": "表现",
  "eqa.results.questionable": "可疑",
  "eqa.results.report.downloading": "正在下载报告...",
  "eqa.results.report.generate": "生成报告",
  "eqa.results.search.placeholder": "搜索结果...",
  "eqa.results.standardDeviation": "标准差",
  "eqa.results.statistics": "统计",
  "eqa.results.submit": "提交",
  "eqa.results.test": "检测",
  "eqa.results.test.select": "选择检测",
  "eqa.results.title": "EQA结果",
  "eqa.results.unacceptable": "不可接受",
  "eqa.results.value": "值",
  "eqa.results.zscore": "Z分数",
  "eqa.sample.badge": "EQA样本",
  "eqa.sample.checkbox": "EQA样本",
  "eqa.sample.checkbox.helper": "勾选此项以将该样本标记为外部质量评估样本",
  "eqa.sample.demographics.disabled": "EQA样本的人口统计信息已禁用",
  "eqa.sample.patient.readonly.body": "EQA样本的患者信息为只读",
  "eqa.sample.patient.readonly.title": "患者信息只读",
  "eqa.section.title": "外部质量评估",
  "eqa.status.active": "活跃",
  "eqa.status.completed": "已完成",
  "eqa.status.inProgress": "进行中",
  "eqa.status.inactive": "非活跃",
  "eqa.status.inprogress": "进行中",
  "eqa.status.overdue": "已逾期",
  "eqa.status.pending": "待处理",
  "eqa.submission.audit": "提交审计",
  "eqa.submission.date": "提交日期",
  "eqa.submission.error": "提交时出错",
  "eqa.submission.fhir": "FHIR提交",
  "eqa.submission.fhir.description": "通过FHIR提交EQA结果",
  "eqa.submission.late.approve": "批准延迟提交",
  "eqa.submission.late.justification": "延迟提交理由",
  "eqa.submission.late.justification.placeholder": "请输入延迟提交的理由...",
  "eqa.submission.late.supervisor": "主管审批",
  "eqa.submission.late.warning": "此提交已超过截止日期",
  "eqa.submission.method": "提交方式",
  "eqa.submission.success": "提交成功",
  "eqa.submission.title": "提交",
  "eqa.tests.action.enterResults": "录入结果",
  "eqa.tests.action.viewOrder": "查看订单",
  "eqa.tests.action.viewResults": "查看结果",
  "eqa.tests.dateEntered": "录入日期",
  "eqa.tests.deadline": "截止日期",
  "eqa.tests.enterNew": "录入新检测",
  "eqa.tests.labNumber": "实验室编号",
  "eqa.tests.orders.subtitle": "管理EQA检测订单",
  "eqa.tests.orders.title": "EQA检测订单",
  "eqa.tests.priority": "优先级",
  "eqa.tests.program": "室间质评计划",
  "eqa.tests.provider": "供应商",
  "eqa.tests.searchPlaceholder": "搜索检测...",
  "eqa.tests.status": "状态",
  "eqa.tests.status.completed": "已完成",
  "eqa.tests.status.inProgress": "进行中",
  "eqa.tests.status.overdue": "已逾期",
  "eqa.tests.status.pending": "待处理",
  "eqa.tests.summary.completedThisMonth": "本月已完成",
  "eqa.tests.summary.inProgress": "进行中",
  "eqa.tests.summary.overdue": "已逾期",
  "eqa.tests.summary.pending": "待处理",
  "eqa.validation.deadline.required": "截止日期为必填项",
  "eqa.validation.program.required": "方案为必填项",
  "eqa.validation.provider.required": "供应商为必填项",
  "error.add.edited.msg": "编辑/添加时出错",
  "error.barcode.dimension.positive": "条码尺寸必须为正数",
  "error.barcode.labelcount.default.lte.max": "默认标签数量不能超过最大值",
  "error.delete.msg": "删除时出错",
  "error.duplicate.calculationname": "重复的计算名称或保存时出错",
  "error.fetch.boxDetails": "获取箱子详情失败",
  "error.fetch.boxes": "获取转运箱信息失败",
  "error.fetch.facilities": "获取机构信息失败",
  "error.fetch.unassignedSamples": "获取未分配样本失败",
  "error.field.required": "此字段为必填项",
  "error.import.patient": "将患者导入OpenELIS时出错",
  "error.invalid.email": "无效的电子邮件",
  "error.invalidcredentials": "用户名或密码不正确",
  "error.locale.format": "区域设置格式无效",
  "error.no.patient.data": "没有要导入的患者数据",
  "error.nonconform.report": "请输入值",
  "error.report.csv.date": "请选择日期类型。",
  "error.report.csv.study": "请选择研究类型。",
  "error.report.status": "生成报告时出错",
  "error.report.linkIncomplete": "链接未指明要打开哪个{0}，因此无法显示报告。请改为从报告列表中选择。",
  "error.report.linkIncomplete.title": "此报告链接不完整",
  "error.required.destination": "目标机构为必填项",
  "error.results.loadFailed": "无法加载结果工作列表",
  "error.results.loadFailed.detail": "这不是一个空的工作列表——请求失败了，因此此处不会显示任何待处理的工作。请重试，如果仍无法成功，请告知管理员。",
  "error.results.precision": "此检测的报告结果精确到 {0} 位小数。请按该精度输入数值，否则记录值与报告值将不一致。",
  "error.results.staleSave": "该结果由 {0} 在 {1} 进行了更新——请刷新页面以查看最新值",
  "error.results.save.noResponse": "结果未保存，因为服务器没有响应。请检查网络连接后重试。",
  "error.order.staleSave": "此订单已于 {1} 被 {0} 更新。请刷新以查看最新版本，然后重新进行更改。",
  "error.patient.staleSave": "此患者已于 {1} 被 {0} 更新。请刷新以查看最新版本，然后重新进行更改。",
  "error.testCatalog.staleSave": "此检测已由 {0} 于 {1} 更新。请刷新查看最新版本，然后重新进行修改。",
  "error.testCatalog.storage.invalidField": "{field}：不接受此值。请选择列出的条件，时长使用零或更大的数值，并使文本不超过长度限制。",
  "error.staleSave.section": "在您打开后，其他人修改了此内容。未保存任何内容。请刷新查看最新版本，然后重新进行修改。",
  "error.load.failed": "无法加载此列表。请重新加载以重试。",
  "error.save.failed": "保存失败",
  "error.save.msg": "保存时出错",
  "error.save.order": "保存订单时出错",
  "error.save.patient": "保存患者时出错",
  "error.title": "错误",
  "errorBoundary.reload": "重新加载页面",
  "errorBoundary.route.patientResultsViewer.message": "加载患者结果时出错，请重试",
  "errorBoundary.route.patientResultsViewer.title": "患者结果查看器出错",
  "errorBoundary.route.resultsSearch.message": "搜索结果时出错，请重试",
  "errorBoundary.route.resultsSearch.title": "结果搜索出错",
  "errorBoundary.route.modifyOrder.message": "修改订单页面出错。请重新加载后重试。",
  "errorBoundary.route.modifyOrder.title": "无法加载修改订单",
  "errorBoundary.route.orderEntry.message": "订单录入页面出错。请重新加载后重试。",
  "errorBoundary.route.orderEntry.title": "无法加载订单录入",
  "errorBoundary.route.samplePatientEntry.message": "加载样本患者录入时出错，请重试",
  "errorBoundary.route.samplePatientEntry.title": "样本患者录入出错",
  "errorBoundary.route.storage.message": "加载存储模块时出错，请重试",
  "errorBoundary.route.storage.title": "存储模块出错",
  "errorBoundary.route.analyzers.message": "加载分析仪模块时出错，请重试",
  "errorBoundary.route.analyzers.title": "分析仪模块出错",
  "errorBoundary.route.analyzerResults.message": "加载分析仪结果时出错，请重试",
  "errorBoundary.route.analyzerResults.title": "分析仪结果出错",
  "serverReconnect.title": "无法连接服务器",
  "serverReconnect.retryIn": "{seconds} 秒后重试",
  "serverReconnect.trying": "正在重试…",
  "serverReconnect.tryNow": "立即重试",
  "errors.no.sample": "请为每个检测选择相应的样本。",
  "errors.requester.org.or.requestor.required": "请至少填写申请机构或请求者联系人中的一项。",
  "esig.button.certify": "确认并继续",
  "esig.button.reject": "拒绝",
  "esig.button.saveAndSign": "保存",
  "esig.button.saveModification": "保存",
  "esig.button.sign": "签名",
  "esig.button.validate": "验证",
  "esig.certification.acknowledge": "我已阅读并理解上述声明",
  "esig.certification.intro": "在使用电子签名之前，您必须确认您的电子签名在法律上与您的亲笔签名具有同等效力。",
  "esig.error.disabled": "未启用电子签名",
  "esig.error.generic": "发生错误",
  "esig.error.invalidCredentials": "凭证无效",
  "esig.error.keycloakNotSupported": "目前尚不支持将 Keycloak 身份验证用于电子签名",
  "esig.error.loadingStatus": "无法加载签名状态",
  "esig.error.mustAcknowledge": "您必须确认该认证声明",
  "esig.error.passwordRequired": "需要密码",
  "esig.error.rejectionReasonRequired": "必须填写拒绝原因",
  "esig.error.title": "错误",
  "esig.error.usernameRequired": "需要用户名",
  "esig.info.fullAuth": "这是您在本会话中的首次签名。请输入用户名和密码进行身份验证。",
  "esig.info.legalBinding": "输入您的凭据即表示您根据《联邦法规汇编》第21篇第11部分的规定，创建了一份具有法律约束力的电子签名。",
  "esig.info.passwordOnly": "您当前有一个有效的签名会话。请输入密码以继续。",
  "esig.label.context": "操作：",
  "esig.label.meaning": "签名含义：",
  "esig.label.password": "密码",
  "esig.label.rejectionReason": "拒绝原因",
  "esig.label.signingAs": "署名：{userName}",
  "esig.label.username": "用户名",
  "esig.meaning.authored": "已编写",
  "esig.meaning.modified": "已修改",
  "esig.meaning.rejected": "已拒收",
  "esig.meaning.validatedAndReleased": "已审核并发布",
  "esig.placeholder.password": "请输入密码以确认",
  "esig.placeholder.rejectionReason": "请输入拒绝原因",
  "esig.placeholder.username": "请输入您的用户名",
  "esig.title.certification": "电子签名认证",
  "esig.title.signature": "电子签名",
  "example": "示例",
  "external.id": "外部ID",
  "external.referrals.report": "外部转诊报告",
  "externalReferredOutTests.title": "外部转诊报告",
  "externalconnections.active": "活跃",
  "externalconnections.add.title": "添加外部连接",
  "externalconnections.authtype": "认证类型",
  "externalconnections.authtype.basic.password": "密码",
  "externalconnections.authtype.basic.username": "用户名",
  "externalconnections.browse.title": "外部连接",
  "externalconnections.deactivate.success": "外部连接停用成功",
  "externalconnections.description": "描述",
  "externalconnections.edit.title": "编辑外部连接",
  "externalconnections.name": "名称",
  "externalconnections.name.placeholder": "输入连接名称",
  "externalconnections.programmedconnection": "程序化连接",
  "externalconnections.save.success": "外部连接保存成功",
  "externalconnections.search": "搜索",
  "externalconnections.search.placeholder": "搜索连接...",
  "externalconnections.select": "选择",
  "externalconnections.uri": "URI地址",
  "externalconnections.uri.placeholder": "输入连接URI",
  "false.label": "假",
  "field.active": "活跃/不活跃",
  "field.ageRange": "年龄范围",
  "field.dictionaryValues": "字典值",
  "field.loinc": "LOINC",
  "field.name": "名称",
  "field.normalRange": "正常范围",
  "field.note": "备注",
  "field.orderable": "可订购/不可订购",
  "field.panel": "面板",
  "field.referenceValue": "参考值",
  "field.reportName": "报告名称",
  "field.resultLimits": "结果限制",
  "field.resultType": "结果类型",
  "field.sampleType": "样本类型",
  "field.select.testSection": "选择检测科室",
  "field.selectValues": "选择值",
  "field.sex": "性别",
  "field.significantDigits": "有效位数",
  "field.testSection": "检测科室",
  "field.testUnit": "检测单元",
  "field.uom": "测量单位",
  "field.validRange": "有效范围",
  "file.import.configuration.active": "活跃",
  "file.import.configuration.analyzer": "分析仪",
  "file.import.configuration.analyzer.emptyState": "无可用分析仪",
  "file.import.configuration.analyzer.placeholder": "选择分析仪",
  "file.import.configuration.cancel": "取消",
  "file.import.configuration.columnMappings": "列映射",
  "file.import.configuration.columnMappings.helperText": "配置文件列与系统字段之间的映射关系",
  "file.import.configuration.delimiter": "分隔符",
  "file.import.configuration.delimiter.helperText": "用于分隔文件中各列的字符",
  "file.import.configuration.error.save": "保存配置时出错",
  "file.import.configuration.error.unknown": "发生未知错误",
  "file.import.configuration.fileFormat": "文件格式",
  "file.import.configuration.fileFormat.placeholder": "选择文件格式",
  "file.import.configuration.filePattern": "文件名模式",
  "file.import.configuration.filePattern.helperText": "用于匹配导入文件的文件名模式",
  "file.import.configuration.hasHeader": "包含表头行",
  "file.import.configuration.importDirectory": "导入目录",
  "file.import.configuration.importDirectory.helperText": "监控待导入文件的目录",
  "file.import.configuration.importDirectory.placeholder": "输入导入目录路径",
  "file.import.configuration.save": "保存",
  "file.import.configuration.success.created": "导入配置创建成功",
  "file.import.configuration.success.updated": "导入配置更新成功",
  "file.import.configuration.title.add": "添加导入配置",
  "file.import.configuration.title.edit": "编辑导入配置",
  "file.import.configuration.validation.analyzerId.required": "分析仪为必填项",
  "file.import.configuration.validation.columnMappings.invalid": "列映射配置无效",
  "file.import.configuration.validation.importDirectory.required": "导入目录为必填项",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "过滤器",
  "freezer.alert.detail.acknowledge": "确认",
  "freezer.alert.detail.acknowledgedAt": "确认时间",
  "freezer.alert.detail.acknowledgedBy": "确认人",
  "freezer.alert.detail.acknowledgmentNotes": "确认备注",
  "freezer.alert.detail.actions": "已采取的操作",
  "freezer.alert.detail.close": "关闭",
  "freezer.alert.detail.correctiveAction": "纠正措施",
  "freezer.alert.detail.correctiveActionDescription": "描述",
  "freezer.alert.detail.correctiveActionFailed": "未能记录纠正措施",
  "freezer.alert.detail.correctiveActionType": "措施类型",
  "freezer.alert.detail.delete": "删除警报",
  "freezer.alert.detail.deleteConfirm": "要永久删除此警报吗？",
  "freezer.alert.detail.deleteFailed": "删除警报失败",
  "freezer.alert.detail.deletePermanently": "永久删除",
  "freezer.alert.detail.deleteWarning": "开始时间、严重程度、确认信息和备注将被删除，不留审计跟踪，且无法恢复。",
  "freezer.alert.detail.freezer": "冰箱",
  "freezer.alert.detail.id": "警报编号",
  "freezer.alert.detail.logCorrectiveAction": "记录纠正措施",
  "freezer.alert.detail.message": "消息",
  "freezer.alert.detail.method": "方法",
  "freezer.alert.detail.notes": "备注",
  "freezer.alert.detail.notesPlaceholder": "添加关于此警报的备注...",
  "freezer.alert.detail.notifications": "已发送通知",
  "freezer.alert.detail.overview": "警报概述",
  "freezer.alert.detail.recipient": "收件人",
  "freezer.alert.detail.resolutionNotes": "解决备注",
  "freezer.alert.detail.resolve": "解决",
  "freezer.alert.detail.resolvedAt": "解决时间",
  "freezer.alert.detail.resolvedBy": "解决人",
  "freezer.alert.detail.sentAt": "发送时间",
  "freezer.alert.detail.severity": "严重程度",
  "freezer.alert.detail.startTime": "开始时间",
  "freezer.alert.detail.status": "状态",
  "freezer.alert.detail.summary": "转运箱摘要",
  "freezer.alert.detail.takenAt": "执行时间",
  "freezer.alert.detail.takenBy": "执行人",
  "freezer.alert.detail.title": "警报详情",
  "freezer.alert.severity.critical": "紧急",
  "freezer.alert.severity.warning": "警告",
  "freezer.alert.status.acknowledged": "已确认",
  "freezer.alert.status.closed": "已关闭",
  "freezer.alert.status.escalated": "已升级",
  "freezer.alert.status.open": "待处理",
  "freezer.alert.status.resolved": "已解决",
  "freezer.nav.corrective": "纠正措施",
  "freezer.nav.corrective.tooltip": "查看和管理纠正措施",
  "freezer.nav.dashboard": "仪表板",
  "freezer.nav.dashboard.tooltip": "查看冰箱仪表板",
  "freezer.nav.reports": "报告",
  "freezer.nav.reports.tooltip": "查看冰箱报告",
  "freezer.nav.settings": "设置",
  "freezer.nav.settings.tooltip": "管理冰箱设置",
  "freezer.nav.trends": "趋势",
  "freezer.nav.trends.tooltip": "查看温度趋势",
  "french.current": "法文当前",
  "french.label": "法文",
  "from.title": "从",
  "genericSample.edit.success": "样本编辑成功",
  "genericSample.edit.success.accession": "实验室编号：{accessionNumber}",
  "genericSample.edit.title": "编辑样本",
  "genericSample.field.by": "由",
  "genericSample.field.count": "#",
  "genericSample.field.date": "日期",
  "genericSample.field.from": "从",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "实验室接收人",
  "genericSample.field.project": "项目",
  "genericSample.field.storageLocation": "存储冰箱编号和位置",
  "genericSample.field.type": "类型",
  "genericSample.notebook.selection.title": "笔记本选择（可选）",
  "genericSample.order.error.labNoRequired": "请在保存前生成实验室编号。",
  "genericSample.order.generateLabNo": "生成实验室编号",
  "genericSample.order.labNo.placeholder": "点击'生成实验室编号'创建",
  "genericSample.order.success.details": "样本详情",
  "genericSample.order.success.message": "样本订单创建成功",
  "genericSample.order.title": "接收样本",
  "gps.accuracy.display": "精度：{accuracy}米",
  "gps.accuracy.warning.message": "GPS精度较低，位置信息可能不准确",
  "gps.accuracy.warning.title": "精度警告",
  "gps.button.clear": "清除位置",
  "gps.button.getting.location": "正在获取位置...",
  "gps.button.location.captured": "位置已获取",
  "gps.button.use.my.location": "使用我的位置",
  "gps.collapse": "收起",
  "gps.config.accuracy.helper": "可接受的最大精度值（米）",
  "gps.config.accuracy.label": "精度阈值",
  "gps.config.enabled.description": "启用样本采集的GPS坐标捕获功能",
  "gps.config.enabled.label": "启用GPS",
  "gps.config.error.load": "加载GPS配置时出错",
  "gps.config.save.error": "保存GPS配置时出错",
  "gps.config.save.success": "GPS配置保存成功",
  "gps.config.saving": "正在保存...",
  "gps.config.section.general": "常规设置",
  "gps.config.timeout.helper": "等待GPS信号的最长时间（秒）",
  "gps.config.timeout.label": "超时时间",
  "gps.config.title": "GPS配置",
  "gps.config.unsaved.changes": "您有未保存的更改。是否确定要离开？",
  "gps.config.unsaved.subtitle": "如果离开，未保存的更改将丢失",
  "gps.config.unsaved.title": "未保存的更改",
  "gps.config.validation.accuracy.negative": "精度值不能为负数",
  "gps.config.validation.accuracy.too.high": "精度值过高",
  "gps.config.validation.timeout.too.high": "超时时间过长",
  "gps.config.validation.timeout.too.low": "超时时间过短",
  "gps.coordinates.captured.via": "坐标获取方式：{method}",
  "gps.coordinates.current": "当前坐标",
  "gps.error.not.supported": "您的浏览器不支持地理定位",
  "gps.error.permission.denied": "位置访问权限被拒绝",
  "gps.error.position.unavailable": "位置信息不可用",
  "gps.error.timeout": "获取位置请求超时",
  "gps.error.title": "GPS错误",
  "gps.error.unknown": "发生未知错误",
  "gps.info.description": "GPS坐标用于记录样本采集地点",
  "gps.info.title": "GPS信息",
  "gps.latitude.helper": "输入纬度值（-90到90之间）",
  "gps.latitude.invalid": "纬度值无效",
  "gps.latitude.label": "纬度",
  "gps.latitude.placeholder": "例如：39.9042",
  "gps.longitude.helper": "输入经度值（-180到180之间）",
  "gps.longitude.invalid": "经度值无效",
  "gps.longitude.label": "经度",
  "gps.longitude.placeholder": "例如：116.4074",
  "gps.manual.entry.off": "手动输入已关闭",
  "gps.manual.entry.on": "手动输入已开启",
  "gps.manual.entry.title": "手动输入坐标",
  "gps.manual.entry.toggle": "切换手动输入",
  "gps.not.captured": "未获取位置",
  "gps.section.description": "采集地点的GPS坐标",
  "gps.section.title": "GPS坐标",
  "gps.status.captured": "已获取",
  "gps.status.optional": "可选",
  "gps.tile.collapse": "收起GPS",
  "gps.tile.expand": "展开GPS",
  "gps.warning.partial.coordinates": "请同时提供纬度和经度",
  "header.ID": "ID",
  "header.assign": "分配",
  "header.cancel.test": "取消检测",
  "header.formname": "表单名称",
  "header.icon.help": "帮助",
  "header.icon.lang": "语言",
  "header.icon.menu.close": "关闭菜单",
  "header.icon.menu.open": "打开菜单",
  "header.icon.menu.pin": "固定菜单",
  "header.icon.menu.unpin": "取消固定菜单",
  "header.icon.notifications": "通知",
  "header.icon.search": "搜索",
  "header.icon.user": "用户",
  "header.label.ARV": "ARV-初始",
  "header.label.EID": "DBS-PCR儿童诊断",
  "header.label.changeLab": "选择实验室",
  "header.label.followup": "ARV-随访",
  "header.label.intialFollowup": "ARV -->初始-随访-VL",
  "header.label.logout": "退出登录",
  "header.label.nonconformityByDate": "按日期的不符合报告",
  "header.label.selectLab": "选择实验室",
  "header.label.selectlocale": "选择区域设置",
  "header.label.specialRequest": "特殊请求",
  "header.label.study.ciexport": "按日期导出CSV文件",
  "header.label.study.vlloadtrends": "病毒载量数据导出报告",
  "header.label.version": "版本：",
  "header.reject": "拒绝",
  "header.rejection.reason": "拒绝原因",
  "header.results.recorded": "记录的结果",
  "hide.aliquoting": "隐藏分装样本",
  "holder.choose.availabletest": "选择可用检测",
  "home.dashboard.title": "仪表板",
  "home.label": "首页",
  "immunohistochemistry.label.addreport": "添加报告",
  "immunohistochemistry.label.averageChrom": "每个细胞核平均17号染色体信号",
  "immunohistochemistry.label.averageHer2": "每个细胞核平均HER2",
  "immunohistochemistry.label.cellIntensity": "强度 . Allred评分",
  "immunohistochemistry.label.cellPercent": "%的细胞显示核染色",
  "immunohistochemistry.label.dashboard": "免疫组织化学仪表板",
  "immunohistochemistry.label.her2Assesment": "HER 2蛋白评估是",
  "immunohistochemistry.label.her2Pattern": "CerbB2/HER 2染色模式",
  "immunohistochemistry.label.her2ScoreOf": "评分为",
  "immunohistochemistry.label.historicalDiagnosis": "组织学诊断",
  "immunohistochemistry.label.ihcRatio": "Her2/neu信号与17号染色体的比率",
  "immunohistochemistry.label.ihcScore": "IHC (Cerb2评分)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (增殖指数): ",
  "immunohistochemistry.label.molecularType": "分子亚型",
  "immunohistochemistry.label.numberOfCancer": "癌细胞核数量",
  "immunohistochemistry.label.outOf8": "共8个",
  "immunohistochemistry.label.report": "报告",
  "immunohistochemistry.label.reports": "报告",
  "immunohistochemistry.label.review": "等待免疫组织化学审查",
  "immunohistochemistry.label.title": "免疫组织化学",
  "immunohistochemistry.label.tumorCells": "肿瘤细胞阳性(截止值20%)",
  "immunohistochemistry.status.completed": "已完成",
  "immunohistochemistry.status.inProgress": "进行中",
  "immunohistochemistry.status.readyPathologist": "待病理学家处理",
  "import.autoGenerated": "自动生成",
  "import.created": "已创建",
  "import.error.failed": "导入失败",
  "import.error.importFile": "导入文件时出错",
  "import.error.selectFile": "请选择要导入的文件",
  "import.error.validateFile": "请先验证文件",
  "import.error.validateFirst": "请先进行验证再导入",
  "import.error.validationFailed": "验证失败",
  "import.failed": "失败",
  "import.failedCount": "失败数量",
  "import.header.collectionDate": "采集日期",
  "import.header.errorMessage": "错误信息",
  "import.header.field": "字段",
  "import.header.from": "来源",
  "import.header.labNo": "实验室编号",
  "import.header.quantity": "数量",
  "import.header.row": "行",
  "import.header.sampleType": "样本类型",
  "import.header.samplesToCreate": "待创建样本数",
  "import.importing": "正在导入...",
  "import.invalidRows": "无效行数",
  "import.selectFile": "选择文件",
  "import.status.invalid": "无效",
  "import.status.valid": "有效",
  "import.success": "导入成功",
  "import.totalRows": "总行数",
  "import.totalSamplesToCreate": "待创建样本总数",
  "import.uploadFile": "上传文件",
  "import.uploadFileDesc": "选择要导入的文件",
  "import.validRows": "有效行数",
  "import.validating": "正在验证...",
  "import.validationStatus": "验证状态",
  "input.error.same.panel.type": "已找到具有相同名称的现有面板类型。请取消或使用不同的名称。",
  "input.placeholder.labNo": "输入实验室编号",
  "input.placeholder.patientFirstName": "输入患者名",
  "input.placeholder.patientId": "输入患者ID",
  "input.placeholder.patientLastName": "输入患者姓",
  "input.placeholder.prevLabNumber": "输入之前的实验室编号",
  "input.placeholder.providerEmail": "输入请求者的电子邮件",
  "input.placeholder.providerFax": "输入请求者的传真号码",
  "input.placeholder.providerWorkPhone": "输入请求者的电话号码",
  "input.placeholder.provisionalClinicalDiagnosis": "输入临时临床诊断",
  "input.placeholder.requesterFirstName": "输入请求者的名",
  "input.placeholder.requesterLastName": "输入请求者的姓",
  "input.placeholder.searchTestName": "在此搜索检测名称",
  "input.placeholder.selectPanel": "选择面板类型",
  "input.placeholder.selectPriority": "选择优先级",
  "input.placeholder.selectTest": "选择检测类型",
  "input.placeholder.selectTestSection": "选择单元类型",
  "instructions.copy.labnum": "复制实验室编号",
  "instructions.order.entry.eqa.enabled": "已启用EQA程序订单录入",
  "instructions.order.entry.requester": "启用此功能后，“搜索请求者”、“请求者名”和“请求者姓”将在“添加订单”页面上成为必填字段。禁用此功能（默认值）时，这三个字段均为可选字段。",
  "instructions.test.activation": "活跃检测：选中的框表示已经活跃的检测。要激活检测，请选中框；要停用，请取消选中框。任何没有现有活跃检测的样本类型都将被停用，并显示在底部的'非活跃样本类型'下。如果其中一个检测被激活，样本类型将被激活。",
  "instructions.test.activation.confirm": "验证这些是您想要进行的更改。如果正确，则保存。如果不正确，请使用后退按钮进行正确的更改",
  "instructions.test.activation.sort": "显示顺序：具有新激活检测的样本类型列表。对检测进行排序，以指示它们将如何在订单录入屏幕中显示。可以通过将项目拖动到所需位置来进行排序。",
  "instructions.test.order": "带有检查的检测是可订购的，没有检查的检测是不可订购的。更改检查以更改状态。要能够在录入时订购检测，它必须既活跃又可订购。活跃但不可订购的检测可以作为检测反射的一部分请求。",
  "invalid.json": "JSON无效",
  "inventory.add.button": "添加新批次",
  "inventory.addItem.button": "添加目录项",
  "inventory.consume.error.noLots": "{name}（{code}）无可用库存",
  "inventory.consume.error.noLotsAwaitingQc": "{name}（{code}）没有质控通过的库存：{count} 个有库存的批次正在等待质控。将质控标记为通过后即可使用。",
  "inventory.consume.error.noLotsQcFailed": "{name}（{code}）没有可用库存：{count} 个有库存的批次质控失败",
  "inventory.consume.error.noLotsQuarantined": "{name}（{code}）没有可用库存：{count} 个有库存的批次已隔离",
  "inventory.dashboard.title": "库存仪表板",
  "inventory.export.button": "导出",
  "inventory.filter.all": "全部",
  "inventory.filter.status": "按状态过滤",
  "inventory.item.error.duplicateCode": "代码为“{code}”的库存物品已存在。",
  "inventory.item.error.codeGenerationExhausted": "无法为前缀“{prefix}”找到可用代码。请手动输入代码。",
  "inventory.list.title": "库存物品",
  "inventory.lot.error.duplicateBarcode": "条码“{barcode}”已分配给批次 {lotNumber}",
  "inventory.lot.search.placeholder": "按物品名称、批号或条码搜索",
  "inventory.metrics.expired": "已过期",
  "inventory.metrics.expiringSoon": "即将过期",
  "inventory.metrics.lowStock": "低库存",
  "inventory.metrics.totalLots": "总批次",
  "inventory.tab.catalog": "目录",
  "inventory.tab.dashboard": "仪表板",
  "inventory.tab.reports": "报告",
  "inventory.title": "库存管理",
  "label.action": "操作",
  "labNumber.format.current": "当前格式",
  "labNumber.format.new": "新格式",
  "labNumber.prefix": "前缀",
  "labNumber.type": "实验室编号类型",
  "labNumber.usePrefix": "使用前缀",
  "label.actions": "操作",
  "label.active": "活跃",
  "label.actualTestName": "实际检测名称",
  "label.add": "添加",
  "label.add.notification": "向用户添加弹出通知",
  "label.all": "全部",
  "label.analysisNotStarted": "分析未开始",
  "label.any": "任何",
  "label.audittrail": "实验室编号",
  "label.audittrail.Reports": "审计跟踪报告",
  "label.audittrail.labNo.invalidaccessionnumber": "无效的订单号",
  "label.audittrail.labNo.missing": "实验室编号是必需的！",
  "label.audittrailreport.nextvisitdate": "下次就诊日期",
  "label.audittrailreport.priority": "优先级",
  "label.audittrailreport.program": "程序",
  "label.audittrailreport.receiveddate": "接收日期",
  "label.audittrailreport.requestdate": "请求日期",
  "label.audittrailreport.requester": "请求者",
  "label.audittrailreport.requester.firstname": "请求者的名",
  "label.audittrailreport.requester.lastname": "请求者的姓",
  "label.audittrailreport.sitename": "站点名称",
  "label.autoFilledFromServer": "由服务器自动填充",
  "label.barcode": "条码",
  "label.barcode.labelsets": "标签组数量",
  "label.barcode.orderlabel": "每组订单标签数量",
  "label.barcode.specimenlabel": "每组标本标签数量",
  "label.barcode.totallabel": "要打印的总标签数",
  "label.button.action": "操作",
  "label.button.add": "添加",
  "label.button.add.question": "添加新问题",
  "label.button.cancel": "取消",
  "label.button.close": "关闭",
  "label.button.changepassword": "更改密码",
  "label.button.clear": "清除",
  "label.button.confirm": "确认",
  "label.button.confirmAction": "确认操作",
  "label.button.confirmDelete": "确认删除",
  "label.button.confirmTitle": "您确定吗？",
  "label.button.delete": "删除",
  "label.button.descritpion": "描述",
  "label.button.edit": "编辑",
  "label.button.activate": "激活",
  "label.button.deactivate": "停用",
  "label.button.exit": "退出",
  "label.button.externalsearch": "外部搜索",
  "label.button.field": "字段",
  "label.button.finish": "完成",
  "label.button.finished": "完成",
  "label.button.generatePrintableVersion": "生成可打印版本",
  "label.button.import": "导入",
  "label.button.login": "登录",
  "label.button.login.sso": "单点登录",
  "label.button.newEntry": "新条目",
  "label.button.ok": "确定",
  "label.button.previous": "上一个",
  "label.button.range": "范围",
  "label.button.remove": "移除",
  "label.button.remove.report": "移除报告",
  "label.button.remove.slide": "移除幻灯片",
  "label.button.reset": "重置",
  "label.button.sample": "样本",
  "label.button.save": "保存",
  "label.button.saveconfig": "保存QC频率",
  "label.button.search": "搜索",
  "label.button.select": "选择",
  "label.button.select.pathologist": "选择病理学家",
  "label.button.select.status": "选择状态",
  "label.button.select.technician": "选择技术员",
  "label.button.select.test": "选择检测",
  "label.button.start": "开始",
  "label.button.submit": "提交",
  "label.button.update": "更新",
  "label.button.uploadfile": "上传文件",
  "label.button.validate": "验证",
  "label.button.viewReport": "查看报告",
  "label.cancel": "取消",
  "label.cancel.test.no.replace": "取消所选实验室编号的检测，不分配新检测",
  "label.checkedWillBeModified": "选中的实验室编号将被修改",
  "label.clear": "清除过滤器",
  "label.content": "标签内容",
  "label.confirm": "确认",
  "label.created.samples": "创建的样本",
  "label.critical.range": "危急范围",
  "label.currentTest": "当前检测",
  "label.days": "天",
  "label.default.result": "默认结果",
  "label.delete": "删除",
  "label.description": "描述",
  "label.edit": "编辑",
  "label.electronic.orders": "电子订单",
  "label.equals": "等于",
  "label.error": "错误",
  "label.existing.methods": "现有方法",
  "label.existing.test.sets": "现有检测集",
  "label.filters.mycases": "我的案例",
  "label.filters.status": "状态",
  "label.field.required": "此字段为必填项",
  "label.status": "状态",
  "label.form.searchby": "按...搜索",
  "label.id": "ID",
  "label.import.errors": "导入错误",
  "label.inactive": "非活跃",
  "label.inactive.methods": "非活跃方法。分配检测以激活。",
  "label.includeInactiveTests": "包括非活跃检测",
  "label.inside.normalrange": "在正常范围内",
  "label.lastPrinted": "最后打印：{date} {time} 由 {user} 打印",
  "label.loading": "加载中...",
  "label.required": "必填",
  "label.loinc": "LOINC",
  "label.management.title": "标签管理",
  "label.no": "否",
  "label.no.options.available": "没有可用选项",
  "label.none": "无",
  "label.notValidated": "未验证",
  "label.notequals": "不等于",
  "label.order.labNrPrefix": "实验室编号",
  "label.order.patientPrefix": "患者",
  "label.order.scan.text": "扫描或手动输入或",
  "label.orderable": "可订购",
  "label.outside.normalrange": "超出正常范围",
  "label.page.patientHistory": "患者历史",
  "label.preview.data": "预览数据",
  "label.print": "打印标签",
  "label.print.error": "生成标签时出错。请重试。",
  "label.print.error.popupBlocked": "弹出窗口被阻止。请允许此站点的弹出窗口以打印标签。",
  "label.print.openDirectly": "在新标签页中打开标签",
  "label.print.generating": "生成中...",
  "label.print.success": "标签打印成功",
  "label.print.description": "打印订单和样本的标签",
  "label.print.helper": "选择要打印的标签类型和数量",
  "label.print.success.count": "已成功打印 {count} 个标签",
  "label.print.title": "打印条码",
  "label.printAll": "打印所有标签",
  "label.printAll.success": "所有标签均已打印成功",
  "label.printConfirmation.message": "为 {name}{code} 打印标签？",
  "label.printConfirmation.title": "打印标签",
  "label.printHistory": "打印历史",
  "label.printHistory.byUser": "由 {user} 打印",
  "label.printHistory.count": "{count} 个标签",
  "label.printHistory.loading": "加载打印历史...",
  "label.printHistory.never": "从未打印",
  "label.printHistory.unknownUser": "未知",
  "label.printHistory.viewAll": "查看历史",
  "label.printLabel": "打印标签",
  "label.program": "程序",
  "label.qualifiers": "限定符",
  "label.quantity": "数量",
  "label.readonly": "只读",
  "label.reference.value": "参考值",
  "label.refertest.referencelab": "将检测转诊到参考实验室",
  "label.rejectedByBiologist": "被生物学家拒绝",
  "label.rejectedByTechnician": "被技术员拒绝",
  "label.remove": "移除",
  "label.replaceWith": "替换为",
  "label.report.byNationalId": "按国家ID / 唯一健康ID号",
  "label.reporting.range": "报告范围",
  "label.result.order": "结果顺序",
  "label.resultSelectList": "结果选择列表",
  "label.results.actions": "操作",
  "label.results.anotherUser": "另一位用户",
  "label.results.date": "检测日期",
  "label.results.domain": "临床",
  "label.results.domain.env": "水质",
  "label.results.domain.vector": "病媒监测",
  "label.results.edit": "编辑",
  "label.results.inReviewBy": "正在由 {0} 复核",
  "label.results.labUnit": "实验室单元",
  "label.results.load": "加载结果",
  "label.results.loading": "正在加载结果...",
  "label.results.range": "参考范围",
  "label.results.range.env": "监管限值",
  "label.results.range.vector": "解释",
  "label.results.reflexTriggered": "已为以下内容添加了反射检测/计算检测：",
  "label.results.refresh": "刷新",
  "label.results.result": "结果",
  "label.results.resultFor": "{0} 的结果",
  "label.results.retry": "请重试",
  "label.results.save": "保存",
  "label.results.search": "按实验室编号搜索",
  "label.results.searchByPatient": "按患者搜索",
  "label.results.selectAnotherPatient": "选择另一位患者",
  "label.results.selectedPatient": "已选择的患者",
  "label.results.selectedPatient.none": "无",
  "label.results.status": "状态",
  "label.results.status.all": "所有分析仪",
  "label.results.subject": "样本 / 患者",
  "label.results.subject.env": "样本 / 站点",
  "label.results.subject.vector": "样本 / 诱捕器",
  "label.results.table.caption": "结果工作列表",
  "label.results.test": "检测",
  "label.results.titer.placeholder": "例如 1:10",
  "label.results.method": "方法",
  "label.results.analyzer": "分析仪",
  "label.results.analyzer.none": "并非来自仪器",
  "label.results.fromAnalyzer": "来源：分析仪",
  "label.results.methodAnalyzerHint": "“方法”是指分析仪的类型；“分析仪”是指具体的仪器。",
  "label.results.expandRow": "展开行",
  "label.results.collapseRow": "折叠行",
  "label.results.referredOut": "转诊",
  "label.results.notes": "备注",
  "label.results.note.context": "上下文",
  "label.results.note.context.entry": "录入",
  "label.results.note.context.modification": "修改",
  "label.results.note.context.auto": "根据您当前的操作自动设置。",
  "label.results.note.visibility": "可见性",
  "label.results.note.internal": "仅限实验室内部使用",
  "label.results.note.external": "随结果发送",
  "label.results.note.analysisLevel": "分析级别",
  "label.results.note.externalWarning": "该备注将显示在患者报告中。",
  "label.results.note.placeholder": "添加备注……",
  "label.results.dilution.measured": "测量值",
  "label.results.dilution.factor": "稀释系数",
  "label.results.dilution.reported": "报告值：{0}",
  "label.results.saveHint": "“保存”会记录您的电子签名。危急值确认绝不会阻止“保存”操作。",
  "label.results.flag.normal": "正常",
  "label.results.flag.abnormal": "异常",
  "label.results.flag.critical": "紧急",
  "label.results.flag.invalid": "无效",
  "label.results.sample": "样本",
  "label.results.flag": "标记",
  "label.results.order.clinician": "开单医师",
  "label.results.order.phone": "电话",
  "label.results.order.site": "申请站点",
  "label.results.order.priority": "优先级",
  "label.results.order.collection": "采集",
  "label.results.section.program": "计划信息",
  "label.results.program.name": "计划",
  "label.results.program.eqa": "EQA样本",
  "label.results.program.readonly": "此处的项目字段为只读——请在原始订单中进行编辑。",
  "label.results.section.storage": "存储与样本处置",
  "label.results.storage.location": "位置",
  "label.results.storage.position": "位置",
  "label.results.storage.notes": "备注",
  "label.results.storage.unassigned": "未分配存储空间",
  "label.results.storage.assignLocation": "分配位置",
  "label.results.storage.moveLocation": "移动到位置",
  "label.results.program.capturedData": "项目数据",
  "label.results.sampleStatus.title": "样本状态",
  "label.results.sampleStatus.volume": "体积：{1} 中剩余 {0} · 状态 {2}。",
  "label.results.sampleStatus.noVolume": "状态 {0}。",
  "label.results.sampleStatus.available": "可用",
  "label.results.sampleStatus.usedUp": "已用完（已耗尽）",
  "label.results.sampleStatus.disposed": "已处置",
  "label.results.sampleStatus.recordUse": "记录用量",
  "label.results.sampleStatus.markUsedUp": "标记为已用完",
  "label.results.sampleStatus.startDisposal": "开始处置",
  "label.results.sampleStatus.amountUsed": "本次检测项目的用量",
  "label.results.sampleStatus.record": "记录",
  "label.results.sampleStatus.recordHint": "减少剩余体积——在样本耗尽或被明确标记为“已用完”之前，不会将其处置。",
  "label.results.sampleStatus.usedUpNote": "样本已耗尽，并已排入处置工作流。处置记录了由谁、何时以及采用何种方法进行处置。",
  "label.results.sampleStatus.disposalReason": "处置原因",
  "label.results.sampleStatus.disposalMethod": "处置方法",
  "label.results.sampleStatus.disposalNotes": "备注",
  "label.results.sampleStatus.confirmDisposal": "确认处置",
  "label.results.sampleStatus.updateFailed": "服务器未响应，样本状态未更新。请检查连接后重试。",
  "label.results.sampleStatus.reason.expired": "已过期",
  "label.results.sampleStatus.reason.contaminated": "受污染的",
  "label.results.sampleStatus.reason.patient_request": "患者请求",
  "label.results.sampleStatus.reason.testing_complete": "检测已完成",
  "label.results.sampleStatus.reason.other": "其他原因",
  "label.results.sampleStatus.method.autoclave": "生物危害高压灭菌",
  "label.results.sampleStatus.method.neutralization": "化学中和",
  "label.results.sampleStatus.method.incineration": "焚烧",
  "label.results.sampleStatus.method.other": "其他原因",
  "label.results.sampleStatus.footnote": "“部分使用”会记录已消耗的数量与样本项的剩余体积；“完全耗尽”（或标记为“已用完”）将触发处置流程。",
  "label.results.section.reagents": "试剂、质控与质控品",
  "label.results.reagents.summary.analyzer": "分析仪报告的批次",
  "label.results.reagents.summary.manual": "手动捕获",
  "label.results.reagents.mode.analyzer": "捕获模式：分析仪报告",
  "label.results.reagents.mode.manual": "捕获模式：手动（可选）",
  "label.results.reagents.analyzerNote": "由{0}在其结果有效载荷中报告——只读。",
  "label.results.reagents.lotsUsed": "所用试剂的批号",
  "label.results.reagents.noneLinked": "此检测未关联任何试剂——相关链接已在“检测目录”中配置。",
  "label.results.reagents.noLots": "该试剂目前库存中无可用批次。",
  "label.results.reagents.perTest": "每次检测 {0} {1}",
  "label.results.reagents.fefo": "建议采用FEFO法",
  "label.results.reagents.expires": "有效期 {0} ·",
  "label.results.reagents.remaining": "剩余 {0} {1}",
  "label.results.reagents.quantityUsed": "使用数量",
  "label.results.reagents.recordUse": "记录使用量",
  "label.results.reagents.recorded": "已记录 {0} {1}，已按FEFO原则跨批次消耗。",
  "label.results.reagents.recordFailed": "无法记录试剂使用情况。",
  "label.results.reagents.amountInvalid": "使用数量必须为正数。",
  "label.results.reagents.consumeNote": "记录使用量会减少库存（FEFO），并生成一条与该分析相关的消耗交易。",
  "label.results.control.title": "质控结果",
  "label.results.control.noneConfigured": "此检测和分析仪未配置质控品批号。",
  "label.results.control.viewResults": "查看质控结果",
  "label.results.control.capture.controlLine": "质控线",
  "label.results.control.capture.valid": "有效",
  "label.results.control.capture.invalid": "无效",
  "label.results.control.capture.kitLot": "试剂盒批号",
  "label.results.control.capture.outcome": "结果",
  "label.results.control.capture.lot": "质控品批号",
  "label.results.control.capture.measured": "测量值",
  "label.results.control.capture.expected": "预期值",
  "label.results.control.capture.uncertainty": "不确定度（±）",
  "label.results.control.capture.record": "记录质控结果",
  "label.results.control.capture.recorded": "质控结果已记录。",
  "label.results.control.capture.recordedBlocked": "质控结果已记录。在记录通过的重复结果之前，所覆盖结果的报告将被阻止。",
  "label.results.control.capture.blockedHint": "质控失败会阻止所覆盖结果的报告，需要重复运行。",
  "label.results.control.capture.noBenchLots": "此检测未配置工作台质控品批号。记录定量质控前，请在“质控 → 质控品批号”中添加。",
  "label.results.control.capture.incomplete": "记录前请填写完整的质控结果字段。",
  "label.results.control.capture.failed": "质控结果记录失败。",
  "label.results.dilution.title": "稀释",
  "label.results.section.attachments": "附件",
  "label.results.attachments.summary": "{0} 个文件",
  "label.results.attachments.none": "无",
  "label.results.attachments.empty": "该订单目前尚无附件。",
  "label.results.attachments.add": "添加附件",
  "label.results.attachments.tooLarge": "文件大小超过了 10 MB 的限制。",
  "label.results.attachments.uploadFailed": "上传失败——支持 PDF、JPG、PNG 或 TIFF 格式，文件大小上限为 10 MB。",
  "label.results.attachments.resultsScope": "结果",
  "label.results.attachments.orderScope": "订单录入",
  "label.results.attachments.view": "查看",
  "label.results.attachments.download": "下载",
  "label.results.section.interpretation": "解释",
  "label.results.interpretation.summary": "通过规则或自由文本输入",
  "label.results.interpretation.ruleFired": "规则已触发（{0}）· 自动打开",
  "label.results.interpretation.autoOpen": "规则触发 · 自动打开",
  "label.results.interpretation.ruleBanner": "规则匹配（在检测中配置）：输入的值{0}属于{1}。选择一个类别以应用其解释文本，然后根据需要进行编辑。",
  "label.results.interpretation.match": "与值匹配",
  "label.results.interpretation.freeText": "解释（自由文本）",
  "label.results.interpretation.footnote": "解释可通过在检测中配置的规则（按类别划分的区间，会自动与值匹配）或自由文本来设定。规则文本在应用或编辑之前仅为非强制性的建议。保存后，该解释将随结果一同发送至报告中。",
  "label.results.nce.disposition": "结果处理",
  "label.results.nce.disposition.hint": "在提交不符合事件时应用。转诊是一项单独的行操作，而非结果处置。",
  "label.results.nce.disposition.none": "无",
  "label.results.nce.disposition.none.detail": "在不更改结果的情况下提交不符合事件。",
  "label.results.nce.disposition.cancel": "取消结果",
  "label.results.nce.disposition.cancel.detail": "已作废。不报告值。这在分析前不符合事件中很常见。",
  "label.results.nce.disposition.reject": "拒绝 + 理由",
  "label.results.nce.disposition.reject.detail": "清除该值并记录原因。由您的电子签名“保存”操作应用。",
  "label.results.nce.disposition.retest": "重新检测",
  "label.results.nce.disposition.retest.detail": "对该样本再次下达相同的检测订单；该重复检测将显示为“待处理”。",
  "label.results.nce.disposition.rejectArmed": "已启用该行上的拒绝选项——点击“保存”（电子签名）以应用该设置。",
  "label.results.nce.disposition.cancelled": "结果已取消。",
  "label.results.nce.disposition.retested": "已下达重新检测订单。",
  "label.results.critical.range": "紧急",
  "label.results.critical.banner.title": "紧急值——需通知医生",
  "label.results.critical.banner.notify": "必须通知负责的临床医生。请在警报仪表板上记录，并在下方记录通话。",
  "label.results.critical.acknowledge": "我确认",
  "label.results.critical.acknowledged": "已确认",
  "label.results.critical.comment": "确认备注",
  "label.results.critical.comment.placeholder": "例如：已通过电话通知医生",
  "label.results.section.history": "历史（本分析）",
  "label.results.history.summary": "{0} 个事件",
  "label.results.history.summary.unloaded": "修订 · 状态 · 重新检测",
  "label.results.history.when": "时间",
  "label.results.history.event": "事件",
  "label.results.history.detail": "详情",
  "label.results.history.by": "由",
  "label.results.history.event.CREATED": "创建时间",
  "label.results.history.event.STATUS": "状态",
  "label.results.history.event.RESULT": "结果",
  "label.results.history.event.NOTE": "备注",
  "label.results.history.event.RETEST": "重新检测",
  "label.results.history.event.REFLEX": "反射检测",
  "label.results.history.event.OTHER": "事件",
  "label.results.history.empty": "此项分析目前尚无记录的事件。",
  "label.results.history.footnote": "仅限本分析：修订、状态变更、重新检测、更正、备注和审计条目。患者趋势见患者记录；Westgard 规则见质控仪表板。",
  "label.results.nce.report": "报告不符合项",
  "label.results.reject.result": "拒绝结果",
  "label.results.reject.reason": "拒绝原因",
  "label.results.reject.hint": "保存时若出现拒绝，系统将清除该值，记录拒绝原因，并将该分析标记为“技术性拒绝”。",
  "label.results.referral.refer": "转诊此检测",
  "label.results.referral.editing": "待转诊 — 编辑",
  "label.results.referral.organization": "参考实验室",
  "label.results.referral.reason": "转诊原因",
  "label.results.referral.date": "转诊日期",
  "label.results.referral.reportDate": "参考实验室报告日期",
  "label.results.referral.hint": "当您保存此行时，转诊信息将被记录，并转至“转诊”仪表板。",
  "label.results.referral.cancel": "丢弃",
  "label.results.referral.incomplete": "Choose the reference laboratory and the referral reason, or discard the referral, before saving this row.",
  "label.results.section.aliquots": "分装样本",
  "label.results.aliquots.summary": "{0} 个分装样本",
  "label.results.aliquots.summary.unloaded": "列表 · 创建",
  "label.results.aliquots.labNo": "实验室编号",
  "label.results.aliquots.quantity": "数量",
  "label.results.aliquots.createdDate": "创建时间",
  "label.results.aliquots.empty": "该样本项目前尚无分装样本。",
  "label.results.aliquots.count": "分装样本数量",
  "label.results.aliquots.totalQuantity": "要转移的总数量",
  "label.results.aliquots.notes": "备注",
  "label.results.aliquots.create": "创建分装样本",
  "label.results.aliquots.created": "已创建分装样本。",
  "label.results.aliquots.failed": "无法创建分装样本。",
  "label.results.aliquots.remaining": "父样本剩余数量",
  "label.results.history.event.REFERRAL": "已转诊",
  "label.results.history.event.NCE": "不符合项",
  "label.results.history.event.CRITICAL_ACK": "已确认紧急结果",
  "label.results.history.event.INVALID_CONFIRMED": "已确认超出有效范围",
  "label.results.alert.critical.title": "紧急结果",
  "label.results.alert.critical.defaultMessage": "这是紧急结果。请按照本实验室程序通知负责的临床医生。",
  "label.results.alert.invalid.title": "数值超出有效范围",
  "label.results.alert.invalid.body": "此数值超出该检测的有效范围（{low} 至 {high}）。保存前请核对。",
  "label.results.alert.correct": "更正数值",
  "label.results.alert.keepValue": "保留此数值",
  "label.results.alert.confirmAndSave": "确认并保存",
  "label.results.alert.acknowledgeAndSave": "确认并保存",
  "label.results.callback.logged": "已记录回电",
  "label.results.referenceZone": "参考与背景",
  "label.results.layoutRemembered": "已记住布局",
  "label.results.resetLayout": "重置布局",
  "label.results.section.orderInfo": "订单信息",
  "label.results.sampleType": "样本类型",
  "label.results.testDate": "检测日期",
  "label.results.receivedDate": "已接收",
  "label.results.technician": "技术员",
  "label.routine.Reports": "常规报告",
  "label.sample.types.activate": "以下样本类型将被激活：",
  "label.sample.types.deactivate": "以下样本类型将被停用，因为它们没有检测：",
  "label.save": "保存",
  "label.saving": "保存中...",
  "label.search.available.targetest": "搜索可用检测",
  "label.search.availablepanel": "搜索可用面板",
  "label.search.labno.family": "按实验室编号或姓氏搜索",
  "label.search.patient": "搜索患者",
  "label.select": "选择",
  "label.select.dateRange": "选择您想要报告的日期范围",
  "label.select.list.options": "选择列表选项",
  "label.selectTestSectionCatalog": "选择检测科室以查看该科室的目录",
  "label.sex.dependent": "性别相关",
  "label.shortCode": "短代码",
  "label.shortCode.error.invalidChars": "短代码只能包含字母、数字、连字符和下划线",
  "label.shortCode.error.maxLength": "短代码必须为10个字符或更少",
  "label.shortCode.error.network": "无法验证唯一性。请手动检查。",
  "label.shortCode.error.save": "保存短代码错误：{error}",
  "label.shortCode.error.startChar": "短代码必须以字母或数字开头",
  "label.shortCode.helper": "最多10个字符，字母数字，连字符，下划线",
  "label.shortCode.optional.helper": "可选（如果代码 ≤ 10 个字符，将使用代码）。最多10个字符，字母数字，可包含连字符/下划线",
  "label.shortCode.required.helper": "当代码 > 10 个字符时必填。最多10个字符，字母数字，可包含连字符/下划线",
  "label.shortCode.update.success": "短代码更新成功",
  "label.shortCodeRequired": "打印标签需要短代码。请先在编辑表单中设置短代码。",
  "label.shortCodeWarning": "更改短代码将使现有标签无效",
  "label.showChildren": "显示子元素",
  "label.study.Reports": "研究报告",
  "label.test.name": "检测名称",
  "label.test.activate": "以下检测将被激活：",
  "label.test.add": "向订单添加检测",
  "label.test.batch.cancel.finish": "这是不可逆的。",
  "label.test.batch.cancel.start": "您已选择取消检测",
  "label.test.batch.no.change.finish": "检测不会被更改。",
  "label.test.batch.replace.start": "以下",
  "label.test.deactivate": "以下检测将被停用：",
  "label.test.display.order": "检测显示顺序",
  "label.test.order.confirm": "验证：启用/禁用检测可订购性",
  "label.test.activation.confirm": "核实：启用/停用检测",
  "label.test.orderable": "以下检测可从订单表单订购。",
  "label.test.results": "检测结果",
  "label.test.resultsData": "检测结果数据",
  "label.test.unorderable": "以下检测不可在订单表单上订购。它们只能作为反射检测订购。",
  "label.testActivate": "检测激活",
  "label.testName": "检测名称",
  "label.text.generate": "生成",
  "label.total.tests": "总检测数",
  "label.type": "标签类型",
  "label.type.order": "订单标签",
  "label.type.pool": "{count} 只{animal}的混样",
  "label.type.sample": "样本标签",
  "label.unit": "单位",
  "label.user.notestsection": "当前用户没有分配实验室单元。请联系管理员",
  "label.validation.errors": "验证错误",
  "label.validation.results": "验证结果",
  "label.view": "查看",
  "label.viewtestCatalog": "检测目录",
  "label.warning": "警告",
  "label.yes": "是",
  "labno.alt.prefix.instruction": "预印条码标签的前缀(4个字符)：",
  "labno.alt.prefix.note": "注意：如果此前缀已被使用，编号将从生成的最后一个数字继续。",
  "labno.alt.prefix.use": "使用与订单录入生成相同的编号格式和可用编号池。",
  "language.select.label": "英文",
  "legend.search.availabletests": "搜索可用检测",
  "loading": "加载中...",
  "loading.boxes": "正在加载转运箱...",
  "loading.description": "加载中...",
  "location.collection.title": "取件位置",
  "location.environmentalConditions": "环境条件",
  "location.environmentalConditions.placeholder": "例如：25°C，晴天",
  "location.gps.error": "无法获取位置",
  "location.gps.getCurrent": "获取当前位置",
  "location.gps.getting": "正在获取位置...",
  "location.gps.latitude": "GPS纬度",
  "location.gps.longitude": "GPS经度",
  "location.gps.notSupported": "您的浏览器不支持地理位置功能",
  "location.gps.permissionDenied": "位置权限被拒绝",
  "location.gps.timeout": "位置请求超时",
  "location.gps.unavailable": "无法获取位置信息",
  "location.helper": "位置层次结构（区域/地区/镇村）采用现有的位置结构体系。环境工作流配置文件允许某些行不显示标签，以便根据需要设置更简单或更简短的行集。",
  "location.requesterReference": "请求者参考",
  "location.requesterReference.placeholder": "例如：EPA 524.2 方法",
  "location.select.placeholder": "选择“{levelName}”...",
  "location.siteDescription": "采集点描述",
  "location.siteDescription.placeholder": "例如：市政供水取水口",
  "locale.active": "活跃",
  "locale.add": "添加语言环境",
  "locale.add.title": "添加语言环境",
  "locale.code": "语言代码",
  "locale.code.helper": "语言环境代码（例如 en, fr, zh）",
  "locale.create.success": "语言环境创建成功",
  "locale.delete.confirm.message": "您确定要删除此语言环境吗？此操作无法撤销。",
  "locale.delete.confirm.title": "确认删除语言环境",
  "locale.delete.error": "删除语言环境失败",
  "locale.delete.fallback.error": "无法删除备用语言环境",
  "locale.delete.success": "语言环境删除成功",
  "locale.displayName": "显示名称",
  "locale.displayName.helper": "语言环境的显示名称",
  "locale.edit.title": "编辑语言环境",
  "locale.fallback": "备用语言环境",
  "locale.fallback.error": "设置备用语言环境失败",
  "locale.fallback.success": "备用语言环境设置成功",
  "locale.management.description": "管理应用程序支持的语言环境",
  "locale.management.title": "语言环境管理",
  "locale.setFallback": "设置为备用",
  "locale.sortOrder": "排序顺序",
  "locale.status": "状态",
  "locale.update.success": "语言环境更新成功",
  "log.submitting.aliquot.data": "提交分装样本数据：",
  "log.submitting.aliquot.data2": "提交分装样本数据(JSON)：",
  "logging.management.apply": "应用",
  "logging.management.description": "管理系统日志级别配置",
  "logging.management.label": "日志管理",
  "logging.management.level": "日志级别",
  "logging.management.logger": "日志记录器",
  "logging.management.logger.helper": "输入要修改的日志记录器名称（例如：com.example.MyClass）",
  "logging.management.success": "日志配置更新成功",
  "login.account.disabled": "账户已禁用",
  "login.account.locked": "账户已锁定",
  "login.complexity.message": "密码必须：",
  "login.complexity.message.1": "必须至少7个字符",
  "login.complexity.message.2": "可能包含大写和小写字母或数字",
  "login.complexity.message.3": "必须包含至少一个以下字符：*, $, #, !",
  "login.complexity.message.4": "不得包含任何其他字符",
  "login.complexity.new.message": "新密码必须：",
  "login.complexity.new.message.1": "不得与当前密码相同",
  "login.error.account.disable": "您的账户已禁用。请联系系统管理员。",
  "login.error.password.current.incorrect": "您输入的当前密码不正确。请重试。",
  "login.error.password.expired": "您的密码已过期。请联系系统管理员。",
  "login.error.update.message": "更新密码失败。请重试。",
  "login.login.": "重复密码",
  "login.login.current.password": "当前密码",
  "login.login.first": "名",
  "login.login.last": "姓",
  "login.login.name": "登录名",
  "login.login.new.password": "新密码",
  "login.login.password": "密码",
  "login.login.repeat.password": "重复密码",
  "login.msg.password": "密码",
  "login.msg.password.missing": "需要密码",
  "login.msg.username": "用户名",
  "login.msg.username.missing": "需要用户名",
  "login.notice.message": "注意：此服务仅允许授权人员访问。如果您没有管理员的明确授权，您必须立即退出。本组织禁止未经授权访问、披露、复制、修改、转移、销毁、丢失、滥用或盗窃其信息。",
  "login.password.expired.date": "密码过期日期",
  "login.password.expired.date.placeholder": "(日/月/年)",
  "login.redirecting.sso": "正在重定向到单点登录...",
  "login.subtitle": "登录",
  "login.timeout": "用户超时(分钟)",
  "login.timeout.placeholder": "以毫秒为单位输入",
  "login.title": "登录",
  "lot.barcode": "条码",
  "lot.barcode.assign": "此批次尚无条码。请现在输入；保存后将被锁定。",
  "lot.barcode.hint": "留空则根据物品代码和批号生成。",
  "lot.barcode.locked": "条码保存后即被锁定，以确保已打印的标签继续有效。",
  "lot.barcode.placeholder": "留空则自动生成",
  "lot.barcode.placeholder.assign": "输入条码",
  "lot.calculatedExpiry": "计算出的过期日期",
  "lot.currentQuantity": "当前数量",
  "lot.dateOpened": "开封日期",
  "lot.details.no.movements": "此批次没有出入库记录",
  "lot.details.no.transactions": "此批次无记录的交易",
  "lot.details.no.usage": "此批次无使用历史",
  "lot.details.section.basic": "基本信息",
  "lot.details.section.dates": "重要日期",
  "lot.details.section.movements": "出入库历史",
  "lot.details.section.quantities": "数量",
  "lot.details.section.storage": "存储位置",
  "lot.details.section.transactions": "交易历史",
  "lot.details.section.usage": "使用历史",
  "lot.details.tab.info": "信息",
  "lot.details.tab.transactions": "交易",
  "lot.details.tab.usage": "使用历史",
  "lot.details.title": "批次详情",
  "lot.details.view": "查看详情",
  "lot.expirationDate": "过期日期",
  "lot.form.title.add": "接收新库存批次",
  "lot.form.title.edit": "编辑库存批次",
  "lot.initialQuantity": "初始数量",
  "lot.label.print": "打印标签",
  "lot.label.print.failed": "无法生成标签。请重试。",
  "lot.number": "批号",
  "lot.number.hint": "此批次的固定标识符。留空则根据物品代码和当天日期生成。",
  "lot.number.placeholder": "留空则自动生成",
  "lot.qcStatus.FAILED": "失败数量",
  "lot.qcStatus.PASSED": "通过",
  "lot.qcStatus.PENDING": "待处理",
  "lot.qcStatus.QUARANTINED": "已隔离",
  "lot.qcStatus.hint": "在质控标记为“通过”之前，批次不可用于检测。",
  "lot.qcStatus": "QC状态",
  "lot.receiptDate": "接收日期",
  "lot.save.error": "保存批次时出错",
  "lot.save.error.locationAfterCreate": "批次已创建，但分配储存位置失败。请再次点击保存，仅重试分配，以免批次被重复接收。{reason}",
  "lot.save.success": "批次保存成功",
  "lot.selectItem": "选择目录项",
  "lot.selectLocation": "选择存储位置",
  "lot.status": "状态",
  "lot.status.ACTIVE": "活跃",
  "lot.status.CONSUMED": "已消耗",
  "lot.status.DISPOSED": "已处置",
  "lot.status.EXPIRED": "已过期",
  "lot.status.IN_USE": "使用中",
  "lot.status.QUARANTINED": "已隔离",
  "lot.storageLocation": "存储位置",
  "manage.testing.algorithms.add.reflex.tests": "管理检测算法和反射检测",
  "master.lists.page": "主列表页面",
  "master.lists.page.analyzer": "分析仪检测名称菜单",
  "master.lists.page.barcode": "条码配置",
  "master.lists.page.batchtest": "批量检测重新分配和取消",
  "master.lists.page.external.connections": "外部连接菜单",
  "master.lists.page.field": "字段验证配置 ",
  "master.lists.page.list": "列表插件",
  "master.lists.page.menu": "菜单配置",
  "master.lists.page.notification": "检测通知配置",
  "master.lists.page.order.entry": "订单录入配置",
  "master.lists.page.org": "组织菜单",
  "master.lists.page.patient": "患者录入配置",
  "master.lists.page.printed": "打印报告配置",
  "master.lists.page.provider": "提供者",
  "master.lists.page.report.result": "结果报告配置",
  "master.lists.page.result": "结果录入配置",
  "master.lists.page.site": "站点信息",
  "master.lists.page.test.management": "检测管理",
  "master.lists.page.user": "用户管理",
  "master.lists.page.work.plan": "工作计划配置 ",
  "menu.accession.validation": "按订单",
  "menu.accession.validation.range": "按订单编号范围",
  "menu.billing.active": "计费菜单活跃",
  "menu.billing.address": "计费URL",
  "menu.billing.title": "计费菜单管理",
  "menu.genericSample": "通用样本",
  "menu.genericSample.edit": "编辑订单",
  "menu.genericSample.import": "导入",
  "menu.genericSample.order": "订单",
  "menu.global.title": "全局菜单管理",
  "menu.label.filter": "过滤器：",
  "menu.label.filter.active": "仅活跃",
  "menu.label.filter.admin": "仅管理员",
  "menu.label.filter.role": "按实验室单元角色",
  "menu.nonconform.active": "不符合菜单活跃",
  "menu.nonconform.title": "不符合菜单管理",
  "menu.patient.active": "患者菜单活跃",
  "menu.patient.title": "患者菜单管理",
  "menu.results.range": "按订单编号范围",
  "menu.sidenav.active": "侧边导航活跃",
  "menu.study.active": "研究菜单活跃",
  "menu.study.title": "研究菜单配置",
  "menu.validation.date": "按日期",
  "message.method.activation": "在至少分配一个检测之前，此方法单元不会激活。",
  "message.propertiesupdate.success": "属性更新成功",
  "method.browse.title": "方法部门",
  "method.methodName": "方法名称",
  "method.modal.add.heading": "添加新方法",
  "modal.add.method": "添加新方法",
  "move.back": "向后移动",
  "move.to.aliquot": "移动到分装样本",
  "new.patient.label": "新患者",
  "next.action.button": "下一个",
  "nextLabel.action.button": "下一个标签",
  "no.aliquots": "没有可用的分装样本",
  "no.analysis.found": "没有找到分析",
  "no.data.found": "没有找到数据",
  "no.option": "否",
  "noTestsFound.matching": "没有找到匹配的检测",
  "nonconform.add.new.date": "添加新日期",
  "nonconform.corrective.action": "计划或建议的纠正措施：",
  "nonconform.corrective.actionType": "措施类型",
  "nonconform.corrective.comment": "评论",
  "nonconform.corrective.control": "计划或建议的纠正预防性措施或并发控制：",
  "nonconform.corrective.title": "不符合事件纠正措施",
  "nonconform.date.completed": "完成日期",
  "nonconform.date.discussion.nce": "与NCE staff讨论的日期",
  "nonconform.date.event": "事件日期",
  "nonconform.description.nce": "NCE描述",
  "nonconform.field.date": "NCE日期",
  "nonconform.field.reporting.data": "报告日期",
  "nonconform.goToNceForm": "转到NCE报告表单",
  "nonconform.lab.componenet.nce": "发生NCE的实验室组件",
  "nonconform.label.highseverity": "9 = 非常高严重程度-- 需要立即采取措施",
  "nonconform.label.lowseverity": "1 = 非常低严重程度-- 不需要立即采取措施",
  "nonconform.label.prescibernamesite": "处方者名称和站点",
  "nonconform.label.proposed.action": "建议措施",
  "nonconform.label.reportingunit": "报告单元",
  "nonconform.label.suspected.cause.nce": "NCE的疑似原因",
  "nonconform.nce.concurrent.control.action": "并发控制措施",
  "nonconform.nce.number": "NCE 数字",
  "nonconform.nce.preventive.action": "预防措施",
  "nonconform.nce.resolution": "NCE解决",
  "nonconform.nce.resolution.description": "纠正措施和预防/并发控制是否有效解决了不符合事件并防止其再次发生？",
  "nonconform.nce.turnaround.time": "周转时间",
  "nonconform.order.save.fail": "保存失败",
  "nonconform.order.save.failBecause": "Save failed: {reason}",
  "nonconform.search.nceNumber": "NCE 数字",
  "nonconform.column.date": "日期",
  "nonconform.column.labSection": "Lab Section/Unit",
  "nonconform.search.lastName": "姓",
  "nonconform.search.firstName": "名",
  "nonconform.search.patientCode": "Patient Identification Code",
  "nonconform.search.labNumber": "实验室编号",
  "nonconform.search.specimenType": "标本类型",
  "nonconform.order.save.success": "保存成功",
  "nonconform.person.reporting.different": "报告NCE的人员名称(如果不同)",
  "nonconform.person.responsible": "负责人",
  "nonconform.report": "报告不符合事件(NCE)",
  "nonconform.report.field.date": "报告日期",
  "nonconform.severity.score": "严重程度评分",
  "nonconform.view.comments": "评论",
  "nonconform.view.corrective.action.description": "要采取的纠正措施的描述",
  "nonconform.view.event.date": "事件日期",
  "nonconform.view.event.description": "事件描述",
  "nonconform.view.lab.component": "实验室组件",
  "nonconform.view.nce.category": "NCE类别",
  "nonconform.view.nce.likely.occur": "NCE再次发生的可能性有多大？",
  "nonconform.view.nce.severity": "严重程度",
  "nonconform.view.nce.type": "NCE类型",
  "nonconform.view.preventive.description": "如果适用，预防或并发控制措施的描述",
  "nonconform.view.report": "查看新的不符合事件",
  "nonconform.view.reporting.person": "报告人员",
  "nonconform.view.severe.consequences": "NCE的后果或影响有多严重？",
  "nonconform.view.specimen": "标本",
  "nce.attachment.dropzone": "将文件拖放到此处，或点击上传文件",
  "nce.attachment.error.maxFiles": "最多允许{maxFiles}个文件",
  "nce.attachment.error.size": "文件大小超过了{maxSize}的上限",
  "nce.attachment.error.type": "不允许的文件类型。可接受的类型：{types}",
  "nce.attachment.error.upload": "上传文件时出错",
  "nce.attachment.files": "文件",
  "nce.attachment.hint": "（可选——最大{maxFiles}个文件，每个文件不超过10MB）",
  "nce.attachment.uploading": "正在上传...",
  "nce.category.administrative": "管理",
  "nce.category.analytical": "分析性",
  "nce.category.postanalytical": "分析后",
  "nce.category.preanalytical": "分析前",
  "nce.field.attachments": "附件",
  "nce.field.notes": "备注",
  "nce.field.description.placeholder": "请描述发生了什么、何时发现的，以及任何相关背景……",
  "nce.field.immediateAction": "已采取的紧急措施",
  "nce.field.immediateAction.placeholder": "当时立即采取了哪些纠正措施……",
  "nce.field.linkedItems": "相关样本/结果",
  "nce.field.severity": "严重程度",
  "nce.field.title": "标题",
  "nce.field.title.placeholder": "事件简述……",
  "nce.severity.critical": "紧急",
  "nce.severity.critical.description": "患者安全风险、违反法规",
  "nce.severity.major": "重大",
  "nce.severity.major.description": "对质量或运营产生重大影响",
  "nce.severity.minor": "轻微",
  "nce.severity.minor.description": "影响有限，易于纠正",
  "nce.severity.low": "低",
  "nce.severity.low.description": "影响微乎其微，无需采取纠正措施",
  "nce.status.open": "待处理",
  "nce.status.underInvestigation": "正在调查中",
  "nce.tree.empty": "未找到任何订单。请输入实验室编号以开始搜索。",
  "nce.tree.loading": "正在加载订单...",
  "nce.tree.order": "接收样本",
  "nce.tree.search": "按测试或样本筛选...",
  "nce.tree.selected": "{sampleCount} 样本，已选择{resultCount}的结果",
  "nce.trigger.order_cancellation": "取消订单可能需要提供NCE文件",
  "nce.trigger.partial_sample_rejection": "部分样本被拒需提供NCE文件",
  "nce.trigger.pathology_rejection": "病理学病例被拒可能需要提供NCE文件",
  "nce.trigger.premature_disposal": "过早处置可能需要提供NCE文件",
  "nce.trigger.qc_invalidation": "QC无效需要提供NCE的文件",
  "nce.trigger.referral_rejection": "转诊被拒需提供NCE文件",
  "nce.trigger.result_rejection_no_retest": "若要拒绝检测结果且不进行重新检测，则需提供NCE文件",
  "nce.trigger.result_rejection_retest": "因检测结果被拒而需重新检测的情况，可能需要提供NCE文件",
  "nce.trigger.sample_rejection": "样本拒收需提供NCE文件",
  "nce.trigger.test_cancel_no_results": "考试取消可能需要提供NCE证明文件",
  "nce.trigger.test_cancel_with_results": "若需取消检测并获取结果，须提供NCE相关文件",
  "nce.type.calibration_failure": "校准失败",
  "nce.type.communication_failure": "通信故障",
  "nce.type.contamination": "污染",
  "nce.type.documentation_error": "文档错误",
  "nce.type.equipment_malfunction": "设备故障",
  "nce.type.labeling_error": "标签错误",
  "nce.type.patient_id_mismatch": "患者ID不匹配",
  "nce.type.policy_violation": "违反政策",
  "nce.type.procedure_deviation": "程序偏差",
  "nce.type.qc_failure": "QC失败",
  "nce.type.reagent_issue": "试剂问题",
  "nce.type.report_delay": "报告延迟",
  "nce.type.report_distribution_error": "报告分发错误",
  "nce.type.requisition_incomplete": "采购申请不完整",
  "nce.type.resource_shortage": "资源短缺",
  "nce.type.result_interpretation_error": "结果解释错误",
  "nce.type.sample_collection_error": "样本采集错误",
  "nce.type.staff_competency_issue": "员工能力问题",
  "nce.type.storage_error": "存储错误",
  "nce.type.system_error": "系统错误",
  "nce.type.training_gap": "培训缺口",
  "nce.type.transcription_error": "转录错误",
  "nce.type.transport_issue": "运输问题",
  "nce.type.request_form_error": "请求表单错误",
  "nce.type.equipment_failure": "设备警报",
  "nce.type.procedure_error": "操作错误",
  "nce.type.calibration_error": "校准错误",
  "nce.type.cross_contamination": "交叉污染",
  "nce.type.result_transcription_error": "结果转录错误",
  "nce.type.report_delivery_error": "报告交付错误",
  "nce.type.critical_value_not_reported": "未报告临界值",
  "nce.type.delayed_result": "延迟结果",
  "nce.type.result_amendment": "结果更正",
  "nce.type.training_issue": "培训问题",
  "nce.category.analysis": "Analysis",
  "nce.category.general": "General",
  "nce.category.order": "排序",
  "nce.category.sample": "样本",
  "nce.type.barcodeIssue": "Barcode Issue",
  "nce.type.brokenTubeContainer": "Broken Tube/Container",
  "nce.type.calibrationIssue": "Calibration Issue",
  "nce.type.coagulatedSample": "Coagulated Sample",
  "nce.type.contaminationClient": "Contamination - client",
  "nce.type.contaminationInternal": "Contamination - internal",
  "nce.type.demographicError": "Demographic error",
  "nce.type.employeeConcern": "Employee concern",
  "nce.type.expiredReagentMaterial": "Expired Reagent/Material",
  "nce.type.formIncorrect": "Form incorrect",
  "nce.type.formMissing": "Form missing",
  "nce.type.haemolyticSample": "Hemolytic sample",
  "nce.type.improperSpecimenCollection": "Improper Specimen Collection",
  "nce.type.inadequateSampling": "Inadequate Sampling",
  "nce.type.incorrectMeasurement": "Incorrect measurement of sample or reagent",
  "nce.type.instrumentDowntime": "Instrument Downtime",
  "nce.type.insufficientAmount": "Insufficient Amount",
  "nce.type.inventoryStorage": "Inventory Storage",
  "nce.type.leakage": "Leakage",
  "nce.type.lostSpecimenIrreplacable": "Lost Specimen - Irreplaceable",
  "nce.type.lostSpecimenRedraw": "Lost Specimen - Redraw",
  "nce.type.lotNumberIssue": "Lot Number Issue",
  "nce.type.mislabeledUnlabeled": "Mislabeled/unlabeled specimen",
  "nce.type.missingSample": "Missing Sample",
  "nce.type.otherDescribe": "Other, please describe",
  "nce.type.rerunEquipmentFailure": "Rerun - Equipment Failure",
  "nce.type.rerunInconsistentResults": "Rerun - Inconsistent Results",
  "nce.type.rerunQCFailure": "Rerun- QC Failure",
  "nce.type.resultReported": "Result reported when quality control sample tested out of range",
  "nce.type.sopDeviation": "SOP Deviation (please describe)",
  "nce.type.specimenReceiptDelay": "Specimen Receipt Delay",
  "nce.type.spill": "Spill",
  "nce.type.technologyIssue": "Technology/Computer issue",
  "nce.type.transmissionDelay": "Transmission Delay",
  "nce.type.wrongSpecimen": "Wrong specimen",
  "nce.type.wrongTemperature": "Wrong temperature",
  "nce.type.wrongTestKit": "Wrong Test Kit",
  "nce.button.createNce": "创建 NCE",
  "nce.button.skip": "跳过",
  "nce.creating": "正在创建NCE...",
  "nce.description.placeholder": "请描述该不符合项……",
  "nce.error.create.failed": "无法创建 NCE",
  "nce.error.severity.required": "必须填写严重程度",
  "nce.trigger.mandatory.message": "在执行此操作之前，您必须先创建一个 NCE。",
  "nce.trigger.mandatory.title": "必须具备NCE资格",
  "nce.trigger.order_cancellation.message": "取消订单可能需要提供不符合要求的事件的相关证明文件。",
  "nce.trigger.order_cancellation.title": "订单取消 - NCE",
  "nce.trigger.partial_sample_rejection.message": "部分样本被拒需记录不符合项。",
  "nce.trigger.partial_sample_rejection.title": "部分样本被拒——需提供NCE",
  "nce.trigger.pathology_rejection.message": "病理学病例被拒可能需要提供不符合项的记录。",
  "nce.trigger.pathology_rejection.title": "病理学拒收 - NCE",
  "nce.trigger.premature_disposal.message": "提前处置可能需要对不符合项进行记录。",
  "nce.trigger.premature_disposal.title": "过早处置——NCE",
  "nce.trigger.qc_invalidation.message": "质量控制（QC）无效需要对不符合项进行记录。",
  "nce.trigger.qc_invalidation.title": "QC无效——需要 NCE",
  "nce.trigger.referral_rejection.message": "拒绝转诊需要对不符合项进行记录。",
  "nce.trigger.referral_rejection.title": "转诊申请被拒绝——需提供NCE",
  "nce.trigger.result_rejection_no_retest.message": "若不进行重新检测即拒绝结果，则需记录该不符合项。",
  "nce.trigger.result_rejection_no_retest.title": "结果被拒 - 需提供NCE",
  "nce.trigger.result_rejection_retest.message": "若因结果被拒而需进行重新检测，可能需要记录不符合项。",
  "nce.trigger.result_rejection_retest.title": "结果被拒 - NCE",
  "nce.trigger.sample_rejection.message": "样本拒收需对不符合项进行记录。",
  "nce.trigger.sample_rejection.title": "样本拒收——需提供NCE",
  "nce.trigger.test_cancel_no_results.message": "取消检测可能需要提供不符合项的证明文件。",
  "nce.trigger.test_cancel_no_results.title": "考试取消 - NCE",
  "nce.trigger.test_cancel_with_results.message": "若要取消已产生结果的检测项目，需记录不符合项。",
  "nce.trigger.test_cancel_with_results.title": "考试取消——需参加NCE考试",
  "nce.admin.trigger.config.title": "NCE 触发器配置",
  "nce.admin.trigger.config.description": "配置在何时自动创建或提示生成不符合项。",
  "nce.admin.trigger.behaviors.title": "触发行为",
  "nce.admin.rejection.mappings.title": "拒绝原因映射",
  "nce.admin.rejection.mappings.description": "将拒绝原因映射到NCE类别，以便自动填充数据。",
  "nce.trigger.behavior.mandatory": "必填",
  "nce.trigger.behavior.prompted": "受提示",
  "nce.trigger.behavior.disabled": "已禁用",
  "nce.trigger.column.type": "扳机类型",
  "nce.trigger.column.description": "描述",
  "nce.trigger.column.behavior": "行为",
  "nce.trigger.column.active": "活跃",
  "nce.trigger.type.sampleRejection": "样本拒收",
  "nce.trigger.type.resultRejection": "结果被拒绝",
  "nce.trigger.type.qaEvent": "QA 活动",
  "nce.trigger.type.manual": "手册",
  "nce.trigger.update.success": "触发器配置已更新",
  "nce.trigger.update.error": "无法更新触发器配置",
  "nce.mapping.add": "添加映射",
  "nce.mapping.edit": "编辑映射",
  "nce.mapping.column.rejectionReason": "拒绝原因",
  "nce.mapping.column.category": "NCE类别",
  "nce.mapping.column.type": "NCE类型",
  "nce.mapping.column.severity": "默认值严重程度",
  "nce.mapping.column.active": "活跃",
  "nce.mapping.noData": "未配置任何拒绝映射",
  "nce.mapping.validation.error": "必须填写拒绝原因和类别",
  "nce.mapping.save.success": "映射已成功保存",
  "nce.mapping.active": "活跃",
  "nce.field.category": "类别",
  "nce.field.type": "设备类型",
  "nce.select.category": "选择一个类别",
  "nce.select.type": "选择类型",
  "nce.error.dateOfEvent.required": "必须填写事件日期",
  "nce.error.reportingUnit.required": "必须指定报告单元",
  "nce.error.description.required": "必须填写描述",
  "nce.error.suspectedCauses.required": "必须提供疑似原因",
  "nce.error.proposedAction.required": "需要采取建议措施",
  "nce.error.category.required": "“类别”为必填项",
  "nce.attachment.saveFirst": "保存 NCE 活动以启用文件附件功能",
  "nce.attachment.error.noEvent": "请先保存 NCE 活动，然后再上传附件",
  "nce.attachment.download": "下载",
  "nce.attachment.delete": "删除",
  "requester.add.new.restricted": "管理员已禁用添加新机构的权限。",
  "requester.add.new.restricted.organization.contact": "管理员已禁用为新机构添加联系人信息的功能。请在上方搜索现有机构。",
  "requester.add.new.restricted.provider": "管理员已禁用添加新申请医生的功能。",
  "requester.add.new.restricted.provider.contact": "管理员已禁用为新申请医生输入联系信息的功能。请在上方搜索现有申请医生。",
  "requester.add.new.restricted.requestor": "管理员已禁用添加新请求者的功能。请在上方搜索现有请求者。",
  "requester.contact.search": "请求者搜索",
  "requester.contact.search.helper": "请搜索提出这些检测请求的联系人，或在下方输入新的联系人。必须至少填写“申请机构”或“请求者”其中一项。",
  "requester.organization.add.new": "+ 添加新机构“{name}”",
  "requester.organization.email": "机构电子邮件",
  "requester.organization.fax": "机构传真",
  "requester.organization.new.helper": "保存此订单后，将创建一个新的机构。",
  "requester.organization.new.tag": "新",
  "requester.organization.no.match": "未找到匹配的机构。",
  "requester.organization.phone": "机构电话",
  "requester.organization.search": "查询申请机构",
  "requestor.add.new": "+ 添加新请求者“{name}”",
  "requestor.add.new.restricted": "您的管理员已禁用添加新请求者的功能。",
  "requestor.department": "科室",
  "requestor.email": "电子邮件",
  "requestor.fax": "传真",
  "requestor.firstName": "名",
  "requestor.lastName": "姓",
  "requestor.name": "请求者姓名",
  "requestor.name.placeholder": "请输入请求者姓名",
  "requestor.new.helper": "保存此订单时，将创建一个新的请求者。",
  "requestor.new.tag": "新",
  "requestor.no.match": "未找到匹配的请求者。",
  "requestor.phone": "电话",
  "requestor.search.helper": "请输入至少 2 个字符以进行自动搜索。",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "所有批号",
  "result.pool.filter.allPools": "所有泳池",
  "result.pool.filter.clear": "清除筛选条件",
  "result.pool.filter.count": "显示 {shown}，共 {total} 条结果",
  "result.pool.filter.lot": "按批次筛选",
  "result.pool.filter.pool": "按泳池筛选",
  "result.pool.intake": "进水池",
  "result.pool.subpool": "子池 {n}",
  "result.vectorPool.label": "{count} 只{animal}的混样",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "不确定度必须是一个非负数。",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "样本",
  "sample.priority.ASAP": "尽快",
  "sample.priority.FUTURE_STAT": "预约紧急",
  "sample.priority.ROUTINE": "常规",
  "sample.priority.STAT": "紧急（STAT）",
  "sample.priority.TIMED": "定时",
  "sample.referToReferenceLab.helper": "如果该样本需要在外部参考实验室进行检测，请标记此处。",
  "sampleAcceptance.action.moveDown": "向下移动",
  "sampleAcceptance.action.moveUp": "向上移动",
  "sampleAcceptance.banner.resampledFrom": "这是对样本 #{id} 重新采样后创建的替换样本。",
  "sampleAcceptance.banner.resampledFrom.title": "替换样本",
  "sampleAcceptance.banner.resampledTo": "该样本被拒收并已重新采样。替换订单：{accession}。",
  "sampleAcceptance.banner.resampledTo.title": "重新采样",
  "sampleAcceptance.button.addItem": "添加项目",
  "sampleAcceptance.col.active": "活跃",
  "sampleAcceptance.col.label": "标签",
  "sampleAcceptance.col.order": "订单",
  "sampleAcceptance.col.statusForDomain": "该领域的状态",
  "sampleAcceptance.domain.all": "所有领域",
  "sampleAcceptance.domain.clinical": "临床",
  "sampleAcceptance.domain.environmental": "环境",
  "sampleAcceptance.domain.vector": "病媒",
  "sampleAcceptance.enforcement.help": "执行规则按领域设置，而不是按实验室单元设置：一名接待员可能负责多个实验室单元。",
  "sampleAcceptance.enforcement.label": "检查清单的执行 — {domain}",
  "sampleAcceptance.enforcement.mandatory": "必填 — 完成前禁止执行第3步",
  "sampleAcceptance.enforcement.off": "关闭：隐藏检查清单",
  "sampleAcceptance.enforcement.optional": "可选 — 记录但不阻塞",
  "sampleAcceptance.gate.blocked": "此领域必须进行接收验收：在此订单继续处理之前，请接受所有标本（或报告不符合事件/重新采样）。",
  "sampleAcceptance.labWide.heading": "全实验室通用项目（除非特定领域另有规定，否则均适用）",
  "sampleAcceptance.labWide.inherited": "全实验室通用项目：已继承（生效中的回退）",
  "sampleAcceptance.labWide.superseded": "全实验室通用项目：此处已被取代（请在“所有领域”中编辑）",
  "sampleAcceptance.notify.enforcementSaved": "执行规则已更新",
  "sampleAcceptance.notify.itemAdded": "已添加检查清单项目",
  "sampleAcceptance.notify.itemSaved": "已保存检查清单项目",
  "sampleAcceptance.notify.recordFailed": "记录验收失败",
  "sampleAcceptance.notify.rejectFailed": "拒绝失败",
  "sampleAcceptance.notify.resampleFailed": "重采样失败",
  "sampleAcceptance.ownItems.empty": "尚无项目：该领域将回退使用下方的全实验室列表。",
  "sampleAcceptance.ownItems.heading": "{domain} 项",
  "sampleAcceptance.qa.accepted.success": "已记录验收",
  "sampleAcceptance.qa.answer.fail": "失败",
  "sampleAcceptance.qa.answer.na": "不适用",
  "sampleAcceptance.qa.answer.pass": "通过",
  "sampleAcceptance.qa.button.accept": "接受样本",
  "sampleAcceptance.qa.button.reject": "拒绝",
  "sampleAcceptance.qa.button.resample": "重新采样",
  "sampleAcceptance.qa.context.collected": "已采样",
  "sampleAcceptance.qa.context.longTransit": "运输时间较长：由您判断",
  "sampleAcceptance.qa.context.note": "运输时间仅供参考，不会自动评定任何项目。当前生效列表：{domain}。",
  "sampleAcceptance.qa.context.received": "已接收",
  "sampleAcceptance.qa.context.transit": "运输时间",
  "sampleAcceptance.qa.empty": "此领域尚未配置验收检查清单。",
  "sampleAcceptance.qa.failHint": "该样本有未通过的检查项：请报告不符合事件或重新采样，而不是接受。",
  "sampleAcceptance.qa.failHint.reject": "This sample has failed checks. Report an NCE or reject it instead of accepting.",
  "sampleAcceptance.qa.noSample": "请先保存采集信息，以便对该标本进行接收验收。",
  "sampleAcceptance.qa.note.label": "备注（可选）",
  "sampleAcceptance.qa.note.placeholder": "可选——记录任何观察到的状况",
  "sampleAcceptance.qa.status.accepted": "已接受",
  "sampleAcceptance.qa.status.pending": "待处理",
  "sampleAcceptance.qa.status.rejected": "已拒收",
  "sampleAcceptance.qa.status.review": "复核",
  "sampleAcceptance.qa.subtitle": "完成此样本的验收清单",
  "sampleAcceptance.qa.subtitle.rejected": "该标本已拒收并重新采样——仅供查阅。",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "This sample was rejected — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "此捕获已拒收——只读。",
  "sampleAcceptance.qa.title": "接收验收",
  "sampleAcceptance.reject.commit": "确认拒绝",
  "sampleAcceptance.reject.comment.label": "签名评论",
  "sampleAcceptance.reject.info": "将此捕获物作为不可用样本拒绝。该捕获物无法重新采集，因此不会创建替换订单。",
  "sampleAcceptance.reject.info.eqa": "Reject this proficiency-testing sample. PT material cannot be recollected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "原因（根据失败的项目预填——可编辑）",
  "sampleAcceptance.reject.reason.required": "需要填写理由",
  "sampleAcceptance.reject.success": "样本已拒收。",
  "sampleAcceptance.reject.title": "拒绝 — {labNumber}",
  "sampleAcceptance.resample.commit": "提交重采样",
  "sampleAcceptance.resample.info": "拒绝此样本，并创建新的采样单以安排重新采样。将通知请求者。",
  "sampleAcceptance.resample.reason.label": "原因（根据失败的项目预填——可编辑）",
  "sampleAcceptance.resample.reason.required": "需要填写理由",
  "sampleAcceptance.resample.success": "已创建重采样——新订单编号为{accession}。已通知请求者。",
  "sampleAcceptance.resample.title": "重新采样 — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "资格要求",
  "sampleAcceptance.review.col.labNo": "实验室编号",
  "sampleAcceptance.review.col.sampleType": "样本类型",
  "sampleAcceptance.review.col.transit": "运输时间",
  "sampleAcceptance.review.noSamples": "目前尚无已采集的标本可供复核。",
  "sampleAcceptance.review.subtitle": "选择一个样本以完成其验收清单",
  "sampleAcceptance.review.title": "接收验收",
  "sampleAcceptance.status.active": "活跃",
  "sampleAcceptance.status.inactive": "非活跃",
  "sampleAcceptance.status.inheritedActive": "活跃（继承）",
  "sampleAcceptance.status.superseded": "已废止",
  "sampleAcceptance.title": "样本验收清单",
  "sidenav.label.admin.nceTriggerConfig": "触发器配置",
  "sidenav.label.admin.nceCategoryType": "类别与类型",
  "sidenav.label.admin.nceConfig": "不符合事件配置",
  "nce.admin.categorytype.title": "NCE类别与类型配置",
  "nce.admin.categorytype.description": "管理“不符合项”可用的类别和设备类型。",
  "nce.admin.tab.categories": "类别",
  "nce.admin.tab.types": "设备类型",
  "nce.admin.category.add": "添加类别",
  "nce.admin.category.edit": "编辑类别",
  "nce.admin.category.name.required": "类别名称为必填项",
  "nce.admin.category.save.success": "类别已成功保存",
  "nce.admin.category.save.error": "保存失败",
  "nce.admin.type.add": "添加设备类型",
  "nce.admin.type.edit": "编辑类型",
  "nce.admin.type.validation.error": "设备类型和类别必须填写",
  "nce.admin.type.save.success": "设备类型已成功保存",
  "nce.admin.type.save.error": "保存失败",
  "nce.admin.column.name": "名称",
  "nce.admin.column.displayKey": "显示键",
  "nce.admin.column.typesCount": "设备类型数量",
  "nce.admin.column.category": "类别",
  "nce.admin.column.actions": "操作",
  "nce.admin.field.name": "名称",
  "nce.admin.field.displayKey": "显示键（用于国际化）",
  "nce.admin.field.displayKey.helper": "可选。用于翻译。",
  "nce.admin.field.category": "类别",
  "nce.admin.delete.confirm.title": "确认删除",
  "nce.admin.delete.confirm.message": "您确定要删除“{name}”吗？此操作无法撤销。",
  "nce.admin.delete.success": "已成功删除",
  "nce.inline.title": "报告不符合事件",
  "nce.inline.context": "上下文（自动填充）",
  "nce.dashboard.breadcrumb": "NCE > All NCEs",
  "nce.dashboard.title": "所有NCE",
  "nce.dashboard.subtitle": "实验室中所有未关闭的NCE",
  "nce.dashboard.daysSince": "{count} days",
  "nce.button.reportNce": "报告NCE",
  "nce.search.placeholder": "搜索 NCE...",
  "nce.filter.allStatus": "所有状态",
  "nce.filter.allCategories": "所有类别",
  "nce.filter.allSeverities": "所有严重程度",
  "nce.filter.clearAll": "清除所有",
  "nce.summary.critical": "紧急",
  "nce.summary.major": "重大",
  "nce.summary.minor": "轻微",
  "nce.summary.overdue": "已逾期",
  "nce.tag.overdue": "已逾期",
  "nce.tab.eventDetails": "事件详情",
  "nce.tab.investigation": "调查",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "历史",
  "nce.field.suspectedCauses": "疑似原因",
  "nce.field.proposedAction": "建议措施",
  "nce.field.trigger": "触发器",
  "nce.capReason.time_24h": "已关联 {count} 个样本，仅限 24 小时窗口内",
  "nce.capReason.count_50": "已关联 {count} 个样本，仅保留最近的 50 个",
  "nce.capa.noItems": "目前尚未记录任何纠正/预防措施。",
  "nce.capa.dueDate": "截止日期",
  "nce.history.noItems": "无历史记录。",
  "nce.history.system": "系统",
  "nce.action.acknowledge": "确认",
  "nce.action.assignTo": "分配给",
  "nce.action.addNote": "添加备注",
  "nce.action.close": "关闭 NCE",
  "nce.action.startCorrectiveAction": "开始纠正措施",
  "nce.link.duplicate.warning": "这些标本已与该NCE相关联",
  "nce.list.empty": "未找到符合您条件的NCE。",
  "nce.modal.addNote": "添加备注",
  "nce.modal.addNoteDescription": "在 NCE {nceNumber} 上添加一条备注",
  "nce.modal.notePlaceholder": "请输入您的备注...",
  "nce.modal.assign": "分配 NCE",
  "nce.modal.assignDescription": "将 NCE {nceNumber} 分配给某位用户",
  "nce.modal.selectUser": "选择用户",
  "nce.modal.searchUser": "搜索用户...",
  "nce.assign.selectUser": "请选择要分配的用户",
  "nce.assign.success": "NCE 已成功分配",
  "nce.assign.error": "无法分配 NCE",
  "nce.acknowledge.success": "NCE 已成功确认",
  "nce.acknowledge.error": "未能确认 NCE",
  "nce.note.empty": "请输入备注",
  "nce.note.success": "备注已成功添加",
  "nce.note.error": "添加备注失败",
  "nce.attachment.downloadError": "下载附件失败",
  "nce.attachment.viewError": "无法查看附件",
  "not.available": "不可用",
  "not.specified": "未指定",
  "notAuthenticated": "未认证",
  "notebook.attachments.title": "附件",
  "notebook.attachments.uploadPrompt": "点击上传文件",
  "notebook.auditTrail.action.archived": "归档",
  "notebook.auditTrail.action.created": "创建",
  "notebook.auditTrail.action.finalized": "最终确定",
  "notebook.auditTrail.action.locked": "锁定",
  "notebook.auditTrail.action.submitted": "已提交",
  "notebook.auditTrail.action.updated": "更新",
  "notebook.auditTrail.comingSoon": "审计跟踪功能即将可用。",
  "notebook.auditTrail.none.subtitle": "未找到此笔记本的审计跟踪条目。",
  "notebook.auditTrail.none.title": "无可用审计跟踪",
  "notebook.auditTrail.title": "审计跟踪",
  "notebook.button.edit": "编辑",
  "notebook.button.editResults": "编辑结果",
  "notebook.button.enterResults": "输入结果",
  "notebook.button.newLabNotebook": "项目",
  "notebook.button.view": "查看",
  "notebook.comments.add.button": "添加评论",
  "notebook.comments.add.label": "添加评论",
  "notebook.comments.none.subtitle": "尚未添加任何评论。",
  "notebook.comments.none.title": "无评论",
  "notebook.comments.title": "评论",
  "notebook.error.notAssigned": "您未分配到此项目",
  "notebook.heading.allEntries": "所有条目",
  "notebook.heading.notebooks": "项目",
  "notebook.icon.edit": "编辑",
  "notebook.instruments.title": "仪器",
  "notebook.label.addpage": "添加页面",
  "notebook.label.author": "作者",
  "notebook.label.basicinfo": "基本信息",
  "notebook.label.content": "主要内容",
  "notebook.label.dashboard": "笔记本仪表板",
  "notebook.label.drafts": "草稿",
  "notebook.label.entry": "笔记本条目",
  "notebook.label.entryFiles": "条目文件",
  "notebook.label.instanceEntry": "笔记本实例条目",
  "notebook.label.entryTags": "条目标签",
  "notebook.label.experimentDoc": "实验文档",
  "notebook.label.experimentType": "实验类型",
  "notebook.label.filter.types": "实验类型",
  "notebook.label.finalized": "本周已完成",
  "notebook.label.formEntry": "笔记本表单录入",
  "notebook.label.objective": "目标",
  "notebook.label.pages": "工作流页面",
  "notebook.label.pending": "等待审查",
  "notebook.label.project": "项目",
  "notebook.label.project.title": "项目标题",
  "notebook.label.projectFiles": "项目文件",
  "notebook.label.projectTags": "项目标签",
  "notebook.label.protocol": "协议ID",
  "notebook.label.questionnaire": "问卷",
  "notebook.label.sampleManagement": "样本管理",
  "notebook.label.status": "状态",
  "notebook.label.technician": "技术员",
  "notebook.label.title": "条目标题",
  "notebook.label.total": "总条目数",
  "notebook.page.completed": "已完成",
  "notebook.page.content": "内容：",
  "notebook.page.instructions": "说明：",
  "notebook.page.markComplete": "标记为完成",
  "notebook.page.modal.add.errorRequired": "标题和内容是必需的。",
  "notebook.page.modal.add.title": "添加新页面",
  "notebook.page.modal.content.label": "内容",
  "notebook.page.modal.edit.title": "编辑页面",
  "notebook.page.modal.instructions.label": "说明",
  "notebook.page.modal.title.label": "标题",
  "notebook.page.title": "笔记本",
  "notebook.pages.none.subtitle": "点击添加页面",
  "notebook.pages.none.title": "未添加页面",
  "notebook.project.definition.form.title": "项目定义表单",
  "notebook.project.entry.form.title": "项目录入表单",
  "notebook.results.modal.title": "{accession}的结果",
  "notebook.results.noAccession": "此样本无订单号可用",
  "notebook.results.none.subtitle": "未找到提供的订单号的结果。",
  "notebook.results.none.title": "未找到结果",
  "notebook.results.title": "结果",
  "notebook.sample.result.dateCreated": "创建日期",
  "notebook.samples.available": "可用样本",
  "notebook.samples.none.subtitle": "按患者或订单号搜索样本",
  "notebook.samples.none.subtitle.selected": "点击添加样本",
  "notebook.samples.none.title": "无可用样本",
  "notebook.samples.none.title.selected": "未选择样本",
  "notebook.samples.resultsRecorded": "结果记录：",
  "notebook.samples.selected": "已选样本",
  "notebook.search.byAccession": "按订单号搜索",
  "notebook.search.byPatient": "按患者搜索",
  "notebook.select.label": "选择笔记本",
  "notebook.select.none": "无（仅默认字段）",
  "notebook.select.optional": "选择笔记本（可选）",
  "notebook.status.archived": "归档条目",
  "notebook.status.assignment.title": "状态和分配",
  "notebook.status.draft": "保存草稿",
  "notebook.status.finalized": "最终确定条目",
  "notebook.status.locked": "锁定条目",
  "notebook.status.metadata.title": "状态和元数据",
  "notebook.status.submitted": "提交审查",
  "notebook.tab.attachments": "附件",
  "notebook.tab.auditTrail": "审计跟踪",
  "notebook.tab.comments": "评论",
  "notebook.tab.content": "内容",
  "notebook.tab.entryDetails": "条目详情",
  "notebook.tab.metadata": "元数据",
  "notebook.tab.results": "结果",
  "notebook.tab.samples": "样本",
  "notebook.tab.workflow": "工作流",
  "notebook.table.header.entries": "条目",
  "notebook.tag.placeholder": "输入标签",
  "notebook.tags.add": "添加标签",
  "notebook.tags.modal.add.errorRequired": "标签是必需的。",
  "notebook.tags.modal.add.label": "标签",
  "notebook.tags.modal.add.title": "添加新标签",
  "notebook.tags.title": "标签",
  "notebook.validation.content.required": "主要内容是必需的。",
  "notebook.validation.objective.required": "目标是必需的。",
  "notebook.validation.project.required": "项目是必需的。",
  "notebook.validation.protocol.required": "协议ID是必需的。",
  "notebook.validation.title.required": "标题是必需的。",
  "notebook.validation.type.required": "实验类型是必需的。",
  "notification.error": "错误",
  "notification.info": "信息",
  "notification.invalid.confirm.password": "您输入的密码与上述密码不同。",
  "notification.invalid.loginName": "登录名只能包含字母以及字符 . _ @ -（不能包含数字）。",
  "notification.invalid.name": "请输入仅包含字母数字的值。",
  "notification.invalid.password": "请按照说明输入密码。",
  "notification.login.generic.error": "尝试登录时出错",
  "notification.login.syntax.error": "尝试登录时出错 - 无法将响应解析为JSON",
  "notification.organization.post.delete.success": "机构停用成功。",
  "notification.organization.post.internetAddress": "输入有效的组织URL。",
  "notification.organization.post.save.success": "机构信息添加成功。",
  "notification.organization.post.success": "机构信息更新成功。",
  "notification.password.change.fail": "密码更改失败",
  "notification.password.change.success": "密码更改成功",
  "notification.response.syntax.error": "错误 - 无法将响应解析为JSON",
  "notification.resultSelectList.post.save.success": "结果选择列表已成功保存。",
  "notification.resultSelectList.post.update.success": "结果选择列表已成功更新。",
  "notification.slideover.button.hideread": "隐藏已读",
  "notification.slideover.button.markallasread": "全部标记为已读",
  "notification.slideover.button.markasread": "标记为已读",
  "notification.slideover.button.reload": "重新加载",
  "notification.slideover.button.showread": "显示已读",
  "notification.slideover.button.subscribe": "在此设备上订阅",
  "notification.slideover.button.subscribe.fail": "订阅失败",
  "notification.slideover.button.subscribe.success": "订阅成功",
  "notification.slideover.button.unsubscribe": "取消订阅",
  "notification.slideover.button.unsubscribe.fail": "取消订阅失败",
  "notification.slideover.button.unsubscribe.success": "取消订阅成功",
  "notification.slideover.empty.header": "您已全部完成",
  "notification.sliderover.empty.message": "您目前没有任何通知。",
  "notification.success": "成功",
  "notification.title": "通知消息",
  "notification.user.add.success": "用户信息已成功添加。",
  "notification.user.post.delete.success": "用户停用成功。",
  "notification.user.post.save.success": "用户信息添加成功。",
  "notification.user.update.success": "用户信息已成功更新。",
  "notify.error": "用户和消息是必需的",
  "notify.main.title": "通知用户",
  "notify.message": "消息",
  "notify.user.by": "要通知的用户",
  "notify.user.success.notification": "通知发送成功",
  "of": "的",
  "openreports.activity.title": "活动报告",
  "openreports.aggregate.title": "汇总报告",
  "openreports.all.test.summary.title": "检测报告摘要",
  "openreports.all.tests.aggregate": "所有检测摘要",
  "openreports.hiv.aggregate": "HIV检测摘要",
  "openreports.management.title": "管理报告",
  "openreports.mgt.nonconformity.date": "按日期的不符合报告",
  "openreports.mgt.nonconformity.section": "按单元和原因的不符合报告",
  "openreports.mgt.rejection": "拒绝报告",
  "openreports.patient.EID.version1": "EID版本1",
  "openreports.patient.EID.version2": "EID版本2",
  "openreports.patient.VL.version1": "VL国家版本",
  "openreports.patientTestStatus": "患者状态报告",
  "openreports.patientreports.title": "患者状态报告",
  "openreports.stat.aggregate": "统计报告",
  "order.accept": "接受",
  "order.accept.error": "无法接受订单",
  "order.additionalInfo": "附加信息",
  "order.additionalInfo.helper": "关于此订单的可选备注",
  "order.clinicalInfo": "临床信息",
  "order.continue": "继续",
  "order.current.time": "当前时间 (hh:mm)",
  "order.dashboard.empty": "未找到任何订单",
  "order.dashboard.title": "订单仪表板",
  "order.department.label": "病房/科室/单元：",
  "order.diagnosis.helper": "初步诊断，用于指导检测选择。不作为确诊诊断记录。",
  "order.diagnosis.placeholder": "输入诊断结果或临床备注",
  "order.entry.setup": "批量订单录入设置",
  "order.external": "外部",
  "order.facility": "设施",
  "order.filter.priority": "按优先级筛选",
  "order.filter.status": "状态",
  "order.fixIssue": "修复问题",
  "order.form.label": "表单：",
  "order.form.select": "选择表单",
  "order.generate.barcode": "生成条码并保存",
  "order.generate.barcode.history": "之前使用的实验室编号",
  "order.if.other.label": "如果是其他请指定：",
  "order.invalid.requester.name.label": "无效的请求者姓名",
  "order.invalid.site.name": "无效站点名称",
  "order.labNumber": "实验室编号",
  "order.labNumber.generate": "生成实验室编号",
  "order.labNumber.helper": "此订单的唯一标识符",
  "order.attachment.action.delete": "删除附件",
  "order.attachment.action.download": "下载附件",
  "order.attachment.action.view": "查看附件",
  "order.attachment.column.actions": "操作",
  "order.attachment.column.fileName": "文件名称",
  "order.attachment.column.fileSize": "大小",
  "order.attachment.column.fileType": "设备类型",
  "order.attachment.column.uploadedAt": "上传于",
  "order.attachment.delete.confirm.body": "您确定要删除“{fileName}”吗？此操作无法撤销。",
  "order.attachment.delete.confirm.title": "删除附件",
  "order.attachment.delete.failed": "无法删除该附件。请重试。",
  "order.attachment.dropzone": "将文件拖放到此处，或点击浏览文件",
  "order.attachment.empty": "目前尚无附件。",
  "order.attachment.saveFirst": "保存订单后才能添加附件。",
  "order.attachment.error.maxFiles": "您最多可以附加{maxFiles}个文件。",
  "order.attachment.error.size": "每个文件的大小必须不超过{maxSize}。",
  "order.attachment.error.type": "允许的文件类型：{types}",
  "order.attachment.heading": "附件",
  "order.attachment.hint": "可选。最多{maxFiles}个文件，每个文件大小不超过10MB。支持格式：PDF、JPG、PNG、TIFF。",
  "order.attachment.upload.failed": "无法上传一个或多个附件。",
  "order.labNumber.placeholder": "输入或生成实验室编号",
  "order.label.add": "添加订单",
  "order.label.modify": "修改订单",
  "order.legend.EDTATube": "EDTA管",
  "order.legend.commonFields": "公共字段",
  "order.legend.configureBarcode": "配置条码录入",
  "order.legend.dryBloodSpot": "干血斑",
  "order.legend.dryTube": "干燥管",
  "order.legend.facility": "设施",
  "order.legend.onDemand": "按需",
  "order.legend.optionalFields": "可选字段",
  "order.legend.patient": "患者信息",
  "order.legend.preDemand": "预印",
  "order.legend.sample": "样本",
  "order.legend.selectMethod": "选择方法",
  "order.legend.siteName": "站点名称",
  "order.legend.specimen.collected": "已采集标本",
  "order.legend.tests": "检测",
  "order.legend.viralLoadTest": "病毒载量检测",
  "order.lastUpdated": "最后更新时间",
  "order.load.error": "加载订单失败",
  "order.location": "位置",
  "order.new": "新订单",
  "order.payment.status.label": "患者支付状态：",
  "order.paymentStatus": "付款状态",
  "order.previousLabNumber": "之前的实验室编号",
  "order.previousLabNumber.placeholder": "如有，请输入之前的实验室编号",
  "order.printLabels": "打印条码",
  "order.printLabels.info": "打印此订单的条码",
  "order.priority": "优先级",
  "order.progress": "进度",
  "order.provisionalDiagnosis": "初步诊断",
  "order.received.time": "接收时间（hh:mm）",
  "order.reception.time": "接收时间 (hh:mm)：",
  "order.remember.site.and.requester.label": "记住站点和请求者",
  "order.readonly.message": "此订单处于只读模式",
  "order.requester": "请求者",
  "order.requester.email.label": "请求者电子邮件：",
  "order.requester.fax.label": "请求者传真号码：",
  "order.requester.firstName.label": "请求者名：",
  "order.requester.lastName.label": "请求者姓：",
  "order.requester.phone.label": "请求者电话：",
  "order.requester.provisionalDiagnosis.label": "临时临床诊断：",
  "order.result.reporting.heading": "结果报告",
  "order.sampleCategory": "样本类别",
  "order.sampleCategory.helper": "选择要采集的样本类别",
  "order.sampling.performed.label": "已执行采样用于分析：",
  "order.search.requester.label": "搜索请求者",
  "order.saveStatus.error": "保存失败",
  "order.saveStatus.saved": "已保存",
  "order.saveStatus.saving": "保存中...",
  "order.saveStatus.unsaved": "未保存的更改",
  "order.save.blocked": "订单未保存",
  "order.save.notPersisted": "服务器已接受该订单，但未为其存储任何样本。请在继续前检查该订单。",
  "order.save.incomplete": "请在保存前添加一名患者（或采样点）和至少一种样本类型。",
  "order.save.incomplete.fields": "保存前请添加{fields}。",
  "order.save.incomplete.and": "和",
  "order.save.requirements.title": "保存前必填",
  "order.save.requirement.labNumber": "实验室编号",
  "order.save.requirement.patient": "患者",
  "order.save.requirement.samplingSite": "采样站点",
  "order.save.requirement.collectionSite": "采集站点",
  "order.save.requirement.requesterOrRequestor": "申请机构或请求者",
  "order.sample.missingTests": "样本 {sampleNumber} 有样本类型但没有检测。保存前请添加检测或移除该样本。",
  "order.sample.missingTests.named": "Sample {sampleNumber}: {sampleType} has no test. Add a test or remove the sample before saving.",
  "order.save.requirement.sampleType": "至少一种样本类型",
  "order.save.requirement.site": "申请站点",
  "order.save.requirement.patientSex": "患者性别",
  "order.save.requirement.patientBirthDate": "患者出生日期",
  "order.save.requirement.nationalId": "患者国家ID",
  "order.save.requirement.validEmail": "有效的电子邮件地址",
  "order.requestDate": "订单日期",
  "order.nextVisitDate": "下次就诊日期",
  "order.sampleHandling": "样本处理",
  "sampleAcceptance.qa.button.continueWithTesting": "继续检测",
  "sampleAcceptance.qa.continueWithTesting.reason": "检查未通过，为何仍要检测此样本？",
  "sampleAcceptance.qa.continueWithTesting.record": "记录并继续",
  "order.eqaSample": "室间质评（EQA）样本",
  "order.noPatient": "此订单没有患者",
  "order.noPatient.reason": "无患者下单的原因",
  "order.noPatient.reason.eqa": "室间质评样本",
  "order.noPatient.warning.title": "结果将不会按参考范围进行评估",
  "order.noPatient.warning.subtitle": "没有患者就没有可用于选择参考范围的年龄或性别，因此此订单的结果不会被标记为正常或异常。",
  "order.noPatient.butPatientChosen": "此订单已关联患者，因此不会记录“无患者”的决定。",
  "order.rangeNotApplied.warning.title": "部分结果将不会按参考范围进行核查",
  "order.rangeNotApplied.warning.subtitle": "未记录患者性别或年龄，而以下检测的范围依赖于此：{tests}。其结果在发布前需要复核。",
  "order.rangeNotApplied.warning.reportNce": "报告不符合事件",
  "order.eqa.program": "室间质评计划",
  "order.eqa.providerSampleId": "供应商样本编号",
  "order.eqa.deadline": "截止日期",
  "order.eqa.priority": "优先级",
  "order.rememberSiteAndRequester": "为我的下一个订单记住此站点和请求者",
  "order.testLocationCode": "采样执行地点",
  "order.testLocationCode.other": "其他原因",
  "order.testLocationCode.otherLabel": "如为其他，请注明",
  "provider.fax.invalid": "请输入有效的传真号码，仅限数字和 + ( ) -。",
  "provider.email.invalid": "请输入有效的电子邮件地址，例如 lab@example.org。",
  "order.save.requirement.provider": "申请医生",
  "order.save.requirement.testsPerSample": "每个样本至少一项检测或面板",
  "order.saved.draft": "草稿已保存",
  "order.saved.title": "已保存订单 {labNumber}",
  "order.saved.next": "下一步：{step}",
  "order.search.placeholder": "搜索订单……",
  "order.search.site.name": "搜索站点名称",
  "order.send.toAnalyzer": "发送至分析仪",
  "order.send.modal.title": "将订单发送至分析仪",
  "order.send.modal.confirm": "发送",
  "order.send.modal.cancel": "取消",
  "order.send.modal.analyzerLabel": "目标分析仪",
  "order.send.modal.accession": "物种编号：{accession}",
  "order.send.modal.noAnalyzers": "未为 LIS 发起的外送配置任何分析仪。",
  "order.send.success": "订单已发货",
  "order.send.error": "订单派送失败",
  "order.send.unknownError": "未知桥接错误",
  "order.send.missingAccession": "该订单没有可用于关联该结果的订单号。",
  "order.site.name": "站点名称：",
  "order.step.collect": "采集",
  "order.step.complete": "完成",
  "order.step.enter": "录入订单",
  "order.step.label": "贴标签与存储",
  "order.step.patient.info": "患者信息",
  "order.step.program.selection": "程序选择",
  "order.step.qa": "质量保证复核",
  "order.step.prepare": "准备样本",
  "order.step.sampleCheck": "样本核查",
  "order.step.notStarted": "待处理的订单",
  "order.step.done": "打印完成",
  "order.step.doneAt": "完成于 {time}",
  "order.step.toDo": "{count} 项待办",
  "order.step.ready": "就绪",
  "order.nav.saveExit": "保存并退出",
  "order.nav.saveNext": "保存并下一步",
  "order.nav.saveFinish": "保存并完成",
  "order.nav.discard.title": "放弃未保存的更改？",
  "order.nav.discard.body": "此页面未保存的更改将丢失（{samples} 个样本，{tests} 项检测）。",
  "order.nav.discard.order": "放弃订单",
  "order.nav.discard.changes": "放弃更改",
  "order.continue.heading": "继续到{step}",
  "order.continue.count": "还需完成 {count} 项才能继续",
  "order.continue.countOne": "还需完成 1 项才能继续",
  "order.continue.item.patient": "选择或创建患者",
  "order.continue.item.labNumber": "添加实验室编号",
  "order.continue.item.nationalId": "输入患者的国家ID",
  "order.continue.item.patientSex": "选择患者性别",
  "order.continue.item.birthDate": "输入患者的出生日期",
  "order.continue.item.sampleType": "至少添加一种样本类型",
  "order.continue.item.provider": "添加申请医生",
  "order.continue.item.noTests": "样本 {number}：至少选择一项检测",
  "order.continue.item.noTestsOnSample": "{sample} 没有检测项目。请在录入订单中添加，或移除该样本",
  "errors.samples.with.no.tests": "有样本没有检测。请在录入订单中添加检测，或删除该样本。",
  "order.continue.item.collectionTime": "{sample} 的采集日期和时间",
  "order.continue.item.consent": "记录知情同意",
  "order.continue.item.acceptance": "填写样本接受核查表",
  "order.status.entered": "已录入",
  "order.status.samplesPrepared": "样本已准备",
  "order.status.readyForTesting": "可检测",
  "order.status.cancelled": "已取消",
  "order.status.complete": "完成",
  "order.cancelled.notice": "该订单已取消：{reason}",
  "order.cancelled": "该订单已取消",
  "order.notFound": "未找到订单",
  "order.cancel.reasonRequired": "必须填写取消原因",
  "order.cancel.complete": "订单录入已完成，此处无法再取消该订单",
  "order.cancel.inProgress": "该订单已开始检测，此处无法再取消",
  "order.release.prepareIncomplete": "准备样本尚未完成",
  "order.release.reasonRequired": "在所有样本均被接受前发布的原因",
  "order.finish.title": "订单 {labNo} 已完成",
  "order.finish.subtitle": "订单录入已完成。结果到达后即可录入。",
  "order.finish.backToOrders": "返回订单列表",
  "order.finish.awaiting": "仍在等待样本：{tests}",
  "order.sampleCheck.release": "发布以进行检测",
  "order.sampleCheck.return": "返回准备样本",
  "order.sampleCheck.proceedReason": "在所有样本均被接受前发布的原因",
  "order.sampleCheck.notAcceptedYet": "尚未接受：{samples}。按下“接受样本”后答案才会计入。",
  "order.sampleCheck.released": "订单 {labNo} 已发布以进行检测",
  "order.sampleCheck.disabled.incomplete": "准备样本尚未完成。请先打开并完成样本。",
  "order.dashboard.cancelOrder": "取消订单",
  "order.dashboard.cancel.reason": "取消原因",
  "order.dashboard.cancel.reasonOther": "描述原因",
  "order.dashboard.cancel.other": "其他原因",
  "order.dashboard.cancel.confirm": "取消订单 {labNo}？",
  "order.dashboard.cancel.body": "其检测将被取消，样本将被作废。不会删除任何内容。",
  "order.dashboard.cancelled": "订单 {labNo} 已取消",
  "order.dashboard.filter.cancelled": "已取消",
  "order.dashboard.open": "待处理",
  "order.samples.printLabels": "打印条码",
  "order.samples.notStored": "未存储",
  "storage.noSamples": "在上方添加样本以进行存储。",
  "common.discard": "丢弃",
  "common.stay": "留下",
  "order.start.new": "开始新订单",
  "order.submit.labNumber": "提交时请注明实验室编号",
  "order.submit.success": "订单已成功提交",
  "order.submit.success.labNumber": "实验室编号：{labNumber}",
  "order.submitted.success.msg": "订单已成功提交",
  "order.summary.accessionNumber": "订单号",
  "order.summary.collectionDate": "采集日期",
  "order.dashboard.status.all": "所有状态",
  "order.dashboard.status.inProgress": "进行中",
  "order.dashboard.status.pendingQa": "待样本核查",
  "order.dashboard.status.completed": "已完成",
  "order.dashboard.status.hasReferred": "含转诊检测",
  "order.dashboard.status.referredOut": "转诊",
  "order.dashboard.priority.all": "所有优先级",
  "order.dashboard.priority.stat": "紧急",
  "order.dashboard.priority.asap": "尽快",
  "order.dashboard.priority.timed": "定时",
  "order.dashboard.priority.routine": "常规",
  "order.summary.patientName": "患者姓名",
  "order.summary.sampleType": "样本类型",
  "order.summary.title": "订单摘要",
  "order.test.request.heading": "检测请求",
  "order.title": "订单",
  "ordertests.title": "订单检测",
  "organization.add.placeholder": "字母数字值",
  "organization.add.placeholder.active": "Y 或 N",
  "organization.add.placeholder.internetAddress": "https://组织名称.com",
  "organization.add.placeholder.parent": "上级组织",
  "organization.add.title": "添加组织",
  "organization.city": "城市",
  "organization.clia.number": "CLIA编号",
  "organization.edit.title": "编辑组织",
  "organization.internetaddress": "互联网地址",
  "organization.isActive": "是否活跃",
  "organization.main.title": "组织管理",
  "organization.next": "下一页",
  "organization.organizationName": "组织名称",
  "organization.parent": "上级组织",
  "organization.previous": "上一页",
  "organization.search.byorgname": "按组织名称搜索",
  "organization.search.parent.name": "上级组织名称",
  "organization.search.placeHolder": "按组织名称搜索...",
  "organization.select": "选择",
  "organization.short.CI": "组织前缀",
  "organization.streetAddress": "街道地址",
  "organization.type.CI": "活动类型",
  "organization.type.CI.description": "活动类型：描述",
  "organization.type.CI.name": "活动类型：名称",
  "organization.type.CI.select": "活动类型：选择",
  "otherMalignant.placeholder": "其他恶性",
  "page.breadcrumb.separator": "/",
  "page.title.back": "返回",
  "pagination.backward": "上一页",
  "pagination.forward": "下一页",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "第{min}-{max}项，共{total}项",
  "pagination.items-on-page": "本页 {count} {count, plural, one {项} other {项}}",
  "pagination.items-per-page": "每页项目数",
  "pagination.itemsPerPage": "每页项数",
  "pagination.nextPage": "下一页",
  "pagination.page": "第{page}页",
  "pagination.page-number": "页码",
  "pagination.page-range": "共{total} {total, plural, one {页} other {页}}",
  "pagination.previousPage": "上一页",
  "panel.existing": "现有面板",
  "panel.existing.inactive": "非活跃面板（分配检测以激活）",
  "panel.new": "新面板",
  "panel.panelName": "面板名称",
  "pathology.action.addCassette": "Add cassette",
  "pathology.action.addSlide": "Add slide",
  "pathology.action.deactivateBlock": "Deactivate block {designation}",
  "pathology.action.deactivateCassette": "Deactivate cassette {designation}",
  "pathology.action.deactivateSlide": "Deactivate slide {barcode}",
  "pathology.action.printCassetteLabels": "Print all cassette labels",
  "pathology.action.printSlideLabels": "Print all slide labels",
  "pathology.badge.cassetteCount": "{count, plural, one {# cassette} other {# cassettes}}",
  "pathology.badge.openRequestCount": "{count} 个未完成",
  "pathology.badge.openRequests": "未完成的请求：{names}",
  "pathology.badge.openRequestsMore": "未完成的请求：{names} 及另外 {count} 个",
  "pathology.badge.slideCount": "{count, plural, other {# 张切片}}",
  "pathology.banner.transitionsLater": "阶段流转将在后续版本中提供。目前请在此处设置阶段。",
  "pathology.empty.noReports": "尚无报告。完成检查所见和结论后即可生成报告。",
  "pathology.empty.stageNotRecorded": "OpenELIS 尚未记录此阶段的工作。病例仍可经过此阶段。",
  "pathology.error.designationConflict": "Another save changed this case at the same moment. Reload the case and try again.",
  "pathology.label.addslide": "添加幻灯片",
  "pathology.label.block": "块",
  "pathology.label.block.number": "块号",
  "pathology.label.blocks": "块",
  "pathology.label.case": "病理病例",
  "pathology.label.caseTitle": "病理病例 {labNumber}",
  "pathology.label.casesInProgress": "进行中的案例",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassettes",
  "pathology.label.complete": "完成",
  "pathology.label.conclusion": "结论",
  "pathology.label.dashboard": "病理学仪表板",
  "pathology.label.deactivating": "Deactivating",
  "pathology.label.designationPending": "Assigned on save",
  "pathology.label.grossexam": "大体检查",
  "pathology.label.location": "位置",
  "pathology.label.microexam": "显微镜检查",
  "pathology.label.newCassette": "New cassette {position}",
  "pathology.label.newSlide": "New slide {position}",
  "pathology.label.parentBlock": "Cut from block",
  "pathology.label.printlabel": "打印标签",
  "pathology.label.refer": "转诊至免疫组织化学",
  "pathology.label.release": "准备发布",
  "pathology.label.report": "病理学报告",
  "pathology.label.request": "请求",
  "pathology.label.requests": "其他病理学请求",
  "pathology.label.review": "等待病理学审查",
  "pathology.label.slide": "幻灯片",
  "pathology.label.slide.add.number": "要添加的幻灯片数",
  "pathology.label.slide.number": "切片编号",
  "pathology.label.slides": "幻灯片",
  "pathology.label.stage": "阶段",
  "pathology.label.techniques": "使用的技术",
  "pathology.label.textconclusion": "文本结论",
  "pathology.label.title": "病理学",
  "pathology.label.view": "查看文件",
  "pathology.locked.nothingToPrint": "No saved labels to print yet",
  "pathology.locked.reasonRequired": "Give a reason before deactivating",
  "pathology.locked.releaseNoPathologist": "病例发布前必须分配病理学家",
  "pathology.locked.releaseNoTechnician": "病例发布前必须分配技术员",
  "pathology.locked.saveBeforeDeactivate": "Save or discard your changes before deactivating",
  "pathology.locked.slideNeedsBlock": "Pick the block this slide was cut from",
  "pathology.locked.slideNeedsSavedBlock": "Save a cassette before adding a slide",
  "pathology.locked.stageDisabled": "本实验室未跟踪",
  "pathology.modal.deactivateBlockHeading": "Deactivate block {designation}?",
  "pathology.modal.deactivateBody": "The record is kept and stays available under Show deactivated. Cassettes, blocks and slides are never deleted.",
  "pathology.modal.deactivateCassetteHeading": "Deactivate cassette {designation}?",
  "pathology.modal.deactivateFailed": "The deactivation was refused. Reload the case and try again.",
  "pathology.modal.deactivateSlideHeading": "Deactivate slide {barcode}?",
  "pathology.section.caseInfo": "病例信息",
  "pathology.section.findings": "检查所见和结论",
  "pathology.section.review": "病理学家复核",
  "pathology.stage.accessioned": "已登记",
  "pathology.stage.completed": "已完成",
  "pathology.stage.coverslipping": "封片和质控",
  "pathology.stage.decalcification": "脱钙",
  "pathology.stage.embedding": "包埋",
  "pathology.stage.grossing": "取材",
  "pathology.stage.microtomy": "切片制备",
  "pathology.stage.processing": "处理",
  "pathology.stage.readyPathologist": "待病理学家处理",
  "pathology.stage.staining": "染色",
  "pathology.stage.underReview": "病理学家复核中",
  "pathology.toast.blockDeactivated": "Block {designation} deactivated",
  "pathology.toast.cassetteDeactivated": "Cassette {designation} deactivated",
  "pathology.toast.slideDeactivated": "Slide {barcode} deactivated",
  "patient.address.camp": "营地/公社",
  "patient.address.fokontany": "福孔塔尼",
  "patient.address.hamletOrLot": "村庄 / 地块",
  "patient.address.healthdistrict": "地区",
  "patient.address.healthregion": "区域",
  "patient.address.province": "省",
  "patient.address.street": "街道",
  "patient.address.town": "城镇",
  "patient.age.days": "天",
  "patient.age.months": "月",
  "patient.age.years": "年龄/年",
  "patient.alias": "别名",
  "patient.dataSourceName": "数据源名称",
  "patient.dob": "出生日期",
  "patient.dob.future": "出生日期不能是未来日期。",
  "patient.validation.contactEmailInvalid": "Enter a valid email address for the contact.",
  "patient.validation.dobInvalid": "Enter a valid date of birth.",
  "patient.validation.dobOrAgeRequired": "Enter a date of birth or an age in years, months or days.",
  "patient.validation.emailInvalid": "Enter a valid email address.",
  "patient.validation.nationalIdRequired": "Enter the national ID.",
  "patient.validation.sexRequired": "Select the patient's sex.",
  "patient.eduction": "教育",
  "patient.emergency.additional.camp": "输入营地/公社",
  "patient.emergency.additional.district": "输入地区",
  "patient.emergency.additional.education": "输入教育",
  "patient.emergency.additional.maritalstatus": "输入婚姻状况",
  "patient.emergency.additional.nationnality": "输入国籍",
  "patient.emergency.additional.othernationality": "输入其他国籍",
  "patient.emergency.additional.region": "输入区域",
  "patient.emergency.additional.street": "输入街道",
  "patient.emergency.additional.town": "输入城镇",
  "patient.emergency.email": "输入紧急联系人电子邮件",
  "patient.emergency.firstname": "输入紧急联系人名",
  "patient.emergency.lastname": "输入紧急联系人姓",
  "patient.emergency.phone": "输入紧急联系人电话",
  "patient.externalId": "国家ID",
  "patient.female": "女性",
  "patient.first.name": "名",
  "patient.gender": "性别",
  "patient.gps.latitude": "GPS纬度",
  "patient.gps.latitude.placeholder": "例如：-18.879190（范围为-90到90）",
  "patient.gps.longitude": "GPS经度",
  "patient.gps.longitude.placeholder": "例如，47.507905（范围为 -180 到 180）",
  "patient.id": "患者ID",
  "patient.information.age": "输入年龄",
  "patient.information.days": "输入天数",
  "patient.information.email": "输入患者电子邮件",
  "patient.information.firstname": "输入患者名",
  "patient.information.healthid": "输入唯一健康标识符",
  "patient.information.lastname": "输入患者姓",
  "patient.information.months": "输入月数",
  "patient.information.nationalid": "输入国籍标识符",
  "patient.information.primaryphone": "输入患者主要电话",
  "patient.label": "患者",
  "patient.label.additionalInfo": "附加信息",
  "patient.label.age": "年龄",
  "patient.label.customNotes": "自定义备注",
  "patient.label.diseaseProgramme": "目标疾病项目",
  "patient.label.occupation": "职业",
  "patient.label.contactphone": "联系电话：{PHONE_FORMAT}",
  "patient.label.email": "电子邮件",
  "patient.label.info": "患者信息",
  "patient.label.modify": "添加或修改患者",
  "patient.label.name": "姓名",
  "patient.label.nopatientid": "无患者信息可用",
  "patient.label.primaryphone": "主要电话：{PHONE_FORMAT}",
  "patient.label.sex": "性别",
  "patient.last.name": "姓",
  "phone.format.international.label": "国际",
  "phone.format.local.label": "本地",
  "patient.male": "男性",
  "patient.maritalstatus": "婚姻状况",
  "patient.merge.activeOrders": "活跃订单",
  "patient.merge.address": "地址",
  "patient.merge.addressesDiffer": "地址不同：{primary} 对比 {secondary}",
  "patient.merge.auditEntries": "审计条目（将保留原始患者）",
  "patient.merge.back": "返回",
  "patient.merge.cancelButton": "取消",
  "patient.merge.clinicalSummary": "临床摘要",
  "patient.merge.confirmButton": "确认合并",
  "patient.merge.confirmCheckbox": "我理解此操作无法撤销，并已验证正在合并正确的患者",
  "patient.merge.confirmMerge": "确认患者合并",
  "patient.merge.conflictNote": "（将使用主要患者的人口统计信息）",
  "patient.merge.conflictingInfo": "检测到冲突信息",
  "patient.merge.contactInfo": "联系信息",
  "patient.merge.county": "县/州",
  "patient.merge.dataToConsolidate": "要合并的数据",
  "patient.merge.demographics": "人口统计",
  "patient.merge.dob": "出生日期",
  "patient.merge.email": "电子邮件",
  "patient.merge.emailsDiffer": "电子邮件不同：{primary} 对比 {secondary}",
  "patient.merge.error.alreadyMerged": "患者已被合并",
  "patient.merge.error.executionFailed": "合并执行失败",
  "patient.merge.error.noPermission": "只有全局管理员可以合并患者",
  "patient.merge.error.patientNotFound": "未找到患者",
  "patient.merge.error.samePatient": "不能将患者与自身合并",
  "patient.merge.error.selectBoth": "请选择两个患者以继续",
  "patient.merge.error.selectPrimary": "请选择哪个患者应作为主要记录",
  "patient.merge.error.validationFailed": "合并验证失败",
  "patient.merge.externalIds": "外部ID",
  "patient.merge.gender": "性别",
  "patient.merge.identifiers": "标识符",
  "patient.merge.identifiersToPreserve": "要保留的标识符（两个患者）",
  "patient.merge.mergeSummary": "合并摘要",
  "patient.merge.mergingFrom": "合并自",
  "patient.merge.mergingLabel": "合并",
  "patient.merge.name": "姓名",
  "patient.merge.nationalId": "国家ID",
  "patient.merge.nationalIds": "国家ID",
  "patient.merge.nextStep": "下一步",
  "patient.merge.noIdentifiers": "未记录标识符",
  "patient.merge.noPatientSelected": "未选择患者",
  "patient.merge.notRecorded": "未记录",
  "patient.merge.orders": "订单",
  "patient.merge.ordersCount": "{count} ({active} 活跃)",
  "patient.merge.patientId": "患者ID",
  "patient.merge.patientIds": "患者ID",
  "patient.merge.patientResults": "患者结果",
  "patient.merge.phone": "电话",
  "patient.merge.phonesDiffer": "电话号码不同：{primary} 对比 {secondary}",
  "patient.merge.postalCode": "邮政编码",
  "patient.merge.primaryLabel": "主要",
  "patient.merge.primaryPatient": "主要患者",
  "patient.merge.reason": "合并原因（必需）",
  "patient.merge.reasonPlaceholder": "输入合并这些患者记录的原因...",
  "patient.merge.recordsReassigned": "{count} 条记录已重新分配",
  "patient.merge.samples": "样本",
  "patient.merge.searchDifferent": "搜索不同的患者",
  "patient.merge.selectFirstPatient": "选择第一个患者",
  "patient.merge.selectPrimaryDescription": "哪个患者应成为主要记录？",
  "patient.merge.selectPrimaryRecord": "选择主要患者记录",
  "patient.merge.selectSecondPatient": "选择第二个患者",
  "patient.merge.step.compare": "选择主要患者",
  "patient.merge.step.confirm": "确认合并",
  "patient.merge.step.select": "选择患者",
  "patient.merge.streetAddress": "街道地址",
  "patient.merge.success": "患者合并成功完成",
  "patient.merge.successMessage": "患者 {mergedId} 已合并到患者 {primaryId} 中。审计ID：{auditId}",
  "patient.merge.testResults": "检测结果",
  "patient.merge.title": "合并患者记录",
  "patient.merge.totalContacts": "联系人",
  "patient.merge.totalRelations": "关系",
  "patient.merge.totalResults": "总结果数",
  "patient.merge.totalSamples": "样本数",
  "patient.merge.town": "城镇/城市",
  "patient.merge.tryDifferentSearch": "请尝试调整搜索条件或使用不同的患者标识符。",
  "patient.merge.warning.dataLink": "所有未来的数据都将链接到主要患者。未选中的患者将被标记为合并且不活跃。",
  "patient.merge.warning.irreversible": "此操作无法撤销。所有数据将被永久合并。",
  "patient.merge.warning.samePatient": "选择了相同的患者",
  "patient.merge.warning.samePatientDescription": "您选择了相同的患者作为两个记录。请选择两个不同的患者进行合并。",
  "patient.natioanalid": "国家ID",
  "patient.nationalid": "国家ID",
  "patient.nationality": "国籍",
  "patient.nationality.other": "指定其他国籍",
  "patient.photo.active.camera": "点击激活相机",
  "patient.photo.add": "添加照片",
  "patient.photo.browse": "点击浏览文件",
  "patient.photo.camera.permission.denied": "相机权限被拒绝。请检查您的浏览器设置。",
  "patient.photo.cancel": "取消",
  "patient.photo.capture": "拍摄照片",
  "patient.photo.captured": "已拍摄照片：",
  "patient.photo.change": "更改图像",
  "patient.photo.confirm": "确认",
  "patient.photo.dragndrop": "将图像拖放到此处",
  "patient.photo.error.fileTooLarge": "图片太大。最大尺寸为 2MB。",
  "patient.photo.formats": "格式：JPG、PNG（最大 2MB）",
  "patient.photo.import": "导入",
  "patient.photo.label": "患者照片",
  "patient.photo.modal.heading": "选择患者照片",
  "patient.photo.modal.options": "图像选择选项",
  "patient.photo.preview": "预览：",
  "patient.photo.preview.alt": "患者照片预览",
  "patient.photo.preview.captured.alt": "已拍摄的患者照片",
  "patient.photo.retake": "重新拍摄",
  "patient.photo.start.camera": "启动相机",
  "patient.photo.take": "拍摄照片",
  "patient.photo.view": "查看照片",
  "patient.idDoc.title": "身份证明文件",
  "patient.idDoc.addDocument": "添加文档",
  "patient.idDoc.selectImage": "选择图片",
  "patient.idDoc.documentType": "文档类型",
  "patient.idDoc.description": "描述",
  "patient.idDoc.description.placeholder": "输入文档描述",
  "patient.idDoc.category.nationalId": "国家ID",
  "patient.idDoc.category.insuranceCard": "保险卡",
  "patient.idDoc.category.other": "其他原因",
  "patient.idDoc.view": "查看",
  "patient.idDoc.edit": "编辑",
  "patient.idDoc.delete": "删除",
  "patient.idDoc.remove": "移除",
  "patient.idDoc.pending": "未保存",
  "patient.idDoc.empty": "未上传任何身份证明文件",
  "patient.idDoc.viewDocument": "查看文档",
  "patient.idDoc.editDocument": "编辑文档",
  "patient.idDoc.confirmDelete": "删除文档",
  "patient.idDoc.deleteWarning": "您确定要删除此文档吗？此操作无法撤销。",
  "patient.idDoc.upload": "上传",
  "patient.idDoc.dragndrop": "将文件拖放到此处",
  "patient.idDoc.browse": "或点击浏览文件",
  "patient.idDoc.formats": "文件格式：JPEG、PNG、PDF（最大10MB）",
  "patient.idDoc.useCamera": "使用相机",
  "patient.idDoc.pdfSelected": "已选择 PDF 文档",
  "patient.idDoc.error.invalidFormat": "文件格式无效。支持的格式：JPEG、PNG、PDF。",
  "patient.idDoc.error.fileTooLarge": "文件过大。最大大小为 10MB。",
  "patient.prev.lab.no": "之前的实验室编号",
  "patient.report.associated.name": "关联患者报告",
  "patient.report.collection.name": "已采集的ARV患者报告",
  "patient.search.nopatient": "未找到与搜索词匹配的患者",
  "patient.st.number": "ST编号",
  "patient.subject.number": "唯一健康ID号",
  "patient.yrs": "年",
  "patientcontact.person.email": "联系人电子邮件",
  "patientcontact.person.firstname": "联系人名",
  "patientcontact.person.lastname": "联系人姓",
  "placeholder.accession.number": "输入订单号",
  "print.barcode": "打印条码",
  "process.testAdd.pressNext.ageRangeSelectiong": "年龄范围选择步骤不是必需的，请按下一个按钮！",
  "process.testAdd.pressNext.selectGroupDictionary": "选择组字典列表步骤不是必需的，请按下一个按钮！",
  "program.name.label": "程序名称",
  "project.ARVFollowupStudy.name": "ARV随访",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "初始ARV",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "未确定",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "近期检测",
  "project.SequencingStudy.name": "测序",
  "project.SpecialRequestStudy.name": "特殊请求",
  "project.VLStudy.name": "病毒载量",
  "project.add.subtitle": "添加项目",
  "project.add.title": "添加项目",
  "project.browse.title": "项目",
  "project.completedDate": "完成日期",
  "project.desc.short": "项目描述",
  "project.description": "项目描述",
  "project.edit.subtitle": "编辑项目",
  "project.edit.title": "编辑项目",
  "project.external.reference": "外部参考",
  "provider.browse.title": "提供者管理",
  "provider.email": "电子邮件",
  "provider.fax": "传真",
  "provider.isActive": "是否活跃",
  "provider.modal.add.heading": "添加申请医生",
  "provider.modal.update.heading": "更新申请医生",
  "provider.providerFirstName": "提供者名",
  "provider.providerLastName": "提供者姓",
  "provider.search": "申请医生搜索",
  "provider.search.placeholder": "搜索提供者姓名...",
  "provider.select": "选择提供者",
  "provider.telephone": "电话",
  "qa.checklist.incomplete": "质量保证检查清单不完整",
  "qa.checklist.instructions": "提交前请完成所有必要的检查",
  "qa.checklist.samplingSiteCorrect": "站点信息正确",
  "qa.checklist.title": "质量保证检查清单",
  "qa.summary.noSamples": "没有待复核的样本",
  "qa.summary.noTests": "未选择检测",
  "qa.summary.order": "订单详情",
  "qa.summary.panel": "面板",
  "qa.summary.patient": "患者信息",
  "qa.summary.poolOf": "{count} 只{animal}的混样",
  "qa.summary.samples": "样本摘要",
  "qa.summary.samplingSite": "样本采样点",
  "qa.summary.siteCode": "站点位置代码",
  "qa.summary.siteName": "站点名称",
  "qc.comments.add": "添加评论",
  "qc.comments.empty": "暂无评论",
  "qc.comments.placeholder": "输入评论...",
  "qc.comments.title": "QC评论",
  "qc.expectedValue": "期望值",
  "qc.frequency.compliance": "合规性",
  "qc.frequency.config": "QC频率配置",
  "qc.frequency.daily": "每天",
  "qc.frequency.everyHours": "每隔数小时",
  "qc.frequency.everySamples": "每隔数个样本",
  "qc.frequency.manual": "手动",
  "qc.frequency.notConfigured": "未配置",
  "qc.frequency.perShift": "每班次",
  "qc.frequency.save": "保存QC频率",
  "qc.frequency.type": "频率类型",
  "qc.frequency.value": "频率值",
  "qc.leveyJennings.mean": "均值",
  "qc.leveyJennings.minus2SD": "-2SD",
  "qc.leveyJennings.minus3SD": "-3SD",
  "qc.leveyJennings.noData": "无可用数据",
  "qc.leveyJennings.plus2SD": "+2SD",
  "qc.leveyJennings.plus3SD": "+3SD",
  "qc.leveyJennings.title": "Levey-Jennings图",
  "qc.notes": "QC备注",
  "qc.notes.placeholder": "输入QC备注和观察结果",
  "qc.parentSample": "父样本",
  "qc.signature.comment": "签名评论",
  "qc.signature.comment.placeholder": "输入签名评论...",
  "qc.signature.ipAddress": "IP地址",
  "qc.signature.noSignatures": "暂无签名",
  "qc.signature.sign": "签名",
  "qc.signature.signedAt": "签名时间",
  "qc.signature.success": "签名成功",
  "qc.signature.title": "QC签名",
  "qc.signature.userId": "用户ID",
  "qc.status": "QC状态",
  "qc.status.failed": "失败",
  "qc.status.notRequired": "非必需",
  "qc.status.passed": "通过",
  "qc.status.pending": "待处理QC",
  "qc.status.select": "选择QC状态",
  "qc.status.update.button": "更新QC状态",
  "qc.status.update.success": "QC状态更新成功",
  "qc.status.update.title": "更新QC状态",
  "qc.status.warning.message": "将此批次标记为'失败'将阻止其使用，直到QC状态更新。",
  "qc.status.warning.title": "QC失败警告",
  "qc.westgard.noViolations": "无违规",
  "qc.westgard.rule.disabled": "已禁用",
  "qc.westgard.rule.enabled": "已启用",
  "qc.westgard.rules": "Westgard规则",
  "qc.westgard.rules.description": "配置用于QC数据评估的Westgard规则",
  "qc.westgard.violations": "违规记录",
  "quantity": "数量",
  "quantity.balanced": "数量平衡",
  "quantity.not.balanced": "数量不平衡",
  "quick.entry.accession.number": "订单号",
  "referTest.referralLabel": "将检测转诊到参考实验室",
  "referral.button.labSearch": "按实验室编号搜索转诊",
  "referral.button.patientSearch": "搜索患者",
  "referral.button.unitTestSearch": "按单元和检测搜索转诊",
  "referral.date.end": "结束日期 (dd/mm/yyyy)",
  "referral.date.start": "开始日期 (dd/mm/yyyy)",
  "referral.emptyState": "根据所选筛选条件，未找到转诊。",
  "referral.error": "无匹配条件的转诊",
  "referral.input": "扫描或手动输入",
  "referral.label.institute": "机构",
  "referral.label.reason": "转诊原因",
  "referral.label.referredOutTests": "已转诊检测",
  "referral.label.sentdate": "发送日期",
  "referral.label.testmethod": "方法",
  "referral.label.testtoperform": "要执行的检测",
  "referral.main.button": "按患者搜索转诊",
  "referral.matching.search": "匹配搜索的转诊检测",
  "referral.out.head": "转诊",
  "referral.out.note": "注意：如果按结果日期搜索，只会显示有结果的检测。",
  "referral.out.request": "按日期/检测/单元的日期类型结果：",
  "referral.print.selected.patient.reports": "打印选定的患者报告",
  "referral.print.selected.patient.reports.selectall.button": "选择全部",
  "referral.print.selected.patient.reports.selectnone.button": "选择无",
  "referral.result.labNumber": "按实验室编号结果",
  "referral.result.referenceRange": "参考范围",
  "referral.search": "搜索",
  "referral.search.column.analysisId": "分析ID",
  "referral.search.column.referenceLab": "参考实验室",
  "referral.search.column.resultDate": "结果日期",
  "referral.search.column.sentDate": "发送日期",
  "referral.test": "检测",
  "referral.testresult.pastnote": "历史备注",
  "referral.units": "单元",
  "referrer.label": "转诊者",
  "reflexTests": "反射检测",
  "reject.action.button": "拒绝",
  "reject.order.sample.notification": "您正在拒绝一个样本。此样本将被拒绝，保存后不会出现在工作计划中，此订单不能输入结果。",
  "remaining.quantity": "剩余数量：",
  "remove.aliquot": "移除分装样本",
  "report.enter.labNumber.headline": "按订单号/实验室编号生成一个报告或一系列报告",
  "report.enter.patient.headline": "生成客户的所有报告",
  "report.enter.patient.headline.description": "通过之前的实验室编号、患者ID（可以是唯一健康ID号或国家ID）或其他字段搜索患者。",
  "report.enter.site.headline": "按站点生成报告",
  "report.labe.byLabNumber": "按实验室编号报告",
  "report.labe.byPatient": "按患者报告",
  "report.labe.date": "按日期报告",
  "report.labe.site": "按站点报告",
  "report.label.site.dateType": "日期类型",
  "report.label.site.onlyResults": "仅包含结果的报告",
  "report.patient.site.description": "按结果日期或订单日期生成报告。结果日期将仅显示有结果的报告。如果选择仅包含结果的报告，则所有检测都在进行中的报告将不会生成。",
  "report.patient.title.final": "Results: final report",
  "report.patient.title.partial": "Results: partial report",
  "report.patient.labDirector": "Lab director",
  "report.patient.block.order": "排序",
  "report.patient.block.dates": "Dates",
  "report.patient.siteWard": "Site / ward",
  "report.patient.completed": "已完成",
  "report.patient.completed.pending": "Not yet complete",
  "report.patient.contactTracing.indexName": "Contact tracing index name",
  "report.patient.contactTracing.indexRecordNumber": "Contact tracing index record number",
  "report.patient.samples": "样本",
  "report.patient.sample.number": "清单编号",
  "report.patient.sample.condition": "状况",
  "report.patient.sample.rejected": "Rejected: {0}",
  "report.patient.sample.notRecorded": "未记录",
  "report.patient.strip.collected": "Collected {0}",
  "report.patient.strip.collectedFirst": "Collected {0} (first of {1} samples)",
  "report.patient.result.sampleRejected": "Sample rejected",
  "report.patient.result.rejected": "已拒收",
  "report.patient.col.sample": "Smp",
  "report.patient.col.completed": "已完成",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Legend",
  "report.patient.legend.high": "above normal",
  "report.patient.legend.low": "below normal",
  "report.patient.legend.critical": "critical",
  "report.patient.legend.referred": "referred, result pending",
  "report.patient.legend.confirm": "confirmation test",
  "report.patient.notAccredited": "Not within the laboratory's accredited scope",
  "report.patient.awaitingValidation": "Awaiting validation",
  "report.patient.performedBy": "执行人：{0}",
  "report.patient.accred.notesLine": "Tests on this report are accredited by: {0}.",
  "report.patient.callback.line": "Callback: {0}, {1}, by {2}. {3}.",
  "report.patient.callback.more": "(+{0} earlier attempts)",
  "report.patient.callback.confirmed": "Read back confirmed",
  "report.patient.callback.noReadback": "已联系，未复述",
  "report.patient.callback.unreachable": "无法联系",
  "report.patient.corrected.line": "Corrected report. Replaces the report issued {0}. Change: {1}.",
  "report.patient.corrected.seeReplaced": "See the replaced report",
  "report.patient.version": "Version {0}.",
  "report.patient.footer.version": "Version {0}",
  "report.patient.comments": "General comments",
  "report.patient.releasedBy": "Validated and released by",
  "report.patient.endOfReport": "End of report",
  "report.patient.issued": "Issued",
  "report.patient.page": "Page",
  "report.select.site": "选择站点",
  "report.select.studttype": "选择研究类型",
  "reporting.label.testName": "报告检测名称",
  "reports.auditTrail": "审计跟踪",
  "reports.systemAuditTrail": "系统审计跟踪",
  "reports.button": "生成报告",
  "reports.dateRange": "日期范围",
  "reports.endDate": "结束日期",
  "reports.error.dateRangeRequired": "此报告类型需要日期范围",
  "reports.error.generationFailed": "生成报告失败。请重试。",
  "reports.error.invalidDate": "日期无效",
  "reports.error.invalidDateRange": "结束日期必须在开始日期之后",
  "reports.error.unknownExportFormat": "未知的导出格式",
  "reports.error.unknownReportType": "未知的报告类型",
  "reports.export": "导出",
  "reports.export.byDate": "按日期导出",
  "reports.export.byDate_routine": "常规CSV报告",
  "reports.export.general": "通用导出",
  "reports.export.specific": "病毒载量数据导出",
  "reports.export.valid": "有效",
  "reports.export.whonet": "WHONET报告",
  "reports.followupRequired.byLocation": "需要随访",
  "reports.format": "导出格式",
  "reports.format.select": "选择格式",
  "reports.generate.title": "生成库存报告",
  "reports.generating": "生成中...",
  "reports.generation.success": "报告生成并下载成功",
  "reports.groupByLocation": "按存储位置分组",
  "reports.groupByType": "按物品类型分组",
  "reports.grouping": "分组选项",
  "reports.help.description": "使用这些报告分析您的库存数据：",
  "reports.help.tip1": "使用日期范围进行趋势分析",
  "reports.help.tip2": "按类型或位置分组以获得更好的洞察",
  "reports.help.tip3": "导出到Excel进行进一步分析",
  "reports.help.title": "报告提示",
  "reports.includeExpired": "包括已过期批次",
  "reports.includeInactive": "包括非活跃物品",
  "reports.info.message": "请选择下方的报告类型和选项。生成报告可能需要几分钟时间。",
  "reports.info.title": "报告生成",
  "reports.label.cistudyexport": "通用报告",
  "reports.label.indicator": "指标",
  "reports.label.indicator.performance": "部分性能",
  "reports.label.referred.out": "已转诊检测报告",
  "reports.label.trends": "趋势",
  "reports.menu.covid": "Covid报告",
  "reports.nonConformity.byDate.report": "按日期",
  "reports.nonConformity.byLabno.report": "按实验室编号",
  "reports.nonConformity.bySectionReason.report": "按单元和原因",
  "reports.nonConformity.bySectionReason.title": "按单元和原因的不符合报告",
  "reports.nonConformity.menu": "不符合报告",
  "reports.nonConformity.notification.report": "不符合通知",
  "reports.nonConformity.notification.report.instructions": "如果选择了服务，则将打印尚未打印的任何不符合通知。如果没有列出服务，则所有通知都已打印。输入实验室编号将打印通知，即使它已经打印过。不必选择服务。",
  "reports.options": "过滤选项",
  "reports.patient.ARV.version1": "ARV版本",
  "reports.patient.ARV.version1 ": "ARV版本1",
  "reports.patient.ARVFollowup.version1": "ARV随访版本1",
  "reports.patient.ARVFollowup.version2": "ARV随访版本2",
  "reports.patient.ARVInitial.version1": "ARV初始版本1",
  "reports.patient.ARVInitial.version2": "ARV初始版本2",
  "reports.patient.Indeterminate.location": "按服务的未确定",
  "reports.patient.Indeterminate.version1": "未确定版本1",
  "reports.patient.Indeterminate.version2": "未确定版本2",
  "reports.startDate": "开始日期",
  "reports.type": "报告类型",
  "reports.type.expirationForecast": "过期预测",
  "reports.type.expirationForecast.description": "在指定日期范围内过期的物品",
  "reports.type.lotTraceability": "批次可追溯性",
  "reports.type.lotTraceability.description": "完整的批次移动和使用可追溯性",
  "reports.type.lowStock": "低库存警报",
  "reports.type.lowStock.description": "当前低于最低库存水平的物品",
  "reports.type.select": "选择报告类型",
  "reports.type.stockLevels": "库存水平报告",
  "reports.type.stockLevels.description": "所有库存物品的当前库存水平",
  "reports.type.transactionHistory": "交易历史",
  "reports.type.transactionHistory.description": "日期范围内的所有交易",
  "reports.type.usageTrends": "使用趋势",
  "reports.type.usageTrends.description": "随时间的使用模式和消耗趋势",
  "request.samesite.order": "下相同站点订单",
  "requester.label": "请求者",
  "required.invalidtext": "此字段是必需的",
  "result.acceptasis.warning": "选中此框将表示您无条件接受结果。\n预期用途：\n1. 检测已重做且结果相同。\n2. 检测没有结果，但您不想取消它。\n3. 结果已更改，技术员希望给予生物学家在验证步骤中添加备注解释更改原因的选项。\n在任何情况下，请留下备注解释您采取此操作的原因。\n",
  "result.acceptasis.trigger": "接受",
  "result.acceptasis.reason.label": "无条件接受的理由",
  "result.acceptasis.reason.placeholder": "必填项——例如：经两次重新检测结果相同，或无结果可用",
  "result.acceptasis.confirm": "确认接受",
  "result.acceptasis.cancel": "取消",
  "result.acceptasis.committed": "已接受",
  "result.acceptasis.undo": "撤销",
  "result.entry.error.accessionRequired": "请输入订单号",
  "result.entry.error.title": "错误",
  "result.entry.info.title": "信息",
  "result.entry.label": "结果录入",
  "result.entry.noResults": "未找到订单号 {accessionNumber} 的样本",
  "result.entry.noTestsFound": "未找到订单号 {accessionNumber} 的待处理结果检测",
  "result.entry.results.accessionNumber": "订单号",
  "result.entry.results.sampleCount": "样本",
  "result.entry.results.testCount": "检测",
  "result.entry.results.title": "待处理结果的检测",
  "result.entry.saveSuccess": "{testName} 的结果已保存",
  "result.entry.search.accessionLabel": "订单号",
  "result.entry.search.accessionPlaceholder": "输入订单号...",
  "result.entry.search.button": "搜索",
  "result.entry.search.searching": "搜索中...",
  "result.entry.search.title": "按订单号搜索",
  "result.entry.success.title": "成功",
  "result.entry.table.action": "操作",
  "result.entry.table.header.sampleId": "样本ID",
  "result.entry.table.header.sampleType": "样本类型",
  "result.entry.table.header.testCount": "检测",
  "result.entry.table.noSamples": "未找到包含检测的样本",
  "result.entry.table.noTests": "此样本无检测",
  "result.entry.table.result": "结果",
  "result.entry.table.resultPlaceholder": "输入结果",
  "result.entry.table.save": "保存",
  "result.entry.table.saving": "保存中...",
  "result.entry.table.status": "状态",
  "result.entry.table.testName": "检测名称",
  "result.entry.table.testsTitle": "检测 ({count})",
  "result.entry.title": "结果录入",
  "result.noTestsFound": "未找到合适的检测。",
  "result.nonconforming.item": "样本或订单不符合或检测已被拒绝",
  "result.outOfValidRange.msg": "您输入的值（红色字段）超出了该记录允许的值范围。请检查该值",
  "result.notNumeric.msg": "{test}：“{value}”不是数字。请输入普通小数或科学计数法（如 1.5e5 或 1.5 x 10^5），然后重新保存。",
  "result.reject.warning": "拒绝结果将永久删除检测结果 \n结果将不再可用。",
  "result.report.queue.size": "队列大小：",
  "result.search.noresult": "未找到结果",
  "resultreporting.browse.title": "结果报告配置",
  "resultreporting.config.url": "结果将发送到的站点的URL。例如 http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://组织名称.com/someSite",
  "results.label.refer": "将检测转诊到参考实验室",
  "routine.reports": "常规报告",
  "rulebuilder.error.invalidNumeric": "无效的数值",
  "rulebuilder.error.invalidTest": "无效的检测",
  "rulebuilder.label.add.externaltrigger": "添加外部`触发者`消息",
  "rulebuilder.label.add.internaltrigger": "添加内部`触发者`消息",
  "rulebuilder.label.addAction": "添加操作",
  "rulebuilder.label.addCondition": "添加条件",
  "rulebuilder.label.addExternalNote": "添加外部备注",
  "rulebuilder.label.addInternalNote": "添加内部备注",
  "rulebuilder.label.addPopup": "添加弹出窗口",
  "rulebuilder.label.addRule": "添加规则",
  "rulebuilder.label.addRuleConditions": "添加反射规则条件",
  "rulebuilder.label.confirmDelete": "您确定要停用此规则吗？",
  "rulebuilder.label.dictValue": "字典值",
  "rulebuilder.label.noSuggestions": "无可用建议",
  "rulebuilder.label.numericValue": "数值",
  "rulebuilder.label.numericValue2": "数值2",
  "rulebuilder.label.overallOptions": "整体选项",
  "rulebuilder.label.perfomActions": "执行以下操作",
  "rulebuilder.label.relation": "关系",
  "rulebuilder.label.removeAction": "移除操作",
  "rulebuilder.label.removeCondition": "移除条件",
  "rulebuilder.label.removeRule": "停用规则",
  "rulebuilder.label.rule": "规则",
  "rulebuilder.label.ruleDetails": "查看规则",
  "rulebuilder.label.ruleName": "规则名称",
  "rulebuilder.label.searchTest": "搜索检测",
  "rulebuilder.label.selectSample": "选择样本",
  "rulebuilder.label.textValue": "文本值",
  "rulebuilder.label.toggleRule": "启用/停用",
  "sample.accession.number": "样本订单号",
  "sample.add.action": "添加样本",
  "sample.collection.date": "采集日期",
  "sample.collection.method": "采集方法",
  "sample.collection.method.placeholder": "例如：静脉采血、毛细血管采血、导管采血",
  "sample.collection.time": "采集时间",
  "sample.currentDate": "当前日期",
  "sample.requiredBy": "要求提供者",
  "sample.specimen.origin": "标本来源（参考实验室）",
  "sample.specimen.origin.placeholder": "转诊实验室名称",
  "sample.temperature": "样本储存温度",
  "sample.temperature.placeholder": "例如：室温、置于冰上、冷藏",
  "sample.entry.available.tests": "可用检测",
  "sample.entry.nextVisit.date": "下次就诊日期",
  "sample.entry.panels": "面板",
  "sample.entry.project.patient.and.testName": "患者姓名/代码{br}检测名称",
  "sample.entry.project.testName": "检测名称",
  "sample.entry.search.barcode": "打印现有订单的条码",
  "sample.id": "样本ID",
  "sample.item.info": "样本信息",
  "sample.items.for.accession": "订单号的样本项：",
  "sample.label.accessionNumber": "订单号",
  "sample.label.collectionDate": "采集日期",
  "sample.label.dept": "病房/科室/单元",
  "sample.label.facility": "转诊设施",
  "sample.label.labnumber": "实验室编号",
  "sample.label.labnumber.generate": "生成",
  "sample.label.labnumber.new": "新实验室编号",
  "sample.labnumber.reassign.button": "重新分配实验室编号",
  "sample.labnumber.reassign.confirm": "重新分配",
  "sample.labnumber.reassign.current": "当前实验室编号",
  "sample.labnumber.reassign.heading": "重新分配实验室编号",
  "sample.labnumber.reassign.pending": "保存后，该标本将被重新分配至{number}。",
  "sample.labnumber.reassign.pending.title": "待处理的实验室编号重新分配",
  "sample.labnumber.reassign.undo": "撤销",
  "sample.labnumber.reassign.warning": "重新分配会永久更改该标本的实验室编号。现有标签、报告以及对当前编号的引用将不再与之匹配。请仅在需要更正标本标签错误时执行此操作。",
  "sample.label.noorder": "订单不存在",
  "sample.label.orderdate": "订单日期",
  "sample.label.orderpanel": "订单面板",
  "sample.label.requester": "请求者",
  "sample.label.search.Order": "搜索订单",
  "sample.label.search.labnumber": "按实验室编号搜索",
  "sample.label.search.patient": "按患者搜索",
  "sample.label.typeOfSample": "样本类型",
  "sample.label.types": "样本类型",
  "sample.management.action.clearSelection": "清除选择",
  "sample.management.action.createAliquot": "创建分装样本",
  "sample.management.action.selectAllAliquots": "选择所有分装样本",
  "sample.management.action.selectAllParents": "选择所有父样本",
  "sample.management.addTests.button": "添加检测",
  "sample.management.addTests.error.addFailed": "添加检测失败。请重试。",
  "sample.management.addTests.error.loadSampleTypes": "加载样本类型时出错",
  "sample.management.addTests.error.loadTests": "加载可用检测时出错",
  "sample.management.addTests.error.noEligibleSamples": "无法添加检测：所有选定的样本已全部分配",
  "sample.management.addTests.error.noTests": "请至少选择一个检测",
  "sample.management.addTests.modal.add": "添加检测",
  "sample.management.addTests.modal.addCount": "添加 {count} 个检测",
  "sample.management.addTests.modal.adding": "添加中...",
  "sample.management.addTests.modal.aliquotsIncluded": "包含分装样本",
  "sample.management.addTests.modal.bulkAliquotNote": "检测将添加到所有选定的样本，包括分装样本。",
  "sample.management.addTests.modal.cancel": "取消",
  "sample.management.addTests.modal.noEligibleSamples": "无符合条件的样本",
  "sample.management.addTests.modal.noTestsAvailable": "此样本类型无可用检测。",
  "sample.management.addTests.modal.noTestsSelected": "未选择检测",
  "sample.management.addTests.modal.panels": "面板",
  "sample.management.addTests.modal.searchTestsPlaceholder": "搜索检测...",
  "sample.management.addTests.modal.selectSampleType": "样本类型",
  "sample.management.addTests.modal.selectSampleTypeFirst": "请选择样本类型以查看可用面板和检测。",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "选择样本类型...",
  "sample.management.addTests.modal.selectTests": "选择检测",
  "sample.management.addTests.modal.selectTestsPlaceholder": "搜索并选择检测...",
  "sample.management.addTests.modal.selectedTests": "已选检测",
  "sample.management.addTests.modal.subtitle": "向 {count} 个选定的样本添加检测",
  "sample.management.addTests.modal.tests": "检测",
  "sample.management.addTests.modal.title": "向样本添加检测",
  "sample.management.addTests.resultItem": "{sampleId}：{added} 个已添加",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}：{added} 个已添加，{skipped} 个已跳过",
  "sample.management.addTests.success": "{count} 个检测成功添加",
  "sample.management.addTests.successDetailed": "{count} 个检测已添加到 {samples} 个样本：{details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} 个检测已添加到 {samples} 个样本，{skipped} 个已跳过：{details}",
  "sample.management.addTests.successWithSkipped": "{added} 个检测已添加，{skipped} 个已跳过（已订购）",
  "sample.management.addTests.title": "添加检测",
  "sample.management.addTests.warning.dispensedSamples": "{count} 个样本没有剩余体积，将被跳过。检测将添加到 {eligible} 个符合条件的样本。",
  "sample.management.addTests.warning.dispensedSamples.title": "已分配样本已排除",
  "sample.management.aliquot.error.createFailed": "创建分装样本失败。请重试。",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "分装样本数量必须在1到100之间",
  "sample.management.aliquot.error.quantityExceedsRemaining": "请求的数量 ({requested}) 超过剩余数量 ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "每个分装样本的数量 ({quantityPerAliquot}) 将小于最小值 (0.001)",
  "sample.management.aliquot.error.quantityPositive": "数量必须大于0",
  "sample.management.aliquot.error.quantityRequired": "数量是必需的",
  "sample.management.aliquot.error.title": "错误",
  "sample.management.aliquot.modal.cancel": "取消",
  "sample.management.aliquot.modal.create": "创建分装样本",
  "sample.management.aliquot.modal.createMultiple": "创建 {count} 个分装样本",
  "sample.management.aliquot.modal.creating": "创建中...",
  "sample.management.aliquot.modal.notesLabel": "备注（可选）",
  "sample.management.aliquot.modal.notesPlaceholder": "添加关于此分装样本的任何备注...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "输入要创建的等体积分装样本数量（1-100）",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "分装样本数量",
  "sample.management.aliquot.modal.parentInfo": "父样本信息",
  "sample.management.aliquot.modal.preview": "预览",
  "sample.management.aliquot.modal.previewText": "创建 {count} 个分装样本，每个 {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "输入要转移的数量，单位为 {unit}",
  "sample.management.aliquot.modal.quantityLabel": "要转移的数量",
  "sample.management.aliquot.modal.quantityPlaceholder": "输入数量",
  "sample.management.aliquot.modal.subtitle": "从样本 {externalId} 创建分装样本",
  "sample.management.aliquot.modal.title": "创建分装样本",
  "sample.management.aliquot.modal.totalQuantityHelper": "输入要在所有分装样本中分配的总数量，单位为 {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "要转移的总数量",
  "sample.management.aliquot.success": "分装样本 {externalId} 创建成功。请再次搜索以查看更新后的结果。",
  "sample.management.aliquot.successMultiple": "{count} 个分装样本创建成功 ({externalIds})。请再次搜索以查看更新后的结果。",
  "sample.management.breadcrumb.title": "样本管理",
  "sample.management.cancelTest.error": "取消检测失败。请重试。",
  "sample.management.cancelTest.success": "检测 \"{testName}\" 成功取消",
  "sample.management.description": "搜索和管理样本项，创建分装样本，以及添加检测",
  "sample.management.error.title": "错误",
  "sample.management.hierarchy.aliquotOf": "{parent} 的分装样本",
  "sample.management.hierarchy.aliquots": "分装样本",
  "sample.management.noResults.subtitle": "未找到订单号为 {accessionNumber} 的样本项",
  "sample.management.noResults.title": "未找到结果",
  "sample.management.results.accessionNumber": "订单号",
  "sample.management.results.aliquots": "分装样本",
  "sample.management.results.aliquotsSelected": "分装样本",
  "sample.management.results.item": "项",
  "sample.management.results.items": "项",
  "sample.management.results.selected": "已选择",
  "sample.management.results.title": "样本项",
  "sample.management.results.totalCount": "总样本数",
  "sample.management.search.error.general": "加载样本结果时出错。请重试。",
  "sample.management.search.label": "搜索样本",
  "sample.management.search.loading": "搜索中...",
  "sample.management.search.placeholder": "输入订单号以搜索...",
  "sample.management.search.title": "搜索样本",
  "sample.management.status.allVolumeDispensed": "已分配所有体积",
  "sample.management.status.available": "可用",
  "sample.management.status.consumed": "已消耗",
  "sample.management.status.inUse": "使用中",
  "sample.management.status.unknown": "未知",
  "sample.management.success.title": "成功",
  "sample.management.table.cancelTest": "取消检测",
  "sample.management.table.cancelling": "取消中...",
  "sample.management.table.header.externalId": "样本ID",
  "sample.management.table.header.hierarchy": "层次结构",
  "sample.management.table.header.originalQuantity": "原始数量",
  "sample.management.table.header.quantity": "原始数量",
  "sample.management.table.header.remainingQuantity": "剩余数量",
  "sample.management.table.header.sampleType": "样本类型",
  "sample.management.table.header.status": "状态",
  "sample.management.table.header.tests": "检测",
  "sample.management.table.noResults": "无样本项可显示。使用上面的搜索查找样本。",
  "sample.management.table.noTests": "此样本未订购检测",
  "sample.management.table.orderedDate": "已订购",
  "sample.management.table.orderedTests": "已订购检测 ({count})",
  "sample.management.title": "样本管理",
  "sample.panel.label.text": "搜索可用面板",
  "sample.panel.placeholder": "选择可用面板",
  "sample.panel.search.error.msg": "未找到匹配的面板",
  "sample.quantity.label": "数量",
  "sample.receivedDate": "接收日期",
  "sample.reject.label": "拒绝样本",
  "sample.reject.reason.choose": "Choose a rejection reason",
  "sample.reject.reason.label": "拒绝原因",
  "sample.reject.reasonRequired": "Choose a rejection reason.",
  "sample.remove.action": "移除样本",
  "sample.requestDate": "请求日期",
  "sample.search.nosample": "未找到提供的订单号的样本。",
  "sample.search.panel.legend.text": "搜索可用面板",
  "sample.search.scanner.instructions": "扫描或手动输入。对于单个报告，请将右侧的框留空",
  "sample.search.scanner.instructions.highaccession": "对于单个报告，请将右侧的框留空",
  "sample.search.scanner.instructions2": "扫描或手动输入。",
  "sample.search.title": "搜索样本",
  "sample.select.type": "选择样本类型",
  "sample.type": "样本类型",
  "sample.type.and.test.sort.order": "样本类型和检测排序顺序",
  "sample.type.helper": "选择标本类型，选择后可用的检测面板和检测项目将自动更新。",
  "sample.uom.label": "样本测量单位",
  "sample.voided.title": "样本已作废",
  "sampleManagement.actions": "操作",
  "sampleManagement.addTests.button": "添加检测",
  "sampleManagement.addTests.cancel": "取消",
  "sampleManagement.addTests.duplicate": "检测已为 {sampleId} 订购",
  "sampleManagement.addTests.error": "添加检测时出错",
  "sampleManagement.addTests.incompatible": "检测与样本类型 ({sampleType}) 不兼容",
  "sampleManagement.addTests.selectSamples": "选择要添加检测的样本",
  "sampleManagement.addTests.selectTests": "选择要添加的检测",
  "sampleManagement.addTests.skipped": "跳过了 {count} 个重复项",
  "sampleManagement.addTests.submit": "添加检测",
  "sampleManagement.addTests.success": "{count} 个检测成功添加",
  "sampleManagement.addTests.title": "向样本添加检测",
  "sampleManagement.aliquot.button": "创建分装样本",
  "sampleManagement.aliquot.cancel": "取消",
  "sampleManagement.aliquot.error": "创建分装样本时出错",
  "sampleManagement.aliquot.error.concurrentModification": "其他用户修改了此样本。请刷新后重试。",
  "sampleManagement.aliquot.error.insufficientQuantity": "无法分装：请求的 {requested} 超过剩余的 {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "已分配所有体积：没有剩余数量可供分装",
  "sampleManagement.aliquot.notes": "备注（可选）",
  "sampleManagement.aliquot.notesPlaceholder": "添加关于此分装样本的备注...",
  "sampleManagement.aliquot.parentExternalId": "父样本外部ID",
  "sampleManagement.aliquot.parentLabel": "父样本",
  "sampleManagement.aliquot.quantityPlaceholder": "输入数量...",
  "sampleManagement.aliquot.quantityToTransfer": "要转移的数量",
  "sampleManagement.aliquot.remainingQuantity": "剩余数量",
  "sampleManagement.aliquot.submit": "创建分装样本",
  "sampleManagement.aliquot.success": "分装样本 {externalId} 创建成功",
  "sampleManagement.aliquot.title": "创建分装样本",
  "sampleManagement.aliquot.unit": "单位",
  "sampleManagement.aliquot.validation.exceeds": "数量超过剩余数量",
  "sampleManagement.aliquot.validation.min": "数量必须至少为 0.001",
  "sampleManagement.aliquot.validation.required": "要转移的数量是必需的",
  "sampleManagement.clearSelection": "清除选择",
  "sampleManagement.hierarchy.children": "分装样本：",
  "sampleManagement.hierarchy.collapse": "折叠层次结构",
  "sampleManagement.hierarchy.expand": "展开层次结构",
  "sampleManagement.hierarchy.level": "级别 {level}",
  "sampleManagement.hierarchy.parent": "父样本：",
  "sampleManagement.notification.refreshResults": "结果已刷新",
  "sampleManagement.results.children": "分装样本",
  "sampleManagement.results.collectionDate": "采集日期",
  "sampleManagement.results.count": "找到 {count} 个样本",
  "sampleManagement.results.externalId": "外部ID",
  "sampleManagement.results.originalQuantity": "原始数量",
  "sampleManagement.results.parent": "父样本",
  "sampleManagement.results.remainingQuantity": "剩余数量",
  "sampleManagement.results.sampleType": "样本类型",
  "sampleManagement.results.status": "状态",
  "sampleManagement.results.tests": "检测",
  "sampleManagement.results.title": "搜索结果",
  "sampleManagement.search.button": "搜索",
  "sampleManagement.search.error": "搜索样本时出错",
  "sampleManagement.search.label": "按订单号搜索",
  "sampleManagement.search.loading": "搜索中...",
  "sampleManagement.search.noResults": "未找到此订单号的样本",
  "sampleManagement.search.placeholder": "输入订单号...",
  "sampleManagement.selectSamples": "选择样本",
  "sampleManagement.selectedCount": "{count} 个已选择",
  "sampleManagement.test.name": "检测名称",
  "sampleManagement.test.orderedDate": "订购日期",
  "sampleManagement.test.status": "状态",
  "sampleManagement.test.status.CANCELLED": "已取消",
  "sampleManagement.test.status.COMPLETED": "已完成",
  "sampleManagement.test.status.IN_PROGRESS": "进行中",
  "sampleManagement.test.status.ORDERED": "已订购",
  "sampleManagement.title": "样本管理",
  "sampleManagement.validation.accessionNumberRequired": "订单号是必需的",
  "sampleManagement.validation.parentSampleRequired": "父样本项是必需的",
  "sampleManagement.validation.samplesRequired": "必须至少选择一个样本",
  "sampleManagement.validation.testsRequired": "必须至少选择一个检测",
  "sampleType.existing": "现有样本类型",
  "sampleType.existing.inactive": "非活跃样本类型。分配检测以激活。",
  "sampleType.new": "新样本类型",
  "sampleType.typeName": "样本类型名称",
  "save.aliquot.changes": "保存分装样本更改",
  "save.config.success.msg": "配置更新成功",
  "save.order.success.msg": "样本订单录入已成功保存",
  "save.success": "成功保存",
  "saving": "保存中...",
  "search.by.dictionary.entry": "按字典条目搜索",
  "search.label": "搜索",
  "search.label.accession": "输入订单号",
  "search.label.analysis": "选择分析状态",
  "search.label.collectiondate": "输入采集日期",
  "search.label.fromaccession": "从订单号",
  "search.label.loadnext": "从实验室编号加载下一个99条记录",
  "search.label.receiveddate": "输入接收日期",
  "search.label.sample": "选择样本状态",
  "search.label.test": "选择检测名称",
  "search.label.testdate": "输入检测日期",
  "search.label.testunit": "选择检测单元",
  "search.label.toaccession": "到订单号",
  "search.patient.label": "搜索患者",
  "search.placeholder": "请输入搜索内容...",
  "searchTests.label": "搜索可用检测",
  "searchTests.legend": "搜索可用检测",
  "searchindexmanagement.description": "添加或修改数据时，搜索索引会自动更新。如果您需要手动更新搜索索引，请单击开始重新索引按钮。这可能需要一些时间。",
  "searchindexmanagement.label": "搜索索引管理",
  "searchindexmanagement.reindex": "开始重新索引",
  "searchindexmanagement.reindex.error": "重新索引失败",
  "searchindexmanagement.reindex.success": "重新索引成功完成",
  "select.aliquot": "选择分装样本",
  "select.datarange.label": "日期范围用于转诊时间",
  "select.dateRange": "选择检测报告摘要的日期范围",
  "select.default.option.label": "选择一个选项",
  "select.end.date.referredTests": "结束日期 (dd/mm/yyyy)",
  "select.labUnits": "选择您要为其创建检测的实验室单元，您可以根据需要选择多个",
  "select.label.analyser": "选择分析仪",
  "select.priority.tests": "选择要显示的检测的优先级",
  "select.program": "程序",
  "select.referral.centre": "转诊中心或实验室",
  "select.referral.centre.is.required": "转诊中心或实验室是必需的",
  "select.start.date.referredTests": "开始日期 (dd/mm/yyyy)",
  "select.timeFrame": "选择您要生成报告的时间范围",
  "select.timeFrame.Note": "注意：所有日期和时间均基于接收时间。例如：1月31日晚上11:59接收并于2月1日上午9:30得出结果的检测将显示为1月非正常工作时间。",
  "select.year.report": "选择您要生成报告的年份",
  "selectListRenameEntry.selectList": "选择列表重命名条目",
  "selectListRenameEntry.selectListEdit": "选择列表重命名条目编辑",
  "selectReportValues.title": "选择报告值",
  "selectResult.title": "选择结果",
  "serial.config.active.label": "活跃",
  "serial.config.baudRate.label": "波特率",
  "serial.config.connect.button": "连接",
  "serial.config.connect.error": "连接失败",
  "serial.config.connect.success": "连接成功",
  "serial.config.create.title": "创建串口配置",
  "serial.config.dataBits.label": "数据位",
  "serial.config.disconnect.button": "断开连接",
  "serial.config.disconnect.error": "断开连接失败",
  "serial.config.disconnect.success": "断开连接成功",
  "serial.config.edit.title": "编辑串口配置",
  "serial.config.flowControl.label": "流控制",
  "serial.config.flowControl.none": "无",
  "serial.config.form.legend": "串口配置",
  "serial.config.parity.even": "偶校验",
  "serial.config.parity.label": "校验位",
  "serial.config.parity.mark": "标记",
  "serial.config.parity.none": "无",
  "serial.config.parity.odd": "奇校验",
  "serial.config.parity.space": "空格",
  "serial.config.portName.label": "端口名称",
  "serial.config.save.error": "保存串口配置失败",
  "serial.config.save.success": "串口配置保存成功",
  "serial.config.status.label": "状态",
  "serial.config.stopBits.label": "停止位",
  "serial.config.validation.analyzerId.required": "分析仪ID为必填项",
  "serial.config.validation.baudRate.invalid": "波特率无效",
  "serial.config.validation.dataBits.invalid": "数据位无效",
  "serial.config.validation.portName.required": "端口名称为必填项",
  "server.error.msg": "哎呀，服务器错误，请联系管理员",
  "common.retry": "重试",
  "show.aliquoting": "显示分装样本",
  "showing": "显示",
  "breadcrumb.label.addOrder": "添加订单",
  "sidenav.label.admin": "管理",
  "sidenav.label.admin.backToMainMenu": "返回主菜单",
  "sidenav.label.admin.barcodeconfiguration": "条码配置",
  "sidenav.label.admin.labelPresets": "标签预设",
  "sidenav.label.admin.commonproperties": "应用属性",
  "sidenav.label.admin.eqaProgram": "EQA程序",
  "sidenav.label.admin.formEntry.menustatementconfig": "菜单声明配置",
  "sidenav.label.admin.formEntry.nonconformityconfig": "不符合配置",
  "sidenav.label.admin.formEntry.patientconfig": "患者录入配置",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "打印报告配置",
  "sidenav.label.admin.formEntry.resultConfig": "结果录入配置",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "订单录入配置",
  "sidenav.label.admin.formEntry.siteBranding": "站点品牌",
  "sidenav.label.admin.formEntry.siteInfoconfig": "站点信息",
  "sidenav.label.admin.formEntry.validationconfig": "验证配置",
  "sidenav.label.admin.formEntry.Workplanconfig": "工作计划配置",
  "sidenav.label.admin.labNumber": "实验室编号管理",
  "sidenav.label.admin.localization": "本地化",
  "sidenav.label.admin.menu": "菜单配置",
  "sidenav.label.admin.menu.billing": "计费菜单配置",
  "sidenav.label.admin.menu.global": "全局菜单配置",
  "sidenav.label.admin.menu.nonconform": "不符合菜单配置",
  "sidenav.label.admin.menu.patient": "患者菜单配置",
  "sidenav.label.admin.menu.study": "研究菜单配置",
  "sidenav.label.admin.organizationmgt": "组织管理",
  "sidenav.label.admin.testmgt": "反射检测配置",
  "sidenav.label.admin.testmgt.calculated": "计算值检测管理",
  "sidenav.label.admin.testmgt.testCatalogEditor": "检测目录编辑器",
  "sidenav.label.admin.testCatalog": "检测目录管理",
  "sidenav.label.admin.testCatalog.backToList": "← 所有检测项目",
  "sidenav.label.admin.testCatalog.sectionsHelper": "点击某项检测以编辑其各部分",
  "sidenav.label.admin.testCatalog.editing": "编辑中",
  "sidenav.label.admin.testCatalog.editingGeneric": "编辑检测",
  "label.testCatalog.editor": "检测目录编辑器",
  "label.testCatalog.editor.empty": "点击某项检测以编辑其各部分",
  "label.testCatalog.editor.empty.helper": "从“检测目录”列表中打开一项检测以进行编辑。",
  "label.testCatalog.editor.loadError": "无法加载此检测。请重试。",
  "label.testCatalog.editor.saveAsNew": "另存为新检测……",
  "label.testCatalog.editor.save.pending": "各部分编辑器上线后即可保存。",
  "label.testCatalog.editor.clone.pending": "编辑器各部分上线后，即可使用“另存为新检测”功能。",
  "label.testCatalog.section.pending": "本节的编辑器将在后续的里程碑版本中发布。",
  "label.testCatalog.section.basic-info": "基本信息",
  "label.testCatalog.section.sample-results": "样本与结果",
  "label.testCatalog.section.methods": "方法",
  "label.testCatalog.section.ranges": "范围",
  "label.testCatalog.section.qc-targets": "质控靶值",
  "label.testCatalog.section.storage": "样本存储",
  "label.testCatalog.section.panels": "检测面板",
  "label.testCatalog.entity.panels": "面板编辑器",
  "note.panel.domainUpgrade": "检测面板的领域在面板本身上设置，而不是根据其检测所用的样本类型推断。",
  "note.panel.domainLaterPhase": "如果检测面板中的检测涉及其他领域的样本类型，该面板将标记为“混合领域”。",
  "label.panel.list.description": "有序的检测组合；样本类型由其成员检测派生",
  "label.panel.list.empty": "没有面板符合当前的过滤器条件。",
  "label.panel.search": "按名称或 LOINC 搜索",
  "button.panel.add": "添加面板",
  "label.panel.col.name": "面板名称",
  "label.panel.col.tests": "检测项目",
  "label.panel.col.domain": "领域",
  "label.panel.list.mixedDomain": "混合领域",
  "label.panel.list.mixedDomain.detail": "不属于此面板领域的样本类型：{sampleTypes}",
  "label.panel.col.sampleTypes": "样本类型（衍生）",
  "label.panel.col.status": "状态",
  "label.panel.backToList": "返回列表",
  "label.panel.notFound": "此面板不存在或无法加载。请返回列表选择其他面板。",
  "title.panel.new": "新面板",
  "label.panel.name": "面板名称",
  "placeholder.panel.name": "例如：贫血检查",
  "label.panel.domain": "领域",
  "helper.panel.domainGuard": "此面板中仅可添加{domain}领域的检测项目。",
  "helper.panel.loincIsIdentifier": "该面板的 LOINC 即为其标识符。",
  "note.panel.sampleTypesDerived": "样本类型源自本检测面板中的检测项目。",
  "label.panel.description": "描述",
  "label.panel.active": "活跃",
  "helper.panel.needsTest": "必须添加至少一项检测项目，才能激活此面板。",
  "error.panel.save": "无法保存该面板。请检查各字段，然后重试。",
  "error.panel.nameRequired": "必须填写面板名称。",
  "error.panel.nameTooLong": "面板名称最多 20 个字符。",
  "error.panel.descriptionTooLong": "描述最多 60 个字符。",
  "error.panel.nameDuplicate": "已有其他面板使用此名称。请输入其他名称。",
  "error.panel.domainConflict": "此面板不能归入 {domain}：{count, plural, one {其中 # 个检测属于} other {其中 # 个检测属于}}另一个领域（{tests}）。",
  "helper.panel.domainConflict.remedy": "请在检测目录中更改这些检测的领域，或将其从此面板中移除，然后重新保存。",
  "error.panel.tests.domainConflict": "未保存：{tests}{count, plural, one {不} other {不}}在此面板的领域（{domain}）内。只能添加 {domain} 领域的检测。",
  "error.panel.tests.activeNeedsTest": "未保存：启用的面板至少需要一个检测。请保留一个检测，或先在“基本信息”中停用该面板。",
  "error.panel.tests.inactive": "未保存：{tests}{count, plural, one {已停用} other {已停用}}。只能将已启用的检测添加到面板。",
  "error.panel.tests.loadFailed": "无法加载面板的检测，因此暂时无法保存。请重试以重新加载。",
  "error.testCatalog.panels.domainConflict": "此检测无法加入 {panelName}：该面板归入 {panelDomain}，而检测归入 {testDomain}。",
  "error.testCatalog.panels.activateFailed": "Panel \"{name}\" was created and this test added, but it could not be switched on. Activate it in the Panel Editor.",
  "error.testCatalog.panels.activeNeedsTest": "未保存：{panels} 在启用状态下将没有任何检测。请先停用{count, plural, one {该面板} other {这些面板}}，或在{count, plural, one {其中} other {其中}}保留此检测。",
  "success.panel.created": "面板已创建。在至少分配一项检测之前，该面板将保持停用状态。",
  "error.panel.create.invalid": "无法创建面板。请填写所有必填字段，包括 LOINC 代码。",
  "label.panel.section.basic-info": "基本信息",
  "label.panel.section.tests": "检测项目",
  "label.panel.section.terminology": "术语",
  "label.panel.section.localization": "本地化",
  "label.panel.localization.intro": "编辑此面板名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.panel.localization.empty": "此面板中没有可本地化的名称字段。",
  "label.panel.localization.loadError": "无法加载此面板的翻译。",
  "label.panel.localization.field.name": "面板名称",
  "sidenav.label.admin.panel.editing": "编辑面板：{name}",
  "sidenav.label.admin.panel.sectionsHelper": "点击一个面板以编辑其中的各部分",
  "sidenav.label.admin.panel.addingNew": "添加新面板",
  "label.panel.testsCount": "检测项目",
  "label.panel.addTest": "添加检测",
  "label.panel.tests.filterBySampleType": "按样本类型筛选",
  "label.panel.tests.filterBySampleType.all": "所有样本类型",
  "placeholder.panel.addTest": "按名称或代码搜索……",
  "helper.panel.membershipSync": "面板成员关系的写入会使订单录入中的面板列表保持同步。",
  "label.panel.col.order": "排序",
  "label.panel.col.testName": "检测名称",
  "label.panel.col.code": "代码",
  "label.panel.moveUp": "向上移动",
  "label.panel.moveDown": "向下移动",
  "empty.panel.tests": "尚无检测项目——请在上方搜索以添加第一个检测项目。",
  "helper.panel.loincRouting": "它同时也是实时路由键：FHIR 电子订单在接收时按此代码匹配检测面板。主要 LOINC 代码仍保留在检测面板上，用于列表显示和订单录入。",
  "label.panel.terminology.primary": "主要",
  "label.panel.terminology.empty": "目前尚无术语映射。LOINC映射即为该检测面板的标识符。",
  "label.panel.terminology.saved": "术语映射已保存。",
  "label.panel.terminology.saveInvalid": "某些映射无效。请检查来源、代码和重复项。",
  "label.panel.terminology.codeTooLong": "未保存：代码 {code} 超过 {max} 个字符。",
  "label.panel.terminology.loincTooLong": "未保存：{code} 不是 LOINC 代码。LOINC 代码最多 10 个字符。",
  "label.panel.terminology.saveError": "无法保存术语映射。",
  "note.panel.positionShared": "“位置”写入 panel_item.sort_order，即检测端“检测面板”部分所编辑的同一字段。",
  "label.testCatalog.section.labels": "标签",
  "label.testCatalog.section.terminology": "术语",
  "label.testCatalog.labels.col.preset": "预设",
  "label.testCatalog.labels.col.defaultQty": "默认数量",
  "label.testCatalog.labels.col.maxQty": "最大数量",
  "label.testCatalog.labels.col.allowOverride": "允许覆盖",
  "label.testCatalog.labels.col.actions": "操作",
  "label.testCatalog.labels.addLabelType": "添加标签类型",
  "label.testCatalog.labels.addLabelType.placeholder": "选择一个标签预设……",
  "label.testCatalog.labels.empty": "未配置任何标签类型。请添加标签预设，以便在订单中开具此检测时自动推荐标签。",
  "label.testCatalog.labels.loadError": "无法加载此检测项目的标签配置。",
  "label.testCatalog.labels.saved": "标签配置已保存",
  "label.testCatalog.labels.saveError": "无法保存标签配置。",
  "label.testCatalog.labels.unsaved": "您有未保存的标签更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.labels.maxLtDefault": "“最大数量”必须大于或等于“默认数量”。",
  "label.testCatalog.labels.allowOverride.label": "允许在订单录入时进行覆盖",
  "label.testCatalog.labels.generationSettings": "标签生成设置",
  "label.testCatalog.labels.remove.action": "移除",
  "label.testCatalog.labels.remove.title": "移除标签类型",
  "label.testCatalog.labels.remove.confirm": "移除",
  "label.testCatalog.labels.remove.body": "是否从该检测的标签配置中移除“{name}”？",
  "label.testCatalog.section.reagents": "试剂",
  "label.testCatalog.section.analyzers": "分析仪列表",
  "label.testCatalog.section.alerts": "警报",
  "label.testCatalog.section.accreditation": "认可",
  "label.testCatalog.accreditation.add": "添加认可",
  "label.testCatalog.accreditation.added": "已添加认可",
  "label.testCatalog.accreditation.removed": "已移除认可",
  "label.testCatalog.accreditation.empty": "此检测未获任何机构认可。",
  "label.testCatalog.accreditation.selectBody": "选择认可机构",
  "label.testCatalog.accreditation.remove": "移除认可",
  "label.testCatalog.accreditation.remove.body": "将此检测从 {body} 中移除？仅包含此检测的报告将不再显示其标志。",
  "label.testCatalog.accreditation.manageLink": "管理认可机构和有效期",
  "label.testCatalog.accreditation.loadError": "无法加载认可信息。",
  "label.testCatalog.accreditation.saveError": "无法添加认可。",
  "label.testCatalog.accreditation.deleteError": "无法移除认可。",
  "label.testCatalog.section.reflex-calc": "反射与计算",
  "label.testCatalog.section.localization": "本地化",
  "label.testCatalog.section.display-order": "显示顺序",
  "label.sampleType.section.basic-info": "基本信息",
  "label.sampleType.section.associated-tests": "相关检测项目",
  "label.sampleType.section.terminology": "术语",
  "label.sampleType.section.localization": "本地化",
  "label.sampleType.localization.intro": "编辑此样本类型名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.sampleType.localization.empty": "该样本类型没有可本地化的名称字段。",
  "label.sampleType.localization.loadError": "无法加载此样本类型的翻译。",
  "label.sampleType.localization.field.name": "样本类型名称",
  "label.sampleType.terminology.intro": "为确保互操作性，请将此样本类型映射到标准术语代码。",
  "label.sampleType.terminology.empty": "目前尚无术语映射。",
  "label.sampleType.terminology.saved": "术语映射已保存。",
  "label.sampleType.terminology.saveError": "无法保存术语映射。",
  "label.sampleType.terminology.saveInvalid": "某些映射无效。请检查来源、代码和重复项。",
  "label.sampleType.terminology.addHint": "请先保存此样本类型，然后再添加术语映射。",
  "label.sampleType.localization.addHint": "请先保存此样本类型，然后编辑其翻译。",
  "label.sampleType.name": "名称",
  "label.sampleType.section.display-order": "显示顺序",
  "label.sampleType.section.disposal": "处置",
  "label.sampleType.displayOrder": "在“样本类型”菜单中的位置",
  "label.sampleType.displayOrder.intro": "将此样本类型放置在订单录入的“样本类型”菜单中。输入位置或使用方向键，然后保存——所有样本类型都会重新编号。",
  "label.sampleType.displayOrder.current": "此样本类型",
  "label.sampleType.displayOrder.loading": "正在加载样本类型...",
  "label.sampleType.displayOrder.saved": "显示顺序已更新。",
  "label.sampleType.displayOrder.saveError": "无法更新显示顺序。",
  "label.sampleType.displayOrder.addHint": "请先保存此样本类型，然后设置其菜单位置。",
  "label.sampleType.disposalInstructions": "处置说明",
  "label.sampleType.disposal.intro": "关于处置此样本类型的自由文本参考指南。权威且规范的操作流程详见各检测项目的“存储”部分及样本处置工作流。",
  "label.sampleType.disposal.placeholder": "例如：在作为生物危害废物处置前进行高压灭菌",
  "label.sampleType.disposal.loading": "正在加载处置说明...",
  "label.sampleType.disposal.saved": "已保存处置说明。",
  "label.sampleType.disposal.saveError": "无法保存处置说明。",
  "label.sampleType.disposal.addHint": "请先保存此样本类型，然后再添加处置说明。",
  "label.sampleType.tests.manageIntro": "与该样本类型相关的检测项目。搜索目录以添加更多项目，或删除现有链接。该链接也可在“检测目录”中通过检测项目的“基本信息”进行管理。",
  "label.sampleType.tests.search": "搜索检测",
  "label.sampleType.tests.searchPlaceholder": "按检测名称搜索...",
  "label.sampleType.tests.filterBySampleType": "按样本类型筛选",
  "label.sampleType.tests.filterBySampleType.all": "任何样本类型",
  "label.sampleType.tests.pick": "要添加的检测",
  "label.sampleType.tests.pickPlaceholder": "选择一项检测……",
  "label.sampleType.tests.add": "添加检测",
  "label.sampleType.tests.addError": "无法将该检测与该样本类型关联。",
  "label.sampleType.tests.domainMismatch": "此检测属于与该样本类型不同的领域，因此不能使用该样本类型。",
  "label.sampleType.tests.remove": "移除检测",
  "helper.sampleType.name": "为此样本类型输入唯一名称（例如“血清”、“全血”）",
  "helper.sampleType.description": "提供此样本类型的描述，供实验室人员参考",
  "label.sampleType.active": "活跃",
  "label.sampleType.description": "描述",
  "label.sampleType.tests.removeError": "无法取消关联该检测项目。",
  "label.sampleType.tests.removeLastOfActive": "未取消关联：这是某个启用中检测的唯一样本类型，取消后该检测将无法下单。请先为该检测添加其他样本类型或将其停用。",
  "label.sampleType.tests.loading": "正在加载相关检测项目...",
  "label.sampleType.tests.none": "此样本类型未关联任何检测项目。",
  "message.sampleType.add.success": "样本类型保存成功。",
  "message.sampleType.edit.success": "样本类型已成功更新。",
  "heading.sampleType.add": "添加新样本类型",
  "button.sampleType.create": "创建样本类型",
  "button.sampleType.creating": "创建中...",
  "heading.sampleType.filtered": "显示 {filtered} / {total} 个样本类型",
  "heading.sampleType.total": "总计：{total} 个样本类型",
  "label.sampleType.tests.addHint": "请先保存此样本类型，然后在检测配置中关联检测。",
  "message.sampleType.noResults": "未找到符合条件的样本类型",
  "error.sampleType.create.invalidName": "此名称包含不允许的字符，例如 HTML 标签。请删除后重试。",
  "error.sampleType.create.invalid": "样本类型未创建。请检查各字段后重试。",
  "error.sampleType.create.duplicateName": "已存在同名的样本类型。",
  "error.sampleType.create.duplicateDescription": "此领域中已有另一个样本类型使用此描述。",
  "error.sampleType.update.description.409": "此领域中已有另一个样本类型使用此描述。",
  "error.sampleType.update.abbreviation.409": "此领域中已有另一个样本类型使用此缩写。",
  "error.sampleType.update.abbreviation.400": "缩写最多 10 个字符。",
  "error.sampleType.update.whonetCode.400": "WHONET 代码最多 5 个字符。",
  "error.sampleType.update.description.400": "描述最多 40 个字符。",
  "error.sampleType.nameTooLong": "新样本类型名称最多 40 个字符。",
  "label.sampleType.loading": "正在加载样本类型...",
  "label.sampleType.notFound": "此样本类型不存在。请返回列表选择其他样本类型。",
  "label.sampleType.editorLoadError": "无法加载样本类型。请刷新页面重试。",
  "stock.status.pendingQc": "待处理QC",
  "stock.status.qcFailed": "质控未通过",
  "stock.status.quarantined": "已隔离",
  "label.sampleType.whonetCode": "WHONET 标本代码",
  "helper.sampleType.whonetCode": "写入 WHONET SPECIMEN_TYPE 字段的代码（最多 5 个字符）。",
  "label.sampleType.whonetReturn": "返回 WHONET 预览",
  "warning.sampleType.deactivateInUse": "{count} 项启用的检测使用此类型；此类型停用期间将无法为这些检测下达订单。",
  "note.sampleType.associatedTests.viewOnly": "仅查看——检测标本是其身份识别的一部分。若要对该样本类型进行检测，请在“检测目录”中创建一个标本变体。",
  "sidenav.label.admin.sampleType.backToList": "← 所有样本类型",
  "sidenav.label.admin.sampleType.editing": "编辑中",
  "sidenav.label.admin.sampleType.editingGeneric": "编辑样本类型",
  "sidenav.label.admin.sampleType.sectionsHelper": "点击某样本类型以编辑其各部分",
  "sidenav.label.admin.sampleType.addingNew": "添加新样本类型",
  "label.testCatalog.localization.locale": "区域设置",
  "label.testCatalog.localization.intro": "编辑此检测名称和报告名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.testCatalog.localization.unsaved": "您有未保存的翻译更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.localization.loadError": "无法加载此检测项目的翻译。",
  "label.testCatalog.localization.empty": "此检测没有可本地化的名称字段。",
  "label.testCatalog.localization.saved": "翻译已保存",
  "label.testCatalog.localization.saveError": "无法保存翻译。",
  "label.testCatalog.localization.fallbackRequired": "英文值是没有翻译时所有界面显示的内容，因此不能为空。",
  "label.testCatalog.localization.field.name": "检测名称",
  "label.testCatalog.localization.field.reportingName": "报告名称",
  "label.testCatalog.localization.fallback.en": "备用语言（英文）",
  "label.testCatalog.localization.fallback.tooltip": "由于未为“{locale}”配置翻译值，因此显示英文值。",
  "label.testCatalog.reflexCalc.loadError": "无法为此检测加载反射和计算交叉链接。",
  "label.testCatalog.reflexCalc.reflex.heading": "反射检测",
  "label.testCatalog.reflexCalc.reflex.helper": "根据该检测结果自动安排后续检测的规则。请在“主列表”→“反射规则”中进行管理。",
  "label.testCatalog.reflexCalc.reflex.col.rule": "规则名称",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "触发条件",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "已下单的反射检测",
  "label.testCatalog.reflexCalc.reflex.empty": "未配置任何反射规则。反射规则可在“主列表”→“反射规则”中进行管理。",
  "label.testCatalog.reflexCalc.reflex.manage": "管理反射规则",
  "label.testCatalog.reflexCalc.calc.heading": "计算结果",
  "label.testCatalog.reflexCalc.calc.helper": "使用此检测结果或以此检测为输出的公式。请在“主列表”→“计算结果”中进行管理。",
  "label.testCatalog.reflexCalc.calc.feedsInto": "该检测项目的结果将纳入",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "此检测由以下公式计算得出",
  "label.testCatalog.reflexCalc.calc.col.name": "公式名称",
  "label.testCatalog.reflexCalc.calc.col.formula": "公式",
  "label.testCatalog.reflexCalc.calc.col.output": "输出检测",
  "label.testCatalog.reflexCalc.calc.empty": "无",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "此检测不参与任何计算结果。计算在“主列表”→“计算值”中管理。",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "此检测并非由其他检测计算得出。计算在“主列表”→“计算值”中管理。",
  "label.testCatalog.reflexCalc.calc.manage": "管理计算结果",
  "label.testCatalog.alerts.addRule": "添加规则",
  "label.testCatalog.alerts.empty": "未配置任何警报规则。请添加一条规则，以便在结果符合某个条件时通知收件人。",
  "label.testCatalog.alerts.loadError": "无法加载此检测项目的警报规则。",
  "label.testCatalog.alerts.saved": "警报规则已保存",
  "label.testCatalog.alerts.saveError": "无法保存警报规则。",
  "label.testCatalog.alerts.saveRefused": "警报规则被拒绝。名称、值和自定义电子邮件最多 100 个字符，自定义电话最多 20 个字符，且角色必须是可接收通知的角色。",
  "label.testCatalog.alerts.deleted": "已删除警报规则",
  "label.testCatalog.alerts.deleteError": "无法删除该警报规则。",
  "label.testCatalog.alerts.nameRequired": "规则名称为必填项。",
  "label.testCatalog.alerts.valueRequired": "“特定值”触发器需要指定一个具体值。",
  "label.testCatalog.alerts.col.name": "名称",
  "label.testCatalog.alerts.col.trigger": "触发条件",
  "label.testCatalog.alerts.col.channels": "渠道",
  "label.testCatalog.alerts.col.ack": "需确认",
  "label.testCatalog.alerts.col.enabled": "已启用",
  "label.testCatalog.alerts.col.actions": "操作",
  "label.testCatalog.alerts.trigger.ALL": "所有结果",
  "label.testCatalog.alerts.trigger.ABNORMAL": "异常",
  "label.testCatalog.alerts.trigger.CRITICAL": "紧急",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "具体值",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "合规违规",
  "label.testCatalog.alerts.edit.action": "编辑",
  "label.testCatalog.alerts.delete.action": "删除",
  "label.testCatalog.alerts.delete.title": "删除警报规则",
  "label.testCatalog.alerts.delete.confirm": "删除",
  "label.testCatalog.alerts.delete.body": "删除警报规则{name}？",
  "label.testCatalog.alerts.modal.addTitle": "添加警报规则",
  "label.testCatalog.alerts.modal.editTitle": "编辑警报规则",
  "label.testCatalog.alerts.field.name": "规则名称",
  "label.testCatalog.alerts.field.trigger": "当结果为以下情况时触发警报：",
  "label.testCatalog.alerts.field.specificValue": "具体值",
  "label.testCatalog.alerts.field.channels": "通知渠道",
  "label.testCatalog.alerts.field.recipients": "收件人",
  "label.testCatalog.alerts.field.ackRequired": "要求确认",
  "label.testCatalog.alerts.channel.sms": "短信",
  "label.testCatalog.alerts.channel.email": "电子邮件",
  "label.testCatalog.alerts.recipient.physician": "申请医生",
  "label.testCatalog.alerts.recipient.patient": "患者",
  "label.testCatalog.alerts.recipient.facility": "转诊设施",
  "label.testCatalog.alerts.recipient.customPhone": "自定义电话",
  "label.testCatalog.alerts.recipient.customEmail": "自定义电子邮件",
  "label.testCatalog.alerts.recipient.roleId": "通知具有该角色的用户",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "选择角色",
  "label.testCatalog.reagents.col.name": "试剂名称",
  "label.testCatalog.reagents.col.usage": "使用类型",
  "label.testCatalog.reagents.col.qty": "每次检测的数量",
  "label.testCatalog.reagents.col.stock": "库存水平",
  "label.testCatalog.reagents.col.actions": "操作",
  "label.testCatalog.reagents.empty": "未关联任何试剂。请从库存中关联试剂，以便跟踪每次检测项目的消耗量。",
  "label.testCatalog.reagents.loadError": "无法加载此检测所需的试剂。",
  "label.testCatalog.reagents.linkButton": "关联试剂",
  "label.testCatalog.reagents.linkError": "无法关联一个或多个试剂。请重试。",
  "label.testCatalog.reagents.modal.title": "关联试剂",
  "label.testCatalog.reagents.modal.linkSelected": "关联所选项",
  "label.testCatalog.reagents.modal.select.label": "试剂",
  "label.testCatalog.reagents.modal.select.placeholder": "选择要关联的试剂",
  "label.testCatalog.reagents.modal.allLinked": "所有可用的试剂均已与该检测关联。",
  "label.testCatalog.reagents.unitPlaceholder": "单位",
  "label.testCatalog.reagents.updated": "试剂已更新",
  "label.testCatalog.reagents.saveError": "无法保存更改。",
  "label.testCatalog.reagents.unitTooLong": "单位最多 50 个字符。",
  "label.testCatalog.reagents.unsaved": "您有未保存的试剂更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.reagents.retry": "重试",
  "label.testCatalog.reagents.unlink.action": "取消关联",
  "label.testCatalog.reagents.unlink.title": "解除试剂关联",
  "label.testCatalog.reagents.unlink.confirm": "取消关联",
  "label.testCatalog.reagents.unlink.body": "是否要将{name}与此检测解除关联？与该试剂关联的现有结果不受影响。",
  "label.testCatalog.reagents.unlinked": "试剂已取消关联",
  "label.testCatalog.reagents.unlinkError": "无法解除试剂的关联。请重试。",
  "label.testCatalog.basicInfo.name": "名称",
  "label.testCatalog.basicInfo.name.helper": "显示名称已被翻译——请在“本地化”部分进行编辑。",
  "label.testCatalog.basicInfo.reportingName": "报告名称",
  "label.testCatalog.basicInfo.labUnit": "实验室单元",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name}（已停用）",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "此实验室单元已停用，因此无法下单此检测。保存后仍保持停用；请在实验室单元管理中重新启用。",
  "label.testCatalog.basicInfo.createInactiveHint": "该检测创建时处于“非活跃”状态。请配置其各部分，然后将其激活，使其可以下单。",
  "sidenav.label.environmental.compliance.tooltip": "环境合规仪表板",
  "site.search.helper": "请输入至少 2 个字符以进行自动搜索。必填，用于将结果回传给申请站点。",
  "storage.skipped.title": "跳过了{count}个样本的存储操作",
  "test.qc.blankThreshold": "空白阈值",
  "test.qc.recoveryWindowPct": "回收率窗口（%）",
  "test.qc.rpdThreshold": "RPD阈值（%）",
  "test.qc.thresholds.description": "环境/病媒质控评估的可选阈值。如不适用，请留空。",
  "test.qc.thresholds.heading": "质控接受阈值",
  "title.testCatalog.createTest": "创建新测试",
  "label.testCatalog.testName": "检测名称",
  "label.testCatalog.testCode": "检测代码",
  "label.testCatalog.domain": "领域",
  "label.testCatalog.specimenType": "样本类型",
  "label.testCatalog.basicInfo.sampleTypes": "样本类型",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "选择本检测适用的所有样本。配置在这些样本之间共享。",
  "error.testCatalog.basicInfo.sampleTypeRequired": "请至少选择一种样本类型。",
  "error.testCatalog.basicInfo.sampleTypeDomain": "此样本类型的领域与检测的领域不匹配。",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "标本",
  "label.testCatalog.override.shared": "所有样本（共享）",
  "notice.testCatalog.intake.awaitingSpecimen": "等待标本——该检测需使用多个标本；请在采样时解决。",
  "tag.testCatalog.finding.noSampleTypeLink": "没有样本类型的链接",
  "error.testCatalog.codeExists": "已存在使用此代码的检测。",
  "error.testCatalog.description.inUse": "已有另一个检测项目使用了此描述。描述必须是唯一的——请修改后再次保存。",
  "notification.testCatalog.testCreated": "检测“{name}”已创建。请在左侧各部分中完成其配置。",
  "label.testCatalog.basicInfo.code": "代码",
  "label.testCatalog.basicInfo.description": "描述",
  "label.testCatalog.basicInfo.domain": "领域",
  "label.testCatalog.basicInfo.domain.CLINICAL": "临床",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "环境",
  "label.testCatalog.basicInfo.domain.VECTOR": "病媒",
  "label.testCatalog.basicInfo.domainModal.title": "更改检测领域？",
  "label.testCatalog.basicInfo.domainModal.body": "将此检测的领域更改为 {domain} 吗？这会影响该检测在目录中的分类方式。",
  "label.testCatalog.basicInfo.amr": "AMR监测检测",
  "label.testCatalog.basicInfo.active": "活跃",
  "label.testCatalog.basicInfo.status": "状态",
  "label.testCatalog.basicInfo.orderable": "可订购",
  "label.testCatalog.basicInfo.saved": "基本信息已保存。",
  "error.testCatalog.basicInfo.labUnitInactive": "该实验室单元已停用。请选择一个启用的单元，或先在实验室单元管理中重新启用它。",
  "error.testCatalog.create.refused": "检测未创建：某个样本类型或实验室单元无法使用。请检查后重试。",
  "error.testCatalog.basicInfo.invalidValue": "基本信息未保存：某个值无法存储。请更正突出显示的字段。",
  "error.testCatalog.basicInfo.timeHolding": "请输入整数分钟数，或留空。",
  "error.testCatalog.basicInfo.qcThreshold": "请输入 0 或更大的数字（最多 5 位小数），或留空。",
  "label.testCatalog.sampleResults.saved": "样本和结果已保存。",
  "label.testCatalog.sampleResults.empty": "目前尚无结果组件。请添加一个，以定义如何采集此检测的结果。",
  "label.testCatalog.sampleResults.newComponent": "（新组件）",
  "label.testCatalog.sampleResults.code": "组件代码",
  "label.testCatalog.sampleResults.isPrimary": "主要组件",
  "label.testCatalog.sampleResults.showOnReport": "显示在患者报告中",
  "label.testCatalog.sampleResults.label": "组件标签",
  "label.testCatalog.sampleResults.resultType": "结果类型",
  "label.testCatalog.sampleResults.resultType.N": "数值",
  "label.testCatalog.sampleResults.resultType.none": "未选择结果类型",
  "label.testCatalog.sampleResults.preview.noType": "请在上方选择一种结果类型，以查看技术人员将如何录入该结果。",
  "label.testCatalog.sampleResults.resultType.D": "单选列表（字典）",
  "label.testCatalog.sampleResults.resultType.R": "自由文本",
  "label.testCatalog.sampleResults.resultType.M": "多选列表",
  "label.testCatalog.sampleResults.resultType.C": "级联多选",
  "label.testCatalog.sampleResults.resultType.T": "滴度",
  "label.testCatalog.sampleResults.resultType.A": "字母型（经验证的文本）",
  "label.testCatalog.sampleResults.resultType.group.primary": "常见",
  "label.testCatalog.sampleResults.resultType.group.advanced": "高级/旧版类型",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "高级/旧版类型",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "隐藏高级/旧版类型",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "一个带有单位的测量数值（例如 12.3 g/dL）。",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "从固定集合中选择的一个值（例如“检测到”/“未检测到”）。",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "手动输入的备注或描述。",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "列表中的一个或多个值；没有单一的参考值。",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "分组选项；可选择多个组。",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "稀释比例，例如 1:10 或 1:20（常见于血清学）。",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "经验证的字母数字文本（代码或简短编码值）。",
  "label.testCatalog.sampleResults.preview": "结果录入预览",
  "label.testCatalog.sampleResults.previewHelper": "技术员输入该结果时，看到的画面如下。",
  "label.testCatalog.sampleResults.purpose": "明确技术员在该检测中应记录的内容以及如何解释结果。",
  "label.testCatalog.sampleResults.labelRequired": "每个结果组件在保存之前都需要添加标签。",
  "label.testCatalog.sampleResults.resultTypeRequired": "在保存之前，请为“{component}”选择一种结果类型。",
  "label.testCatalog.sampleResults.mostTestsOneResult": "大多数检测只记录一个结果。仅当该检测产生多个值（例如白细胞分类计数）时，才添加组件。",
  "label.testCatalog.sampleResults.displayOrder": "显示顺序",
  "label.testCatalog.sampleResults.uom": "测量单位",
  "label.testCatalog.sampleResults.uom.none": "（无）",
  "label.testCatalog.sampleResults.uom.addNew": "＋ 添加新单位…",
  "label.testCatalog.sampleResults.uom.newName": "显示名称",
  "label.testCatalog.sampleResults.uom.newCode": "代码",
  "label.testCatalog.sampleResults.uom.newUcum": "UCUM 代码",
  "label.testCatalog.sampleResults.uom.newDescription": "描述",
  "label.testCatalog.sampleResults.uom.saveNew": "创建单位",
  "label.testCatalog.sampleResults.significantDigits": "有效位数",
  "label.testCatalog.sampleResults.significantDigits.helper": "输入数值结果时，小数点后保留的位数。如不进行四舍五入，请留空。",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "检出限（可选）",
  "admin.testCatalog.sampleResults.loq.helper": "定量限（可选）",
  "error.testCatalog.sampleResults.valueTooLong": "{component}：某个值超出了字段允许的长度（标签 255、代码 50、默认结果和选项值 80；判读文本 255、匹配 80、严重程度和颜色 20 个字符）。",
  "error.testCatalog.sampleResults.unitUnknown": "{component}：该测量单位不存在。",
  "error.testCatalog.sampleResults.activeNeedsComponent": "未保存：启用的检测至少需要一个结果组分。请保留一个组分，或先在基本信息中停用该检测。",
  "error.testCatalog.sampleResults.lodGtLoq": "检出限（LOD）不能大于定量限（LOQ）。",
  "error.testCatalog.sampleResults.detectionLimitNegative": "检出限必须大于或等于零。",
  "admin.testCatalog.qcTargets.section.label": "质控目标值",
  "admin.testCatalog.qcTargets.intro": "结果录入据以判定每次质控运行的质控目标值。在此输入一次，技术人员只需输入测量值。",
  "admin.testCatalog.qcTargets.column.level": "质控水平",
  "admin.testCatalog.qcTargets.column.expected": "预期值",
  "admin.testCatalog.qcTargets.column.uncertainty": "不确定度（±）",
  "admin.testCatalog.qcTargets.column.unit": "单位",
  "admin.testCatalog.qcTargets.column.overrides": "批号覆盖",
  "admin.testCatalog.qcTargets.column.status": "状态",
  "admin.testCatalog.qcTargets.column.actions": "操作",
  "admin.testCatalog.qcTargets.level.low": "低",
  "admin.testCatalog.qcTargets.level.normal": "正常",
  "admin.testCatalog.qcTargets.level.high": "高",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "预期结果",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "选择预期结果",
  "admin.testCatalog.qcTargets.addTarget": "添加目标值",
  "admin.testCatalog.qcTargets.addOverride": "添加批号覆盖",
  "admin.testCatalog.qcTargets.lot.label": "质控品批号",
  "admin.testCatalog.qcTargets.lot.placeholder": "搜索质控品批号…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "未找到批号：请在质控品批号管理中管理批号",
  "admin.testCatalog.qcTargets.overrides.none": "无批号覆盖",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, other {# 个批号覆盖}}",
  "admin.testCatalog.qcTargets.empty.level": "未配置目标值：技术人员在录入时输入数值",
  "admin.testCatalog.qcTargets.helper.precedence": "在结果录入时，质控表单会优先使用批号覆盖值（如有），否则使用质控水平默认值进行预填。",
  "admin.testCatalog.qcTargets.showDeactivated": "显示已停用",
  "admin.testCatalog.qcTargets.deactivate": "停用",
  "admin.testCatalog.qcTargets.reactivate": "重新激活",
  "admin.testCatalog.qcTargets.edit": "编辑目标值",
  "admin.testCatalog.qcTargets.done": "打印完成",
  "admin.testCatalog.qcTargets.saved": "质控目标值已保存。",
  "admin.testCatalog.qcTargets.loadError": "无法加载质控目标值。",
  "error.testCatalog.qcTargets.uncertaintyNegative": "不确定度必须是一个非负数。",
  "error.testCatalog.qcTargets.required": "每个启用的靶值都需要一个期望值和一个不确定度，或一个期望结果。",
  "label.testCatalog.sampleResults.defaultResult": "默认结果",
  "label.testCatalog.sampleResults.defaultResult.none": "无默认值",
  "label.testCatalog.sampleResults.allowMultiple": "允许多个读数",
  "label.testCatalog.sampleResults.options": "选择列表选项",
  "label.testCatalog.sampleResults.options.empty": "尚未定义任何选项。请至少添加一个选项，以便输入此结果。",
  "label.testCatalog.sampleResults.option.value": "值",
  "label.testCatalog.sampleResults.option.sortOrder": "排序顺序",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "选项会按升序排序顺序显示给技术员——数字越小，显示位置越靠前。",
  "label.testCatalog.sampleResults.option.normal": "正常",
  "label.testCatalog.sampleResults.option.qualifiable": "可附加说明",
  "error.testCatalog.sampleResults.duplicateOption": "{component} 多次列出了 {options}。请删除多余的行，使结果录入中每个选项只出现一次。",
  "label.testCatalog.sampleResults.addOption": "添加选项",
  "label.testCatalog.sampleResults.addCustomOption": "添加自定义选项",
  "label.testCatalog.sampleResults.searchDictionary": "搜索字典值……",
  "label.testCatalog.sampleResults.removeOption": "移除选项",
  "label.testCatalog.sampleResults.interpretations": "解释",
  "label.testCatalog.sampleResults.interpretations.empty": "未定义任何解释。请添加一个解释，以便为结果附加指导信息或严重程度标记。",
  "label.testCatalog.sampleResults.interp.valueMatch": "值匹配",
  "label.testCatalog.sampleResults.interp.selectValue": "请选择一个值……",
  "label.testCatalog.sampleResults.interp.numericHint": "例如：>140、90-140、=0",
  "label.testCatalog.sampleResults.interp.text": "解释",
  "label.testCatalog.sampleResults.interp.severity": "严重程度",
  "label.testCatalog.sampleResults.addInterpretation": "添加解释",
  "label.testCatalog.sampleResults.removeInterpretation": "移除解释",
  "label.testCatalog.sampleResults.severity.NORMAL": "正常",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "异常",
  "label.testCatalog.sampleResults.severity.CRITICAL": "紧急",
  "label.testCatalog.sampleResults.actions": "操作",
  "label.testCatalog.sampleResults.addComponent": "添加组件",
  "label.testCatalog.sampleResults.removeComponent": "移除组件",
  "label.testCatalog.sampleResults.moveUp": "将组件向上移动",
  "label.testCatalog.sampleResults.moveDown": "将组件向下移动",
  "label.testCatalog.sampleResults.copyFrom": "从检测复制配置",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "选择一项检测……",
  "label.testCatalog.sampleResults.copyFromButton": "从检测项目中复制",
  "label.testCatalog.sampleResults.copyConfirm.title": "替换此检测的结果配置？",
  "label.testCatalog.sampleResults.copyConfirm.body": "此检测的所有结果组件、选择列表选项和判读都将替换为 {source} 的内容。点击保存前不会有任何更改。保存后，替换无法撤销。",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "替换配置",
  "label.testCatalog.sampleResults.copyStaged": "已从 {source} 复制配置，尚未保存",
  "label.testCatalog.sampleResults.copyStaged.helper": "点击保存以用其替换此检测的配置，或放弃以保留当前配置。",
  "label.testCatalog.sampleResults.copyDiscard": "放弃复制的配置",
  "label.testCatalog.sampleResults.copyEmpty": "{source} 没有可复制的结果配置。",
  "label.testCatalog.sampleResults.copyLoadError": "无法加载 {source} 的配置。",
  "label.testCatalog.sampleResults.copied": "配置已复制。",
  "label.testCatalog.ranges.activated": "检测已激活。",
  "label.testCatalog.ranges.ackModal.title": "存在覆盖缺口时仍要激活吗？",
  "label.testCatalog.ranges.ackModal.confirm": "确认并激活",
  "label.testCatalog.ranges.ackModal.warning": "该检测项目的参考范围存在覆盖缺口。",
  "label.testCatalog.ranges.ackModal.body": "以下年龄段没有参考范围——该年龄段的结果无法根据参考范围进行标记。如仍要激活，请确认。",
  "label.testCatalog.ranges.male": "男性",
  "label.testCatalog.ranges.female": "女性",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "天",
  "label.testCatalog.ranges.months": "月",
  "label.testCatalog.ranges.years": "岁",
  "label.testCatalog.ranges.noUpperLimit": "无上限",
  "label.testCatalog.ranges.noLowerLimit": "无下限",
  "label.testCatalog.ranges.both": "两者",
  "label.testCatalog.ranges.add": "添加范围",
  "label.testCatalog.ranges.empty": "尚未定义参考范围。",
  "label.testCatalog.ranges.saved": "参考范围已保存。",
  "label.testCatalog.ranges.loadError": "无法加载参考范围。",
  "label.testCatalog.ranges.col.component": "组件",
  "label.testCatalog.ranges.allComponents": "所有组件",
  "label.testCatalog.ranges.col.sex": "性别",
  "label.testCatalog.ranges.col.age": "年龄范围",
  "label.testCatalog.ranges.col.normal": "正常",
  "label.testCatalog.ranges.col.critical": "紧急",
  "label.testCatalog.ranges.col.valid": "有效",
  "label.testCatalog.ranges.col.actions": "操作",
  "label.testCatalog.ranges.anyAge": "任何年龄",
  "label.testCatalog.ranges.coverage.title": "覆盖范围验证",
  "label.testCatalog.ranges.coverage.gapsHeading": "未覆盖的年龄区间：",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "完全覆盖",
  "label.testCatalog.ranges.coverage.status.GAP": "存在缺口",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "存在重叠",
  "label.testCatalog.ranges.coverage.status.EMPTY": "无范围",
  "label.testCatalog.ranges.modal.titleAdd": "添加参考范围",
  "label.testCatalog.ranges.modal.titleEdit": "编辑参考范围",
  "label.testCatalog.ranges.modal.sex": "适用范围",
  "label.testCatalog.ranges.modal.component": "结果组件",
  "label.testCatalog.ranges.modal.component.all": "所有组件",
  "label.testCatalog.ranges.modal.ageUnit": "年龄单位",
  "label.testCatalog.ranges.modal.minAge": "起始年龄",
  "label.testCatalog.ranges.modal.maxAge": "截止年龄（留空表示无上限）",
  "label.testCatalog.ranges.modal.lowNormal": "正常下限",
  "label.testCatalog.ranges.modal.highNormal": "正常上限",
  "label.testCatalog.ranges.modal.lowCritical": "紧急下限",
  "label.testCatalog.ranges.modal.highCritical": "紧急上限",
  "label.testCatalog.ranges.modal.lowValid": "有效下限",
  "label.testCatalog.ranges.modal.highValid": "有效上限",
  "label.testCatalog.ranges.modal.lowReporting": "报告下限",
  "label.testCatalog.ranges.modal.highReporting": "报告上限",
  "error.testCatalog.ranges.reportingInverted": "报告下限不能高于报告上限。",
  "label.testCatalog.ranges.modal.ageError": "“截止年龄”必须大于“起始年龄”。",
  "label.testCatalog.ranges.modal.boundsError": "边界值必须按由内向外嵌套：有效下限 ≤ 紧急下限 ≤ 正常下限 ≤ 正常上限 ≤ 紧急上限 ≤ 有效上限。",
  "label.testCatalog.storage.saved": "样本存储已保存。",
  "label.testCatalog.storage.loadError": "无法加载样本存储设置。",
  "label.testCatalog.storage.history.view": "查看更改历史",
  "label.testCatalog.storage.history.title": "样本存储 — 变更历史",
  "label.testCatalog.storage.history.loadError": "无法加载更改历史记录。",
  "label.testCatalog.storage.history.empty": "未记录任何变更。",
  "label.testCatalog.storage.history.filter": "按字段筛选",
  "label.testCatalog.storage.history.col.changedAt": "修改于",
  "label.testCatalog.storage.history.col.changedBy": "修改者",
  "label.testCatalog.storage.history.col.field": "字段",
  "label.testCatalog.storage.history.col.old": "旧值",
  "label.testCatalog.storage.history.col.new": "新值",
  "label.testCatalog.storage.storageHeading": "存储",
  "label.testCatalog.storage.disposalHeading": "处置",
  "label.testCatalog.storage.handlingHeading": "特殊处理",
  "label.testCatalog.storage.condition": "存储条件",
  "label.testCatalog.storage.conditionCustom": "自定义条件",
  "label.testCatalog.storage.duration": "最长存储期限",
  "label.testCatalog.storage.durationUnit": "时间单位",
  "label.testCatalog.storage.stabilityNotes": "稳定性备注",
  "label.testCatalog.storage.protectFromLight": "避光保存",
  "label.testCatalog.storage.doNotFreeze": "请勿冷冻",
  "label.testCatalog.storage.doNotRefrigerate": "请勿冷藏",
  "label.testCatalog.storage.disposalMethod": "处置方法",
  "label.testCatalog.storage.disposalTimeframe": "处置时间框架",
  "label.testCatalog.storage.disposalUnit": "时间单位",
  "label.testCatalog.storage.specialInstructions": "特别说明",
  "label.testCatalog.storage.overrideRestricted": "限制存储时长的覆盖设置",
  "label.testCatalog.storage.none": "— 无 —",
  "label.testCatalog.storage.condition.AMBIENT": "环境温度/常温",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "受控室温（20–25°C）",
  "label.testCatalog.storage.condition.COOL_ROOM": "阴凉室（8–15°C）",
  "label.testCatalog.storage.condition.COLD_ROOM": "冷藏室（2–8°C）",
  "label.testCatalog.storage.condition.REFRIGERATED": "冷藏（2–8°C）",
  "label.testCatalog.storage.condition.FROZEN": "冷冻（−20°C）",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "深冷（−70°C）",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "超低温冰箱（−80°C）",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "恒温培养箱（35–37°C）",
  "label.testCatalog.storage.disposal.INCINERATION": "焚烧",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "高压灭菌",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "化学消毒",
  "label.testCatalog.storage.disposal.BIOHAZARD": "生物危害废物",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "锐器容器",
  "label.testCatalog.storage.disposal.SEWER": "污水/排水处置",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "退回发送方",
  "label.testCatalog.storage.disposal.ARCHIVE": "长期存档",
  "label.testCatalog.storage.disposal.STANDARD": "普通废物",
  "label.testCatalog.storage.unit.hours": "小时",
  "label.testCatalog.storage.unit.days": "天",
  "label.testCatalog.storage.unit.weeks": "周",
  "label.testCatalog.storage.unit.months": "月",
  "label.testCatalog.analyzers.infoCard": "在分析仪配置屏幕上，分析仪与该检测项目相关联。此列表为只读。",
  "label.testCatalog.analyzers.empty": "目前尚未将任何分析仪映射到此检测。",
  "label.testCatalog.analyzers.loadError": "无法为该检测项目加载分析仪列表。",
  "label.testCatalog.analyzers.col.analyzer": "分析仪",
  "label.testCatalog.analyzers.col.testName": "分析仪检测名称",
  "label.testCatalog.displayOrder.pickSampleType": "样本类型",
  "label.testCatalog.displayOrder.intro": "重新排列某样本类型中检测的显示顺序。顺序会自动保存。",
  "label.testCatalog.displayOrder.empty": "此样本类型未分配任何检测。",
  "label.testCatalog.displayOrder.loadError": "无法加载显示顺序。",
  "label.testCatalog.displayOrder.saved": "显示顺序已保存。",
  "label.testCatalog.displayOrder.currentTest": "此检测",
  "label.testCatalog.displayOrder.moveUp": "向上移动",
  "label.testCatalog.displayOrder.moveDown": "向下移动",
  "label.testCatalog.displayOrder.col.position": "位置",
  "label.testCatalog.displayOrder.col.test": "检测",
  "label.testCatalog.displayOrder.dragHandle": "拖动以重新排序",
  "label.testCatalog.terminology.intro": "为确保互操作性，请将此检测映射到标准术语代码。",
  "vector.collectedVolume.helper": "该混样中的生物体数量，例如蚊子的数量。",
  "vector.complete.animal": "动物",
  "vector.complete.cancel": "取消",
  "vector.complete.details.collectionDate": "采集日期",
  "vector.complete.details.collectionSite": "回收点",
  "vector.complete.details.collector": "采集人",
  "vector.complete.details.lifecycleStage": "生命周期阶段",
  "vector.complete.details.tests": "检测项目",
  "vector.complete.details.title": "订单详情",
  "vector.complete.details.trapType": "陷阱类型",
  "vector.complete.labNumber": "实验室编号",
  "vector.complete.newOrder": "新病媒订单",
  "vector.complete.quantity": "数量",
  "vector.complete.quantity.value": "{count} 个生物体",
  "vector.complete.status": "状态",
  "vector.complete.status.processing": "处理中",
  "vector.lifecycleStage.helper": "已采样生物体的发育阶段。",
  "vector.order.collectionContext.helper": "可选：记录采集时的生态条件（生态习性）。",
  "vector.order.collectionDate.heading": "采集日期",
  "vector.order.collectionDate.helper": "从现场实际采集该批次的日期。适用于本订单中的每个样本。",
  "vector.order.site.add.new": "+ 添加新站点“{name}”",
  "vector.order.site.add.new.restricted": "管理员已禁用添加新采样点的功能。",
  "vector.order.site.new.helper": "保存此订单后，将创建一个新的采样点。",
  "vector.order.site.new.tag": "新",
  "vector.order.site.no.match": "未找到匹配的站点。",
  "vector.pool.noTests": "未记录任何检测项目",
  "vector.pool.summary": "{count} 只{animal}的混样",
  "vector.trapCount.helper": "已布设的诱捕器数量，与布设夜数结合，用于计算每诱捕器夜的密度。",
  "vector.trapNights.helper": "诱捕器处于工作状态的夜数。若未记录监测工作量，请留空。",
  "vector.trapType.helper": "使用的采集方法或设备——请先选择样本类型。",
  "vectorDec.actionBar.assigned": "{assigned}/{total} 已分配 · {pools} 个混样",
  "vectorDec.button.back": "返回",
  "vectorDec.button.discard": "丢弃",
  "vectorDec.button.previewGrouping": "预览分组",
  "vectorDec.button.savePools": "保存混样",
  "vectorDec.button.splitIndividuals": "拆分为单个标本 →",
  "vectorDec.button.splitIndividuals.tooltip": "快速设置：每个混样一个标本",
  "vectorDec.button.view": "查看",
  "vectorDec.col.children": "子标本",
  "vectorDec.col.positiveTest": "检测结果呈阳性",
  "vectorDec.col.results": "结果",
  "vectorDec.col.status": "状态",
  "vectorDec.empty": "没有混样拆分任务。",
  "vectorDec.error.initiateFailed": "无法启动混样拆分。",
  "vectorDec.error.loadWorklist": "无法加载混样拆分工作列表。",
  "vectorDec.error.minPoolCount": "混样数量必须至少为2个。",
  "vectorDec.error.noAssignedSpecimens": "保存前，请将至少一个标本拖放到混样中。",
  "vectorDec.error.noParent": "没有可用以拆分的父样本 SampleItem。",
  "vectorDec.error.poolFloorByType": "该批次有{types}种样本类型（{names}），随机分配至少需要{types}个混样。",
  "vectorDec.error.unassignedSpecimens": "{count} 标本尚未分配。请在保存前将所有标本分配完毕。",
  "vectorDec.field.howManyPools": "需要多少个混样？",
  "vectorDec.field.notes": "备注",
  "vectorDec.field.organismsPerPool": "每个样池中的生物体数量",
  "vectorDec.field.poolCount": "池的数量",
  "vectorDec.field.strategy": "分配方法",
  "vectorDec.filter.all": "所有分析仪",
  "vectorDec.filter.status": "按状态筛选",
  "vectorDec.heading.preview": "拟议的混样分组",
  "vectorDec.heading.split": "拆分为子混样",
  "vectorDec.heading.worklist": "混样拆分",
  "vectorDec.individualMode.badge": "单个标本模式",
  "vectorDec.locationOverride.help": "为各个子混样覆盖从接收记录继承的采集站点。当一个批次采集自多个站点时，请使用此选项。",
  "vectorDec.locationOverride.inherit": "继承自批次（默认）",
  "vectorDec.locationOverride.notes": "分装样本备注",
  "vectorDec.locationOverride.site": "采集站点",
  "vectorDec.locationOverride.title": "各子混样的采集地点（可选）",
  "vectorDec.message.success": "已创建 {count} 个子混样（{labRange}），{orders} 个检测订单已排入队列。状态 → 混样拆分进行中。",
  "vectorDec.message.successIndividual": "已创建 {count} 个单个分装样本（{labRange}），{orders} 项检测订单已排入队列。状态 → 混样拆分进行中。确认阳性后将触发VR-07子孢子确认流程。",
  "vectorDec.parent.label": "父样本",
  "vectorDec.parent.quantity": "数量：{qty}",
  "vectorDec.preview.body": "{count} 个混样，使用{strategy}。保存前可在混样之间拖拽标本进行调整。",
  "vectorDec.preview.empty": "无标本",
  "vectorDec.preview.organisms": "生物体",
  "vectorDec.preview.poolN": "混样 {n}",
  "vectorDec.preview.poolWithSpecies": "混样 {n}（{species}）",
  "vectorDec.preview.specimenCount": "{count, plural, other {# 个标本}}",
  "vectorDec.preview.title": "建议的分组方案",
  "vectorDec.preview.unassigned": "{count, plural, =0 {所有标本均已分配} one {# 个未分配} other {# 个未分配}}",
  "vectorDec.preview.unassignedHint": "{count} 个未分配，这些标本仍保留在原混样中。",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ 反射规则将在豁免检定时触发",
  "vectorDec.reflexPreview.parentTests": "父级测试指令（{test}）——在每个子节点上重新执行",
  "vectorDec.reflexPreview.screeningPanel": "筛选小组",
  "vectorDec.reflexPreview.tipSplitIndividuals": "提示：将标本拆分为单独的标本，以便同时触发{rules}——这些规则仅适用于仅含单一生物体的标本池。",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} 个标本 → 每个混样约 {perPool} 个{remainder, plural, =0 {} other {，余数 +1 分配给前 {remainder} 个}}",
  "vectorDec.status.complete": "拆分完成",
  "vectorDec.status.confirmed": "已确认",
  "vectorDec.status.inProgress": "进行中",
  "vectorDec.status.pending": "需要复核",
  "vectorDec.strategy.manual": "手动分配——将标本拖放至组中",
  "vectorDec.strategy.manual.hint": "请自行将标本拖拽到混样中",
  "vectorDec.strategy.manual.title": "手动分配",
  "vectorDec.strategy.random": "随机分配——将标本均匀分配到各混合样本中",
  "vectorDec.strategy.random.hint": "将标本均匀分配到各混样中",
  "vectorDec.strategy.random.title": "随机分配",
  "vectorDec.strategy.species": "由物种自动划分子组——将匹配的标本分组",
  "vectorDec.strategy.species.hint": "按物种对标本进行分组——标本上需标注物种名称",
  "vectorDec.strategy.species.title": "按物种自动划分子混样",
  "vectorDec.totalOrganisms": "生物体总数",
  "vectorDec.warning.exceedsParent.body": "子混样共请求 {total} 个生物体，但父混样只有 {parent} 个。系统仍会创建 {total} 个子样本。",
  "vectorDec.warning.exceedsParent.title": "总数量超过父项数量",
  "vectorId.batch.selectedCount": "{count, plural, other {已选择 # 个标本}}",
  "vectorId.bloodMeal.add": "将面板添加到订单中",
  "vectorId.bloodMeal.added": "已将血餐鉴定面板添加到标本检测订单中。",
  "vectorId.bloodMeal.addedSub": "来源：手动（实验室技术人员接受了该建议）。依据 BR-V03-014。",
  "vectorId.bloodMeal.alreadyAttached": "血餐面板已关联（{skipped} 项检测）。",
  "vectorId.bloodMeal.body": "下达“蚊虫血餐鉴定面板”检测，以鉴定该标本吸血的宿主物种。",
  "vectorId.bloodMeal.bulkAdd": "将面板添加到全部（{count}）",
  "vectorId.bloodMeal.bulkAddedSub": "已为 {count} 个标本处理血餐面板。",
  "vectorId.bloodMeal.bulkBody": "请为每个已选标本添加“蚊虫血餐鉴定面板”，以便实验室鉴定蚊虫吸食了哪种脊椎动物宿主的血液。",
  "vectorId.bloodMeal.bulkSummary": "血餐面板：已添加 {added}，{skipped} 已存在，{rejected} 被拒绝。",
  "vectorId.bloodMeal.bulkTitle": "检测到吸血雌蚊（{count} 个标本）",
  "vectorId.bloodMeal.dismiss": "忽略",
  "vectorId.bloodMeal.error.add": "无法添加“蚊虫血餐鉴定面板”。",
  "vectorId.bloodMeal.error.dismiss": "无法记录忽略操作。",
  "vectorId.bloodMeal.title": "检测到已吸血的雌蚊",
  "vectorId.bulk.applyToCount": "应用到 {count} 个标本",
  "vectorId.bulk.heading": "批量应用物种鉴定",
  "vectorId.bulk.notice.body": "分子详细信息字段（目标基因、检测方法、登记号）不会批量复制——请针对每个标本分别记录这些信息。",
  "vectorId.bulk.notice.title": "未复制标本特有的字段",
  "vectorId.button.bulkApply": "🔖 批量应用（{count}）",
  "vectorId.button.cancel": "取消",
  "vectorId.button.close": "▲ 关闭",
  "vectorId.button.confirm": "确认",
  "vectorId.button.confirmAll": "✓ 确认所有向量",
  "vectorId.button.confirmResult": "✓ 确认：{test}",
  "vectorId.button.hideResults": "隐藏结果",
  "vectorId.button.identify": "▼ 鉴定",
  "vectorId.button.reviewResults": "复核结果（{n}）",
  "vectorId.button.save": "保存鉴定",
  "vectorId.button.splitPool": "↗ 分割",
  "vectorId.col.collectionDate": "采集日期",
  "vectorId.col.decon": "拆分",
  "vectorId.col.decon.help": "混样拆分状态：是否已录入混样结果，以及子混样是否正在等待复核。",
  "vectorId.col.idStatus": "ID 状态",
  "vectorId.col.lotId": "批次编号",
  "vectorId.col.organismGroup": "组",
  "vectorId.col.progress": "进度",
  "vectorId.col.site": "样本采样点",
  "vectorId.completion.body": "已确认 {positive}/{total} 个子混样（{pct}%）",
  "vectorId.completion.body.confirmed": "已确认 {total} 个病媒",
  "vectorId.completion.body.partial": "已确认适用于该混样中的所有病媒：",
  "vectorId.completion.heading": "混样拆分完成",
  "vectorId.completion.heading.confirmed": "结果已确认",
  "vectorId.completion.heading.partial": "结果部分得到确认",
  "vectorId.completion.tag": "拆分完成",
  "vectorId.completion.tag.confirmed": "已确认",
  "vectorId.completion.tag.partial": "部分确认",
  "vectorId.confidence.confirmed": "已确认",
  "vectorId.confidence.presumptive": "推定",
  "vectorId.distribution.confirmed": "{count} 已确认",
  "vectorId.distribution.heading": "物种分布",
  "vectorId.distribution.notIdentified": "{count} 未鉴定",
  "vectorId.distribution.notYet": "尚未鉴定",
  "vectorId.distribution.presumptive": "{count} 推定",
  "vectorId.empty": "此队列中没有批次。",
  "vectorId.error.accessionFormat": "GenBank 登录号格式：1–2 个字母，后跟 5–8 个数字（例如 MW123456）。",
  "vectorId.error.confidenceRequired": "置信度为必填项。",
  "vectorId.error.loadSpecimens": "无法加载该批次的标本。",
  "vectorId.error.loadWorklist": "无法加载工作列表。",
  "vectorId.error.methodRequired": "必须指定鉴定方法。",
  "vectorId.error.notesTooLong": "备注内容不得超过500个字符。",
  "vectorId.error.requiredFields": "必须提供物种、方法和置信度。",
  "vectorId.error.saveFailed": "无法保存鉴定。",
  "vectorId.error.speciesRequired": "必须填写物种。",
  "vectorId.filter.complete": "完成",
  "vectorId.filter.complete.sub": "所有标本均已鉴定完毕。",
  "vectorId.filter.decon": "混样拆分",
  "vectorId.filter.decon.sub": "已录入混样结果，正在等待技术员决定拆分或确认。",
  "vectorId.filter.label": "状态",
  "vectorId.filter.notstarted": "待处理的订单",
  "vectorId.filter.notstarted.sub": "已接收，0份标本已鉴定。",
  "vectorId.filter.partialid": "部分鉴定",
  "vectorId.filter.partialid.sub": "鉴定正在进行中。",
  "vectorId.filter.pending": "待处理",
  "vectorId.filter.pending.sub": "所有未完成的批次，包括结果待技术员复核的混样。",
  "vectorId.form.assayName": "检测名称",
  "vectorId.form.assayName.placeholder": "多重RT-PCR",
  "vectorId.form.confidence": "置信度",
  "vectorId.form.genbankAccession": "GenBank 登记号",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "生命周期阶段",
  "vectorId.form.linkedResult": "关联病原体结果",
  "vectorId.form.linkedResultPlaceholder": "请选择该批次的一个结果……",
  "vectorId.form.method": "方法",
  "vectorId.form.molecularDetails": "🔬 分子细节",
  "vectorId.form.notes": "备注",
  "vectorId.form.physState": "生理状态",
  "vectorId.form.select": "选择…",
  "vectorId.form.species": "物种",
  "vectorId.form.speciesPlaceholder": "搜索属或种……",
  "vectorId.form.targetGene": "靶基因",
  "vectorId.form.targetGene.placeholder": "COI、ITS2、28S rDNA",
  "vectorId.heading.worklist": "病媒鉴定工作列表",
  "vectorId.loading": "正在加载……",
  "vectorId.message.bulkSuccess": "已对 {count} 个标本应用鉴定。",
  "vectorId.message.saveSuccess": "鉴定已保存。",
  "vectorId.method.both": "形态学 + 分子学",
  "vectorId.method.molecular": "分子",
  "vectorId.method.morphological": "形态学",
  "vectorId.notif.confirmAll.error": "无法确认结果。请重试。",
  "vectorId.notif.confirmAll.success": "已确认该混样中所有病媒的结果。",
  "vectorId.notif.deconNeeded.body": "已为该混样录入结果。请拆分为子混样以进一步检测，或确认该结果适用于所有病媒。",
  "vectorId.notif.deconNeeded.bodyWithTest": "其中一项检测已有结果。请拆分为子混样以进一步检测，或确认该结果适用于所有病媒。",
  "vectorId.notif.deconNeeded.title": "混样结果等待复核",
  "vectorId.physState.blood_fed": "吸过血的",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "半孕期",
  "vectorId.physState.unfed": "未喂食",
  "vectorId.physState.unknown": "未知 / 未评估",
  "vectorId.resplit.heading": "Split：{label}",
  "vectorId.search.placeholder": "搜索批次……",
  "vectorId.specimen.col.confidence": "置信度",
  "vectorId.specimen.col.idStatus": "ID 状态",
  "vectorId.specimen.col.label": "标本",
  "vectorId.specimen.col.labNo": "实验室编号",
  "vectorId.specimen.col.poolOrSpecimen": "混样 / 标本",
  "vectorId.specimen.col.species": "物种",
  "vectorId.specimen.confirmed": "已确认",
  "vectorId.specimen.count": "标本",
  "vectorId.specimen.empty": "本批次无标本。",
  "vectorId.specimen.label": "标本编号：{n}",
  "vectorId.specimen.notIdentified": "未鉴定",
  "vectorId.specimen.presumptive": "推定",
  "vectorId.status.complete": "完成",
  "vectorId.status.inProgress": "进行中",
  "vectorId.status.notStarted": "待处理的订单",
  "vectorId.tag.deconComplete": "完成",
  "vectorId.tag.deconInProgress": "混样拆分进行中",
  "vectorId.tag.deconNeeded": "⚠ 复核结果",
  "vectorId.tag.subPoolPending": "{count} 个子混样有结果",
  "vectorId.tree.organisms": "{count, plural, other {# 个生物体}}",
  "vectorReport.density.bySite": "按站点和时期划分的密度",
  "vectorReport.density.effortNotRecorded": "未记录监测工作量",
  "vectorReport.density.period": "时期",
  "vectorReport.density.perTrapNight": "密度（每诱捕器夜）",
  "vectorReport.density.pools": "混样",
  "vectorReport.density.site": "站点",
  "vectorReport.density.specimens": "标本",
  "vectorReport.density.title": "各站点标本数量统计",
  "vectorReport.density.trapNights": "诱捕器夜",
  "vectorReport.description": "根据记录的病媒采集数据、物种鉴定结果和病原体检测结果计算得出的监测指标",
  "vectorReport.empty": "已选择范围内无数据。",
  "vectorReport.exportPdf": "导出PDF",
  "vectorReport.fieldMap.description": "对“手动录入助手”中显示的指标进行重新排序、隐藏、重新标记或添加门户标签。",
  "vectorReport.fieldMap.hidden": "隐藏",
  "vectorReport.fieldMap.label": "标签",
  "vectorReport.fieldMap.metric": "指标",
  "vectorReport.fieldMap.order": "排序",
  "vectorReport.fieldMap.portalTag": "门户标签",
  "vectorReport.fieldMap.title": "手动输入字段映射",
  "vectorReport.fieldMap.visibility": "可见性",
  "vectorReport.fieldMap.visible": "可见",
  "vectorReport.fieldMap.visibleLabel": "在“手动输入助手”中可见",
  "vectorReport.filter.allSites": "所有站点",
  "vectorReport.filter.apply": "应用",
  "vectorReport.filter.dateRange": "日期范围",
  "vectorReport.filter.from": "来源",
  "vectorReport.filter.site": "采样点",
  "vectorReport.filter.to": "到",
  "vectorReport.freshness": "数据时效性",
  "vectorReport.freshness.as": "截至 {time} 的数据",
  "vectorReport.freshness.unknown": "未知",
  "vectorReport.generated": "生成时间",
  "vectorReport.home": "首页",
  "vectorReport.loadError": "无法加载监测指标。请重试。",
  "vectorReport.manualEntry.confirmBody": "是否要记录本周数据的审计快照（{periodStart} – {periodEnd}）？重新提交一周的数据将被记录为一条独立的条目。",
  "vectorReport.manualEntry.confirmSubmit": "确认",
  "vectorReport.manualEntry.copied": "已复制到剪贴板",
  "vectorReport.manualEntry.copy": "复制值",
  "vectorReport.manualEntry.empty": "此期间未配置任何指标",
  "vectorReport.manualEntry.loading": "正在加载每周的数据……",
  "vectorReport.manualEntry.lowConfidence": "置信度降低（混样去卷积低于95%）",
  "vectorReport.manualEntry.markSubmitted": "将本周标记为已提交",
  "vectorReport.manualEntry.submitError": "无法记录提交",
  "vectorReport.manualEntry.submitted": "本周已标记为已提交",
  "vectorReport.manualEntry.title": "手动录入助手",
  "vectorReport.manualEntry.week": "报告周",
  "vectorReport.mir.classic": "MIR（经典版）",
  "vectorReport.mir.observed": "感染率（观察值）",
  "vectorReport.mir.pathogen": "病原体",
  "vectorReport.mir.positivePools": "阳性混样",
  "vectorReport.mir.resolution": "阳性解析率",
  "vectorReport.mir.species": "物种",
  "vectorReport.mir.sporozoite": "子孢子率",
  "vectorReport.mir.sporozoiteNote": "当混样去卷积解析率低于95%时，置信度会降低。",
  "vectorReport.mir.title": "各物种的最低感染率",
  "vectorReport.mir.totalSpecimens": "标本总数",
  "vectorReport.mir.withheld": "暂不公布",
  "vectorReport.positivity.notConfigured": "此部署未配置阳性分类，因此无法提供感染率、阳性率和子孢子率数据。请在检测目录中配置结果临床意义以启用这些数据。",
  "vectorReport.positivity.pathogen": "病原体",
  "vectorReport.positivity.pct": "阳性率",
  "vectorReport.positivity.poolsPositive": "阳性混样数",
  "vectorReport.positivity.poolsTested": "已检测混样数",
  "vectorReport.positivity.title": "病原体阳性率",
  "vectorReport.positivity.unrecognized": "某些结果的临床意义值不属于可识别的分类（阳性、阴性或不确定），因此未计入阳性率统计。请复核检测目录，以便将这些结果计入统计。",
  "vectorReport.prompt": "选择日期范围和站点，然后点击“应用”以查看监测指数。",
  "vectorReport.qc.detail": "{total} 项分析中有 {passed} 项通过",
  "vectorReport.qc.passed": "已通过分析数",
  "vectorReport.qc.passRate": "通过率",
  "vectorReport.qc.title": "质控通过率",
  "vectorReport.qc.total": "分析总计",
  "vectorReport.species.genus": "属",
  "vectorReport.species.pct": "占比",
  "vectorReport.species.species": "物种",
  "vectorReport.species.specimens": "标本",
  "vectorReport.species.title": "物种分布",
  "vectorReport.sporozoite.title": "子孢子率（按蚊）",
  "vectorReport.title": "病媒监测",
  "vfs.abj": "ABJ（无幼虫率）",
  "vfs.abj.target.below": "✗ ABJ 低于卫生部设定的 95% 目标",
  "vfs.abj.target.met": "✓ ABJ 达到了卫生部设定的 95% 的目标",
  "vfs.bi": "布雷托指数（每100户）",
  "vfs.ci": "容器指数（CI）",
  "vfs.containersExamined": "已检查容器数",
  "vfs.containersPositive": "阳性容器数",
  "vfs.err.containersExceeded": "不能超过已检查容器数。",
  "vfs.err.examinedMin": "输入幼虫数据时，该值必须≥1。",
  "vfs.err.housesExceeded": "不得超过已检查的房屋数量。",
  "vfs.err.negative": "不能为负数。",
  "vfs.err.populationMin": "输入蛹的数据时，该值必须≥1。",
  "vfs.hi": "房屋指数（HI）",
  "vfs.housesExamined": "已检查的房屋",
  "vfs.housesPositive": "阳性房屋数",
  "vfs.indices.title": "计算指标（预览）",
  "vfs.larval.title": "幼虫调查——模式C",
  "vfs.populationAtRisk": "风险人口",
  "vfs.ppi": "每人蛹数（PPI）",
  "vfs.pupaeCount": "蛹的数量",
  "vfs.pupal.title": "蛹调查——D模式",
  "vfs.surveyMethod": "调查方法",
  "vfs.surveyMethod.placeholder": "选择一个选项",
  "warning.testCatalog.noLoinc": "该检测项目没有 LOINC 代码。无法将分析仪和电子订单的结果导入到该检测项目中。",
  "warning.testCatalog.duplicateLoinc": "{testName} 也使用了 LOINC 代码 {code}。针对该代码接收到的检测结果仅会被路由到一项检测（首次匹配）——这可能导致结果被发送至错误的检测项目。",
  "label.testCatalog.terminology.col.source": "来源",
  "label.testCatalog.terminology.col.code": "代码",
  "label.testCatalog.terminology.col.displayName": "显示名称",
  "label.testCatalog.terminology.displayName.placeholder": "例如：血清或血浆中的葡萄糖[质量/体积]",
  "label.testCatalog.terminology.col.relationship": "关系",
  "label.testCatalog.terminology.col.appliesTo": "适用范围",
  "label.testCatalog.terminology.appliesTo.test": "完整检测",
  "label.testCatalog.terminology.col.actions": "操作",
  "label.testCatalog.terminology.source": "术语来源",
  "label.testCatalog.terminology.sourceTooLong": "A source is at most {max} characters",
  "label.testCatalog.terminology.code": "代码",
  "label.testCatalog.terminology.relationship": "关系",
  "label.testCatalog.terminology.addMapping": "添加映射",
  "label.testCatalog.terminology.remove": "移除映射",
  "label.testCatalog.terminology.empty": "目前尚无术语映射。",
  "label.testCatalog.terminology.loadError": "无法加载术语映射。",
  "label.testCatalog.terminology.saved": "术语映射已保存。",
  "error.testCatalog.terminology.duplicate": "{source} 代码 {code} 重复：该检测已存在此映射。",
  "error.testCatalog.terminology.invalid": "无法保存映射——请检查是否存在重复代码、未知来源或无效关系。",
  "error.testCatalog.terminology.tooLong": "代码最多 80 个字符，显示名称最多 255 个字符。",
  "label.testCatalog.terminology.rel.none": "— 无 —",
  "label.testCatalog.terminology.rel.SAME_AS": "与……相同",
  "label.testCatalog.terminology.rel.BROADER_THAN": "比……更广泛",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "比……窄",
  "label.testCatalog.panels.intro": "管理该检测所属的面板，以及它在每个面板中的位置。",
  "label.testCatalog.panels.addToPanel": "添加到面板",
  "label.testCatalog.panels.col.panel": "面板",
  "label.testCatalog.panels.col.position": "位置",
  "label.testCatalog.panels.col.actions": "操作",
  "label.testCatalog.panels.position": "位置",
  "label.testCatalog.panels.remove": "从面板中移除",
  "label.testCatalog.panels.remove.confirm.heading": "从面板上移除检测项目吗？",
  "label.testCatalog.panels.remove.confirm.body": "该检测将从“{panel}”中移除。它仍会保留在目录及其他面板中。您可以稍后重新添加它。",
  "label.testCatalog.panels.moveUp": "前移",
  "label.testCatalog.panels.moveDown": "后移",
  "label.testCatalog.panels.viewOrder": "查看该面板的检测顺序",
  "label.testCatalog.panels.orderContext": "此面板中的检测项目（按顺序）：",
  "label.testCatalog.panels.empty": "该检测项目目前尚未加入任何面板。",
  "label.testCatalog.panels.loadError": "无法加载面板归属信息。",
  "label.testCatalog.panels.saved": "面板归属信息已保存。",
  "label.testCatalog.panels.createPanel": "创建新面板",
  "label.testCatalog.panels.createPanelHint": "输入名称以创建面板，并将此检测添加到该面板中。其样本类型、订单模块及其他设置稍后在“面板编辑器”中配置。",
  "notification.testCatalog.panels.created": "已创建面板“{name}”，并已添加此检测。请在面板编辑器中进一步配置。",
  "label.search": "搜索",
  "label.testCatalog.list": "检测目录",
  "label.testCatalog.list.search": "按检测名称搜索",
  "label.testCatalog.list.col.status": "状态",
  "label.testCatalog.list.filter.allDomains": "所有领域",
  "label.testCatalog.list.filter.allStatus": "所有状态",
  "label.testCatalog.list.filter.inactive": "非活跃",
  "label.testCatalog.list.coverageIncomplete": "覆盖不完整",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "任何",
  "label.testCatalog.list.filter.amrOnly": "仅限AMR",
  "label.testCatalog.list.filter.nonAmr": "非AMR",
  "label.testCatalog.list.filter.sampleType": "样本类型",
  "label.testCatalog.list.filter.allSampleTypes": "所有样本类型",
  "label.testCatalog.list.filter.allLabUnits": "所有实验室单元",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "无 LOINC",
  "label.testCatalog.list.filter.issuesOnly": "仅显示存在问题的检测项目",
  "label.testCatalog.list.health.banner": "{count} 项检测存在配置问题（{errors} 个错误 · {warnings} 个警告）",
  "label.testCatalog.list.health.show": "显示",
  "label.testCatalog.activation.incomplete.heading": "检测目前还无法激活",
  "label.testCatalog.activation.incomplete.body": "在激活此检测之前，请先解决以下问题：",
  "label.testCatalog.list.col.sampleType": "样本类型",
  "button.testCatalog.newTest": "新检测项目",
  "button.testCatalog.editRelated": "将相关的检测项目集中编辑",
  "button.testCatalog.editRelatedFromEditor": "编辑相关检测项目……",
  "label.testCatalog.editor.noRelated": "没有其他检测项目与该检测名称相同。",
  "label.testCatalog.editor.createSaveFirst.title": "请先保存检测项目",
  "label.testCatalog.editor.createSaveFirst": "填写基本信息并保存。创建检测后，该部分即可使用。",
  "label.testCatalog.editingNTests": "正在编辑 {count} 项检测",
  "label.testCatalog.perTestIdentity": "标识与 LOINC（每项检测）",
  "state.testCatalog.differsAcrossTests": "各检测项目之间不同",
  "button.testCatalog.setAllTo": "将所有值都设置为这些值",
  "label.testCatalog.group.rangesSaved": "参考范围已保存至 {count} 项检测。",
  "label.testCatalog.group.storageIntro": "只需编辑一次“存储与处理”设置；保存后，您更改的字段将应用到所有已选择的检测，其他字段保持各检测原有值不变。",
  "label.testCatalog.group.storageDiffer": "以下字段在所选检测中不一致：{fields}。表单显示第一个检测的值；未更改的字段将保留各检测自身的值。",
  "button.testCatalog.removeFromSet": "从该集合中移除",
  "label.testCatalog.group.rangesIntro": "只需编辑一次参考范围；保存后，该参考范围将应用于所有已选择的检测项目。标识符和LOINC将保留在每个检测项目中。",
  "label.testCatalog.group.rangesDiffer": "已选检测项目的当前范围并不相同。保存后，所有检测项目的范围都将设置为以下值。",
  "label.testCatalog.group.rangesLoadError": "无法加载 {tests} 的当前范围，因此暂时无法应用任何内容。请重试以重新加载。",
  "label.testCatalog.ranges.table.sex": "适用范围",
  "label.testCatalog.ranges.table.age": "年龄范围",
  "label.testCatalog.ranges.table.normal": "正常（低/高）",
  "label.testCatalog.list.filters": "过滤器",
  "label.testCatalog.list.filters.count": "过滤器（{count}）",
  "label.testCatalog.list.error": "无法加载检测目录。请调整过滤器或重新加载页面后重试。",
  "label.testCatalog.list.empty": "没有检测项目符合当前的筛选条件。",
  "sidenav.label.admin.testmgt.ManageMethod": "管理方法",
  "sidenav.label.admin.testmgt.reflex": "反射检测管理",
  "sidenav.label.admin.usermgt": "用户管理",
  "sideNav.label.arvfollowup1": "ARV随访版本1",
  "sideNav.label.arvfollowup2": "ARV随访版本2",
  "sideNav.label.arvreports1": "ARV初始版本1",
  "sideNav.label.arvreports2": "ARV初始版本2",
  "sideNav.label.arvversion1": "ARV版本1",
  "sideNav.label.associatedpatientreport": "关联患者报告",
  "sideNav.label.audittrail": "审计跟踪",
  "sidenav.label.barcode": "条码",
  "sidenav.label.batchorder": "批量订单录入",
  "sideNav.label.bypaneltype": "按面板类型",
  "sideNav.label.bytesttype": "按检测类型",
  "sideNav.label.byunit": "按单元",
  "sideNav.label.collectedarvpatientreports": "已采集的ARV患者报告",
  "sidenav.label.cytology": "细胞学",
  "sidenav.label.cytology.dashboard": "仪表板",
  "sideNav.label.delayedvalidation": "延迟验证",
  "sidenav.label.editorder": "编辑订单",
  "sideNav.label.eidreports1": "EID版本1",
  "sideNav.label.eidreports2": "EID版本2",
  "sideNav.label.exportcsvfile": "导出常规CSV文件",
  "sideNav.label.followuprequired": "需要随访",
  "sideNav.label.generalreport": "通用报告",
  "sideNav.label.hivtestsummary": "HIV检测摘要",
  "sidenav.label.immunochem": "免疫组织化学",
  "sidenav.label.immunochem.dashboard": "仪表板",
  "sidenav.label.incomingorder": "电子订单",
  "sideNav.label.intermediatebyservice": "按服务的中间报告",
  "sideNav.label.intermediatereport1": "中间报告版本1",
  "sideNav.label.intermediatereport2": "中间报告版本2",
  "sidenav.label.inventory": "库存",
  "sidenav.label.inventory.management": "库存管理",
  "sidenav.label.inventory.management.tooltip": "管理库存物品、批次和库存水平",
  "sidenav.label.inventory.tooltip": "试剂、试剂盒和用品的库存管理",
  "sideNav.label.laporanHasil": "合规报告",
  "sideNav.label.noncomformitynotification": "不符合通知",
  "sideNav.label.noncomformityreportsbydate": "按日期",
  "sideNav.label.noncomformityreportsbylabno": "按实验室编号",
  "sideNav.label.noncomformityreportsbyunit": "按单元和原因",
  "sidenav.label.notebook": "笔记本",
  "sidenav.label.add.order": "添加订单",
  "sidenav.label.clinical.order": "添加临床订单",
  "sidenav.label.environmental.compliance": "合规仪表板",
  "sidenav.label.environmental.order": "添加环境订单",
  "sidenav.label.vector.order": "添加病媒订单",
  "sidenav.label.order": "订单",
  "sidenav.label.order.collect": "采集样本",
  "sidenav.label.order.dashboard": "仪表板",
  "sidenav.label.order.enter": "录入订单",
  "sidenav.label.order.label": "贴标签与存放",
  "sidenav.label.order.qa": "质量保证复核",
  "sidenav.label.order.prepare": "准备样本",
  "sidenav.label.order.sampleCheck": "样本检查",
  "sidenav.label.pathology": "病理学",
  "sidenav.label.pathology.dashboard": "仪表板",
  "sideNav.label.referredtestreport": "已转诊检测报告",
  "sideNav.label.rejectionreport": "拒绝报告",
  "sidenav.label.reports": "报告",
  "sidenav.label.reports.routine": "常规",
  "sidenav.label.reports.study": "研究",
  "sidenav.label.results": "结果",
  "sidenav.label.results.byrange": "按实验室编号范围",
  "sidenav.label.results.order": "按订单",
  "sidenav.label.results.patient": "按患者",
  "sidenav.label.results.testdate": "按检测日期",
  "sidenav.label.results.unit": "按单元",
  "sideNav.label.sectionperformance": "部分性能",
  "sideNav.label.specialrequest": "特殊请求 ",
  "sidenav.label.statisticsreport": "统计报告",
  "sidenav.label.statusreport": "患者状态报告",
  "sidenav.label.storage.coldstorage": "冷藏存储监控",
  "sidenav.label.storage.coldstorage.tooltip": "监控冰箱和冷藏库的温度和湿度",
  "sidenav.label.storage.management": "存储管理",
  "sidenav.label.storage.management.tooltip": "管理存储位置和设备",
  "sidenav.label.testsummary": "所有检测摘要",
  "sidenav.label.validation": "验证",
  "sidenav.label.validation.order": "按订单搜索",
  "sidenav.label.validation.routine": "常规",
  "sidenav.label.validation.study": "研究",
  "sidenav.label.validation.testdate": "按检测日期搜索",
  "sideNav.label.viralloaddataexport": "病毒载量数据导出",
  "sideNav.label.vlversionnational": "VL国家版本",
  "sidenav.label.workplan": "工作计划",
  "sidenav.label.workplan.panel": "按面板类型",
  "sidenav.label.workplan.priority": "按优先级",
  "sidenav.label.workplan.test": "按检测类型",
  "sidenav.label.workplan.unit": "按单元",
  "sideNav.title.activityreport": "活动报告",
  "sidenav.title.aggregatereport": "汇总报告",
  "sideNav.title.arvreports": "ARV报告",
  "sideNav.title.associatedpatientreport": "关联患者报告",
  "sideNav.title.audittrail": "审计 Trail",
  "sideNav.title.collectedarvpatientreports": "已采集的ARV患者报告",
  "sideNav.title.delayedvalidation": "延迟验证",
  "sideNav.title.eidreports": "EID报告",
  "sideNav.title.environmentalReports": "环境报告",
  "sideNav.title.exportbydate": "按日期导出",
  "sideNav.title.exportcsvfile": "导出常规CSV文件",
  "sideNav.title.indicator": "指标",
  "sideNav.title.intermediatereport": "中间报告",
  "sideNav.title.noncomformityreports": "不符合报告",
  "sideNav.title.referredtestreport": "已转诊检测报告",
  "sideNav.title.rejectionreport": "拒绝报告",
  "sideNav.title.specialrequest": "特殊请求 ",
  "sideNav.title.tatreport": "周转时间",
  "sideNav.title.vectorIdentification": "病媒鉴定",
  "sideNav.title.vlreport": "病毒载量报告",
  "sideNav.label.audittrail.orderEvents": "订单事件",
  "sideNav.label.audittrail.systemEvents": "系统事件",
  "sidenav.label.addorder": "添加通用订单",
  "sidenav.label.admin.sampleTypeManagement": "样本类型编辑器",
  "sideNav.label.qa": "质量保证",
  "sideNav.label.qa.overview": "质量保证概览",
  "sideNav.label.qa.qc": "统计质控",
  "sideNav.label.qa.qc.dashboard": "质控仪表板",
  "sideNav.label.qa.qc.alerts": "质控警报",
  "sideNav.label.qa.qc.controlLots": "质控品批号管理",
  "sideNav.label.qa.qc.ruleConfig": "规则配置",
  "sideNav.label.qa.qc.reagentQc": "试剂质控",
  "sideNav.label.qa.qc.manualQc": "分析仪手工质控",
  "sideNav.label.qa.qi": "质量指标",
  "sideNav.label.qa.qi.dashboard": "质量指标仪表板",
  "sideNav.label.qa.qi.config": "质量指标配置",
  "qa.qiConfig.subtitle": "设置各指标的目标和行动阈值，启用或停用指标，并为特定实验室单元覆盖阈值。",
  "qa.qiConfig.column.overrides": "覆盖",
  "qa.qiConfig.field.enabled": "跟踪此指标",
  "qa.qiConfig.field.target": "目标",
  "qa.qiConfig.field.action": "行动阈值",
  "qa.qiConfig.field.category": "实验室单元",
  "qa.qiConfig.editor.title": "编辑 {indicator}",
  "qa.qiConfig.editor.defaults": "默认阈值",
  "qa.qiConfig.editor.overrides": "按单元覆盖",
  "qa.qiConfig.editor.usesDefault": "未设置覆盖的实验室单元使用指标默认值。",
  "qa.qiConfig.editor.noOverrides": "无覆盖：所有实验室单元均使用默认值。",
  "qa.qiConfig.editor.addOverride": "添加单元覆盖",
  "qa.qiConfig.editor.autoNce": "当本月累计值超过行动阈值时，将自动创建一个不符合事件（每个指标每月一个）。",
  "qa.qiConfig.indicator.tat": "平均周转时间",
  "qa.qiConfig.indicator.rejection": "拒绝率",
  "qa.qiConfig.indicator.amendment": "修订率",
  "qa.qiConfig.indicator.nce": "不符合事件动态",
  "qa.qiConfig.indicator.callback": "紧急回电合规率",
  "qa.qiConfig.validation.required": "目标阈值和措施阈值均为必填项。",
  "qa.qiConfig.validation.range": "阈值必须介于 0 到 100 之间。",
  "qa.qiConfig.validation.direction": "该指标的目标阈值与措施阈值顺序有误。",
  "qa.qiConfig.validation.category": "请为每项覆盖选择一个实验室单元。",
  "qa.qiConfig.validation.duplicateCategory": "每个实验室单元只能覆盖一次。",
  "qa.qiConfig.confirmDisableTitle": "停用此指标？",
  "qa.qiConfig.confirmDisableBody": "这将隐藏仪表板卡片、停止新的警报，并停止为此指标自动生成不符合事件。历史数据将被保留。是否继续？",
  "qa.qiConfig.saveFailed": "无法保存质量指标配置。",
  "sideNav.label.qa.qms": "质量管理体系与改进",
  "sideNav.label.qa.qms.esigLog": "电子签名日志",
  "sideNav.label.qa.qms.capaRegister": "CAPA 登记册",
  "sideNav.label.qa.qms.accreditation": "认可",
  "qa.qms.capaRegister.subtitle": "所有不符合事件的全部纠正和预防措施，包括截止日期和状态。",
  "qa.qms.capaRegister.tile.dueThisWeek": "本周到期",
  "qa.qms.capaRegister.tile.completed": "已完成（90 天）",
  "qa.qms.capaRegister.filter.assignee": "负责人",
  "qa.qms.capaRegister.filter.from": "截止日期（起）",
  "qa.qms.capaRegister.filter.to": "截止日期（止）",
  "qa.qms.capaRegister.column.correctiveAction": "纠正/预防措施",
  "qa.qms.capaRegister.column.assignee": "负责人",
  "qa.qms.capaRegister.status.open": "待处理",
  "qa.qms.capaRegister.status.overdue": "已逾期",
  "qa.qms.capaRegister.status.completed": "已完成",
  "qa.qms.capaRegister.error": "无法加载 CAPA 登记册。",
  "qa.qms.accreditation.title": "检测认可",
  "qa.qms.accreditation.subtitle": "认可机构及各检测的注册情况。用于决定患者报告上的认可标志以及检查准备情况的结论。",
  "qa.qms.accreditation.error": "无法加载认可数据。",
  "qa.qms.accreditation.actionError": "无法保存更改。",
  "qa.qms.accreditation.tile.total": "机构",
  "qa.qms.accreditation.inForce": "有效：{names}",
  "qa.qms.accreditation.bodies.title": "认可机构",
  "qa.qms.accreditation.bodies.add": "添加机构",
  "qa.qms.accreditation.body.column.logo": "标志",
  "qa.qms.accreditation.body.column.expiresOn": "到期",
  "qa.qms.accreditation.status.ACTIVE": "活跃",
  "qa.qms.accreditation.status.EXPIRING": "即将到期",
  "qa.qms.accreditation.status.EXPIRED": "已过期",
  "qa.qms.accreditation.status.INACTIVE": "非活跃",
  "qa.qms.accreditation.body.modal.addTitle": "添加认可机构",
  "qa.qms.accreditation.body.modal.editTitle": "编辑认可机构",
  "qa.qms.accreditation.body.edit": "编辑机构",
  "qa.qms.accreditation.body.delete": "删除机构",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 个字符：大写字母、数字和连字符。之后无法更改。",
  "qa.qms.accreditation.body.field.expiresOn": "认可到期日期",
  "qa.qms.accreditation.body.field.visibilityMode": "在以下情况下于报告中显示标志",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "报告中含有任一已认可检测",
  "qa.qms.accreditation.visibility.PERCENTAGE": "报告中一定比例的检测已获认可",
  "qa.qms.accreditation.body.field.thresholdPct": "阈值（%）",
  "qa.qms.accreditation.body.field.logo": "标志（PNG 或 JPEG，至少 64×64 像素，不超过 500 KB）",
  "qa.qms.accreditation.body.logo.remove": "移除标志",
  "qa.qms.accreditation.body.required": "代码、名称和有效期为必填项。",
  "qa.qms.accreditation.body.saveError": "无法保存认可机构。",
  "qa.qms.accreditation.body.logoError": "无法上传标志。请使用至少 64×64 像素且不超过 500 KB 的 PNG 或 JPEG 图片。",
  "qa.qms.accreditation.body.delete.title": "删除认可机构",
  "qa.qms.accreditation.body.delete.body": "删除 {name}？此操作无法撤销。",
  "qa.qms.accreditation.body.delete.blocked": "无法删除：有 {count} 条检测认可记录引用此机构。请先将其移除。",
  "qa.qms.accreditation.enrollments.title": "已注册检测",
  "qa.qms.accreditation.enrollments.add": "注册检测",
  "qa.qms.accreditation.enrollment.column.body": "认可机构",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "生效日期",
  "qa.qms.accreditation.enrollment.column.expires": "机构到期",
  "qa.qms.accreditation.enrollment.remove": "移除注册",
  "qa.qms.accreditation.eqa.title": "认可范围的室间质评覆盖情况",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 要求您声明为已认可的每项检测都参加室间质评。此处将认可范围与有效的室间质评注册进行比较。",
  "qa.qms.accreditation.eqa.column.scope": "范围内检测",
  "qa.qms.accreditation.eqa.column.covered": "已纳入室间质评",
  "qa.qms.accreditation.eqa.column.gaps": "缺口",
  "qa.qms.accreditation.eqa.noGaps": "完全覆盖",
  "qa.qms.accreditation.eqa.gapsMore": "{names} 及另外 {count} 项",
  "qa.qms.accreditation.eqa.error": "无法加载室间质评覆盖情况。",
  "qa.qms.accreditation.filter.body": "认可机构",
  "qa.qms.accreditation.filter.test": "检测：{name}",
  "qa.qms.accreditation.enroll.modal.title": "注册检测",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "生效日期（可选）",
  "qa.qms.accreditation.enroll.required": "请选择一个认可机构和至少一项检测。",
  "qa.qms.accreditation.enroll.failed": "注册被拒绝。",
  "qa.qms.accreditation.enrollment.delete.title": "移除注册",
  "qa.qms.accreditation.enrollment.delete.body": "从 {body} 中移除 {test}？",
  "qa.qms.esigLog.subtitle": "系统中记录的每个电子签名：谁签署了什么、何时签署以及签署原因。",
  "qa.qms.esigLog.column.signer": "签名人",
  "qa.qms.esigLog.column.subject": "主题",
  "qa.qms.esigLog.filter.subjectType": "对象类型",
  "qa.qms.esigLog.filter.apply": "应用筛选",
  "qa.qms.esigLog.export.confirm.title": "不使用筛选条件导出？",
  "qa.qms.esigLog.export.confirm.body": "未应用任何筛选条件，因此将导出所选日期范围内的全部签名（最多 10,000 行）。",
  "qa.qms.esigLog.meaning.AUTHORED": "已撰写",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "已审核并发布",
  "qa.qms.esigLog.meaning.REJECTED": "已拒收",
  "qa.qms.esigLog.error": "无法加载签名日志。请重试。",
  "qa.qi.dashboard.subtitle": "五项质量指标，包括可选启用的紧急回电合规率。",
  "qa.qi.dashboard.window.label": "报告时间窗口",
  "qa.qi.dashboard.window.7d": "滚动 7 天",
  "qa.qi.dashboard.window.30d": "滚动 30 天",
  "qa.qi.dashboard.window.90d": "滚动 90 天",
  "qa.qi.dashboard.window.ytd": "年初至今",
  "qa.qi.dashboard.lastRecomputed": "最近重新计算：{time}",
  "qa.qi.dashboard.viewDetail": "查看详情",
  "qa.qi.dashboard.tileInfo": "此卡片衡量什么？",
  "qa.qi.disabled.toast.title": "指标已停用",
  "qa.qi.disabled.toast.message": "此质量指标已在质量指标配置中停用，其详情页不可用。",
  "qa.qi.dashboard.tile.tat.label": "平均 TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "报告时间窗口内所有已完成检测订单从样本接收到结果审核的平均周转时间。",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "对比前 {days} 天",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "对比上一周期",
  "qa.qi.dashboard.tile.tat.secondary": "涵盖 {count, plural, one {# 个实验室单元} other {# 个实验室单元}} · 最慢：{unit}（{tat}）",
  "qa.qi.dashboard.tile.tat.empty": "此时间窗口内无已完成的检测订单。",
  "qa.qi.dashboard.tile.tat.error": "周转时间数据不可用。",
  "qa.qi.dashboard.tile.rejection.label": "拒绝率",
  "qa.qi.dashboard.tile.amendment.label": "修订率",
  "qa.qi.dashboard.tile.ncePulse.label": "不符合事件动态",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "截至目前尚未确认的紧急不符合事件。这是当前计数，不是趋势。",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "紧急待处理",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} 项处于纠正措施阶段",
  "qa.qi.dashboard.tile.ncePulse.error": "不符合事件数据不可用。",
  "qa.qi.dashboard.tile.amendment.tooltip": "患者报告发出后被更正的结果占报告时间窗口内已发布结果的比例。",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "对比前 {days} 天",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "对比上一周期",
  "qa.qi.dashboard.tile.amendment.secondary": "已发布 {released} 项，已修订 {amended} 项",
  "qa.qi.dashboard.tile.amendment.empty": "此时间窗口内无已发布的结果。",
  "qa.qi.dashboard.tile.amendment.error": "修订数据不可用。",
  "qa.qi.dashboard.tile.rejection.tooltip": "在结果录入或审核时被拒绝的检测占报告时间窗口内已开始检测的比例。",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "对比前 {days} 天",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "对比上一周期",
  "qa.qi.dashboard.tile.rejection.secondary": "已开始 {total} 项，已拒绝 {rejected} 项",
  "qa.qi.dashboard.tile.rejection.empty": "此时间窗口内无已开始的检测。",
  "qa.qi.dashboard.tile.rejection.error": "拒绝数据不可用。",
  "qa.qi.dashboard.tile.thresholds": "目标 {target} · 行动 {action}",
  "qa.qi.amendment.title": "修订率：详情",
  "qa.qi.amendment.subtitle": "患者报告发出后被更正的结果。",
  "qa.qi.amendment.column.amendedAt": "修订时间",
  "qa.qi.amendment.column.priorValue": "原值",
  "qa.qi.amendment.column.currentValue": "当前值",
  "qa.qi.amendment.column.amendedBy": "修订人",
  "qa.qi.amendment.column.releasedAt": "发布时间",
  "qa.qi.amendment.column.timeToAmend": "修订耗时",
  "qa.qi.amendment.rate.label": "修订率",
  "qa.qi.amendment.trend.empty": "此时间窗口内无趋势数据。",
  "qa.qi.amendment.breakdown.title": "按检测",
  "qa.qi.amendment.breakdown.column.rate": "比率",
  "qa.qi.rejection.title": "拒绝率：详情",
  "qa.qi.rejection.subtitle": "在结果录入时被拒绝的检测，以及记录的拒绝原因。",
  "qa.qi.rejection.column.rejectedAt": "拒绝时间",
  "qa.qi.rejection.column.rejectedBy": "拒绝人",
  "qa.qi.rejection.heatmap.title": "热图：申请地点 × 实验室单元",
  "qa.qi.rejection.heatmap.section": "实验室单元",
  "qa.qi.rejection.heatmap.unknown": "未知地点",
  "qa.qi.rejection.heatmap.unknownSection": "未知单元",
  "qa.qi.rejection.heatmap.legend": "单元格按比率相对于实验室阈值着色：绿色 ≤ {target}%，琥珀色介于两者之间，红色 ≥ {action}%。将鼠标悬停在单元格上可查看已拒绝 / 已开始数量。",
  "qa.qi.rejection.rate.label": "拒绝率",
  "qa.qi.rejection.reasons.title": "按原因（帕累托）",
  "qa.qi.rejection.reasons.column.percent": "占拒绝的 %",
  "qa.qi.rejection.reasons.column.cumulative": "累计 %",
  "qa.qi.rejection.reasons.donut.label": "拒绝",
  "qa.qi.rejection.reasons.insight": "前 {count} 项原因（共 {total} 项）占拒绝的 {percent}%，优先解决 {reason} 的影响最大。",
  "qa.qi.rejection.breakdown.other": "其他（{count} 项检测）",
  "qa.qi.rejection.list.title": "拒绝明细",
  "qa.qi.amendment.list.title": "修订明细",
  "qa.qi.callback.button": "登记回电",
  "qa.qi.callback.banner.title": "紧急结果需要回电通知临床医生",
  "qa.qi.callback.banner.subtitle": "{count, plural, other {本页有 # 条已保存的紧急结果未登记回电，需要复述确认（TJC NPSG.02.03.01）。}}",
  "qa.qi.callback.modal.title": "登记紧急回电",
  "qa.qi.callback.field.recipientName": "被通知人",
  "qa.qi.callback.field.recipientName.placeholder": "被联系的临床医生或病房姓名",
  "qa.qi.callback.field.status": "回电结果",
  "qa.qi.callback.status.CONFIRMED": "已确认并复述",
  "qa.qi.callback.status.REACHED_NO_READBACK": "已联系，未复述",
  "qa.qi.callback.status.UNABLE_TO_REACH": "无法联系",
  "qa.qi.callback.save.success": "回电已登记",
  "qa.qi.callback.save.fail": "登记回电失败",
  "qa.qi.callback.title": "紧急回电合规率：详情",
  "qa.qi.callback.subtitle": "已发布的紧急结果，以及每条结果是否在回电目标时间窗口内电话通知临床医生并复述确认。",
  "qa.qi.callback.distribution.title": "确认耗时分布",
  "qa.qi.callback.distribution.0-5": "0–5 分钟",
  "qa.qi.callback.distribution.5-15": "5–15 分钟",
  "qa.qi.callback.distribution.15-30": "15–30 分钟",
  "qa.qi.callback.distribution.30-60": "30–60 分钟",
  "qa.qi.callback.distribution.over60": "60 分钟以上",
  "qa.qi.callback.distribution.noAck": "未确认",
  "qa.qi.callback.failures.title": "按原因统计的失败（{count}）",
  "qa.qi.callback.failures.overTarget": "超出目标",
  "qa.qi.callback.failures.unableToReach": "无法联系",
  "qa.qi.callback.failures.noReadback": "未记录复述确认",
  "qa.qi.callback.failures.noCallback": "未记录回电",
  "qa.qi.callback.list.title": "时间窗口内的紧急结果",
  "qa.qi.callback.rate.label": "回电合规率（{minutes} 分钟内复述确认）",
  "qa.qi.callback.status.notLogged": "未登记",
  "qa.qi.callback.column.status": "回电状态",
  "qa.qi.callback.column.timeToCallback": "回电耗时",
  "qa.qi.callback.column.loggedBy": "登记人",
  "qa.qi.dashboard.tile.callback.label": "紧急回电合规率",
  "qa.qi.dashboard.tile.callback.tooltip": "已发布的紧急结果中，在实验室回电目标时间窗口内完成复述确认回电的比例。可选启用：请在质量指标配置中开启。合规率根据当前紧急范围重新计算。",
  "qa.qi.dashboard.tile.callback.secondary": "{critical} 项紧急结果中有 {confirmed} 项在目标时间内确认",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "对比前 {days} 天",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "对比上一周期",
  "qa.qi.dashboard.tile.callback.empty": "此时间窗口内无紧急结果。",
  "qa.qi.dashboard.tile.callback.error": "回电数据不可用。",
  "qa.qi.dashboard.tile.callback.disabled": "未启用：请在质量指标配置中开启。",
  "qa.empty.callback.title": "此时间范围内没有紧急结果",
  "qa.empty.callback.subhead": "已发布的紧急结果及其回电记录状态将显示在此处。",
  "qa.overview.rejection.caption": "在结果录入时被拒绝（30天）",
  "qa.overview.rejection.ofStarted": "已开始 {total} 个中的 {rejected} 个",
  "qa.overview.callback.caption": "紧急结果复述合规率（30天）",
  "qa.overview.callback.ofCritical": "{critical} 个紧急结果中已确认 {confirmed} 个",
  "qa.overview.callback.none": "此时间范围内无紧急结果",
  "qa.overview.week.confirmedCount": "{count} 项已确认",
  "qa.overview.amendment.caption": "报告后修订（30天）",
  "qa.overview.amendment.ofReleased": "已发布 {released} 个中的 {amended} 个",
  "qa.future.subtitle": "未来功能：设计已完成，尚未安排开发。",
  "qa.future.questionLabel": "此功能解答的问题",
  "qa.future.whyLabel": "为何重要",
  "qa.future.readDesignDoc": "在 GitHub 上阅读设计文档",
  "qa.future.reagentQc.question": "此试剂批号在用于患者之前是否已经过验证？",
  "qa.future.reagentQc.summary": "按批号跟踪质控频率。新试剂批号用于临床之前，系统要求提供有记录的验证样本，将新批号与旧批号或同行比对参考进行比较。",
  "qa.future.reagentQc.why": "如果没有批号验证，一个有问题的试剂批号可能在被发现之前就毁掉一周的患者结果。如今大多数实验室以非正式方式进行此项工作；将其作为系统功能提供，可以发现非正式流程失效的情况。",
  "qa.future.manualQc.question": "技术员今天是否在此仪器上运行了每日质控，结果是否通过？",
  "qa.future.manualQc.summary": "每台仪器的每日通过/不通过日志。不同仪器有不同的每日检查；系统将它们统一为一种形式：包含签名人、时间戳的每日通过/不通过日志，如不通过则禁止使用该仪器。",
  "qa.future.manualQc.why": "检查员走进实验室时首先会问：“请出示这台仪器的每日质控日志。”每台仪器每天都要有一份签名日志，天天如此。遗漏它正是检查不合格的原因。",
  "qa.overview.subtitle": "质量保证负责人的每日概览",
  "qa.overview.comingSoon": "即将推出",
  "qa.overview.section.attention": "需要关注",
  "qa.overview.section.thisWeek": "本周",
  "qa.overview.section.pillars": "支柱状态",
  "qa.overview.section.activity": "最近活动",
  "qa.overview.section.inspector": "检查准备情况：五个 ISO 15189 质量问题",
  "qa.overview.attention.criticalNce": "待确认的紧急不符合事件",
  "qa.overview.attention.criticalResults": "过去 24 小时内的紧急结果",
  "qa.overview.attention.overdueCapas": "逾期 CAPA",
  "qa.overview.attention.qcViolations": "过去 24 小时内的质控违规",
  "qa.overview.attention.effectivenessReview": "到期的 CAPA 有效性复核",
  "qa.overview.attention.eqaDue": "未来 14 天内到期的室间质评提交",
  "qa.overview.attention.nceSla": "接近确认 SLA 的不符合事件",
  "qa.overview.tile.criticalCallback": "紧急结果回电",
  "qa.overview.week.newNces": "新增不符合事件",
  "qa.overview.week.ncesResolved": "已解决的不符合事件",
  "qa.overview.week.capasCompleted": "已完成的 CAPA",
  "qa.overview.week.qcViolations": "质控违规",
  "qa.overview.week.criticalResults": "紧急结果",
  "qa.overview.week.eqaSubmissions": "室间质评提交",
  "qa.overview.week.auditEntries": "审计日志条目",
  "qa.overview.week.signatureEvents": "签名事件",
  "qa.overview.inspector.q1": "运行是否在控？",
  "qa.overview.inspector.q2": "上一轮次室间质评表现如何？",
  "qa.overview.inspector.q3": "质量指标是否达标？",
  "qa.overview.inspector.q4": "是否有未关闭的紧急不符合事件？",
  "qa.overview.inspector.q5": "认可状态如何？",
  "qa.overview.inspector.q1.answer": "{total} 台仪器中 {inControl} 台在控（30天）",
  "qa.overview.inspector.q3.answer": "平均 TAT {tat}，对比前 30 天",
  "qa.overview.inspector.q4.answer": "{count} 个紧急不符合事件待确认",
  "qa.overview.inspector.q5.answer": "{total} 个中 {active} 个有效，{expiring} 个即将到期，{expired} 个已过期",
  "qa.overview.inspector.q5.noData": "未配置认可机构",
  "qa.overview.week.severityBreakdown": "{critical} 项紧急 · {major} 项重大 · {minor} 项轻微",
  "qa.overview.week.overdueCount": "{count} 项已逾期",
  "qa.overview.week.currentlyOpen": "当前未关闭",
  "qa.overview.pillar.qc.text": "{total} 台仪器中 {inControl} 台在控",
  "qa.overview.pillar.qc.noData": "尚无质控数据",
  "qa.overview.pillar.qi.text": "平均 TAT {tat}",
  "qa.overview.pillar.qi.noData": "尚无 TAT 数据",
  "qa.overview.pillar.qi.disabled": "当前未跟踪",
  "qa.overview.pillar.qms.text": "{critical} 个紧急待处理 · {capa} 个处于纠正措施中",
  "qa.overview.activity.viewAudit": "查看完整审计跟踪",
  "qa.overview.activity.empty": "过去 24 小时内无活动",
  "qa.empty.activity.subhead": "所有支柱中经签名确认的操作将在发生时显示在此处。",
  "qa.empty.attention.title": "目前没有需要关注的事项",
  "qa.empty.attention.subhead": "紧急不符合事件、逾期 CAPA 和质控违规发生时将显示在此处。",
  "qa.empty.amendment.title": "此时间范围内没有修订",
  "qa.empty.amendment.subhead": "已发布结果被更正时，修订将显示在此处。",
  "qa.empty.rejection.title": "此时间范围内没有拒绝记录",
  "qa.empty.rejection.subhead": "在结果录入或审核时拒绝检测，拒绝记录将显示在此处。",
  "qa.empty.capaRegister.title": "没有符合这些筛选条件的 CAPA",
  "qa.empty.capaRegister.subhead": "针对不符合事件记录的纠正和预防措施将显示在此处。",
  "qa.empty.accreditation.bodies.title": "尚无认可机构",
  "qa.empty.accreditation.bodies.subhead": "添加认可本实验室的认可机构，以开始按检测跟踪认可情况。",
  "qa.empty.accreditation.enrollments.title": "没有符合这些筛选条件的注册",
  "qa.empty.accreditation.enrollments.subhead": "在认可机构下注册检测，以便在患者报告上显示其标志。",
  "qa.empty.accreditation.eqa.title": "暂无可比较的内容",
  "qa.empty.accreditation.eqa.subhead": "检测在认可机构下注册后，将在此处比较其室间质评覆盖情况。",
  "qa.empty.esigLog.title": "此时间范围内没有签名",
  "qa.empty.esigLog.subhead": "结果录入和审核时，签名将显示在此处。请尝试扩大日期范围或减少筛选条件。",
  "qa.empty.tat.title": "此时间范围内没有结果",
  "qa.empty.tat.subhead": "检测订单完成并审核后，周转时间将显示在此处。请尝试其他日期范围。",
  "qa.empty.sparse.labUnits": "{count, plural, other {# 个实验室单元}} this period",
  "qa.overview.activity.yesterday": "昨天 {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "录入了结果：",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "审核并发布了",
  "qa.overview.activity.meaning.REJECTED": "拒绝了",
  "qa.overview.activity.qc": "质控警报：{instrument} 上的 {rule}（{severity}）",
  "qa.overview.activity.nce.CREATED": "{actor} 报告了 {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} 确认了 {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} 分配了 {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} 为 {nce} 添加了备注",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} 更新了 {nce} 的状态",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} 更新了 {nce} 的纠正措施",
  "qa.overview.activity.nce.RESOLVED": "{actor} 解决了 {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} 更新了 {nce}",
  "sidenav.title.statusreport": "患者状态报告",
  "systemAudit.filter.startDate": "开始日期",
  "systemAudit.filter.endDate": "结束日期",
  "systemAudit.filter.entityType": "实体类型",
  "systemAudit.filter.action": "操作",
  "systemAudit.filter.search": "搜索",
  "systemAudit.filter.export": "导出翻译",
  "systemAudit.table.heading.time": "时间",
  "systemAudit.table.heading.entityType": "实体类型",
  "systemAudit.table.heading.entityId": "实体 ID",
  "systemAudit.table.heading.action": "操作",
  "systemAudit.table.heading.user": "用户",
  "systemAudit.table.heading.changes": "变更",
  "systemAudit.noResults": "在给定的筛选条件下未找到任何系统事件。",
  "systemAudit.filter.all": "所有分析仪",
  "systemAudit.filter.user": "用户",
  "systemAudit.filter.searchText": "搜索",
  "systemAudit.filter.searchText.placeholder": "按实体 ID 搜索...",
  "systemAudit.filter.exportPdf": "导出PDF",
  "systemAudit.filter.selectedPatient": "已选择的患者",
  "systemAudit.filter.selectedPatient.none": "无",
  "systemAudit.filter.selectPatient": "选择患者",
  "systemAudit.filter.selectAnotherPatient": "选择另一位患者",
  "systemAudit.action.insert": "插入",
  "systemAudit.action.update": "更新",
  "systemAudit.action.delete": "删除",
  "site.branding.cancel": "取消",
  "site.branding.color.format.error": "颜色格式无效",
  "site.branding.color.hex.label": "十六进制颜色值",
  "site.branding.colorPicker.helperText": "选择颜色或输入十六进制值",
  "site.branding.colorPicker.placeholder": "选择颜色...",
  "site.branding.confirm.remove": "确认移除",
  "site.branding.confirm.remove.message": "您确定要移除此图标吗？",
  "site.branding.current.logo": "当前Logo",
  "site.branding.description": "自定义站点的外观，包括Logo、颜色和网站图标",
  "site.branding.error.remove": "移除失败",
  "site.branding.favicon": "网站图标",
  "site.branding.favicon.description": "显示在浏览器标签中的图标",
  "site.branding.file.format.error": "文件格式不支持",
  "site.branding.file.pending": "文件待上传",
  "site.branding.file.size.error": "文件大小超过限制",
  "site.branding.formats": "文件格式：PNG、SVG、JPG（最大2MB）",
  "site.branding.header.color": "页眉颜色",
  "site.branding.header.color.description": "应用程序页眉栏的背景颜色",
  "site.branding.header.logo": "页眉Logo",
  "site.branding.header.logo.description": "显示在应用程序页眉中的Logo",
  "site.branding.login.logo": "登录页Logo",
  "site.branding.login.logo.description": "显示在登录页面上的Logo",
  "site.branding.login.using.header.logo": "登录页使用页眉Logo",
  "site.branding.logo.upload.success": "Logo上传成功",
  "site.branding.no.logo": "未设置Logo",
  "site.branding.preview": "预览",
  "site.branding.primary.color": "主色调",
  "site.branding.primary.color.description": "应用程序的主要颜色",
  "site.branding.remove.favicon": "移除网站图标",
  "site.branding.remove.header.logo": "移除页眉Logo",
  "site.branding.remove.login.logo": "移除登录页Logo",
  "site.branding.remove.logo": "移除Logo",
  "site.branding.reset.confirmation": "您确定要将所有品牌设置恢复为默认值吗？",
  "site.branding.reset.error": "重置品牌设置失败",
  "site.branding.reset.success": "品牌设置已恢复为默认值",
  "site.branding.reset.to.defaults": "恢复默认设置",
  "site.branding.save": "保存",
  "site.branding.save.error": "保存品牌设置失败",
  "site.branding.save.success": "品牌设置保存成功",
  "site.branding.secondary.color": "辅色调",
  "site.branding.secondary.color.description": "应用程序的辅助颜色",
  "site.branding.section.colors": "颜色",
  "site.branding.section.logos": "品牌徽标",
  "site.branding.title": "站点品牌",
  "site.branding.unsaved.changes": "未保存的更改",
  "site.branding.unsaved.changes.warning": "您有未保存的更改。离开此页面将丢失这些更改。",
  "site.branding.upload.favicon": "上传网站图标",
  "site.branding.upload.header.logo": "上传页眉Logo",
  "site.branding.upload.login.logo": "上传登录页Logo",
  "site.branding.upload.logo": "上传Logo",
  "site.branding.use.header.logo.for.login": "将页眉Logo用于登录页",
  "siteInfo.description.default.barcode": "指示每次订单和标本应打印的默认条码标签数量。",
  "siteInfo.description.dimensions": "指示打印时条码标签应符合的尺寸。",
  "siteInfo.description.elements": "勾选应出现在订单和样本条码标签上的可选元素旁边的框。",
  "siteInfo.description.max.barcode": "指示每个订单或标本可以打印的最大条码标签数量。达到最大值后，用户将无法打印更多标签。",
  "siteInfo.elements.mandatory": "必需元素",
  "siteInfo.elements.optional": "可选元素",
  "siteInfo.section.altAccession": "预印条码订单号",
  "siteInfo.section.elements": "条码标签元素",
  "siteInfo.section.number": "条码标签数量",
  "siteInfo.section.size": "条码标签尺寸",
  "siteInfo.title.default.barcode": "默认条码标签",
  "siteInfo.title.default.barcode.block": "块",
  "siteInfo.title.default.barcode.height": "高度",
  "siteInfo.title.default.barcode.order": "订单",
  "siteInfo.title.default.barcode.order.none": "无",
  "siteInfo.title.default.barcode.slide": "幻灯片",
  "siteInfo.title.default.barcode.specimen": "标本",
  "siteInfo.title.default.barcode.freezer": "冰箱",
  "siteInfo.title.default.barcode.width": "宽度",
  "siteInfo.title.max.barcode": "最大条码标签",
  "started.date": "开始日期",
  "status": "状态",
  "status.in.progress": "进行中",
  "status.unknown": "未知",
  "stillThere.message": "用户会话即将超时。点击任意位置以保持登录状态。",
  "stillThere.title": "还在吗？",
  "stock.available": "可用",
  "stock.level": "库存水平",
  "stock.status": "库存状态",
  "stock.status.expired": "已过期",
  "stock.status.expiring": "即将过期",
  "stock.status.expiringIn": "即将过期（{days}天）",
  "stock.status.inStock": "有库存",
  "stock.status.lowStock": "低库存",
  "stock.status.outOfStock": "缺货",
  "storage.active": "活跃",
  "storage.add.device": "添加设备",
  "storage.add.location": "位置",
  "storage.add.location.option": "添加位置...",
  "storage.add.new.device": "添加新设备",
  "storage.add.rack": "添加货架",
  "storage.add.box": "添加箱子",
  "storage.add.room": "添加房间",
  "storage.add.shelf": "添加货架",
  "storage.allAssigned.title": "所有样本均已分配",
  "storage.assign.button": "分配位置",
  "storage.assign.title": "分配存储位置",
  "storage.assigned": "已分配",
  "storage.assigned.by": "分配者",
  "storage.assigned.date": "分配日期",
  "storage.barcode.scan.placeholder": "扫描条码或手动输入",
  "storage.bulk.move.auto.assigned": "自动分配的位置（可编辑）",
  "storage.bulk.move.preview": "批量移动预览",
  "storage.cannotDelete.hasAssignments": "无法删除 {entityType} '{name}'：有 {count} 个分配的样本",
  "storage.cannotDelete.hasChildren": "无法删除 {entityType} '{name}'：包含 {count} 个 {childType}",
  "storage.capacity.calculated": "计算",
  "storage.capacity.manual": "手动限制",
  "storage.capacity.undetermined.tooltip": "无法计算容量：某些子位置缺少定义的容量",
  "storage.capacity.warning": "{location} 已满 {percentage}%。请考虑使用其他存储。",
  "storage.code.change.acknowledge": "我理解并希望继续进行代码更改",
  "storage.code.change.warning": "警告",
  "storage.code.change.warning.message": "更改代码将使之前打印的此位置的所有标签无效。",
  "storage.confirm.add.device": "您要创建新设备 '{name}' 吗？",
  "storage.conditionNotes": "状况备注",
  "storage.conditionNotes.placeholder": "请输入有关存储条件的任何备注……",
  "storage.confirm.delete": "确认删除",
  "storage.create.room.error": "创建房间失败",
  "storage.create.room.success": "房间创建成功",
  "storage.current.location": "当前位置",
  "storage.currentLocation": "当前位置",
  "storage.delete.admin.only": "只有全局管理员可以删除位置",
  "storage.delete.are.you.sure": "您确定要删除",
  "storage.delete.cannot.be.undone": "此操作无法撤销。",
  "storage.delete.cascade.confirm": "确认级联删除",
  "storage.delete.cascade.confirmation.checkbox": "我确认要删除此位置及其所有子位置。所有样本将被取消分配。此操作无法撤销。",
  "storage.delete.cascade.summary": "这将删除 {childCount} 个 {childType} 并取消分配 {sampleCount} 个样本。您确定要继续吗？",
  "storage.delete.cascade.warning": "级联删除警告",
  "storage.delete.checking": "检查约束...",
  "storage.delete.confirmation.checkbox": "我确认要删除此位置。此操作无法撤销。",
  "storage.delete.constraints.title": "无法删除",
  "storage.delete.device": "删除设备",
  "storage.delete.error": "删除位置失败",
  "storage.delete.location": "删除位置",
  "storage.delete.rack": "删除货架",
  "storage.delete.room": "删除房间",
  "storage.delete.shelf": "删除货架",
  "storage.device.code": "代码",
  "storage.device.communicationProtocol": "通信协议",
  "storage.device.communicationProtocol.helper": "用于设备通信的协议（例如，BACnet）",
  "storage.device.ipAddress": "IP地址",
  "storage.device.ipAddress.helper": "网络连接设备的IPv4或IPv6地址",
  "storage.device.label": "设备",
  "storage.device.name": "名称",
  "storage.device.placeholder": "选择或键入以创建设备...",
  "storage.device.port": "端口",
  "storage.device.port.helper": "通信端口号（1-65535）",
  "storage.device.room": "房间",
  "storage.device.type": "类型",
  "storage.edit.device": "编辑设备",
  "storage.edit.error.loadLocation": "无法加载位置",
  "storage.edit.error.saveFailed": "保存失败",
  "storage.edit.error.saveHttp": "保存失败（HTTP {status}）",
  "storage.edit.rack": "编辑货架",
  "storage.edit.room": "编辑房间",
  "storage.edit.shelf": "编辑货架",
  "storage.edit.selectParent": "选择 {parent}",
  "storage.editbox.error.loadBox": "无法加载框",
  "storage.editbox.selectRack": "选择货架",
  "storage.box.capacity": "容量",
  "storage.box.gridSize": "网格尺寸",
  "storage.box.rows": "行",
  "storage.box.columns": "列",
  "storage.box.preset": "尺寸预设",
  "storage.box.preset.select": "选择尺寸",
  "storage.error.location.inactive": "不能分配到非活跃位置",
  "storage.error.name.duplicate": "在选定的父位置中已存在具有此名称的 {entityType}",
  "storage.error.position.occupied": "位置已被占用",
  "storage.expanded.capacityLimit": "容量限制",
  "storage.expanded.createdBy": "创建者",
  "storage.expanded.createdDate": "创建日期",
  "storage.expanded.description": "描述",
  "storage.expanded.lastModifiedBy": "最后修改者",
  "storage.expanded.lastModifiedDate": "最后修改日期",
  "storage.expanded.notAvailable": "不适用",
  "storage.expanded.positionSchemaHint": "位置架构提示",
  "storage.expanded.temperatureSetting": "温度设置",
  "storage.filter.by.locations": "按位置过滤",
  "storage.filter.by.locations.placeholder": "按位置过滤...",
  "storage.filter.device": "按设备过滤",
  "storage.filter.room": "按房间过滤",
  "storage.filter.status": "按状态过滤",
  "storage.hierarchical.path": "位置路径",
  "storage.inline.add.device": "添加新设备",
  "storage.inline.add.rack": "添加新货架",
  "storage.inline.add.room": "添加新房间",
  "storage.inline.add.shelf": "添加新货架",
  "storage.location": "位置",
  "storage.location.active": "活跃",
  "storage.location.add.button": "添加位置",
  "storage.location.add.title": "添加存储位置",
  "storage.location.current": "存储位置",
  "storage.location.code": "位置代码",
  "storage.location.code.helper": "最多10个字符，字母数字，可包含连字符/下划线",
  "storage.location.description": "描述",
  "storage.location.label": "存储位置",
  "storage.location.name": "位置名称",
  "storage.location.skipped": "跳过存储",
  "storage.location.tempMax": "最高温度",
  "storage.location.tempMin": "最低温度",
  "storage.location.type": "位置类型",
  "storage.location.unassigned": "未分配",
  "storage.location.notAssigned": "未分配",
  "storage.location.move": "移动存储位置",
  "storage.location.assign": "分配存储位置",
  "storage.manageLocation.error.saveFailed": "保存失败",
  "storage.manageLocation.error.selectTarget": "保存前请先选择设备、货架、机架或箱子",
  "storage.nav.box": "箱",
  "storage.nav.device": "设备",
  "storage.nav.room": "房间",
  "storage.nav.shelf": "货架",
  "storage.picker.currentLocation": "当前位置",
  "storage.picker.heading.assignLocation": "分配存储位置",
  "storage.picker.heading.move": "移动物品",
  "storage.picker.newLocation": "新位置",
  "storage.picker.notes": "备注",
  "storage.picker.orBrowse": "或逐级选择",
  "storage.picker.position.optional": "位置（可选）",
  "storage.picker.select": "选择{level}",
  "storage.picker.selectDeviceType": "选择设备类型",
  "storage.picker.addNewLevel": "添加新{level}",
  "storage.picker.inlineCreate.heading": "创建新的{level}",
  "storage.picker.inlineCreate.error.title": "无法创建位置",
  "storage.picker.inlineCreate.error": "无法创建位置",
  "storage.picker.occupant.identifier": "标识符",
  "storage.picker.occupant.heading": "项目",
  "storage.picker.occupant.status": "状态",
  "storage.picker.occupant.type": "设备类型",
  "storage.picker.storageLocation": "存储位置",
  "storage.metrics.active": "活跃",
  "storage.metrics.disposed": "已处置",
  "storage.metrics.total.samples": "总样本项",
  "storage.mode.autocomplete": "提前输入搜索",
  "storage.mode.barcode": "条码扫描",
  "storage.mode.cascading": "级联下拉菜单",
  "storage.move.button": "移动样本",
  "storage.move.reason.label": "移动原因",
  "storage.nav.boxes": "储物盒",
  "storage.nav.boxes.tooltip": "管理储物盒",
  "storage.nav.dashboard": "仪表板",
  "storage.nav.devices": "设备",
  "storage.nav.devices.tooltip": "管理存储设备",
  "storage.nav.locations": "位置",
  "storage.nav.locations.tooltip": "管理存储位置",
  "storage.nav.racks": "货架",
  "storage.nav.racks.tooltip": "管理货架",
  "storage.nav.rooms": "房间",
  "storage.nav.rooms.tooltip": "管理存储房间",
  "storage.nav.sample.items": "样本项",
  "storage.nav.sample.items.tooltip": "管理存储中的样本项",
  "storage.nav.samples": "样本",
  "storage.nav.samples.tooltip": "管理存储中的样本",
  "storage.nav.shelves": "架层",
  "storage.nav.shelves.tooltip": "管理架层",
  "storage.no.data": "无可用数据",
  "storage.occupancy": "占用率",
  "storage.position.label": "位置",
  "storage.rack.device": "设备",
  "storage.rack.dimensions": "尺寸",
  "storage.rack.label": "货架",
  "storage.rack.placeholder": "选择或键入以创建货架...",
  "storage.rack.room": "房间",
  "storage.rack.shelf": "货架",
  "storage.room.code": "代码",
  "storage.room.devices": "设备",
  "storage.room.label": "房间",
  "storage.room.name": "名称",
  "storage.room.placeholder": "选择或键入以创建房间...",
  "storage.room.samples": "样本",
  "storage.sampleitem.id": "样本项ID",
  "storage.search.boxes.placeholder": "按标签或代码搜索箱子...",
  "storage.search.devices.placeholder": "按设备名称或代码搜索...",
  "storage.search.location.minLength": "请继续输入，至少 2 个字符",
  "storage.search.location.searching": "搜索中...",
  "storage.search.location.error": "无法搜索位置。请重试。",
  "storage.search.location.noResults": "没有与“{query}”匹配的存储位置",
  "storage.search.placeholder": "按样本ID或位置搜索...",
  "storage.search.racks.placeholder": "按货架标签搜索...",
  "storage.search.rooms.placeholder": "按房间名称或代码搜索...",
  "storage.search.lots.placeholder": "按批号、条码、物品或位置搜索...",
  "storage.search.samples.placeholder": "按样本ID或位置搜索...",
  "storage.search.shelves.placeholder": "按货架标签搜索...",
  "storage.select.location": "选择位置",
  "storage.selectSample": "选择样本",
  "storage.shelf.device": "设备",
  "storage.shelf.label": "货架",
  "storage.shelf.placeholder": "选择或键入以创建货架...",
  "storage.shelf.room": "房间",
  "storage.status": "状态",
  "storage.status.disposed": "已处置",
  "storage.success.assigned": "样本成功分配到存储位置",
  "storage.success.moved": "样本成功移动到新位置",
  "storage.tab.ariaLabel": "存储管理选项卡",
  "storage.tab.dashboard": "仪表板",
  "storage.tab.inventoryLots": "库存批次",
  "storage.tab.samples": "样本项",
  "storage.target.location": "目标位置",
  "storage.unassigned.title": "未分配样本",
  "storage.skipAssignment": "无需存储——样本将立即进行处理",
  "success.add.edited.msg": "成功添加/编辑",
  "success.delete.msg": "成功删除",
  "success.import.patient": "患者成功导入",
  "success.report.status": "成功生成报告",
  "success.save.msg": "成功保存",
  "success.save.patient": "患者保存成功",
  "systemuser.firstName": "系统用户名",
  "systemuser.isActive": "是否活跃",
  "systemuser.lastName": "系统用户姓",
  "systemuser.loginName": "系统用户登录名",
  "systemuser.role": "角色",
  "systemuserrole.apply": "应用",
  "systemuserrole.allLabUnits.confirm.body": "将此行切换为“所有实验室单元”会移除这些实验室单元权限。“所有实验室单元”行初始未勾选任何权限。",
  "systemuserrole.allLabUnits.confirm.noPermissions": "未勾选任何权限",
  "systemuserrole.allLabUnits.confirm.primary": "替换权限",
  "systemuserrole.allLabUnits.confirm.title": "替换实验室单元权限？",
  "systemuserrole.allLabUnits.exclusive.error": "“所有实验室单元”不能与单个实验室单元组合使用。未保存任何内容。",
  "systemuserrole.allLabUnits.exclusive.info": "“所有实验室单元”不能与单个实验室单元组合使用：选择它将替换所有特定于实验室单元的权限。",
  "systemuserrole.copypermissions": "从用户复制权限",
  "systemuserrole.copypermissions.placeholder": "复制用户权限",
  "systemuserrole.instruction.1": "有两种类型的角色。为整个应用程序设置的全局角色和可以为所有实验室单元或特定实验室单元设置的实验室单元角色。",
  "systemuserrole.instruction.2": "可用的全局角色有：全局管理员（访问所有管理功能）、审计跟踪（访问所有审计跟踪）、用户账户管理员（可以访问所有用户账户管理功能，但不能访问任何其他管理功能）。",
  "systemuserrole.instruction.3": "实验室单元角色有：接收（访问订单、患者和不符合选项卡）、结果（访问工作计划、不符合和结果选项卡）、验证（访问验证和不符合选项卡）、报告（访问报告选项卡，但CSV导出仅适用于全局管理员）。",
  "systemuserrole.instruction.4": "要分配实验室单元角色，请从下拉列表中选择所有实验室单元或特定实验室单元，并选择您要设置的任何角色。",
  "systemuserrole.instruction.5": "您也可以使用复制权限功能复制现有用户的权限。确保您已填写上述所有信息，并在框中输入要复制其权限的用户名，然后单击应用。",
  "systemuserrole.newpermissions": "添加新权限",
  "systemuserrole.rmpermissions": "移除权限",
  "systemuserrole.roles.global": "全局角色",
  "systemuserrole.roles.labunit": "实验室单元角色",
  "test.add.copy.name": "从检测名称复制",
  "test.antimicrobialResistance": "抗菌素耐药性",
  "test.description.active": "如果检测处于活跃状态，它可以在订单表单上订购或作为检测算法的一部分。如果它不活跃，则不能订购或作为检测算法的一部分",
  "test.description.name": "检测在openELIS中显示的名称。需要英文和法文",
  "test.description.orderable": "如果检测处于活跃状态且可订购，则可以在订单表单上订购。如果它处于活跃状态但不可订购，则只有当它从另一个检测反射时才会执行",
  "test.description.panel": "如果此检测是检测面板的一部分，则可以在此处添加面板。一个检测可以属于多个面板，但这不常见",
  "test.description.reportName": "检测在报告中显示的名称。需要英文和法文。如果名称和报告名称相同，请单击按钮复制名称",
  "test.description.testSection": "将执行检测的检测科室",
  "test.description.uom": "检测的测量单位。这通常仅适用于数值或字母数字结果类型",
  "test.field.active": "活跃",
  "test.field.orderable": "可订购",
  "test.inLabOnly": "仅限实验室内部",
  "test.modify.en": "英文",
  "test.modify.fr": "法文",
  "test.modify.header.modify": "请选择要修改的检测！",
  "test.modify.header.test": "检测",
  "test.name": "检测名称",
  "test.notifyResults": "通知患者结果",
  "test.section": "检测科室",
  "test.section.label": "检测科室",
  "test.show.guide": "显示指南",
  "testcalculation.label.calculation": "计算",
  "testcalculation.label.finalresult": "最终结果",
  "testcalculation.label.insertOperation": "插入操作",
  "testcalculation.label.integer": "整数",
  "testcalculation.label.mathFucntion": "数学函数",
  "testcalculation.label.name": "计算名称",
  "testcalculation.label.patientAttribute": "患者属性",
  "testcalculation.label.searchNumericTest": "搜索数值检测",
  "testcalculation.label.selectDictionaryValue": "选择字典值",
  "testcalculation.label.testResult": "检测结果",
  "testcalculation.label.textValue": "文本值",
  "testCatalog.header.ageRange": "年龄范围",
  "testCatalog.header.criticalRange": "危急范围",
  "testCatalog.header.field": "字段",
  "testCatalog.header.gender": "性别",
  "testCatalog.header.normalRange": "正常范围",
  "testCatalog.header.reportingRange": "报告范围",
  "testCatalog.header.validRange": "有效范围",
  "testCatalog.header.value": "值",
  "admin.testCatalog.methods.title": "方法",
  "admin.testCatalog.methods.column.name": "方法名称",
  "admin.testCatalog.methods.column.code": "代码",
  "admin.testCatalog.methods.column.default": "默认值",
  "admin.testCatalog.methods.column.effectiveDate": "生效日期",
  "admin.testCatalog.methods.column.actions": "操作",
  "admin.testCatalog.methods.action.edit": "编辑",
  "admin.testCatalog.methods.action.remove": "移除",
  "admin.testCatalog.methods.btn.linkMethod": "+ 关联方法",
  "admin.testCatalog.methods.btn.createMethod": "+ 创建新方法",
  "admin.testCatalog.methods.btn.copyFromTest": "从检测复制",
  "admin.testCatalog.methods.modal.link.title": "关联方法",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "选择要关联的方法",
  "admin.testCatalog.methods.modal.link.noAvailable": "所有活跃方法均已关联",
  "admin.testCatalog.methods.inline.nameEnglish": "方法名称（英文）",
  "admin.testCatalog.methods.inline.nameFrench": "方法名称（法文）",
  "admin.testCatalog.methods.inline.code": "短代码",
  "admin.testCatalog.methods.inline.codeHint": "3–10个大写字母和数字，不包含空格",
  "admin.testCatalog.methods.inline.createAndLink": "创建与关联",
  "admin.testCatalog.methods.copyFromTest.label": "从检测中复制方法",
  "admin.testCatalog.methods.copyFromTest.placeholder": "选择源检测",
  "admin.testCatalog.methods.effectiveDate.label": "生效日期",
  "admin.testCatalog.methods.default.label": "设为默认值",
  "admin.testCatalog.methods.error.duplicateLink": "该方法已与检测相关联",
  "admin.testCatalog.methods.error.codeFormat": "代码必须由 3–10 个大写字母或数字组成，且不能包含空格",
  "admin.testCatalog.methods.error.effectiveDateRequired": "必须填写生效日期",
  "admin.testCatalog.methods.error.duplicateCode": "已存在具有此代码的方法。请输入其他代码。",
  "admin.testCatalog.methods.error.duplicateName": "已存在具有此名称的方法。请使用其他名称，或关联现有方法。",
  "admin.testCatalog.methods.error.invalidRequest": "请求被拒绝。请检查各字段后重试。",
  "admin.testCatalog.methods.error.server": "服务器无法完成请求。请重试。",
  "admin.testCatalog.methods.error.removeFailed": "无法移除该方法。它仍处于关联状态，请重试。",
  "admin.testCatalog.methods.linked": "方法已关联。",
  "admin.testCatalog.methods.created": "方法已创建并关联。",
  "admin.testCatalog.methods.copied": "从 {source}：已复制{count, plural, one {# 个方法} other {# 个方法}}。",
  "admin.testCatalog.methods.copyNothing": "未复制任何方法：{source} 中没有尚未关联到此检测的方法。",
  "admin.testCatalog.methods.empty": "未关联任何方法。请使用“+ 关联方法”或“+ 创建新方法”来添加一个。",
  "testnotification.bcc": "密送",
  "testnotification.instructionis.variables.body": "[testName]：此检测的名称",
  "testnotification.instructionis.variables.body.0": "[testResult]：检测结果",
  "testnotification.instructionis.variables.header": "变量列表：",
  "testnotification.instructions.body": "创建通知时，首先检查是否为收件人/消息类型定义了消息模板。",
  "testnotification.instructions.body.0": "如果不存在，它将使用检测默认消息。",
  "testnotification.instructions.body.1": "如果不存在，它将使用系统默认消息。",
  "testnotification.instructions.body.2": "变量将在消息正文和主题中被其相应的值替换。",
  "testnotification.instructions.body.3": "变量应始终包含方括号且不应有空格。",
  "testnotification.instructions.header": "说明：",
  "testnotification.messagetemplate": "消息",
  "testnotification.options": "单独消息",
  "testnotification.patient.email": "患者电子邮件",
  "testnotification.patient.sms": "患者短信",
  "testnotification.patiententry.header": "结果报告",
  "testnotification.patiententry.info": "如果 OpenELIS 无法连接到所传输结果的接收方，会将这些结果放入队列。队列过大且不断增长表明需要进行故障排除，包括联系接收方。",
  "testnotification.provider.email": "提供者电子邮件",
  "testnotification.provider.sms": "提供者短信",
  "testnotification.subjecttemplate": "主题",
  "testnotification.systemdefault.template": "系统默认消息",
  "testnotification.testdefault.editIcon": "编辑检测通知",
  "testnotification.testdefault.template": "检测的默认消息",
  "testnotificationconfig.browse.title": "检测通知配置",
  "tests.not.assigned": "未分配的检测",
  "testsection.testSectionName": "检测部分名称",
  "testUnit.existing": "现有检测单元",
  "testUnit.existing.inactive": "非活跃检测单元。分配检测以激活。",
  "testUnit.new": "新单元检测",
  "text.length.max": "文本长度不应大于200",
  "title.notestfoundmatching": "未找到匹配的检测",
  "to.title": "到",
  "tooltip.banner.menu.generic.sample.results": "为通用样本输入检测结果",
  "tooltip.banner.menu.workplan.batch": "批量工作计划",
  "total.quantity": "总数量",
  "transaction.date": "日期",
  "transaction.quantity": "数量",
  "transaction.type": "类型",
  "transaction.user": "用户",
  "true.label": "真",
  "unifiedSystemUser.add.user": "添加用户",
  "unifiedSystemUser.browser.button.add": "添加新用户",
  "unifiedSystemUser.browser.search": "按用户名搜索",
  "unifiedSystemUser.browser.search.placeholder": "按用户名搜索...",
  "unifiedSystemUser.browser.title": "用户管理",
  "unifiedSystemUser.edit.user": "修改用户",
  "unifiedSystemUser.select": "选择",
  "unknown.section": "未知部分",
  "unknown.test": "未知检测",
  "uom.browse.title": "测量单位",
  "uom.create.heading.confirmation": "确认",
  "uom.existing": "当前测量单位",
  "uom.existing.inactive": "非活跃测量单位。分配检测到此测量单位以激活它。",
  "uom.new": "创建新的测量单位",
  "uom.new.added": "新测量单位将被添加",
  "uom.notification.duplicate": "测量单位已存在",
  "uom.notification.save": "新测量单位已保存。",
  "uom.uomName": "测量单位名称",
  "training.installation.message": "这是培训/演示系统，请勿录入真实患者数据",
  "translation.edit.title": "编辑翻译",
  "translation.export": "导出翻译",
  "translation.export.success": "翻译导出成功",
  "translation.fallback": "备用值",
  "translation.management.description": "管理应用程序的翻译和本地化",
  "translation.management.title": "翻译管理",
  "translation.missing": "缺失翻译",
  "translation.search": "搜索翻译",
  "translation.selectLocale": "选择语言环境",
  "translation.showMissing": "仅显示缺失项",
  "translation.stats.title": "翻译统计",
  "translation.stats.total": "总计",
  "translation.update.error": "更新翻译失败",
  "translation.update.success": "翻译更新成功",
  "translation.value": "翻译值",
  "translation.origin": "Origin",
  "translation.origin.shipped": "已发货",
  "translation.origin.siteOverride": "Site override",
  "translation.origin.siteValue": "Site value",
  "translation.shippedLabel": "Shipped translation: {label}",
  "translation.reset": "Reset to shipped translation",
  "translation.reset.confirm": "Replace the lab's label with the shipped translation \"{label}\"?",
  "translation.reset.confirmButton": "重置",
  "translation.reset.success": "The label is back to the shipped translation.",
  "translation.reset.error": "The label could not be reset.",
  "localization.error.overrideBlank": "A label for a value OpenELIS ships cannot be blank. To drop the lab's label, use Reset to shipped translation.",
  "localization.error.notShipped": "Only a value OpenELIS ships has a shipped translation to return to.",
  "usage.analysisId": "分析ID",
  "usage.date": "使用日期",
  "usage.error.quantityPositive": "数量必须大于0",
  "usage.fefo.note": "数量将从该物品最早过期且质控已通过的批次中扣除（FEFO），该批次可能不是您打开此页面时所在的批次。",
  "usage.item": "项目",
  "usage.notes": "备注",
  "usage.notes.placeholder": "添加关于此使用情况的任何备注",
  "usage.quantityUsed": "使用数量",
  "usage.quantityUsed.helper": "输入消耗的单位数量",
  "usage.record.button": "记录使用情况",
  "usage.record.error": "记录使用量时出错",
  "usage.record.success": "使用情况记录成功",
  "usage.record.title": "记录库存使用情况",
  "usage.testResultId": "检测结果ID（可选）",
  "usage.testResultId.placeholder": "链接到检测结果以进行追溯",
  "user.select.instruction": "选择要修改或停用的用户。您可以设置过滤器、搜索用户或添加用户以及顶部的控件。",
  "validation.accept.all": "保存所有结果",
  "validation.accept.normal": "保存所有正常",
  "validation.field.required": "此字段为必填项",
  "validation.ignore.all": "忽略所有结果",
  "validation.label.nonconform": "= 样本或订单不符合或检测已被拒绝",
  "validation.legend.qcHold": "= 涵盖此结果的质控未通过；相关不符合项仍未关闭",
  "validation.qcHold.tooltip": "本实验室单元中该检测的一次质控运行失败。发布此结果前，请复核不符合项。",
  "validation.password.match": "密码不匹配",
  "validation.password.minLength": "密码长度不足",
  "validation.password.notSameAsOld": "新密码不能与旧密码相同",
  "validation.password.specialChar": "密码必须包含至少一个特殊字符（*、$、#、!），且只能包含字母、数字或这些字符",
  "validation.no.records.display": "无可显示的记录",
  "validation.reject.all": "重新检测所有检测",
  "validation.save.error": "无法保存分析仪结果",
  "validation.save.success": "结果验证成功",
  "validation.search.noresult": "未找到要验证的结果",
  "validation.search.noresult.analyser": "未找到结果：",
  "vl.arvRegimen": "ARV治疗方案",
  "vl.durationOnARV": "抗逆转录病毒治疗持续时间（月）",
  "vl.durationOnARV.placeholder": "输入治疗月数",
  "vl.indication": "VL检测的适应症",
  "vl.lastVLDate": "上次VL结果日期",
  "vl.lastVLResult": "上次VL检测结果（拷贝/毫升）",
  "vl.lastVLResult.placeholder": "例如，150",
  "vl.pregnancyStatus": "怀孕/哺乳状态",
  "workplan.batch.action.activate": "激活",
  "workplan.batch.action.archive": "归档",
  "workplan.batch.action.complete": "完成",
  "workplan.batch.batches": "批次",
  "workplan.batch.batches.empty": "未找到批次",
  "workplan.batch.column.actions": "操作",
  "workplan.batch.column.count": "检测项目",
  "workplan.batch.column.created": "创建时间",
  "workplan.batch.column.method": "方法",
  "workplan.batch.column.name": "批次",
  "workplan.batch.column.sampleType": "样本类型",
  "workplan.batch.column.status": "状态",
  "workplan.batch.column.test": "检测",
  "workplan.batch.column.unit": "单位",
  "workplan.batch.create": "创建批次（{count}）",
  "workplan.batch.create.error": "无法创建批次",
  "workplan.batch.create.success": "批次已创建",
  "workplan.batch.pending.empty": "未找到待处理的检测",
  "workplan.batch.pendingTests": "待处理检测",
  "workplan.batch.refresh": "刷新",
  "workplan.batch.selectPage": "选择本页",
  "workplan.batch.selectTest": "选择{accessionNumber}",
  "workplan.batch.status.ACTIVE": "活跃",
  "workplan.batch.status.ARCHIVED": "归档",
  "workplan.batch.status.COMPLETED": "已完成",
  "workplan.batch.status.DRAFT": "草稿",
  "workplan.batch.status.error": "无法更新批次状态",
  "workplan.batch.status.success": "批次状态已更新",
  "workplan.batch.tabs": "批次工作计划标签页",
  "workplan.batch.title": "批次工作计划",
  "workplan.page.title": "工作计划 {0}",
  "workplan.panel.selection.error.msg": "这是无效的错误消息。",
  "workplan.panel.title": "按面板的工作计划",
  "workplan.panel.types": "面板类型",
  "workplan.print": "打印工作计划",
  "workplan.priority.list": "优先级",
  "workplan.priority.title": "按优先级的工作计划",
  "workplan.run": "获取工作计划",
  "workplan.test.title": "按检测的工作计划",
  "workplan.test.types": "检测类型",
  "workplan.title": "工作计划",
  "workplan.unit.title": "按单元的工作计划",
  "workplan.unit.types": "单元类型",
  "yes.option": "是",
  "shipment.module.title": "样本转运",
  "shipment.breadcrumb": "转运",
  "shipment.nav.dashboard": "仪表板",
  "shipment.nav.createBox": "创建转运箱",
  "shipment.nav.receiveBox": "接收转运箱",
  "shipment.dashboard.title": "样本转运管理",
  "shipment.dashboard.description": "管理样本的转运和分发",
  "shipment.dashboard.tabs.shipments": "转运列表",
  "shipment.dashboard.tabs.unassigned": "未分配样本",
  "shipment.tab.boxes": "转运箱",
  "shipment.tab.unassignedSamples": "未分配样本",
  "shipment.label.boxId": "箱子编号",
  "shipment.label.createdDate": "创建日期",
  "shipment.label.daysUnassigned": "未分配天数",
  "shipment.label.destination": "目标机构",
  "shipment.label.priority": "优先级",
  "shipment.label.referralTest": "转诊检测",
  "shipment.label.sampleCount": "样本数量",
  "shipment.label.state": "状态",
  "shipment.label.tests": "检测项目",
  "shipment.filter.state": "状态筛选",
  "shipment.filter.facility": "机构筛选",
  "shipment.action.addSelected": "添加已选择内容",
  "shipment.action.addToBox": "加入转运箱",
  "shipment.action.cancelReferral": "取消转诊",
  "shipment.action.confirmRejection": "确认拒绝",
  "shipment.action.createBox": "创建转运箱",
  "shipment.action.markAsLost": "标记为丢失",
  "shipment.action.printManifest": "打印清单",
  "shipment.action.rejectSample": "拒绝样本",
  "shipment.action.saveAndMarkReady": "保存并标记为待发",
  "shipment.action.saveBox": "保存转运箱",
  "shipment.action.saveDraft": "保存为草稿",
  "shipment.action.scanSample": "扫描样本",
  "shipment.box.addSample": "添加样本",
  "shipment.box.addSampleDescription": "扫描或搜索样本以添加到此转运箱",
  "shipment.box.addSamples": "添加样本",
  "shipment.box.details": "转运箱详情",
  "shipment.box.autoGenerate": "自动生成",
  "shipment.box.capacity": "容量",
  "shipment.box.capacityValue": "{used}/{total}",
  "shipment.box.create": "创建",
  "shipment.box.createDescription": "填写以下信息创建新的转运箱",
  "shipment.box.created": "创建时间",
  "shipment.box.createdBy": "创建人",
  "shipment.box.createdDate": "创建日期",
  "shipment.box.destination": "目标机构",
  "shipment.box.downloadLabel": "下载标签",
  "shipment.box.downloadManifest": "下载清单",
  "shipment.box.generateLabel": "生成标签",
  "shipment.box.generateManifest": "生成清单",
  "shipment.box.id": "箱子编号",
  "shipment.box.labelDownloaded": "标签已下载",
  "shipment.box.labelPrefix": "标签前缀",
  "shipment.box.labelPrefixHelper": "设置转运箱标签的前缀",
  "shipment.box.manifest": "转运清单",
  "shipment.box.manifestDownloaded": "清单已下载",
  "shipment.box.noSamples": "此转运箱暂无样本",
  "shipment.box.noUnassignedSamples": "暂无未分配的样本",
  "shipment.box.notes": "备注",
  "shipment.box.notesPlaceholder": "输入转运备注（可选）",
  "shipment.box.number": "箱号",
  "shipment.box.readyConfirmation": "确认将此转运箱标记为待发送？",
  "shipment.box.readySampleCount": "此转运箱包含 {count} 个样本",
  "shipment.box.readyToSend": "准备发送",
  "shipment.box.reconcile": "核对",
  "shipment.box.removeSample": "移除样本",
  "shipment.box.removeSampleConfirmation": "确认从转运箱中移除此样本？",
  "shipment.box.resendManifest": "重新发送清单",
  "shipment.box.sampleCount": "样本数量",
  "shipment.box.sampleProgress": "{added}/{capacity} 个样本",
  "shipment.box.samplesAdded": "已添加样本",
  "shipment.box.samplesSelected": "已选择 {count} 个样本",
  "shipment.box.scanExisting": "扫描现有",
  "shipment.box.scanExistingId": "扫描现有箱编号",
  "shipment.box.scanExistingIdPlaceholder": "扫描或输入现有箱编号",
  "shipment.box.sendBox": "发送转运箱",
  "shipment.box.sendConfirmation": "确认发送此转运箱？",
  "shipment.box.sendSampleCount": "将发送 {count} 个样本",
  "shipment.box.state": "状态",
  "shipment.box.summary": "转运箱摘要",
  "shipment.box.temperature": "储存温度",
  "shipment.box.title": "转运箱详情",
  "shipment.box.useExistingId": "使用现有编号",
  "shipment.dashboard.boxNotFound": "未找到转运箱",
  "shipment.dashboard.scanBoxPlaceholder": "扫描箱子编号",
  "shipment.error.addSample": "添加样本失败",
  "shipment.error.assignToBox": "分配至转运箱失败",
  "shipment.error.boxFull": "转运箱已满",
  "shipment.error.boxNotEmpty": "转运箱不为空",
  "shipment.error.boxNotFound": "未找到转运箱",
  "shipment.error.cancelReferral": "取消转诊失败",
  "shipment.error.confirmReception": "确认接收失败",
  "shipment.error.createBox": "创建转运箱失败",
  "shipment.error.exceedsCapacity": "超出转运箱容量",
  "shipment.error.fetchBox": "获取转运箱信息失败",
  "shipment.error.fetchBoxes": "获取转运箱列表失败",
  "shipment.error.generateLabel": "生成标签失败",
  "shipment.error.generateManifest": "生成清单失败",
  "shipment.error.invalidState": "转运箱状态无效",
  "shipment.error.markAsLost": "标记丢失失败",
  "shipment.error.markReady": "标记待发送失败",
  "shipment.error.noDestinationFacility": "未设置目标机构",
  "shipment.error.noReferralId": "未找到转诊编号",
  "shipment.error.noSampleSelected": "请先选择样本",
  "shipment.error.partialReception": "部分接收",
  "shipment.error.partialSampleAdd": "仅有 {added}/{total} 个样本已添加到转运箱。该转运箱已保留为草稿，以便您添加其余样本。",
  "shipment.error.reasonRequired": "原因为必填项",
  "shipment.error.reconcile": "核对失败",
  "shipment.error.removeSample": "移除样本失败",
  "shipment.error.sampleAlreadyAssigned": "样本已分配至其他转运箱",
  "shipment.error.sampleAlreadyInBox": "样本已在转运箱中",
  "shipment.error.sampleNotFound": "未找到样本",
  "shipment.error.saveFailed": "保存失败",
  "shipment.error.searchFailed": "搜索失败，请重试",
  "shipment.error.selectBox": "请先选择转运箱",
  "shipment.error.sendBox": "发送转运箱失败",
  "shipment.filter.clear": "清除筛选",
  "shipment.filter.dateFrom": "开始日期",
  "shipment.filter.dateTo": "结束日期",
  "shipment.filter.referenceLab": "参考实验室",
  "shipment.label.addedDate": "添加日期",
  "shipment.label.position": "位置",
  "shipment.label.samples": "样本",
  "shipment.label.shippingLabel": "转运标签",
  "shipment.manifest.generated": "生成时间",
  "shipment.manifest.number": "清单编号",
  "shipment.manifest.recallExpired": "清单召回已过期",
  "shipment.manifest.regenerationExpired": "清单已过期，请重新生成",
  "shipment.manifest.serviceLocation": "服务地点",
  "shipment.manifest.specimenBarcodes": "样本条码",
  "shipment.manifest.title": "转运清单",
  "shipment.manifest.totalSamples": "样本总数",
  "shipment.modal.addToBox.existingBox": "加入现有箱",
  "shipment.modal.addToBox.mode": "加入方式",
  "shipment.modal.addToBox.newBox": "创建新箱",
  "shipment.modal.addToBox.newBoxInfo.message": "将创建新转运箱并将此样本加入",
  "shipment.modal.addToBox.newBoxInfo.title": "新建转运箱",
  "shipment.modal.addToBox.noDraftBoxes.message": "没有可用的草稿转运箱，请先创建新箱",
  "shipment.modal.addToBox.noDraftBoxes.title": "暂无草稿转运箱",
  "shipment.modal.addToBox.selectBox": "选择转运箱",
  "shipment.modal.addToBox.title": "加入转运箱",
  "shipment.modal.cancelReferral.reason": "取消原因",
  "shipment.modal.cancelReferral.reasonPlaceholder": "输入取消转诊的原因",
  "shipment.modal.cancelReferral.title": "取消转诊",
  "shipment.modal.cancelReferral.warning.message": "取消转诊后，相关检测将被退回，无法恢复",
  "shipment.modal.cancelReferral.warning.title": "警告",
  "shipment.modal.createBox.cancel": "取消",
  "shipment.modal.createBox.submit": "创建",
  "shipment.modal.createBox.title": "创建转运箱",
  "shipment.modal.markAsLost.reason": "丢失原因",
  "shipment.modal.markAsLost.reasonPlaceholder": "输入丢失原因",
  "shipment.modal.markAsLost.title": "标记为丢失",
  "shipment.modal.markAsLost.warning.message": "将此样本标记为丢失后，将无法再进行后续操作",
  "shipment.modal.markAsLost.warning.title": "警告",
  "shipment.modal.rejectSample": "拒绝样本",
  "shipment.modal.rejectSampleMessage": "确认拒绝此样本？",
  "shipment.nav.referenceLabResults": "参考实验室检测结果",
  "shipment.nav.reports": "报告",
  "shipment.nav.settings": "设置",
  "shipment.notification.boxCreated": "转运箱创建成功",
  "shipment.notification.boxReadyToSend": "转运箱已标记为待发送",
  "shipment.notification.boxReconciled": "转运箱核对完成",
  "shipment.notification.boxSent": "转运箱已成功发送",
  "shipment.notification.error": "操作失败，请重试",
  "shipment.notification.partialSamplesAdded": "部分样本已添加（部分样本已存在或超出容量）",
  "shipment.notification.receptionComplete": "转运箱接收完成",
  "shipment.notification.referralCancelled": "转诊已取消",
  "shipment.notification.sampleAdded": "样本添加成功",
  "shipment.notification.sampleAssignedToBox": "样本已分配到转运箱",
  "shipment.notification.sampleMarkedAsLost": "样本已标记为丢失",
  "shipment.notification.sampleRejected": "样本已拒收",
  "shipment.notification.sampleRemoved": "样本已移除",
  "shipment.notification.samplesAdded": "{count, plural, other {{count}个样本已添加}}",
  "shipment.notification.samplesRemovedDueToCapacity": "部分样本因超出容量而被移除",
  "shipment.reception.acceptSample": "接受样本",
  "shipment.reception.applyToAll": "应用到全部",
  "shipment.reception.awaitingAcceptance": "等待接受",
  "shipment.reception.confirmMessage": "确认完成此转运箱的接收？",
  "shipment.reception.confirmReception": "确认接收",
  "shipment.reception.damaged": "损坏",
  "shipment.reception.description": "扫描或输入箱子编号进行接收",
  "shipment.reception.enterBoxId": "输入箱子编号",
  "shipment.reception.generalNotes": "总体备注",
  "shipment.reception.generalNotesPlaceholder": "输入接收总体备注",
  "shipment.reception.importError": "FHIR导入失败",
  "shipment.reception.importFromFhir": "从FHIR导入",
  "shipment.reception.importResult": "导入成功",
  "shipment.reception.incomingBoxes": "待接收的转运",
  "shipment.reception.leaked": "泄漏",
  "shipment.reception.markAllMissing": "全部标记为缺失",
  "shipment.reception.markAllReceived": "全部标记为已接收",
  "shipment.reception.missing": "缺失",
  "shipment.reception.noIncomingBoxes": "没有新到货。请点击“从FHIR导入”以查看是否有新到货。",
  "shipment.reception.notes": "备注",
  "shipment.reception.notesPlaceholder": "输入样本状态备注",
  "shipment.reception.notesRequired": "请注明拒收/损坏原因",
  "shipment.reception.notesRequiredPlaceholder": "输入原因...",
  "shipment.reception.openBox": "待处理",
  "shipment.reception.originFacility": "来源",
  "shipment.reception.pending": "待处理",
  "shipment.reception.pendingAcceptance": "待接受的标本",
  "shipment.reception.received": "已接收",
  "shipment.reception.referralOrder": "转诊订单",
  "shipment.reception.rejected": "已拒收",
  "shipment.reception.sampleCountSummary": "已接受 {accepted} / 预期 {expected}",
  "shipment.reception.sampleNotFound": "未找到此样本",
  "shipment.reception.sampleScanned": "样本已扫描",
  "shipment.reception.sampleVerification": "样本核查",
  "shipment.reception.scanBox": "扫描箱子",
  "shipment.reception.scanBoxPlaceholder": "扫描或输入箱子编号",
  "shipment.reception.scanButton": "扫描",
  "shipment.reception.scanSample": "扫描样本",
  "shipment.reception.scanSampleButton": "扫描",
  "shipment.reception.scanSamplePlaceholder": "扫描样本条码",
  "shipment.reception.shipped": "已发货",
  "shipment.reception.specimen": "标本",
  "shipment.reception.status": "状态",
  "shipment.reception.title": "接收转运箱",
  "shipment.reception.unresolved": "没有匹配的订单",
  "shipment.rejection.damaged": "损坏",
  "shipment.rejection.expired": "已过期",
  "shipment.rejection.insufficientVolume": "量不足",
  "shipment.rejection.other": "其他原因",
  "shipment.rejection.reason": "拒绝原因",
  "shipment.rejection.wrongType": "类型错误",
  "shipment.report.contents": "内容",
  "shipment.report.description": "查看和导出转运报告",
  "shipment.report.export.excel": "导出Excel",
  "shipment.report.export.pdf": "导出PDF",
  "shipment.report.generate": "生成报告",
  "shipment.report.noResults": "暂无报告数据",
  "shipment.report.receivedDate": "接收日期",
  "shipment.report.receivedStatus": "接收状态",
  "shipment.report.receiver": "接收方",
  "shipment.report.receivingUser": "接收人",
  "shipment.report.sender": "发送方",
  "shipment.report.sentDate": "发送日期",
  "shipment.report.title": "转运报告",
  "shipment.report.totalBoxes": "总箱数",
  "shipment.report.totalSamples": "样本总数",
  "shipment.sample.accessionNumber": "订单号",
  "shipment.sample.multipleMatches": "有多个匹配的样本——请选择要添加的样本",
  "shipment.sample.remove": "移除样本",
  "shipment.sample.search": "搜索样本",
  "shipment.sample.searchPlaceholder": "搜索样本...",
  "shipment.sample.status": "状态",
  "shipment.sample.type": "样本类型",
  "shipment.settings.administration": "管理",
  "shipment.settings.boxLabelSection": "转运箱标签设置",
  "shipment.settings.description": "配置样本转运系统",
  "shipment.settings.fhirConfig": "FHIR配置",
  "shipment.settings.fhirConfigDesc": "配置FHIR集成设置",
  "shipment.settings.fhirConfigNote": "FHIR配置用于与外部系统集成进行样本数据交换",
  "shipment.settings.fhirConfigSaveError": "FHIR配置保存失败",
  "shipment.settings.fhirConfigSaved": "FHIR配置保存成功",
  "shipment.settings.fhirContainerType": "FHIR容器类型",
  "shipment.settings.fhirDisplayName": "显示名称",
  "shipment.settings.fhirNonConformity": "不符合代码",
  "shipment.settings.fhirSnomedCode": "SNOMED代码",
  "shipment.settings.manageFacilities": "管理机构",
  "shipment.settings.manageFacilitiesDesc": "配置参与转运的机构",
  "shipment.settings.manageUsers": "管理用户",
  "shipment.settings.manageUsersDesc": "配置转运系统用户权限",
  "shipment.settings.prefixHelperText": "标签前缀用于标识转运箱，最多4个字符",
  "shipment.settings.prefixPlaceholder": "输入前缀（最多4个字符）",
  "shipment.settings.prefixPreview": "标签预览",
  "shipment.settings.prefixRequired": "前缀为必填项",
  "shipment.settings.prefixSaveError": "前缀保存失败",
  "shipment.settings.prefixSaved": "前缀保存成功",
  "shipment.settings.siteOrgDescription": "配置此站点关联的机构",
  "shipment.settings.siteOrgLabel": "关联机构",
  "shipment.settings.siteOrgSaveError": "站点机构保存失败",
  "workflow.clinical": "临床",
  "workflow.environmental": "环境 / 其他原因",
  "provider.name": "申请医生姓名",
  "provider.name.placeholder": "输入申请医生姓名",
  "provider.phone": "申请医生电话",
  "provider.search.helper": "输入申请医生姓名或电话号码，然后点击“搜索”。",
  "site.search": "站点搜索",
  "site.name": "站点名称",
  "site.name.placeholder": "输入站点名称",
  "site.location": "位置",
  "site.type": "设备类型",
  "site.department": "科室 / 病区 / 单元",
  "site.department.selectFirst": "请先选择设施...",
  "site.department.choose": "请选择科室...",
  "site.department.none": "没有可用子单元",
  "sample.filterByLabUnit": "按实验室单元筛选",
  "sample.allLabUnits": "所有实验室单元",
  "sample.orderPanels": "订单面板",
  "sample.orderTests": "订单检测",
  "sample.referToReferenceLab": "将检测转诊到参考实验室",
  "sample.optional.info": "检测项目可以稍后添加：“保存并退出”会保留订单而不含检测项目。“保存并下一步”要求每个样本至少有一项检测。",
  "panel.search.placeholder": "选择可用面板",
  "test.search.placeholder": "选择可用检测",
  "test.timeHolding": "SOP 最长保存时间（分钟）",
  "select.regimen": "选择治疗方案...",
  "select": "选择...",
  "generating": "生成中...",
  "label.order": "订单标签行",
  "label.sample": "样本标签",
  "label.slide": "切片标签",
  "label.block": "块标签",
  "label.freezer": "冰箱标签",
  "environmental.coming.soon": "环境工作流",
  "environmental.location.info": "此处将提供位置层次结构字段（区域/地区/城镇-村）和GPS定位功能。",
  "env.collectionConditions.title": "默认采集条件",
  "env.collectionConditions.subtitle": "默认设置已应用到该批次中的所有样本。",
  "env.collectionMethod": "采集方法",
  "env.waterTemp": "水温（°C）",
  "env.ambientTemp": "环境温度（°C）",
  "env.weather": "天气",
  "env.preservationMethod": "保存方法",
  "env.preservationMethod.placeholder": "例如：HNO3酸化、4°C冷藏箱",
  "env.fieldNotes": "实地笔记",
  "env.fieldNotes.placeholder": "输入实地观察结果……",
  "env.sample.manifest.title": "每样本转运清单",
  "env.sample.manifest.subtitle": "一行 = 一个实物样本",
  "env.sample.container": "容器",
  "env.sample.gpsLat": "GPS纬度",
  "env.sample.gpsLat.placeholder": "例如 -6.2088",
  "env.sample.gpsLng": "GPS经度",
  "env.sample.gpsLng.placeholder": "例如 106.8456",
  "env.sample.samplingSite": "采样点",
  "env.sample.useOrderSite": "使用订单站点 {site}",
  "order.microPreview.site": "部位：{site}",
  "env.sample.locationDetails": "位置详情",
  "env.sample.locationDetails.placeholder": "例如：进水口、河岸……",
  "env.sample.collected": "已采样",
  "env.sample.duplicate": "重复样本",
  "env.sample.addRow": "+ 添加样本行",
  "env.sample.total": "总计：此批次中 {count} {count, plural, one {个样本} other {个样本}}",
  "env.sample.testsAndPanels": "检测项目和面板",
  "env.sample.tests.required": "必填",
  "env.complianceStandards.title": "适用的合规标准",
  "env.complianceStandards.subtitle": "请选择适用于本订单的监管标准。",
  "env.complianceStandards.label": "合规标准",
  "env.complianceStandards.placeholder": "选择标准……",
  "env.complianceStandards.empty": "未配置任何有效的合规标准。请在“管理”→“合规标准”中添加。",
  "order.dashboard.samplingSite": "样本采样点",
  "order.search.placeholder.env": "按站点名称或实验室编号搜索...",
  "order.filter.dateFrom": "来源",
  "order.filter.dateTo": "到",
  "program.placeholder": "输入内容进行筛选，或从列表中选择",
  "program.helper": "输入内容进行筛选，或从列表中选择。选择某个项目后，其具体的“附加订单信息”字段将显示在下方。",
  "patient.externalSearch": "外部搜索",
  "patient.results": "患者结果",
  "patient.id.helper": "请输入受试者编号、国家ID或ST编号。",
  "patient.id.placeholder": "输入患者ID",
  "patient.lastName.placeholder": "输入患者姓",
  "patient.firstName.placeholder": "输入患者名",
  "patient.natId": "唯一健康识别码",
  "patient.dataSource": "数据来源",
  "patient.noResults": "0-0（共0项）",
  "patient.new.info": "请在下方输入新患者的信息。保存医嘱后，系统将自动创建该患者的信息。",
  "pagination.showing": "显示 {start}-{end}（共 {total} 个检测项目）",
  "results.found.for": "搜索“{term}”得到的结果",
  "selected": "已选择",
  "shipment.settings.siteOrgSaved": "站点机构保存成功",
  "shipment.settings.siteOrgSection": "站点机构设置",
  "shipment.settings.title": "转运设置",
  "shipment.state.cancelled": "已取消",
  "shipment.state.draft": "草稿",
  "shipment.state.inTransit": "运输中",
  "shipment.state.lostInTransit": "运输中丢失",
  "shipment.state.partiallyReceived": "部分接收",
  "shipment.state.readyToSend": "准备发送",
  "shipment.state.received": "已接收",
  "shipment.state.reconciled": "已核对",
  "shipment.state.sent": "已发送",
  "shipment.stats.delivered": "已送达",
  "shipment.stats.inTransit": "运输中",
  "shipment.stats.reconciled": "已核对",
  "shipment.stats.totalSamples": "样本总数",
  "shipment.temperature.ambient": "常温",
  "shipment.temperature.deepFrozen": "深冷冻（-80°C）",
  "shipment.temperature.dryIce": "干冰",
  "shipment.temperature.frozen": "冷冻（-20°C）",
  "shipment.temperature.refrigerated": "冷藏（2-8°C）",
  "shipment.validation.addSample": "请至少添加一个样本",
  "shipment.validation.selectDestination": "请选择目标机构",
  "qc.dashboard.title": "质控仪表板",
  "qc.dashboard.lastUpdate": "最后更新时间",
  "qc.dashboard.complianceStatus": "合规状态",
  "qc.dashboard.compliant": "符合要求的",
  "qc.dashboard.warning": "警告",
  "qc.dashboard.nonCompliant": "不符合要求",
  "qc.dashboard.violationsCount": "{count} 违规记录",
  "qc.dashboard.lastResult": "最新结果",
  "qc.dashboard.noInstruments": "未配置任何仪器",
  "qc.dashboard.subtitle": "监控仪器的质控状态和警报",
  "qc.dashboard.loading": "正在加载仪表板数据...",
  "qc.dashboard.refresh": "刷新",
  "qc.dashboard.lastUpdated": "最后更新时间",
  "qc.dashboard.export.title": "导出质控数据",
  "qc.dashboard.export.selectInstrument": "选择仪器",
  "qc.dashboard.export.dateError": "结束日期必须等于或晚于开始日期。",
  "qc.dashboard.error.title": "错误",
  "qc.dashboard.error.loadFailed": "无法加载仪表板数据。请重试。",
  "qc.dashboard.tab.instruments": "仪器",
  "qc.dashboard.tab.alerts": "警报",
  "qc.dashboard.summary.inControl": "在控仪器",
  "qc.dashboard.summary.warningStatus": "警告状态",
  "qc.dashboard.summary.outOfControl": "失控",
  "qc.dashboard.summary.passRate": "在控仪器 %",
  "qc.dashboard.summary.ofTotal": "占仪器总数的 {percentage}%",
  "qc.dashboard.instruments.title": "仪器质控状态",
  "qc.dashboard.instruments.subtitle": "监控所有实验室仪器的合规状态和质控表现",
  "qc.dashboard.instruments.search": "搜索仪器……",
  "qc.dashboard.instruments.col.id": "仪器编号",
  "qc.dashboard.instruments.col.name": "仪器名称",
  "qc.dashboard.instruments.col.type": "设备类型",
  "qc.dashboard.instruments.col.location": "位置",
  "qc.dashboard.instruments.col.status": "状态",
  "qc.dashboard.instruments.col.analytes": "分析物",
  "qc.dashboard.instruments.col.violations": "近期违规记录",
  "qc.dashboard.instruments.col.lastUpdate": "最后更新",
  "qc.dashboard.instruments.col.actions": "操作",
  "qc.dashboard.instruments.view": "查看",
  "qc.dashboard.instruments.status.green": "在控",
  "qc.dashboard.instruments.status.yellow": "警告",
  "qc.dashboard.instruments.status.red": "失控",
  "qc.dashboard.instruments.status.notConfigured": "未配置",
  "qc.dashboard.instruments.status.unknown": "未知",
  "qc.dashboard.instruments.noViolations": "无违规记录",
  "qc.dashboard.instruments.empty": "未找到仪器",
  "qc.dashboard.alerts.title": "质控违规记录与警报",
  "qc.dashboard.alerts.subtitle": "显示来自{period}的违规记录",
  "qc.dashboard.alerts.timePeriod": "时间段",
  "qc.dashboard.alerts.timePeriod.24h": "过去24小时",
  "qc.dashboard.alerts.timePeriod.72h": "过去72小时",
  "qc.dashboard.alerts.timePeriod.7d": "最近7天",
  "qc.dashboard.alerts.timePeriod.30d": "最近30天",
  "qc.dashboard.alerts.timePeriod.all": "历史总计",
  "qc.dashboard.alerts.active": "当前质控违规记录",
  "qc.dashboard.alerts.active.count": "{count} 条未确认的违规记录需要处理",
  "qc.dashboard.alerts.active.empty": "无未解决的违规记录",
  "qc.dashboard.alerts.acknowledge": "确认",
  "qc.dashboard.alerts.acknowledged": "已确认的违规记录",
  "qc.dashboard.alerts.acknowledged.count": "已确认 {count} 条违规记录",
  "qc.dashboard.alerts.acknowledged.empty": "无已确认的违规记录",
  "qc.dashboard.alerts.col.severity": "严重程度",
  "qc.dashboard.alerts.col.time": "时间",
  "qc.dashboard.alerts.col.instrument": "仪器",
  "qc.dashboard.alerts.col.analyte": "分析物",
  "qc.dashboard.alerts.col.rule": "规则",
  "qc.dashboard.alerts.col.acknowledgedBy": "确认人",
  "qc.dashboard.alerts.col.acknowledgedDate": "确认日期",
  "qc.dashboard.banner.title": "{count} 项有效质控违规需要处理",
  "qc.dashboard.banner.viewAll": "查看所有警报",
  "qc.violations.error.acknowledgeFailed": "确认违规失败",
  "qc.chart.axis.date": "日期时间",
  "qc.chart.axis.run": "运行",
  "qc.chart.axis.value": "标准差（σ）",
  "qc.instrument.notFound": "未找到仪器",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "西格玛性能",
  "qc.chart.sigma.notCalculable": "无法计算：未配置 TEa",
  "qc.chart.sigma.bias": "未计入偏倚（无同行数据）",
  "qc.chart.sigma.WORLD_CLASS": "世界级",
  "qc.chart.sigma.ACCEPTABLE": "可接受",
  "qc.chart.sigma.MARGINAL": "勉强",
  "qc.chart.sigma.POOR": "差",
  "qc.chart.title": "质控图",
  "qc.chart.loading": "正在加载质控图…",
  "qc.chart.error.title": "无法加载质控图",
  "qc.chart.tabs.label": "质控图水平",
  "qc.chart.filter.allLevels": "所有水平",
  "qc.chart.filter.selectLot": "选择批号",
  "qc.chart.action.zoomIn": "放大",
  "qc.chart.action.zoomOut": "缩小",
  "qc.chart.action.zoomReset": "重置缩放",
  "qc.chart.legend.normal": "正常",
  "qc.chart.legend.violation": "违规记录",
  "qc.chart.mean": "均值",
  "qc.chart.noData": "无可用数据",
  "qc.chart.tooltip.date": "日期",
  "qc.chart.tooltip.value": "值",
  "qc.chart.tooltip.violations": "违规记录",
  "qc.chart.tooltip.zScore": "Z分数",
  "qc.charts.title": "控制图",
  "qc.charts.leveyJennings": "莱维-詹宁斯图",
  "qc.charts.dateRange": "日期范围",
  "qc.charts.controlLevel": "质控水平",
  "qc.charts.export": "导出图表",
  "qc.charts.noData": "无可用数据",
  "qc.violations.title": "QC违规记录",
  "qc.violations.severity": "严重程度",
  "qc.violations.rule": "规则",
  "qc.violations.date": "日期",
  "qc.violations.status": "状态",
  "qc.violations.unresolved": "未解决",
  "qc.violations.resolved": "已解决",
  "qc.violations.acknowledged": "已确认",
  "qc.correctiveActions.title": "纠正措施",
  "qc.correctiveActions.create": "创建纠正措施",
  "qc.correctiveActions.type": "措施类型",
  "qc.correctiveActions.description": "描述",
  "qc.correctiveActions.assignedTo": "分配给",
  "qc.correctiveActions.status": "状态",
  "qc.correctiveActions.pending": "待处理",
  "qc.correctiveActions.inProgress": "进行中",
  "qc.correctiveActions.completed": "已完成",
  "qc.correctiveActions.resolutionNotes": "决议备注",
  "qc.alerts.title": "QC警报",
  "qc.alerts.markAsRead": "标记为已读",
  "qc.alerts.viewDetails": "查看详情",
  "qc.rules.title": "Westgard规则配置",
  "qc.rules.enable": "启用",
  "qc.rules.disable": "禁用",
  "qc.rules.preset": "预设配置",
  "qc.rules.basic": "基础",
  "qc.rules.standard": "标准",
  "qc.rules.comprehensive": "全面",
  "qc.rules.1₂ₛ.description": "一个对照值超出±2个标准差",
  "qc.rules.1₃ₛ.description": "一个对照值超出±3个标准差",
  "qc.rules.2₂ₛ.description": "连续两次对照值在同一方向上超出±2个标准差",
  "qc.rules.R₄ₛ.description": "两个质控值之间的极差超过4个标准差",
  "qc.rules.4₁ₛ.description": "连续四个质控值在同一方向上超出±1个标准差",
  "qc.rules.10ₓ.description": "均值同一侧的连续十个对照值",
  "qc.rules.3₁ₛ.description": "连续三个质控值在同一方向上超出±1个标准差",
  "qc.rules.7ₜ.description": "连续七个质控值呈同一方向趋势",
  "qc.ruleConfig.title": "规则配置",
  "qc.ruleConfig.subtitle": "根据分析仪和检测组合配置Westgard规则",
  "qc.ruleConfig.field.analyzer": "分析仪",
  "qc.ruleConfig.field.selectAnalyzer": "选择分析仪",
  "qc.ruleConfig.field.test": "检测",
  "qc.ruleConfig.field.selectTest": "选择一项检测",
  "qc.ruleConfig.field.severity": "严重程度",
  "qc.ruleConfig.severity.warning": "警告",
  "qc.ruleConfig.severity.rejection": "拒绝",
  "qc.ruleConfig.category.rejection": "拒绝规则",
  "qc.ruleConfig.category.warning": "警告规则",
  "qc.ruleConfig.action.reset": "重置到默认值",
  "qc.ruleConfig.loading": "正在加载规则配置……",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "选择一台分析仪和一项检测，以配置Westgard规则。",
  "qc.ruleConfig.error.title": "错误",
  "qc.ruleConfig.error.selectAnalyzerTest": "请同时选择分析仪和检测项目。",
  "qc.ruleConfig.error.saveFailed": "保存规则配置失败。",
  "qc.ruleConfig.success.title": "成功",
  "qc.ruleConfig.success.saved": "规则配置已成功保存。",
  "qc.ruleConfig.table.title": "已配置的规则集",
  "qc.ruleConfig.table.empty": "未找到任何规则配置。",
  "qc.ruleConfig.field.enabledRules": "已启用的规则",
  "qc.ruleConfig.unconfigured.title": "未配置的质控映射",
  "qc.ruleConfig.unconfigured.subtitle": "未配置Westgard规则的质控品批号",
  "qc.ruleConfig.unconfigured.configure": "配置",
  "qc.ruleConfig.unconfigured.activeLots": "有效批号",
  "qc.ruleConfig.modal.title.edit": "编辑规则配置",
  "qc.ruleConfig.modal.title.create": "创建规则配置",
  "button.saving": "保存中...",
  "qc.controlLots.title": "质控品批号",
  "qc.controlLots.create": "创建控制批次",
  "qc.controlLots.productName": "产品名称",
  "qc.controlLots.lotNumber": "批号",
  "qc.controlLots.level": "控制级别",
  "qc.controlLots.statisticsMethod": "统计计算方法",
  "qc.controlLots.initialRuns": "初期运行",
  "qc.controlLots.rolling": "滑动窗口",
  "qc.controlLots.manufacturerFixed": "制造商已修复",
  "qc.controlLots.activationDate": "激活日期",
  "qc.controlLots.expirationDate": "过期日期",
  "qc.controlLots.status.active": "活跃",
  "qc.controlLots.status.establishment": "成立",
  "qc.controlLots.status.expired": "已过期",
  "qc.controlLots.subtitle": "管理用于Westgard规则评估的质控品批号",
  "qc.controlLots.empty": "未找到质控品批号",
  "qc.controlLot.filter.allStatuses": "所有状态",
  "qc.controlLot.status.establishment": "建立期",
  "qc.controlLot.status.active": "活跃",
  "qc.controlLot.status.expired": "已过期",
  "qc.controlLot.field.lotNumber": "批号",
  "qc.controlLot.field.lotNumberPlaceholder": "输入批号",
  "qc.controlLot.field.material": "质控品",
  "qc.controlLot.field.materialPlaceholder": "输入材料名称",
  "qc.controlLot.field.manufacturer": "制造商",
  "qc.controlLot.field.level": "质控水平",
  "qc.controlLot.field.selectLevel": "选择质控水平",
  "qc.controlLot.field.expiration": "过期日期",
  "qc.controlLot.field.analyzer": "分析仪",
  "qc.controlLot.field.selectAnalyzer": "选择分析仪",
  "qc.controlLot.field.analyzerHelper": "可选。对于在工作台上不使用仪器进行的手工方法，请选择“工作台/无分析仪”。",
  "qc.controlLot.analyzer.bench": "工作台/无分析仪（手工方法）",
  "qc.controlLot.field.test": "检测",
  "qc.controlLot.field.selectTest": "选择检测",
  "qc.controlLot.field.isActive": "状态",
  "qc.controlLot.field.inactive": "非活跃",
  "qc.controlLot.field.active": "活跃",
  "qc.controlLot.field.status": "状态",
  "qc.controlLot.loading": "加载中...",
  "qc.controlLot.error.title": "错误",
  "qc.controlLot.error.saveFailed": "保存质控品批号失败",
  "qc.controlLot.error.statsRequired": "厂家固定批号需要均值和标准差。请在保存前点击“配置”输入。",
  "qc.controlLot.error.benchNeedsFixedStats": "工作台批号没有分析仪累积运行数据，因此必须使用厂家固定统计值。请点击“配置”输入均值和标准差，或为此批号选择一台分析仪。",
  "qc.controlLot.new.title": "新建质控品批号",
  "qc.controlLot.viewChart": "查看图表",
  "qc.controlLot.new.subtitle": "创建新的质控品批号",
  "qc.controlLot.edit.title": "编辑质控品批号",
  "qc.controlLot.edit.subtitle": "更新质控品批号配置",
  "qc.controlLot.validation.lotNumberRequired": "必须填写批号",
  "qc.controlLot.validation.materialRequired": "需要材料",
  "qc.controlLot.validation.levelRequired": "必须选择质控水平",
  "qc.controlLot.validation.expirationRequired": "必须填写过期日期",
  "qc.controlLot.validation.analyzerRequired": "分析仪为必填项",
  "qc.controlLot.validation.testRequired": "必须选择检测",
  "qc.controlLot.level.low": "低",
  "qc.controlLot.level.normal": "正常",
  "qc.controlLot.level.high": "高",
  "qc.controlLot.statistics.title": "统计配置",
  "qc.controlLot.statistics.configure": "配置",
  "qc.controlLot.statistics.method": "计算方法",
  "qc.controlLot.statistics.mean": "均值",
  "qc.controlLot.statistics.sd": "标准差",
  "qc.controlLot.statistics.config.title": "统计配置",
  "qc.controlLot.statistics.config.label": "配置统计方法",
  "qc.controlLot.statistics.method.manufacturer_fixed": "制造商固定值",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "使用制造商提供的均值和标准差值",
  "qc.controlLot.statistics.method.rolling": "滑动窗口",
  "qc.controlLot.statistics.method.rolling.description": "根据最近的 N 次结果重新计算",
  "qc.controlLot.statistics.method.initial_runs": "初期运行",
  "qc.controlLot.statistics.method.initial_runs.description": "从前 N 次建立运行中计算一次",
  "qc.controlLot.statistics.manufacturerValues": "制造商给定值",
  "qc.controlLot.statistics.rollingConfig": "滑动窗口配置",
  "qc.controlLot.statistics.windowSize": "窗口大小",
  "qc.controlLot.statistics.windowSize.helper": "计算中应包含的近期结果数量",
  "qc.controlLot.statistics.initialRunsConfig": "初始运行配置",
  "qc.controlLot.statistics.initialRunsRequired": "所需运行次数",
  "qc.controlLot.statistics.initialRunsRequired.helper": "计算统计数据前所需的建立期运行次数",
  "qc.instrumentDetail.analytesMonitored": "监测的分析物",
  "qc.instrumentDetail.analyte.cv": "简历：{value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "活动时间轴",
  "qc.instrumentDetail.tab.controlChart": "控制图",
  "qc.instrumentDetail.timeline.empty": "在已选择的时间段内未记录任何警报或纠正措施",
  "qc.instrumentDetail.timeline.violation": "违规记录",
  "qc.instrumentDetail.timeline.correctiveAction": "纠正措施",
  "qc.instrumentDetail.timeline.loading": "正在加载活动时间轴...",
  "qc.instrumentDetail.chart.selectAnalyte": "选择分析物",
  "qc.instrumentDetail.chart.loading": "正在加载控制图...",
  "qc.instrumentDetail.chart.noData": "该分析物无可用质控数据",
  "qc.instrumentDetail.chart.activeRules": "已启用的质控规则",
  "qc.instrumentDetail.chart.noRules": "未配置任何有效的规则",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "均值 (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "标准差 (s)",
  "qc.instrumentDetail.error.loadFailed": "无法加载乐器详情",
  "qc.instrumentDetail.notConfigured.title": "未配置运行质控",
  "qc.instrumentDetail.notConfigured.description": "该分析仪未关联任何有效的质控品批号或质控结果。",
  "question.text.required": "必须填写问题内容",
  "compliance.legend.limitTypes": "限值类型：",
  "compliance.limitType.borderlineShort": "边缘型 ⚑",
  "compliance.limitType.descriptiveShort": "定性",
  "compliance.limitType.MAXIMUM": "上限 ≤",
  "compliance.limitType.MINIMUM": "下限 ≥",
  "compliance.limitType.RANGE": "正常范围",
  "compliance.limitType.BORDERLINE": "边缘型 🚩",
  "compliance.limitType.DESCRIPTIVE": "定性",
  "compliance.limitType.EXACT": "精确",
  "compliance.limitType.SELECT_MAP": "值映射",
  "compliance.status.ACTIVE": "活跃",
  "compliance.status.DRAFT": "草稿",
  "compliance.status.SUPERSEDED": "已被取代",
  "compliance.status.ARCHIVED": "归档",
  "compliance.standard.placeholder.name": "例如，第22/2021号政府条例（水质）",
  "compliance.standard.placeholder.issuingBody": "例如，印度尼西亚政府",
  "compliance.standard.placeholder.regulationNumber": "例如，PP 22/2021",
  "compliance.standard.placeholder.version": "例如，2021年",
  "compliance.standard.placeholder.countryRegion": "例如，印度尼西亚",
  "compliance.standard.placeholder.description": "可选。对标准适用范围的完整描述。",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "下限 / 最小值",
  "compliance.threshold.placeholder.upper": "上限 / 最大值",
  "compliance.threshold.placeholder.unit": "单位",
  "compliance.standard.archive": "归档",
  "compliance.standard.archiveHeading": "归档合规标准",
  "compliance.standard.archivePrompt": "将此标准归档？现有评估结果仍会与该标准保持关联，以便进行审计，但该标准将从活动选择列表中隐藏。通过将该标准的状态编辑回“活跃”状态，可以撤销此操作。",
  "compliance.standard.archived": "合规标准已归档。",
  "compliance.standard.archiveError": "无法归档此标准。",
  "button.complianceStandard.copy": "复制标准",
  "compliance.standard.copied": "合规标准已复制为新的草稿。",
  "compliance.standard.copyError": "无法复制此标准。",
  "compliance.standard.viewLinkedTests": "查看相关检测项目",
  "compliance.testEditor.groupBy": "按……分组",
  "compliance.testEditor.section.configuration": "配置",
  "compliance.testEditor.section.organization": "机构",
  "compliance.testEditor.section.resources": "资源",
  "compliance.testEditor.section.automation": "自动化",
  "compliance.testEditor.section.compliance": "合规",
  "compliance.testEditor.tab.compliance": "合规",
  "compliance.testEditor.tabPlaceholder": "将随“检测编辑器”界面提供；目前请通过“修改检测”页面进行管理。",
  "compliance.parameterGroup.editBtn": "编辑",
  "compliance.parameterGroup.moveUp": "向上移动",
  "compliance.parameterGroup.moveDown": "向下移动",
  "compliance.parameterGroup.updateError": "无法更新参数组。",
  "compliance.testEditor.standardInactiveBanner": "该检测的阈值关联到 {name}，该标准现为{status}。结果将不再依据该标准进行评估。",
  "compliance.standard.viewLinkedTests.heading": "相关检测项目 — {name}",
  "compliance.standard.viewLinkedTests.empty": "目前尚无任何检测项目与该标准相关联。",
  "compliance.filter.status": "状态",
  "compliance.filter.region": "区域",
  "compliance.filter.allStatuses": "所有状态",
  "compliance.filter.allRegions": "所有区域",
  "compliance.filter.sampleType": "样本类型",
  "compliance.filter.allSampleTypes": "所有样本类型",
  "compliance.sampleTypes.addLabel": "添加样本类型",
  "compliance.sampleTypes.noneConfigured": "未配置",
  "compliance.sampleTypes.noneTitle": "尚未配置任何样本类型。",
  "compliance.sampleTypes.noneSubtitle": "在链接检测之前，请至少添加一种样本类型。",
  "compliance.sampleTypes.counter": "{count, plural, other {已配置 # 种样本类型}}",
  "compliance.standard.default": "默认值",
  "compliance.standard.groups": "组",
  "compliance.standard.tests": "检测项目",
  "compliance.standard.expiryDate": "过期日期",
  "compliance.parameterGroups.heading": "参数组与关联检测项目",
  "compliance.parameterGroups.requireSampleTypes": "首先配置标准的字段和样本类型，然后关联检测项目。",
  "compliance.button.save": "保存",
  "compliance.button.saving": "正在保存……",
  "compliance.parameterGroup.createError": "无法添加参数组。",
  "compliance.parameterGroup.deleteHeading": "删除参数组",
  "compliance.parameterGroup.deletePrompt": "是否要删除参数组“{name}”及其所有阈值？此操作无法撤销。",
  "compliance.parameterGroup.deleteWarning": "{count, plural, other {# 个检测}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "无法保存此行。",
  "compliance.threshold.deleteError": "无法移除此行。",
  "compliance.validation.required": "此字段为必填项。",
  "compliance.validation.expiryAfterEffective": "过期日期不得早于生效日期。",
  "compliance.validation.missingUpper": "必须设定上限。",
  "compliance.validation.missingLower": "必须设定下限。",
  "compliance.validation.missingBounds": "需要同时指定下界和上界。",
  "compliance.validation.lowerGtUpper": "下界必须小于或等于上界。",
  "compliance.validation.missingDescriptive": "必须填写定性值。",
  "compliance.linkTest.selectNoOptions": "此检测为选择列表类型，但在检测目录中未配置任何选项。请在将其与合规标准关联之前，先在检测管理中添加结果选项。",
  "compliance.linkTest.resultTypeLegend": "结果类型",
  "compliance.linkTest.resultType.numeric": "数值（使用极限值）",
  "compliance.linkTest.resultType.select": "选择列表（将选项映射到状态）",
  "compliance.linkTest.optionsHint": "添加此测试的结果选项（例如“缺失”、“存在”）。下一步将引导您将每个选项与相应的合规状态进行映射。",
  "compliance.linkTest.optionLabel": "期权价值",
  "compliance.linkTest.optionPlaceholder": "例如：缺席",
  "compliance.linkTest.optionsRequired": "在映射状态之前，请在上面添加至少一个选项。",
  "compliance.admin.title": "合规标准管理",
  "compliance.admin.tile.explain": "管理合规标准、参数组和各项检测项目的阈值（例如 PP 22/2021、WHO 饮用水标准）。",
  "compliance.tabs.standardsAdmin": "合规标准清单",
  "compliance.tabs.testThresholds": "“合规”选项卡（检测编辑器）",
  "compliance.testEditor.back": "返回",
  "compliance.testEditor.editTest": "编辑检测：",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "样本类型:",
  "compliance.testEditor.resultType": "结果类型：",
  "compliance.testEditor.saveTest": "保存检测",
  "compliance.testEditor.saveDisabledHint": "本版本中，其他测试编辑器选项卡尚未接入。",
  "compliance.testEditor.thresholdsHeading": "合规阈值",
  "compliance.testEditor.addThreshold": "添加阈值",
  "compliance.testEditor.addThresholdHeading": "将 {name} 与一项合规标准关联起来",
  "compliance.testEditor.pickStandard": "合规标准",
  "compliance.testEditor.pickStandardPlaceholder": "-- 选择一个标准 --",
  "compliance.testEditor.pickGroup": "参数组",
  "compliance.testEditor.pickGroupPlaceholder": "-- 选择一个参数组 --",
  "compliance.testEditor.pickGroupHint": "请从上方选择一个标准和参数组来配置阈值。",
  "compliance.testEditor.unlink": "取消关联",
  "compliance.testEditor.unlinkHeading": "解除关联阈值",
  "compliance.testEditor.unlinkPrompt": "是否要从{test}中移除此阈值？阈值本身仍保留在标准的参数组中；仅移除指向此特定检测项目的链接。",
  "compliance.testEditor.linkedBanner": "此检测已关联 {count, plural, one {# 个合规标准} other {# 个合规标准}}。阈值在审核时进行评估。",
  "compliance.testEditor.expandRow": "展开行",
  "compliance.testEditor.col.standard": "标准",
  "compliance.testEditor.col.parameterGroup": "参数组",
  "compliance.testEditor.col.limitType": "限值类型",
  "compliance.testEditor.col.thresholdRange": "阈值 / 范围",
  "compliance.testEditor.col.unit": "单位",
  "compliance.testEditor.col.effective": "生效",
  "compliance.testEditor.col.status": "状态",
  "compliance.testThresholds.selectHint": "选择一项检测，查看其跨标准关联的合规阈值。",
  "compliance.testThresholds.overviewHeading": "与合规标准相关的检测项目",
  "compliance.testThresholds.overviewCount": "{filtered} / {total} 个检测{total, plural, one {} other {}}",
  "compliance.testThresholds.overviewEmpty": "目前尚无任何检测项目与合规标准相关联。",
  "compliance.testThresholds.overviewEmptyHint": "在参数组级别通过 CSV 设置的阈值显示在“选项卡 1（合规标准管理）”中，而非此处。请在上方搜索，从目录中选择一项检测，并将其与某项标准关联。",
  "compliance.testThresholds.noLinkedMatches": "没有与“{q}”匹配的关联检测项目。",
  "compliance.testThresholds.addSection": "将检测添加到合规管理",
  "compliance.testThresholds.col.test": "检测",
  "compliance.testThresholds.col.code": "代码",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "样本类型",
  "compliance.testThresholds.col.thresholdCount": "# 阈值",
  "compliance.testThresholds.col.standardCount": "# 标准",
  "compliance.testThresholds.openEditor": "待处理",
  "compliance.testThresholds.title": "检测合规阈值",
  "compliance.testThresholds.tile.explain": "查看与特定检测项目相关的合规阈值，按标准和参数组分类。",
  "compliance.testThresholds.searchLabel": "搜索检测",
  "compliance.testThresholds.searchPlaceholder": "筛选检测项目列表……",
  "compliance.testThresholds.test": "检测",
  "compliance.testThresholds.selectPlaceholder": "-- 选择检测 --",
  "compliance.testThresholds.empty": "此检测目前尚未关联任何合规阈值。请点击上方的“+ 添加阈值”，将其关联到某项合规标准的参数组。",
  "compliance.testThresholds.parameter": "参数",
  "compliance.testThresholds.type": "限额类型",
  "compliance.testThresholds.value": "值",
  "compliance.testThresholds.note": "备注",
  "compliance.testThresholds.unknownStandard": "未知标准",
  "compliance.button.openAdmin": "开放合规标准管理",
  "compliance.button.addStandard": "添加标准",
  "compliance.button.saveStandard": "保存标准",
  "compliance.button.linkTest": "将检测链接到组",
  "compliance.button.saveLimits": "保存限值",
  "compliance.button.saveMapping": "保存映射",
  "compliance.search": "搜索标准",
  "compliance.search.placeholder": "按名称、颁发机构、法规、国家等进行搜索……",
  "compliance.list.empty": "目前尚无合规标准。",
  "compliance.standard.name": "标准名称",
  "compliance.standard.issuingBody": "签发机构",
  "compliance.standard.regulationNumber": "法规编号",
  "compliance.standard.version": "版本",
  "compliance.standard.countryRegion": "国家/区域",
  "compliance.standard.status": "状态",
  "compliance.standard.effectiveDate": "生效日期",
  "compliance.standard.description": "描述",
  "compliance.standard.addNew": "添加新的合规标准",
  "compliance.standard.edit": "编辑合规标准",
  "compliance.standard.preSeeded": "预先种子",
  "compliance.standard.saved": "已保存合规标准。",
  "compliance.standard.saveError": "无法保存标准。",
  "compliance.standard.saveBeforeGroups": "在添加参数组之前，请先保存该标准。",
  "compliance.standard.deleted": "已删除合规标准。",
  "compliance.standard.deleteError": "无法删除该标准（可能是预设的，或者与阈值相关联）。",
  "compliance.standard.deleteHeading": "删除合规标准",
  "compliance.standard.deletePrompt": "您确定要删除此标准吗？预设标准和带有关联阈值的标准无法删除。",
  "compliance.sampleTypes.heading": "适用样本类型",
  "compliance.sampleTypes.explicitHint": "说明本标准适用于哪些样本类型类别。在关联检测时，这些选项将决定检测筛选器的设置。",
  "compliance.sampleTypes.empty": "尚未声明任何样本类型。",
  "compliance.sampleTypes.selectPlaceholder": "选择样本类型...",
  "compliance.sampleTypes.addBtn": "添加样本类型",
  "compliance.sampleTypes.remove": "移除",
  "compliance.parameterGroups": "参数组",
  "compliance.parameterGroups.empty": "尚未定义任何参数组。",
  "compliance.parameterGroups.add": "添加参数组",
  "compliance.parameterGroup.name": "组名称",
  "compliance.parameterGroup.description": "描述",
  "compliance.parameterGroup.deleteBtn": "删除",
  "compliance.label.tests": "检测项目",
  "compliance.linkedTest.name": "检测",
  "compliance.linkedTest.sampleTypes": "样本类型",
  "compliance.linkedTest.limits": "已配置限值",
  "compliance.linkedTest.editLimits": "编辑限值",
  "compliance.linkedTest.unlink": "从组中移除",
  "compliance.linkedTest.unlinkHeading": "从组中移除检测",
  "compliance.linkedTest.unlinkConfirm": "移除",
  "compliance.linkedTest.unlinkPrompt": "将此检测项目从该组中移除？该组中此检测项目的所有阈值定义都将被删除。",
  "compliance.group.noTests": "目前尚未与此组关联任何检测项目。请关联检测项目以定义评估的合规阈值。",
  "compliance.linkTest.heading": "将检测链接到组",
  "compliance.linkTest.step1": "步骤 1 — 按样本类型筛选",
  "compliance.linkTest.step2": "第 2 步 — 搜索并选择检测",
  "compliance.linkTest.step3Numeric": "第 3 步：配置限值",
  "compliance.linkTest.step3Select": "第 3 步：合规值映射",
  "compliance.linkTest.filterByST": "按样本类型筛选：",
  "compliance.linkTest.searchTest": "搜索检测目录",
  "compliance.linkTest.searchPlaceholder": "输入名称或代码进行搜索...",
  "compliance.linkTest.noResults": "未找到匹配的检测项目。",
  "compliance.linkTest.selectListBadge": "选择列表",
  "compliance.linkTest.clearSelection": "清除选择",
  "compliance.multiLimit.editHeading": "配置限值",
  "compliance.multiLimit.hint": "为该检测启用一种或多种限值类型。必须至少启用一种限值类型。",
  "compliance.multiLimit.type": "限值类型",
  "compliance.multiLimit.lower": "下限",
  "compliance.multiLimit.upper": "上限",
  "compliance.multiLimit.unit": "单位",
  "compliance.multiLimit.note": "备注 / 提示",
  "compliance.multiLimit.descriptive.placeholder": "例如：无气味、未检出、清澈",
  "compliance.multiLimit.note.placeholder": "可选备注",
  "compliance.limitType.high": "上限 ≤",
  "compliance.limitType.high.hint": "若结果超过上限，则视为不符合要求",
  "compliance.limitType.low": "下限 ≥",
  "compliance.limitType.low.hint": "如果结果低于下限，则视为不符合要求",
  "compliance.limitType.range": "正常范围",
  "compliance.limitType.range.hint": "符合下限至上限范围",
  "compliance.limitType.borderline": "边缘型（提示）",
  "compliance.limitType.borderline.hint": "提示区域：触发复核标记，而非不合格",
  "compliance.limitType.descriptive": "定性 / 描述性",
  "compliance.limitType.descriptive.hint": "由分析师评估的文本值",
  "compliance.selectMap.editHeading": "合规映射",
  "compliance.selectMap.hint": "将每个结果选项与其合规状态进行映射。这些选项来自检测目录。",
  "compliance.selectMap.option": "结果选项",
  "compliance.selectMap.status": "合规状态",
  "compliance.selectMap.preview": "预览",
  "compliance.selectMap.badge": "值映射",
  "compliance.selectMap.optionsLabel": "选项已映射",
  "compliance.selectMap.statusForOption": "{option} 的合规状态",
  "compliance.status.compliant": "符合要求",
  "compliance.status.borderline": "临界",
  "compliance.status.nonCompliant": "不符合要求",
  "compliance.status.compliantWithIcon": "符合要求 ✓",
  "compliance.status.borderlineWithIcon": "临界 ⚑",
  "compliance.status.nonCompliantWithIcon": "不符合要求 ✗",
  "compliance.linkedTest.noLimits": "未配置限值",
  "compliance.threshold.savedThresholds": "合规阈值已关联到该检测。",
  "compliance.threshold.savedValueMap": "已保存值映射阈值。",
  "compliance.threshold.savedPartialError": "某些阈值无法保存。请检查已高亮显示的行。",
  "compliance.threshold.unlinked": "已解除阈值与该检测的关联。",
  "compliance.threshold.unlinkError": "无法解除此阈值的关联。",
  "notification.title.success": "成功",
  "notification.title.error": "错误",
  "sidenav.label.admin.vectorSurveillance": "病媒监测",
  "vector.admin.title": "病媒监测系统的设置中",
  "vector.admin.groups": "生物体类群",
  "vector.admin.group.code": "位置代码",
  "vector.admin.group.label": "标签",
  "vector.admin.group.colorTag": "颜色标签",
  "vector.admin.group.description": "描述",
  "vector.admin.active": "活跃",
  "vector.admin.system": "系统",
  "vector.admin.trapTypes": "诱捕器类型",
  "vector.admin.trapType.name": "名称",
  "vector.admin.trapType.description": "描述",
  "vector.admin.species": "物种",
  "vector.admin.selectGroup": "在左侧选择一个组，以管理该组的陷阱类型和物种。",
  "vector.admin.newGroup": "新群组（未保存）",
  "vector.admin.newTrapType": "新诱捕器类型",
  "vector.admin.newSpecies": "新物种",
  "vector.admin.saveGroup": "保存组",
  "vector.admin.saveTrap": "保存诱捕器",
  "vector.admin.saveSpecies": "保存物种",
  "vector.admin.addGroup": "+ 添加群组",
  "vector.admin.addTrapType": "+ 添加诱捕器类型",
  "vector.admin.addSpecies": "+ 添加物种",
  "vector.admin.locked": "已锁定",
  "vector.admin.systemGroup": "系统受保护组",
  "vector.admin.systemGroup.desc": "该代码已被锁定，因为核心报告和初始数据引用了此组。您仍可编辑标签、颜色和描述。",
  "vector.admin.usedBy": "由……使用",
  "vector.admin.status": "状态",
  "vector.admin.status.active": "活跃",
  "vector.admin.status.inactive": "非活跃",
  "vector.admin.group": "生物类群",
  "vector.admin.trapType.group": "目标生物群",
  "vector.admin.trapType.groups": "生物体类群",
  "vector.admin.trapType.sampleTypes": "样本类型",
  "vector.admin.sampleType": "样本类型",
  "vector.admin.search.groups": "按代码或标签搜索...",
  "vector.admin.search.traps": "搜索诱捕器名称或描述...",
  "vector.admin.search.species": "搜索属或种……",
  "vector.admin.samplingSites": "样本点",
  "vector.admin.samplingSite.newSite": "新站点",
  "vector.admin.samplingSite.allSites": "所有站点",
  "vector.admin.samplingSite.code": "代码",
  "vector.admin.samplingSite.name": "站点名称",
  "vector.admin.samplingSite.type": "站点类型",
  "vector.admin.samplingSite.region": "区域",
  "vector.admin.samplingSite.district": "地区",
  "vector.admin.samplingSite.contactName": "联系人",
  "vector.admin.samplingSite.contactPhone": "联系电话",
  "vector.admin.samplingSite.gpsLatitude": "GPS纬度",
  "vector.admin.samplingSite.gpsLongitude": "GPS经度",
  "vector.admin.samplingSite.environmentalZone": "环境区域",
  "vector.admin.samplingSite.address": "地址",
  "vector.admin.samplingSite.description": "描述",
  "vector.admin.samplingSite.source": "来源",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "最近采集",
  "vector.admin.samplingSite.search": "按代码、名称、区域等搜索...",
  "vector.admin.samplingSite.saveSite": "保存站点",
  "vector.admin.samplingSites.registry": "采样点登记册",
  "vector.admin.samplingSite.deactivate": "停用",
  "vector.admin.samplingSite.activate": "激活",
  "vector.admin.samplingSite.location": "位置",
  "vector.admin.samplingSite.allTypes": "所有类型",
  "vector.admin.samplingSite.subtype": "子类型",
  "vector.admin.samplingSite.subtype.placeholder": "例如：河流、水井、BG-Sentinel、固定站",
  "vector.admin.samplingSite.city": "城市",
  "vector.admin.samplingSite.addressLocation": "地址位置",
  "vector.admin.samplingSite.addressSearch.placeholder": "搜索位置以自动填充下拉菜单……",
  "vector.admin.samplingSite.gpsCoordinates": "GPS信息",
  "vector.admin.samplingSite.lastModified": "最后修改",
  "label.noResults": "未找到结果",
  "vector.admin.addSite": "+ 新站点",
  "vector.order.title": "新建病媒订单",
  "vector.order.subtitle": "实验室单元：病媒监测实验室，病媒领域已启用。",
  "vector.order.samplingSite": "样本采样点",
  "vector.order.site.code": "站点代码",
  "vector.order.site.helper": "搜索结果中仅显示处于活跃状态的监测站点。GPS坐标已根据站点记录预先填入。",
  "vector.order.site.name": "站点名称",
  "vector.order.site.placeholder": "按站点名称或代码搜索...",
  "vector.order.site.type": "站点类型",
  "vector.order.specimen": "标本",
  "vector.order.organism": "动物 / 生物体",
  "vector.order.organism.hint": "通用名称——例如：蚊子、蜱、啮齿动物、沙蝇。",
  "vector.order.organism.placeholder": "搜索生物体或物种……",
  "vector.order.quantity": "数量",
  "vector.order.quantity.hint": "该水池中的生物体数量。",
  "vector.order.requester.section": "请求者 / 订购项目",
  "vector.order.requester": "请求者",
  "vector.order.requester.placeholder": "按机构名称或代码搜索...",
  "vector.order.panels": "订单面板",
  "vector.order.panels.search": "选择可用面板",
  "vector.order.tests": "订单检测",
  "vector.order.tests.search": "选择可用检测",
  "vector.order.collectionContext": "采集背景（可选：生态习性数据采集）",
  "vector.order.timeOfDay": "时段",
  "vector.order.timeOfDay.dawn": "黎明",
  "vector.order.timeOfDay.day": "白天",
  "vector.order.timeOfDay.dusk": "黄昏",
  "vector.order.timeOfDay.night": "夜晚",
  "vector.order.restingContext": "栖息环境",
  "vector.order.restingContext.outdoor": "户外（外栖性）",
  "vector.order.restingContext.indoor": "室内（喜室内环境）",
  "vector.order.restingContext.peridomestic": "家宅周边",
  "vector.order.humanBitingCatch": "人诱叮咬捕获",
  "vector.order.humanBitingCatch.hint": "该标本来自人诱停落采集",
  "vector.order.collectionNotes": "采集备注",
  "vector.order.collectionNotes.placeholder": "天气、诱捕器状况、异常情况……",
  "vector.admin.group.code.placeholder": "例如，SANDFLY",
  "vector.admin.group.label.placeholder": "例如，沙蝇",
  "vector.species.genus.placeholder": "例如，Mansonia",
  "vector.species.species.placeholder": "例如，uniformis",
  "vector.species.subspecies.placeholder": "例如，diardii",
  "vector.species.genus": "属",
  "vector.species.species": "物种",
  "vector.species.subspecies": "亚种",
  "vector.species.pathogensOfInterest": "重点关注的病原体",
  "vector.species.lifecycleStages": "生命周期阶段",
  "vector.species.pathogenCategory": "病原体类别",
  "vector.species.lifecycleCategory": "生命周期类别",
  "workflow.vector": "病媒监测",
  "vector.sampleType": "样本类型",
  "vector.organismGroup": "生物类群",
  "vector.species": "物种",
  "vector.animalOrganism": "动物/生物体",
  "vector.animalOrganism.add": "添加动物/生物体",
  "vector.animalOrganism.remove": "移除动物/生物体",
  "vector.collectedVolume": "混样中的数量",
  "vector.lifecycleStage": "生命周期阶段",
  "vector.trapCount": "已布设诱捕器",
  "vector.trapNights": "布设夜数",
  "vector.trapType": "诱捕器类型",
  "vector.poolingMethod": "池化方法",
  "vector.poolCount": "池的数量",
  "vector.samplesPerPool": "每组标本数量",
  "vector.totalSpecimens": "标本总数",
  "vector.pathogensOfInterest": "重点关注的病原体",
  "vector.homogeneous": "均质",
  "vector.random": "随机",
  "vector.collectionSite": "回收点",
  "vector.collectionSiteName": "回收点站点名称",
  "vector.gpsLatitude": "GPS纬度",
  "vector.gpsLongitude": "GPS经度",
  "patient.search.merged.tag": "已合并",
  "patient.merged.banner.title": "该患者记录已合并",
  "patient.merged.banner.subtitle": "有效记录保留在患者 {target} 下。",
  "patient.merged.banner.subtitle.noTarget": "该记录已与另一位患者的记录合并。",
  "admin.testCatalog.tabs.ariaLabel": "检测项目详细信息选项卡",
  "admin.testCatalog.tabs.details": "详情",
  "admin.testCatalog.tabs.labels": "标签",
  "admin.testCatalog.labels.masterOverride.label": "允许在订单录入中覆盖",
  "admin.testCatalog.labels.masterOverride.on": "手动输入已开启",
  "admin.testCatalog.labels.masterOverride.off": "手动输入已关闭",
  "admin.testCatalog.labels.linkedPresets.title": "关联标签预设",
  "admin.testCatalog.labels.linkedPresets.empty": "未关联任何标签预设。请使用下方的下拉菜单添加一个。",
  "admin.testCatalog.labels.col.presetName": "预设名称",
  "admin.testCatalog.labels.col.defaultQty": "默认数量",
  "admin.testCatalog.labels.col.maxQty": "最大数量",
  "admin.testCatalog.labels.col.allowOverride": "允许覆盖",
  "admin.testCatalog.labels.col.actions": "操作",
  "admin.testCatalog.labels.action.remove": "移除预设链接",
  "admin.testCatalog.labels.addPreset.label": "添加标签类型",
  "admin.testCatalog.labels.addPreset.placeholder": "选择标签预设",
  "admin.testCatalog.labels.preview.title": "订单录入预览",
  "admin.testCatalog.labels.preview.col.locked": "锁定",
  "admin.testCatalog.labels.preview.locked": "锁定",
  "admin.testCatalog.labels.preview.unlocked": "可编辑",
  "admin.testCatalog.labels.save.success": "标签配置已保存。",
  "admin.testCatalog.labels.save.error": "标签配置保存失败。",
  "orderEntry.labels.orderTable.title": "订单标签",
  "orderEntry.labels.sampleTable.title": "样本标签",
  "orderEntry.labels.col.row": "行",
  "orderEntry.labels.col.sample": "样本",
  "orderEntry.labels.col.quantity": "数量",
  "orderEntry.labels.orderRow.header": "订单",
  "orderEntry.labels.sampleRow.header": "样本 {number}",
  "orderEntry.labels.input.sample": "样本 {number} {column} 数量",
  "orderEntry.labels.input.sampleNamed": "{sample} {column} quantity",
  "orderEntry.labels.source.test": "来自检测",
  "orderEntry.labels.source.presetDefault": "预设默认值",
  "orderEntry.labels.source.saved": "已保存",
  "orderEntry.labels.locked.tooltipFor": "{label} 已被检测配置锁定，无法更改。",
  "orderEntry.labels.total": "标签总数：{total}",
  "orderEntry.labels.heading": "标签",
  "orderEntry.labels.title": "标签",
  "orderEntry.labels.printRow": "打印{label}的标签",
  "orderEntry.labels.printColumn": "打印所有{label}标签",
  "orderEntry.labels.printAll": "打印所有标签",
  "orderEntry.labels.pendingSave": "保存后打印",
  "orderEntry.labels.empty": "在上方添加样本以查看其标签。",
  "orderEntry.labels.loadFailed": "无法从预设中加载标签数量。",
  "orderEntry.labels.printFailed": "无法生成标签。",
  "orderEntry.labels.printFailed.detail": "服务器返回 {status}。",
  "orderEntry.labels.printFailed.unreachable": "无法连接服务器。",
  "orderEntry.labels.nothingToPrint": "此选择未配置任何标签。",
  "orderEntry.labels.downloaded": "打印窗口被拦截，标签已改为下载。",
  "orderEntry.labels.retry": "重试",
  "label.patientHistory.filterByCategory": "按检测类别筛选",
  "label.patientHistory.testCategories": "检测类别",
  "label.patientHistory.tree": "树",
  "label.patientHistory.showTree": "显示树形图",
  "label.patientHistory.resetTree": "重置树",
  "label.patientHistory.viewResults": "查看 {count} 个结果",
  "label.patientHistory.emptyState": "该患者没有可显示的{displayText}",
  "label.patientHistory.record": "记录 {displayText}",
  "label.patientHistory.dataLoadError": "数据加载错误",
  "label.patientHistory.errorCopy": "抱歉，显示此信息时出现了一些问题。您可以尝试重新加载页面，或联系网站管理员并提供上述错误代码。",
  "label.patientHistory.backToTimeline": "返回时间轴",
  "label.patientHistory.returnToTimeline": "返回时间轴",
  "label.patientHistory.timeOfTest": "检测时间",
  "label.patientHistory.observations": "观察结果",
  "label.patientHistory.range.oneDay": "1天",
  "label.patientHistory.range.fiveDays": "5天",
  "label.patientHistory.range.oneMonth": "1个月",
  "label.patientHistory.range.sixMonths": "6个月",
  "label.patientHistory.range.oneYear": "1年",
  "label.patientHistory.range.fiveYears": "5年",
  "label.patientHistory.range.all": "所有分析仪",
  "label.patientHistory.date": "日期",
  "address.search.no.results": "未找到“{term}”的地址",
  "address.search.placeholder": "搜索地址（请输入至少2个字符）...",
  "address.search.results.count": "找到 {count} 条结果",
  "alert.error": "错误",
  "alert.warning": "警告",
  "analyzer.errorDetails.noLogsAvailable": "没有日志可用",
  "analyzer.fieldSelector.placeholder": "搜索并选择字段...",
  "analyzer.fieldSelector.title": "选择 OpenELIS 字段",
  "analyzer.form.columnMappings": "列映射（JSON）",
  "analyzer.form.columnMappings.helperText": "将文件中的列名称映射到内部字段名称",
  "analyzer.form.delimiter": "分隔符",
  "analyzer.form.fileFormat": "文件格式",
  "analyzer.form.fileImport.title": "文件导入设置",
  "analyzer.form.filePattern": "文件名模式",
  "analyzer.form.filePattern.helperText": "用于匹配结果文件的Glob模式",
  "analyzer.form.hasHeader": "文件包含表头行",
  "analyzer.form.importDirectory": "导入目录",
  "analyzer.form.importDirectory.helperText": "桥接器监听传入结果文件的目录",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "列映射必须是有效的 JSON",
  "analyzer.form.validation.importDirectory.required": "基于文件的分析仪需要导入目录",
  "analyzer.form.validation.port.invalid": "端口号必须是1到65535之间的一个数字（简体中文（大陆））",
  "analyzer.qc.batch.failure.subtitle": "该批次中的质控品存在失败项。在接受患者结果之前，请先复核下方的质控结果。",
  "analyzer.qc.batch.failure.title": "质控品失败",
  "analyzer.qc.controls.hidden": "质控品已从患者视图中隐藏",
  "analyzer.qc.controls.section.title": "质控品（{count}）",
  "audittrail.table.heading": "订单信息",
  "barcode.label.info.labnumber": "实验室编号",
  "button.close": "关闭",
  "button.collapse": "折叠",
  "button.expand": "展开",
  "button.home": "首页",
  "button.new.search": "新搜索",
  "column.name.labNo": "实验室编号",
  "env.collectionConditions.helper": "搜索现有采样点或创建新的采样点。采样点可在不同订单中重复使用——就像临床工作流程中的患者一样。",
  "env.collectionMethod.placeholder": "例如：随机样本、24小时混合样本",
  "env.conditions": "环境条件",
  "env.conditions.placeholder": "例如：20°C，晴天，旱季",
  "env.regulatoryReference": "监管参考",
  "env.regulatoryReference.placeholder": "例如，第22/2021号总统令《水质》",
  "env.samplingSite.title": "主题 — 采样点",
  "env.site.address": "地址",
  "env.site.addressSearch.placeholder": "搜索位置以自动填充下方的下拉菜单……",
  "env.site.code": "站点位置代码",
  "env.site.code.placeholder": "自动生成（或手动输入）",
  "env.site.contactPerson": "联系人",
  "env.site.contactPerson.placeholder": "网站管理员或联系人的名称",
  "env.site.contactPhone": "联系电话",
  "env.site.description": "站点描述",
  "env.site.description.placeholder": "例如，水闸下游附近的监测点",
  "env.site.helperText": "注册一个新的采样点。该采样点将保存在“采样点注册表”中，并可在今后的订单中重复使用。",
  "env.site.name": "站点名称",
  "env.site.name.placeholder": "例如，西里旺河——芒加莱",
  "env.site.newTab": "新网站",
  "env.site.saveAndSelect": "保存并选择站点",
  "env.site.searchLabel": "站点名称",
  "env.site.searchPlaceholder": "例如，西里旺河——曼加拉伊",
  "env.site.searchTab": "站内搜索",
  "env.site.streetAddress": "地址",
  "env.site.streetAddress.placeholder": "街道地址或位置参考",
  "env.site.subtype": "亚型",
  "env.site.subtype.placeholder": "例如：河流、水井、BG-Sentinel、固定站",
  "env.site.type": "场地类型",
  "env.site.type.select": "选择设备类型...",
  "env.site.zone": "环保区",
  "env.site.zone.select": "选择区域...",
  "error.dateRange.start": "请选择开始日期和结束日期。",
  "error.loading.metrics": "加载指标时出错",
  "error.nonconform.report.data.found": "没有找到数据",
  "error.report.csv.dateType": "请选择日期类型。",
  "error.required.fields": "请填写所有必填项",
  "error.save.sample": "保存样本时发生错误",
  "error.validation.failed": "验证失败",
  "error.value": "请选择一个值。",
  "esig.context.saveResults": "保存 {count} 中与登记号 {accession} 相关的结果",
  "esig.context.saveResultsMulti": "保存{accessionCount}中各种质资源的{count}结果",
  "esig.context.validateResults": "验证 {count} 网站中编号为 {accession} 的结果",
  "esig.context.validateResultsMulti": "验证{count}在{accessionCount}各接穗中的结果",
  "fhir.questionnaire.title": "附加信息",
  "genericSample.default.fields.title": "样本信息",
  "genericSample.import.success": "导入成功",
  "genericSample.notebook.label": "选择笔记本",
  "genericSample.order.newOrder": "创建另一个样本",
  "genericSample.search.title": "按订单号搜索",
  "http.success": "成功！",
  "label.button.assign": "分配",
  "label.button.create": "创建",
  "label.button.saving": "保存中...",
  "label.button.view": "查看报告",
  "label.code": "代码",
  "label.editing": "正在编辑",
  "label.label": "标签",
  "label.name": "名称",
  "label.panel": "面板",
  "label.tests": "检测项目",
  "loading.label": "加载中...",
  "loading.metrics": "正在加载指标...",
  "locale.save.error": "保存语言失败",
  "logging.management.tail.clear": "清除位置",
  "logging.management.tail.disconnected": "日志流已断开。请关闭后重新打开以重新连接。",
  "logging.management.tail.label": "实时应用程序日志",
  "logging.management.tail.off": "手动输入已关闭",
  "logging.management.tail.on": "手动输入已开启",
  "logging.management.tail.stream": "实时流",
  "nationalID.title": "国家ID",
  "nce.button.linkSelected": "关联所选样本",
  "nce.button.submit": "提交 NCE",
  "nce.error.numberGeneration": "无法生成NCE编号。请重试。",
  "nce.error.unknownOrder": "No order has the lab number {0}.",
  "nce.field.dateOfEvent": "事件日期",
  "nce.field.description": "描述",
  "nce.field.nceNumber": "NCE 数字",
  "nce.field.proposedAction.helper": "与在纠正措施工作流中分配的CAPA措施分开处理",
  "nce.field.proposedAction.placeholder": "建议的下一步操作...",
  "nce.field.reporterName": "报告人姓名",
  "nce.field.reportingUnit": "报告单元",
  "nce.field.subcategory": "子类别",
  "nce.field.suspectedCauses.helper": "仅为初步评估——正式的根本原因将在调查过程中确定",
  "nce.field.suspectedCauses.placeholder": "报告人",
  "nce.form.subtitle": "记录质量事件，并关联相关样本和结果",
  "nce.form.title": "报告不符合事件",
  "nce.linkSamples.helper": "搜索上面的订单，将样本与该NCE关联。此步骤为可选操作。",
  "nce.section.attachments": "附件",
  "nce.section.classification": "分类",
  "nce.section.details": "详情",
  "nce.section.linkSamples": "关联样本/结果（可选）",
  "nce.section.reporterContext": "报告人与事件背景",
  "nce.select.subcategory": "选择子类别...",
  "nce.severity.critical.desc": "患者安全风险、违反法规",
  "nce.severity.major.desc": "对质量或运营产生重大影响",
  "nce.severity.minor.desc": "影响有限，易于纠正",
  "nonconform.corrective.requiredFields": "请填写所有纠正措施字段（措施、负责人、完成日期以及至少一种措施类型），或者将该行完全留空。",
  "nonconform.view.requiredFields": "“实验室组件”、“NCE类别”、“NCE类型”、“严重程度与后果”以及“复发情况”均为必填项。",
  "notebook.sample.create": "创建",
  "notebook.sample.create.title": "创建新样本",
  "notebook.sample.edit": "编辑",
  "notebook.sample.edit.title": "编辑样本",
  "notebook.sample.import": "导入",
  "notebook.sample.import.title": "导入样本",
  "notebook.sample.order.info": "该样本将与当前笔记本相关联。",
  "notebook.sample.order.title": "为笔记本创建样本",
  "notification.warning": "警告",
  "order.entry.setup.batch": "批量订单录入",
  "order.legend.patient1": "患者信息",
  "pagination.next": "下一页",
  "pagination.previous": "上一页",
  "patient.fetch.error": "无法加载患者信息。患者ID可能无效，或者无法连接到服务器。",
  "patient.firstName": "名",
  "patient.lastName": "姓",
  "print.barcode.all": "打印所有条码（{count}）",
  "sample.item.id": "样本项目编号",
  "sample.label": "样本",
  "sample.noPanels": "此样本类型无面板可用",
  "sample.noTests": "此样本类型暂无可用检测项目",
  "sample.testsLoadFailed": "无法加载此样本类型的检测。",
  "sample.noTestsMatchSearch": "没有与搜索匹配的检测",
  "sample.noPanelsMatchSearch": "没有与搜索匹配的面板",
  "sample.selectType.first": "请在上方选择样本类型，查看可用的检测面板和检测项目",
  "sample.testsCount": "{count} 项可用检测",
  "sample.types": "样本",
  "sample.referral.listsFailed": "无法加载转诊原因或实验室。您输入的所有内容均已保留；请按“重试”以转诊检测。",
  "sample.tests.loadFailed": "无法加载{sampleType}的检测。",
  "sample.tests.loadFailed.hint": "您输入的所有内容均已保留。请检查连接或重新登录，然后按“重试”。",
  "sample.tests.loading": "正在加载检测…",
  "save.error.msg": "保存时出错",
  "saving.label": "保存中...",
  "select.label.analyzer": "选择分析仪",
  "site.code": "代码",
  "steps.complete": "步骤",
  "storage.audit.empty": "目前尚未记录到该样本的任何移动情况。",
  "storage.audit.empty.title": "无移动记录",
  "storage.audit.fetch.error": "无法加载审计跟踪。",
  "storage.audit.fetch.error.title": "错误",
  "storage.audit.from": "来源",
  "storage.audit.movedBy": "移动人",
  "storage.audit.movementDate": "移动日期",
  "storage.audit.reason": "理由",
  "storage.audit.to": "到",
  "storage.box.code.helper": "最多 10 个字符",
  "storage.confirm.disposal": "确认处置",
  "storage.dashboard.title": "存储",
  "storage.disposal.method": "处置方法",
  "storage.disposal.method.placeholder": "选择方法...",
  "storage.disposal.notes": "备注（可选）",
  "storage.disposal.notes.placeholder": "请输入任何其他备注……",
  "storage.disposal.reason": "处置原因",
  "storage.disposal.reason.placeholder": "选择原因...",
  "storage.dispose.confirmation": "我确认希望永久处置该样本。此操作无法撤销。",
  "storage.dispose.error": "处置失败",
  "storage.dispose.instructions.subtitle": "请确保按照实验室安全规程执行正确的处置程序。",
  "storage.dispose.instructions.title": "处置说明",
  "storage.dispose.location.note": "处置时，将从该位置移除样本",
  "storage.dispose.sample": "处置样本",
  "storage.dispose.sample.subtitle": "永久处置样本 {sampleId}",
  "storage.dispose.warning.subtitle": "该样本将被标记为已处置，并从存储中移除。",
  "storage.dispose.warning.title": "此操作无法撤销",
  "storage.edit.heading": "编辑 {type}",
  "storage.edit.title": "编辑",
  "storage.editbox.heading": "编辑框",
  "storage.error": "错误",
  "storage.error.save": "保存失败",
  "storage.filter.select.location": "选择位置...",
  "storage.filter.selected": "已选择:",
  "storage.location.assigned.error": "无法分配位置",
  "storage.location.assigned.success": "位置已成功分配",
  "storage.location.created": "已创建{level}",
  "storage.location.deleted": "已删除{level}",
  "storage.location.no.results": "未找到任何位置",
  "storage.location.type.devices": "设备",
  "storage.location.type.racks": "货架",
  "storage.location.type.rooms": "房间",
  "storage.location.type.shelves": "架层",
  "storage.location.updated": "已更新{level}",
  "storage.manage.location": "管理位置",
  "storage.nav.rack": "货架",
  "storage.sample.actions": "样本操作",
  "storage.sampleitem.accession": "样本订单号",
  "storage.sampleitem.location": "存储位置",
  "storage.sampleitem.status": "状态",
  "storage.sampleitem.type": "设备类型",
  "storage.search.location.label": "搜索存储位置",
  "storage.search.location.placeholder": "输入 2 个及以上字符进行搜索……",
  "storage.skipRemaining": "跳过未分配样本的存储（{count}）——将立即处理",
  "storage.view.audit": "查看审计记录",
  "storage.view.audit.subtitle": "样本{sampleId}的移动历史",
  "storage.view.audit.title": "存储审计跟踪",
  "systemDefaultPayloadTemplate.messageTemplate": "消息模板",
  "systemDefaultPayloadTemplate.subjectTemplate": "主题模板",
  "tests.count": "{count, plural, other {项检测}}",
  "validation.invalid.ip": "IP地址格式无效（IPv4 或 IPv6）",
  "validation.invalid.port": "端口号必须在 1 到 65535 之间",
  "validation.required": "此字段为必填项",
  "common.accept": "接受",
  "common.accessionNumber": "订单号",
  "common.action": "操作",
  "common.actions": "操作",
  "common.active": "活跃",
  "common.addTests": "添加检测",
  "common.aliquots": "分装样本",
  "common.all": "所有分析仪",
  "common.allStatuses": "所有状态",
  "common.analyzer": "分析仪",
  "common.analyzers": "分析仪列表",
  "common.auditTrail": "审计跟踪",
  "common.back": "返回",
  "common.boxId": "箱子编号",
  "common.byUnit": "按单元",
  "common.cancel": "取消",
  "common.category": "类别",
  "common.clinical": "临床",
  "common.code": "代码",
  "common.collected": "已采样",
  "common.collectionDate": "采集日期",
  "common.complete": "完成",
  "common.completed": "已完成",
  "common.confirm": "确认",
  "common.correctiveActions": "纠正措施",
  "common.createAliquot": "创建分装样本",
  "common.critical": "紧急",
  "common.dashboard": "仪表板",
  "common.date": "日期",
  "common.dateRange": "日期范围",
  "common.deactivate": "停用",
  "common.delete": "删除",
  "common.description": "描述",
  "common.draft": "草稿",
  "common.edit": "编辑",
  "common.editOrder": "编辑订单",
  "common.email": "电子邮件",
  "common.enterResults": "录入结果",
  "common.error": "错误",
  "common.expired": "已过期",
  "common.exportPdf": "导出PDF",
  "common.failed": "失败数量",
  "common.filterByStatus": "状态",
  "common.firstName": "名",
  "common.from": "来源",
  "common.generateReport": "生成报告",
  "common.home": "首页",
  "common.inProgress": "进行中",
  "common.inactive": "非活跃",
  "common.labNumber": "实验室编号",
  "common.lastName": "姓",
  "common.loading": "加载中...",
  "common.location": "位置",
  "common.mean": "均值",
  "common.name": "名称",
  "common.nationalId": "国家ID",
  "common.new": "新",
  "common.none": "无",
  "common.normal": "正常",
  "common.normalRange": "正常范围",
  "common.notCompleted": "Not Completed",
  "common.notes": "备注",
  "common.order": "订单",
  "common.overdue": "已逾期",
  "common.panels": "检测面板",
  "common.participants": "参与者管理",
  "common.patient": "患者",
  "common.pending": "待处理",
  "common.position": "位置",
  "common.printLabel": "打印标签",
  "common.priority": "优先级",
  "common.program": "计划",
  "common.programName": "项目名称",
  "common.provider": "供应商",
  "common.quantity": "数量",
  "common.reason": "原因",
  "common.received": "已接收",
  "common.referenceLab": "参考实验室",
  "common.reject": "拒绝",
  "common.remove": "移除",
  "common.removeSelection": "移除{name}",
  "common.reports": "报告",
  "common.requester": "请求者",
  "common.result": "结果",
  "common.results": "结果",
  "common.room": "房间",
  "common.routine": "常规",
  "common.sample": "样本",
  "common.sampleId": "样本编号",
  "common.sampleManagement": "样本管理",
  "common.sampleType": "样本类型",
  "common.samples": "样本",
  "common.samplingSite": "样本采样点",
  "common.save": "保存",
  "common.saveFailed": "保存失败",
  "common.saving": "保存中...",
  "common.search": "搜索",
  "common.select": "选择",
  "common.severity": "严重程度",
  "common.siteName": "站点名称",
  "common.species": "物种",
  "common.standard": "标准",
  "common.status": "状态",
  "common.storageLocation": "存储位置",
  "common.study": "研究",
  "common.test": "检测",
  "common.testName": "检测名称",
  "common.tests": "检测项目",
  "common.type": "设备类型",
  "common.unit": "单位",
  "common.user": "用户",
  "common.value": "值",
  "common.view": "查看",
  "common.warning": "警告",
  "label.testCatalog.alerts.field.component": "结果组件",
  "label.testCatalog.alerts.field.componentHelp": "此警报监视的结果。若不进行设置，则监视该检测的所有组件。",
  "label.testCatalog.alerts.field.sampleType": "样本类型",
  "label.testCatalog.alerts.field.sampleTypeHelp": "此警报监控的样本。若不进行设置，则监控该检测项目运行的所有样本类型。",
  "label.testCatalog.alerts.scope.anyComponent": "任何组件",
  "label.testCatalog.alerts.scope.anySampleType": "任何样本类型",
  "label.testCatalog.alerts.col.scope": "适用范围",
  "label.testCatalog.alerts.scope.wholeTest": "完整检测",
  "microbiology.ast.breakpointStandard": "折点标准",
  "microbiology.ast.hint": "记录MIC或抑菌圈读数，复核判读结果，并就地记录覆盖操作。",
  "microbiology.ast.noOverride": "无覆盖",
  "microbiology.ast.reading": "AST读数",
  "microbiology.case.isolates.hint": "在AST之前，添加并鉴定具有临床意义的生长菌。",
  "microbiology.isolate.contaminant": "污染物",
  "microbiology.isolate.edit": "编辑分离株",
  "microbiology.isolate.identificationStatus": "鉴定状态",
  "microbiology.isolate.normalFlora": "正常菌群",
  "microbiology.isolate.organism": "生物体",
  "microbiology.isolate.organism.freeText": "以自由文本形式输入生物体名称",
  "microbiology.isolate.significant": "具有临床意义",
  "microbiology.isolate.unknown": "未知",
  "microbiology.isolate.update": "保存鉴定结果",
  "microbiology.enum.AST_REVIEW_REQUIRED": "需要进行AST复核",
  "microbiology.enum.AWAITING_RESULTS": "等待结果",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "需要抗生素映射",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "需结案",
  "microbiology.enum.AMENDED": "已修订",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "修改操作失败",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "培养协议已变更",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "修订已开启",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "修订历史加载失败",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "修订进行中",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "修订需进行新的AST运行",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "修订未开启",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "修订原因（必填）",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "修订需最终发布",
  "microbiology.enum.ACKNOWLEDGED": "已确认",
  "microbiology.enum.AMENDMENT_CANCELLED": "修订已取消",
  "microbiology.enum.AMENDMENT_OPENED": "修订已开启",
  "microbiology.enum.AMENDMENT_RELEASED": "修订已发布",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "修订来源 AST 必须为应报告项目",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "已确认分析仪标志",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "分析仪质控失败",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "已接收分析仪结果",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "AST 尝试原因（必填）",
  "microbiology.enum.AST_ENTRY": "AST 录入",
  "microbiology.enum.AST_IN_PROGRESS": "AST 进行中",
  "microbiology.enum.AST_READY": "已准备好进行AST",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "需重复或重新检测",
  "microbiology.enum.AST_REVIEW": "AST 复核",
  "microbiology.enum.AST_REVIEWED": "AST 已复核",
  "microbiology.enum.AST_READING_OVERRIDDEN": "AST 读数已覆盖",
  "microbiology.enum.AST_READING_RECORDED": "AST读数已记录",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "已选择应报告的AST",
  "microbiology.enum.AST_RUN_CREATED": "已创建 AST 运行",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST 运行已作废",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "AST 运行方法不匹配",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST 质控已覆盖",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "AST 设置不可用",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "需要对AST源运行进行复核",
  "microbiology.enum.ANALYZER": "分析仪",
  "microbiology.enum.BROTH_MICRODILUTION": "肉汤微量稀释法",
  "microbiology.enum.CASE": "案例",
  "microbiology.enum.CASE_CREATED": "案例已创建",
  "microbiology.enum.CASE_REVIEW": "案例复核",
  "microbiology.enum.CANCELLED": "已取消",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "具有临床意义",
  "microbiology.enum.CLOSED": "已关闭",
  "microbiology.enum.CONFIRMED": "已确认",
  "microbiology.enum.CONTAMINANT": "污染物",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "已确认紧急通报",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "紧急通报已关闭",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "已记录紧急通报",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "需要紧急随访",
  "microbiology.enum.DISK_DIFFUSION": "纸片扩散法",
  "microbiology.enum.EMAIL": "电子邮件",
  "microbiology.enum.EMERGENCY": "紧急情况",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "失败数量",
  "microbiology.enum.FINAL": "最终确定版",
  "microbiology.enum.FINAL_REPORT_RELEASED": "最终报告已发布",
  "microbiology.enum.GROWTH_DETECTED": "检测到生长",
  "microbiology.enum.HIGH": "高",
  "microbiology.enum.IDENTIFICATION": "鉴定",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "孵育中",
  "microbiology.enum.INPATIENT": "住院患者",
  "microbiology.enum.IN_PROGRESS": "进行中",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "当面",
  "microbiology.enum.INOCULATION_RECORDED": "已记录接种",
  "microbiology.enum.ISOLATE": "分离株",
  "microbiology.enum.ISOLATE_CREATED": "已创建分离株",
  "microbiology.enum.ISOLATE_ID": "分离株编号",
  "microbiology.enum.ISOLATE_REQUIRED": "需要分离株",
  "microbiology.enum.ISOLATE_UPDATED": "分离株已更新",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "未指定MIC技术",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "未指定抑菌圈技术",
  "microbiology.enum.MANUAL_NOTE": "手动备注",
  "microbiology.enum.MANUAL_ENTRY": "手动录入条目",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "无法记录接种审计",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "无法记录协议审计",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "选择其他协议",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "在选择协议之前分配工作流",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "传代培养来源必须属于本案例",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "无法记录工作流审计",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "确认保留现有工作",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "需对工作流进行分类",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "培养方法与工作流不兼容",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "不支持此工作流",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "此工作流已存在案例",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "选择其他工作流",
  "microbiology.enum.NO_GROWTH_READY": "无生长就绪",
  "microbiology.enum.NORMAL_FLORA": "正常菌群",
  "microbiology.enum.NEEDS_WORKFLOW": "需要工作流",
  "microbiology.enum.NOT_READY": "尚未准备好",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "已报告不符合项",
  "microbiology.enum.NONE": "无",
  "microbiology.enum.OPEN": "待处理",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "需要生物体映射",
  "microbiology.enum.ORGANISM": "生物体",
  "microbiology.enum.ORIGINAL": "原始",
  "microbiology.enum.OTHER": "其他原因",
  "microbiology.enum.OUTPATIENT": "门诊",
  "microbiology.enum.PENDING": "待处理",
  "microbiology.enum.PASSED": "通过",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "电话",
  "microbiology.enum.POSITIVE_SIGNAL": "阳性信号",
  "microbiology.enum.PRELIM_RELEASED": "初步报告已发布",
  "microbiology.enum.PRELIMINARY": "初步",
  "microbiology.enum.PRELIMINARY_RELEASED": "初步报告已发布",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "初步报告已发布",
  "microbiology.enum.QC_FAILED": "质控未通过",
  "microbiology.enum.RECEIVED": "已接收",
  "microbiology.enum.RELEASED": "已发布",
  "microbiology.enum.REPEAT": "重复",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "需要应报告的AST运行",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "必须复核应报告的AST运行",
  "microbiology.enum.RESULT": "结果",
  "microbiology.enum.RESULTS_IN": "已出结果",
  "microbiology.enum.RETEST": "重新检测",
  "microbiology.enum.REVIEW_READY": "已准备好复核",
  "microbiology.enum.REVIEWED": "已复核",
  "microbiology.enum.INTERMEDIATE": "中介",
  "microbiology.enum.LOST_SPECIMEN": "丢失的标本",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "丢失的标本——阳性培养结果",
  "microbiology.enum.NO_BREAKPOINT": "无折点",
  "microbiology.enum.RESISTANT": "耐药",
  "microbiology.enum.ROUTINE": "常规",
  "microbiology.enum.SAMPLE_ITEM": "样本项",
  "microbiology.enum.SETUP": "设置中",
  "microbiology.enum.SETUP_RECORDED": "已记录设置",
  "microbiology.enum.SMS": "短信",
  "microbiology.enum.SPECIMEN_LOST": "标本丢失",
  "microbiology.enum.STAGE_CHANGED": "阶段已切换",
  "microbiology.enum.SUBCULTURE_RECORDED": "已记录传代培养",
  "microbiology.enum.UNASSIGNED": "未分配",
  "microbiology.enum.UNKNOWN_ERROR": "未知错误",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "工作流已变更",
  "microbiology.enum.ZONE": "抑菌圈",
  "microbiology.enum.FINAL_RELEASED": "最终版已发布",
  "microbiology.enum.SUSCEPTIBLE": "敏感",
  "microbiology.enum.UNKNOWN": "未知",
  "rulebuilder.label.selectComponent": "选择组件",
  "testcalculation.label.selectComponent": "选择组件",
  "testcalculation.label.finalComponent": "结果组件",
  "qc.dashboard.tab.bench": "工作台质控",
  "qc.bench.source.all": "所有工作台来源",
  "qc.bench.source.manual": "手工定量",
  "qc.bench.source.rdt": "快速检测（RDT）",
  "qc.bench.column.runs": "已运行质控",
  "qc.bench.column.lastRun": "最近运行",
  "qc.bench.empty": "此期间内未记录任何手工或快速检测质控。",
  "microbiology.case.activityNote": "活动说明",
  "microbiology.case.accessionNumber": "实验室编号",
  "microbiology.case.actionError": "无法完成培养操作",
  "microbiology.case.action.markNoGrowth": "标记无生长结果就绪",
  "microbiology.case.action.recordGrowth": "记录检测到生长",
  "microbiology.case.action.rejectCase": "拒绝病例",
  "microbiology.case.action.setIncubating": "设为培养中",
  "microbiology.case.action.startInoculation": "开始接种",
  "microbiology.case.createIsolate": "创建分离株",
  "microbiology.case.cultureAction": "培养操作",
  "microbiology.case.atmosphere": "气体环境",
  "microbiology.case.eyebrow": "微生物学病例工作台",
  "microbiology.case.sectionExpanded": "{section} 已展开",
  "microbiology.case.sectionStatus": "分区状态",
  "microbiology.case.error": "微生物学案例错误",
  "microbiology.case.isolateLabel": "分离株标签",
  "microbiology.case.isolates": "分离株",
  "microbiology.case.isolates.empty": "未记录任何分离株",
  "microbiology.case.loadError": "无法加载微生物学案例",
  "microbiology.case.lastActivityBy": "最后操作人",
  "microbiology.case.incubation": "孵育",
  "microbiology.case.media": "培养基或培养瓶",
  "microbiology.case.nextStage": "下一个阶段",
  "microbiology.case.patient": "患者",
  "microbiology.case.nonconformanceCount": "{count, plural, other {# 个不符合事件}}",
  "microbiology.case.relatedWorkflows": "相关的标本工作流",
  "microbiology.case.requestingLocation": "请求位置",
  "microbiology.case.preliminaryOrganism": "初步鉴定生物体",
  "microbiology.case.recordActivity": "记录活动",
  "microbiology.case.sampleItem": "样本项",
  "microbiology.case.setup": "接种",
  "microbiology.case.setup.hint": "请记录该培养病例的初始设置、培养基或孵育步骤。",
  "microbiology.case.significance": "意义",
  "microbiology.case.specimenType": "标本类型",
  "microbiology.case.timeline": "病例时间线",
  "microbiology.case.timeline.addNote": "添加备注",
  "microbiology.case.timeline.auto": "自动",
  "microbiology.case.timeline.culturePurposeChange": "{from} 至 {to}",
  "microbiology.case.timeline.culturePurposeChanged": "培养目的已变更",
  "microbiology.case.timeline.empty": "未记录任何病例动态",
  "microbiology.case.timeline.hint": "记录在案的病例动态按时间顺序显示。",
  "microbiology.case.timeline.manual": "手动",
  "microbiology.case.timeline.note": "备注或观察",
  "microbiology.case.timeline.noteExpanded": "备注表单已展开",
  "microbiology.case.timeline.performedBy": "执行人：{actor}",
  "microbiology.case.timeline.saveNote": "保存备注",
  "microbiology.case.timeline.showAll": "显示全部 {count} 个事件",
  "microbiology.case.timeline.showRecent": "显示最近 {count} 个事件",
  "microbiology.case.events": "事件",
  "microbiology.case.finalLocked.message": "最终发布后，分离株和AST更改已被禁用。",
  "microbiology.case.finalLocked.title": "最终病例为只读",
  "microbiology.case.title": "微生物学案例",
  "microbiology.inoculation.addSubculture": "添加传代培养",
  "microbiology.inoculation.empty": "尚未记录任何培养基。请开始接种以启动培养。",
  "microbiology.inoculation.hint": "对每瓶或每块培养皿进行记录，并保留其培养系谱。",
  "microbiology.inoculation.identifier": "培养瓶或平板编号",
  "microbiology.inoculation.identifierHint": "扫描或输入标识符。",
  "microbiology.inoculation.parent": "上级培养基",
  "microbiology.inoculation.parentPlaceholder": "选择来源培养瓶或平板",
  "microbiology.inoculation.primaryExpanded": "接种表已展开",
  "microbiology.inoculation.primary": "主要",
  "microbiology.inoculation.recorded": "已记录的培养基",
  "microbiology.inoculation.save": "保存培养基",
  "microbiology.inoculation.source": "来源",
  "microbiology.inoculation.start": "开始接种",
  "microbiology.inoculation.subcultureExpanded": "传代培养表单已展开",
  "microbiology.inoculation.subculture": "传代培养",
  "microbiology.amendment.actionError": "无法完成修改操作",
  "microbiology.amendment.cancel": "取消修订",
  "microbiology.amendment.cancelReason": "取消原因",
  "microbiology.amendment.cancelled": "修改已取消；该最终案例再次被锁定",
  "microbiology.amendment.correctsVersion": "更正版本 {number}",
  "microbiology.amendment.hint": "在不替换其已发布版本历史记录的情况下，更正最终报告。",
  "microbiology.amendment.history": "修订历史",
  "microbiology.amendment.inProgress.message": "记录更正内容，并发布或取消此修订，以再次锁定该病例。",
  "microbiology.amendment.inProgress.title": "修订进行中",
  "microbiology.amendment.noReportVersions": "未记录任何最终报告版本",
  "microbiology.amendment.none": "未记录任何修订",
  "microbiology.amendment.number": "修订",
  "microbiology.amendment.numberValue": "修订 {number}",
  "microbiology.amendment.open": "开启修订",
  "microbiology.amendment.opened": "修订功能已开启；现已启用临床更正功能",
  "microbiology.amendment.reason": "修改原因",
  "microbiology.amendment.release": "发布修订后的报告",
  "microbiology.amendment.released": "修订版报告已发布；该病例再次被锁定",
  "microbiology.amendment.reportVersions": "已发布的报告版本",
  "microbiology.amendment.status": "状态",
  "microbiology.amendment.status.closed": "无已开启的修订",
  "microbiology.amendment.status.open": "修订已开启",
  "microbiology.amendment.title": "修订",
  "microbiology.amendment.version": "版本{number}",
  "microbiology.ast.antibiotic": "抗生素",
  "microbiology.ast.acceptResults": "接受结果",
  "microbiology.ast.acknowledgeFlags": "确认已复核的标记",
  "microbiology.ast.analyzer": "分析仪",
  "microbiology.ast.analyzerOrganism": "分析仪鉴定生物体：{organism}（{confidence}%）",
  "microbiology.ast.analyzerProvenance": "卡片或面板 {card} · 软件 {version}",
  "microbiology.ast.analyzerResolutionReason": "原因及纠正措施",
  "microbiology.ast.actionError": "无法完成 AST 操作",
  "microbiology.ast.adjustPanel": "调整面板",
  "microbiology.ast.orderedAntibiotics": "待检测的抗生素",
  "microbiology.ast.actions": "操作",
  "microbiology.ast.applyOverride": "应用覆盖",
  "microbiology.ast.attempt": "尝试",
  "microbiology.ast.attemptMethod": "尝试方法",
  "microbiology.ast.attemptNumber": "第 {number} 次尝试",
  "microbiology.ast.attemptReason": "理由",
  "microbiology.ast.attemptScope": "重复范围",
  "microbiology.ast.attempts": "AST 尝试次数",
  "microbiology.ast.attemptType": "尝试类型",
  "microbiology.ast.awaitingAnalyzerResults": "等待分析仪结果",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "当已连接的分析仪发送结果时，结果将自动显示。未匹配的事件将保留在“分析仪导入问题”中。",
  "microbiology.ast.awaitingSetupCount": "{count} 个待设置",
  "microbiology.ast.cardId": "卡或面板 ID",
  "microbiology.ast.entryMode": "结果录入",
  "microbiology.ast.entryMode.analyzer": "联网分析仪",
  "microbiology.ast.entryMode.manual": "手动输入",
  "microbiology.ast.expertFlags": "分析仪专家标记需要复核",
  "microbiology.ast.hideOriginal": "隐藏历史记录",
  "microbiology.ast.historyTo": "到",
  "microbiology.ast.interpretation": "解释",
  "microbiology.ast.instrumentInterpretation": "分析仪：{interpretation}",
  "microbiology.ast.invalidateAndRepeat": "作废并开始新的运行",
  "microbiology.ast.includedInReport": "已纳入报告",
  "microbiology.ast.initialAttemptReason": "首次尝试",
  "microbiology.ast.isolate": "分离株",
  "microbiology.ast.method": "方法",
  "microbiology.ast.matchedBy": "匹配的折点",
  "microbiology.ast.measurement.mic": "MIC（微克/毫升）",
  "microbiology.ast.measurement.zone": "抑菌圈直径（毫米）",
  "microbiology.ast.noBreakpointGuidance": "无标准折点。请根据当地标准操作规程（SOP）判读该读数。",
  "microbiology.ast.noBreakpointTitle": "需要本地判读",
  "microbiology.ast.noIsolate": "在记录AST之前创建分离株",
  "microbiology.ast.noSourceAttempt": "原始尝试",
  "microbiology.ast.notIncludedInReport": "不包括在内",
  "microbiology.ast.newAttempt": "新的重复检测或重新检测",
  "microbiology.ast.noRunsYet": "尚无运行记录",
  "microbiology.ast.antibioticToRepeat": "需重复检测的抗生素",
  "microbiology.ast.override": "覆盖判读",
  "microbiology.ast.overrideHistory": "覆盖历史记录",
  "microbiology.ast.optionsExpanded": "{section} 选项已展开。",
  "microbiology.ast.overrideReason": "覆盖原因",
  "microbiology.ast.orderedPanel": "已下单的AST面板",
  "microbiology.ast.organismMismatch": "分析仪鉴定的生物体与该病例的分离株不同",
  "microbiology.ast.organismMismatchDetail": "分析仪的鉴定结果仅供参考。请复核差异；以已确认的病例分离株为准。",
  "microbiology.ast.overrideQc": "覆盖质控标记",
  "microbiology.ast.panel": "AST 面板",
  "microbiology.ast.panelAdjustmentReason": "调整面板的原因",
  "microbiology.ast.panelProvenance.organismDefault": "按已鉴定生物体配置的默认面板下单",
  "microbiology.ast.rawValue": "结果值",
  "microbiology.ast.qcFailed": "分析仪质控失败",
  "microbiology.ast.qcFailedDetail": "质控参考编号：{reference}。在本次运行被作废或主管记录覆盖操作之前，无法接受结果。",
  "microbiology.ast.replacementCardId": "新的卡片或面板 ID",
  "microbiology.ast.resultsReady": "分析仪结果已就绪，可供复核",
  "microbiology.ast.resultsReadyDetail": "在接受这些结果之前，请复核其中的差异、缺失的折点以及专家标记。",
  "microbiology.ast.runsComplete": "{complete} / {total} 次运行已完成",
  "microbiology.ast.pendingIdentificationCount": "{count} 个待鉴定",
  "microbiology.ast.reasonForAttempt": "重复或重新检测的原因",
  "microbiology.ast.recordReading": "记录AST读数",
  "microbiology.ast.reviewRun": "复核 AST 运行",
  "microbiology.ast.repeat": "重复",
  "microbiology.ast.revertOverride": "恢复为原始版本",
  "microbiology.ast.revertReason": "撤销覆盖操作的原因",
  "microbiology.ast.reporting": "报告",
  "microbiology.ast.retest": "重新检测",
  "microbiology.ast.selectAntibiotic": "选择抗生素",
  "microbiology.ast.singleAntibiotic": "单一抗生素",
  "microbiology.ast.wholePanel": "整个面板",
  "microbiology.ast.runStatus": "AST 运行状态",
  "microbiology.ast.startRun": "开始 AST 运行",
  "microbiology.ast.startAttempt": "开始{type}尝试",
  "microbiology.ast.sourceAttempt": "来源",
  "microbiology.ast.source": "读数来源",
  "microbiology.ast.showOriginal": "显示原始记录",
  "microbiology.ast.title": "手动AST",
  "microbiology.ast.useAttemptForReporting": "使用第 {number} 次尝试进行报告",
  "microbiology.ast.useForReporting": "用于报告",
  "microbiology.ast.view": "查看",
  "microbiology.ast.viewAttempt": "查看尝试记录 {number}",
  "microbiology.ast.viewing": "正在查看",
  "microbiology.ast.viewingAttempt": "正在查看第 {number} 次尝试",
  "microbiology.critical.acknowledge": "确认",
  "microbiology.critical.followUp": "需要跟进",
  "microbiology.critical.hint": "记录紧急结果回电，并就地确认。",
  "microbiology.critical.log": "记录沟通",
  "microbiology.critical.logForIsolate": "为{isolate}记录紧急通知",
  "microbiology.critical.logNotification": "记录紧急通知",
  "microbiology.critical.method": "通信方式",
  "microbiology.critical.message": "消息",
  "microbiology.critical.messageRequired": "必须填写消息",
  "microbiology.critical.none": "未记录任何紧急通信",
  "microbiology.critical.recipient": "收件人",
  "microbiology.critical.recipientContact": "收件人联系方式",
  "microbiology.critical.required": "选择一个目标，并填写收件人和消息内容。",
  "microbiology.critical.resolution": "处理结果备注",
  "microbiology.critical.resolutionRequired": "在关闭沟通之前，必须提供处理结果备注。",
  "microbiology.critical.close": "关闭沟通",
  "microbiology.critical.target": "紧急结果对象",
  "microbiology.critical.targetId": "目标记录",
  "microbiology.critical.title": "紧急沟通",
  "microbiology.caseInfo.no": "否",
  "microbiology.caseInfo.notProvided": "未提供",
  "microbiology.caseInfo.summary": "病例信息摘要",
  "microbiology.caseInfo.yes": "是",
  "microbiology.currentStep.open": "打开 {step}",
  "microbiology.currentStep.title": "当前步骤",
  "microbiology.cultureAction.error": "无法更新培养状态。",
  "microbiology.cultureAction.noGrowth.confirm": "确认无生长",
  "microbiology.cultureAction.noGrowth.detail": "确认已完成规定的培养时间，且未检测到菌落生长。",
  "microbiology.cultureAction.noGrowth.title": "将培养标记为无生长",
  "microbiology.cultureAction.positive.confirm": "确认阳性信号",
  "microbiology.cultureAction.positive.detail": "确认阳性结果。下一个操作是进行传代培养并记录革兰氏染色结果。",
  "microbiology.cultureAction.positive.title": "将培养标记为阳性",
  "microbiology.nce.category": "类别",
  "microbiology.nce.configurationBlockerTitle": "需要进行配置",
  "microbiology.nce.configurationLoadError": "无法加载不符合事件类别和报告单元。",
  "microbiology.nce.critical": "紧急",
  "microbiology.nce.description": "描述",
  "microbiology.nce.disposition": "处置",
  "microbiology.nce.errorTitle": "无法报告不符合项",
  "microbiology.nce.flagOnly": "仅标记",
  "microbiology.nce.immediateAction": "立即措施",
  "microbiology.nce.lostTypeMissing": "当前的不符合事件配置中不包含“标本丢失”类型。",
  "microbiology.nce.major": "主要",
  "microbiology.nce.markLost": "标记为丢失",
  "microbiology.nce.markLostHint": "记录该实物标本为丢失，并拒绝受影响的未完成检测项目。",
  "microbiology.nce.markLostTitle": "标记标本丢失",
  "microbiology.nce.minor": "次要",
  "microbiology.nce.rejectTests": "拒绝受影响的检测项目",
  "microbiology.nce.retest": "重新检测AST",
  "microbiology.nce.retestLoadError": "无法加载已复核的AST运行结果。请在选择“重新检测AST”之前重试。",
  "microbiology.nce.sourceAstRun": "待重新检测的AST运行",
  "microbiology.nce.report": "报告不符合事件",
  "microbiology.nce.reportHint": "针对该标本记录一项不符合项，并选择其处置方式。",
  "microbiology.nce.reportingUnit": "报告单元",
  "microbiology.nce.reportTitle": "报告不符合项",
  "microbiology.nce.required": "请选择类别、报告单元和严重程度，并填写描述。",
  "microbiology.nce.sectionTitle": "不符合项",
  "microbiology.nce.severity": "严重程度",
  "microbiology.nce.submitError": "无法保存该不符合项。",
  "microbiology.nce.title": "标题",
  "microbiology.nce.type": "设备类型",
  "microbiology.isolate.identify": "鉴定生物体",
  "microbiology.isolate.reidentify": "重新鉴定",
  "microbiology.isolate.identified": "已鉴定",
  "microbiology.isolate.pending": "鉴定待处理",
  "microbiology.isolate.gramStain": "革兰氏染色",
  "microbiology.isolate.colonyMorphology": "菌落形态",
  "microbiology.isolate.identification": "鉴定",
  "microbiology.isolate.identificationMethod": "鉴定方法",
  "microbiology.isolate.identificationConfidence": "鉴定置信度（%）",
  "microbiology.isolate.identificationChange": "{previous} 改为 {next}：{reason}",
  "microbiology.isolate.identificationHistory": "鉴定历史",
  "microbiology.isolate.identificationReason": "重新鉴定的原因",
  "microbiology.isolate.organism.select": "选择一种生物体",
  "microbiology.isolate.unidentified": "未鉴定",
  "microbiology.ast.identificationRequired": "在进行抗菌药物敏感性试验（AST）前，应先鉴定该分离株。",
  "microbiology.next.createIsolate": "接种记录已登记。若出现显著生长，请添加记录；若无生长，请标记该样本，以便后续处理。",
  "microbiology.next.completeAmendment": "修订已开放。记录更正内容，复核报告，然后发布修订版。",
  "microbiology.next.finalReleased": "最终报告已发布。导出前请复核监测准备情况。",
  "microbiology.next.incubating": "孵育中。当出现生长迹象时，将该样本标记为阳性；当规定的孵育期完成时，标记为无生长。",
  "microbiology.next.subculturePositive": "检测到阳性信号。将培养瓶中的培养物进行传代培养，并记录革兰氏染色结果。",
  "microbiology.next.recordSetup": "已接收案例。记录初始设置，开始孵育。",
  "microbiology.next.release": "AST已完成复核。确认报告已准备就绪，并发布最终报告。",
  "microbiology.next.noGrowthRelease": "已记录无生长。请复核并发布最终阴性报告。",
  "microbiology.next.reviewAst": "已记录分离株。发布前请完成并复核AST。",
  "microbiology.next.title": "下一步",
  "microbiology.navigation.backToWorklist": "返回微生物学工作列表",
  "microbiology.navigation.menu": "微生物学",
  "microbiology.navigation.worklist": "微生物学工作清单",
  "order.context.workflowProgress": "订单工作流进度",
  "microbiology.culturePurpose.clinical": "临床诊断或治疗",
  "microbiology.culturePurpose.label": "培养目的",
  "microbiology.culturePurpose.screening": "主动筛查或携带状态检测",
  "microbiology.culturePurpose.unspecified": "未指定",
  "microbiology.orderDetail.antibioticExposure": "患者近期（2周内）曾使用过抗生素",
  "microbiology.orderDetail.admissionDate": "入院日期",
  "microbiology.orderDetail.admissionDateFuture": "入院日期不能是未来的时间。",
  "microbiology.orderDetail.admissionDateHelper": "住院日期。如不清楚，请留空。",
  "microbiology.orderDetail.admissionDateOutpatient": "门诊患者不纳入住院统计——按“社区来源”记录。",
  "microbiology.orderDetail.collectionDateContext": "采集日期：{date}",
  "microbiology.orderDetail.collectionTimingHospital": "入院后{days}天采集，监测中按医院来源计。",
  "microbiology.orderDetail.collectionTimingCommunity": "入院后{days}天采集，监测中按社区来源计。",
  "microbiology.orderDetail.clinicalHistory": "病史",
  "microbiology.orderDetail.cultureMethod": "培养协议",
  "microbiology.orderDetail.hint": "记录实验室进行培养准备和紧急结果随访所需的订单信息。",
  "microbiology.orderDetail.numberOfSets": "组数",
  "microbiology.orderDetail.numberOfSets.helper": "采样组，例如从不同部位采集的两套血培养样本。并非指标本的数量或体积。",
  "microbiology.orderDetail.patientOrigin": "患者来源",
  "microbiology.orderDetail.protocolDerived": "派生",
  "microbiology.orderDetail.protocolHelper": "来自订单中的检测。如果检验流程不同，请在工作台更改。",
  "microbiology.orderDetail.protocolUnset": "未设置，将由工作台选择协议",
  "microbiology.orderDetail.protocolUnsetTitle": "协议未设置",
  "microbiology.orderDetail.save": "保存订单详情",
  "microbiology.orderDetail.title": "订单详情",
  "microbiology.patientOrigin.emergency": "急诊科",
  "microbiology.patientOrigin.icu": "重症监护室",
  "microbiology.patientOrigin.inpatient": "住院病房",
  "microbiology.patientOrigin.other": "其他原因",
  "microbiology.patientOrigin.outpatient": "门诊部",
  "microbiology.progress.ast": "AST结果",
  "microbiology.progress.caseInfo": "病例信息",
  "microbiology.progress.inoculation": "接种",
  "microbiology.progress.isolates": "分离株",
  "microbiology.progress.reports": "报告",
  "microbiology.progress.review": "专家复核",
  "microbiology.progress.timeline": "时间轴",
  "microbiology.progress.title": "病例进度",
  "microbiology.protocol.noneTitle": "未设置协议",
  "microbiology.case.timeline.protocolChanged": "培养方案已从 {from} 更改为 {to}：{reason}",
  "microbiology.readiness.blocked": "最终发布被阻止",
  "microbiology.readiness.ready": "最终版本已准备发布",
  "microbiology.reagentLots.blocked": "已阻止：{reason}",
  "microbiology.reagentLots.context": "工作台场景",
  "microbiology.reagentLots.context.AST_SETUP": "AST 设置",
  "microbiology.reagentLots.context.CULTURE_SETUP": "培养设置",
  "microbiology.reagentLots.empty": "此检测未关联任何试剂。",
  "microbiology.reagentLots.fefo": "FEFO：优先使用",
  "microbiology.reagentLots.fifo.tooltip": "批次按到期日最早的顺序排列；若无法确定到期日，则按接收日期排序。",
  "microbiology.reagentLots.hint": "请为每个关联的试剂或耗材选择其确切的批号。",
  "microbiology.reagentLots.history": "记录的批号使用情况",
  "microbiology.reagentLots.legend": "{reagent} 的可用批次",
  "microbiology.reagentLots.lot": "批号",
  "microbiology.reagentLots.noExpiry": "未记录到期日",
  "microbiology.reagentLots.noLots": "该试剂目前无库存。",
  "microbiology.reagentLots.option": "{lot}，{quantity} {unit} 可用，有效期至 {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "每次检测的数量：{quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} 批次{lot}已过期；请选择其他批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} 批次{lot}的数量已不足；请选择另一个批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} 批次{lot}质控未通过；请选择质控已通过的批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} 批次{lot}未通过质控；请选择质控已通过的批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} 批次{lot}已不可用；请刷新并选择其他批次。",
  "microbiology.reagentLots.qc.FAILED": "质控未通过",
  "microbiology.reagentLots.qc.PASSED": "质控已通过",
  "microbiology.reagentLots.qc.PENDING": "质控待处理",
  "microbiology.reagentLots.qc.QUARANTINED": "质控隔离中",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "已消耗",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "已过期",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "非活跃",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "数量不足",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "质控未通过",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "质控未通过",
  "microbiology.reagentLots.reagent": "试剂或耗材",
  "microbiology.reagentLots.recorded": "已记录",
  "microbiology.reagentLots.role.PRIMARY": "主要",
  "microbiology.reagentLots.role.SECONDARY": "次要",
  "microbiology.reagentLots.scan.ambiguous": "该批号与多个关联试剂匹配。请在试剂列表中选择该批号。",
  "microbiology.reagentLots.scan.label": "扫描或输入批号",
  "microbiology.reagentLots.scan.notFound": "没有与该批号匹配的关联批次。",
  "microbiology.reagentLots.scan.placeholder": "扫描或输入确切的批号",
  "microbiology.reagentLots.scan.selected": "已选择批次{lot}。",
  "microbiology.reagentLots.status": "当前批次状态",
  "microbiology.reagentLots.status.ACTIVE": "活跃",
  "microbiology.reagentLots.status.CONSUMED": "已消耗",
  "microbiology.reagentLots.status.IN_USE": "使用中",
  "microbiology.reagentLots.title": "试剂和批次可追溯性",
  "microbiology.reagentLots.used": "使用数量",
  "microbiology.release.failed": "无法发布该报告。请查看相关要求，然后重试。",
  "microbiology.release.final": "发布最终报告",
  "microbiology.release.finalReleased": "最终报告已发布",
  "microbiology.release.hint": "仅在就绪检查通过后发布报告。",
  "microbiology.release.mappingConfigured": "已配置患者报告映射",
  "microbiology.release.mappingRequired": "最终发布需要患者报告映射",
  "microbiology.release.noReportableContent": "尚无可报告的微生物学内容。",
  "microbiology.release.notEvaluated": "尚未对准备情况进行评估",
  "microbiology.release.patientReport": "患者报告预览",
  "microbiology.release.preliminary": "发布初步报告",
  "microbiology.release.readinessChecks": "最终发布准备情况",
  "microbiology.release.title": "报告准备情况",
  "microbiology.release.viewPatientResults": "查看患者结果",
  "microbiology.release.useAmendment": "从“修订”中发布更正版本",
  "microbiology.release.whonetChecks": "WHONET 准备情况",
  "microbiology.whonet.blocked": "WHONET 导出被阻止",
  "microbiology.whonet.ready": "WHONET 已准备好导出",
  "microbiology.worklist.clearFilters": "清除筛选条件",
  "microbiology.worklist.column.action": "操作",
  "microbiology.worklist.column.context": "上下文",
  "microbiology.worklist.column.due": "应采取的操作",
  "microbiology.worklist.column.flags": "标记",
  "microbiology.worklist.column.isolate": "分离株",
  "microbiology.worklist.column.labNumber": "实验室编号",
  "microbiology.worklist.column.lastActivity": "最后操作人",
  "microbiology.worklist.column.organism": "生物体",
  "microbiology.worklist.column.panel": "面板",
  "microbiology.worklist.column.patient": "患者",
  "microbiology.worklist.column.priority": "优先级",
  "microbiology.worklist.column.sample": "样本项",
  "microbiology.worklist.column.specimen": "标本",
  "microbiology.worklist.column.stage": "阶段",
  "microbiology.worklist.column.started": "已开始",
  "microbiology.worklist.column.status": "状态",
  "microbiology.worklist.column.urgency": "紧迫性",
  "microbiology.worklist.critical": "紧急沟通",
  "microbiology.worklist.dueDetail.ast_entry": "针对已鉴定出的分离株设置AST。",
  "microbiology.worklist.dueDetail.ast_review": "复核已报告的药敏结果。",
  "microbiology.worklist.dueDetail.case_review": "复核报告就绪情况并发布。",
  "microbiology.worklist.dueDetail.isolate_id": "记录生长情况并鉴定分离株。",
  "microbiology.worklist.dueDetail.incubating": "第 {day} 天，共 {max} 天",
  "microbiology.worklist.dueDetail.setup": "记录初始培养设置。",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "进行传代培养，并记录革兰氏染色结果。",
  "microbiology.worklist.empty.ast": "没有匹配的AST运行记录。请清除搜索结果或选择其他状态。",
  "microbiology.worklist.empty.cultures": "没有匹配的培养。请清除搜索条件或选择其他状态。",
  "microbiology.worklist.expertRulesUnavailable": "OpenELIS 专家规则标记在第 1B 阶段可用。如有分析仪报告的标记，则会显示出来。",
  "microbiology.worklist.filters": "工作列表过滤器",
  "microbiology.worklist.filter.allActions": "所有操作",
  "microbiology.worklist.filter.allStages": "所有阶段",
  "microbiology.worklist.filter.allUrgencies": "所有紧急程度",
  "microbiology.worklist.filter.activeAst": "进行中的工作",
  "microbiology.worklist.filter.astStatus": "AST状态",
  "microbiology.worklist.filter.dueAction": "应采取的操作",
  "microbiology.worklist.filter.reviewed": "已复核",
  "microbiology.worklist.filter.stage": "阶段",
  "microbiology.worklist.filter.urgency": "紧迫性",
  "microbiology.worklist.flagsUnavailable": "专家规则（第1B阶段）",
  "microbiology.worklist.loadError.subtitle": "无法加载队列。请尝试刷新页面。",
  "microbiology.worklist.loadError.title": "无法加载微生物学工作单",
  "microbiology.worklist.editAst": "编辑 AST",
  "microbiology.worklist.grain.ast": "AST运行",
  "microbiology.worklist.grain.cultures": "培养",
  "microbiology.worklist.notSet": "未设置",
  "microbiology.worklist.notStarted": "待处理的订单",
  "microbiology.worklist.markLost": "标记为丢失",
  "microbiology.worklist.markNoGrowth": "标记为无生长",
  "microbiology.worklist.markPositive": "标记为阳性",
  "microbiology.worklist.openCase": "打开病例",
  "microbiology.worklist.newAstAttempt": "设置新的 AST 运行",
  "microbiology.worklist.newPositive": "新增阳性",
  "microbiology.worklist.phase1b": "将在第1B阶段提供",
  "microbiology.worklist.print": "打印列表",
  "microbiology.worklist.qcDashboard": "质控仪表板",
  "microbiology.worklist.queueStatus": "共享队列",
  "microbiology.worklist.refresh": "立即刷新",
  "microbiology.worklist.rowActions": "行操作",
  "microbiology.worklist.recentActivity.empty": "近期没有微生物学方面的活动。",
  "microbiology.worklist.recentActivity.title": "最近的活动（{count}）",
  "microbiology.worklist.resistance.hint": "分析仪报告的标记今天已完成处理；OpenELIS专家规则检测仍处于第1B阶段。",
  "microbiology.worklist.resistance.title": "今日耐药检出",
  "microbiology.worklist.search.ast": "搜索实验室编号、患者、分离株、生物体或检测面板",
  "microbiology.worklist.search.cultures": "搜索实验室编号、患者或标本",
  "microbiology.worklist.sharedQueue": "共享实验室队列",
  "microbiology.worklist.setupAst": "设置 AST",
  "microbiology.worklist.sort": "排序",
  "microbiology.worklist.sort.newest": "最新动态",
  "microbiology.worklist.sort.priority": "优先级",
  "microbiology.worklist.sort.workflow": "工作流",
  "microbiology.worklist.subtitle": "根据工作流阶段、紧急程度和所需的实验室操作，对培养病例进行优先级排序。",
  "microbiology.worklist.summary.astReview": "AST 复核",
  "microbiology.worklist.summary.astInProgress": "进行中",
  "microbiology.worklist.summary.astInQueue": "正在排队",
  "microbiology.worklist.summary.astPendingSetup": "待设置",
  "microbiology.worklist.summary.astResultsIn": "结果已出，待复核",
  "microbiology.worklist.summary.caseReview": "待病例复核",
  "microbiology.worklist.summary.critical": "未完成的紧急后续事项",
  "microbiology.worklist.summary.growthDetected": "检测到生长",
  "microbiology.worklist.summary.hint": "选择一个队列以更新病例列表。",
  "microbiology.worklist.summary.identification": "鉴定进行中",
  "microbiology.worklist.summary.incubating": "孵育中",
  "microbiology.worklist.summary.positive": "阳性",
  "microbiology.worklist.summary.expertFlags": "专家标记 (1B)",
  "microbiology.worklist.summary.title": "需要采取行动的工作",
  "microbiology.worklist.summary.totalPending": "待处理总数",
  "microbiology.worklist.table.hint": "病例按紧急程度和下一步所需操作排序。",
  "microbiology.worklist.table.astTitle": "AST运行",
  "microbiology.worklist.table.title": "未结微生物学病例",
  "microbiology.worklist.viewAudit": "查看审计报告",
  "microbiology.worklist.viewReviewedAst": "查看已复核的AST",
  "microbiology.worklist.whonetExport": "导出到 WHONET",
  "microbiology.worklist.surveillance.title": "监测范围",
  "microbiology.worklist.surveillance.description": "按报告期和结构化监测字段筛选AST行。操作队列过滤器不会改变导出数据集。",
  "microbiology.worklist.ast.automaticResults": "分析仪的结果会自动发送过来",
  "microbiology.worklist.ast.automaticResultsDetail": "已连接的仪器会将结果直接发送至病例。失败或无法匹配的事件将保留在“分析仪导入问题”中。",
  "microbiology.worklist.ast.awaitingResults": "等待分析仪结果",
  "microbiology.worklist.ast.pendingIdentification": "鉴定待处理",
  "microbiology.worklist.ast.resultsInBadge": "已出结果",
  "microbiology.worklist.title": "微生物学工作清单",
  "microbiology.worklist.updated": "{seconds}秒前更新 · 30秒自动刷新",
  "microbiology.admin.action.deactivate": "停用",
  "microbiology.admin.action.moveDown": "向下移动",
  "microbiology.admin.action.moveUp": "向上移动",
  "microbiology.admin.action.reactivate": "重新激活",
  "microbiology.admin.actions": "行操作",
  "microbiology.admin.antibiotics.add": "添加抗生素",
  "microbiology.admin.antibiotics.description": "AST 检测面板和折点规则使用的抗菌药物术语。",
  "microbiology.admin.antibiotics.edit": "抗生素",
  "microbiology.admin.antibiotics.title": "抗生素",
  "microbiology.admin.astPanels.add": "添加 AST 面板",
  "microbiology.admin.astPanels.antibiotic": "抗生素",
  "microbiology.admin.astPanels.behavior.always": "始终",
  "microbiology.admin.astPanels.behavior.cascade": "级联",
  "microbiology.admin.astPanels.behavior.resistant": "仅在耐药时",
  "microbiology.admin.astPanels.current": "当前",
  "microbiology.admin.astPanels.confirmDeactivate": "将版本 {version} 发布为不可用于新工作？现有 AST 运行将保留其原始面板版本。",
  "microbiology.admin.astPanels.confirmPublish": "发布版本 {version}？现有的 AST 运行将保留其原始面板版本。",
  "microbiology.admin.astPanels.confirmTitle": "确认面板发布",
  "microbiology.admin.astPanels.historical": "历史",
  "microbiology.admin.astPanels.loadingEditor": "正在加载 AST 面板管理界面。",
  "microbiology.admin.astPanels.publishVersion": "发布新版本",
  "microbiology.admin.astPanels.readOnly": "此历史版本为只读版本。请打开当前版本以发布更改。",
  "microbiology.admin.astPanels.reportBehavior": "报告行为",
  "microbiology.admin.astPanels.tier": "层级",
  "microbiology.admin.astPanels.title": "AST面板",
  "microbiology.admin.astPanels.version": "版本",
  "microbiology.admin.astPanels.versionNotice": "保存操作会创建一个新的面板版本；现有的 AST 运行将保留其原始版本。",
  "microbiology.admin.astPanels.viewVersion": "查看版本",
  "microbiology.admin.breakpoints.activate": "激活标准",
  "microbiology.admin.breakpoints.applyValid": "应用有效的行",
  "microbiology.admin.breakpoints.archive": "归档标准",
  "microbiology.admin.breakpoints.archiveConfirm": "该标准仍可用于历史 AST 运行，但不能被选用于新工作。",
  "microbiology.admin.breakpoints.back": "返回标准",
  "microbiology.admin.breakpoints.breakpointType": "折点类型",
  "microbiology.admin.breakpoints.chooseFile": "选择CSV文件",
  "microbiology.admin.breakpoints.correction.add": "添加本地修正",
  "microbiology.admin.breakpoints.correction.edit": "编辑本地修正",
  "microbiology.admin.breakpoints.count.imported": "{count} 已导入",
  "microbiology.admin.breakpoints.count.skipped": "{count} 已跳过",
  "microbiology.admin.breakpoints.count.unchanged": "{count} 未作更改",
  "microbiology.admin.breakpoints.count.valid": "{count} 有效",
  "microbiology.admin.breakpoints.csv": "折点 CSV",
  "microbiology.admin.breakpoints.description": "已加载的折点标准以及新 AST 运行所采用的版本。",
  "microbiology.admin.breakpoints.detail": "折点规则",
  "microbiology.admin.breakpoints.downloadRejected": "下载被拒绝的行",
  "microbiology.admin.breakpoints.effectiveDate": "生效日期",
  "microbiology.admin.breakpoints.import": "导入CSV",
  "microbiology.admin.breakpoints.intermediate": "中介",
  "microbiology.admin.breakpoints.intermediateLower": "中介下限",
  "microbiology.admin.breakpoints.intermediateUpper": "中介上限",
  "microbiology.admin.breakpoints.groupOption": "群组：{name}",
  "microbiology.admin.breakpoints.method.all": "所有方法",
  "microbiology.admin.breakpoints.method.zone": "抑菌圈",
  "microbiology.admin.breakpoints.organism": "生物体或群体",
  "microbiology.admin.breakpoints.organismGroup": "生物类群",
  "microbiology.admin.breakpoints.publisher": "发布机构",
  "microbiology.admin.breakpoints.resistant": "耐药",
  "microbiology.admin.breakpoints.rowError": "第{row}行",
  "microbiology.admin.breakpoints.rules": "规则",
  "microbiology.admin.breakpoints.source": "来源",
  "microbiology.admin.breakpoints.source.imported": "已导入",
  "microbiology.admin.breakpoints.source.local": "本地修正",
  "microbiology.admin.breakpoints.source.manual": "手动",
  "microbiology.admin.breakpoints.specimen": "标本上下文",
  "microbiology.admin.breakpoints.specimen.any": "任何标本",
  "microbiology.admin.breakpoints.status.active": "活跃",
  "microbiology.admin.breakpoints.status.archived": "归档",
  "microbiology.admin.breakpoints.status.loaded": "已加载",
  "microbiology.admin.breakpoints.susceptible": "敏感",
  "microbiology.admin.breakpoints.title": "折点标准",
  "microbiology.admin.breakpoints.units": "单位",
  "microbiology.admin.breakpoints.view": "查看规则",
  "microbiology.admin.filter.all": "所有分析仪",
  "microbiology.admin.sort": "排序",
  "microbiology.admin.sort.nameAsc": "名称（A-Z）",
  "microbiology.admin.sort.nameDesc": "名称 Z-A",
  "microbiology.admin.deactivate.impact": "{name} 被 {count, plural, one {# 条现有工作流记录} other {# 条现有工作流记录}}使用。停用后将无法再选择，但会保留这些历史引用。",
  "microbiology.admin.deactivate.title": "复核停用影响",
  "microbiology.admin.deactivated": "参考数据已停用",
  "microbiology.admin.empty": "没有匹配的参考记录",
  "microbiology.admin.error.save": "无法保存该参考记录。",
  "microbiology.admin.error.title": "无法完成请求",
  "microbiology.admin.field.active": "可用于新工作",
  "microbiology.admin.field.atmosphere": "培养气体环境默认值",
  "microbiology.admin.field.class": "类别",
  "microbiology.admin.field.code": "代码",
  "microbiology.admin.field.defaultPanel": "默认 AST 面板",
  "microbiology.admin.field.defaultPanelId": "默认 AST 面板 ID",
  "microbiology.admin.field.gramStain": "革兰氏染色",
  "microbiology.admin.field.group": "生物类群",
  "microbiology.admin.field.incubation": "孵育默认值",
  "microbiology.admin.field.incubationHours": "常规读数间隔（小时）",
  "microbiology.admin.field.subcultureAtHours": "传代培养时间（小时）",
  "microbiology.admin.field.maxIncubationDays": "最长孵育时间（天）",
  "microbiology.admin.field.media": "培养基默认值",
  "microbiology.admin.field.method": "方法",
  "microbiology.admin.field.methodId": "方法 ID",
  "microbiology.admin.field.name": "名称",
  "microbiology.admin.field.notes": "备注",
  "microbiology.admin.field.oclCode": "OCL代码",
  "microbiology.admin.field.reportableAnalyteId": "应报告的分析物ID",
  "microbiology.admin.field.route": "给药途径",
  "microbiology.admin.field.shortName": "简称",
  "microbiology.admin.field.significance": "初始临床意义",
  "microbiology.admin.field.whonetCode": "WHONET 代码",
  "microbiology.admin.organisms.add": "添加生物体",
  "microbiology.admin.organisms.description": "培养鉴定和药敏试验（AST）中使用的生物体术语。",
  "microbiology.admin.organisms.edit": "生物体",
  "microbiology.admin.organisms.title": "生物体",
  "microbiology.admin.patientOrigins.description": "在微生物学订单录入和 WHONET 导出过程中使用的已配置患者来源选项。",
  "microbiology.admin.patientOrigins.title": "患者来源",
  "microbiology.admin.reactivated": "参考数据已重新激活",
  "microbiology.admin.route.both": "口服和静脉注射",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "口服",
  "microbiology.admin.route.topical": "外用",
  "microbiology.admin.saved": "参考资料已保存",
  "microbiology.admin.search": "搜索参考数据",
  "microbiology.admin.sections": "微生物学参考章节",
  "microbiology.admin.significance.possible": "可能的病原体",
  "microbiology.admin.significance.rare": "罕见病原体",
  "microbiology.admin.significance.usually": "通常有临床意义",
  "microbiology.admin.status": "状态",
  "microbiology.admin.status.active": "活跃",
  "microbiology.admin.status.all": "所有状态",
  "microbiology.admin.status.inactive": "非活跃",
  "microbiology.admin.title": "微生物学参考数据",
  "button.add": "添加",
  "button.remove": "移除",
  "sidenav.label.microbiology": "微生物学",
  "sidenav.label.microbiology.worklist": "微生物学工作清单",
  "sidenav.label.microbiology.whonet": "WHONET 导出",
  "microbiology.whonet.title": "WHONET 导出",
  "microbiology.whonet.eyebrow": "常规细菌学监测",
  "microbiology.whonet.subtitle": "在生成用于 WHONET 验证的当前 OpenELIS 监测 CSV 文件之前，请复核已最终确定的培养和抗菌药物敏感性试验（AST）数据。",
  "microbiology.whonet.progress": "WHONET 导出进度",
  "microbiology.whonet.step.configure": "配置",
  "microbiology.whonet.step.preview": "预览",
  "microbiology.whonet.step.generate": "生成",
  "microbiology.whonet.configure.title": "配置导出",
  "microbiology.whonet.configure.description": "选择报告期间及要纳入的分离株。",
  "microbiology.whonet.from": "来源",
  "microbiology.whonet.to": "至",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "结束日期必须在开始日期之后或与之相同。",
  "microbiology.whonet.period.preset": "报告期",
  "microbiology.whonet.period.thisMonth": "本月",
  "microbiology.whonet.period.lastMonth": "上月",
  "microbiology.whonet.period.thisQuarter": "本季度",
  "microbiology.whonet.period.custom": "自定义",
  "microbiology.whonet.source.worklist.title": "AST工作列表提供的范围",
  "microbiology.whonet.source.worklist.description": "报告期间和结构化监测过滤器来源于AST工作列表。在此处仍可对其进行编辑。",
  "microbiology.whonet.source.worklist.clear": "清除工作列表范围",
  "microbiology.whonet.significance": "纳入",
  "microbiology.whonet.significance.clinical": "具有临床意义的分离株",
  "microbiology.whonet.significance.all": "所有分离株",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "具有临床意义",
  "microbiology.whonet.significance.CONTAMINANT": "污染物",
  "microbiology.whonet.significance.NORMAL_FLORA": "正常菌群",
  "microbiology.whonet.significance.UNKNOWN": "未分类",
  "microbiology.whonet.culturePurpose.description": "临床培养样本默认包含在内。当监测问题有此要求时，请明确添加其他人群。",
  "microbiology.whonet.culturePurpose.includeScreening": "包括主动筛查或携带者培养",
  "microbiology.whonet.culturePurpose.includeUnspecified": "包含目的未明的历史培养",
  "microbiology.whonet.culturePurpose.title": "培养目的",
  "microbiology.whonet.filter.specimen": "标本类型",
  "microbiology.whonet.filter.organism": "生物体",
  "microbiology.whonet.filter.origin": "患者来源",
  "microbiology.whonet.filter.any": "任何",
  "microbiology.whonet.filter.choose": "选择值",
  "microbiology.whonet.dedup": "去重",
  "microbiology.whonet.dedup.apply": "应用首个分离株选择",
  "microbiology.whonet.dedup.apply.help": "在所选时间范围内，合并同一患者和同一生物体的重复分离株。",
  "microbiology.whonet.dedup.advanced": "调整首个分离株策略",
  "microbiology.whonet.dedup.window": "窗口长度",
  "microbiology.whonet.dedup.window.help": "恰好位于所选天数边界的重复分离株将开始新的时间窗口。",
  "microbiology.whonet.dedup.sevenDay": "7天",
  "microbiology.whonet.dedup.fourteenDay": "14天",
  "microbiology.whonet.dedup.thirtyDay": "30天",
  "microbiology.whonet.dedup.basis": "窗口日期",
  "microbiology.whonet.dedup.basis.collection": "标本采集日期",
  "microbiology.whonet.dedup.basis.release": "最终结果发布日期",
  "microbiology.whonet.dedup.basis.help": "请选择该时间段是基于样本采集时间还是最终结果发布时间。报告周期始终以采集日期为准。",
  "microbiology.whonet.dedup.scope": "标本来源范围",
  "microbiology.whonet.dedup.scope.any": "任何标本来源",
  "microbiology.whonet.dedup.scope.same": "仅限同一标本来源",
  "microbiology.whonet.dedup.scope.help": "任何来源都会在不同标本类型之间对患者和生物体进行比较；同一来源则在每种标本类型内部进行比较。",
  "microbiology.whonet.dedup.contaminants": "在选择前排除可能的污染物",
  "microbiology.whonet.dedup.contaminants.help": "在选择第一个具有代表性的分离株之前，应移除可能的污染物。",
  "microbiology.whonet.dedup.profile": "药敏谱",
  "microbiology.whonet.dedup.profile.insensitive": "忽略已更改的S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "将已更改的S/I/R视为新的",
  "microbiology.whonet.dedup.profile.help": "“基于药敏谱的选择”会将时间窗口内不同的已复核抗生素 S/I/R 模式计为新的分离株。",
  "microbiology.whonet.dedup.none": "不去重",
  "microbiology.whonet.preview.action": "预览导出",
  "microbiology.whonet.preview.title": "预览",
  "microbiology.whonet.preview.description": "生成 CSV 文件时将使用这些数量和行。",
  "microbiology.whonet.generate.action": "生成 CSV",
  "microbiology.whonet.count.cases": "已最终确定的病例",
  "microbiology.whonet.count.clinicalPurpose": "临床培养",
  "microbiology.whonet.count.screeningPurpose": "筛选培养物",
  "microbiology.whonet.count.unspecifiedPurpose": "未指明的培养物",
  "microbiology.whonet.count.purposeIncluded": "培养目的确定后",
  "microbiology.whonet.count.isolates": "发现的分离株",
  "microbiology.whonet.count.specimen": "标本过滤器后",
  "microbiology.whonet.count.organism": "生物体过滤后",
  "microbiology.whonet.count.origin": "来源过滤器后",
  "microbiology.whonet.count.included": "已纳入的分离株",
  "microbiology.whonet.count.deduplicated": "去重后",
  "microbiology.whonet.count.mappable": "可映射的分离株",
  "microbiology.whonet.count.rows": "符合条件的行",
  "microbiology.whonet.count.excluded": "已排除的行",
  "microbiology.whonet.mapping.title": "映射就绪情况",
  "microbiology.whonet.mapping.excluded": "{count, plural, other {已排除行数}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "修复生物体映射",
  "microbiology.whonet.mapping.fixAntibiotic": "修复抗生素映射",
  "microbiology.whonet.mapping.fixSpecimen": "修复标本映射",
  "microbiology.whonet.table.title": "符合条件的 AST 行",
  "microbiology.whonet.table.description": "已复核、需报告的AST读数，并包含此导出所需的映射关系。",
  "microbiology.whonet.table.accession": "实验室编号",
  "microbiology.whonet.table.specimen": "标本",
  "microbiology.whonet.table.organism": "生物体",
  "microbiology.whonet.table.antibiotic": "抗生素",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "方法",
  "microbiology.whonet.error.title": "无法完成 WHONET 导出",
  "microbiology.whonet.error.invalidRequest": "请检查报告期间和导出选项，然后重试。",
  "microbiology.whonet.error.blocked": "已无有效行。在生成 CSV 文件之前，请先解决列出的就绪问题。",
  "microbiology.whonet.error.network": "无法访问该导出服务。请在连接可用后重试。",
  "microbiology.whonet.error.generic": "无法完成导出请求。",
  "microbiology.whonet.preview.loading": "正在准备导出预览。",
  "microbiology.whonet.preview.announced": "预览已就绪，共 {count, plural, one {# 条符合条件的行} other {# 条符合条件的行}}。",
  "microbiology.whonet.generated.title": "已生成CSV文件",
  "microbiology.whonet.generated.subtitle": "已验证的导出文件已下载，并已记录其审计摘要。",
  "catalog.import.title": "导入目录（CSV）",
  "catalog.import.description": "无需逐个编辑检测即可加载检测目录文件。预览会根据当前目录检查每个文件，但不保留任何内容，因此如果某行需要同一次上传中另一个文件创建的实验室单元、标本或检测，在应用之前该行会显示为已跳过。应用会按顺序加载文件，并将其与配置一起保存，因此下次重启时会准确加载您所应用的内容。",
  "catalog.import.dropzone": "添加 CSV 文件",
  "catalog.import.preview": "预览",
  "catalog.import.apply": "应用",
  "catalog.import.remove": "移除",
  "catalog.import.plan.title": "这些文件将执行的操作",
  "catalog.import.result.title": "使用",
  "catalog.import.column.file": "文件",
  "catalog.import.column.domain": "目录区域",
  "catalog.import.column.created": "创建时间",
  "catalog.import.column.updated": "更新",
  "catalog.import.column.skipped": "已跳过",
  "catalog.import.column.name": "文件中的名称",
  "catalog.import.column.where": "出现位置",
  "catalog.import.column.use": "使用此记录",
  "catalog.import.file.error": "无法读取此文件",
  "catalog.import.applied": "目录文件已应用。",
  "catalog.import.applied.partial": "部分目录文件未加载。表格中列出了具体文件及原因。",
  "catalog.import.apply.failed": "目录文件未应用。",
  "catalog.import.apply.hint": "请先预览文件。预览显示无文件错误后即可应用。",
  "catalog.import.failed": "无法发送目录文件。",
  "catalog.import.unresolved.title": "需要您决定",
  "catalog.import.unresolved.description": "导入无法与记录匹配的名称。请将每个名称指向其对应的记录，或跳过。记住名称后，下次将自动解决。",
  "catalog.import.unresolved.empty": "没有等待决定的项目。",
  "catalog.import.remember": "已加载的内容",
  "catalog.import.resolve": "记住此名称",
  "catalog.import.skip": "跳过",
  "sidenav.label.admin.catalogImport": "导入目录（CSV）",
  "reporting.design.subtitle": "为新问题创建CSV，或针对新期间重新运行常用报告。",
  "reporting.design.overview": "导出概览",
  "reporting.design.newTitle": "创建新导出",
  "reporting.design.newHelp": "选择报告类型、所需字段和报告期间。如果您访问队列或稍后返回，您的工作仍会保留。",
  "reporting.design.savedTitle": "使用已保存的报告",
  "reporting.design.savedHelp": "重复使用已保存的字段和筛选条件，然后选择新的报告期间。",
  "reporting.design.start": "开始新导出",
  "reporting.design.continue": "继续当前导出",
  "reporting.design.newExport": "新建导出",
  "reporting.design.useReport": "使用报告",
  "reporting.design.savedFields": "{count}个已保存字段 · 报告期间不会被保存",
  "reporting.design.steps": "导出步骤",
  "reporting.design.chooseColumns": "选择列",
  "reporting.design.setFilters": "设置筛选条件",
  "reporting.design.reviewSubmit": "复核并提交",
  "reporting.design.typeQuestion": "您需要哪类信息？",
  "reporting.design.typeHelp": "请选择一种报告类型，使每一行CSV都有明确含义。在选择字段之前，您可以更改类型。",
  "reporting.design.type.SAMPLE_TESTING": "样本和检测",
  "reporting.design.type.REFERRALS": "转诊",
  "reporting.design.type.NON_CONFORMANCE": "不符合项",
  "reporting.design.typeHelp.SAMPLE_TESTING": "订单、结果、患者和周转时间",
  "reporting.design.typeHelp.REFERRALS": "转诊至其他实验室的检测 · 保留已返回结果和待返回的转诊",
  "reporting.design.typeHelp.NON_CONFORMANCE": "被拒绝的样本和不符合事件 · 保留关联样本和各次独立发生记录",
  "reporting.design.pending": "尚未接入",
  "reporting.design.building": "您正在创建{type}报告。",
  "reporting.design.changeType": "更改类型并清除字段",
  "reporting.design.chooseType": "选择报告类型以查看其字段。",
  "reporting.design.configuredReports": "已配置的报告",
  "reporting.design.chooseConfigured": "选择已配置的报告",
  "reporting.design.available": "可用字段",
  "reporting.design.findField": "查找字段",
  "reporting.design.searchPlaceholder": "搜索所有字段和组…",
  "reporting.design.clearSearch": "清除搜索",
  "reporting.design.fieldCount": "{count}个字段，分布于{groups}个组",
  "reporting.design.matchCount": "{count}个匹配字段，分布于{groups}个组",
  "reporting.design.expansion": "展开或折叠字段组",
  "reporting.design.expandAll": "全部展开",
  "reporting.design.collapseAll": "全部折叠",
  "reporting.design.groupCount": "已添加{added} / {total}",
  "reporting.design.scrollCatalog": "可滚动的字段目录",
  "reporting.design.addShown": "添加所有显示项",
  "reporting.design.removeShown": "移除显示项",
  "reporting.design.addShownGroup": "添加所有显示的{group}字段",
  "reporting.design.removeShownGroup": "移除所有显示的{group}字段",
  "reporting.design.addField": "添加 {field}",
  "reporting.design.addedField": "已添加{field}",
  "reporting.design.add": "+ 添加",
  "reporting.design.added": "已添加",
  "reporting.design.noFields": "没有与您的搜索匹配的字段。",
  "reporting.design.selectedCount": "您的CSV列（{count}）",
  "reporting.design.orderHelp": "拖动手柄以更改列顺序，或使用箭头按钮。方向键可移动当前聚焦的手柄；Home和End键可将其移至第一个或最后一个位置。",
  "reporting.design.columnOrder": "CSV列顺序",
  "reporting.design.drag": "拖动{field}以重新排序",
  "reporting.design.move": "移动{field}",
  "reporting.design.emptyColumns": "添加字段以构建您的CSV。",
  "reporting.design.addedMessage": "已添加{field}。共{count}列。",
  "reporting.design.removedMessage": "已移除{field}。共{count}列。",
  "reporting.design.columnViews": "列构建器视图",
  "reporting.design.yourColumns": "您的列（{count}）",
  "reporting.design.csvPreview": "CSV预览",
  "reporting.design.previewHelp": "列布局，按其在您下载的CSV中出现的顺序显示。",
  "reporting.design.scrollPreview": "可滚动的CSV预览",
  "reporting.design.nextFilters": "下一步：设置筛选条件",
  "reporting.design.nextReview": "下一步：复核并提交",
  "reporting.design.scopeFilters": "范围筛选条件（可选）",
  "reporting.design.periodDays": "{count, plural, other {# 天}}",
  "reporting.design.moreFilters": "显示更多筛选条件",
  "reporting.design.hideFilters": "隐藏更多筛选条件",
  "reporting.design.sampleStatus": "样本状态",
  "reporting.design.referringSite": "转诊站点",
  "reporting.design.reviewConfiguration": "复核配置",
  "reporting.design.dateFilters": "日期范围和筛选条件",
  "reporting.design.testStatus": "检测和状态",
  "reporting.design.change": "更改",
  "reporting.design.deliveryHelp": "您的CSV将在后台生成。准备就绪后可在此处下载，或返回“我的报告队列”。",
  "reporting.design.fileName": "文件名称",
  "reporting.design.customFileName": "自定义文件名",
  "reporting.design.fileNamePending": "文件名将自动生成。自定义名称尚未接入。",
  "reporting.design.saveLater": "保存这些报告设置以供日后使用",
  "reporting.design.saveSettings": "保存报告设置",
  "reporting.design.queueHelp": "查看并下载您已排队的CSV导出。",
  "reporting.design.queue.jobName": "任务名称",
  "reporting.design.queue.report": "报告",
  "reporting.design.queue.size": "行数 / 文件大小",
  "reporting.design.queue.submitted": "提交时间",
  "reporting.design.queuePending": "活动任务会自动刷新。可重试失败的导出、取消排队中的任务，或使用新日期重新运行已过期的报告。删除任务功能尚未接入。",
  "reporting.design.details": "详情",
  "reporting.design.expires": "可用至{date}",
  "reporting.design.jobsShown": "显示{count}个任务",
  "reporting.design.jobAction.EXPIRED": "重新运行",
  "reporting.design.labScope": "实验室范围",
  "reporting.design.reviewFields": "已选字段（{count}）",
  "reporting.recovery.cancelTitle": "取消导出",
  "reporting.recovery.keepQueued": "保持排队",
  "reporting.recovery.cancelHelp": "取消此排队中的导出？如果处理已开始，它将继续进行，您可以返回查看其结果。",
  "reporting.job.cannotCancel": "此导出已开始或已完成，无法取消。",
  "reporting.job.cannotRetry": "只有失败的导出才能重试。请使用当前任务或开始新导出。",
  "reporting.job.interrupted": "处理已中断。请重试此导出以生成新文件。",
  "reporting.job.claimLost": "此导出已不再分配给当前工作进程。请返回队列查看其状态。",
  "sidenav.section.main": "主菜单",
  "sidenav.section.patientOrders": "患者与订单",
  "sidenav.section.administration": "管理",
  "sidenav.workflow.orderTest": "订单检测",
  "sidenav.workflow.resultsValidation": "结果审核",
  "sidenav.workflow.patientManagement": "患者管理",
  "sidenav.moreTools": "更多工具",
  "reporting.menu.otherReports": "其他报告",
  "reporting.menu.patientPrintQueue": "患者报告打印队列",
  "common.icon": "图标",
  "menu.presentation.style": "显示为",
  "menu.presentation.item": "菜单项",
  "menu.presentation.section": "分区标题",
  "menu.configuration.description": "更新菜单可见性、分区标题和图标。由此实例管理的设置在此处为只读。",
  "menu.configuration.export": "Export menu file",
  "menu.configuration.loadError": "无法加载菜单设置。",
  "menu.configuration.saved": "菜单设置已保存。",
  "menu.presentation.sectionHint": "分区标题用于归组其下级菜单项，本身不带链接。",
  "menu.presentation.sectionIconHint": "图标显示在菜单项上，而不显示在分区标题上。",
  "analyzer.action.copyMappings": "复制映射",
  "analyzer.action.delete": "删除",
  "analyzer.action.edit": "编辑",
  "analyzer.action.fieldMappings": "映射",
  "analyzer.action.qcRules": "质控规则",
  "analyzer.action.testConnection": "测试连接",
  "analyzer.copyMappings.confirmation.message": "确定要将映射从源分析仪复制到目标分析仪吗？",
  "analyzer.copyMappings.confirmation.title": "确认复制映射",
  "analyzer.copyMappings.copy": "复制映射",
  "analyzer.copyMappings.error": "复制映射失败",
  "analyzer.copyMappings.error.noSourceMappings": "源分析仪没有可复制的映射",
  "analyzer.copyMappings.loading": "正在加载...",
  "analyzer.copyMappings.source": "源分析仪",
  "analyzer.copyMappings.source.name": "名称",
  "analyzer.copyMappings.source.type": "设备类型",
  "analyzer.copyMappings.subtitle": "将字段映射从一个分析仪复制到另一个",
  "analyzer.copyMappings.success": "映射复制成功",
  "analyzer.copyMappings.success.viewTarget": "查看目标分析仪",
  "analyzer.copyMappings.summary": "摘要",
  "analyzer.copyMappings.summary.breakdown": "明细",
  "analyzer.copyMappings.summary.count": "数量",
  "analyzer.copyMappings.target": "目标分析仪",
  "analyzer.copyMappings.target.placeholder": "选择目标分析仪",
  "analyzer.copyMappings.target.required": "目标分析仪为必填项",
  "analyzer.copyMappings.title": "复制映射",
  "analyzer.copyMappings.warning": "警告：目标分析仪的现有映射将被覆盖",
  "analyzer.delete.cancel": "取消",
  "analyzer.delete.delete": "删除",
  "analyzer.delete.error": "错误",
  "analyzer.delete.error.noId": "分析仪ID为必填项",
  "analyzer.delete.error.unknown": "发生未知错误",
  "analyzer.delete.message": "确定要删除此分析仪吗？此操作无法撤销。",
  "analyzer.delete.success": "分析仪删除成功",
  "analyzer.delete.title": "删除分析仪",
  "analyzer.delete.unknown": "未知错误",
  "analyzer.errorDashboard.acknowledgeAll": "全部确认",
  "analyzer.errorDashboard.action.acknowledge": "确认",
  "analyzer.errorDashboard.action.menu": "操作",
  "analyzer.errorDashboard.action.viewDetails": "查看详情",
  "analyzer.errorDashboard.errorType.connection": "连接",
  "analyzer.errorDashboard.errorType.mapping": "映射错误",
  "analyzer.errorDashboard.errorType.protocol": "协议",
  "analyzer.errorDashboard.errorType.timeout": "超时错误",
  "analyzer.errorDashboard.errorType.validation": "验证中",
  "analyzer.errorDashboard.filter.analyzer": "分析仪",
  "analyzer.errorDashboard.filter.analyzer.all": "所有分析仪",
  "analyzer.errorDashboard.filter.search": "搜索",
  "analyzer.errorDashboard.filter.severity": "严重程度",
  "analyzer.errorDashboard.filter.severity.all": "所有严重程度",
  "analyzer.errorDashboard.filter.type": "类型",
  "analyzer.errorDashboard.filter.type.all": "所有类型",
  "analyzer.errorDashboard.severity.critical": "紧急",
  "analyzer.errorDashboard.severity.error": "错误",
  "analyzer.errorDashboard.severity.warning": "警告",
  "analyzer.errorDashboard.stats.critical": "紧急",
  "analyzer.errorDashboard.stats.last24Hours": "过去24小时",
  "analyzer.errorDashboard.stats.total": "总计",
  "analyzer.errorDashboard.stats.unacknowledged": "未确认",
  "analyzer.errorDashboard.status.acknowledged": "已确认",
  "analyzer.errorDashboard.status.unacknowledged": "未确认",
  "analyzer.errorDashboard.subtitle": "监控和管理分析仪错误",
  "analyzer.errorDashboard.table.analyzer": "分析仪",
  "analyzer.errorDashboard.table.message": "消息",
  "analyzer.errorDashboard.table.severity": "严重程度",
  "analyzer.errorDashboard.table.status": "状态",
  "analyzer.errorDashboard.table.timestamp": "时间戳",
  "analyzer.errorDashboard.table.type": "设备类型",
  "analyzer.errorDashboard.title": "分析仪错误仪表板",
  "analyzer.errorDetails.acknowledged": "已确认",
  "analyzer.errorDetails.acknowledgedBy": "确认人",
  "analyzer.errorDetails.analyzer": "分析仪",
  "analyzer.errorDetails.analyzerId": "分析仪ID",
  "analyzer.errorDetails.close": "关闭",
  "analyzer.errorDetails.copy": "复制",
  "analyzer.errorDetails.createMapping": "创建映射",
  "analyzer.errorDetails.download": "下载",
  "analyzer.errorDetails.errorId": "错误ID",
  "analyzer.errorDetails.errorMessage": "错误信息",
  "analyzer.errorDetails.errorType": "类型",
  "analyzer.errorDetails.logs": "日志",
  "analyzer.errorDetails.recommendedActions": "建议操作",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "检查配置",
  "analyzer.errorDetails.recommendedActions.createMapping": "创建映射",
  "analyzer.errorDetails.recommendedActions.testConnection": "测试连接",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "验证连接",
  "analyzer.errorDetails.severity": "严重程度",
  "analyzer.errorDetails.subtitle": "错误详细信息",
  "analyzer.errorDetails.timestamp": "时间戳",
  "analyzer.errorDetails.title": "错误详情",
  "analyzer.fieldMapping.activationModal.activate": "激活",
  "analyzer.fieldMapping.activationModal.cancel": "取消",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "我确认要激活此映射",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "映射已被其他用户修改，请刷新页面",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "缺少必填映射",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "请完成所有必填字段映射后再激活",
  "analyzer.fieldMapping.activationModal.reloadPage": "刷新页面",
  "analyzer.fieldMapping.activationModal.subtitle": "激活后映射将立即生效",
  "analyzer.fieldMapping.activationModal.title": "激活映射",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "查看待处理消息",
  "analyzer.fieldMapping.activationModal.warning": "警告：激活后将处理所有待处理消息",
  "analyzer.fieldMapping.activationModal.warningActive": "此分析仪已有活跃的映射配置",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "有待处理的消息尚未处理",
  "analyzer.fieldMapping.back": "返回",
  "analyzer.fieldMapping.fieldType.controlTest": "质控检测",
  "analyzer.fieldMapping.fieldType.custom": "自定义",
  "analyzer.fieldMapping.fieldType.dateTime": "日期时间",
  "analyzer.fieldMapping.fieldType.meltingPoint": "熔点",
  "analyzer.fieldMapping.fieldType.numeric": "数值",
  "analyzer.fieldMapping.fieldType.qualitative": "定性",
  "analyzer.fieldMapping.fieldType.text": "文本",
  "analyzer.fieldMapping.page.subtitle": "管理分析仪字段映射配置",
  "analyzer.fieldMapping.page.title": "映射",
  "analyzer.fieldMapping.panel.mapping.active": "活跃",
  "analyzer.fieldMapping.panel.mapping.retired": "已停用",
  "analyzer.fieldMapping.panel.retire": "停用",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "无法停用此映射",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "个可用字段",
  "analyzer.fieldMapping.panel.source.search": "搜索字段",
  "analyzer.fieldMapping.panel.source.title": "源字段",
  "analyzer.fieldMapping.panel.status.mapped": "已映射",
  "analyzer.fieldMapping.panel.status.unmapped": "未映射",
  "analyzer.fieldMapping.panel.statusFilter.active": "仅活跃",
  "analyzer.fieldMapping.panel.statusFilter.all": "全部",
  "analyzer.fieldMapping.panel.statusFilter.draft": "草稿",
  "analyzer.fieldMapping.panel.statusFilter.label": "状态",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "已映射",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "未映射",
  "analyzer.fieldMapping.panel.target.cancel": "取消",
  "analyzer.fieldMapping.panel.target.edit": "编辑",
  "analyzer.fieldMapping.panel.target.remove": "移除",
  "analyzer.fieldMapping.panel.target.saveActivate": "保存并激活",
  "analyzer.fieldMapping.panel.target.saveDraft": "保存为草稿",
  "analyzer.fieldMapping.panel.target.selectField": "选择字段",
  "analyzer.fieldMapping.panel.target.summary": "摘要",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "此字段尚未映射",
  "analyzer.fieldMapping.pendingCodes.actions": "操作",
  "analyzer.fieldMapping.pendingCodes.code": "代码",
  "analyzer.fieldMapping.pendingCodes.empty": "暂无待处理代码",
  "analyzer.fieldMapping.pendingCodes.ignore": "忽略",
  "analyzer.fieldMapping.pendingCodes.markMapped": "标记为已映射",
  "analyzer.fieldMapping.pendingCodes.seenCount": "出现次数",
  "analyzer.fieldMapping.pendingCodes.status": "状态",
  "analyzer.fieldMapping.pendingCodes.subtitle": "查看和管理待处理的映射代码",
  "analyzer.fieldMapping.pendingCodes.title": "待处理代码",
  "analyzer.fieldMapping.pluginConfig.title": "插件配置",
  "analyzer.fieldMapping.queryAnalyzer": "查询分析仪",
  "analyzer.fieldMapping.retirementModal.cancel": "取消",
  "analyzer.fieldMapping.retirementModal.confirmation": "确定要停用此映射吗？",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "存在待处理消息，无法停用",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "停用原因",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "请输入停用原因",
  "analyzer.fieldMapping.retirementModal.retire": "停用",
  "analyzer.fieldMapping.retirementModal.subtitle": "停用后此映射将不再处理新消息",
  "analyzer.fieldMapping.retirementModal.title": "停用",
  "analyzer.fieldMapping.save": "保存",
  "analyzer.fieldMapping.stats.pendingCodes": "待处理代码",
  "analyzer.fieldMapping.stats.required": "必填",
  "analyzer.fieldMapping.stats.total": "总计",
  "analyzer.fieldMapping.stats.unmapped": "未映射",
  "analyzer.fieldMapping.status.active": "活跃",
  "analyzer.fieldMapping.status.draft": "草稿",
  "analyzer.fieldMapping.status.retired": "已停用",
  "analyzer.fieldMapping.status.unmapped": "未映射",
  "analyzer.fieldMapping.testMapping": "测试映射",
  "analyzer.fieldMapping.warning.missingRequired": "缺少必填字段",
  "analyzer.fieldMapping.warning.missingRequired.detail": "请填写所有必填字段后再继续",
  "analyzer.navigation.errorDashboard": "分析仪错误仪表板",
  "analyzerType.column.name": "名称",
  "analyzerType.column.description": "描述",
  "analyzerType.column.pluginClass": "插件类",
  "analyzerType.column.genericPlugin": "通用插件",
  "analyzerType.column.identifierPattern": "标识符模式",
  "analyzerType.column.pluginLoaded": "插件已加载",
  "analyzerType.column.instances": "实例数",
  "analyzerType.button.creating": "创建中...",
  "analyzerType.modal.createTitle": "创建分析仪类型",
  "analyzerType.field.name": "名称",
  "analyzerType.field.description": "描述",
  "analyzerType.field.selectProtocol": "选择协议",
  "analyzerType.field.pluginClassName": "插件类名",
  "analyzerType.field.identifierPattern": "标识符模式",
  "analyzerType.field.identifierPatternHelper": "用于识别此类型分析仪消息的正则表达式",
  "analyzerType.field.isGenericPlugin": "通用插件",
  "analyzerType.field.isActive": "活跃",
  "analyzerType.error.nameRequired": "名称为必填项",
  "analyzerType.notification.createSuccess": "分析仪类型创建成功",
  "analyzerType.notification.createError": "创建分析仪类型失败",
  "analyzer.stat.pluginWarnings": "插件警告",
  "analyzer.status.pending_registration": "待注册",
  "analyzer.qcRules.modal.title": "质控样本识别规则：{analyzerName}",
  "analyzer.qcRules.breadcrumb": "质控样本识别规则",
  "analyzer.qcRules.orSemantics": "规则采用“或”逻辑：只要任一启用的规则匹配，样本即被标记为质控。",
  "analyzer.qcRules.addRule": "添加规则",
  "analyzer.qcRules.deleteRule": "删除规则",
  "analyzer.qcRules.noRules": "未配置质控规则。启用此分析仪前请至少添加一条规则。",
  "analyzer.qcRules.ruleType": "规则类型",
  "analyzer.qcRules.targetField": "字段引用",
  "analyzer.qcRules.targetField.placeholder": "例如：O.12, QC_TASK",
  "analyzer.qcRules.operand": "匹配值",
  "analyzer.qcRules.operand.placeholder": "例如：Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "加载质控规则失败",
  "analyzer.qcRules.error.saveFailed": "保存质控规则失败",
  "analyzer.qcRules.error.deleteFailed": "删除质控规则失败",
  "analyzer.placement.instrumentSpecimen": "仪器发送：{id}",
  "analyzer.placement.state.RESOLVED": "已匹配",
  "analyzer.placement.state.RETEST_CHOICE": "已有结果",
  "analyzer.placement.state.MULTI_TUBE": "多个匹配",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "检测未下单",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "检测未下单",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "检测未下单",
  "analyzer.placement.state.NEW_SAMPLE": "新样本",
  "analyzer.placement.reason.RESOLVED": "{tube} 上有一项分析正在等待此结果。",
  "analyzer.placement.reason.RETEST_CHOICE": "{tube} 上的分析已有结果。保存将替换该结果并将其标记为已更正。",
  "analyzer.placement.reason.MULTI_TUBE": "有多个分析与此 ID 匹配。请选择此结果所属的分析。",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "有多个样本管带有此 ID。请更正重复的样本管标签，然后重新复核。",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "此检测未下单。保存时会将其添加到 {tube}。",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "此检测未下单，且有多个样本管可以容纳。请在下方选择样本类型。",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "此检测未下单，且订单中没有样本管可以容纳。保存时将添加一个该检测样本类型的新样本管。",
  "analyzer.placement.reason.NEW_SAMPLE": "没有订单或样本管带有此 ID。保存时将为其创建新样本。",
  "analyzer.placement.chooseAnalysis": "此结果所属的分析",
  "analyzer.placement.chooseAnalysis.none": "选择分析",
  "analyzer.placement.option": "{tube}，{status}",
  "analyzer.placement.option.awaiting": "等待结果",
  "analyzer.placement.option.hasResult": "已有结果",
  "analyzer.placement.tubeUnlabelled": "样本管 {id}",
  "analyzer.placement.viewBundle": "查看交付包",
  "analyzer.placement.bundleTitle": "交付包",
  "analyzer.placement.bundleLoading": "正在加载交付包",
  "analyzer.placement.bundleFailed": "无法加载交付包。",
  "analyzer.placement.redirect.open": "放到其他订单",
  "analyzer.placement.redirect.accession": "订单（实验室编号）",
  "analyzer.placement.redirect.reason": "此结果属于该订单的原因",
  "analyzer.placement.redirect.help": "当仪器误读样本 ID 时使用此功能。原因将与结果一起保存。",
  "analyzer.placement.redirect.reasonRequired": "保存前请输入原因。",
  "analyzer.placement.patient.match": "仪器患者 {instrument} 与订单患者匹配。",
  "analyzer.placement.patient.mismatch.tag": "患者不匹配",
  "analyzer.placement.patient.mismatch": "仪器报告的患者为 {instrument}，但订单患者为 {order}。保存前请添加备注说明原因。",
  "analyzer.placement.patient.noOrderPatient": "仪器报告的患者为 {instrument}。订单中没有可供比对的患者标识符。",
  "instructions.qc.fail.blocks.validation": "启用后，受未关闭质控失败影响的结果在不符合项关闭之前无法在审核中接受，但仍可拒绝。停用后，失败仅在该行显示为警告。",
  "coldStorage.bacnetUdpPort": "BACnet UDP端口",
  "coldStorage.config.saveSuccess": "配置保存成功",
  "coldStorage.configMoved": "配置已迁移",
  "coldStorage.configMovedDesc": "配置已迁移到新位置",
  "coldStorage.databaseVersion": "数据库版本",
  "coldStorage.error.loadConfig": "加载配置失败",
  "coldStorage.error.saveConfig": "保存配置失败",
  "coldStorage.lastUpdate": "最后更新",
  "coldStorage.loadingConfig": "正在加载配置...",
  "coldStorage.modbusTcpPort": "Modbus TCP端口",
  "coldStorage.protocolConfiguration": "协议配置",
  "coldStorage.readOnlyMode": "只读模式",
  "coldStorage.readOnlyModeDesc": "启用只读模式后，无法修改设备配置",
  "coldStorage.securitySettings": "安全设置",
  "coldStorage.sessionTimeout": "会话超时",
  "coldStorage.systemConfiguration": "系统配置",
  "coldStorage.systemInformation": "系统信息",
  "coldStorage.systemVersion": "系统版本",
  "coldStorage.twoFactorAuth": "双因素认证",
  "coldStorage.uptime": "运行时间",
  "customFieldType.page.hierarchy.management": "自定义字段类型",
  "customFieldType.page.hierarchy.root": "系统管理",
  "eqa.program.tests.helper": "此计划的结果录入仅提供这些检测，包括结果表格及其 CSV 导入。",
  "eqa.program.tests.saveFailed": "计划已保存，但其检测未保存。请重新打开并再次设置。",
  "inventory.search.placeholder": "按物品名称、批号或条码搜索",
  "label.results.control.capture.pass": "通过",
  "label.results.control.capture.fail": "失败",
  "message.noPluginFound": "未找到插件",
  "nce.status.capa": "CAPA",
  "nce.status.completed": "已完成",
  "nce.capa.add": "添加",
  "plugin.files": "插件文件",
  "plugin.name": "插件名称",
  "sidenav.label.admin.analyzerTest": "分析仪检测名称",
  "sidenav.label.admin.Listplugin": "列表插件",
  "sidenav.label.admin.pluginFile": "插件文件",
  "label.testCatalog.accreditation.col.body": "认可机构",
  "label.testCatalog.accreditation.col.expires": "机构认可到期",
  "label.testCatalog.accreditation.col.status": "状态",
  "label.testCatalog.accreditation.col.actions": "操作",
  "label.testCatalog.accreditation.remove.confirm": "移除",
  "qa.qiConfig.title": "质量指标配置",
  "qa.qiConfig.error": "无法加载质量指标配置。",
  "qa.qiConfig.column.indicator": "指标",
  "qa.qiConfig.column.enabled": "已启用",
  "qa.qiConfig.column.target": "目标",
  "qa.qiConfig.column.action": "行动阈值",
  "qa.qiConfig.column.actions": "操作",
  "qa.qms.capaRegister.title": "CAPA 登记册",
  "qa.qms.capaRegister.tile.open": "待处理",
  "qa.qms.capaRegister.tile.overdue": "已逾期",
  "qa.qms.capaRegister.filter.status": "状态",
  "qa.qms.capaRegister.filter.status.all": "所有分析仪",
  "qa.qms.capaRegister.column.nceNumber": "NCE 数字",
  "qa.qms.capaRegister.column.actionType": "设备类型",
  "qa.qms.capaRegister.column.dueDate": "截止日期",
  "qa.qms.capaRegister.column.completed": "已完成",
  "qa.qms.capaRegister.column.status": "状态",
  "qa.qms.accreditation.tile.active": "活跃",
  "qa.qms.accreditation.tile.expiring": "即将过期",
  "qa.qms.accreditation.tile.expired": "已过期",
  "qa.qms.accreditation.body.column.code": "代码",
  "qa.qms.accreditation.body.column.name": "名称",
  "qa.qms.accreditation.body.column.enrolled": "已注册检测",
  "qa.qms.accreditation.body.column.status": "状态",
  "qa.qms.accreditation.body.column.actions": "操作",
  "qa.qms.accreditation.body.field.code": "代码",
  "qa.qms.accreditation.body.field.name": "名称",
  "qa.qms.accreditation.body.field.displayOrder": "显示顺序",
  "qa.qms.accreditation.body.field.active": "活跃",
  "qa.qms.accreditation.body.delete.confirm": "删除",
  "qa.qms.accreditation.enrollment.column.test": "检测",
  "qa.qms.accreditation.enrollment.column.status": "状态",
  "qa.qms.accreditation.enrollment.column.actions": "操作",
  "qa.qms.accreditation.eqa.column.body": "认可机构",
  "qa.qms.accreditation.filter.status": "状态",
  "qa.qms.accreditation.filter.all": "所有分析仪",
  "qa.qms.accreditation.filter.search": "搜索检测",
  "qa.qms.accreditation.enroll.field.body": "认可机构",
  "qa.qms.accreditation.enroll.field.tests": "检测项目",
  "qa.qms.accreditation.enrollment.delete.confirm": "移除",
  "qa.qms.esigLog.title": "电子签名日志",
  "qa.qms.esigLog.column.signedAt": "签名时间",
  "qa.qms.esigLog.column.action": "操作",
  "qa.qms.esigLog.column.reason": "理由",
  "qa.qms.esigLog.filter.from": "日期范围(起)",
  "qa.qms.esigLog.filter.to": "日期范围(止)",
  "qa.qms.esigLog.filter.action": "操作",
  "qa.qms.esigLog.filter.user": "用户",
  "qa.qms.esigLog.filter.all": "所有分析仪",
  "qa.qms.esigLog.filter.clear": "清除筛选",
  "qa.qms.esigLog.export.csv": "导出翻译",
  "qa.qms.esigLog.export.pdf": "导出PDF",
  "qa.qms.esigLog.export.confirm.confirm": "导出",
  "qa.qms.esigLog.export.confirm.cancel": "取消",
  "qa.qi.dashboard.title": "质量指标仪表板",
  "qa.qi.dashboard.refresh": "刷新",
  "qa.qi.dashboard.comingSoon": "即将推出：{ticket}",
  "qa.qi.amendment.filter.from": "来源",
  "qa.qi.amendment.filter.to": "到",
  "qa.qi.amendment.column.labNumber": "实验室编号",
  "qa.qi.amendment.column.test": "检测",
  "qa.qi.amendment.empty": "此时间窗口内无修订。",
  "qa.qi.amendment.error": "修订数据不可用。",
  "qa.qi.amendment.trend.title": "趋势",
  "qa.qi.amendment.trend.series": "修订率",
  "qa.qi.amendment.trend.interval": "聚合",
  "qa.qi.amendment.threshold.target": "目标",
  "qa.qi.amendment.threshold.action": "操作",
  "qa.qi.amendment.breakdown.column.test": "检测",
  "qa.qi.amendment.breakdown.column.amended": "已修订",
  "qa.qi.amendment.breakdown.column.released": "已发布",
  "qa.qi.rejection.filter.from": "来源",
  "qa.qi.rejection.filter.to": "到",
  "qa.qi.rejection.column.labNumber": "实验室编号",
  "qa.qi.rejection.column.test": "检测",
  "qa.qi.rejection.column.reason": "原因",
  "qa.qi.rejection.column.location": "位置",
  "qa.qi.rejection.column.nce": "不符合事件",
  "qa.qi.rejection.error": "拒绝数据不可用。",
  "qa.qi.rejection.trend.title": "趋势",
  "qa.qi.rejection.trend.series": "拒绝率",
  "qa.qi.rejection.trend.interval": "聚合",
  "qa.qi.rejection.trend.empty": "此时间窗口内无趋势数据。",
  "qa.qi.rejection.threshold.target": "目标",
  "qa.qi.rejection.threshold.action": "操作",
  "qa.qi.rejection.reasons.column.reason": "原因",
  "qa.qi.rejection.reasons.column.count": "数量",
  "qa.qi.rejection.breakdown.title": "按检测",
  "qa.qi.rejection.breakdown.column.test": "检测",
  "qa.qi.rejection.breakdown.column.rejected": "已拒收",
  "qa.qi.rejection.breakdown.column.total": "已开始",
  "qa.qi.rejection.breakdown.column.rate": "比率",
  "qa.qi.callback.failures.column.reason": "原因",
  "qa.qi.callback.failures.column.count": "数量",
  "qa.qi.callback.error": "回电数据不可用。",
  "qa.qi.callback.column.releasedAt": "已发布",
  "qa.qi.callback.column.labNumber": "实验室编号",
  "qa.qi.callback.column.test": "检测",
  "qa.qi.callback.column.resultValue": "结果",
  "qa.qi.callback.column.criticalRange": "危急范围",
  "qa.qi.callback.column.recipient": "被通知人",
  "qa.comingSoon.subtitle": "此页面已在计划中，但尚未构建。",
  "qa.overview.section.today": "今天",
  "qa.overview.tile.tat": "平均 TAT",
  "qa.overview.tile.rejectionRate": "拒绝率",
  "qa.overview.tile.amendmentRate": "修订率",
  "qa.overview.tile.ncePulse": "不符合事件动态",
  "qa.overview.ncePulse.criticalPending": "紧急待处理",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} 个处于纠正措施中",
  "qa.overview.activity.system": "系统",
  "storage.picker.backToSearch": "返回搜索",
  "storage.picker.createNewLocation": "创建新位置",
  "storage.picker.heading.moveSample": "移动样本",
  "storage.picker.sample.accession": "实验室编号",
  "storage.picker.sample.heading": "样本",
  "storage.picker.sample.status": "状态",
  "storage.picker.sample.type": "设备类型",
  "storage.metrics.storage.locations": "存储位置",
  "storage.tab.devices": "设备",
  "storage.tab.racks": "货架",
  "storage.tab.rooms": "房间",
  "storage.tab.shelves": "架层",
  "validation.label.qcHold": "质控未通过",
  "validation.qcHold.blocked": "部分结果未发布，因为覆盖这些结果的质控失败。请关闭不符合项，或拒绝受影响的结果。",
  "validation.qcHold.withheld": "{count, plural, other {# 个结果未发布（{accessions}）。覆盖这些结果的质控失败仍未关闭。请复核不符合项，或拒绝该结果。}}",
  "qc.dashboard.export.button": "导出",
  "qc.dashboard.export.instrument": "仪器",
  "qc.dashboard.export.level": "质控水平",
  "qc.dashboard.export.startDate": "开始日期",
  "qc.dashboard.export.endDate": "结束日期",
  "qc.dashboard.export.csv": "导出翻译",
  "qc.dashboard.export.pdf": "导出PDF",
  "qc.dashboard.export.cancel": "取消",
  "qc.instrument.tab.timeline": "活动时间轴",
  "qc.instrument.tab.chart": "控制图",
  "qc.chart.stats.mean": "均值",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Levey-Jennings 质控图",
  "qc.chart.filter.startDate": "开始日期",
  "qc.chart.filter.endDate": "结束日期",
  "qc.chart.filter.controlLevel": "质控水平",
  "qc.chart.filter.selectLevel": "选择质控水平",
  "qc.chart.filter.levelLow": "低",
  "qc.chart.filter.levelNormal": "正常",
  "qc.chart.filter.levelHigh": "高",
  "qc.chart.filter.controlLot": "质控品批号",
  "qc.chart.filter.allLots": "所有批号",
  "qc.chart.action.export": "导出",
  "qc.bench.source.label": "来源",
  "qc.bench.column.labUnit": "实验室单元",
  "qc.bench.column.test": "检测",
  "qc.bench.column.source": "来源",
  "qc.bench.column.failed": "失败数量",
  "eqa.distribution.updateSuccess": "分发草稿已更新。",
  "banner.menu.eqa.myCycles": "我的轮次",
  "banner.menu.eqa.labPerformance": "实验室表现",
  "banner.menu.eqa.followUpQueue": "本实验室的跟进",
  "banner.menu.eqa.analystCompetency": "分析人员能力",
  "banner.menu.eqa.provider": "室间质评提供者",
  "eqa.participant.myCycles.title": "我的室间质评轮次",
  "eqa.participant.myCycles.subtitle": "本实验室参加的轮次。结果录入和审核在 OpenELIS 标准结果流程中进行：本页面跟踪进度并引导您前往相应位置。",
  "eqa.participant.infoTitle": "室间质评结果通过标准审核流程处理。",
  "eqa.participant.infoBody": "点击实验室编号可打开该样本的标准结果录入。审核完成后，轮次将进入“已提交”（如计划要求轮次级复核，则进入“待提交”）。",
  "eqa.kpi.active": "进行中的轮次",
  "eqa.kpi.active.hint": "进行中",
  "eqa.kpi.readyToSubmit": "已完成的订单",
  "eqa.kpi.readyToSubmit.hint": "已开启复核标记",
  "eqa.kpi.awaiting": "待评分",
  "eqa.kpi.awaiting.hint": "已提交给提供者",
  "eqa.kpi.openNce": "与室间质评关联的未关闭不符合事件",
  "eqa.kpi.openNce.attention": "需要关注",
  "eqa.kpi.openNce.none": "无未关闭事件",
  "eqa.bucket.label": "状态",
  "eqa.bucket.active": "活跃",
  "eqa.bucket.awaiting": "待评分",
  "eqa.bucket.completed": "已完成",
  "eqa.bucket.all": "所有分析仪",
  "eqa.bucket.active.hint": "进行中的工作：即将开始、检测中或待提交",
  "eqa.bucket.awaiting.hint": "已提交给提供者；等待评分",
  "eqa.bucket.completed.hint": "已评分或已关闭",
  "eqa.bucket.all.hint": "本实验室参与过的所有轮次",
  "eqa.filter.schemeType": "计划类型",
  "eqa.schemeType.all": "所有类型",
  "eqa.schemeType.international_pt": "国际能力验证",
  "eqa.schemeType.regional_pt": "区域能力验证",
  "eqa.schemeType.inter_lab_split": "实验室间分样比对",
  "eqa.schemeType.in_house": "内部",
  "eqa.filter.searchCycles": "搜索计划、提供者或轮次",
  "eqa.filter.showing": "显示 {shown} / {total} 个轮次",
  "eqa.filter.clear": "清除筛选条件",
  "eqa.col.scheme": "计划",
  "eqa.col.type": "设备类型",
  "eqa.col.cycle": "轮次",
  "eqa.col.status": "状态",
  "eqa.col.deadline": "截止日期",
  "eqa.col.progress": "进度",
  "eqa.cycle.status.planned": "已计划",
  "eqa.cycle.status.panel_received": "面板已接收",
  "eqa.cycle.status.testing": "检测中",
  "eqa.cycle.status.ready_to_submit": "已完成的订单",
  "eqa.cycle.status.submitted": "已提交",
  "eqa.cycle.status.scored": "已评分",
  "eqa.cycle.status.closed": "已关闭",
  "eqa.cycle.toggleDetails": "展开/收起轮次详情",
  "eqa.cycle.emptyFiltered": "没有符合这些筛选条件的轮次。",
  "eqa.cycle.nceBanner": "{scheme} 出现不可接受评分。请在不符合事件登记中跟进。",
  "eqa.cycle.perAnalyst.title": "需按分析人员记录",
  "eqa.cycle.perAnalyst.body": "分析人员在注册计划时完成映射。按分析人员列显示在标准结果录入页面上。",
  "eqa.cycle.review.title": "此计划已启用可选的轮次级复核。",
  "eqa.cycle.review.body": "全部 {total} 个分析物已在标准流程中完成审核。只需单击一次即可提交：审核是权威关口，无需重新验证身份。",
  "eqa.btn.reviewSubmit": "复核并提交",
  "eqa.cycle.submitted.success": "轮次已提交给提供者，等待评分。",
  "eqa.cycle.submitted.error": "提交失败：轮次未推进。请检查所有结果是否已审核，然后重试。",
  "eqa.progress.title": "样本进度",
  "eqa.sample.labNo": "实验室编号",
  "eqa.sample.providerId": "提供者样本ID",
  "eqa.sample.analytes": "分析物",
  "eqa.sample.analyst": "指定分析人员",
  "eqa.sample.entryStatus": "录入状态",
  "eqa.labNo.tooltip": "打开此实验室编号的结果录入",
  "eqa.entry.entered": "已录入",
  "eqa.entry.in_progress": "进行中",
  "eqa.entry.empty": "未录入",
  "eqa.cycle.scoredCopy": "评分已完成。已评分结果显示在“实验室表现”下。",
  "eqa.cycle.submittedCopy": "已提交给提供者，等待评分。",
  "eqa.cycle.closedCopy": "轮次已关闭。",
  "eqa.cycle.panelReceivedCopy": "面板已接收。请进入标准结果录入开始检测。",
  "eqa.cycle.plannedCopy": "本实验室尚未接收面板。请勾选室间质评框打开“添加订单”以记录接收。",
  "eqa.btn.receivePanel": "接收面板：打开“添加订单”",
  "eqa.uncycled.title": "未关联轮次的室间质评订单",
  "eqa.uncycled.subtitle": "未关联轮次的室间质评订单。这些订单保留在此处，以免遗漏。",
  "eqa.review.title": "提交前摘要",
  "eqa.review.subtitle": "按样本分组的所有已审核结果的只读摘要。这些内容将提交给提供者。",
  "eqa.review.auditFootnote": "上述每个值均已在标准流程中审核，审核用户已记录在审计轨迹中。提交仅记录确认，不另行签核。",
  "eqa.sample.analyte": "分析物",
  "eqa.sample.reportedValue": "报告值",
  "eqa.sample.validatedAt": "已审核",
  "eqa.order.cycle": "室间质评轮次",
  "eqa.order.receipt.title": "面板接收",
  "eqa.order.receipt.tempC": "到达时温度（°C）",
  "eqa.order.receipt.integrityOk": "面板送达时完好",
  "eqa.order.receipt.notes": "完整性备注",
  "eqa.order.receipt.recorded": "已于 {date} 记录面板接收。",
  "eqa.cycle.status.prep_in_progress": "准备中",
  "eqa.cycle.status.ready_to_ship": "待发货",
  "eqa.cycle.status.shipped": "已发货",
  "eqa.cycle.status.delivered": "已送达",
  "eqa.cycle.status.submissions_open": "提交已开放",
  "eqa.cycle.status.submissions_closed": "提交已关闭",
  "eqa.cycle.status.scoring": "评分中",
  "eqa.provider.workbench.cycle": "轮次工作台",
  "eqa.provider.workbench.forCycle": "制备与发运：{name}",
  "eqa.provider.workbench.tabs": "工作台",
  "eqa.provider.workbench.stateHint": "制备必须通过库存和质控关卡后，才能发送任何面板。",
  "eqa.prep.tab": "制备",
  "eqa.prep.participants": "参与者管理",
  "eqa.prep.panels": "检测面板",
  "eqa.prep.gate": "待发运关卡",
  "eqa.prep.gate.clear": "所有制备要求均已满足",
  "eqa.prep.noPanel.title": "尚未制备面板",
  "eqa.prep.noPanel.body": "请先创建轮次的面板及其样本，再记录制备进度。",
  "eqa.prep.needExplained": "所需分装样本：{samples, plural, one {# 个样本} other {# 个样本}} x {participants, plural, one {# 个参与者} other {# 个参与者}} + 预留 {reserved} 个 = {needed, plural, one {# 个分装样本} other {# 个分装样本}}；目前已发送 {shipped, plural, one {# 个分装样本} other {# 个分装样本}}。",
  "eqa.prep.produced": "已制备分装样本",
  "eqa.prep.reserved": "预留分装样本",
  "eqa.prep.shortfall": "缺少 {n} 个",
  "eqa.prep.homogeneity": "均匀性质控已通过",
  "eqa.prep.homogeneityNotes": "质控备注",
  "eqa.prep.save": "保存制备记录",
  "eqa.prep.saved": "制备记录已更新。",
  "eqa.prep.saveFailed": "制备记录未保存。",
  "eqa.prep.readyToShip": "将轮次标记为待发运",
  "eqa.prep.readyToShip.success": "轮次已放行发运：请在“转运”标签页记录快递详情。",
  "eqa.prep.readyToShip.refused": "轮次未被放行发运。请解决未完成的制备事项后重试。",
  "eqa.shipment.tab": "转运列表",
  "eqa.shipment.participant": "参加者",
  "eqa.shipment.box": "箱子",
  "eqa.shipment.courier": "快递公司",
  "eqa.shipment.courierFor": "{name} 的快递公司",
  "eqa.shipment.tracking": "运单号",
  "eqa.shipment.trackingFor": "{name} 的运单号",
  "eqa.shipment.expected": "预计送达日期",
  "eqa.shipment.expectedFor": "{name} 的预计送达日期",
  "eqa.shipment.selectAll": "全选待处理项",
  "eqa.shipment.selectRow": "选择 {name} 进行发送",
  "eqa.shipment.markShipped": "将 {n} 个标记为已发货",
  "eqa.shipment.firstShipHint": "首次发送后，轮次将变为已发货。",
  "eqa.shipment.saved": "寄送详情已保存。",
  "eqa.shipment.saveFailed": "未保存寄送详情。",
  "eqa.shipment.shipped": "已发送 {n} 个参加者寄送批次。",
  "eqa.shipment.shipFailed": "未发送任何内容。",
  "eqa.shipment.shippedOn": "已于 {date} 发货",
  "eqa.shipment.packList": "装箱单",
  "eqa.shipment.packList.noPanel": "此轮次没有面板，因此无需装箱。",
  "eqa.shipment.packList.unavailable": "无法读取面板样本，因此未生成装箱单。请重新加载后重试。",
  "eqa.shipment.packList.notes": "室间质评面板材料：检测期开始前请勿打开。",
  "eqa.shipment.label": "标签",
  "eqa.shipment.noParticipants.title": "无参加者",
  "eqa.shipment.noParticipants.body": "请先在此轮次中注册参加实验室，再寄送面板。",
  "eqa.report.download": "下载表现报告",
  "banner.menu.eqa.inHouse": "内部盲样",
  "eqa.inhouse.wizard.title": "创建内部盲样面板",
  "eqa.inhouse.step1": "计划与轮次",
  "eqa.inhouse.step2": "样本与制备",
  "eqa.inhouse.step3": "分析人员",
  "eqa.inhouse.step4": "确认并封存",
  "eqa.inhouse.scheme": "内部计划",
  "eqa.inhouse.cycleName": "轮次名称",
  "eqa.inhouse.plannedStart": "计划开始日期",
  "eqa.inhouse.unblindDate": "揭盲日期（提交截止日期）",
  "eqa.inhouse.sample": "样本",
  "eqa.inhouse.samples": "样本",
  "eqa.inhouse.test": "检测",
  "eqa.inhouse.target": "靶值",
  "eqa.inhouse.unit": "单位",
  "eqa.inhouse.rangeLow": "范围下限",
  "eqa.inhouse.rangeHigh": "范围上限",
  "eqa.inhouse.addSample": "添加样本",
  "eqa.inhouse.analyst": "分析人员",
  "eqa.inhouse.roster": "计划分析人员",
  "eqa.inhouse.roster.pick": "选择分析人员",
  "eqa.inhouse.roster.saveError": "无法保存分析人员名单",
  "eqa.inhouse.assign.manual": "手动分配分析人员（否则轮流分配）",
  "eqa.inhouse.assign.mode": "分配方式",
  "eqa.inhouse.assign.ROUND_ROBIN": "轮流分配：每个样本分配一位分析人员，依次轮换",
  "eqa.inhouse.assign.IDENTICAL": "相同样本组：每位分析人员检测相同的样本",
  "eqa.inhouse.assign.MANUAL": "按样本手动分配",
  "eqa.inhouse.assign.identicalNote": "每位分析人员检测每个样本：{materials, plural, one {# 个样本} other {# 个样本}} × {analysts, plural, one {# 位分析人员} other {# 位分析人员}} = {aliquots, plural, one {# 份盲样分装样本} other {# 份盲样分装样本}}，每份都有各自的盲码。",
  "eqa.inhouse.assign.footnote": "每次分配都会记录在其创建的盲样订单上，并随该订单进入结果录入。",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "相同样本组需要计划名单中至少有一位分析人员",
  "eqa.inhouse.samplesLeadIn": "{count, plural, other {# 个样本}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "盲样分装样本",
  "eqa.inhouse.confirm.sealWarning": "封存将加密靶值",
  "eqa.inhouse.confirm.sealWarningBody": "封存后，揭示靶值需要揭盲权限，并会记录在审计跟踪中。此后面板将无法编辑。",
  "eqa.inhouse.confirm.afterSeal": "封存后将为每份分装样本创建一个盲样订单。这些订单以盲码显示在结果录入和工作计划中，与其他订单相同。",
  "eqa.inhouse.prep.sourceType": "来源",
  "eqa.inhouse.prep.lotNumber": "批号",
  "eqa.inhouse.prep.aliquots": "已制备的分装样本",
  "eqa.inhouse.prep.storageTemp": "存储温度",
  "eqa.inhouse.prep.expiration": "有效期",
  "eqa.inhouse.prep.homogeneity": "均匀性质控已通过",
  "eqa.inhouse.prep.homogeneityNotes": "均匀性质控备注",
  "eqa.inhouse.gate.noSamples": "请至少添加一个样本后再继续",
  "eqa.inhouse.gate.aliquots": "制备的分装样本必须覆盖所有盲样",
  "eqa.inhouse.gate.homogeneity": "均匀性质控未通过，因此分发需要书面说明理由",
  "eqa.inhouse.gate.targets": "每个样本都需要一项检测和一个靶值",
  "eqa.inhouse.confirm.samples": "样本",
  "eqa.inhouse.confirm.labelNote": "标签页仅包含盲码、轮次和分析物，绝不包含靶值。",
  "eqa.inhouse.seal": "封存面板并分发",
  "eqa.inhouse.seal.error": "无法封存面板",
  "eqa.inhouse.seal.cycleError": "无法创建轮次",
  "eqa.inhouse.seal.panelError": "无法创建面板",
  "eqa.inhouse.sealed.title": "面板已封存并分发",
  "eqa.inhouse.sealed.help": "盲样订单现以这些盲码作为其样本ID，显示在结果录入和工作计划中。",
  "eqa.inhouse.sealed.done": "返回内部面板",
  "eqa.inhouse.panel": "室间质评质控品面板",
  "eqa.inhouse.panel.defaultName": "内部面板",
  "eqa.inhouse.cycle": "轮次",
  "eqa.inhouse.status": "状态",
  "eqa.inhouse.actions": "操作",
  "eqa.inhouse.launchWizard": "启动设盲向导",
  "eqa.inhouse.noSchemes": "尚无内部计划。请先在室间质评计划管理中创建一个。",
  "eqa.inhouse.labels.print": "打印标签页",
  "eqa.inhouse.labels.error": "无法生成标签页",
  "eqa.inhouse.unblind.now": "立即揭盲",
  "eqa.inhouse.unblind.done": "面板已揭盲并评分",
  "eqa.inhouse.unblind.error": "无法揭盲此面板",
  "eqa.inhouse.targetValues": "靶值",
  "eqa.inhouse.seal.sealed": "已封存",
  "eqa.inhouse.seal.unsealed": "未封存",
  "eqa.inhouse.kpi.awaitingDistribution": "已封存，待分发",
  "eqa.inhouse.kpi.inTesting": "检测中",
  "eqa.inhouse.kpi.unblindingSoon": "7 天内揭盲",
  "eqa.inhouse.kpi.closed": "已评分或已关闭",
  "eqa.inhouse.prep.title": "制备与分装详情",
  "eqa.inhouse.prep.subtitle": "记录与提供者相同的面板库存详情。",
  "eqa.inhouse.prep.required": "要求：{samples, plural, one {# 个样本} other {# 个样本}} = 至少 {samples, plural, one {# 份分装样本} other {# 份分装样本}}",
  "eqa.inhouse.back": "返回",
  "eqa.inhouse.next": "下一个",
  "eqa.inhouse.cancel": "取消",
  "eqa.enrollment.testAnalytes": "各检测的报告分析物",
  "eqa.enrollment.testAnalytes.help": "设置本计划中每项检测所报告的分析物。结果将以该分析物提交给提供者；未设置的检测不会自动提交。",
  "eqa.enrollment.selectAnalyte": "选择分析物",
  "eqa.provider.schemes.title": "我们提供的室间质评计划",
  "eqa.provider.schemes.hint": "展开计划可查看其轮次，或新建轮次以定义其面板和参与者。",
  "eqa.provider.schemes.none.title": "尚无可提供的计划",
  "eqa.provider.schemes.none.body": "其他实验室有效注册某计划后，该计划将显示在此处。",
  "eqa.provider.schemes.provider": "供应商",
  "eqa.provider.schemes.enrolled": "已注册实验室",
  "eqa.provider.schemes.cycles": "轮次",
  "eqa.provider.schemes.expand": "显示轮次",
  "eqa.provider.schemes.newCycle": "新建轮次",
  "eqa.provider.schemes.noCycles": "尚无轮次。新建轮次以定义其面板和参与者。",
  "eqa.scheme.type.international_pt": "国际能力验证",
  "eqa.scheme.type.regional_pt": "区域能力验证",
  "eqa.scheme.type.inter_lab_split": "实验室间分样比对",
  "eqa.scheme.type.in_house": "内部",
  "eqa.panel.source.in_house_aliquoted": "患者样本混样，内部分装",
  "eqa.panel.source.vendor_sourced": "供应商提供的材料",
  "eqa.panel.source.mixed": "混合来源",
  "eqa.panel.storage.ambient": "室温",
  "eqa.panel.storage.refrigerated_2_8c": "冷藏，2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "冷冻，−20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "超低温冷冻，−80°C",
  "eqa.panel.storage.dry_ice": "干冰",
  "eqa.provider.wizard.title": "新建轮次",
  "eqa.provider.wizard.forScheme": "新建轮次：{name}",
  "eqa.provider.wizard.step.cycle": "轮次",
  "eqa.provider.wizard.step.panel": "面板",
  "eqa.provider.wizard.step.distribution": "分发",
  "eqa.provider.wizard.cycleName": "轮次名称",
  "eqa.provider.wizard.cycleNumber": "轮次编号",
  "eqa.provider.wizard.cycleNumber.hint": "留空时，将使用此计划下一个未使用的编号。",
  "eqa.provider.wizard.panelName": "面板名称",
  "eqa.provider.wizard.source": "材料来源",
  "eqa.provider.wizard.lot": "批号",
  "eqa.provider.wizard.vendor": "供应商名称",
  "eqa.provider.wizard.vendorLot": "供应商批号",
  "eqa.provider.wizard.vendorCertificate": "供应商证书参考号",
  "eqa.provider.wizard.sampleCode": "样本代码",
  "eqa.provider.wizard.target": "靶值",
  "eqa.provider.wizard.target.hint": "靶值在存储时被封存并加密；如靶值仅在评分时才知晓，请留空。",
  "eqa.provider.wizard.unit": "单位",
  "eqa.provider.wizard.rangeLow": "可接受下限",
  "eqa.provider.wizard.rangeHigh": "可接受上限",
  "eqa.provider.wizard.addSample": "添加样本",
  "eqa.provider.wizard.removeSample": "移除",
  "eqa.provider.wizard.sampleCount": "面板样本",
  "eqa.provider.wizard.test": "检测",
  "eqa.provider.wizard.test.select": "选择一项检测",
  "eqa.provider.wizard.participants": "参与实验室",
  "eqa.provider.wizard.participants.hint": "只有有效注册此计划的实验室才能参加，且制备关卡只计算此处所选的实验室。",
  "eqa.provider.wizard.storageTemp": "存储温度",
  "eqa.provider.wizard.storageTemp.hint": "将作为每个转运箱的温度要求。",
  "eqa.provider.wizard.storageTemp.select": "选择温度",
  "eqa.provider.wizard.expiration": "材料有效期",
  "eqa.provider.wizard.reserve.hint": "材料制备完成后，为重复检测预留的分装样本将记录在制备工作台上。",
  "eqa.provider.wizard.confirm.hint": "创建轮次后将直接进入制备阶段，在此记录分装样本数量和均匀性质控。",
  "eqa.provider.wizard.create": "创建轮次并开始制备",
  "eqa.provider.wizard.failed": "轮次未创建。",
  "eqa.cycle.distributionMethod": "分发方式",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "CSV 导出",
  "eqa.cycle.distributionMethod.mixed": "混合",
  "eqa.cycle.distributionMethod.hint": "通过 FHIR 连接、导出文件，或在参与者不同时两者兼用。面板的冷链信息及其来源将在第 2 步中记录。",
  "eqa.cycle.history": "轮次历史",
  "eqa.cycle.history.empty": "此轮次尚未记录任何状态变更。",
  "eqa.cycle.history.when": "时间",
  "eqa.cycle.history.state": "状态",
  "eqa.cycle.history.trigger": "触发方式",
  "eqa.cycle.history.reason": "理由",
  "eqa.cycle.history.manual": "手动",
  "eqa.report.comments.tab": "报告备注",
  "eqa.report.comments.hint": "只能打印预先批准的备注。请在“管理 → 字典管理”下编辑措辞。",
  "eqa.report.comments.picker": "已批准的备注",
  "eqa.report.comments.pickerLabel": "选择备注",
  "eqa.report.comments.add": "添加到报告",
  "eqa.report.comments.added": "已将 {count} 条备注添加到报告",
  "eqa.report.comments.comment": "备注",
  "eqa.report.comments.attribution": "添加人",
  "eqa.report.comments.none": "此轮次的报告尚无备注。",
  "eqa.report.comments.remove": "移除",
  "eqa.report.comments.emptyLibrary.title": "未配置已批准的备注",
  "eqa.report.comments.emptyLibrary.body": "在“室间质评报告备注”字典类别中添加条目，即可在此处选择。",
  "eqa.report.comments.addFailed": "无法将备注添加到报告。",
  "eqa.report.comments.removeFailed": "无法从报告中移除备注。",
  "eqa.performance.ACCEPTABLE": "可接受",
  "eqa.performance.QUESTIONABLE": "可疑",
  "eqa.performance.UNACCEPTABLE": "不可接受",
  "eqa.oversight.followUpQueue": "本实验室的跟进",
  "eqa.oversight.queueSubtitle": "本实验室待纠正复核的可疑室间质评评分，来自外部提供者及本实验室自身的内部计划。与参加本实验室所提供计划的实验室之间的往来沟通属于另一个登记册：",
  "eqa.queue.policyTitle": "自动不符合事件策略已启用。",
  "eqa.queue.policyBody": "本实验室参加的任何外部计划中出现不可接受分数时，将自动创建不符合事件。此队列包含可疑范围（2 < |Z| ≤ 3）和内部失败，需要人工分诊。",
  "eqa.queue.kpi.queued": "排队条目",
  "eqa.queue.kpi.questionable": "可疑",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "内部失败",
  "eqa.queue.kpi.oldest": "最早",
  "eqa.queue.kpi.days": "{days} 天",
  "eqa.queue.count": "队列 · {count, plural, one {# 项} other {# 项}}",
  "eqa.queue.exportCsv": "导出翻译",
  "eqa.queue.empty": "没有待分诊的条目。轮次评分后，可疑分数和内部失败将显示在此处。",
  "eqa.queue.cycle": "轮次",
  "eqa.queue.cycleNumber": "轮次 {number}",
  "eqa.queue.analyte": "分析物",
  "eqa.queue.analytePlus": "{first} 等另 {more} 项",
  "eqa.queue.zScore": "Z分数",
  "eqa.queue.reason": "理由",
  "eqa.queue.enqueued": "已入队",
  "eqa.queue.source": "来源",
  "eqa.queue.source.external": "外部提供者",
  "eqa.queue.source.in_house": "内部",
  "eqa.queue.source.inter_lab_split": "实验室间分样比对",
  "eqa.queue.reason.questionable": "可疑",
  "eqa.queue.reason.inHouseFailure": "内部失败",
  "eqa.queue.triage": "分诊",
  "eqa.queue.triageTitle": "分诊此条目",
  "eqa.queue.triageHelp": "如果怀疑存在真正的不符合项，请升级。如果只是干扰（例如转录错误，或已记录的设备故障），请填写原因并忽略。已忽略的条目仍与轮次关联，以供认可追溯。",
  "eqa.queue.reported": "已报告",
  "eqa.queue.target": "靶值",
  "eqa.queue.verdict": "判定",
  "eqa.queue.escalate": "升级为不符合事件",
  "eqa.queue.dismiss": "填写原因并忽略",
  "eqa.queue.viewCycle": "查看轮次",
  "eqa.queue.escalated": "已升级：已为此轮次创建不符合事件 {nce}。",
  "eqa.queue.escalateFailed": "升级请求被拒绝。",
  "eqa.queue.dismissed": "已忽略。已记录此类别对应的能力事件。",
  "eqa.queue.dismissFailed": "忽略请求被拒绝。",
  "eqa.queue.dismissHeading": "填写原因并忽略",
  "eqa.queue.dismissConfirm": "忽略",
  "eqa.queue.dismissHelp": "所选类别决定针对此条目涵盖的每个结果记录哪种能力事件，请选择最能描述实际情况的类别。",
  "eqa.queue.cancel": "取消",
  "eqa.queue.category": "类别",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "转录错误",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "已知设备问题",
  "eqa.queue.category.PENDING_RE_TEST": "待重新检测",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "复核后可接受",
  "eqa.queue.category.OTHER": "其他原因",
  "eqa.queue.notes": "备注",
  "eqa.labperf.title": "实验室表现",
  "eqa.labperf.coverage.title": "实验室室间质评表现：覆盖情况",
  "eqa.labperf.coverage.subtitle": "认可概览：先显示全实验室 KPI，再按实验室单元显示各计划最近四个轮次的室间质评覆盖情况。没有有效能力验证的实验室单元可考虑采用 ISO 15189 §7.7.2 替代评估。",
  "eqa.labperf.recent.title": "实验室室间质评表现：最近轮次",
  "eqa.labperf.recent.subtitle": "本实验室最近 12 个月内报告的轮次，包括评分状态和结论。",
  "eqa.labperf.tab.coverage": "覆盖情况",
  "eqa.labperf.tab.recent": "最近轮次",
  "eqa.labperf.kpi.acceptance": "可接受率（12 个月）",
  "eqa.labperf.kpi.delta": "较上一年 {delta}",
  "eqa.labperf.kpi.noPriorYear": "无上一年数据可比较",
  "eqa.labperf.kpi.onTime": "按时提交率",
  "eqa.labperf.kpi.late": "{total} 次中 {late} 次逾期",
  "eqa.labperf.kpi.nce": "室间质评触发的不符合事件（12 个月）",
  "eqa.labperf.kpi.nceOpen": "{open} 个未关闭 → 不符合事件登记册",
  "eqa.labperf.kpi.uncovered": "无室间质评的已认可检测",
  "eqa.labperf.kpi.uncovered.hint": "§7.7.2 候选项",
  "eqa.labperf.openNceRegister": "打开已筛选为室间质评触发事件的不符合事件登记册",
  "eqa.labperf.legendIntro": "各计划最近四个轮次，按实验室单元列出。",
  "eqa.labperf.legend.acceptable": "可接受",
  "eqa.labperf.legend.questionable": "可疑",
  "eqa.labperf.legend.unacceptable": "不可接受",
  "eqa.labperf.legend.missing": "未注册 / 已错过",
  "eqa.labperf.section": "实验室单元",
  "eqa.labperf.unassignedSection": "未分配实验室单元",
  "eqa.labperf.scheme": "计划",
  "eqa.labperf.cycle": "轮次",
  "eqa.labperf.cycleOffset": "轮次 −{n}",
  "eqa.labperf.mostRecent": "最近",
  "eqa.labperf.acceptanceRate": "可接受率",
  "eqa.labperf.coverage.empty": "尚无已评分的室间质评结果。本实验室参加的轮次评分后将显示覆盖情况。",
  "eqa.labperf.gapTitle": "已认可但无室间质评覆盖：",
  "eqa.labperf.gapBody": "{tests}：没有有效的室间质评注册，因此需要进行 ISO 15189 §7.7.2 替代评估。",
  "eqa.labperf.filterScheme": "筛选计划",
  "eqa.labperf.status": "状态",
  "eqa.labperf.score": "得分",
  "eqa.labperf.scoreOf": "{scored} 个中 {acceptable} 个",
  "eqa.labperf.performance": "表现",
  "eqa.labperf.submitted": "已提交",
  "eqa.labperf.pending": "待处理",
  "eqa.labperf.verdict.acceptable": "可接受",
  "eqa.labperf.verdict.questionable": "可疑",
  "eqa.labperf.verdict.unacceptable": "不可接受",
  "eqa.labperf.recent.empty": "最近 12 个月内无已报告的轮次。",
  "nce.filter.source": "来源",
  "nce.filter.source.all": "所有来源",
  "nce.filter.source.eqa": "由室间质评触发",
  "eqa.receipt.tab": "接收与评分",
  "eqa.receipt.hint": "所有参加者都收到其面板后，提交将自动开放。逾期是指超过预计送达日期两个工作日。",
  "eqa.receipt.noParticipants.body": "面板发送给已注册的参加实验室后，接收记录将显示在此处。",
  "eqa.receipt.condition": "状况",
  "eqa.receipt.damaged": "已损坏：{notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "重新寄送",
  "eqa.receipt.markReceived": "标记为已接收",
  "eqa.receipt.delivered": "已记录送达。",
  "eqa.receipt.deliveredFailed": "无法记录送达。",
  "eqa.receipt.sendRepeat": "重新寄送",
  "eqa.receipt.repeatHeading": "发送重新寄送的面板",
  "eqa.receipt.repeatHelp": "重新寄送的面板从该面板的储备中取用。如果储备不足，在使用非储备材料前需要提供书面理由。",
  "eqa.receipt.overrideNote": "覆盖说明",
  "eqa.receipt.repeatSent": "已发送重新寄送的面板。",
  "eqa.receipt.repeatFailed": "重新寄送请求被拒绝。",
  "eqa.receipt.status.NOT_SHIPPED": "未发货",
  "eqa.receipt.status.IN_TRANSIT": "运输中",
  "eqa.receipt.status.EXCEPTION": "到达时已损坏",
  "eqa.score.scoreCycle": "为轮次评分",
  "eqa.score.scored": "轮次已评分。不可接受的参加者已列入跟进登记册。",
  "eqa.score.scoreFailed": "无法为此轮次评分。",
  "eqa.score.verdicts": "分数",
  "eqa.score.counts": "{total} 个中有 {unacceptable} 个不可接受",
  "eqa.score.sendScores": "发送分数",
  "eqa.score.distributed": "分数已放入 FHIR 存储库，供参加者获取。",
  "eqa.score.distributeFailed": "无法返回分数。",
  "eqa.score.downloadCsv": "分数 CSV",
  "eqa.provider.followups.title": "参与者跟进",
  "eqa.provider.followups.subtitle": "参加本实验室所提供计划且返回不可接受结果的实验室。此处的跟进是与其他实验室的往来沟通，不会在本实验室自身的登记册中创建不符合项。",
  "eqa.provider.followups.open": "跟进登记册",
  "eqa.provider.followups.empty": "暂无参与者跟进。提供者轮次评分后，条目将显示在此处。",
  "eqa.provider.followups.unknownOrg": "未知实验室",
  "eqa.provider.followups.persistent": "持续失败",
  "eqa.provider.followups.response": "回复",
  "eqa.provider.followups.notify": "通知实验室",
  "eqa.provider.followups.emailed": "通知已通过电子邮件发送至 {to}。",
  "eqa.provider.followups.csvFallback": "未登记联系邮箱：通知已下载为 CSV 文件，请手动发送。",
  "eqa.provider.followups.flagRepeat": "标记为重复检测",
  "eqa.provider.followups.repeatSent": "重复面板已发送至 {name}。",
  "eqa.provider.followups.moved": "跟进已移至 {status}。",
  "eqa.provider.followups.failed": "操作被拒绝。",
  "eqa.provider.followups.notesHelp": "与该实验室达成的约定。记录在登记册条目中，用于认可追溯。",
  "eqa.provider.followups.status.NOTIFIED": "已通知",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "已收到回复",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "调查中",
  "eqa.provider.followups.status.ESCALATED": "已升级",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "已从计划中移除",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "记录回复",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "调查",
  "eqa.provider.followups.action.RESOLVED": "解决",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "从计划中移除",
  "eqa.competency.subtitle": "过去十二个月内分配参加能力验证的所有分析人员，按分析物分级。只有在证据支持时分析人员才被评为合格：可评估样本少于四个时显示为复核中，而不是通过。",
  "eqa.competency.band.competent": "合格",
  "eqa.competency.band.underReview": "复核中",
  "eqa.competency.band.notCompetent": "不合格",
  "eqa.competency.outcome.acceptable": "可接受",
  "eqa.competency.outcome.questionable": "可疑",
  "eqa.competency.outcome.unacceptable": "不可接受",
  "eqa.competency.outcome.missed": "已错过截止日期",
  "eqa.competency.outcome.dismissed": "分诊时已忽略",
  "eqa.competency.event.scored": "已评分结果",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "不可接受评分",
  "eqa.competency.event.QUESTIONABLE_SCORE": "可疑评分",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "错过提供者截止日期",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "错过内部截止日期",
  "eqa.competency.event.ESCALATED_TO_NCE": "已升级为不符合项",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "已忽略：设备原因",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "已忽略：转录错误",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "已忽略：复核后可接受",
  "eqa.competency.event.DISMISSED_OTHER": "已忽略：其他原因",
  "eqa.competency.kpi.analysts": "已评估分析人员",
  "eqa.competency.kpi.samples": "{count} 个能力验证样本",
  "eqa.competency.kpi.notCompetent.hint": "未关闭的已升级不符合事件",
  "eqa.competency.search": "筛选分析人员",
  "eqa.competency.export": "导出翻译",
  "eqa.competency.analyst": "分析人员",
  "eqa.competency.samples": "能力验证样本（12 个月）",
  "eqa.competency.recent": "最近表现",
  "eqa.competency.status": "能力",
  "eqa.competency.history": "历史",
  "eqa.competency.viewHistory": "查看历史记录",
  "eqa.competency.empty": "过去十二个月内没有在任何室间质评结果上记录分析人员。结果分配了分析人员后，分析人员将显示在此处。",
  "eqa.competency.analyteCount": "已评估 {count} 个分析物",
  "eqa.competency.thisYear": "今年 {count} 个 · {failures} 个失败",
  "eqa.competency.byAnalyte": "按分析物的能力评估",
  "eqa.competency.analyte": "分析物",
  "eqa.competency.evaluable": "可评估",
  "eqa.competency.failures": "失败次数",
  "eqa.competency.latest": "最新",
  "eqa.competency.unnamedAnalyte": "未命名分析物",
  "eqa.competency.evidence": "证据 · 时间窗口内的所有事件",
  "eqa.competency.date": "日期",
  "eqa.competency.scheme": "计划",
  "eqa.competency.event": "活动",
  "eqa.competency.outcome": "结果",
  "eqa.competency.counted": "计入",
  "eqa.competency.countsFail": "失败",
  "eqa.competency.countsPass": "已评估",
  "eqa.competency.countsExcused": "已豁免",
  "eqa.result.analyst": "分析人员（室间质评）",
  "eqa.result.analystChoose": "选择分析人员",
  "eqa.result.analystRequired": "此室间质评计划会记录每个样本的检测人。请在保存前选择分析人员。",
  "eqa.program.perAnalyst": "在每个结果上记录分析人员",
  "eqa.program.perAnalyst.on": "已记录分析人员",
  "eqa.program.perAnalyst.off": "未记录",
  "eqa.result.analyst.tooltip": "显示此列是因为本次运行包含一个室间质评样本，其计划会记录每个样本的检测人。请从计划的分析人员名单中选择检测该样本的 OpenELIS 用户；这与录入此结果的人员和审核此结果的人员是分开记录的。非室间质评行无需填写。",
  "shipment.settings.siteOrgUnsetTitle": "未设置站点机构",
  "shipment.settings.siteOrgUnsetSubtitle": "传入的寄送批次不会按本站点筛选，传出的转运箱也不带发送方。请选择代表本实验室的机构。",
  "shipment.settings.siteOrgUnmatchedTitle": "已设为本实例中不存在的机构",
  "shipment.settings.siteOrgUnmatchedSubtitle": "下方 UUID 是合作方用于识别本实验室的标识，它与本系统中的任何机构都不匹配。筛选功能正常；除非合作方更改，否则请保持不变。",
  "eqa.receipt.openSubmissions": "开放提交",
  "eqa.receipt.openSubmissionsHeading": "在仍有面板未送达时开放提交",
  "eqa.receipt.openSubmissionsHelp": "尚未收到面板的参加者将在名单中保留为逾期。这是一项有记录的手动覆盖操作，请填写原因。",
  "eqa.receipt.openSubmissionsReason": "理由",
  "eqa.receipt.submissionsOpened": "提交已开放。",
  "eqa.receipt.submissionsOpenFailed": "无法开放提交。",
  "eqa.provider.schemes.lastDistribution": "最近一次分发",
  "eqa.provider.wizard.distributionDate": "分发日期",
  "eqa.provider.wizard.submissionDeadline": "提交截止日期",
  "eqa.provider.kpi.activeSchemes": "活动计划",
  "eqa.provider.kpi.openCycles": "未关闭的轮次",
  "eqa.provider.kpi.enrolled": "已注册参与者",
  "eqa.provider.kpi.followupsOpen": "未关闭的跟进",
  "eqa.provider.schemes.discipline": "专业",
  "eqa.cycle.history.actor": "操作人",
  "eqa.cycle.history.systemActor": "系统",
  "eqa.prep.reserved.recommend": "建议 {n} 个：max（参与者的 10%，5）",
  "eqa.provider.schemes.participantOnly.title": "仅参与者视图",
  "eqa.provider.schemes.participantOnly.body": "提供者计划管理需要提供者权限。本实验室的参与信息位于下方页面。",
  "eqa.provider.schemes.link.myPrograms": "我的注册：本实验室参加的计划",
  "eqa.provider.schemes.link.myCycles": "我的轮次：面板、结果和截止日期",
  "eqa.btn.newCycle": "新建轮次",
  "eqa.cycle.new.heading": "新建室间质评轮次",
  "eqa.cycle.new.help": "适用于不向此 OpenELIS 发送寄送批次的提供者：记录面板所属的轮次，使其显示在此处并可使用“接收面板”。来自 OpenELIS 提供者的寄送批次在导入时会自动开启其轮次。",
  "eqa.cycle.new.scheme": "计划（来自“我的室间质评计划”）",
  "eqa.cycle.new.name": "轮次名称",
  "eqa.cycle.new.distributionDate": "分发日期",
  "eqa.cycle.new.deadline": "提交截止日期",
  "eqa.cycle.new.create": "创建轮次",
  "eqa.cycle.new.created": "轮次已创建。其状态为“已计划”；面板到达时请使用“接收面板”。",
  "eqa.cycle.new.error": "无法创建轮次",
  "eqa.cycle.new.noPrograms": "请先在“我的室间质评计划”中注册一个计划。",
  "eqa.order.receipt.consignment": "入库托运批次",
  "eqa.order.receipt.consignment.none": "无：在转运模块之外接收",
  "eqa.order.receipt.consignment.thisCycle": "本轮次",
  "eqa.order.receipt.consignment.help": "选择托运批次即表示接收该批次，并通知提供者面板已送达。",
  "eqa.order.receipt.reference": "转运参考号",
  "eqa.order.receipt.referenceRecorded": "寄送批次 {code} 已接收。",
  "eqa.intake.enterResults": "录入结果",
  "eqa.intake.heading": "来自 {lab} 的结果",
  "eqa.intake.help": "按参与者报告的原样录入数值：数字，或“有反应”等文字。保存将覆盖该检测已存档的内容。",
  "eqa.intake.test": "检测",
  "eqa.intake.value": "报告值",
  "eqa.intake.save": "保存结果",
  "eqa.intake.saved": "已为 {lab} 记录结果。",
  "eqa.intake.failed": "无法记录结果",
  "eqa.intake.csv": "或粘贴参与者的导出包（CSV）",
  "eqa.intake.import": "导入CSV",
  "eqa.intake.imported": "{count, plural, other {已导入 # 个数值。}}",
  "eqa.intake.noTests": "此计划尚未分配任何检测。",
  "eqa.cycle.importScores": "导入评分（CSV）",
  "eqa.cycle.importScores.heading": "导入提供者的评分",
  "eqa.cycle.importScores.help": "粘贴提供者发送的评分 CSV（包含 analyte_name 和 performance_status 列）。来自 OpenELIS 提供者的评分会通过 FHIR 存储自动到达。",
  "eqa.cycle.importScores.csv": "评分 CSV",
  "eqa.cycle.importScores.import": "导入评分",
  "eqa.cycle.importScores.imported": "已记录 {count} 个评分。",
  "eqa.cycle.importScores.unmapped": "此处无法识别：{names}",
  "eqa.cycle.importScores.failed": "无法导入评分",
  "eqa.program.schemeType": "计划类型",
  "eqa.program.schemeType.helper": "内部计划由本实验室运行，无需提供者；其他所有类型均需要提供者。",
  "eqa.order.receipt.notes.required": "请说明质控品存在的问题。标记为不完好的接收记录需要附上说明原因的备注。",
  "eqa.provider.wizard.cycleName.required": "轮次需要名称。",
  "eqa.provider.wizard.dates.required": "轮次需要分发日期和提交截止日期；提醒将依据截止日期发送。",
  "eqa.enrollment.scheme": "计划",
  "eqa.enrollment.scheme.helper": "选择本实例提供的计划，或选择“未列出”并输入名称。",
  "eqa.enrollment.scheme.frozen": "此注册已有关联的轮次，因此其计划和提供者无法更改。",
  "eqa.enrollment.scheme.other": "未列出：输入名称",
  "eqa.action.forbidden": "此操作需要 {grant} 权限，您的账户没有该权限。请向管理员申请。",
  "eqa.receipt.readOnly.title": "接收与评分的只读视图",
  "eqa.receipt.readOnly.body": "记录送达、发送重新寄送的面板、录入结果和返回分数都需要提供者权限；为轮次评分需要管理权限。无论哪种情况，下表都显示整个轮次。",
  "eqa.inhouse.readOnly.title": "内部面板只读视图",
  "eqa.inhouse.readOnly.body": "设计和封存盲样面板需要管理权限。无论如何，下方面板即为全部内容。",
  "eqa.score.downloadReport": "报告 PDF",
  "eqa.labperf.exportCsv": "导出翻译",
  "eqa.labperf.kpi.submitted": "已提交轮次",
  "eqa.labperf.acceptableOf": "已评分中可接受数",
  "eqa.labperf.kpi.lateCount": "逾期提交",
  "eqa.labperf.kpi.nceOpenCount": "其中仍未关闭",
  "eqa.queue.source.all": "所有来源",
  "eqa.queue.countFiltered": "队列 · {count} / {total, plural, one {# 项} other {# 项}}",
  "eqa.queue.emptyForSource": "此来源没有待分诊的条目。队列中有来自其他来源的{total, plural, one {# 个条目} other {# 个条目}}。",
  "eqa.program.requiresCycleReview": "每个轮次在提交前暂停以待复核",
  "eqa.program.requiresCycleReview.off": "自动提交",
  "eqa.program.requiresCycleReview.on": "暂停待复核",
  "eqa.cycle.submitManual": "手动提交",
  "eqa.cycle.submitManual.heading": "记录手动提交",
  "eqa.cycle.submitManual.help": "在结果已通过其他方式送达提供者后使用此功能。提供者给您的参考编号使其成为记录而非声明，因此为必填项。",
  "eqa.cycle.submitManual.reference": "提供者的参考编号",
  "eqa.cycle.submitManual.success": "已记录为手动提交，并附有提供者的参考编号。",
  "eqa.cycle.retriesSpent.title": "此轮次的自动提交已停止。",
  "eqa.cycle.retriesSpent.body": "已失败 {attempts} 次，将不再重试。请自行将结果发送给提供者（导出包位于该计划的页面上），并在此处记录其参考编号。",
  "eqa.provider.wizard.sampleCode.duplicate": "同一面板上的每个样本代码必须不同。",
  "eqa.provider.wizard.rangeHigh.backwards": "可接受范围的上限不能低于下限。",
  "eqa.shipment.packList.panelColumn": "面板",
  "eqa.provider.schemes.performance": "表现",
  "eqa.performance.title": "参与者表现",
  "eqa.performance.subtitle": "各实验室在此计划中最近四个已评分轮次的通过率。展开一行可查看构成该通过率的轮次。",
  "eqa.performance.laboratory": "实验室",
  "eqa.performance.region": "区域",
  "eqa.performance.enrollment": "注册",
  "eqa.performance.passRate": "通过率（最近 4 次）",
  "eqa.performance.mostRecent": "最近一次",
  "eqa.performance.openFollowups": "未关闭的跟进",
  "eqa.performance.expand": "轮次历史",
  "eqa.performance.ofJudged": "{judged} 项中 {accepted} 项",
  "eqa.performance.noRate": "尚无已评分轮次",
  "eqa.performance.noCycles": "此实验室尚未在已评分轮次中报告结果。",
  "eqa.performance.empty": "尚无实验室注册此计划。",
  "eqa.performance.loadFailed": "无法加载参与者表现",
  "eqa.myPrograms.group.active": "有效注册（{count}）",
  "eqa.order.coverage.title": "超出本实验室的注册范围",
  "eqa.order.coverage.subtitle": "此计划的注册不涵盖：{tests}。您仍可保存该订单。",
  "eqa.myPrograms.group.suspended": "已暂停的注册（{count}）",
  "eqa.myPrograms.group.withdrawn": "已退出的注册（{count}）",
  "eqa.enrollment.resume": "继续",
  "eqa.enrollment.statusReason": "理由",
  "eqa.enrollment.statusReasonPlaceholder": "此注册为何要更改状态？",
  "eqa.enrollment.statusEffectiveDate": "生效日期",
  "eqa.enrollment.withdrawIsFinal": "退出后不可撤销。如需再次参加，本实验室须重新注册该计划。",
  "eqa.enrollment.statusChanged": "此注册现为{status}",
  "eqa.enrollment.statusChangeFailed": "无法更改此注册的状态",
  "eqa.enrollment.panels.help": "来自目录的标准检测组合。这是您的实验室报告的内容，而不是提供者寄送给您的室间质评样品。",
  "eqa.myPrograms.panels.help": "此注册所涵盖的检测目录中的检测面板。",
  "eqa.score.scoredWithUnjudged": "轮次已评分，但 {tests} 上有 {count} 个结果未获判定。这些分析物没有封存的靶值，且该轮次的同组参加者太少，无法据此判定。",
  "eqa.cycle.close": "关闭轮次",
  "eqa.cycle.closeHeading": "关闭此轮次",
  "eqa.cycle.closeHelp": "已关闭的轮次为最终状态：参与者将看到其已关闭，且不再记录针对它的任何判定。如有未关闭的跟进事项，或有错过截止日期的结果仍在等待答复，将拒绝关闭。",
  "eqa.cycle.closeFailed": "无法关闭此轮次",
  "eqa.prep.ofTotal": "{total} 中的 {n}",
  "eqa.prep.tile.participants": "为本轮次选定的已注册实验室",
  "eqa.prep.tile.panels": "已制备质控品面板",
  "eqa.prep.dispatched": "参与者转运已发送",
  "eqa.prep.readyToShip.blockedByGate": "制备尚未完成。上方的待发运关卡列出了仍未完成的事项。",
  "eqa.prep.readyToShip.notInPrep": "轮次状态：{status}。仅在轮次处于制备阶段时才可放行发运。",
  "eqa.prep.goToShipments": "打开“转运”标签页",
  "eqa.competency.rule.meetsEvidence": "证据充足",
  "eqa.competency.rule.repeatedFailure": "重复失败",
  "eqa.competency.rule.insufficientEvidence": "证据不足",
  "eqa.competency.rule.openEscalation": "未关闭的不符合项",
  "eqa.competency.reason.meetsEvidence": "{from} 至 {to} 期间有 {evaluable} 个可评估样本，其中 {failures} 个失败，达到或高于证据下限 {floor}。无需采取行动。",
  "eqa.competency.reason.repeatedFailure": "{from} 至 {to} 期间 {evaluable} 个可评估样本中有 {failures} 个失败。这属于能力问题：请复核失败的结果并提出不符合项，或在分诊时将其忽略。",
  "eqa.competency.reason.insufficientEvidence": "{from} 至 {to} 期间有 {evaluable} 个可评估样本，低于证据下限 {floor}。这不属于能力问题：请为该分析人员分配更多能力验证样本。",
  "eqa.competency.reason.openEscalation": "{from} 至 {to} 期间提出的一项已升级不符合项仍未关闭，涉及 {evaluable} 个可评估样本，其中 {failures} 个失败。关闭该不符合项即可解除此等级。",
  "eqa.competency.whatIsAnAnalyst": "分析人员是计划分析人员名单中的 OpenELIS 用户账户，记录在其检测的样本上。这与录入结果的人员和审核结果的人员是分开的记录。",
  "eqa.inhouse.roster.help": "分析人员为 OpenELIS 用户账户。此处选择的每个人都会加入本计划名单，并可被分配样本进行检测；该名单与结果的录入人和审核人无关。",
  "banner.menu.eqa.providerFollowups": "参与者跟进",
  "eqa.oversight.queueSubtitle.link": "参与者跟进",
  "eqa.inhouse.sealed.deadline": "揭盲日期，即分析人员提交截止日期：{date}",
  "eqa.inhouse.sealed.analysts": "已分配的分析人员：{names}",
  "eqa.inhouse.sealed.noAnalysts": "此面板上没有任何样本分配了分析人员。",
  "eqa.inhouse.sealed.toMyCycles": "打开我的轮次",
  "eqa.inhouse.sealed.toWorkplan": "打开工作计划",
  "analyzerType.editor.heading": "配置文件设置",
  "analyzerType.editor.choose": "请选择…",
  "analyzerType.editor.version": "配置文件版本",
  "analyzerType.editor.confidence": "证据可信度",
  "analyzerType.editor.category": "实验室专业",
  "analyzerType.editor.inboundResults": "接收分析仪结果",
  "analyzerType.editor.outboundOrders": "向分析仪发送订单",
  "analyzerType.editor.connectionTest": "支持连接测试",
  "analyzerType.editor.fileHeading": "文件解析",
  "analyzerType.editor.fileFormat": "配置文件的文件格式",
  "analyzerType.editor.defaultFileFormat": "默认文件格式",
  "analyzerType.editor.filePattern": "文件名模式",
  "analyzerType.editor.hasHeader": "第一行包含列名",
  "analyzerType.editor.delimiter": "列分隔符",
  "analyzerType.editor.encoding": "文本编码",
  "analyzerType.editor.sheetIndex": "工作表编号（从零开始）",
  "analyzerType.editor.skipRows": "要跳过的行数",
  "analyzerType.editor.extensions": "支持的文件扩展名",
  "analyzerType.editor.columns": "文件列",
  "analyzerType.editor.columnsHelp": "将导出文件中的列名与下方的结果字段对应。请保持拼写和标点一致。",
  "analyzerType.editor.columnNumber": "文件列 {number}",
  "analyzerType.editor.columnName": "文件中的列名",
  "analyzerType.editor.columnField": "列的含义",
  "analyzerType.editor.removeColumn": "移除列",
  "analyzerType.editor.columnsInvalid": "每一列都需要唯一的名称和已选择的含义。",
  "analyzerType.editor.addColumn": "添加列",
  "analyzerType.editor.resultOrder": "结果值优先顺序（使用第一个可用值）",
  "analyzerType.editor.communicationHeading": "通信默认设置",
  "analyzerType.editor.analyzerName": "消息中的仪器名称",
  "analyzerType.editor.identifierPattern": "分析仪标识符模式",
  "analyzerType.editor.protocolVersion": "协议版本",
  "analyzerType.editor.lowerLayerVersion": "ASTM 帧格式版本",
  "analyzerType.editor.msh3Pattern": "发送应用程序模式",
  "analyzerType.editor.communicationMode": "由谁发起通信",
  "analyzerType.editor.lisInitiated": "允许实验室系统发起通信",
  "analyzerType.editor.connectionRole": "默认连接角色",
  "analyzerType.editor.transport": "默认传输方式",
  "analyzerType.editor.port": "默认出站端口（可选）",
  "analyzerType.editor.aggregationMode": "结果分组",
  "analyzerType.editor.aggregationWindowSeconds": "结果分组时间窗口（秒）",
  "analyzerType.editor.connectionFields": "设置连接时显示的字段",
  "analyzerType.editor.connectionFieldsHelp": "这些字段描述实验室为每个连接提供的设置。FILE 连接需要一个目录字段，用于指定 Bridge 上的监视文件夹。标签使用应用程序的翻译键。选项保留其值类型；可见性条件引用另一项设置。",
  "analyzerType.editor.connectionFieldNumber": "连接字段 {number}",
  "analyzerType.editor.fieldKey": "设置名称",
  "analyzerType.editor.fieldLabel": "标签翻译键",
  "analyzerType.editor.inputKind": "输入类型",
  "analyzerType.editor.required": "设置连接时必填",
  "analyzerType.editor.addField": "添加连接字段",
  "analyzerType.editor.removeField": "移除连接字段",
  "analyzerType.editor.save": "保存并验证配置文件设置",
  "analyzerType.editor.saved": "配置文件设置已保存",
  "analyzerType.editor.saveBeforeRecognition": "请先保存配置文件设置，再编辑质控识别或发布。",
  "analyzerType.editor.loadError": "无法重新加载草稿。您未保存的编辑仍保留在此。",
  "analyzerType.editor.saveError": "无法保存草稿。您的编辑仍保留在此；请重新尝试保存。",
  "analyzerType.editor.conflict": "草稿自打开后已被更改。您的编辑尚未发送。请先重新加载已保存的草稿，再进行更多修改。",
  "analyzerType.editor.error": "无法保存配置文件",
  "analyzerType.editor.reload": "重新加载已保存的草稿并放弃本地编辑",
  "analyzerType.editor.validation": "配置文件需要处理",
  "analyzerType.editor.add": "添加值",
  "analyzerType.editor.remove": "移除值",
  "analyzerType.editor.semantic.sampleId": "样本标识符",
  "analyzerType.editor.semantic.testCode": "分析仪检测代码",
  "analyzerType.editor.semantic.qcTask": "质控任务",
  "analyzerType.editor.semantic.ctValue": "循环阈值（Ct）",
  "analyzerType.editor.inputKind.TEXT": "文本",
  "analyzerType.editor.inputKind.NUMBER": "数字",
  "analyzerType.editor.inputKind.SELECT": "选项列表",
  "analyzerType.editor.inputKind.BOOLEAN": "是或否",
  "analyzerType.editor.inputKind.SECRET": "密钥",
  "analyzerType.editor.inputKind.FILE_PATH": "文件夹或文件路径",
  "analyzerType.editor.testDefinitions": "分析仪检测定义",
  "analyzerType.editor.testDefinitionsHelp": "列出仪器报告的检测代码和结果值。这些定义用于提供与实验室目录匹配的建议，不会创建或更改实验室检测。",
  "analyzerType.editor.testNumber": "分析仪检测 {number}",
  "analyzerType.editor.testCode": "分析仪检测代码",
  "analyzerType.editor.testName": "建议检测名称",
  "analyzerType.editor.loinc": "LOINC 代码",
  "analyzerType.editor.testUnit": "报告单位",
  "analyzerType.editor.resultType": "报告值类型",
  "analyzerType.editor.resultType.quantitative": "数值测量",
  "analyzerType.editor.resultType.qualitative": "命名结果",
  "analyzerType.editor.resultType.text": "自由文本结果",
  "analyzerType.editor.testAliases": "同一检测的其他代码",
  "analyzerType.editor.testValues": "此检测报告的结果值",
  "analyzerType.editor.removeTest": "移除分析仪检测",
  "analyzerType.editor.addTest": "添加分析仪检测",
  "analyzerType.editor.choices": "连接选项",
  "analyzerType.editor.choiceNumber": "选项 {number}",
  "analyzerType.editor.choiceValue": "选项值",
  "analyzerType.editor.addChoice": "添加选项",
  "analyzerType.editor.removeChoice": "移除选项",
  "analyzerType.editor.visibility": "在以下情况下显示此连接字段",
  "analyzerType.editor.controllingField": "控制设置",
  "analyzerType.editor.comparison": "比较方式",
  "analyzerType.editor.comparisonValue": "比较值",
  "analyzerType.editor.comparison.EQUALS": "等于",
  "analyzerType.editor.comparison.NOT_EQUALS": "不等于",
  "analyzerType.editor.comparison.IN": "属于其中之一",
  "analyzerType.editor.comparison.NOT_IN": "不属于其中之一",
  "analyzerType.editor.addCondition": "添加可见性条件",
  "analyzerType.editor.removeCondition": "移除可见性条件",
  "analyzerType.editor.valueType": "值类型",
  "analyzerType.editor.valueType.string": "文本值",
  "analyzerType.editor.valueType.boolean": "布尔值",
  "analyzerType.editor.valueType.array": "列表值",
  "analyzerType.editor.valueType.object": "对象值",
  "analyzerType.editor.valueType.null": "空值",
  "analyzerType.editor.nullValue": "此选项的值为空。",
  "analyzerType.editor.invalidTypedValue": "请输入所选类型的有效值。",
  "analyzerType.editor.structuredValueHelp": "请输入与所选类型匹配的 JSON 列表或对象。“属于其中之一”比较请使用列表。",
  "analyzerType.editor.newProtocolHelp": "请选择 FILE、ASTM 或 HL7，并输入仪器支持的设置。首次保存后协议将无法更改。",
  "analyzerType.editor.switchProtocol": "切换协议并清除其设置",
  "analyzerType.editor.switchProtocolHelp": "切换到 {protocol}？这将清除未保存的通信、解析、连接字段和质控识别设置。配置文件标识、检测定义和描述信息将被保留。",
  "analyzerType.editor.keepProtocol": "保留当前协议",
  "analyzerType.editor.supportedTransports": "支持的传输方式",
  "analyzerType.editor.supportTransport": "支持 {transport}",
  "analyzerType.editor.transportSettings": "{transport} 设置",
  "analyzerType.editor.transportPortHelp": "此传输方式的出站目标端口（可选）。留空则使用 Bridge 的备用设置；传入消息使用共享监听器。",
  "analyzerType.editor.serialSettings": "串口通信设置",
  "analyzerType.editor.readTimeout": "串口读取超时（毫秒）",
  "analyzerType.editor.messageTimeout": "串口消息超时（毫秒）",
  "analyzerType.editor.reconnectInterval": "串口重连间隔（毫秒）",
  "analyzerType.editor.maxReconnectAttempts": "串口最大重连次数",
  "analyzerType.editor.rtsEnabled": "启用 RTS",
  "analyzerType.editor.dtrEnabled": "启用 DTR",
  "analyzerType.editor.resultRecords": "要解析的结果记录",
  "analyzerType.editor.resultRecords.ALL": "所有结果记录",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "含已填写字段的记录",
  "analyzerType.editor.resultRecordField": "必需的 ASTM 字段（record.field.component）",
  "analyzerType.editor.specimenPosition": "HL7 样本相对于结果的位置",
  "analyzerType.editor.dataFlow": "默认数据传输方向",
  "analyzerType.editor.outboundPortMode": "默认出站端口选择",
  "analyzerType.editor.clientProfilePort": "存储在此配置文件中的客户端连接端口（可选）",
  "eqa.intake.sample": "样本 {code}",
  "eqa.competency.countsFoldedTriage": "由分诊决定",
  "eqa.competency.countsFoldedScore": "随评分计入",
  "eqa.provider.followups.responseText": "实验室的说明",
  "eqa.provider.followups.responseHelp": "该实验室发现的根本原因及其采取的纠正措施。随跟进一并保存。",
  "eqa.provider.followups.responseShown": "实验室的回复：{text}",
  "notification.organization.post.error": "机构未保存。请检查各字段后重试。",
  "organization.email": "联系人电子邮件",
  "eqa.provider.followups.sendFailed": "无法发送电子邮件至 {to}。通知已下载为 CSV 文件，请手动发送。",
  "label.validation.review.error.qcHold": "发布被阻止：质控失败，在其不符合项关闭前此结果被暂扣。",
  "sidenav.label.admin.locations": "位置与机构",
  "sidenav.label.admin.locations.organizations": "机构",
  "sidenav.label.admin.locations.sites": "采样点",
  "sidenav.label.admin.locations.areas": "地理区域",
  "sidenav.label.admin.locations.import": "导入/导出",
  "help.locations.page.organizations": "机构是与您的实验室合作的卫生机构和实验室：向您送检患者样本的医院、诊所和卫生中心，以及您转诊样本的实验室。机构内的病房和科室列在其下。机构在订单录入中显示为申请站点，在转诊中显示为目标实验室。",
  "help.locations.page.sites": "采样点是环境中采集非患者样本的固定地点：水源、蚊子诱捕器、空气监测器、土壤地块。采样点不申请检测。它记录样本的采集地点，以便对同一地点的结果进行长期比较。每个采样点位于一个地理区域内，并可有自己的 GPS 坐标和联系人。",
  "help.locations.page.areas": "地理区域是国家的行政区划，例如大区、省、地区和地方级政府（LLG）辖区。它们用于患者地址，并用于说明每个机构和采样点所在的位置。大多数部署从国家列表中一次性加载这些区域，然后在此处添加或更正区域。要在某个区域内添加区域，请使用上级行上的 + 按钮：在 Morobe 省上点击“+ 地区”会在 Morobe 中添加一个地区。在顶部使用“+ 添加大区”可添加新的顶级区域。",
  "help.locations.page.import": "从 CSV 文件加载或更新机构、病房/科室、采样点和地理区域，格式与系统安装时使用的格式相同。在您复核预览并应用之前，不会保存任何内容。",
  "label.locations.page.compare": "机构还是采样点：我需要哪一个？",
  "label.locations.page.compare.orgTitle": "以下情况请添加机构...",
  "label.locations.page.compare.siteTitle": "以下情况请添加采样点...",
  "label.locations.page.compare.orgExamples": "示例：Port Moresby General Hospital、9 Mile Urban Clinic、Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "示例：Bumbu Settlement 灯光诱捕器、Laloki River 取水口、Waigani 空气监测器",
  "help.locations.page.compare.org": "当样本来自在该机构就诊的人员、该机构申请检测或接收报告或转诊样本，或者该机构有申请检测的病房或科室时，请添加机构。",
  "help.locations.page.compare.site": "当样本来自环境（水、土壤、空气或昆虫），当您反复在同一固定地点采集，或者希望在地图上查看该地点随时间变化的结果时，请添加采样点。",
  "help.locations.page.compare.tip": "医院里的水箱仍然是采样点：医院是机构，水箱是位于同一区域的采样点。",
  "label.locations.kind.facility": "设施",
  "label.locations.kind.ward": "病房/科室",
  "label.locations.kind.wards": "病房/科室",
  "label.locations.kind.site": "采样点",
  "label.locations.kind.area": "地理区域",
  "label.locations.kind.records": "记录",
  "label.locations.column.name": "名称",
  "label.locations.column.code": "位置代码",
  "label.locations.column.type": "设备类型",
  "label.locations.column.wards": "病房/科室",
  "label.locations.column.location": "位置",
  "label.locations.column.inUse": "使用中",
  "label.locations.column.level": "层级",
  "label.locations.column.children": "下级区域",
  "label.locations.column.siteType": "站点类型",
  "label.locations.column.active": "活跃",
  "label.locations.column.actions": "操作",
  "label.locations.column.serviceType": "服务类型",
  "label.locations.column.contact": "联系人姓名",
  "label.locations.column.phone": "电话",
  "label.locations.column.email": "电子邮件",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "未完成",
  "label.locations.openOrders": "未完成订单",
  "label.locations.none": "无",
  "label.locations.empty": "（空）",
  "label.locations.location.notSet": "未设置",
  "label.locations.status.active": "活跃",
  "label.locations.status.inactive": "非活跃",
  "label.locations.status.all": "所有分析仪",
  "label.locations.source.registry": "登记库",
  "help.locations.registry": "来自机构注册库。注册库是此记录的权威来源。",
  "label.locations.filter.type": "设备类型",
  "label.locations.filter.type.all": "所有类型",
  "label.locations.filter.location": "位置（包括下级区域）",
  "label.locations.filter.location.any": "任意区域",
  "label.locations.filter.status": "状态",
  "label.locations.filter.clear": "清除筛选条件",
  "label.locations.filter.reviewOverdue": "仅显示审查逾期或认可已过期的转诊实验室",
  "label.locations.filter.category.all": "所有类别",
  "label.locations.filter.ownership.all": "所有所有权类型",
  "label.locations.toolbar": "过滤器",
  "placeholder.locations.search": "按名称、代码或任何标识符搜索",
  "placeholder.locations.area.search": "按名称或代码搜索区域",
  "help.locations.status.inactive": "已停用的记录在订单录入和其他选择器中隐藏。它们仍会显示在现有订单和报告中。",
  "help.locations.field.location": "选择您所知道的最具体的区域。如果不知道地方级政府（LLG）辖区，选择地区即可。",
  "help.locations.field.gps": "十进制度，WGS84",
  "help.locations.field.siteDescription": "请包含路线说明，以便他人找到确切位置",
  "help.locations.identifiers": "输入任意标签，或选择已使用的标签。报告代码在列表、导出和报告中显示为“代码”。每个标识符都可搜索，并用于匹配导入行。",
  "help.locations.ward": "此机构内的病房、科室或诊室",
  "help.locations.ward.gps": "GPS 留空则使用 {parent} 的位置。地址始终使用 {parent} 的地址。",
  "label.locations.ward.inheritedGps": "{lat}, {lng}（继承自 {parent}）",
  "label.locations.inherited": "已继承",
  "label.locations.inherits": "继承",
  "label.locations.draft": "草稿",
  "label.locations.ward.namePlaceholder": "病房/科室名称",
  "label.locations.optional": "可选",
  "warning.locations.registry.edit": "此记录来自机构注册表。对注册表提供的字段所做的更改将在下次同步时被覆盖。如需永久更改，请更新注册表。您在此处添加的病房/科室及其他本地信息将被保留。",
  "warning.locations.registry.deactivate": "此记录来自机构注册表。下次同步可能会重新启用该记录；如需永久关闭，请更新注册表。",
  "label.locations.registry.field": "来自登记库",
  "button.locations.add": "添加",
  "button.locations.import": "导入",
  "button.locations.export": "导出",
  "button.locations.deactivate": "停用",
  "button.locations.reactivate": "重新激活",
  "button.locations.exportSelected": "导出所选项",
  "button.locations.addWard": "添加病房/科室",
  "button.locations.saveWards": "保存 {count} 个新病房/科室",
  "button.locations.moveWard": "移动",
  "button.locations.history": "历史",
  "button.locations.history.hide": "隐藏历史记录",
  "button.locations.identifier.add": "添加标识符",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "添加{level}",
  "button.locations.area.expandAll": "全部展开",
  "button.locations.area.collapseAll": "全部收起",
  "button.locations.undo": "撤销",
  "button.locations.template": "下载模板",
  "button.locations.import.preview": "预览",
  "button.locations.import.apply": "应用",
  "button.locations.import.report": "下载结果报告",
  "label.locations.selectAll": "全选行",
  "label.locations.select": "选择",
  "label.locations.section.identity": "身份信息",
  "label.locations.section.identifiers": "标识符",
  "label.locations.section.location": "位置",
  "label.locations.section.contact": "联系方式",
  "label.locations.section.referral": "转诊实验室",
  "label.locations.section.site": "站点详情",
  "label.locations.section.wards": "病房/科室",
  "label.locations.form.jump": "跳转到",
  "label.locations.field.types": "机构类型",
  "label.locations.field.shortName": "简称",
  "label.locations.field.category": "类别",
  "label.locations.field.ownership": "所有权",
  "label.locations.field.description": "描述",
  "label.locations.field.location": "位置",
  "label.locations.field.parentArea": "上级区域",
  "label.locations.field.streetAddress": "街道地址",
  "label.locations.field.city": "城市",
  "label.locations.field.state": "州/省",
  "label.locations.field.zipCode": "邮政编码",
  "label.locations.field.gpsLatitude": "GPS 纬度",
  "label.locations.field.gpsLongitude": "GPS 经度",
  "label.locations.field.contactName": "联系人姓名",
  "label.locations.field.phone": "电话",
  "label.locations.field.email": "电子邮件",
  "label.locations.field.website": "网站",
  "label.locations.field.serviceType": "服务类型",
  "label.locations.field.siteType": "站点类型",
  "label.locations.field.subtype": "子类型",
  "label.locations.field.zone": "环境分区",
  "label.locations.identifier.label": "标签",
  "label.locations.identifier.value": "值",
  "label.locations.identifier.reporting": "报告代码",
  "label.locations.identifier.labelPlaceholder": "例如 DHIS2 ID",
  "label.locations.referral.approval": "批准状态",
  "label.locations.referral.approved": "已批准",
  "label.locations.referral.evaluation": "评估中",
  "label.locations.referral.suspended": "已暂停",
  "label.locations.referral.notApproved": "未批准",
  "label.locations.referral.accreditationBody": "认可机构",
  "label.locations.referral.accreditationNumber": "认可编号",
  "label.locations.referral.accreditationExpiry": "认可有效期",
  "label.locations.referral.lastReview": "上次审查日期",
  "label.locations.referral.nextReview": "下次审查到期",
  "label.locations.referral.notes": "审查备注",
  "label.locations.referral.overdue": "审查逾期",
  "label.locations.referral.expired": "认可已过期",
  "message.locations.referral.overdueSince": "审查自 {date} 起已逾期。请在下方记录审查，或更改批准状态。",
  "label.locations.history.title": "{name} 的历史记录",
  "label.locations.history.filter": "按操作筛选",
  "label.locations.history.allChanges": "所有更改",
  "help.locations.history.readOnly": "只读。在记录存在期间一直保留。",
  "label.locations.history.formerly": "原名 {name}",
  "label.locations.history.action.created": "创建时间",
  "label.locations.history.action.edited": "已编辑",
  "label.locations.history.action.deactivated": "已停用",
  "label.locations.history.action.reactivated": "已重新激活",
  "label.locations.history.action.moved": "已移动",
  "label.locations.history.action.identifiers": "标识符已更改",
  "label.locations.history.action.referralReview": "转诊审查",
  "label.locations.history.action.imported": "已导入",
  "label.locations.history.action.registrySync": "已从登记库更新",
  "label.locations.search.ward": "病房/科室：{name}",
  "error.locations.name.required": "名称为必填项",
  "error.locations.types.required": "请至少选择一种机构类型",
  "error.locations.gps.range": "请输入十进制度数：纬度 -90 至 90，经度 -180 至 180",
  "error.locations.parent.kind": "病房的上级必须是设施",
  "error.locations.parent.required": "请选择上级区域",
  "error.locations.referral.status": "请选择批准状态",
  "error.locations.identifier.duplicate": "{label} {value} 已被 {name} 使用",
  "error.locations.reactivate.parentInactive": "请先重新启用 {parent}。",
  "error.locations.save.conflict": "另一位管理员已先保存此记录。下方显示其数值；请重新应用您的更改并再次保存。",
  "error.locations.save.failed": "记录未保存。",
  "error.locations.request.failed": "请求未能完成，因此未保存任何内容。请重试；如果仍然失败，请联系管理员。",
  "error.locations.save.check": "尚未保存。请检查：{fields}。",
  "error.locations.save.failedBecause": "记录未保存：{reason}",
  "error.locations.save.conflictKept": "另一位管理员已先保存此记录。您的更改已保留，在您未输入的位置已填入其更改（{fields}）。请检查表单并再次保存。",
  "warning.locations.wards.unsaved": "{count, plural, other {# 个病房/科室}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "{name} 未保存：{reason}",
  "message.locations.wards.saved": "{count, plural, other {已保存 # 个病房/科室。}}",
  "warning.locations.import.ignoredColumns": "以下列不会导入，已被忽略：{columns}",
  "label.locations.import.run.applied": "已应用",
  "label.locations.import.run.preview": "预览",
  "warning.locations.identifiers.shared": "部分标识符被多条记录使用。请为每条记录设置唯一的值。",
  "error.locations.load.failed": "无法加载列表。请重试。",
  "warning.locations.name.duplicate": "已存在另一个名为“{name}”的启用状态{kind}",
  "message.locations.empty.none": "暂无记录。请添加一条，或导入文件。",
  "message.locations.empty.filtered": "没有符合这些筛选条件的记录。",
  "message.locations.search.elsewhere": "在{view}中：{count, plural, one {# 个匹配项} other {# 个匹配项}}",
  "message.locations.saved": "已保存 {name}。",
  "message.locations.added": "已添加 {name}。",
  "message.locations.deactivated": "已停用 {name}。",
  "message.locations.reactivated": "已重新启用 {name}。",
  "message.locations.undo.deactivated": "已停用 {name}。",
  "message.locations.deactivate.inUse": "{name} 有 {open} 个未完成订单和 {children} 个启用中的{childKind}。",
  "message.locations.deactivate.confirm": "停用 {name}？",
  "button.locations.deactivate.record": "停用 {name}",
  "button.locations.deactivate.only": "仅停用 {name}",
  "button.locations.deactivate.withChildren": "停用 {name} 及其 {count} 个{childKind}",
  "message.locations.area.inUse": "{name} 内仍有启用中的区域、机构或站点。请先停用或移走这些项。",
  "message.locations.area.searchContext": "{count, plural, other {# 个匹配项}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "展开行时加载子项。",
  "label.locations.area.new": "新建",
  "label.locations.area.topLevel": "顶级",
  "message.locations.unsaved": "您有未保存的更改。确定不保存就离开吗？",
  "label.locations.import.mode": "导入模式",
  "label.locations.import.mode.merge": "添加和更新",
  "help.locations.import.mode.merge": "添加新记录并更新匹配的记录。其他内容不变。",
  "label.locations.import.mode.replace": "替换",
  "help.locations.import.mode.replace": "同时停用文件中所含类型、但文件未包括的记录。不会删除任何内容。",
  "label.locations.import.files": "文件",
  "label.locations.import.drop": "将 CSV 文件拖到此处或点击浏览（organizations-*.csv、*-levels.csv、*-values.csv）",
  "label.locations.import.area": "区域",
  "label.locations.import.area.organizations": "设施、病房和站点",
  "label.locations.import.area.levels": "地理层级",
  "label.locations.import.area.values": "地理区域",
  "label.locations.import.forThisFile": "针对此文件：",
  "label.locations.import.replaceScope": "此文件包含 {types} 行。{untouched} 不会更改。病房/科室仅在 {parents} 下被替换。登记库记录永远不会被停用。",
  "label.locations.import.rename.title": "可能的更名",
  "label.locations.import.rename.same": "同一地点，已更名",
  "label.locations.import.rename.different": "不同地点",
  "warning.locations.import.registryOverwrite": "将在下次注册表同步时被覆盖",
  "warning.locations.import.wardAddressIgnored": "第 {line} 行：病房/科室的地址将被忽略，病房/科室使用其所属机构的地址",
  "label.locations.import.outcome.new": "新增",
  "label.locations.import.outcome.updated": "更新",
  "label.locations.import.outcome.unchanged": "未更改",
  "label.locations.import.outcome.reactivated": "已重新激活",
  "label.locations.import.outcome.deactivated": "已停用",
  "label.locations.import.outcome.decision": "需要决定",
  "label.locations.import.outcome.rename": "可能已更名",
  "label.locations.import.outcome.rejected": "已拒收",
  "label.locations.import.decision.use": "使用此记录",
  "label.locations.import.decision.new": "新建",
  "label.locations.import.decision.skip": "跳过此行",
  "label.locations.import.decision.remember": "记住此名称",
  "label.locations.import.willDeactivate": "将被停用",
  "label.locations.import.rows": "行",
  "label.locations.import.column.line": "行",
  "label.locations.import.column.outcome": "结果",
  "label.locations.import.column.type": "设备类型",
  "label.locations.import.column.code": "位置代码",
  "label.locations.import.column.name": "名称",
  "label.locations.import.column.detail": "详情",
  "message.locations.import.nothingSaved": "未保存任何内容。",
  "label.locations.import.confirm.title": "应用此导入？",
  "label.locations.import.confirm.replace": "我了解将停用 {count} 条记录",
  "label.locations.import.complete": "导入完成",
  "label.locations.import.recent": "最近的导入",
  "message.locations.export.done": "已按导入格式导出 {count} 条记录。",
  "label.locations.import.working": "正在读取文件并匹配每一行。大文件需要一点时间。",
  "message.locations.import.failed": "无法读取导入内容：{reason}",
  "eqa.wizard.noSchemeTests": "此计划没有可供面板使用的检测。",
  "eqa.performance.titleForScheme": "参与者表现：{scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "首批发货已发出",
  "eqa.cycle.trigger.all_shipments_delivered": "所有发货均已送达",
  "eqa.cycle.trigger.score_intake": "评分已记录",
  "eqa.cycle.trigger.panel_receipt": "面板已接收",
  "eqa.cycle.trigger.last_validated_result": "最后一个结果已审核",
  "eqa.cycle.trigger.fhir_submit_success": "结果已提交给提供者",
  "eqa.cycle.trigger.panel_unblind": "面板已揭盲",
  "eqa.cycle.trigger.v1_backfill": "沿用自先前的分发",
  "sampleAcceptance.banner.resampledFrom.accession": "这是对样本 {accession} 重新采样后创建的替代样本。",
  "label.results.sampleStatus.markUsedUpConfirm.title": "将此样本标记为已用完？",
  "label.results.sampleStatus.markUsedUpConfirm.body": "其剩余量将设为零。样本在处置前仍保留在储存位置中。",
  "alerts.acknowledge.note": "确认备注",
  "alerts.acknowledge.note.required": "确认紧急警报时必须填写备注",
  "alerts.resolve.button": "解决",
  "alerts.resolve.title": "解决警报",
  "alerts.resolve.comment.required": "必须填写解决备注",
  "alerts.resolve.error": "解决警报失败",
  "configuration.panel.manage": "管理面板",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "查看检测目录",
  "compliance.parameterGroup.deleted": "已删除参数组。",
  "compliance.parameterGroup.updated": "已更新参数组。",
  "compliance.parameterGroup.deleteError": "无法删除参数组。",
  "compliance.validation.fillRequired": "请填写所有必填字段。",
  "compliance.parameterGroup.moveError": "无法重新排序参数组。",
  "compliance.parameterGroup.moved": "已重新排序参数组。",
  "compliance.parameterGroup.created": "已添加参数组。",
  "compliance.testEditor.thresholdsDone": "已更新此检测的合规阈值。",
  "compliance.testEditor.meta.loinc": "LOINC：",
  "compliance.testEditor.meta.resultType.select": "选择列表",
  "compliance.testEditor.meta.resultType": "结果类型：",
  "compliance.testEditor.editHeader": "编辑检测：",
  "compliance.testEditor.meta.sampleType": "样本类型：",
  "compliance.testThresholds.comboboxPlaceholder": "按名称、代码或 LOINC 搜索…",
  "label.button.done": "打印完成",
  "compliance.testEditor.meta.resultType.numeric": "数值",
  "compliance.multiLimit.advisoryNote.placeholder": "例如，需在 24h 内重新采样",
  "compliance.multiLimit.advisoryNote": "建议说明",
  "compliance.inlineEdit.editingMapping": "编辑合规映射",
  "label.loading.message": "正在加载……",
  "compliance.linkedTest.unlinked": "已从参数组中移除检测。",
  "compliance.linkedTest.unlinkError": "无法从该组中移除此检测。",
  "compliance.threshold.testLinked": "检测已关联到参数组。",
  "compliance.inlineEdit.editingLimits": "编辑所有限值",
  "search.possibleMatches.title": "可能的匹配",
  "search.possibleMatches.intro": "这些记录与您正在创建的记录相似。请使用其中一条，或创建新记录。",
  "search.possibleMatches.use": "使用此记录",
  "search.possibleMatches.createAnyway": "仍然新建",
  "search.possibleMatches.confirm": "已存在 {count} 条相似记录，仍要创建新记录吗？",
  "search.possibleMatches.confirm.button": "创建新记录",
  "search.possibleMatches.back": "返回",
  "search.possibleMatches.matched": "匹配字段：{fields}",
  "search.possibleMatches.field.name": "姓名",
  "search.possibleMatches.field.dateOfBirth": "出生日期",
  "search.possibleMatches.field.identifier": "标识符",
  "search.possibleMatches.field.code": "代码",
  "search.possibleMatches.inactive": "非活跃",
  "search.possibleMatches.failed": "无法检查相似记录。您仍可创建新记录。",
  "search.possibleMatches.recordFailed": "无法记录您的选择，因此未创建任何内容。请重试。",
  "order.entry.patient.create": "创建患者",
  "order.entry.patient.willBeCreated": "保存订单时将创建新患者。",
  "provider.title.none": "无称谓",
  "order.billing.reference": "计费参考号",
  "sample.handling.title": "处理条件",
  "sample.handling.noRequirement": "无要求",
  "sample.handling.processWithin": "须在{time}内处理",
  "sample.handling.holding.minutes": "{minutes} 分钟",
  "sample.handling.holding.hours": "{hours} 小时",
  "sample.handling.holding.hoursMinutes": "{hours} 小时 {minutes} 分钟",
  "sample.handling.requiredLabel": "要求：",
  "sample.handling.storedAtLabel": "存储位置：",
  "sample.handling.arrivedAs": "到达时状态",
  "sample.handling.measuredTemp": "测得温度（°C）",
  "sample.handling.measuredTemp.invalid": "请输入 -100 至 60 °C 之间的温度。",
  "sample.handling.sameForAll": "所有样本相同",
  "sample.handling.notStored": "尚未存储",
  "sample.handling.storedAt.temperature": "{location}（{degrees} °C）",
  "sample.handling.mismatch": "处理条件不符",
  "sample.handling.mismatch.detail": "要求{required}；{actual}",
  "sample.handling.actual.arrived": "到达时为{condition}",
  "sample.handling.actual.measured": "到达时测得 {degrees} °C",
  "sample.handling.actual.stored": "存储于 {degrees} °C",
  "sample.handling.reportNonConformity": "报告不符合项",
  "sample.condition.roomTemp": "室温",
  "sample.condition.refrigerated": "冷藏 2 至 8 °C",
  "sample.condition.frozen": "冷冻",
  "sample.condition.onIce": "冰上",
  "sample.condition.dryIce": "干冰",
  "common.notRecorded": "未记录",
  "sample.legacy.recordedBefore": "记录于此版本之前",
  "order.continue.item.arrivalTemperature": "{sample} 的测量温度超出 -100 至 60 °C 范围",
  "order.entry.receivedBy.you": "接收人：{name}（您）",
  "order.entry.receivedBy.other": "接收人：{name}",
  "order.entry.receivedBy.search": "接收人",
  "common.change": "更改",
  "common.moreActions": "更多操作",
  "order.tests.action.markTestedElsewhere": "标记为外部已检测",
  "order.tests.action.unmarkTestedElsewhere": "未在外部检测",
  "order.tests.tag.testedElsewhere": "外部检测",
  "order.tests.testedElsewhere.help": "结果由其他实验室报告",
  "order.tests.testedElsewhereAt": "外部检测：{lab}",
  "order.tests.testedElsewhere.value": "报告值",
  "order.tests.testedElsewhere.lab": "执行实验室",
  "order.tests.testedElsewhere.saveFailed": "外部检测未保存：{reason}",
  "inventory.board.title": "物品",
  "inventory.board.purpose": "现有物品及需要再订购的物品。展开一行可查看其批次及所在位置。",
  "inventory.board.column.item": "项目",
  "inventory.board.column.onHand": "现有库存",
  "inventory.board.column.runsOut": "耗尽时间",
  "inventory.board.byLocation": "按位置：",
  "inventory.board.empty": "尚无库存物品。添加物品以开始跟踪，然后接收库存。",
  "inventory.board.noMatches": "没有符合搜索和筛选条件的物品。清除条件以查看完整目录。",
  "inventory.board.error": "无法加载物品看板。",
  "inventory.filter.location": "按位置筛选",
  "inventory.projection.window": "{early} – {late}",
  "inventory.projection.windowOpen": "{early} 或更晚",
  "inventory.projection.basis": "基于截至 {date} 的使用情况",
  "inventory.projection.stale": "关注：用量数据可能已过时",
  "inventory.projection.insufficient": "使用天数太少，无法预测用尽日期",
  "inventory.projection.outOfStock": "缺货",
  "inventory.projection.trend": "用量趋势",
  "inventory.projection.trend.steady": "平稳",
  "inventory.projection.trend.change": "{percent}% / {days}天",
  "inventory.projection.medianDailyUse": "每日用量中位数：{rate} {units}/天（最近 {days} 天，中位数可平滑偶发的峰值）",
  "inventory.orderBy.label": "最迟订购",
  "inventory.orderBy.pastDue": "已逾期",
  "inventory.orderBy.leadSet": "{days} 天（已设置）",
  "inventory.orderBy.leadObserved": "约 {days} 天（实测）",
  "inventory.orderBy.leadDefault": "{days} 天（默认值，设置后可更准确）",
  "inventory.reorderStatus.now": "立即再订购",
  "inventory.reorderStatus.soon": "即将再订购",
  "inventory.reorderStatus.adequate": "充足",
  "inventory.reorderStatus.buildingData": "数据积累中",
  "inventory.lots.useFirst": "优先使用",
  "inventory.lots.disposeFailedQc": "质控失败：处置",
  "inventory.lots.flag": "标记",
  "inventory.lots.none": "此物品尚无批次记录。接收库存以开始跟踪。",
  "inventory.actions.forItem": "{item} 的操作",
  "inventory.actions.forLot": "批次 {lot} 的操作",
  "inventory.actions.editItem": "编辑物品详情",
  "inventory.actions.editLot": "编辑批次和位置",
  "inventory.lots.expiringInDays": "{days} 天后过期",
  "inventory.logUsage.button": "记录使用",
  "inventory.logUsage.title": "记录使用",
  "inventory.logUsage.help": "记录工作台使用的库存。这会用于耗尽预测；如需更正盘点数，请改用“调整库存”。",
  "inventory.logUsage.quantityWithUnits": "使用数量（{units}）",
  "inventory.logUsage.onHand": "现有 {quantity} {units}。按有效期最早的批次优先取用。",
  "inventory.logUsage.error.noItem": "请选择要记录使用的物品。",
  "inventory.logUsage.error.wholeUnits": "请输入整数单位，至少为 1。",
  "inventory.receiveStock.button": "接收库存",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "创建微生物病例",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "病例角色",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "培养",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "直接",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "案例",
  "label.testCatalog.basicInfo.collectedInSets": "成套采集",
  "microbiology.sets.warning.SINGLE_BOTTLE": "本套中只有一瓶",
  "microbiology.sets.warning.REPEATED_CONTAINER": "本套中容器类型重复",
  "microbiology.sets.warning.DIFFERENT_SITES": "本套中存在不同的采集部位",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "采集时间间隔超过 {minutes} 分钟",
  "microbiology.sets.title": "培养套",
  "microbiology.sets.count.sets": "{sets, plural, other {套数}}",
  "microbiology.sets.count.bottles": "{bottles, plural, other {瓶数}}",
  "microbiology.sets.count.summary": "{sets}，{bottles}",
  "microbiology.sets.number": "第 {number} 套",
  "microbiology.sets.unassigned": "未记录套别",
  "order.microPreview.title": "此订单将创建的内容",
  "order.microPreview.loading": "正在更新订单预览…",
  "order.microPreview.failed": "订单预览不可用",
  "order.microPreview.failedDetail": "无法更新预览。请检查网络连接后重试。",
  "order.microPreview.opens": "创建病例",
  "order.microPreview.ordinary": "保留在结果中",
  "order.microPreview.case": "{unit} 中的 {tests} 病例：{samples}",
  "order.microPreview.sample": "{type}样本 {number}",
  "order.microPreview.stays": "{test} 保留在结果中",
  "order.microPreview.splitTag": "分开的病例",
  "order.microPreview.split": "样本 {number} 将创建 {count} 个病例：{units}。",
  "order.microPreview.reflex": "{name}：如果{conditions}，可能添加 {tests}。",
  "order.microPreview.component": "{test}：{component}",
  "order.microPreview.specimen": "{test}（{type}）",
  "order.microPreview.and": " 和 ",
  "order.microPreview.or": " 或 ",
  "order.microPreview.condition.EQUALS": "{subject} 结果等于 {value}",
  "order.microPreview.condition.NOT_EQUALS": "{subject} 结果不等于 {value}",
  "order.microPreview.condition.LESS_THAN": "{subject} 结果小于 {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "{subject} 结果不高于 {value}",
  "order.microPreview.condition.GREATER_THAN": "{subject} 结果大于 {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "{subject} 结果不低于 {value}",
  "order.microPreview.condition.BETWEEN": "{subject} 结果介于 {value} 和 {value2} 之间",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "{subject} 结果在正常范围内",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "{subject} 结果超出正常范围",
  "order.microPreview.newUnitTag": "新实验室单元",
  "order.microPreview.newUnit": "{test} 将在 {unit} 中创建病例；该订单在此实验室单元中没有其他工作。",
  "dictionary.containerPopulation": "采样瓶适用人群（样本容器）",
  "dictionary.containerPopulation.unspecified": "未指定",
  "dictionary.containerPopulation.ADULT": "成人",
  "dictionary.containerPopulation.PAEDIATRIC": "儿童",
  "dictionary.aedesAegyptiPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAegyptiPathogens.dengue": "Dengue",
  "dictionary.aedesAegyptiPathogens.yellowFever": "Yellow Fever",
  "dictionary.aedesAegyptiPathogens.zika": "Zika",
  "dictionary.aedesAlbopictusPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAlbopictusPathogens.dengue": "Dengue",
  "dictionary.aedesAlbopictusPathogens.zika": "Zika",
  "dictionary.afbSkinResults.1Plus": "1+",
  "dictionary.afbSkinResults.2Plus": "2+",
  "dictionary.afbSkinResults.3Plus": "3+",
  "dictionary.afbSkinResults.4Plus": "4+",
  "dictionary.afbSkinResults.5Plus": "5+",
  "dictionary.afbSkinResults.6Plus": "6+",
  "dictionary.afbSkinResults.negative": "Negative",
  "dictionary.afbSputumResults.1Plus": "1+",
  "dictionary.afbSputumResults.2Plus": "2+",
  "dictionary.afbSputumResults.3Plus": "3+",
  "dictionary.afbSputumResults.negative": "Negative",
  "dictionary.afbSputumResults.scanty": "Scanty",
  "dictionary.analyzerGeneXpertResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertResults.error": "ERROR",
  "dictionary.analyzerGeneXpertResults.high": "HIGH",
  "dictionary.analyzerGeneXpertResults.indeterminate": "INDETERMINATE",
  "dictionary.analyzerGeneXpertResults.low": "LOW",
  "dictionary.analyzerGeneXpertResults.medium": "MEDIUM",
  "dictionary.analyzerGeneXpertResults.mtbDetected": "MTB DETECTED",
  "dictionary.analyzerGeneXpertResults.noResult": "NO RESULT",
  "dictionary.analyzerGeneXpertResults.notDetected": "NOT DETECTED",
  "dictionary.analyzerGeneXpertResults.veryLow": "VERY LOW",
  "dictionary.analyzerGeneXpertRifResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertRifResults.indeterminate": "未确定",
  "dictionary.analyzerGeneXpertRifResults.notDetected": "NOT DETECTED",
  "dictionary.anophelesPathogens.malaria": "疟疾",
  "dictionary.biolineHivResults.hiv1And2Positive": "HIV 1 and 2 Positive",
  "dictionary.biolineHivResults.hiv1Positive": "HIV 1 Positive",
  "dictionary.biolineHivResults.hiv2Positive": "HIV 2 Positive",
  "dictionary.biolineHivResults.indeterminate": "未确定",
  "dictionary.biolineHivResults.negative": "Negative",
  "dictionary.candidaKohResults.hypa": "Hyphae",
  "dictionary.candidaKohResults.spora": "Spores",
  "dictionary.candidaKohResults.yeastCell": "Yeast cell",
  "dictionary.clinicalCollectionMethod.arterialPuncture": "Arterial Puncture",
  "dictionary.clinicalCollectionMethod.aspirate": "Aspirate",
  "dictionary.clinicalCollectionMethod.biopsy": "Biopsy",
  "dictionary.clinicalCollectionMethod.capillaryFingerPrick": "Capillary / Finger Prick",
  "dictionary.clinicalCollectionMethod.catheter": "Catheter",
  "dictionary.clinicalCollectionMethod.heelPrick": "Heel Prick",
  "dictionary.clinicalCollectionMethod.lumbarPuncture": "Lumbar Puncture",
  "dictionary.clinicalCollectionMethod.midstreamCleanCatch": "Midstream Clean Catch",
  "dictionary.clinicalCollectionMethod.other": "其他原因",
  "dictionary.clinicalCollectionMethod.sputumExpectoration": "Sputum Expectoration",
  "dictionary.clinicalCollectionMethod.swab": "Swab",
  "dictionary.clinicalCollectionMethod.venipuncture": "Venipuncture",
  "dictionary.confirmatoryResults.indeterminate": "未确定",
  "dictionary.confirmatoryResults.invalid": "无效",
  "dictionary.confirmatoryResults.negative": "Negative",
  "dictionary.confirmatoryResults.positive": "阳性",
  "dictionary.culexPathogens.westNileVirus": "West Nile Virus",
  "dictionary.detectionResults.terdeteksi": "Detected",
  "dictionary.detectionResults.tidakMeyakinkan": "Inconclusive",
  "dictionary.detectionResults.tidakTerdeteksi": "Not Detected",
  "dictionary.envCollectionMethod.composite24H": "Composite 24h",
  "dictionary.envCollectionMethod.composite8H": "Composite 8h",
  "dictionary.envCollectionMethod.depthIntegrated": "Depth Integrated",
  "dictionary.envCollectionMethod.grabSample": "Grab Sample",
  "dictionary.envCollectionMethod.other": "其他原因",
  "dictionary.envCollectionMethod.passiveSampler": "Passive Sampler",
  "dictionary.envCollectionMethod.surfaceGrab": "Surface Grab",
  "dictionary.envWeather.clearSunny": "Clear / Sunny",
  "dictionary.envWeather.drizzle": "Drizzle",
  "dictionary.envWeather.foggy": "Foggy",
  "dictionary.envWeather.heavyRain": "Heavy Rain",
  "dictionary.envWeather.lightRain": "Light Rain",
  "dictionary.envWeather.other": "其他原因",
  "dictionary.envWeather.overcast": "Overcast",
  "dictionary.envWeather.partlyCloudy": "Partly Cloudy",
  "dictionary.envWeather.windy": "Windy",
  "dictionary.environmentalZone.agricultural": "Agricultural",
  "dictionary.environmentalZone.industrial": "Industrial",
  "dictionary.environmentalZone.periUrban": "Peri-Urban",
  "dictionary.environmentalZone.protectedArea": "Protected Area",
  "dictionary.environmentalZone.rural": "Rural",
  "dictionary.environmentalZone.urban": "Urban",
  "dictionary.fleaFullCycle.adult": "成人",
  "dictionary.fleaFullCycle.egg": "Egg",
  "dictionary.fleaFullCycle.larva": "Larva",
  "dictionary.fleaFullCycle.pupa": "Pupa",
  "dictionary.flyStages.adult": "成人",
  "dictionary.flyStages.larva": "Larva",
  "dictionary.flyStages.pupa": "Pupa",
  "dictionary.genieHivResults.hiv1": "HIV 1",
  "dictionary.genieHivResults.hiv2": "HIV 2",
  "dictionary.genieHivResults.hivDual": "HIV Dual",
  "dictionary.genieHivResults.indeterminate": "未确定",
  "dictionary.genieHivResults.invalid": "无效",
  "dictionary.genieHivResults.negative": "Negative",
  "dictionary.gramStainGenitalResults.gramDiplococcusFound": "Gram(-) diplococcus found",
  "dictionary.gramStainGenitalResults.gramDiplococcusNotFound": "Gram(-) diplococcus not found",
  "dictionary.hBsAgResults.negative": "Negative",
  "dictionary.hBsAgResults.positive": "阳性",
  "dictionary.hivRapidResults.indeterminate": "未确定",
  "dictionary.hivRapidResults.negative": "Negative",
  "dictionary.hivRapidResults.positive": "阳性",
  "dictionary.malariaResults.mixedInfection": "Mixed infection",
  "dictionary.malariaResults.noParasitesSeen": "No parasites seen",
  "dictionary.malariaResults.plasmodiumFalciparum": "Plasmodium falciparum",
  "dictionary.malariaResults.plasmodiumMalariae": "Plasmodium malariae",
  "dictionary.malariaResults.plasmodiumOvale": "Plasmodium ovale",
  "dictionary.malariaResults.plasmodiumVivax": "Plasmodium vivax",
  "dictionary.mosquitoFullCycle.adult": "成人",
  "dictionary.mosquitoFullCycle.egg": "Egg",
  "dictionary.mosquitoFullCycle.larva": "Larva",
  "dictionary.mosquitoFullCycle.pupa": "Pupa",
  "dictionary.muscaPathogens.typhus": "Typhus",
  "dictionary.p24AgResults.hiv1": "HIV 1",
  "dictionary.p24AgResults.indeterminate": "未确定",
  "dictionary.p24AgResults.negative": "Negative",
  "dictionary.phlebotomusPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.positifNegatif.negatif": "Negative",
  "dictionary.positifNegatif.positif": "阳性",
  "dictionary.pregnancyTestResults.negative": "Negative",
  "dictionary.pregnancyTestResults.positive": "阳性",
  "dictionary.proteinuriaResults.negative": "Negative",
  "dictionary.proteinuriaResults.positivePlus": "Positive +",
  "dictionary.proteinuriaResults.positivePlusPlus": "Positive ++",
  "dictionary.proteinuriaResults.positivePlusPlusPlus": "Positive +++",
  "dictionary.qaChecklistItem.labelsVerified": "Labels have been printed and applied",
  "dictionary.qaChecklistItem.patientInfoVerified": "Patient information is correct",
  "dictionary.qaChecklistItem.samplesVerified": "Sample types and tests are correct",
  "dictionary.qaChecklistItem.storageVerified": "Storage locations have been assigned",
  "dictionary.rattusPathogens.plague": "Plague",
  "dictionary.rattusPathogens.typhus": "Typhus",
  "dictionary.rodentStages.adult": "成人",
  "dictionary.sampleAcceptanceItem.coldChain": "Cold chain maintained",
  "dictionary.sampleAcceptanceItem.containerIntact": "Container intact / undamaged",
  "dictionary.sampleAcceptanceItem.labelLegible": "Label legible and matches request",
  "dictionary.sampleAcceptanceItem.paperwork": "Required paperwork present and complete",
  "dictionary.sampleAcceptanceItem.transit": "Acceptable transit time / condition",
  "dictionary.sampleAcceptanceItem.volumeAdequate": "Sample volume adequate",
  "dictionary.sampleContainer.1LHdpeBottle": "1L HDPE bottle",
  "dictionary.sampleContainer.250MLGlassBottle": "250mL glass bottle",
  "dictionary.sampleContainer.500MLGlassBottle": "500mL glass bottle",
  "dictionary.sampleContainer.compositeJerryCan5L": "Composite jerry can 5L",
  "dictionary.sampleContainer.filterMembrane": "Filter membrane",
  "dictionary.sampleContainer.other": "其他原因",
  "dictionary.sampleContainer.sterileBag": "Sterile bag",
  "dictionary.sampleType.hPlasma": "Plasma",
  "dictionary.sampleType.hSaliva": "Saliva",
  "dictionary.sampleType.hSerum": "Serum",
  "dictionary.sampleType.hTissue": "Tissue",
  "dictionary.sampleType.hUrine": "Urine",
  "dictionary.sampleType.hWholeBlood": "Whole Blood",
  "dictionary.samplingSiteType.airMonitoringStation": "Air Monitoring Station",
  "dictionary.samplingSiteType.distributionPoint": "Distribution Point",
  "dictionary.samplingSiteType.foodFacility": "Food Facility",
  "dictionary.samplingSiteType.monitoringStation": "Monitoring Station",
  "dictionary.samplingSiteType.other": "其他原因",
  "dictionary.samplingSiteType.soilSamplingSite": "Soil Sampling Site",
  "dictionary.samplingSiteType.treatmentPlant": "Treatment Plant",
  "dictionary.samplingSiteType.waterSource": "Water Source",
  "dictionary.specimenOrigin.communityField": "Community / Field",
  "dictionary.specimenOrigin.emergencyDepartment": "Emergency Department",
  "dictionary.specimenOrigin.inpatientWard": "Inpatient Ward",
  "dictionary.specimenOrigin.intensiveCare": "Intensive Care",
  "dictionary.specimenOrigin.operatingTheatre": "Operating Theatre",
  "dictionary.specimenOrigin.outpatientClinic": "Outpatient Clinic",
  "dictionary.specimenOrigin.referredFromExternalFacility": "Referred from External Facility",
  "dictionary.susceptibilityResults.intermediate": "中介",
  "dictionary.susceptibilityResults.resistan": "耐药",
  "dictionary.susceptibilityResults.sensitif": "Sensitive",
  "dictionary.testResults.detected": "Detected",
  "dictionary.testResults.inconclusive": "Inconclusive",
  "dictionary.testResults.indeterminate": "未确定",
  "dictionary.testResults.negative": "Negative",
  "dictionary.testResults.nonReactive": "Non-Reactive",
  "dictionary.testResults.notDetected": "Not Detected",
  "dictionary.testResults.positive": "阳性",
  "dictionary.testResults.reactive": "Reactive",
  "dictionary.titerResults.1To10": "1:10",
  "dictionary.titerResults.1To160": "1:160",
  "dictionary.titerResults.1To20": "1:20",
  "dictionary.titerResults.1To320": "1:320",
  "dictionary.titerResults.1To40": "1:40",
  "dictionary.titerResults.1To640": "1:640",
  "dictionary.titerResults.1To80": "1:80",
  "dictionary.trichomonasResults.trichomonasNegative": "Trichomonas negative",
  "dictionary.trichomonasResults.trichomonasPositive": "Trichomonas positive",
  "dictionary.urinalysisResults.clear": "清除位置",
  "dictionary.urinalysisResults.cloudy": "Cloudy",
  "dictionary.urinalysisResults.slightlyCloudy": "Slightly Cloudy",
  "dictionary.urinalysisResults.turbid": "Turbid",
  "dictionary.urineColor.amber": "Amber",
  "dictionary.urineColor.brown": "Brown",
  "dictionary.urineColor.darkYellow": "Dark Yellow",
  "dictionary.urineColor.red": "Red",
  "dictionary.urineColor.yellow": "Yellow",
  "dictionary.vecBloodmealHostSpecies.avianProxyToChicken": "Avian (proxy: chicken)",
  "dictionary.vecBloodmealHostSpecies.cattleBosTaurus": "Cattle (Bos taurus)",
  "dictionary.vecBloodmealHostSpecies.dogCanisFamiliaris": "Dog (Canis familiaris)",
  "dictionary.vecBloodmealHostSpecies.goatCapraHircus": "Goat (Capra hircus)",
  "dictionary.vecBloodmealHostSpecies.humanHomoSapiens": "Human (Homo sapiens)",
  "dictionary.vecBloodmealHostSpecies.mixedHostBloodmeal": "Mixed-host bloodmeal",
  "dictionary.vecBloodmealHostSpecies.noHostDetected": "No host detected",
  "dictionary.vecBloodmealHostSpecies.pigSusScrofa": "Pig (Sus scrofa)",
  "dictionary.vecCollectionTimeOfDay.dawn": "黎明",
  "dictionary.vecCollectionTimeOfDay.daylight": "Daylight",
  "dictionary.vecCollectionTimeOfDay.dusk": "黄昏",
  "dictionary.vecCollectionTimeOfDay.night": "夜晚",
  "dictionary.vecCollectionTimeOfDay.unknown": "未知",
  "dictionary.vecInsecticideResistanceGenotype.heterozygote": "Heterozygote",
  "dictionary.vecInsecticideResistanceGenotype.indeterminate": "未确定",
  "dictionary.vecInsecticideResistanceGenotype.resistantHomozygote": "Resistant homozygote",
  "dictionary.vecInsecticideResistanceGenotype.susceptibleHomozygote": "Susceptible homozygote",
  "dictionary.vecLifecycleStages.adult": "成人",
  "dictionary.vecLifecycleStages.egg": "Egg",
  "dictionary.vecLifecycleStages.larva": "Larva",
  "dictionary.vecLifecycleStages.nymph": "Nymph",
  "dictionary.vecLifecycleStages.pupa": "Pupa",
  "dictionary.vecPathogenResult.equivocalIndeterminate": "Equivocal / Indeterminate",
  "dictionary.vecPathogenResult.invalid": "无效",
  "dictionary.vecPathogenResult.negative": "Negative",
  "dictionary.vecPathogenResult.positive": "阳性",
  "dictionary.vecPathogens.chikungunya": "Chikungunya",
  "dictionary.vecPathogens.dengue": "Dengue",
  "dictionary.vecPathogens.malaria": "疟疾",
  "dictionary.vecPathogens.plague": "Plague",
  "dictionary.vecPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.vecPathogens.typhus": "Typhus",
  "dictionary.vecPathogens.westNileVirus": "West Nile Virus",
  "dictionary.vecPathogens.yellowFever": "Yellow Fever",
  "dictionary.vecPathogens.zika": "Zika",
  "dictionary.vecPhysiologicalState.bloodFed": "吸过血的",
  "dictionary.vecPhysiologicalState.gravid": "Gravid",
  "dictionary.vecPhysiologicalState.halfGravid": "半孕期",
  "dictionary.vecPhysiologicalState.unfed": "未喂食",
  "dictionary.vecPhysiologicalState.unknownNotAssessed": "未知 / 未评估",
  "dictionary.vecPlasmodiumDrugResistanceVariant.76T": "76T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a437G": "A437G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a581G": "A581G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a613S": "A613S",
  "dictionary.vecPlasmodiumDrugResistanceVariant.c580Y": "C580Y",
  "dictionary.vecPlasmodiumDrugResistanceVariant.d1246": "D1246",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i164L": "I164L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i543T": "I543T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k540E": "K540E",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k76WildType": "K76 (wild type)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n1042": "N1042",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n51I": "N51I",
  "dictionary.vecPlasmodiumDrugResistanceVariant.otherVariantSequenceCaptured": "Other variant (sequence captured)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.p553L": "P553L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r539T": "R539T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r59": "R59",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s1034": "S1034",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s108": "S108",
  "dictionary.vecPlasmodiumDrugResistanceVariant.wildTypePfkelch13": "Wild type (pfkelch13)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y184": "Y184",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y493H": "Y493H",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y86": "Y86",
  "dictionary.vecPlasmodiumSpecies.indeterminate": "未确定",
  "dictionary.vecPlasmodiumSpecies.mixedInfection": "Mixed infection",
  "dictionary.vecPlasmodiumSpecies.pFalciparum": "P. falciparum",
  "dictionary.vecPlasmodiumSpecies.pKnowlesi": "P. knowlesi",
  "dictionary.vecPlasmodiumSpecies.pMalariae": "P. malariae",
  "dictionary.vecPlasmodiumSpecies.pOvale": "P. ovale",
  "dictionary.vecPlasmodiumSpecies.pVivax": "P. vivax",
  "dictionary.vecRestingContext.indoorEndophilic": "室内（喜室内环境）",
  "dictionary.vecRestingContext.outdoorExophilic": "户外（外栖性）",
  "dictionary.vecRestingContext.unknown": "未知",
  "dictionary.vecTrapType.aspirator": "Aspirator",
  "dictionary.vecTrapType.bgSentinelTrap": "BG-Sentinel trap",
  "dictionary.vecTrapType.cdcLightTrap": "CDC light trap",
  "dictionary.vecTrapType.gravidTrap": "Gravid trap",
  "dictionary.vecTrapType.humanLandingCollection": "Human-landing collection",
  "dictionary.vecTrapType.otherSpecifyInNotes": "Other (specify in notes)",
  "dictionary.vecTrapType.ovitrap": "Ovitrap",
  "dictionary.vecTrapType.sweepNet": "Sweep net",
  "dictionary.vecVirusIsolationResult.inconclusive": "Inconclusive",
  "dictionary.vecVirusIsolationResult.isolated": "Isolated",
  "dictionary.vecVirusIsolationResult.notIsolated": "Not isolated",
  "dictionary.vecWhoInsecticideSusceptibilityClass.possiblyResistant": "Possibly resistant",
  "dictionary.vecWhoInsecticideSusceptibilityClass.resistant": "耐药",
  "dictionary.vecWhoInsecticideSusceptibilityClass.susceptible": "敏感",
  "dictionary.waterClarity.agakKeruh": "Slightly Turbid",
  "dictionary.waterClarity.jernih": "清除位置",
  "dictionary.waterClarity.keruh": "Turbid",
  "dictionary.waterColor.biru": "Blue",
  "dictionary.waterColor.cokelat": "Brown",
  "dictionary.waterColor.hijau": "Green",
  "dictionary.waterColor.hitam": "Black",
  "dictionary.waterColor.kuning": "Yellow",
  "dictionary.waterColor.merah": "Red",
  "dictionary.waterColor.putih": "White",
  "dictionary.waterColor.tidakBerwarna": "Colorless",
  "dictionary.xenopsyllaPathogens.plague": "Plague",
  "dictionary.xenopsyllaPathogens.typhus": "Typhus",
  "microbiology.sets.warning.MIXED_POPULATIONS": "本套同时包含儿童瓶和成人瓶。",
  "order.cultureSetNumber": "套号",
  "order.cultureSetNumber.required": "请输入正整数套号。",
  "order.cultureBottle.duplicate": "复制培养瓶",
  "microbiology.sets.container": "容器类型",
  "microbiology.sets.bodySite": "身体部位",
  "inventory.reorder.suggestions": "再订购建议",
  "inventory.reorder.help": "库存处于或低于阈值，或预计在新订单到货前达到阈值的物品。标记为已订购仅记录已下订单，并不会实际下订单。",
  "inventory.reorder.none": "目前无需订购任何物品。",
  "inventory.reorder.markOrdered": "标记为已订购",
  "inventory.reorder.onOrder": "已订购",
  "inventory.reorder.note": "备注",
  "inventory.reorder.note.placeholder": "申请单或采购订单编号",
  "inventory.reorder.expectedDate": "预计日期",
  "inventory.reorder.marked": "{count, plural, other {# 项}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "审查并标记为已订购",
  "inventory.reorder.clearOrdered": "取消已订购标记",
  "inventory.reorder.cleared": "{count, plural, other {# 项}} no longer marked as ordered.",
  "inventory.board.andMore": "及其他 {count} 项",
  "inventory.item.leadTime": "交货周期（天）",
  "inventory.item.leadTime.help": "此物品从订购到到货所需的时间。留空则根据您自己的到货记录学习得出。",
  "inventory.item.leadTime.observedSuggest": "您最近几次到货大约需要 {days} 天。",
  "inventory.item.leadTime.useObserved": "使用此值",
  "inventory.item.tags": "标签",
  "inventory.item.tags.help": "此物品的分组、筛选和报告方式。一个物品可以有多个标签。",
  "inventory.item.tags.add": "输入以查找或添加标签",
  "inventory.item.tags.remove": "移除标签 {tag}",
  "inventory.item.autoConsume.help": "没有自动消耗设置。将物品关联到检测目录中的检测后，工作台在录入该检测结果时即可记录其使用。",
  "inventory.search.placeholder.board": "按物品名称、代码、标签或批号搜索",
  "inventory.filter.tags": "按标签筛选",
  "inventory.filter.tags.clear": "清除标签",
  "inventory.tags.manage": "管理标签",
  "inventory.tags.help": "整理标签。停用某个标签后，它将不再被推荐或作为筛选条件提供。已带有该标签的物品会保留它。",
  "inventory.tags.tag": "标签",
  "inventory.tags.usage": "物品",
  "inventory.tags.status": "状态",
  "inventory.tags.active": "活跃",
  "inventory.tags.deactivated": "已停用",
  "inventory.tags.deactivate": "停用",
  "inventory.tags.reactivate": "重新激活",
  "inventory.tags.showDeactivated": "显示已停用",
  "inventory.tags.new": "新标签",
  "inventory.tags.add": "添加标签",
  "inventory.tags.none": "暂无标签。可在此添加，或直接为物品添加标签。",
  "inventory.tags.error.blank": "标签需要名称。",
  "inventory.item.new": "新物品",
  "inventory.item.created": "物品已定义。针对它接收库存即可开始跟踪数量。",
  "inventory.item.showDeactivated": "显示已停用",
  "inventory.item.deactivated": "已停用",
  "inventory.item.deactivate": "停用物品",
  "inventory.item.reactivate": "重新启用物品",
  "inventory.item.reactivated": "{item} 已重新启用。",
  "inventory.item.deactivated.success": "{item} 已停用。可通过“显示已停用”再次找到它。",
  "inventory.item.deactivate.confirm.title": "停用此物品？",
  "inventory.item.deactivate.confirm": "停用 {item}？",
  "inventory.item.deactivate.implication.hidden": "它将从看板中移除，并且在接收或记录使用时不再提供。",
  "inventory.item.deactivate.implication.stock": "其批次和历史记录会保留，仍持有的库存不会被核销。",
  "inventory.item.deactivate.implication.reversible": "您可以随时在“显示已停用”中重新启用它。",
  "catalog.item.catalogNumber": "目录编号",
  "catalog.item.expirationAlertDays": "到期前提前提醒的天数",
  "catalog.item.trackLots": "跟踪批次和有效期",
  "catalog.item.trackLots.help": "适用于分批接收且有有效期的物品。按单一总量计数的耗材请关闭。",
  "catalog.item.form.help": "此处定义一种物品。如需增加已有物品的数量，请使用接收库存。",
  "inventory.item.form.title.add": "新物品",
  "inventory.item.form.title.edit": "编辑物品",
  "inventory.count.enter": "盘点模式",
  "inventory.count.leave": "退出盘点模式",
  "inventory.count.confirm": "确认盘点",
  "inventory.count.expected": "共 {expected} {units}",
  "inventory.count.matches": "相符",
  "inventory.count.perLot": "逐个盘点以下批次（此处预计 {expected} {units}）",
  "inventory.count.nothingHere": "此处没有可盘点的物品",
  "inventory.count.countOf": "{item} 的盘点数量",
  "inventory.count.tally": "{counted, plural, =0 {尚未盘点} one {已盘点 # 个批次} other {已盘点 # 个批次}}",
  "inventory.count.scoped": "正在盘点 {location}。仅列出此位置的库存，且仅提交您输入的内容。",
  "inventory.count.unscoped": "正在盘点所有位置。按位置筛选可一次盘点一个货架。仅提交您输入的内容。",
  "inventory.count.done": "盘点已记录：{adjusted, plural, =0 {无更正} one {# 项更正} other {# 项更正}}，{confirmed, plural, =0 {无确认} one {已确认 # 个批次} other {已确认 # 个批次}}。",
  "inventory.count.lastCounted": "盘点于 {date}",
  "inventory.count.neverCounted": "从未盘点",
  "inventory.count.column": "上次盘点",
  "inventory.delivery.purpose": "录入到货。扫描一箱，输入到货数量，添加，再扫描下一箱。在您确认整批到货之前，不会保存任何内容。",
  "inventory.delivery.scan": "扫描箱子",
  "inventory.delivery.scan.help": "GS1 标签会自动填写产品、批号和有效期。标签未包含的信息可在下方输入。",
  "inventory.delivery.scan.unread": "无法识别该代码。请手动输入该行。",
  "inventory.delivery.partialScan": "部分已扫描",
  "inventory.delivery.add": "添加到到货单",
  "inventory.delivery.remove": "移除",
  "inventory.delivery.confirm": "接收 {count, plural, one {# 行} other {# 行}}",
  "inventory.delivery.discard": "放弃到货单",
  "inventory.delivery.received": "{count, plural, other {# 行}} received.",
  "inventory.delivery.expired": "此批次已超过有效期",
  "inventory.delivery.expired.help": "您仍可接收它。近效期库存属于正常到货，看板会对其进行标记。",
  "catalog.item.upc": "产品条码（UPC 或 GTIN）",
  "catalog.item.upc.help": "此产品的制造商条码。同一产品的每一盒都带有相同的条码，因此扫描该条码可识别物品种类，而不是到货的批次。",
  "inventory.receive.title": "接收库存",
  "inventory.receive.submit": "接收",
  "inventory.receive.success": "已接收 {quantity} {units}。该数量现已计入现有库存，质控通过后即可使用。",
  "inventory.receive.help": "为已有物品增加数量。如需定义新物品，请使用“新物品”。",
  "inventory.receive.scan": "扫描产品条码",
  "inventory.receive.scan.help": "扫描或输入 UPC 即可直接选择物品，无需搜索。",
  "inventory.receive.scan.unknown": "没有物品使用该条码",
  "inventory.receive.quantityWithUnits": "接收数量（{units}）",
  "inventory.receive.lotNumber.help": "留空则根据物品代码和当天日期自动生成批号。",
  "inventory.receive.location.optional": "未分配。可以现在设置，也可以稍后在批次中设置。",
  "inventory.receive.error.noItem": "请选择要接收的物品。",
  "inventory.receive.error.quantity": "请输入到货数量。",
  "inventory.receive.error.locationAfterReceive": "库存已接收，但无法分配存储位置：{reason}",
  "reports.type.received": "已接收",
  "reports.type.received.description": "期间内到货的物品，按物品和批次列出。",
  "reports.type.consumed": "已消耗",
  "reports.type.consumed.description": "期间内的使用量，按物品汇总。",
  "reports.type.stockOnHand": "现有库存",
  "reports.type.stockOnHand.description": "您持有的库存，按批次列出，含有效期。",
  "reports.type.expiring": "即将过期",
  "reports.type.expiring.description": "有效期落在您所选时间段内的批次。",
  "reports.asOfDate": "截至",
  "reports.asOfDate.help": "留空则显示当前库存。",
  "reports.expiringFrom": "有效期起始",
  "reports.expiringTo": "有效期截止",
  "reports.tags": "标签",
  "reports.tags.help": "仅包含带有任一这些标签的物品。",
  "reports.tags.placeholder": "任意标签",
  "reports.run": "运行报告",
  "reports.running": "运行中...",
  "reports.empty": "没有符合这些筛选条件的内容。",
  "reports.empty.stockOnHandAsOf": "该日期当天或之前没有记录任何库存变动，因此无法重建当时的库存。这并不等同于当时没有任何库存。",
  "reports.asOfDate.basis": "根据截至该日期记录的库存变动重建，而非根据实物盘点。",
  "order.continue.item.eqaScheme": "Choose the EQA scheme",
  "order.eqa.cycle": "轮次",
  "order.eqa.cycle.none": "No cycle",
  "order.eqa.cycleNotInScheme": "The chosen cycle is not an open cycle of this EQA scheme.",
  "order.eqa.newCycle": "新建轮次",
  "order.eqa.noCycle.warning": "This sample is not linked to a cycle, so it will not be submitted or scored from OpenELIS.",
  "order.eqa.noEnrollments.link": "Enroll under My EQA Schemes",
  "order.eqa.noEnrollments.title": "This laboratory is not enrolled in any active EQA scheme.",
  "order.eqa.providerSampleId.codes": "Panel codes for this cycle: {codes}",
  "order.eqa.providerSampleId.noMatch": "This code matches none of the cycle's panel codes ({codes}).",
  "order.eqa.scheme": "室间质评计划",
  "order.eqa.scheme.choose": "Choose a scheme",
  "order.eqa.schemeRequired": "Choose the EQA scheme this sample belongs to.",
  "order.eqa.schemeUnknown": "The chosen EQA scheme is not one of this laboratory's active enrollments.",
  "order.save.requirement.eqaScheme": "the EQA scheme",
  "save.order.success.labNumber": "Order {labNumber} has been saved.",
  "qc.status.error.required": "Select a QC status.",
  "qc.status.error.notesRequired": "Say why QC failed.",
  "disposal.error.reasonRequired": "Select a disposal reason.",
  "common.error.notesRequiredForOther": "Add a note to explain the reason you chose.",
  "adjustment.error.negativeQuantity": "Quantity cannot be negative.",
  "adjustment.error.reasonRequired": "Select a reason for the adjustment.",
  "lot.error.numberRequired": "Lot number is required.",
  "lot.error.locationRequired": "Assign a storage location.",
  "lot.status.select": "Select lot status",
  "catalog.item.error.nameRequired": "Item name is required.",
  "sidenav.label.inventory.items": "物品",
  "sidenav.label.inventory.items.tooltip": "What you have and what to reorder",
  "sidenav.label.inventory.receive": "接收",
  "sidenav.label.inventory.receive.tooltip": "Enter a delivery, scanning or typing each line",
  "sidenav.label.inventory.reports": "报告",
  "sidenav.label.inventory.reports.tooltip": "Received, consumed, stock on hand and expiring",
  "inventory.import.button": "Import items",
  "inventory.import.title": "Import items from a file",
  "inventory.import.help": "Define many items at once from a CSV file. The preview shows what the file would do and saves nothing; only Apply writes anything. Re-importing a corrected file updates the same items rather than adding them again.",
  "inventory.import.template": "Download the template",
  "inventory.import.dropzone": "Add a CSV file",
  "inventory.import.preview": "预览",
  "inventory.import.apply": "应用",
  "inventory.import.plan.title": "What this file would do",
  "inventory.import.result.title": "What was imported",
  "inventory.import.column.line": "行",
  "inventory.import.column.outcome": "结果",
  "inventory.import.column.reason": "原因",
  "inventory.import.outcome.create": "新建",
  "inventory.import.outcome.update": "更新",
  "inventory.import.outcome.unchanged": "未更改",
  "inventory.import.outcome.skip": "已跳过",
  "inventory.import.count.created": "{count} new",
  "inventory.import.count.updated": "已更新{count}",
  "inventory.import.count.unchanged": "{count} 未作更改",
  "inventory.import.count.skipped": "{count} 已跳过",
  "inventory.import.error.rowsTitle": "Some rows cannot be used",
  "inventory.import.error.rowsMessage": "The rows listed below will be skipped. Applying saves the rest; fix those rows and add the file again to include them.",
  "inventory.import.error.unreadable": "That file could not be read.",
  "inventory.import.error.failed": "The file could not be imported.",
  "inventory.import.nothingToDo": "This file would change nothing",
  "inventory.import.nothingToDo.help": "Every item in it already matches what is stored.",
  "sidenav.label.reports.printQueue": "Report Print Queue",
  "reportQueue.title": "Report Print Queue",
  "reportQueue.subtitle": "Print, reprint and reissue released reports",
  "reportQueue.guidance.lead": "Reports land here when their first result is released.",
  "reportQueue.guidance.body": "Printed reports come back when more results are released or a printed result changes.",
  "reportQueue.legend.partial": "Some results are not released yet",
  "reportQueue.legend.final": "Every result is released",
  "reportQueue.legend.amended": "A printed result changed, or the report was reissued with a correction",
  "reportQueue.legend.unprinted": "The current content has not been printed yet",
  "reportQueue.legend.printed": "The last print matches what is released",
  "reportQueue.tile.toPrint": "To print",
  "reportQueue.tile.amendedToPrint": "Amended to print",
  "reportQueue.type.patient": "Patient report",
  "reportQueue.state.partial": "Partial {released}/{total}",
  "reportQueue.state.partialName": "Partial",
  "reportQueue.state.final": "最终确定版",
  "reportQueue.state.amended": "已修订",
  "reportQueue.state.amendedPartial": "Amended {released}/{total}",
  "reportQueue.printStatus.unprinted": "Unprinted",
  "reportQueue.printStatus.printed": "Printed",
  "reportQueue.col.type": "设备类型",
  "reportQueue.col.labNoName": "Lab No / Name",
  "reportQueue.col.subject": "主题",
  "reportQueue.col.details": "详情",
  "reportQueue.col.released": "Released / Submitted",
  "reportQueue.col.state": "状态",
  "reportQueue.col.printStatus": "Print status",
  "reportQueue.col.version": "版本",
  "reportQueue.version.none": "Not issued",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "打印",
  "reportQueue.print.disabled.nothingReleased": "Nothing released yet on this order",
  "reportQueue.print.success": "{count, plural, one {# report} other {# reports}} ready",
  "reportQueue.print.failed": "Could not prepare {count, plural, one {# report} other {# reports}}: {labNumbers}",
  "reportQueue.print.reprinted": "Reprinted version {n} of {labNumber}",
  "reportQueue.print.issued": "Printed version {n} of {labNumber}",
  "reportQueue.print.popupBlocked": "The browser blocked the report window for {labNumber}",
  "reportQueue.print.open": "Open the report",
  "reportQueue.filter.labNo.placeholder": "Scan or type lab number",
  "reportQueue.filter.labNo.helper": "Scanning a barcode applies the filter instantly",
  "reportQueue.filter.labNo.range": "范围",
  "reportQueue.filter.labNo.to": "To lab number",
  "reportQueue.filter.labNo.rangeReversed": "The To lab number is before the From lab number",
  "reportQueue.filter.patient": "按患者搜索",
  "reportQueue.filter.state": "状态",
  "reportQueue.filter.printStatus": "Print status",
  "reportQueue.filter.window": "Time window",
  "reportQueue.filter.window.24h": "Last 24 hours",
  "reportQueue.filter.window.7d": "Last 7 days",
  "reportQueue.filter.window.30d": "Last 30 days",
  "reportQueue.filter.window.all": "All time",
  "reportQueue.filter.window.custom": "Custom range",
  "reportQueue.filter.window.to": "到",
  "reportQueue.filter.window.helper": "Applies to printed reports; unprinted ones always show",
  "reportQueue.filter.facility": "设施",
  "reportQueue.filter.ward": "Ward / Dept / Unit",
  "reportQueue.filter.ward.disabled": "Select a facility first",
  "reportQueue.filter.typeahead.helper": "Type 2 or more characters to search",
  "reportQueue.filter.clear": "清除筛选条件",
  "reportQueue.search.active.labNo": "Lab No: {labNo}",
  "reportQueue.search.active.labRange": "Lab No: {from} to {to}",
  "reportQueue.search.active.patient": "Patient: {name}",
  "reportQueue.search.clear": "清除搜索",
  "reportQueue.search.disabledHelper": "Other filters are off while you look up a specific order",
  "reportQueue.empty": "Nothing to print. Every released report in this view has been printed.",
  "reportQueue.error.load": "Could not load the queue.",
  "reportQueue.detail.tests": "检测项目",
  "reportQueue.detail.order": "排序",
  "reportQueue.detail.validatedBy": "Validated by",
  "reportQueue.detail.col.test": "检测",
  "reportQueue.detail.col.result": "结果",
  "reportQueue.detail.col.flag": "标记",
  "reportQueue.detail.col.released": "已发布",
  "reportQueue.detail.awaitingValidation": "Awaiting validation",
  "reportQueue.detail.inProgress": "进行中",
  "reportQueue.history.title": "Version history",
  "reportQueue.history.issued": "Issued",
  "reportQueue.history.by": "由",
  "reportQueue.history.change": "更改",
  "reportQueue.history.firstIssue": "First issue",
  "reportQueue.history.completeness": "Completeness",
  "reportQueue.history.fingerprint": "Fingerprint",
  "reportQueue.history.openPdf": "Open PDF",
  "reportQueue.history.reprinted": "Reprinted {date} by {user}",
  "reportQueue.history.notArchived": "Not archived (issued before {date})",
  "reportQueue.history.archiveFailed": "Archive failed",
  "reportQueue.history.none": "Nothing printed yet",
  "reportQueue.awaitingValidation": "Correction awaiting validation",
  "sidenav.label.reports.sentMessages": "已发送的消息",
  "sidenav.label.admin.notifications": "通知",
  "sidenav.label.admin.notifications.channels": "渠道",
  "sidenav.label.admin.notifications.templates": "模板",
  "sidenav.label.admin.notifications.delivery": "Delivery Settings",
  "sidenav.label.admin.notifications.triggers": "触发器",
  "delivery.sent.title": "已发送的消息",
  "delivery.sent.subtitle": "Every message the laboratory sent or tried to send: reports, alerts, notices, notification triggers and channel tests",
  "delivery.sent.empty": "Nothing sent in this period.",
  "delivery.sent.loadError": "The messages could not be loaded",
  "delivery.sent.resend": "重新发送",
  "delivery.sent.resend.done": "Message queued again.",
  "delivery.sent.resend.failed": "The message could not be queued again.",
  "delivery.sent.sentBy.auto": "Automatic",
  "delivery.sent.col.time": "时间",
  "delivery.sent.col.product": "Product",
  "delivery.sent.col.labNo": "实验室编号",
  "delivery.sent.col.recipient": "收件人",
  "delivery.sent.col.channel": "渠道",
  "delivery.sent.col.status": "状态",
  "delivery.sent.col.attempts": "尝试次数",
  "delivery.sent.col.sentBy": "Sent by",
  "delivery.sent.filter.product": "Product",
  "delivery.sent.filter.status": "状态",
  "delivery.sent.filter.channel": "渠道",
  "delivery.sent.filter.to": "到",
  "delivery.sent.filter.recipient": "收件人",
  "delivery.sent.filter.all": "所有分析仪",
  "delivery.sent.detail.subject": "主题",
  "delivery.sent.detail.message": "消息",
  "delivery.sent.detail.attempts": "尝试次数",
  "delivery.sent.detail.noAttempts": "No attempt yet",
  "delivery.sent.detail.nextAttempt": "Next attempt {time}",
  "delivery.sent.detail.rule": "规则",
  "delivery.sent.detail.report": "Report version {n}, {format}",
  "delivery.sent.detail.openOrder": "Open the order",
  "delivery.sent.detail.openQueue": "Open in the Report Print Queue",
  "delivery.sent.detail.loadError": "The message could not be loaded",
  "delivery.status.queued": "已排队",
  "delivery.status.sent": "已发送",
  "delivery.status.failed": "失败数量",
  "delivery.status.skipped": "已跳过",
  "delivery.product.report": "报告",
  "delivery.product.alert": "Alert",
  "delivery.product.notice": "Ready notice",
  "delivery.product.trigger": "Notification",
  "delivery.product.test": "检测",
  "delivery.format.protected": "Protected full report",
  "delivery.format.masked": "Masked copy",
  "delivery.channel.email": "电子邮件",
  "delivery.channel.sms": "短信",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "渠道",
  "delivery.channel.subtitle": "Email, SMS and WhatsApp are set up here once and used by every message the laboratory sends",
  "delivery.channel.status.ready": "就绪",
  "delivery.channel.status.notSetUp": "Not set up",
  "delivery.channel.status.failing": "Failing",
  "delivery.channel.lastSuccess": "Last successful send",
  "delivery.channel.never": "从未",
  "delivery.channel.lastError": "Last error",
  "delivery.channel.active": "活跃",
  "delivery.channel.host": "SMTP host",
  "delivery.channel.port": "端口",
  "delivery.channel.security": "Security",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "无",
  "delivery.channel.username": "用户名",
  "delivery.channel.password": "密码",
  "delivery.channel.secretSet": "Set",
  "delivery.channel.secretHelper": "A secret is stored. Leave this blank to keep it.",
  "delivery.channel.replace": "替换",
  "delivery.channel.senderAddress": "Sender address",
  "delivery.channel.senderName": "Sender name",
  "delivery.channel.replyTo": "Reply-to address",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Auth token",
  "delivery.channel.whatsapp.from": "Sending number",
  "delivery.channel.whatsapp.address": "API address (optional)",
  "delivery.channel.countryCode": "Default country code",
  "delivery.channel.gateway": "Gateway",
  "delivery.channel.sms.note": "The SMS gateway (BMP or SMPP) keeps its settings in the server properties until its own change lands; this row shows whether one is enabled.",
  "delivery.channel.save": "保存",
  "delivery.channel.saved": "Channel saved.",
  "delivery.channel.saveFailed": "The channel could not be saved: check {field}.",
  "delivery.channel.sendTest": "Send test",
  "delivery.channel.test.title": "Send a test message",
  "delivery.channel.test.address": "地址",
  "delivery.channel.test.send": "发送",
  "delivery.channel.test.sent": "Test message sent.",
  "delivery.channel.test.failed": "The test message was not sent.",
  "delivery.settings.title": "Delivery Settings",
  "delivery.settings.subtitle": "Lab-wide rules for how reports, alerts and notices are sent",
  "delivery.settings.retryDelays": "Retry after (minutes, in order)",
  "delivery.settings.retryDelays.helper": "For example 1,5,15: a failed send is tried again after 1, 5 and 15 minutes, then marked Failed",
  "delivery.settings.defaultFormat": "Format for recipients without a password",
  "delivery.settings.hold": "Wait before sending a new version (minutes)",
  "delivery.settings.partials": "Send partial reports automatically",
  "delivery.settings.contact": "Lab contact line",
  "delivery.settings.contact.helper": "Phone, email and opening hours, as printed in notices",
  "delivery.settings.location": "Where reports are sent from",
  "delivery.settings.location.local": "This lab",
  "delivery.settings.location.central": "Central delivery service",
  "delivery.settings.centralAddress": "Central delivery service address",
  "delivery.settings.centralConfirm": "Reports, alerts and patient notices for this lab will be sent by the central service at {address}. This lab will stop sending them.",
  "delivery.settings.links": "Secure links",
  "delivery.settings.linkDays": "Link lifetime (days)",
  "delivery.settings.countryCode": "Default country code",
  "delivery.settings.save": "保存",
  "delivery.settings.saved": "Settings saved.",
  "delivery.settings.invalid": "The settings could not be saved: check {field}.",
  "externalconnections.password.set": "A password is stored. Leave this blank to keep it.",
  "notificationtrigger.referralrejected.name": "Referral result rejected",
  "notificationtrigger.referralrejected.description": "Sent when a result returned by the reference laboratory is rejected and the sample must be collected again.",
  "notificationtrigger.templates.referralrejected.description": "Sent to the ordering provider or the submitting user when a returned referral result is rejected.",
  "notificationtrigger.referralnudge.name": "Referral nudge",
  "notificationtrigger.referralnudge.description": "Sent to the reference laboratory's contact when a referral is overdue and a nudge is requested.",
  "notificationtrigger.templates.referralnudge.description": "Sent to the chain-of-custody contact at the reference laboratory when a result is awaited.",
  "notificationtrigger.sampleresampled.name": "Sample re-collection",
  "notificationtrigger.sampleresampled.description": "Sent when an order is marked for re-collection and a replacement order is created.",
  "notificationtrigger.templates.sampleresampled.description": "Sent to the ordering provider or the submitting user when a sample must be collected again.",
  "notificationtrigger.testresult.name": "Patient results ready",
  "notificationtrigger.testresult.description": "Sent to the patient or the provider when a test configured under Test Notifications has a released result.",
  "notificationtrigger.templates.testresult.description": "Sent to the patient or the provider when a configured test's result is released. It never names the patient."
}
